// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%233cd278%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f0323c%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f0323c%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27%2332373b%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 strokeWidth=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 strokeWidth=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fillRule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%230a7280%27%3e%3cpath fillRule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236db2bb%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/icons/warning-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/icons/check-blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/icons/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/icons/planning/warning-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 1920 120%27 preserveAspectRatio=%27none%27%3E%3Cg class=%27n2-ss-divider-end%27%3E%3Cpath fill=%27RGBA%28255,255,255,1%29%27 opacity=%270.25%27 d=%27M1920,0,0,120,0,0z%27%3E%3C/path%3E%3Cpath fill=%27RGBA%28255,255,255,1%29%27 opacity=%270.5%27 d=%27M1920,0,0,80,0,0z%27%3E%3C/path%3E%3Cpath fill=%27RGBA%28255,255,255,1%29%27 d=%27M1920,-2,1920,0,0,40,0,-2z%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/icons/planning/checkbox.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/icons/clock-grey9.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/shapes/x.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/shapes/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/shapes/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3Csvg width=%271em%27 height=%271em%27 viewBox=%270 0 16 16%27 class=%27bi bi-arrow-left%27 fill=%27currentColor%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fillRule=%27evenodd%27 d=%27M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z%27/%3E%3Cpath fillRule=%27evenodd%27 d=%27M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3Csvg width=%271em%27 height=%271em%27 viewBox=%270 0 16 16%27 class=%27bi bi-arrow-right%27 fill=%27currentColor%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fillRule=%27evenodd%27 d=%27M10.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L12.793 8l-2.647-2.646a.5.5 0 0 1 0-.708z%27/%3E%3Cpath fillRule=%27evenodd%27 d=%27M2 8a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../images/pattern/dot3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../images/shapes/rounded-square2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../images/shapes/rounded-square.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../images/pattern/dot2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../images/pattern/dot.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../images/pattern/dot5.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../images/pattern/dot4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../images/icons/planning/warning-yellow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../images/icons/planning/info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/icons/calendar-grey9.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/icons/check-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Prompt Kit
Author: CoderThemes
Version: 1.0.0
Website: https://coderthemes.com/
Contact: support@coderthemes.com
File: Main Css File
*/
/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/
html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.tw-pointer-events-none{
  pointer-events: none;
}
.tw-fixed{
  position: fixed;
}
.tw-bottom-4{
  bottom: 1rem;
}
.tw-left-1\\/2{
  left: 50%;
}
.tw-right-0{
  right: 0px;
}
.tw-right-4{
  right: 1rem;
}
.tw-top-0{
  top: 0px;
}
.tw-top-1\\/2{
  top: 50%;
}
.tw-top-\\[4px\\]{
  top: 4px;
}
.tw-m-0{
  margin: 0px;
}
.tw-mb-0{
  margin-bottom: 0px;
}
.tw-mb-2{
  margin-bottom: 0.5rem;
}
.tw-mb-4{
  margin-bottom: 1rem;
}
.tw-mb-5{
  margin-bottom: 1.25rem;
}
.tw-ml-1{
  margin-left: 0.25rem;
}
.tw-mr-2{
  margin-right: 0.5rem;
}
.tw-mt-10{
  margin-top: 2.5rem;
}
.tw-mt-6{
  margin-top: 1.5rem;
}
.tw-mt-7{
  margin-top: 1.75rem;
}
.tw-flex{
  display: flex;
}
.tw-inline-flex{
  display: inline-flex;
}
.tw-grid{
  display: grid;
}
.tw-h-11{
  height: 2.75rem;
}
.tw-h-14{
  height: 3.5rem;
}
.tw-h-2{
  height: 0.5rem;
}
.tw-h-2\\.5{
  height: 0.625rem;
}
.tw-h-6{
  height: 1.5rem;
}
.tw-h-\\[12px\\]{
  height: 12px;
}
.tw-h-\\[200px\\]{
  height: 200px;
}
.tw-h-\\[250px\\]{
  height: 250px;
}
.tw-h-\\[38px\\]{
  height: 38px;
}
.tw-h-\\[42px\\]{
  height: 42px;
}
.tw-h-\\[500px\\]{
  height: 500px;
}
.tw-h-\\[50px\\]{
  height: 50px;
}
.tw-h-\\[60px\\]{
  height: 60px;
}
.tw-h-\\[84px\\]{
  height: 84px;
}
.tw-h-full{
  height: 100%;
}
.tw-min-h-\\[35px\\]{
  min-height: 35px;
}
.tw-min-h-\\[700px\\]{
  min-height: 700px;
}
.tw-w-11{
  width: 2.75rem;
}
.tw-w-14{
  width: 3.5rem;
}
.tw-w-2{
  width: 0.5rem;
}
.tw-w-2\\.5{
  width: 0.625rem;
}
.tw-w-2\\/4{
  width: 50%;
}
.tw-w-6{
  width: 1.5rem;
}
.tw-w-\\[12px\\]{
  width: 12px;
}
.tw-w-\\[150px\\]{
  width: 150px;
}
.tw-w-\\[20\\%\\]{
  width: 20%;
}
.tw-w-\\[200px\\]{
  width: 200px;
}
.tw-w-\\[250px\\]{
  width: 250px;
}
.tw-w-\\[30\\%\\]{
  width: 30%;
}
.tw-w-\\[32px\\]{
  width: 32px;
}
.tw-w-\\[42px\\]{
  width: 42px;
}
.tw-w-\\[50\\%\\]{
  width: 50%;
}
.tw-w-\\[50px\\]{
  width: 50px;
}
.tw-w-\\[84px\\]{
  width: 84px;
}
.tw-w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.tw-w-full{
  width: 100%;
}
.tw-max-w-4xl{
  max-width: 56rem;
}
.tw-max-w-5xl{
  max-width: 64rem;
}
.tw-max-w-\\[120px\\]{
  max-width: 120px;
}
.tw-max-w-lg{
  max-width: 32rem;
}
.tw-max-w-screen-lg{
  max-width: 1024px;
}
.tw-max-w-screen-md{
  max-width: 768px;
}
.tw-max-w-sm{
  max-width: 24rem;
}
.tw-max-w-xs{
  max-width: 20rem;
}
.-tw-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-tw-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw--translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw--translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-translate-y-full{
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-pulse{
  50%{
    opacity: .5;
  }
}
.tw-animate-pulse{
  animation: tw-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.tw-cursor-pointer{
  cursor: pointer;
}
.tw-list-disc{
  list-style-type: disc;
}
.tw-grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.tw-grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.tw-grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.tw-flex-col{
  flex-direction: column;
}
.tw-items-center{
  align-items: center;
}
.tw-justify-end{
  justify-content: flex-end;
}
.tw-justify-center{
  justify-content: center;
}
.tw-justify-between{
  justify-content: space-between;
}
.tw-gap-2{
  gap: 0.5rem;
}
.tw-gap-3{
  gap: 0.75rem;
}
.tw-gap-4{
  gap: 1rem;
}
.tw-gap-5{
  gap: 1.25rem;
}
.tw-gap-52{
  gap: 13rem;
}
.tw-gap-6{
  gap: 1.5rem;
}
.tw-gap-7{
  gap: 1.75rem;
}
.tw-gap-8{
  gap: 2rem;
}
.tw-gap-x-4{
  column-gap: 1rem;
}
.tw-gap-x-6{
  column-gap: 1.5rem;
}
.tw-gap-y-2{
  row-gap: 0.5rem;
}
.tw-gap-y-3{
  row-gap: 0.75rem;
}
.tw-gap-y-4{
  row-gap: 1rem;
}
.tw-gap-y-5{
  row-gap: 1.25rem;
}
.tw-gap-y-6{
  row-gap: 1.5rem;
}
.tw-gap-y-8{
  row-gap: 2rem;
}
.tw-space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.tw-divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.tw-divide-white > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-divide-opacity));
}
.tw-overflow-visible{
  overflow: visible;
}
.tw-overflow-x-auto{
  overflow-x: auto;
}
.tw-rounded{
  border-radius: 0.25rem;
}
.tw-rounded-2xl{
  border-radius: 1rem;
}
.tw-rounded-\\[10px\\]{
  border-radius: 10px;
}
.tw-rounded-\\[8px\\]{
  border-radius: 8px;
}
.tw-rounded-full{
  border-radius: 9999px;
}
.tw-rounded-lg{
  border-radius: 0.5rem;
}
.tw-border{
  border-width: 1px;
}
.tw-border-b{
  border-bottom-width: 1px;
}
.tw-border-b-4{
  border-bottom-width: 4px;
}
.tw-border-t{
  border-top-width: 1px;
}
.tw-border-\\[\\#0B7F8E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(11 127 142 / var(--tw-border-opacity));
}
.tw-border-\\[\\#2E80D1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(46 128 209 / var(--tw-border-opacity));
}
.tw-border-\\[\\#2eb85c\\]{
  --tw-border-opacity: 1;
  border-color: rgb(46 184 92 / var(--tw-border-opacity));
}
.tw-border-\\[\\#C54007\\]{
  --tw-border-opacity: 1;
  border-color: rgb(197 64 7 / var(--tw-border-opacity));
}
.tw-border-\\[\\#E2E8F0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.tw-border-\\[\\#EF4444\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.tw-border-\\[\\#e55353\\]{
  --tw-border-opacity: 1;
  border-color: rgb(229 83 83 / var(--tw-border-opacity));
}
.tw-border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.tw-border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.\\!tw-bg-\\[\\#D0E6E8\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(208 230 232 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#D6FCDE\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(214 252 222 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#EEF6F7\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 246 247 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#FFE5E8\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 229 232 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#FFEEDA\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 238 218 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#cfcfcf\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(207 207 207 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#eaf2fa\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 242 250 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-\\[\\#faebea\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 235 234 / var(--tw-bg-opacity)) !important;
}
.tw-bg-\\[\\#0B7F8E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 127 142 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#111827\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#1F2937\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#222222\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 34 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#2eb85c\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 184 92 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#94CA00\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(148 202 0 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#CDE0F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(205 224 244 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#D0E6E8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(208 230 232 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#D6FCDE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(214 252 222 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#D9EDEE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 237 238 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#DAF3FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(218 243 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#DCFCE7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#DFE6EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(223 230 235 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#E0F2F1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 241 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#E85414\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 84 20 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#EF4444\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#EF6A9D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 106 157 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#EFF6FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F1F5F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F3E8FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F3F4F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F3F4F7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 247 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F4F5F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 245 246 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F6F7F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 247 249 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F7F7F7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F8DCDC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 220 220 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F9FAFB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FBA707\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 167 7 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FEE2E2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FEEBE4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 235 228 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FFEEDA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 238 218 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#e55353\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 83 83 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#f3f4f7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 247 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#f5f9fa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 249 250 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#f9fafb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#faedda\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 237 218 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#fef2f2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#ffffff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[var\\(--green1\\)\\]{
  background-color: var(--green1);
}
.tw-bg-\\[var\\(--grey1\\)\\]{
  background-color: var(--grey1);
}
.tw-bg-\\[var\\(--red1\\)\\]{
  background-color: var(--red1);
}
.tw-bg-\\[var\\(--teal1\\)\\]{
  background-color: var(--teal1);
}
.tw-bg-\\[var\\(--white\\)\\]{
  background-color: var(--white);
}
.tw-bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.tw-bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.tw-bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.tw-bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.tw-bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-fill-gray-200{
  fill: #e5e7eb;
}
.tw-fill-gray-400{
  fill: #9ca3af;
}
.tw-fill-gray-500{
  fill: #6b7280;
}
.tw-stroke-gray-300{
  stroke: #d1d5db;
}
.tw-stroke-gray-500{
  stroke: #6b7280;
}
.tw-stroke-green-300{
  stroke: #86efac;
}
.tw-stroke-red-400{
  stroke: #f87171;
}
.tw-stroke-yellow-300{
  stroke: #fde047;
}
.tw-p-20{
  padding: 5rem;
}
.tw-p-24{
  padding: 6rem;
}
.tw-p-3{
  padding: 0.75rem;
}
.tw-p-4{
  padding: 1rem;
}
.tw-p-5{
  padding: 1.25rem;
}
.tw-p-8{
  padding: 2rem;
}
.tw-px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.tw-px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw-px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw-px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw-px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw-px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.tw-py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw-py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.tw-pb-2{
  padding-bottom: 0.5rem;
}
.tw-pl-\\[64px\\]{
  padding-left: 64px;
}
.tw-pt-1{
  padding-top: 0.25rem;
}
.tw-text-left{
  text-align: left;
}
.\\!tw-text-right{
  text-align: right !important;
}
.tw-text-justify{
  text-align: justify;
}
.tw-text-end{
  text-align: end;
}
.tw-text-\\[11px\\]{
  font-size: 11px;
}
.tw-text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw-text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw-text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw-text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.tw-font-bold{
  font-weight: 700;
}
.tw-font-medium{
  font-weight: 500;
}
.tw-uppercase{
  text-transform: uppercase;
}
.tw-text-\\[\\#06D64A\\]{
  --tw-text-opacity: 1;
  color: rgb(6 214 74 / var(--tw-text-opacity));
}
.tw-text-\\[\\#0B7F8E\\]{
  --tw-text-opacity: 1;
  color: rgb(11 127 142 / var(--tw-text-opacity));
}
.tw-text-\\[\\#0F172A\\]{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
.tw-text-\\[\\#0b7f8e\\]{
  --tw-text-opacity: 1;
  color: rgb(11 127 142 / var(--tw-text-opacity));
}
.tw-text-\\[\\#10B981\\]{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.tw-text-\\[\\#1E293B\\]{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.tw-text-\\[\\#202224\\]{
  --tw-text-opacity: 1;
  color: rgb(32 34 36 / var(--tw-text-opacity));
}
.tw-text-\\[\\#2EB85C\\]{
  --tw-text-opacity: 1;
  color: rgb(46 184 92 / var(--tw-text-opacity));
}
.tw-text-\\[\\#2eb85c\\]{
  --tw-text-opacity: 1;
  color: rgb(46 184 92 / var(--tw-text-opacity));
}
.tw-text-\\[\\#334155\\]{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.tw-text-\\[\\#51555A\\]{
  --tw-text-opacity: 1;
  color: rgb(81 85 90 / var(--tw-text-opacity));
}
.tw-text-\\[\\#64748B\\]{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.tw-text-\\[\\#94A3B8\\]{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.tw-text-\\[\\#999999\\]{
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity));
}
.tw-text-\\[\\#C54007\\]{
  --tw-text-opacity: 1;
  color: rgb(197 64 7 / var(--tw-text-opacity));
}
.tw-text-\\[\\#DA0606\\]{
  --tw-text-opacity: 1;
  color: rgb(218 6 6 / var(--tw-text-opacity));
}
.tw-text-\\[\\#DE890D\\]{
  --tw-text-opacity: 1;
  color: rgb(222 137 13 / var(--tw-text-opacity));
}
.tw-text-\\[\\#E55353\\]{
  --tw-text-opacity: 1;
  color: rgb(229 83 83 / var(--tw-text-opacity));
}
.tw-text-\\[\\#E85414\\]{
  --tw-text-opacity: 1;
  color: rgb(232 84 20 / var(--tw-text-opacity));
}
.tw-text-\\[\\#EF4444\\]{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.tw-text-\\[\\#F59E0B\\]{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.tw-text-\\[\\#FBA707\\]{
  --tw-text-opacity: 1;
  color: rgb(251 167 7 / var(--tw-text-opacity));
}
.tw-text-\\[\\#e55353\\]{
  --tw-text-opacity: 1;
  color: rgb(229 83 83 / var(--tw-text-opacity));
}
.tw-text-\\[var\\(--green6\\)\\]{
  color: var(--green6);
}
.tw-text-\\[var\\(--grey10\\)\\]{
  color: var(--grey10);
}
.tw-text-\\[var\\(--red6\\)\\]{
  color: var(--red6);
}
.tw-text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.tw-text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.tw-text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.tw-text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.tw-text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.tw-text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.tw-text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-opacity-0{
  opacity: 0;
}
.tw-opacity-100{
  opacity: 1;
}
.tw-opacity-60{
  opacity: 0.6;
}
.tw-opacity-70{
  opacity: 0.7;
}
.tw-opacity-80{
  opacity: 0.8;
}
.tw-opacity-90{
  opacity: 0.9;
}
.tw-transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw-ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0b7f8e;
  --bs-indigo: #5c7cfa;
  --bs-purple: #a499ff;
  --bs-pink: #f06595;
  --bs-red: #f0323c;
  --bs-yellow: #ffc837;
  --bs-green: #3cd278;
  --bs-cyan: #17a2b8;
  --bs-white: #fff;
  --bs-gray: #787878;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f4f5f7;
  --bs-gray-200: #f3f4f7;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #cdcdcd;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #787878;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0b7f8e;
  --bs-secondary: #495057;
  --bs-success: #3cd278;
  --bs-info: #17a2b8;
  --bs-warning: #ffc837;
  --bs-danger: #f0323c;
  --bs-light: #f4f5f7;
  --bs-dark: #343a40;
  --bs-orange: #ff784b;
  --bs-teal: #20c997;
  --bs-gray-50: #fefefe;
  --bs-primary-rgb: 11, 127, 142;
  --bs-secondary-rgb: 73, 80, 87;
  --bs-success-rgb: 60, 210, 120;
  --bs-info-rgb: 23, 162, 184;
  --bs-warning-rgb: 255, 200, 55;
  --bs-danger-rgb: 240, 50, 60;
  --bs-light-rgb: 244, 245, 247;
  --bs-dark-rgb: 52, 58, 64;
  --bs-orange-rgb: 255, 120, 75;
  --bs-teal-rgb: 32, 201, 151;
  --bs-gray-50-rgb: 254, 254, 254;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Be Vietnam Pro", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Be Vietnam Pro", sans-serif;
  --bs-body-font-size: 0.9375rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #495057;
  --bs-body-color-rgb: 73, 80, 87;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #495057;
  --bs-link-color-rgb: 73, 80, 87;
  --bs-link-decoration: none;
  --bs-link-hover-color: #0b7f8e;
  --bs-link-hover-color-rgb: 11, 127, 142;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #f0323c;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06);
  --bs-box-shadow-sm: 0 0 0.25rem rgba(73, 80, 87, 0.05);
  --bs-box-shadow-lg: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6db2bb;
  --bs-secondary-text-emphasis: #92969a;
  --bs-success-text-emphasis: #8ae4ae;
  --bs-info-text-emphasis: #74c7d4;
  --bs-warning-text-emphasis: #ffde87;
  --bs-danger-text-emphasis: #f6848a;
  --bs-light-text-emphasis: #f4f5f7;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #02191c;
  --bs-secondary-bg-subtle: #0f1011;
  --bs-success-bg-subtle: #0c2a18;
  --bs-info-bg-subtle: #052025;
  --bs-warning-bg-subtle: #33280b;
  --bs-danger-bg-subtle: #300a0c;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #074c55;
  --bs-secondary-border-subtle: #2c3034;
  --bs-success-border-subtle: #247e48;
  --bs-info-border-subtle: #0e616e;
  --bs-warning-border-subtle: #997821;
  --bs-danger-border-subtle: #901e24;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6db2bb;
  --bs-link-hover-color: #99c9cf;
  --bs-link-color-rgb: 109, 178, 187;
  --bs-link-hover-color-rgb: 153, 201, 207;
  --bs-code-color: #f6848a;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #665016;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #8ae4ae;
  --bs-form-valid-border-color: #8ae4ae;
  --bs-form-invalid-color: #f6848a;
  --bs-form-invalid-border-color: #f6848a;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: #495057;
  border: 0;
  border-top: 0 solid;
  opacity: 0.1;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.4;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.303125rem + 0.6375vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 1.78125rem;
  }
}

h2, .h2 {
  font-size: calc(1.2796875rem + 0.35625vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.546875rem;
  }
}

h3, .h3 {
  font-size: calc(1.25625rem + 0.075vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.3125rem;
  }
}

h4, .h4 {
  font-size: 1.078125rem;
}

h5, .h5 {
  font-size: 0.9375rem;
}

h6, .h6 {
  font-size: 0.84375rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 700;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: underline;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 1rem 1rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 600;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #8a90a2;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.171875rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4rem;
  }
}

.display-3 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 3rem;
  }
}

.display-4 {
  font-size: calc(1.325rem + 0.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 2rem;
  }
}

.display-6 {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.2;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.171875rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #787878;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #787878;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 0.75rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 570px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1440px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 4.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 4.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 6rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 6rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 7.5rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 7.5rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 9rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 9rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 11.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 11.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 6rem;
  }
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 6rem;
  }
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 7.5rem;
  }
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 7.5rem;
  }
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 9rem;
  }
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 9rem;
  }
  .g-sm-10,
  .gx-sm-10 {
    --bs-gutter-x: 11.5rem;
  }
  .g-sm-10,
  .gy-sm-10 {
    --bs-gutter-y: 11.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 6rem;
  }
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 6rem;
  }
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 7.5rem;
  }
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 7.5rem;
  }
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 9rem;
  }
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 9rem;
  }
  .g-md-10,
  .gx-md-10 {
    --bs-gutter-x: 11.5rem;
  }
  .g-md-10,
  .gy-md-10 {
    --bs-gutter-y: 11.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 6rem;
  }
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 6rem;
  }
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 7.5rem;
  }
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 7.5rem;
  }
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 9rem;
  }
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 9rem;
  }
  .g-lg-10,
  .gx-lg-10 {
    --bs-gutter-x: 11.5rem;
  }
  .g-lg-10,
  .gy-lg-10 {
    --bs-gutter-y: 11.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 6rem;
  }
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 6rem;
  }
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 7.5rem;
  }
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 7.5rem;
  }
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 9rem;
  }
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 9rem;
  }
  .g-xl-10,
  .gx-xl-10 {
    --bs-gutter-x: 11.5rem;
  }
  .g-xl-10,
  .gy-xl-10 {
    --bs-gutter-y: 11.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 6rem;
  }
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 6rem;
  }
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 7.5rem;
  }
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 7.5rem;
  }
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 9rem;
  }
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 9rem;
  }
  .g-xxl-10,
  .gx-xxl-10 {
    --bs-gutter-x: 11.5rem;
  }
  .g-xxl-10,
  .gy-xxl-10 {
    --bs-gutter-y: 11.5rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #495057;
  --bs-table-bg: transparent;
  --bs-table-border-color: #dee2e6;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #495057;
  --bs-table-striped-bg: #f3f4f7;
  --bs-table-active-color: #495057;
  --bs-table-active-bg: #f3f4f7;
  --bs-table-hover-color: #495057;
  --bs-table-hover-bg: #f3f4f7;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid #dee2e6;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 3.75rem 3.75rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #212529;
  --bs-table-bg: #cee5e8;
  --bs-table-border-color: #bdd2d5;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #212529;
  --bs-table-bg: #dbdcdd;
  --bs-table-border-color: #c8cacb;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #212529;
  --bs-table-bg: #d8f6e4;
  --bs-table-border-color: #c6e1d1;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #212529;
  --bs-table-bg: #d1ecf1;
  --bs-table-border-color: #bfd8dd;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #212529;
  --bs-table-bg: #fff4d7;
  --bs-table-border-color: #e9dfc6;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #212529;
  --bs-table-bg: #fcd6d8;
  --bs-table-border-color: #e6c4c7;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #212529;
  --bs-table-bg: #f4f5f7;
  --bs-table-border-color: #dfe0e2;
  --bs-table-striped-bg: #212529;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #212529;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #212529;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: #484e53;
  --bs-table-striped-bg: white;
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: white;
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: white;
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.col-form-label {
  padding-top: calc(0.5625rem + 1px);
  padding-bottom: calc(0.5625rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 600;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.9375rem + 1px);
  padding-bottom: calc(0.9375rem + 1px);
  font-size: 1.171875rem;
}

.col-form-label-sm {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  font-size: 0.8203125rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #8a90a2;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5625rem 1rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: #cdcdcd;
  opacity: 1;
}
.form-control:disabled {
  background-color: #fff;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5625rem 1rem;
  margin: -0.5625rem -1rem;
  margin-inline-end: 1rem;
  color: #495057;
  background-color: #f3f4f7;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #e7e8eb;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5625rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.8203125rem;
  border-radius: 0.25rem;
}
.form-control-sm::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.875rem + 2px);
  padding: 0.9375rem 1.25rem;
  font-size: 1.171875rem;
  border-radius: 0.25rem;
}
.form-control-lg::file-selector-button {
  padding: 0.9375rem 1.25rem;
  margin: -0.9375rem -1.25rem;
  margin-inline-end: 1.25rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1.125rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.75rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.875rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1.125rem + 2px);
  padding: 0.5625rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.75rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.875rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.5625rem 3rem 0.5625rem 1rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 14px 12px;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgba(0, 0, 0, 0.25);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(11, 127, 142, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #f3f4f7;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-select-sm {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.75rem;
  font-size: 0.8203125rem;
  border-radius: 0.25rem;
}

.form-select-lg {
  padding-top: 0.9375rem;
  padding-bottom: 0.9375rem;
  padding-left: 1.25rem;
  font-size: 1.171875rem;
  border-radius: 0.25rem;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.40625rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: #fff;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25rem;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgba(0, 0, 0, 0.25);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(11, 127, 142, 0.25);
}
.form-check-input:checked {
  background-color: #0b7f8e;
  border-color: #0b7f8e;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0b7f8e;
  border-color: #0b7f8e;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0b7f8e;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d9dd;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0b7f8e;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d9dd;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  min-height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.5rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  border-radius: 0.25rem;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #fff;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5625rem 1rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #f3f4f7;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.9375rem 1.25rem;
  font-size: 1.171875rem;
  border-radius: 0.25rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.375rem 0.75rem;
  font-size: 0.8203125rem;
  border-radius: 0.25rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #3cd278;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.3rem 0.75rem;
  margin-top: 0.1rem;
  font-size: 0.9375rem;
  color: #fff;
  background-color: rgba(60, 210, 120, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #3cd278;
  padding-right: calc(1.5em + 1.125rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.28125rem) center;
  background-size: calc(0.75em + 0.5625rem) calc(0.75em + 0.5625rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #3cd278;
  box-shadow: 0 0 0 0.15rem rgba(60, 210, 120, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.125rem);
  background-position: top calc(0.375em + 0.28125rem) right calc(0.375em + 0.28125rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #3cd278;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 14px 12px, calc(0.75em + 0.5625rem) calc(0.75em + 0.5625rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #3cd278;
  box-shadow: 0 0 0 0.15rem rgba(60, 210, 120, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1.125rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #3cd278;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #3cd278;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.15rem rgba(60, 210, 120, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #3cd278;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f0323c;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.3rem 0.75rem;
  margin-top: 0.1rem;
  font-size: 0.9375rem;
  color: #fff;
  background-color: rgba(240, 50, 60, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f0323c;
  padding-right: calc(1.5em + 1.125rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.28125rem) center;
  background-size: calc(0.75em + 0.5625rem) calc(0.75em + 0.5625rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f0323c;
  box-shadow: 0 0 0 0.15rem rgba(240, 50, 60, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.125rem);
  background-position: top calc(0.375em + 0.28125rem) right calc(0.375em + 0.28125rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f0323c;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 14px 12px, calc(0.75em + 0.5625rem) calc(0.75em + 0.5625rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #f0323c;
  box-shadow: 0 0 0 0.15rem rgba(240, 50, 60, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1.125rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f0323c;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #f0323c;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.15rem rgba(240, 50, 60, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f0323c;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1rem;
  --bs-btn-padding-y: 0.5625rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.9375rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.375rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  text-decoration: none;
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0b7f8e;
  --bs-btn-border-color: #0b7f8e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #096c79;
  --bs-btn-hover-border-color: #096672;
  --bs-btn-focus-shadow-rgb: 48, 146, 159;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #096672;
  --bs-btn-active-border-color: #085f6b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0b7f8e;
  --bs-btn-disabled-border-color: #0b7f8e;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #495057;
  --bs-btn-border-color: #495057;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3e444a;
  --bs-btn-hover-border-color: #3a4046;
  --bs-btn-focus-shadow-rgb: 100, 106, 112;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3a4046;
  --bs-btn-active-border-color: #373c41;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #495057;
  --bs-btn-disabled-border-color: #495057;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #3cd278;
  --bs-btn-border-color: #3cd278;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #33b366;
  --bs-btn-hover-border-color: #30a860;
  --bs-btn-focus-shadow-rgb: 89, 217, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #30a860;
  --bs-btn-active-border-color: #2d9e5a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #3cd278;
  --bs-btn-disabled-border-color: #3cd278;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #17a2b8;
  --bs-btn-border-color: #17a2b8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #148a9c;
  --bs-btn-hover-border-color: #128293;
  --bs-btn-focus-shadow-rgb: 58, 176, 195;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #128293;
  --bs-btn-active-border-color: #117a8a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #17a2b8;
  --bs-btn-disabled-border-color: #17a2b8;
}

.btn-warning {
  --bs-btn-color: #212529;
  --bs-btn-bg: #ffc837;
  --bs-btn-border-color: #ffc837;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #ffd055;
  --bs-btn-hover-border-color: #ffce4b;
  --bs-btn-focus-shadow-rgb: 222, 176, 53;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #ffd35f;
  --bs-btn-active-border-color: #ffce4b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: #ffc837;
  --bs-btn-disabled-border-color: #ffc837;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f0323c;
  --bs-btn-border-color: #f0323c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #cc2b33;
  --bs-btn-hover-border-color: #c02830;
  --bs-btn-focus-shadow-rgb: 242, 81, 89;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c02830;
  --bs-btn-active-border-color: #b4262d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f0323c;
  --bs-btn-disabled-border-color: #f0323c;
}

.btn-light {
  --bs-btn-color: #212529;
  --bs-btn-bg: #f4f5f7;
  --bs-btn-border-color: #f4f5f7;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #cfd0d2;
  --bs-btn-hover-border-color: #c3c4c6;
  --bs-btn-focus-shadow-rgb: 212, 214, 216;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #c3c4c6;
  --bs-btn-active-border-color: #b7b8b9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: #f4f5f7;
  --bs-btn-disabled-border-color: #f4f5f7;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #52585d;
  --bs-btn-hover-border-color: #484e53;
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5d6166;
  --bs-btn-active-border-color: #484e53;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}

.btn-orange {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ff784b;
  --bs-btn-border-color: #ff784b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d96640;
  --bs-btn-hover-border-color: #cc603c;
  --bs-btn-focus-shadow-rgb: 255, 140, 102;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #cc603c;
  --bs-btn-active-border-color: #bf5a38;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ff784b;
  --bs-btn-disabled-border-color: #ff784b;
}

.btn-teal {
  --bs-btn-color: #fff;
  --bs-btn-bg: #20c997;
  --bs-btn-border-color: #20c997;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1bab80;
  --bs-btn-hover-border-color: #1aa179;
  --bs-btn-focus-shadow-rgb: 65, 209, 167;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1aa179;
  --bs-btn-active-border-color: #189771;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #20c997;
  --bs-btn-disabled-border-color: #20c997;
}

.btn-gray-50 {
  --bs-btn-color: #212529;
  --bs-btn-bg: #fefefe;
  --bs-btn-border-color: #fefefe;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #fefefe;
  --bs-btn-hover-border-color: #fefefe;
  --bs-btn-focus-shadow-rgb: 221, 221, 222;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #fefefe;
  --bs-btn-active-border-color: #fefefe;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: #fefefe;
  --bs-btn-disabled-border-color: #fefefe;
}

.btn-outline-primary {
  --bs-btn-color: #0b7f8e;
  --bs-btn-border-color: #0b7f8e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b7f8e;
  --bs-btn-hover-border-color: #0b7f8e;
  --bs-btn-focus-shadow-rgb: 11, 127, 142;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0b7f8e;
  --bs-btn-active-border-color: #0b7f8e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0b7f8e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0b7f8e;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #495057;
  --bs-btn-border-color: #495057;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #495057;
  --bs-btn-hover-border-color: #495057;
  --bs-btn-focus-shadow-rgb: 73, 80, 87;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #495057;
  --bs-btn-active-border-color: #495057;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #495057;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #495057;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #3cd278;
  --bs-btn-border-color: #3cd278;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3cd278;
  --bs-btn-hover-border-color: #3cd278;
  --bs-btn-focus-shadow-rgb: 60, 210, 120;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3cd278;
  --bs-btn-active-border-color: #3cd278;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3cd278;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3cd278;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #17a2b8;
  --bs-btn-border-color: #17a2b8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #17a2b8;
  --bs-btn-hover-border-color: #17a2b8;
  --bs-btn-focus-shadow-rgb: 23, 162, 184;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #17a2b8;
  --bs-btn-active-border-color: #17a2b8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #17a2b8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #17a2b8;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc837;
  --bs-btn-border-color: #ffc837;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #ffc837;
  --bs-btn-hover-border-color: #ffc837;
  --bs-btn-focus-shadow-rgb: 255, 200, 55;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #ffc837;
  --bs-btn-active-border-color: #ffc837;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc837;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc837;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #f0323c;
  --bs-btn-border-color: #f0323c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f0323c;
  --bs-btn-hover-border-color: #f0323c;
  --bs-btn-focus-shadow-rgb: 240, 50, 60;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f0323c;
  --bs-btn-active-border-color: #f0323c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f0323c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f0323c;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f4f5f7;
  --bs-btn-border-color: #f4f5f7;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #f4f5f7;
  --bs-btn-hover-border-color: #f4f5f7;
  --bs-btn-focus-shadow-rgb: 244, 245, 247;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #f4f5f7;
  --bs-btn-active-border-color: #f4f5f7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f4f5f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f4f5f7;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}

.btn-outline-orange {
  --bs-btn-color: #ff784b;
  --bs-btn-border-color: #ff784b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff784b;
  --bs-btn-hover-border-color: #ff784b;
  --bs-btn-focus-shadow-rgb: 255, 120, 75;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff784b;
  --bs-btn-active-border-color: #ff784b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff784b;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff784b;
  --bs-gradient: none;
}

.btn-outline-teal {
  --bs-btn-color: #20c997;
  --bs-btn-border-color: #20c997;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #20c997;
  --bs-btn-hover-border-color: #20c997;
  --bs-btn-focus-shadow-rgb: 32, 201, 151;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #20c997;
  --bs-btn-active-border-color: #20c997;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #20c997;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #20c997;
  --bs-gradient: none;
}

.btn-outline-gray-50 {
  --bs-btn-color: #fefefe;
  --bs-btn-border-color: #fefefe;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #fefefe;
  --bs-btn-hover-border-color: #fefefe;
  --bs-btn-focus-shadow-rgb: 254, 254, 254;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #fefefe;
  --bs-btn-active-border-color: #fefefe;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fefefe;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fefefe;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #495057;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #0b7f8e;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #0b7f8e;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #787878;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.9375rem;
  --bs-btn-padding-x: 1.25rem;
  --bs-btn-font-size: 1.171875rem;
  --bs-btn-border-radius: 0.5rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-font-size: 0.8203125rem;
  --bs-btn-border-radius: 0.25rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0.3rem;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.9375rem;
  --bs-dropdown-color: #495057;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: 0.25rem;
  --bs-dropdown-divider-bg: #f3f4f7;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  --bs-dropdown-link-color: #787878;
  --bs-dropdown-link-hover-color: #1e2125;
  --bs-dropdown-link-hover-bg: #f3f4f7;
  --bs-dropdown-link-active-color: #16181b;
  --bs-dropdown-link-active-bg: #f4f5f7;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #787878;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.8203125rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #f3f4f7;
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #16181b;
  --bs-dropdown-link-active-bg: #f4f5f7;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.375rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: #212529;
  --bs-nav-link-hover-color: #0b7f8e;
  --bs-nav-link-disabled-color: #787878;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
  text-decoration: none;
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 0;
  --bs-nav-tabs-border-color: transparent;
  --bs-nav-tabs-border-radius: 0;
  --bs-nav-tabs-link-hover-border-color: #f3f4f7 #f3f4f7 transparent;
  --bs-nav-tabs-link-active-color: #495057;
  --bs-nav-tabs-link-active-bg: #fff;
  --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0b7f8e;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 600;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 1rem;
  --bs-navbar-padding-y: 1rem;
  --bs-navbar-color: #32373b;
  --bs-navbar-hover-color: #0f1012;
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: #0f1012;
  --bs-navbar-brand-padding-y: 0.32421875rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.171875rem;
  --bs-navbar-brand-color: #0f1012;
  --bs-navbar-brand-hover-color: #0f1012;
  --bs-navbar-nav-link-padding-x: 0.75rem;
  --bs-navbar-toggler-padding-y: 0.75rem;
  --bs-navbar-toggler-padding-x: 0;
  --bs-navbar-toggler-font-size: 1.171875rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  --bs-navbar-toggler-border-color: transparent;
  --bs-navbar-toggler-border-radius: 0.375rem;
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
  text-decoration: none;
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.9);
  --bs-navbar-hover-color: white;
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.card {
  --bs-card-spacer-y: 1.5rem;
  --bs-card-spacer-x: 1.5rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0px;
  --bs-card-border-color: rgba(0, 0, 0, 0.125);
  --bs-card-border-radius: 0.1875rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(0.1875rem - 0px);
  --bs-card-cap-padding-y: 0.75rem;
  --bs-card-cap-padding-x: 1.5rem;
  --bs-card-cap-bg: #f3f4f7;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #495057;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: rgba(0, 0, 0, 0.125);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.375rem;
  --bs-accordion-inner-border-radius: calc(0.375rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: #495057;
  --bs-accordion-btn-bg: #fff;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-focus-border-color: rgba(0, 0, 0, 0.25);
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.15rem rgba(11, 127, 142, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #0a7280;
  --bs-accordion-active-bg: #e7f2f4;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.9375rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 1rem;
  --bs-breadcrumb-padding-y: 0.75rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: #f4f5f7;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #787878;
  --bs-breadcrumb-item-padding-x: 0.1rem;
  --bs-breadcrumb-item-active-color: #787878;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: #0b7f8e;
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #dee2e6;
  --bs-pagination-border-radius: 0.375rem;
  --bs-pagination-hover-color: #0b7f8e;
  --bs-pagination-hover-bg: #f3f4f7;
  --bs-pagination-hover-border-color: #dee2e6;
  --bs-pagination-focus-color: #0b7f8e;
  --bs-pagination-focus-bg: #f3f4f7;
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(11, 127, 142, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0b7f8e;
  --bs-pagination-active-border-color: #0b7f8e;
  --bs-pagination-disabled-color: #787878;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #dee2e6;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  text-decoration: none;
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.171875rem;
  --bs-pagination-border-radius: 0.5rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.8203125rem;
  --bs-pagination-border-radius: 0.25rem;
}

.badge {
  --bs-badge-padding-x: 0.5em;
  --bs-badge-padding-y: 0.3em;
  --bs-badge-font-size: 82%;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-orange {
  --bs-alert-color: var(--bs-orange-text-emphasis);
  --bs-alert-bg: var(--bs-orange-bg-subtle);
  --bs-alert-border-color: var(--bs-orange-border-subtle);
  --bs-alert-link-color: var(--bs-orange-text-emphasis);
}

.alert-teal {
  --bs-alert-color: var(--bs-teal-text-emphasis);
  --bs-alert-bg: var(--bs-teal-bg-subtle);
  --bs-alert-border-color: var(--bs-teal-border-subtle);
  --bs-alert-link-color: var(--bs-teal-text-emphasis);
}

.alert-gray-50 {
  --bs-alert-color: var(--bs-gray-50-text-emphasis);
  --bs-alert-bg: var(--bs-gray-50-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-50-border-subtle);
  --bs-alert-link-color: var(--bs-gray-50-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.75rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 0.75rem;
  --bs-progress-font-size: 0.703125rem;
  --bs-progress-bg: #f3f4f7;
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0b7f8e;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: #212529;
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: #495057;
  --bs-list-group-action-hover-color: #495057;
  --bs-list-group-action-hover-bg: #f4f5f7;
  --bs-list-group-action-active-color: #495057;
  --bs-list-group-action-active-bg: #f3f4f7;
  --bs-list-group-disabled-color: #787878;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0b7f8e;
  --bs-list-group-active-border-color: #0b7f8e;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-orange {
  --bs-list-group-color: var(--bs-orange-text-emphasis);
  --bs-list-group-bg: var(--bs-orange-bg-subtle);
  --bs-list-group-border-color: var(--bs-orange-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-orange-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-orange-border-subtle);
  --bs-list-group-active-color: var(--bs-orange-bg-subtle);
  --bs-list-group-active-bg: var(--bs-orange-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-orange-text-emphasis);
}

.list-group-item-teal {
  --bs-list-group-color: var(--bs-teal-text-emphasis);
  --bs-list-group-bg: var(--bs-teal-bg-subtle);
  --bs-list-group-border-color: var(--bs-teal-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-teal-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-teal-border-subtle);
  --bs-list-group-active-color: var(--bs-teal-bg-subtle);
  --bs-list-group-active-bg: var(--bs-teal-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-teal-text-emphasis);
}

.list-group-item-gray-50 {
  --bs-list-group-color: var(--bs-gray-50-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-50-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-50-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.15rem rgba(11, 127, 142, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 0.75rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: rgba(0, 0, 0, 0.1);
  --bs-toast-border-radius: 0.375rem;
  --bs-toast-box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06);
  --bs-toast-header-color: #787878;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: rgba(0, 0, 0, 0.2);
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.25rem;
  --bs-modal-box-shadow: 0 0 0.25rem rgba(73, 80, 87, 0.05);
  --bs-modal-inner-border-radius: calc(0.25rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 0.6rem 1rem;
  --bs-modal-header-border-color: #dee2e6;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #dee2e6;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.75rem;
  --bs-tooltip-padding-y: 0.3rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.9375rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #1a1d20;
  --bs-tooltip-border-radius: 0.25rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.75rem;
  --bs-tooltip-arrow-height: 0.5rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Be Vietnam Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.9375rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: #f3f4f7;
  --bs-popover-border-radius: 0.25rem;
  --bs-popover-inner-border-radius: calc(0.25rem - 1px);
  --bs-popover-box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: #f4f5f7;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: #495057;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Be Vietnam Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: rgba(0, 0, 0, 0.2);
  --bs-offcanvas-box-shadow: 0 0 0.25rem rgba(73, 80, 87, 0.05);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #212529 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #212529 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-orange {
  color: #fff !important;
  background-color: RGBA(var(--bs-orange-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-teal {
  color: #fff !important;
  background-color: RGBA(var(--bs-teal-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-50 {
  color: #212529 !important;
  background-color: RGBA(var(--bs-gray-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(8, 89, 99, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(8, 89, 99, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(51, 56, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(51, 56, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(42, 147, 84, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 147, 84, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(16, 113, 129, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(16, 113, 129, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 217, 115, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 217, 115, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(168, 35, 42, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(168, 35, 42, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(247, 248, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 248, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(36, 41, 45, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(36, 41, 45, var(--bs-link-underline-opacity, 1)) !important;
}

.link-orange {
  color: RGBA(var(--bs-orange-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-orange-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-orange:hover, .link-orange:focus {
  color: RGBA(179, 84, 53, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(179, 84, 53, var(--bs-link-underline-opacity, 1)) !important;
}

.link-teal {
  color: RGBA(var(--bs-teal-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-teal-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-teal:hover, .link-teal:focus {
  color: RGBA(22, 141, 106, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(22, 141, 106, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-50 {
  color: RGBA(var(--bs-gray-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-50:hover, .link-gray-50:focus {
  color: RGBA(254, 254, 254, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(254, 254, 254, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.1;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-orange {
  --bs-focus-ring-color: rgba(var(--bs-orange-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-teal {
  --bs-focus-ring-color: rgba(var(--bs-teal-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-50 {
  --bs-focus-ring-color: rgba(var(--bs-gray-50-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-orange {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-orange-rgb), var(--bs-border-opacity)) !important;
}

.border-teal {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-teal-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-50-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-6 {
  margin: 4.5rem !important;
}

.m-7 {
  margin: 6rem !important;
}

.m-8 {
  margin: 7.5rem !important;
}

.m-9 {
  margin: 9rem !important;
}

.m-10 {
  margin: 11.5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-6 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-7 {
  margin-right: 6rem !important;
  margin-left: 6rem !important;
}

.mx-8 {
  margin-right: 7.5rem !important;
  margin-left: 7.5rem !important;
}

.mx-9 {
  margin-right: 9rem !important;
  margin-left: 9rem !important;
}

.mx-10 {
  margin-right: 11.5rem !important;
  margin-left: 11.5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-6 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-7 {
  margin-top: 6rem !important;
  margin-bottom: 6rem !important;
}

.my-8 {
  margin-top: 7.5rem !important;
  margin-bottom: 7.5rem !important;
}

.my-9 {
  margin-top: 9rem !important;
  margin-bottom: 9rem !important;
}

.my-10 {
  margin-top: 11.5rem !important;
  margin-bottom: 11.5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-6 {
  margin-top: 4.5rem !important;
}

.mt-7 {
  margin-top: 6rem !important;
}

.mt-8 {
  margin-top: 7.5rem !important;
}

.mt-9 {
  margin-top: 9rem !important;
}

.mt-10 {
  margin-top: 11.5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-6 {
  margin-right: 4.5rem !important;
}

.me-7 {
  margin-right: 6rem !important;
}

.me-8 {
  margin-right: 7.5rem !important;
}

.me-9 {
  margin-right: 9rem !important;
}

.me-10 {
  margin-right: 11.5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-6 {
  margin-bottom: 4.5rem !important;
}

.mb-7 {
  margin-bottom: 6rem !important;
}

.mb-8 {
  margin-bottom: 7.5rem !important;
}

.mb-9 {
  margin-bottom: 9rem !important;
}

.mb-10 {
  margin-bottom: 11.5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-6 {
  margin-left: 4.5rem !important;
}

.ms-7 {
  margin-left: 6rem !important;
}

.ms-8 {
  margin-left: 7.5rem !important;
}

.ms-9 {
  margin-left: 9rem !important;
}

.ms-10 {
  margin-left: 11.5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.m-n6 {
  margin: -4.5rem !important;
}

.m-n7 {
  margin: -6rem !important;
}

.m-n8 {
  margin: -7.5rem !important;
}

.m-n9 {
  margin: -9rem !important;
}

.m-n10 {
  margin: -11.5rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n6 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n7 {
  margin-right: -6rem !important;
  margin-left: -6rem !important;
}

.mx-n8 {
  margin-right: -7.5rem !important;
  margin-left: -7.5rem !important;
}

.mx-n9 {
  margin-right: -9rem !important;
  margin-left: -9rem !important;
}

.mx-n10 {
  margin-right: -11.5rem !important;
  margin-left: -11.5rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n6 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n7 {
  margin-top: -6rem !important;
  margin-bottom: -6rem !important;
}

.my-n8 {
  margin-top: -7.5rem !important;
  margin-bottom: -7.5rem !important;
}

.my-n9 {
  margin-top: -9rem !important;
  margin-bottom: -9rem !important;
}

.my-n10 {
  margin-top: -11.5rem !important;
  margin-bottom: -11.5rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.mt-n6 {
  margin-top: -4.5rem !important;
}

.mt-n7 {
  margin-top: -6rem !important;
}

.mt-n8 {
  margin-top: -7.5rem !important;
}

.mt-n9 {
  margin-top: -9rem !important;
}

.mt-n10 {
  margin-top: -11.5rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.me-n6 {
  margin-right: -4.5rem !important;
}

.me-n7 {
  margin-right: -6rem !important;
}

.me-n8 {
  margin-right: -7.5rem !important;
}

.me-n9 {
  margin-right: -9rem !important;
}

.me-n10 {
  margin-right: -11.5rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.mb-n6 {
  margin-bottom: -4.5rem !important;
}

.mb-n7 {
  margin-bottom: -6rem !important;
}

.mb-n8 {
  margin-bottom: -7.5rem !important;
}

.mb-n9 {
  margin-bottom: -9rem !important;
}

.mb-n10 {
  margin-bottom: -11.5rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.ms-n6 {
  margin-left: -4.5rem !important;
}

.ms-n7 {
  margin-left: -6rem !important;
}

.ms-n8 {
  margin-left: -7.5rem !important;
}

.ms-n9 {
  margin-left: -9rem !important;
}

.ms-n10 {
  margin-left: -11.5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.p-6 {
  padding: 4.5rem !important;
}

.p-7 {
  padding: 6rem !important;
}

.p-8 {
  padding: 7.5rem !important;
}

.p-9 {
  padding: 9rem !important;
}

.p-10 {
  padding: 11.5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-6 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-7 {
  padding-right: 6rem !important;
  padding-left: 6rem !important;
}

.px-8 {
  padding-right: 7.5rem !important;
  padding-left: 7.5rem !important;
}

.px-9 {
  padding-right: 9rem !important;
  padding-left: 9rem !important;
}

.px-10 {
  padding-right: 11.5rem !important;
  padding-left: 11.5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-6 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-7 {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}

.py-8 {
  padding-top: 7.5rem !important;
  padding-bottom: 7.5rem !important;
}

.py-9 {
  padding-top: 9rem !important;
  padding-bottom: 9rem !important;
}

.py-10 {
  padding-top: 11.5rem !important;
  padding-bottom: 11.5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pt-6 {
  padding-top: 4.5rem !important;
}

.pt-7 {
  padding-top: 6rem !important;
}

.pt-8 {
  padding-top: 7.5rem !important;
}

.pt-9 {
  padding-top: 9rem !important;
}

.pt-10 {
  padding-top: 11.5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pe-6 {
  padding-right: 4.5rem !important;
}

.pe-7 {
  padding-right: 6rem !important;
}

.pe-8 {
  padding-right: 7.5rem !important;
}

.pe-9 {
  padding-right: 9rem !important;
}

.pe-10 {
  padding-right: 11.5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pb-6 {
  padding-bottom: 4.5rem !important;
}

.pb-7 {
  padding-bottom: 6rem !important;
}

.pb-8 {
  padding-bottom: 7.5rem !important;
}

.pb-9 {
  padding-bottom: 9rem !important;
}

.pb-10 {
  padding-bottom: 11.5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.ps-6 {
  padding-left: 4.5rem !important;
}

.ps-7 {
  padding-left: 6rem !important;
}

.ps-8 {
  padding-left: 7.5rem !important;
}

.ps-9 {
  padding-left: 9rem !important;
}

.ps-10 {
  padding-left: 11.5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.gap-6 {
  gap: 4.5rem !important;
}

.gap-7 {
  gap: 6rem !important;
}

.gap-8 {
  gap: 7.5rem !important;
}

.gap-9 {
  gap: 9rem !important;
}

.gap-10 {
  gap: 11.5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.row-gap-6 {
  row-gap: 4.5rem !important;
}

.row-gap-7 {
  row-gap: 6rem !important;
}

.row-gap-8 {
  row-gap: 7.5rem !important;
}

.row-gap-9 {
  row-gap: 9rem !important;
}

.row-gap-10 {
  row-gap: 11.5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.column-gap-6 {
  column-gap: 4.5rem !important;
}

.column-gap-7 {
  column-gap: 6rem !important;
}

.column-gap-8 {
  column-gap: 7.5rem !important;
}

.column-gap-9 {
  column-gap: 9rem !important;
}

.column-gap-10 {
  column-gap: 11.5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.303125rem + 0.6375vw) !important;
}

.fs-2 {
  font-size: calc(1.2796875rem + 0.35625vw) !important;
}

.fs-3 {
  font-size: calc(1.25625rem + 0.075vw) !important;
}

.fs-4 {
  font-size: 1.078125rem !important;
}

.fs-5 {
  font-size: 0.9375rem !important;
}

.fs-6 {
  font-size: 0.84375rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: 700 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-orange {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-orange-rgb), var(--bs-text-opacity)) !important;
}

.text-teal {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-teal-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-50-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-orange {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-orange-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-teal {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-teal-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-orange {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-orange-rgb), var(--bs-bg-opacity)) !important;
}

.bg-teal {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-teal-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-6 {
    margin: 4.5rem !important;
  }
  .m-sm-7 {
    margin: 6rem !important;
  }
  .m-sm-8 {
    margin: 7.5rem !important;
  }
  .m-sm-9 {
    margin: 9rem !important;
  }
  .m-sm-10 {
    margin: 11.5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-sm-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
  .mx-sm-9 {
    margin-right: 9rem !important;
    margin-left: 9rem !important;
  }
  .mx-sm-10 {
    margin-right: 11.5rem !important;
    margin-left: 11.5rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-sm-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
  .my-sm-9 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }
  .my-sm-10 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-6 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-7 {
    margin-top: 6rem !important;
  }
  .mt-sm-8 {
    margin-top: 7.5rem !important;
  }
  .mt-sm-9 {
    margin-top: 9rem !important;
  }
  .mt-sm-10 {
    margin-top: 11.5rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-6 {
    margin-right: 4.5rem !important;
  }
  .me-sm-7 {
    margin-right: 6rem !important;
  }
  .me-sm-8 {
    margin-right: 7.5rem !important;
  }
  .me-sm-9 {
    margin-right: 9rem !important;
  }
  .me-sm-10 {
    margin-right: 11.5rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-7 {
    margin-bottom: 6rem !important;
  }
  .mb-sm-8 {
    margin-bottom: 7.5rem !important;
  }
  .mb-sm-9 {
    margin-bottom: 9rem !important;
  }
  .mb-sm-10 {
    margin-bottom: 11.5rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-6 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-7 {
    margin-left: 6rem !important;
  }
  .ms-sm-8 {
    margin-left: 7.5rem !important;
  }
  .ms-sm-9 {
    margin-left: 9rem !important;
  }
  .ms-sm-10 {
    margin-left: 11.5rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .m-sm-n6 {
    margin: -4.5rem !important;
  }
  .m-sm-n7 {
    margin: -6rem !important;
  }
  .m-sm-n8 {
    margin: -7.5rem !important;
  }
  .m-sm-n9 {
    margin: -9rem !important;
  }
  .m-sm-n10 {
    margin: -11.5rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-sm-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-sm-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-sm-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
  .mx-sm-n9 {
    margin-right: -9rem !important;
    margin-left: -9rem !important;
  }
  .mx-sm-n10 {
    margin-right: -11.5rem !important;
    margin-left: -11.5rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-sm-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-sm-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-sm-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
  .my-sm-n9 {
    margin-top: -9rem !important;
    margin-bottom: -9rem !important;
  }
  .my-sm-n10 {
    margin-top: -11.5rem !important;
    margin-bottom: -11.5rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .mt-sm-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-sm-n7 {
    margin-top: -6rem !important;
  }
  .mt-sm-n8 {
    margin-top: -7.5rem !important;
  }
  .mt-sm-n9 {
    margin-top: -9rem !important;
  }
  .mt-sm-n10 {
    margin-top: -11.5rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .me-sm-n6 {
    margin-right: -4.5rem !important;
  }
  .me-sm-n7 {
    margin-right: -6rem !important;
  }
  .me-sm-n8 {
    margin-right: -7.5rem !important;
  }
  .me-sm-n9 {
    margin-right: -9rem !important;
  }
  .me-sm-n10 {
    margin-right: -11.5rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-sm-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-sm-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-sm-n8 {
    margin-bottom: -7.5rem !important;
  }
  .mb-sm-n9 {
    margin-bottom: -9rem !important;
  }
  .mb-sm-n10 {
    margin-bottom: -11.5rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .ms-sm-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-sm-n7 {
    margin-left: -6rem !important;
  }
  .ms-sm-n8 {
    margin-left: -7.5rem !important;
  }
  .ms-sm-n9 {
    margin-left: -9rem !important;
  }
  .ms-sm-n10 {
    margin-left: -11.5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .p-sm-6 {
    padding: 4.5rem !important;
  }
  .p-sm-7 {
    padding: 6rem !important;
  }
  .p-sm-8 {
    padding: 7.5rem !important;
  }
  .p-sm-9 {
    padding: 9rem !important;
  }
  .p-sm-10 {
    padding: 11.5rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-sm-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-sm-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
  .px-sm-9 {
    padding-right: 9rem !important;
    padding-left: 9rem !important;
  }
  .px-sm-10 {
    padding-right: 11.5rem !important;
    padding-left: 11.5rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-sm-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-sm-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
  .py-sm-9 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }
  .py-sm-10 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pt-sm-6 {
    padding-top: 4.5rem !important;
  }
  .pt-sm-7 {
    padding-top: 6rem !important;
  }
  .pt-sm-8 {
    padding-top: 7.5rem !important;
  }
  .pt-sm-9 {
    padding-top: 9rem !important;
  }
  .pt-sm-10 {
    padding-top: 11.5rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pe-sm-6 {
    padding-right: 4.5rem !important;
  }
  .pe-sm-7 {
    padding-right: 6rem !important;
  }
  .pe-sm-8 {
    padding-right: 7.5rem !important;
  }
  .pe-sm-9 {
    padding-right: 9rem !important;
  }
  .pe-sm-10 {
    padding-right: 11.5rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-sm-7 {
    padding-bottom: 6rem !important;
  }
  .pb-sm-8 {
    padding-bottom: 7.5rem !important;
  }
  .pb-sm-9 {
    padding-bottom: 9rem !important;
  }
  .pb-sm-10 {
    padding-bottom: 11.5rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .ps-sm-6 {
    padding-left: 4.5rem !important;
  }
  .ps-sm-7 {
    padding-left: 6rem !important;
  }
  .ps-sm-8 {
    padding-left: 7.5rem !important;
  }
  .ps-sm-9 {
    padding-left: 9rem !important;
  }
  .ps-sm-10 {
    padding-left: 11.5rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .gap-sm-6 {
    gap: 4.5rem !important;
  }
  .gap-sm-7 {
    gap: 6rem !important;
  }
  .gap-sm-8 {
    gap: 7.5rem !important;
  }
  .gap-sm-9 {
    gap: 9rem !important;
  }
  .gap-sm-10 {
    gap: 11.5rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-sm-7 {
    row-gap: 6rem !important;
  }
  .row-gap-sm-8 {
    row-gap: 7.5rem !important;
  }
  .row-gap-sm-9 {
    row-gap: 9rem !important;
  }
  .row-gap-sm-10 {
    row-gap: 11.5rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-sm-7 {
    column-gap: 6rem !important;
  }
  .column-gap-sm-8 {
    column-gap: 7.5rem !important;
  }
  .column-gap-sm-9 {
    column-gap: 9rem !important;
  }
  .column-gap-sm-10 {
    column-gap: 11.5rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-6 {
    margin: 4.5rem !important;
  }
  .m-md-7 {
    margin: 6rem !important;
  }
  .m-md-8 {
    margin: 7.5rem !important;
  }
  .m-md-9 {
    margin: 9rem !important;
  }
  .m-md-10 {
    margin: 11.5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-md-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
  .mx-md-9 {
    margin-right: 9rem !important;
    margin-left: 9rem !important;
  }
  .mx-md-10 {
    margin-right: 11.5rem !important;
    margin-left: 11.5rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-md-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
  .my-md-9 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }
  .my-md-10 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-6 {
    margin-top: 4.5rem !important;
  }
  .mt-md-7 {
    margin-top: 6rem !important;
  }
  .mt-md-8 {
    margin-top: 7.5rem !important;
  }
  .mt-md-9 {
    margin-top: 9rem !important;
  }
  .mt-md-10 {
    margin-top: 11.5rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-6 {
    margin-right: 4.5rem !important;
  }
  .me-md-7 {
    margin-right: 6rem !important;
  }
  .me-md-8 {
    margin-right: 7.5rem !important;
  }
  .me-md-9 {
    margin-right: 9rem !important;
  }
  .me-md-10 {
    margin-right: 11.5rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-7 {
    margin-bottom: 6rem !important;
  }
  .mb-md-8 {
    margin-bottom: 7.5rem !important;
  }
  .mb-md-9 {
    margin-bottom: 9rem !important;
  }
  .mb-md-10 {
    margin-bottom: 11.5rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-6 {
    margin-left: 4.5rem !important;
  }
  .ms-md-7 {
    margin-left: 6rem !important;
  }
  .ms-md-8 {
    margin-left: 7.5rem !important;
  }
  .ms-md-9 {
    margin-left: 9rem !important;
  }
  .ms-md-10 {
    margin-left: 11.5rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .m-md-n6 {
    margin: -4.5rem !important;
  }
  .m-md-n7 {
    margin: -6rem !important;
  }
  .m-md-n8 {
    margin: -7.5rem !important;
  }
  .m-md-n9 {
    margin: -9rem !important;
  }
  .m-md-n10 {
    margin: -11.5rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-md-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-md-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-md-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
  .mx-md-n9 {
    margin-right: -9rem !important;
    margin-left: -9rem !important;
  }
  .mx-md-n10 {
    margin-right: -11.5rem !important;
    margin-left: -11.5rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-md-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-md-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-md-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
  .my-md-n9 {
    margin-top: -9rem !important;
    margin-bottom: -9rem !important;
  }
  .my-md-n10 {
    margin-top: -11.5rem !important;
    margin-bottom: -11.5rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .mt-md-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-md-n7 {
    margin-top: -6rem !important;
  }
  .mt-md-n8 {
    margin-top: -7.5rem !important;
  }
  .mt-md-n9 {
    margin-top: -9rem !important;
  }
  .mt-md-n10 {
    margin-top: -11.5rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .me-md-n6 {
    margin-right: -4.5rem !important;
  }
  .me-md-n7 {
    margin-right: -6rem !important;
  }
  .me-md-n8 {
    margin-right: -7.5rem !important;
  }
  .me-md-n9 {
    margin-right: -9rem !important;
  }
  .me-md-n10 {
    margin-right: -11.5rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-md-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-md-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-md-n8 {
    margin-bottom: -7.5rem !important;
  }
  .mb-md-n9 {
    margin-bottom: -9rem !important;
  }
  .mb-md-n10 {
    margin-bottom: -11.5rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .ms-md-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-md-n7 {
    margin-left: -6rem !important;
  }
  .ms-md-n8 {
    margin-left: -7.5rem !important;
  }
  .ms-md-n9 {
    margin-left: -9rem !important;
  }
  .ms-md-n10 {
    margin-left: -11.5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .p-md-6 {
    padding: 4.5rem !important;
  }
  .p-md-7 {
    padding: 6rem !important;
  }
  .p-md-8 {
    padding: 7.5rem !important;
  }
  .p-md-9 {
    padding: 9rem !important;
  }
  .p-md-10 {
    padding: 11.5rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-md-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-md-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
  .px-md-9 {
    padding-right: 9rem !important;
    padding-left: 9rem !important;
  }
  .px-md-10 {
    padding-right: 11.5rem !important;
    padding-left: 11.5rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-md-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-md-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
  .py-md-9 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }
  .py-md-10 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pt-md-6 {
    padding-top: 4.5rem !important;
  }
  .pt-md-7 {
    padding-top: 6rem !important;
  }
  .pt-md-8 {
    padding-top: 7.5rem !important;
  }
  .pt-md-9 {
    padding-top: 9rem !important;
  }
  .pt-md-10 {
    padding-top: 11.5rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pe-md-6 {
    padding-right: 4.5rem !important;
  }
  .pe-md-7 {
    padding-right: 6rem !important;
  }
  .pe-md-8 {
    padding-right: 7.5rem !important;
  }
  .pe-md-9 {
    padding-right: 9rem !important;
  }
  .pe-md-10 {
    padding-right: 11.5rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .pb-md-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-md-7 {
    padding-bottom: 6rem !important;
  }
  .pb-md-8 {
    padding-bottom: 7.5rem !important;
  }
  .pb-md-9 {
    padding-bottom: 9rem !important;
  }
  .pb-md-10 {
    padding-bottom: 11.5rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .ps-md-6 {
    padding-left: 4.5rem !important;
  }
  .ps-md-7 {
    padding-left: 6rem !important;
  }
  .ps-md-8 {
    padding-left: 7.5rem !important;
  }
  .ps-md-9 {
    padding-left: 9rem !important;
  }
  .ps-md-10 {
    padding-left: 11.5rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .gap-md-6 {
    gap: 4.5rem !important;
  }
  .gap-md-7 {
    gap: 6rem !important;
  }
  .gap-md-8 {
    gap: 7.5rem !important;
  }
  .gap-md-9 {
    gap: 9rem !important;
  }
  .gap-md-10 {
    gap: 11.5rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .row-gap-md-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-md-7 {
    row-gap: 6rem !important;
  }
  .row-gap-md-8 {
    row-gap: 7.5rem !important;
  }
  .row-gap-md-9 {
    row-gap: 9rem !important;
  }
  .row-gap-md-10 {
    row-gap: 11.5rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .column-gap-md-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-md-7 {
    column-gap: 6rem !important;
  }
  .column-gap-md-8 {
    column-gap: 7.5rem !important;
  }
  .column-gap-md-9 {
    column-gap: 9rem !important;
  }
  .column-gap-md-10 {
    column-gap: 11.5rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-6 {
    margin: 4.5rem !important;
  }
  .m-lg-7 {
    margin: 6rem !important;
  }
  .m-lg-8 {
    margin: 7.5rem !important;
  }
  .m-lg-9 {
    margin: 9rem !important;
  }
  .m-lg-10 {
    margin: 11.5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-lg-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
  .mx-lg-9 {
    margin-right: 9rem !important;
    margin-left: 9rem !important;
  }
  .mx-lg-10 {
    margin-right: 11.5rem !important;
    margin-left: 11.5rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-lg-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
  .my-lg-9 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }
  .my-lg-10 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-6 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-7 {
    margin-top: 6rem !important;
  }
  .mt-lg-8 {
    margin-top: 7.5rem !important;
  }
  .mt-lg-9 {
    margin-top: 9rem !important;
  }
  .mt-lg-10 {
    margin-top: 11.5rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-6 {
    margin-right: 4.5rem !important;
  }
  .me-lg-7 {
    margin-right: 6rem !important;
  }
  .me-lg-8 {
    margin-right: 7.5rem !important;
  }
  .me-lg-9 {
    margin-right: 9rem !important;
  }
  .me-lg-10 {
    margin-right: 11.5rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-7 {
    margin-bottom: 6rem !important;
  }
  .mb-lg-8 {
    margin-bottom: 7.5rem !important;
  }
  .mb-lg-9 {
    margin-bottom: 9rem !important;
  }
  .mb-lg-10 {
    margin-bottom: 11.5rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-6 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-7 {
    margin-left: 6rem !important;
  }
  .ms-lg-8 {
    margin-left: 7.5rem !important;
  }
  .ms-lg-9 {
    margin-left: 9rem !important;
  }
  .ms-lg-10 {
    margin-left: 11.5rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .m-lg-n6 {
    margin: -4.5rem !important;
  }
  .m-lg-n7 {
    margin: -6rem !important;
  }
  .m-lg-n8 {
    margin: -7.5rem !important;
  }
  .m-lg-n9 {
    margin: -9rem !important;
  }
  .m-lg-n10 {
    margin: -11.5rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-lg-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-lg-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-lg-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
  .mx-lg-n9 {
    margin-right: -9rem !important;
    margin-left: -9rem !important;
  }
  .mx-lg-n10 {
    margin-right: -11.5rem !important;
    margin-left: -11.5rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-lg-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-lg-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-lg-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
  .my-lg-n9 {
    margin-top: -9rem !important;
    margin-bottom: -9rem !important;
  }
  .my-lg-n10 {
    margin-top: -11.5rem !important;
    margin-bottom: -11.5rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .mt-lg-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-lg-n7 {
    margin-top: -6rem !important;
  }
  .mt-lg-n8 {
    margin-top: -7.5rem !important;
  }
  .mt-lg-n9 {
    margin-top: -9rem !important;
  }
  .mt-lg-n10 {
    margin-top: -11.5rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .me-lg-n6 {
    margin-right: -4.5rem !important;
  }
  .me-lg-n7 {
    margin-right: -6rem !important;
  }
  .me-lg-n8 {
    margin-right: -7.5rem !important;
  }
  .me-lg-n9 {
    margin-right: -9rem !important;
  }
  .me-lg-n10 {
    margin-right: -11.5rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-lg-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-lg-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-lg-n8 {
    margin-bottom: -7.5rem !important;
  }
  .mb-lg-n9 {
    margin-bottom: -9rem !important;
  }
  .mb-lg-n10 {
    margin-bottom: -11.5rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .ms-lg-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-lg-n7 {
    margin-left: -6rem !important;
  }
  .ms-lg-n8 {
    margin-left: -7.5rem !important;
  }
  .ms-lg-n9 {
    margin-left: -9rem !important;
  }
  .ms-lg-n10 {
    margin-left: -11.5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .p-lg-6 {
    padding: 4.5rem !important;
  }
  .p-lg-7 {
    padding: 6rem !important;
  }
  .p-lg-8 {
    padding: 7.5rem !important;
  }
  .p-lg-9 {
    padding: 9rem !important;
  }
  .p-lg-10 {
    padding: 11.5rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-lg-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-lg-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
  .px-lg-9 {
    padding-right: 9rem !important;
    padding-left: 9rem !important;
  }
  .px-lg-10 {
    padding-right: 11.5rem !important;
    padding-left: 11.5rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-lg-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-lg-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
  .py-lg-9 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }
  .py-lg-10 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pt-lg-6 {
    padding-top: 4.5rem !important;
  }
  .pt-lg-7 {
    padding-top: 6rem !important;
  }
  .pt-lg-8 {
    padding-top: 7.5rem !important;
  }
  .pt-lg-9 {
    padding-top: 9rem !important;
  }
  .pt-lg-10 {
    padding-top: 11.5rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pe-lg-6 {
    padding-right: 4.5rem !important;
  }
  .pe-lg-7 {
    padding-right: 6rem !important;
  }
  .pe-lg-8 {
    padding-right: 7.5rem !important;
  }
  .pe-lg-9 {
    padding-right: 9rem !important;
  }
  .pe-lg-10 {
    padding-right: 11.5rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-lg-7 {
    padding-bottom: 6rem !important;
  }
  .pb-lg-8 {
    padding-bottom: 7.5rem !important;
  }
  .pb-lg-9 {
    padding-bottom: 9rem !important;
  }
  .pb-lg-10 {
    padding-bottom: 11.5rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .ps-lg-6 {
    padding-left: 4.5rem !important;
  }
  .ps-lg-7 {
    padding-left: 6rem !important;
  }
  .ps-lg-8 {
    padding-left: 7.5rem !important;
  }
  .ps-lg-9 {
    padding-left: 9rem !important;
  }
  .ps-lg-10 {
    padding-left: 11.5rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .gap-lg-6 {
    gap: 4.5rem !important;
  }
  .gap-lg-7 {
    gap: 6rem !important;
  }
  .gap-lg-8 {
    gap: 7.5rem !important;
  }
  .gap-lg-9 {
    gap: 9rem !important;
  }
  .gap-lg-10 {
    gap: 11.5rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-lg-7 {
    row-gap: 6rem !important;
  }
  .row-gap-lg-8 {
    row-gap: 7.5rem !important;
  }
  .row-gap-lg-9 {
    row-gap: 9rem !important;
  }
  .row-gap-lg-10 {
    row-gap: 11.5rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-lg-7 {
    column-gap: 6rem !important;
  }
  .column-gap-lg-8 {
    column-gap: 7.5rem !important;
  }
  .column-gap-lg-9 {
    column-gap: 9rem !important;
  }
  .column-gap-lg-10 {
    column-gap: 11.5rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-6 {
    margin: 4.5rem !important;
  }
  .m-xl-7 {
    margin: 6rem !important;
  }
  .m-xl-8 {
    margin: 7.5rem !important;
  }
  .m-xl-9 {
    margin: 9rem !important;
  }
  .m-xl-10 {
    margin: 11.5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xl-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
  .mx-xl-9 {
    margin-right: 9rem !important;
    margin-left: 9rem !important;
  }
  .mx-xl-10 {
    margin-right: 11.5rem !important;
    margin-left: 11.5rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xl-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
  .my-xl-9 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }
  .my-xl-10 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-6 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-7 {
    margin-top: 6rem !important;
  }
  .mt-xl-8 {
    margin-top: 7.5rem !important;
  }
  .mt-xl-9 {
    margin-top: 9rem !important;
  }
  .mt-xl-10 {
    margin-top: 11.5rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-6 {
    margin-right: 4.5rem !important;
  }
  .me-xl-7 {
    margin-right: 6rem !important;
  }
  .me-xl-8 {
    margin-right: 7.5rem !important;
  }
  .me-xl-9 {
    margin-right: 9rem !important;
  }
  .me-xl-10 {
    margin-right: 11.5rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-7 {
    margin-bottom: 6rem !important;
  }
  .mb-xl-8 {
    margin-bottom: 7.5rem !important;
  }
  .mb-xl-9 {
    margin-bottom: 9rem !important;
  }
  .mb-xl-10 {
    margin-bottom: 11.5rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-6 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-7 {
    margin-left: 6rem !important;
  }
  .ms-xl-8 {
    margin-left: 7.5rem !important;
  }
  .ms-xl-9 {
    margin-left: 9rem !important;
  }
  .ms-xl-10 {
    margin-left: 11.5rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .m-xl-n6 {
    margin: -4.5rem !important;
  }
  .m-xl-n7 {
    margin: -6rem !important;
  }
  .m-xl-n8 {
    margin: -7.5rem !important;
  }
  .m-xl-n9 {
    margin: -9rem !important;
  }
  .m-xl-n10 {
    margin: -11.5rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xl-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xl-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xl-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
  .mx-xl-n9 {
    margin-right: -9rem !important;
    margin-left: -9rem !important;
  }
  .mx-xl-n10 {
    margin-right: -11.5rem !important;
    margin-left: -11.5rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xl-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xl-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xl-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
  .my-xl-n9 {
    margin-top: -9rem !important;
    margin-bottom: -9rem !important;
  }
  .my-xl-n10 {
    margin-top: -11.5rem !important;
    margin-bottom: -11.5rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .mt-xl-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-xl-n7 {
    margin-top: -6rem !important;
  }
  .mt-xl-n8 {
    margin-top: -7.5rem !important;
  }
  .mt-xl-n9 {
    margin-top: -9rem !important;
  }
  .mt-xl-n10 {
    margin-top: -11.5rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .me-xl-n6 {
    margin-right: -4.5rem !important;
  }
  .me-xl-n7 {
    margin-right: -6rem !important;
  }
  .me-xl-n8 {
    margin-right: -7.5rem !important;
  }
  .me-xl-n9 {
    margin-right: -9rem !important;
  }
  .me-xl-n10 {
    margin-right: -11.5rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xl-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-xl-n8 {
    margin-bottom: -7.5rem !important;
  }
  .mb-xl-n9 {
    margin-bottom: -9rem !important;
  }
  .mb-xl-n10 {
    margin-bottom: -11.5rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .ms-xl-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-xl-n7 {
    margin-left: -6rem !important;
  }
  .ms-xl-n8 {
    margin-left: -7.5rem !important;
  }
  .ms-xl-n9 {
    margin-left: -9rem !important;
  }
  .ms-xl-n10 {
    margin-left: -11.5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .p-xl-6 {
    padding: 4.5rem !important;
  }
  .p-xl-7 {
    padding: 6rem !important;
  }
  .p-xl-8 {
    padding: 7.5rem !important;
  }
  .p-xl-9 {
    padding: 9rem !important;
  }
  .p-xl-10 {
    padding: 11.5rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xl-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xl-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
  .px-xl-9 {
    padding-right: 9rem !important;
    padding-left: 9rem !important;
  }
  .px-xl-10 {
    padding-right: 11.5rem !important;
    padding-left: 11.5rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xl-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xl-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
  .py-xl-9 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }
  .py-xl-10 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pt-xl-6 {
    padding-top: 4.5rem !important;
  }
  .pt-xl-7 {
    padding-top: 6rem !important;
  }
  .pt-xl-8 {
    padding-top: 7.5rem !important;
  }
  .pt-xl-9 {
    padding-top: 9rem !important;
  }
  .pt-xl-10 {
    padding-top: 11.5rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pe-xl-6 {
    padding-right: 4.5rem !important;
  }
  .pe-xl-7 {
    padding-right: 6rem !important;
  }
  .pe-xl-8 {
    padding-right: 7.5rem !important;
  }
  .pe-xl-9 {
    padding-right: 9rem !important;
  }
  .pe-xl-10 {
    padding-right: 11.5rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xl-7 {
    padding-bottom: 6rem !important;
  }
  .pb-xl-8 {
    padding-bottom: 7.5rem !important;
  }
  .pb-xl-9 {
    padding-bottom: 9rem !important;
  }
  .pb-xl-10 {
    padding-bottom: 11.5rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .ps-xl-6 {
    padding-left: 4.5rem !important;
  }
  .ps-xl-7 {
    padding-left: 6rem !important;
  }
  .ps-xl-8 {
    padding-left: 7.5rem !important;
  }
  .ps-xl-9 {
    padding-left: 9rem !important;
  }
  .ps-xl-10 {
    padding-left: 11.5rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .gap-xl-6 {
    gap: 4.5rem !important;
  }
  .gap-xl-7 {
    gap: 6rem !important;
  }
  .gap-xl-8 {
    gap: 7.5rem !important;
  }
  .gap-xl-9 {
    gap: 9rem !important;
  }
  .gap-xl-10 {
    gap: 11.5rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xl-7 {
    row-gap: 6rem !important;
  }
  .row-gap-xl-8 {
    row-gap: 7.5rem !important;
  }
  .row-gap-xl-9 {
    row-gap: 9rem !important;
  }
  .row-gap-xl-10 {
    row-gap: 11.5rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xl-7 {
    column-gap: 6rem !important;
  }
  .column-gap-xl-8 {
    column-gap: 7.5rem !important;
  }
  .column-gap-xl-9 {
    column-gap: 9rem !important;
  }
  .column-gap-xl-10 {
    column-gap: 11.5rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-6 {
    margin: 4.5rem !important;
  }
  .m-xxl-7 {
    margin: 6rem !important;
  }
  .m-xxl-8 {
    margin: 7.5rem !important;
  }
  .m-xxl-9 {
    margin: 9rem !important;
  }
  .m-xxl-10 {
    margin: 11.5rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xxl-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
  .mx-xxl-9 {
    margin-right: 9rem !important;
    margin-left: 9rem !important;
  }
  .mx-xxl-10 {
    margin-right: 11.5rem !important;
    margin-left: 11.5rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xxl-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
  .my-xxl-9 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }
  .my-xxl-10 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-6 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-7 {
    margin-top: 6rem !important;
  }
  .mt-xxl-8 {
    margin-top: 7.5rem !important;
  }
  .mt-xxl-9 {
    margin-top: 9rem !important;
  }
  .mt-xxl-10 {
    margin-top: 11.5rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-6 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-7 {
    margin-right: 6rem !important;
  }
  .me-xxl-8 {
    margin-right: 7.5rem !important;
  }
  .me-xxl-9 {
    margin-right: 9rem !important;
  }
  .me-xxl-10 {
    margin-right: 11.5rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-7 {
    margin-bottom: 6rem !important;
  }
  .mb-xxl-8 {
    margin-bottom: 7.5rem !important;
  }
  .mb-xxl-9 {
    margin-bottom: 9rem !important;
  }
  .mb-xxl-10 {
    margin-bottom: 11.5rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-6 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-7 {
    margin-left: 6rem !important;
  }
  .ms-xxl-8 {
    margin-left: 7.5rem !important;
  }
  .ms-xxl-9 {
    margin-left: 9rem !important;
  }
  .ms-xxl-10 {
    margin-left: 11.5rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .m-xxl-n6 {
    margin: -4.5rem !important;
  }
  .m-xxl-n7 {
    margin: -6rem !important;
  }
  .m-xxl-n8 {
    margin: -7.5rem !important;
  }
  .m-xxl-n9 {
    margin: -9rem !important;
  }
  .m-xxl-n10 {
    margin: -11.5rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxl-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xxl-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xxl-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
  .mx-xxl-n9 {
    margin-right: -9rem !important;
    margin-left: -9rem !important;
  }
  .mx-xxl-n10 {
    margin-right: -11.5rem !important;
    margin-left: -11.5rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxl-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xxl-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xxl-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
  .my-xxl-n9 {
    margin-top: -9rem !important;
    margin-bottom: -9rem !important;
  }
  .my-xxl-n10 {
    margin-top: -11.5rem !important;
    margin-bottom: -11.5rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .mt-xxl-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-xxl-n7 {
    margin-top: -6rem !important;
  }
  .mt-xxl-n8 {
    margin-top: -7.5rem !important;
  }
  .mt-xxl-n9 {
    margin-top: -9rem !important;
  }
  .mt-xxl-n10 {
    margin-top: -11.5rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .me-xxl-n6 {
    margin-right: -4.5rem !important;
  }
  .me-xxl-n7 {
    margin-right: -6rem !important;
  }
  .me-xxl-n8 {
    margin-right: -7.5rem !important;
  }
  .me-xxl-n9 {
    margin-right: -9rem !important;
  }
  .me-xxl-n10 {
    margin-right: -11.5rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xxl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xxl-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-xxl-n8 {
    margin-bottom: -7.5rem !important;
  }
  .mb-xxl-n9 {
    margin-bottom: -9rem !important;
  }
  .mb-xxl-n10 {
    margin-bottom: -11.5rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .ms-xxl-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-xxl-n7 {
    margin-left: -6rem !important;
  }
  .ms-xxl-n8 {
    margin-left: -7.5rem !important;
  }
  .ms-xxl-n9 {
    margin-left: -9rem !important;
  }
  .ms-xxl-n10 {
    margin-left: -11.5rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .p-xxl-6 {
    padding: 4.5rem !important;
  }
  .p-xxl-7 {
    padding: 6rem !important;
  }
  .p-xxl-8 {
    padding: 7.5rem !important;
  }
  .p-xxl-9 {
    padding: 9rem !important;
  }
  .p-xxl-10 {
    padding: 11.5rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xxl-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xxl-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
  .px-xxl-9 {
    padding-right: 9rem !important;
    padding-left: 9rem !important;
  }
  .px-xxl-10 {
    padding-right: 11.5rem !important;
    padding-left: 11.5rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xxl-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xxl-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
  .py-xxl-9 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }
  .py-xxl-10 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pt-xxl-6 {
    padding-top: 4.5rem !important;
  }
  .pt-xxl-7 {
    padding-top: 6rem !important;
  }
  .pt-xxl-8 {
    padding-top: 7.5rem !important;
  }
  .pt-xxl-9 {
    padding-top: 9rem !important;
  }
  .pt-xxl-10 {
    padding-top: 11.5rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pe-xxl-6 {
    padding-right: 4.5rem !important;
  }
  .pe-xxl-7 {
    padding-right: 6rem !important;
  }
  .pe-xxl-8 {
    padding-right: 7.5rem !important;
  }
  .pe-xxl-9 {
    padding-right: 9rem !important;
  }
  .pe-xxl-10 {
    padding-right: 11.5rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xxl-7 {
    padding-bottom: 6rem !important;
  }
  .pb-xxl-8 {
    padding-bottom: 7.5rem !important;
  }
  .pb-xxl-9 {
    padding-bottom: 9rem !important;
  }
  .pb-xxl-10 {
    padding-bottom: 11.5rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .ps-xxl-6 {
    padding-left: 4.5rem !important;
  }
  .ps-xxl-7 {
    padding-left: 6rem !important;
  }
  .ps-xxl-8 {
    padding-left: 7.5rem !important;
  }
  .ps-xxl-9 {
    padding-left: 9rem !important;
  }
  .ps-xxl-10 {
    padding-left: 11.5rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .gap-xxl-6 {
    gap: 4.5rem !important;
  }
  .gap-xxl-7 {
    gap: 6rem !important;
  }
  .gap-xxl-8 {
    gap: 7.5rem !important;
  }
  .gap-xxl-9 {
    gap: 9rem !important;
  }
  .gap-xxl-10 {
    gap: 11.5rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xxl-7 {
    row-gap: 6rem !important;
  }
  .row-gap-xxl-8 {
    row-gap: 7.5rem !important;
  }
  .row-gap-xxl-9 {
    row-gap: 9rem !important;
  }
  .row-gap-xxl-10 {
    row-gap: 11.5rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xxl-7 {
    column-gap: 6rem !important;
  }
  .column-gap-xxl-8 {
    column-gap: 7.5rem !important;
  }
  .column-gap-xxl-9 {
    column-gap: 9rem !important;
  }
  .column-gap-xxl-10 {
    column-gap: 11.5rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.78125rem !important;
  }
  .fs-2 {
    font-size: 1.546875rem !important;
  }
  .fs-3 {
    font-size: 1.3125rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
:root {
  --white: #ffffff;
  --black: #000000;
  --primary: #0b7f8e;
  --grey1: #f9fafb;
  --grey2: #f3f4f6;
  --grey3: #e5e7eb;
  --grey4: #d1d5db;
  --grey5: #9ca3af;
  --grey6: #6b7280;
  --grey7: #4b5563;
  --grey8: #334155;
  --grey9: #1f2937;
  --grey10: #111827;
  --teal1: #eef6f7;
  --teal2: #aed4d9;
  --teal3: #85bfc6;
  --teal4: #5caab4;
  --teal5: #3494a1;
  --teal6: #0b7f8e;
  --teal7: #096a76;
  --teal8: #07555f;
  --teal9: #053f47;
  --teal10: #042a2f;
  --green1: #f0fdf4;
  --green2: #dcfce7;
  --green3: #bbf7d0;
  --green4: #86efac;
  --green5: #4ade80;
  --green6: #22c55e;
  --green7: #16a34a;
  --green8: #15803d;
  --green9: #14532d;
  --green10: #052e16;
  --blue1: #eff6ff;
  --blue2: #dbeafe;
  --blue3: #bfdbfe;
  --blue4: #93c5fd;
  --blue5: #60a5fa;
  --blue6: #3b82f6;
  --blue7: #2563eb;
  --blue8: #1d4ed8;
  --blue9: #1e3a8a;
  --blue10: #172554;
  --red1: #fef2f2;
  --red2: #fee2e2;
  --red3: #fecaca;
  --red4: #fca5a5;
  --red5: #f87171;
  --red6: #ef4444;
  --red7: #dc2626;
  --red8: #b91c1c;
  --red9: #991b1b;
  --red10: #450a0a;
  --yellow1: #fefce8;
  --yellow2: #fef9c3;
  --yellow3: #fef08a;
  --yellow4: #fde047;
  --yellow5: #facc15;
  --yellow6: #eab308;
  --yellow7: #ca8a04;
  --yellow8: #a16207;
  --yellow9: #854d0e;
  --yellow10: #422006;
  --orange1: #fff7ed;
  --orange2: #ffedd5;
  --orange3: #fed7aa;
  --orange4: #fdba74;
  --orange5: #fb923c;
  --orange6: #f97316;
  --orange7: #ea580c;
  --orange8: #c2410c;
  --orange9: #7c2d12;
  --orange10: #431407;
  --purple1: #faf5ff;
  --purple2: #f3e8ff;
  --purple3: #e9d5ff;
  --purple4: #d8b4fe;
  --purple5: #c084fc;
  --purple6: #a855f7;
  --purple7: #9333ea;
  --purple8: #7e22ce;
  --purple9: #581c87;
  --purple10: #3b0764;
  --pink1: #fdf2f8;
  --pink2: #fce7f3;
  --pink3: #fbcfe8;
  --pink4: #f9a8d4;
  --pink5: #f472b6;
  --pink6: #ec4899;
  --pink7: #db2777;
  --pink8: #be185d;
  --pink9: #831843;
  --pink10: #500724;
}

.white {
  color: var(--white) !important;
}

.black {
  color: var(--black) !important;
}

.primary {
  color: var(--primary) !important;
}

.grey1 {
  color: var(--grey1) !important;
}

.grey2 {
  color: var(--grey2) !important;
}

.grey3 {
  color: var(--grey3) !important;
}

.grey4 {
  color: var(--grey4) !important;
}

.grey5 {
  color: var(--grey5) !important;
}

.grey6 {
  color: var(--grey6) !important;
}

.grey7 {
  color: var(--grey7) !important;
}

.grey8 {
  color: var(--grey8) !important;
}

.grey9 {
  color: var(--grey9) !important;
}

.grey10 {
  color: var(--grey10) !important;
}

.teal1 {
  color: var(--teal1) !important;
}

.teal2 {
  color: var(--teal2) !important;
}

.teal3 {
  color: var(--teal3) !important;
}

.teal4 {
  color: var(--teal4) !important;
}

.teal5 {
  color: var(--teal5) !important;
}

.teal6 {
  color: var(--teal6) !important;
}

.teal7 {
  color: var(--teal7) !important;
}

.teal8 {
  color: var(--teal8) !important;
}

.teal9 {
  color: var(--teal9) !important;
}

.teal10 {
  color: var(--teal10) !important;
}

.green1 {
  color: var(--green1) !important;
}

.green2 {
  color: var(--green2) !important;
}

.green3 {
  color: var(--green3) !important;
}

.green4 {
  color: var(--green4) !important;
}

.green5 {
  color: var(--green5) !important;
}

.green6 {
  color: var(--green6) !important;
}

.green7 {
  color: var(--green7) !important;
}

.green8 {
  color: var(--green8) !important;
}

.green9 {
  color: var(--green9) !important;
}

.green10 {
  color: var(--green10) !important;
}

.blue1 {
  color: var(--blue1) !important;
}

.blue2 {
  color: var(--blue2) !important;
}

.blue3 {
  color: var(--blue3) !important;
}

.blue4 {
  color: var(--blue4) !important;
}

.blue5 {
  color: var(--blue5) !important;
}

.blue6 {
  color: var(--blue6) !important;
}

.blue7 {
  color: var(--blue7) !important;
}

.blue8 {
  color: var(--blue8) !important;
}

.blue9 {
  color: var(--blue9) !important;
}

.blue10 {
  color: var(--blue10) !important;
}

.red1 {
  color: var(--red1) !important;
}

.red2 {
  color: var(--red2) !important;
}

.red3 {
  color: var(--red3) !important;
}

.red4 {
  color: var(--red4) !important;
}

.red5 {
  color: var(--red5) !important;
}

.red6 {
  color: var(--red6) !important;
}

.red7 {
  color: var(--red7) !important;
}

.red8 {
  color: var(--red8) !important;
}

.red9 {
  color: var(--red9) !important;
}

.red10 {
  color: var(--red10) !important;
}

.yellow1 {
  color: var(--yellow1) !important;
}

.yellow2 {
  color: var(--yellow2) !important;
}

.yellow3 {
  color: var(--yellow3) !important;
}

.yellow4 {
  color: var(--yellow4) !important;
}

.yellow5 {
  color: var(--yellow5) !important;
}

.yellow6 {
  color: var(--yellow6) !important;
}

.yellow7 {
  color: var(--yellow7) !important;
}

.yellow8 {
  color: var(--yellow8) !important;
}

.yellow9 {
  color: var(--yellow9) !important;
}

.yellow10 {
  color: var(--yellow10) !important;
}

.orange1 {
  color: var(--orange1) !important;
}

.orange2 {
  color: var(--orange2) !important;
}

.orange3 {
  color: var(--orange3) !important;
}

.orange4 {
  color: var(--orange4) !important;
}

.orange5 {
  color: var(--orange5) !important;
}

.orange6 {
  color: var(--orange6) !important;
}

.orange7 {
  color: var(--orange7) !important;
}

.orange8 {
  color: var(--orange8) !important;
}

.orange9 {
  color: var(--orange9) !important;
}

.orange10 {
  color: var(--orange10) !important;
}

.purple1 {
  color: var(--purple1) !important;
}

.purple2 {
  color: var(--purple2) !important;
}

.purple3 {
  color: var(--purple3) !important;
}

.purple4 {
  color: var(--purple4) !important;
}

.purple5 {
  color: var(--purple5) !important;
}

.purple6 {
  color: var(--purple6) !important;
}

.purple7 {
  color: var(--purple7) !important;
}

.purple8 {
  color: var(--purple8) !important;
}

.purple9 {
  color: var(--purple9) !important;
}

.purple10 {
  color: var(--purple10) !important;
}

.pink1 {
  color: var(--pink1) !important;
}

.pink2 {
  color: var(--pink2) !important;
}

.pink3 {
  color: var(--pink3) !important;
}

.pink4 {
  color: var(--pink4) !important;
}

.pink5 {
  color: var(--pink5) !important;
}

.pink6 {
  color: var(--pink6) !important;
}

.pink7 {
  color: var(--pink7) !important;
}

.pink8 {
  color: var(--pink8) !important;
}

.pink9 {
  color: var(--pink9) !important;
}

.pink10 {
  color: var(--pink10) !important;
}

.content {
  padding-top: 7rem !important;
  padding-bottom: 1.5rem !important;
}

.btn:hover .svg-hover-white {
  filter: brightness(0) invert(1);
}

.typehead-primary .rbt-input-main {
  border-color: #0b7f8e;
}

@media (max-width: 992px) {
  .container-responsive {
    padding-top: 90px !important;
  }
  .overflow-x-responsive {
    overflow-y: hidden;
    overflow-x: auto;
  }
}
.gray-hover:hover {
  background-color: rgb(248, 248, 248);
}

.table-layout-fixed {
  table-layout: fixed;
}

.select-none {
  -webkit-user-select: none;
          user-select: none;
}

.plasma-menu .plasma-menu {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.plasma-menu button {
  padding: 0.3rem 1.2rem;
  text-align: left;
  opacity: 0.75;
}
.plasma-menu button.active {
  background: #012c32;
  color: white;
  font-weight: 500;
  position: relative;
  opacity: 1;
}
.plasma-menu button.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 10px;
  background-color: #0b7f8e;
}
.plasma-menu button.active:hover {
  opacity: 90%;
}
.plasma-menu button:hover {
  opacity: 1;
}

@media (min-width: 992px) {
  .plasma-menu {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
.accordion-button:not(.collapsed) {
  background-color: white;
  color: var(--bs-accordion-btn-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-icon);
}

.input-group-text.input-group-text-plain {
  background: white;
  color: #adb5bd;
  -webkit-user-select: none;
          user-select: none;
}

.input-group:has(.input-group-text-plain) > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group:has(.input-group-text-plain) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:has(.input-group-text-plain) > .dropdown-toggle:nth-last-child(n+3),
.input-group:has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-control,
.input-group:has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-select {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain) > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-color: #f0323c;
}

.input-group.has-validation:has(.is-warning):has(.input-group-text-plain) > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-color: #ffc837;
}

.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain) > .dropdown-toggle:nth-last-child(n+3),
.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-control,
.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-select {
  border-color: #f0323c;
}

.input-group.has-validation:has(.is-warning):has(.input-group-text-plain) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation:has(.is-warning):has(.input-group-text-plain) > .dropdown-toggle:nth-last-child(n+3),
.input-group.has-validation:has(.is-warning):has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-control,
.input-group.has-validation:has(.is-warning):has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-select {
  border-color: #ffc837;
}

.form-control.is-warning {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) !important;
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.28125rem) center;
}

.form-control:focus ~ .input-group-text-plain {
  border-color: rgba(0, 0, 0, 0.25);
}

.input-group-text-plain:has(+ .form-control:focus) {
  border-color: rgba(0, 0, 0, 0.25);
}

.input-group:has(.input-group-text-plain) > .form-control:disabled {
  background-color: #f3f4f7;
}

.input-group:has(.input-group-text-plain):has(.form-control:disabled) > .input-group-text-plain {
  background-color: #f3f4f7;
}

.input-group:has(.input-group-text-plain) > .form-control:disabled {
  background-color: #f3f4f7;
}

.input-group:has(.input-group-text-plain):has(.form-control:disabled) > .input-group-text-plain {
  background-color: #f3f4f7;
}

.form-check-input:disabled {
  background-color: #cdcdcd;
}

.indicator {
  position: relative;
}
.indicator::after {
  content: "";
  position: absolute;
  top: -5px;
  right: -5px;
  width: 10px;
  height: 10px;
  border-radius: 5rem;
  background-color: #f0323c;
}

.w-fit-content {
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.no-scrollbar {
  scrollbar-width: thin;
}
.no-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 274px;
}
.no-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--grey2);
}

.select.select-ap .react-select__menu {
  width: 300px;
  right: 0;
}
.select.select-unit .react-select__menu {
  width: 200px;
  right: 0;
}
.select.disabled .react-select__control {
  background: var(--grey1);
}
.select.disabled .react-select__control .react-select__value-container .react-select__single-value {
  color: var(--grey6);
}
.select.disabled .react-select__control .react-select__indicators .react-select__indicator {
  display: none;
}
.select.none {
  width: -moz-fit-content;
  width: fit-content;
}
.select.none .react-select__control {
  border: none !important;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.select.none .react-select__control .react-select__value-container {
  padding: 0;
}
.select.none .react-select__control .react-select__value-container .react-select__single-value {
  font-weight: 500;
  font-size: var(--16);
}
.select.none .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
}
.select.none .react-select__menu {
  width: 200px;
}
.select.multi-unit .react-select__control {
  min-height: 30px;
}
.select.multi-unit .react-select__menu {
  width: 100%;
}
.select.is-invalid .react-select__control {
  border: 1px solid var(--red7) !important;
}
.select .react-select__control {
  gap: var(--8);
  cursor: pointer;
  min-height: var(--32);
  border-radius: var(--8);
  background: var(--white);
  border: 1px solid var(--grey3);
}
.select .react-select__control:hover {
  border: 1px solid var(--grey3);
}
.select .react-select__control.react-select__control--is-focused {
  box-shadow: none;
  border: 1px solid var(--primary);
}
.select .react-select__control .react-select__value-container {
  padding: 0 0 0 var(--12);
}
.select .react-select__control .react-select__value-container .react-select__placeholder {
  margin: 0;
  font-weight: 400;
  color: var(--grey9);
  font-size: var(--14);
  line-height: var(--18);
  letter-spacing: -0.02em;
}
.select .react-select__control .react-select__value-container .react-select__single-value {
  margin: 0;
  font-weight: 400;
  color: var(--grey9);
  font-size: var(--14);
  line-height: var(--18);
  letter-spacing: -0.02em;
}
.select .react-select__control .react-select__value-container .react-select__input-container {
  margin: 0;
  padding: 0;
}
.select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0 var(--12) 0 0;
}
.select .react-select__control .react-select__indicators .react-select__indicator svg {
  fill: var(--grey9);
}
.select .react-select__menu {
  z-index: 9999;
  margin: 1px 0 0 0;
  margin-top: var(--4);
  border-radius: var(--8);
  background: var(--white);
  border: 1px solid var(--grey2);
  box-shadow: 0px 4px 6px -2px rgba(26, 26, 26, 0.2);
}
.select .react-select__menu .react-select__menu-list {
  padding: 0;
  padding: 4px;
  overflow-y: auto;
  max-height: 188px;
  scrollbar-width: thin;
}
.select .react-select__menu .react-select__menu-list::-webkit-scrollbar {
  width: 6px;
  height: 274px;
}
.select .react-select__menu .react-select__menu-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--grey2);
}
.select .react-select__menu .react-select__menu-list .react-select__option {
  padding: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  text-wrap-style: balance;
  transition: all ease-in-out 0.2s;
}
.select .react-select__menu .react-select__menu-list .react-select__option:hover {
  font-weight: 500;
  color: var(--blue6);
  background: var(--blue1) !important;
}
.select .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-selected {
  font-weight: 500;
  position: relative;
  color: var(--blue6);
  background: var(--blue1);
}
.select .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-selected::before {
  content: "";
  width: var(--16);
  height: 16px;
  position: absolute;
  top: 10px;
  right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center center;
}
.select .react-select__menu .react-select__menu-list .react-select__option.css-d7l1ni-option {
  background: transparent;
}

.react-select--is-disabled .react-select__control {
  min-height: 32px;
  border-radius: 6px;
  background: var(--grey1);
  border: 1px solid var(--grey3);
}
.react-select--is-disabled .react-select__control .react-select__value-container .react-select__placeholder {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--grey6);
  letter-spacing: -0.02em;
}
.react-select--is-disabled .react-select__control .react-select__indicators .react-select__indicator svg {
  fill: var(--grey6) !important;
}

.custom-scrollbar {
  scrollbar-width: thin;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 274px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--grey2);
}

.custom-search {
  width: 240px;
  height: 32px;
  line-height: 16px;
  border-radius: 6px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  padding: 8px 12px 8px 36px;
  background-color: var(--white);
  border: 1px solid var(--grey3);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
  background-position: 12px center;
}
.custom-search:focus {
  border: 1px solid var(--primary);
}
.custom-search::placeholder {
  font-weight: 400;
  line-height: 16px;
  color: var(--grey5);
  letter-spacing: -0.02em;
}

.custom-search-n-icon {
  width: 300px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 12px 10px;
  border-radius: 4px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  border: 1px solid var(--grey3);
}
.custom-search-n-icon::placeholder {
  color: var(--grey5);
}
.custom-search-n-icon:focus {
  border: 1px solid var(--primary);
}

.custom-field {
  height: 38px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 10px 12px;
  border-radius: 8px;
  color: var(--grey10);
  letter-spacing: -0.02em;
  background: var(--white);
  border: 1px solid var(--grey3);
}
.custom-field:focus {
  border: 1px solid var(--primary);
}
.custom-field::placeholder {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: var(--grey5);
  letter-spacing: -0.02em;
}
.custom-field.is-invalid {
  background-image: none;
}
.custom-field.error-border {
  border: 1px solid var(--red7);
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 6px;
  color: var(--grey7);
  letter-spacing: -0.02em;
}

.custom-input {
  width: 100%;
  display: flex;
  position: relative;
  align-items: stretch;
}
.custom-input > .custom-number-format {
  position: relative;
  flex: 1 1 auto;
  width: 70px;
  min-width: 0;
}

.custom-number-format {
  height: 32px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  border-radius: 6px 0 0 6px;
  border: 1px solid var(--grey3);
  border-right: none;
}
.custom-number-format:focus {
  border: 1px solid var(--primary) !important;
  border-right: none !important;
}
.custom-number-format:focus + .custom-input-text {
  border: 1px solid var(--primary) !important;
}
.custom-number-format.is-invalid {
  border: 1px solid var(--red7) !important;
  border-right: none !important;
}
.custom-number-format.is-invalid + .custom-input-text {
  border: 1px solid var(--red7) !important;
}
.custom-number-format.price {
  order: 1;
  border-radius: 0 6px 6px 0;
  border: 1px solid var(--grey3);
  border-left: none;
}
.custom-number-format.price:focus {
  border: 1px solid var(--primary) !important;
  border-left: none !important;
}
.custom-number-format.price:focus + .custom-input-text {
  border: 1px solid var(--primary) !important;
}
.custom-number-format.price.is-invalid {
  border: 1px solid var(--red7) !important;
  border-left: none !important;
}
.custom-number-format.price.is-invalid + .custom-input-text {
  border: 1px solid var(--red7) !important;
}
.custom-number-format.full-border {
  border-radius: 6px;
  border: 1px solid var(--grey3);
}
.custom-number-format.full-border:focus {
  border: 1px solid var(--primary) !important;
}
.custom-number-format.full-border:focus + .custom-input-text {
  border: 1px solid var(--primary) !important;
}
.custom-number-format.full-border.is-invalid {
  border: 1px solid var(--red7) !important;
}
.custom-number-format.full-border.is-invalid + .custom-input-text {
  border: 1px solid var(--red7) !important;
}

.custom-input-text {
  height: 32px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  background: var(--grey1);
  border-radius: 0 6px 6px 0;
  border: 1px solid var(--grey3);
}
.custom-input-text.price {
  border-radius: 6px 0 0 6px;
}

.react-datepicker-wrapper {
  width: 100%;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-items: stretch;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  height: 32px;
  font-size: 12px;
  font-weight: 400;
  padding: 8px 12px;
  line-height: 16px;
  color: var(--grey9);
  background-image: none;
  letter-spacing: -0.02em;
  border-radius: 6px 0 0 6px;
  border: 1px solid var(--grey3);
  border-right: none !important;
  transition: none !important;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control:focus {
  border: 1px solid var(--primary) !important;
  border-right: none !important;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control:focus + .input-group-text-plain {
  border: 1px solid var(--primary) !important;
  border-left: none !important;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control.is-invalid {
  border: 1px solid var(--red7) !important;
  border-right: none !important;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control.is-invalid + .input-group-text-plain {
  border: 1px solid var(--red7) !important;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control:disabled {
  background: var(--grey1);
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .form-control:disabled + .input-group-text-plain {
  background: var(--grey1);
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .input-group-text-plain {
  height: 32px;
  padding: 8px 12px;
  margin: 0 !important;
  color: var(--primary);
  border-radius: 0 6px 6px 0;
  border: 1px solid var(--grey3);
  border-left: none !important;
}
.react-datepicker-wrapper .react-datepicker__input-container .input-group .input-group-text-plain svg {
  width: 16px;
  height: 16px;
}

.delete-planning .swal2-popup {
  padding: 0;
  width: 550px;
  border-radius: 8px;
}
.delete-planning .swal2-popup .swal2-icon {
  border: none;
  margin: 16px 24px 0 24px;
  background: var(--red1);
}
.delete-planning .swal2-popup .swal2-icon .swal2-icon-content {
  width: 100%;
  height: 100%;
}
.delete-planning .swal2-popup .swal2-icon .swal2-icon-content .icon-wrapper-red {
  width: 100%;
  height: 100%;
}
.delete-planning .swal2-popup .swal2-icon .swal2-icon-content .icon-wrapper-red .info-red6 {
  display: block;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center center;
}
.delete-planning .swal2-popup .swal2-title {
  text-align: start;
  margin: 20px 24px 12px 24px;
}
.delete-planning .swal2-popup .swal2-html-container {
  margin: 0 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: start;
  color: var(--grey6);
  letter-spacing: -0.32px;
}
.delete-planning .swal2-popup .swal2-actions {
  border-radius: 0 0 8px 8px;
}

.custom-tabs {
  border: none !important;
}
.custom-tabs .rts___tabs___container {
  border: none !important;
}
.custom-tabs .rts___tabs___container .rts___tabs .rts___btn {
  margin: 0;
  transition: all 0.3s ease-in-out;
}
.custom-tabs .rts___tabs___container .rts___tabs .rts___btn:hover {
  color: var(--white) !important;
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
}
.custom-tabs .rts___tabs___container .rts___tabs .rts___tab___selected {
  color: var(--white) !important;
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
}

.tab-w-bg .rts___tabs___container .rts___tabs {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 6px;
  align-items: center;
  padding: 2px !important;
  background: var(--grey1);
  border: 1px solid var(--grey2);
}
.tab-w-bg .rts___tabs___container .rts___tabs .rts___btn {
  margin: 0 !important;
  border: none !important;
  padding: 4px 20px !important;
  transition: all 0.1s ease-in-out !important;
}
.tab-w-bg .rts___tabs___container .rts___tabs .rts___btn:hover, .tab-w-bg .rts___tabs___container .rts___tabs .rts___btn.rts___tab___selected {
  border-radius: 4px !important;
  color: var(--primary) !important;
  background: var(--white) !important;
  box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.05) !important;
}
.tab-w-bg .rts___tabs___container .rts___tabs .rts___btn:hover img, .tab-w-bg .rts___tabs___container .rts___tabs .rts___btn.rts___tab___selected img {
  filter: brightness(0) saturate(100%) invert(20%) sepia(94%) saturate(715%) hue-rotate(145deg) brightness(96%) contrast(95%);
}

.ws-nowrap {
  white-space: nowrap;
}

.flex-none {
  flex: none !important;
}

.heading {
  font-weight: 700 !important;
  letter-spacing: -0.02em !important;
}
.heading.heading1 {
  font-size: 40px !important;
  line-height: 48px !important;
}
.heading.heading2 {
  font-size: 36px !important;
  line-height: 44px !important;
}
.heading.heading3 {
  font-size: 32px !important;
  line-height: 38px !important;
}

.title {
  font-weight: 600 !important;
  letter-spacing: -0.02em !important;
}
.title.title1 {
  font-size: 24px !important;
  line-height: 28px !important;
}
.title.title2 {
  font-size: 20px !important;
  line-height: 24px !important;
}

.subtitle {
  font-weight: 500 !important;
  letter-spacing: -0.02em !important;
}
.subtitle.subtitle1 {
  font-size: 20px !important;
  line-height: 24px !important;
}
.subtitle.subtitle2 {
  font-size: 18px !important;
  line-height: 24px !important;
}
.subtitle.subtitle3 {
  font-size: 16px !important;
  line-height: 20px !important;
}
.subtitle.subtitle4 {
  font-size: 14px !important;
  line-height: 18px !important;
}

.body {
  font-weight: 400 !important;
  letter-spacing: -0.02em !important;
}
.body.bodyL {
  font-size: 18px !important;
  line-height: 24px !important;
}
.body.bodyM {
  font-size: 16px !important;
  line-height: 20px !important;
}
.body.bodyS {
  font-size: 14px !important;
  line-height: 18px !important;
}
.body.bodyXs {
  font-size: 12px !important;
  line-height: 16px !important;
}

.label {
  font-weight: 400 !important;
  letter-spacing: -0.02em !important;
}
.label.label1 {
  font-size: 12px !important;
  line-height: 16px !important;
}
.label.label2 {
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 16px !important;
}

.caption {
  font-size: 10px !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  letter-spacing: -0.02em !important;
}

:root {
  --4: 4px;
  --6: 6px;
  --8: 8px;
  --10: 10px;
  --12: 12px;
  --14: 14px;
  --16: 16px;
  --18: 18px;
  --20: 20px;
  --24: 24px;
  --28: 28px;
  --32: 32px;
  --38: 38px;
  --40: 40px;
  --42: 42px;
  --46: 46px;
  --48: 48px;
  --50: 50px;
  --56: 56px;
  --64: 64px;
  --72: 72px;
}

.m-4px {
  margin: var(--4) !important;
}

.m-6px {
  margin: var(--6) !important;
}

.m-8px {
  margin: var(--8) !important;
}

.m-10px {
  margin: var(--10) !important;
}

.m-12px {
  margin: var(--12) !important;
}

.m-14px {
  margin: var(--14) !important;
}

.m-16px {
  margin: var(--16) !important;
}

.m-18px {
  margin: var(--18) !important;
}

.m-20px {
  margin: var(--20) !important;
}

.m-24px {
  margin: var(--24) !important;
}

.m-28px {
  margin: var(--28) !important;
}

.m-32px {
  margin: var(--32) !important;
}

.m-38px {
  margin: var(--38) !important;
}

.m-40px {
  margin: var(--40) !important;
}

.m-42px {
  margin: var(--42) !important;
}

.m-46px {
  margin: var(--46) !important;
}

.m-48px {
  margin: var(--48) !important;
}

.m-50px {
  margin: var(--50) !important;
}

.m-56px {
  margin: var(--56) !important;
}

.m-64px {
  margin: var(--64) !important;
}

.m-72px {
  margin: var(--72) !important;
}

.mt-4px {
  margin-top: var(--4) !important;
}

.mt-6px {
  margin-top: var(--6) !important;
}

.mt-8px {
  margin-top: var(--8) !important;
}

.mt-10px {
  margin-top: var(--10) !important;
}

.mt-12px {
  margin-top: var(--12) !important;
}

.m-14px {
  margin-top: var(--14) !important;
}

.mt-16px {
  margin-top: var(--16) !important;
}

.mt-18px {
  margin-top: var(--18) !important;
}

.mt-20px {
  margin-top: var(--20) !important;
}

.mt-24px {
  margin-top: var(--24) !important;
}

.mt-28px {
  margin-top: var(--28) !important;
}

.mt-32px {
  margin-top: var(--32) !important;
}

.mt-38px {
  margin-top: var(--38) !important;
}

.mt-40px {
  margin-top: var(--40) !important;
}

.m-42px {
  margin-top: var(--42) !important;
}

.mt-46px {
  margin-top: var(--46) !important;
}

.mt-48px {
  margin-top: var(--48) !important;
}

.mt-50px {
  margin-top: var(--50) !important;
}

.mt-56px {
  margin-top: var(--56) !important;
}

.mt-64px {
  margin-top: var(--64) !important;
}

.mt-72px {
  margin-top: var(--72) !important;
}

.mb-4px {
  margin-bottom: var(--4) !important;
}

.mb-6px {
  margin-bottom: var(--6) !important;
}

.mb-8px {
  margin-bottom: var(--8) !important;
}

.mb-10px {
  margin-bottom: var(--10) !important;
}

.mb-12px {
  margin-bottom: var(--12) !important;
}

.mb-14px {
  margin-bottom: var(--14) !important;
}

.mb-16px {
  margin-bottom: var(--16) !important;
}

.mb-18px {
  margin-bottom: var(--18) !important;
}

.mb-20px {
  margin-bottom: var(--20) !important;
}

.mb-24px {
  margin-bottom: var(--24) !important;
}

.mb-28px {
  margin-bottom: var(--28) !important;
}

.mb-32px {
  margin-bottom: var(--32) !important;
}

.mb-38px {
  margin-bottom: var(--38) !important;
}

.mb-40px {
  margin-bottom: var(--40) !important;
}

.mb-42px {
  margin-bottom: var(--42) !important;
}

.mb-46px {
  margin-bottom: var(--46) !important;
}

.mb-48px {
  margin-bottom: var(--48) !important;
}

.mb-50px {
  margin-bottom: var(--50) !important;
}

.mb-56px {
  margin-bottom: var(--56) !important;
}

.mb-64px {
  margin-bottom: var(--64) !important;
}

.mb-72px {
  margin-bottom: var(--72) !important;
}

.ml-4px {
  margin-left: var(--4) !important;
}

.ml-6px {
  margin-left: var(--6) !important;
}

.ml-8px {
  margin-left: var(--8) !important;
}

.ml-10px {
  margin-left: var(--10) !important;
}

.ml-12px {
  margin-left: var(--12) !important;
}

.ml-14px {
  margin-left: var(--14) !important;
}

.ml-16px {
  margin-left: var(--16) !important;
}

.ml-18px {
  margin-left: var(--18) !important;
}

.ml-20px {
  margin-left: var(--20) !important;
}

.ml-24px {
  margin-left: var(--24) !important;
}

.ml-28px {
  margin-left: var(--28) !important;
}

.ml-32px {
  margin-left: var(--32) !important;
}

.ml-38px {
  margin-left: var(--38) !important;
}

.ml-40px {
  margin-left: var(--40) !important;
}

.ml-42px {
  margin-left: var(--42) !important;
}

.ml-46px {
  margin-left: var(--46) !important;
}

.ml-48px {
  margin-left: var(--48) !important;
}

.ml-50px {
  margin-left: var(--50) !important;
}

.ml-56px {
  margin-left: var(--56) !important;
}

.ml-64px {
  margin-left: var(--64) !important;
}

.ml-72px {
  margin-left: var(--72) !important;
}

.mr-4px {
  margin-right: var(--4) !important;
}

.mr-6px {
  margin-right: var(--6) !important;
}

.mr-8px {
  margin-right: var(--8) !important;
}

.mr-10px {
  margin-right: var(--10) !important;
}

.mr-12px {
  margin-right: var(--12) !important;
}

.mr-14px {
  margin-right: var(--14) !important;
}

.mr-16px {
  margin-right: var(--16) !important;
}

.mr-18px {
  margin-right: var(--18) !important;
}

.mr-20px {
  margin-right: var(--20) !important;
}

.mr-24px {
  margin-right: var(--24) !important;
}

.mr-28px {
  margin-right: var(--28) !important;
}

.mr-32px {
  margin-right: var(--32) !important;
}

.mr-38px {
  margin-right: var(--38) !important;
}

.mr-40px {
  margin-right: var(--40) !important;
}

.mr-42px {
  margin-right: var(--42) !important;
}

.mr-46px {
  margin-right: var(--46) !important;
}

.mr-48px {
  margin-right: var(--48) !important;
}

.mr-50px {
  margin-right: var(--50) !important;
}

.mr-56px {
  margin-right: var(--56) !important;
}

.mr-64px {
  margin-right: var(--64) !important;
}

.mr-72px {
  margin-right: var(--72) !important;
}

.mx-4px {
  margin-left: var(--4) !important;
  margin-right: var(--4) !important;
}

.mx-6px {
  margin-left: var(--6) !important;
  margin-right: var(--6) !important;
}

.mx-8px {
  margin-left: var(--8) !important;
  margin-right: var(--8) !important;
}

.mx-10px {
  margin-left: var(--10) !important;
  margin-right: var(--10) !important;
}

.mx-12px {
  margin-left: var(--12) !important;
  margin-right: var(--12) !important;
}

.mx-14px {
  margin-left: var(--14) !important;
  margin-right: var(--14) !important;
}

.mx-16px {
  margin-left: var(--16) !important;
  margin-right: var(--16) !important;
}

.mx-18px {
  margin-left: var(--18) !important;
  margin-right: var(--18) !important;
}

.mx-20px {
  margin-left: var(--20) !important;
  margin-right: var(--20) !important;
}

.mx-24px {
  margin-left: var(--24) !important;
  margin-right: var(--24) !important;
}

.mx-28px {
  margin-left: var(--28) !important;
  margin-right: var(--28) !important;
}

.mx-32px {
  margin-left: var(--32) !important;
  margin-right: var(--32) !important;
}

.mx-38px {
  margin-left: var(--38) !important;
  margin-right: var(--38) !important;
}

.mx-40px {
  margin-left: var(--40) !important;
  margin-right: var(--40) !important;
}

.mx-42px {
  margin-left: var(--42) !important;
  margin-right: var(--42) !important;
}

.mx-46px {
  margin-left: var(--46) !important;
  margin-right: var(--46) !important;
}

.mx-48px {
  margin-left: var(--48) !important;
  margin-right: var(--48) !important;
}

.mx-50px {
  margin-left: var(--50) !important;
  margin-right: var(--50) !important;
}

.mx-56px {
  margin-left: var(--56) !important;
  margin-right: var(--56) !important;
}

.mx-64px {
  margin-left: var(--64) !important;
  margin-right: var(--64) !important;
}

.mx-72px {
  margin-left: var(--72) !important;
  margin-right: var(--72) !important;
}

.my-4px {
  margin-top: var(--4) !important;
  margin-bottom: var(--4) !important;
}

.my-6px {
  margin-top: var(--6) !important;
  margin-bottom: var(--6) !important;
}

.my-8px {
  margin-top: var(--8) !important;
  margin-bottom: var(--8) !important;
}

.my-10px {
  margin-top: var(--10) !important;
  margin-bottom: var(--10) !important;
}

.my-12px {
  margin-top: var(--12) !important;
  margin-bottom: var(--12) !important;
}

.my-14px {
  margin-top: var(--14) !important;
  margin-bottom: var(--14) !important;
}

.my-16px {
  margin-top: var(--16) !important;
  margin-bottom: var(--16) !important;
}

.my-18px {
  margin-top: var(--18) !important;
  margin-bottom: var(--18) !important;
}

.my-20px {
  margin-top: var(--20) !important;
  margin-bottom: var(--20) !important;
}

.my-24px {
  margin-top: var(--24) !important;
  margin-bottom: var(--24) !important;
}

.my-28px {
  margin-top: var(--28) !important;
  margin-bottom: var(--28) !important;
}

.my-32px {
  margin-top: var(--32) !important;
  margin-bottom: var(--32) !important;
}

.my-38px {
  margin-top: var(--38) !important;
  margin-bottom: var(--38) !important;
}

.my-40px {
  margin-top: var(--40) !important;
  margin-bottom: var(--40) !important;
}

.my-42px {
  margin-top: var(--42) !important;
  margin-bottom: var(--42) !important;
}

.my-46px {
  margin-top: var(--46) !important;
  margin-bottom: var(--46) !important;
}

.my-48px {
  margin-top: var(--48) !important;
  margin-bottom: var(--48) !important;
}

.my-50px {
  margin-top: var(--50) !important;
  margin-bottom: var(--50) !important;
}

.my-56px {
  margin-top: var(--56) !important;
  margin-bottom: var(--56) !important;
}

.my-64px {
  margin-top: var(--64) !important;
  margin-bottom: var(--64) !important;
}

.my-72px {
  margin-top: var(--72) !important;
  margin-bottom: var(--72) !important;
}

.p-4px {
  padding: var(--4) !important;
}

.p-6px {
  padding: var(--6) !important;
}

.p-8px {
  padding: var(--8) !important;
}

.p-10px {
  padding: var(--10) !important;
}

.p-12px {
  padding: var(--12) !important;
}

.p-14px {
  padding: var(--14) !important;
}

.p-16px {
  padding: var(--16) !important;
}

.p-18px {
  padding: var(--18) !important;
}

.p-20px {
  padding: var(--20) !important;
}

.p-24px {
  padding: var(--24) !important;
}

.p-28px {
  padding: var(--28) !important;
}

.p-32px {
  padding: var(--32) !important;
}

.p-38px {
  padding: var(--38) !important;
}

.p-40px {
  padding: var(--40) !important;
}

.p-42px {
  padding: var(--42) !important;
}

.p-46px {
  padding: var(--46) !important;
}

.p-48px {
  padding: var(--48) !important;
}

.p-50px {
  padding: var(--50) !important;
}

.p-56px {
  padding: var(--56) !important;
}

.p-64px {
  padding: var(--64) !important;
}

.p-72px {
  padding: var(--72) !important;
}

.pt-4px {
  padding-top: var(--4) !important;
}

.pt-6px {
  padding-top: var(--6) !important;
}

.pt-8px {
  padding-top: var(--8) !important;
}

.pt-10px {
  padding-top: var(--10) !important;
}

.pt-12px {
  padding-top: var(--12) !important;
}

.pt-14px {
  padding-top: var(--14) !important;
}

.pt-16px {
  padding-top: var(--16) !important;
}

.pt-18px {
  padding-top: var(--18) !important;
}

.pt-20px {
  padding-top: var(--20) !important;
}

.pt-24px {
  padding-top: var(--24) !important;
}

.pt-28px {
  padding-top: var(--28) !important;
}

.pt-32px {
  padding-top: var(--32) !important;
}

.pt-38px {
  padding-top: var(--38) !important;
}

.pt-40px {
  padding-top: var(--40) !important;
}

.pt-42px {
  padding-top: var(--42) !important;
}

.pt-46px {
  padding-top: var(--46) !important;
}

.pt-48px {
  padding-top: var(--48) !important;
}

.pt-50px {
  padding-top: var(--50) !important;
}

.p-56px {
  padding-top: var(--56) !important;
}

.pt-64px {
  padding-top: var(--64) !important;
}

.pt-72px {
  padding-top: var(--72) !important;
}

.pb-4px {
  padding-bottom: var(--4) !important;
}

.pb-6px {
  padding-bottom: var(--6) !important;
}

.pb-8px {
  padding-bottom: var(--8) !important;
}

.pb-10px {
  padding-bottom: var(--10) !important;
}

.pb-12px {
  padding-bottom: var(--12) !important;
}

.pb-14px {
  padding-bottom: var(--14) !important;
}

.pb-16px {
  padding-bottom: var(--16) !important;
}

.pb-18px {
  padding-bottom: var(--18) !important;
}

.pb-20px {
  padding-bottom: var(--20) !important;
}

.pb-24px {
  padding-bottom: var(--24) !important;
}

.pb-28px {
  padding-bottom: var(--28) !important;
}

.pb-32px {
  padding-bottom: var(--32) !important;
}

.pb-38px {
  padding-bottom: var(--38) !important;
}

.pb-40px {
  padding-bottom: var(--40) !important;
}

.pb-42px {
  padding-bottom: var(--42) !important;
}

.pb-46px {
  padding-bottom: var(--46) !important;
}

.pb-48px {
  padding-bottom: var(--48) !important;
}

.pb-50px {
  padding-bottom: var(--50) !important;
}

.pb-56px {
  padding-bottom: var(--56) !important;
}

.pb-64px {
  padding-bottom: var(--64) !important;
}

.pb-72px {
  padding-bottom: var(--72) !important;
}

.pl-4px {
  padding-left: var(--4) !important;
}

.pl-6px {
  padding-left: var(--6) !important;
}

.pl-8px {
  padding-left: var(--8) !important;
}

.pl-10px {
  padding-left: var(--10) !important;
}

.pl-12px {
  padding-left: var(--12) !important;
}

.pl-14px {
  padding-left: var(--14) !important;
}

.pl-16px {
  padding-left: var(--16) !important;
}

.pl-18px {
  padding-left: var(--18) !important;
}

.pl-20px {
  padding-left: var(--20) !important;
}

.pl-24px {
  padding-left: var(--24) !important;
}

.pl-28px {
  padding-left: var(--28) !important;
}

.pl-32px {
  padding-left: var(--32) !important;
}

.pl-38px {
  padding-left: var(--38) !important;
}

.pl-40px {
  padding-left: var(--40) !important;
}

.pl-42px {
  padding-left: var(--42) !important;
}

.pl-46px {
  padding-left: var(--46) !important;
}

.pl-48px {
  padding-left: var(--48) !important;
}

.pl-50px {
  padding-left: var(--50) !important;
}

.pl-56px {
  padding-left: var(--56) !important;
}

.pl-64px {
  padding-left: var(--64) !important;
}

.pl-72px {
  padding-left: var(--72) !important;
}

.pr-4px {
  padding-right: var(--4) !important;
}

.pr-6px {
  padding-right: var(--6) !important;
}

.pr-8px {
  padding-right: var(--8) !important;
}

.pr-10px {
  padding-right: var(--10) !important;
}

.pr-12px {
  padding-right: var(--12) !important;
}

.pr-14px {
  padding-right: var(--14) !important;
}

.pr-16px {
  padding-right: var(--16) !important;
}

.pr-18px {
  padding-right: var(--18) !important;
}

.pr-20px {
  padding-right: var(--20) !important;
}

.pr-24px {
  padding-right: var(--24) !important;
}

.pr-28px {
  padding-right: var(--28) !important;
}

.pr-32px {
  padding-right: var(--32) !important;
}

.pr-38px {
  padding-right: var(--38) !important;
}

.pr-40px {
  padding-right: var(--40) !important;
}

.pr-42px {
  padding-right: var(--42) !important;
}

.pr-46px {
  padding-right: var(--46) !important;
}

.pr-48px {
  padding-right: var(--48) !important;
}

.pr-50px {
  padding-right: var(--50) !important;
}

.pr-56px {
  padding-right: var(--56) !important;
}

.pr-64px {
  padding-right: var(--64) !important;
}

.pr-72px {
  padding-right: var(--72) !important;
}

.px-4px {
  padding-left: var(--4) !important;
  padding-right: var(--4) !important;
}

.px-6px {
  padding-left: var(--6) !important;
  padding-right: var(--6) !important;
}

.px-8px {
  padding-left: var(--8) !important;
  padding-right: var(--8) !important;
}

.px-10px {
  padding-left: var(--10) !important;
  padding-right: var(--10) !important;
}

.px-12px {
  padding-left: var(--12) !important;
  padding-right: var(--12) !important;
}

.px-14px {
  padding-left: var(--14) !important;
  padding-right: var(--14) !important;
}

.px-16px {
  padding-left: var(--16) !important;
  padding-right: var(--16) !important;
}

.px-18px {
  padding-left: var(--18) !important;
  padding-right: var(--18) !important;
}

.px-20px {
  padding-left: var(--20) !important;
  padding-right: var(--20) !important;
}

.px-24px {
  padding-left: var(--24) !important;
  padding-right: var(--24) !important;
}

.px-28px {
  padding-left: var(--28) !important;
  padding-right: var(--28) !important;
}

.px-32px {
  padding-left: var(--32) !important;
  padding-right: var(--32) !important;
}

.px-38px {
  padding-left: var(--38) !important;
  padding-right: var(--38) !important;
}

.px-40px {
  padding-left: var(--40) !important;
  padding-right: var(--40) !important;
}

.px-42px {
  padding-left: var(--42) !important;
  padding-right: var(--42) !important;
}

.px-46px {
  padding-left: var(--46) !important;
  padding-right: var(--46) !important;
}

.px-48px {
  padding-left: var(--48) !important;
  padding-right: var(--48) !important;
}

.px-50px {
  padding-left: var(--50) !important;
  padding-right: var(--50) !important;
}

.px-56px {
  padding-left: var(--56) !important;
  padding-right: var(--56) !important;
}

.px-64px {
  padding-left: var(--64) !important;
  padding-right: var(--64) !important;
}

.px-72px {
  padding-left: var(--72) !important;
  padding-right: var(--72) !important;
}

.py-4px {
  padding-top: var(--4) !important;
  padding-bottom: var(--4) !important;
}

.py-6px {
  padding-top: var(--6) !important;
  padding-bottom: var(--6) !important;
}

.py-8px {
  padding-top: var(--8) !important;
  padding-bottom: var(--8) !important;
}

.py-10px {
  padding-top: var(--10) !important;
  padding-bottom: var(--10) !important;
}

.py-12px {
  padding-top: var(--12) !important;
  padding-bottom: var(--12) !important;
}

.py-14px {
  padding-top: var(--14) !important;
  padding-bottom: var(--14) !important;
}

.py-16px {
  padding-top: var(--16) !important;
  padding-bottom: var(--16) !important;
}

.py-18px {
  padding-top: var(--18) !important;
  padding-bottom: var(--18) !important;
}

.py-20px {
  padding-top: var(--20) !important;
  padding-bottom: var(--20) !important;
}

.py-24px {
  padding-top: var(--24) !important;
  padding-bottom: var(--24) !important;
}

.py-28px {
  padding-top: var(--28) !important;
  padding-bottom: var(--28) !important;
}

.py-32px {
  padding-top: var(--32) !important;
  padding-bottom: var(--32) !important;
}

.py-38px {
  padding-top: var(--38) !important;
  padding-bottom: var(--38) !important;
}

.py-40px {
  padding-top: var(--40) !important;
  padding-bottom: var(--40) !important;
}

.py-42px {
  padding-top: var(--42) !important;
  padding-bottom: var(--42) !important;
}

.py-46px {
  padding-top: var(--46) !important;
  padding-bottom: var(--46) !important;
}

.py-48px {
  padding-top: var(--48) !important;
  padding-bottom: var(--48) !important;
}

.py-50px {
  padding-top: var(--50) !important;
  padding-bottom: var(--50) !important;
}

.py-56px {
  padding-top: var(--56) !important;
  padding-bottom: var(--56) !important;
}

.py-64px {
  padding-top: var(--64) !important;
  padding-bottom: var(--64) !important;
}

.py-72px {
  padding-top: var(--72) !important;
  padding-bottom: var(--72) !important;
}

.gap-4px {
  gap: var(--4) !important;
}

.gap-6px {
  gap: var(--6) !important;
}

.gap-8px {
  gap: var(--8) !important;
}

.gap-10px {
  gap: var(--10) !important;
}

.gap-12px {
  gap: var(--12) !important;
}

.gap-14px {
  gap: var(--14) !important;
}

.gap-16px {
  gap: var(--16) !important;
}

.gap-18px {
  gap: var(--18) !important;
}

.gap-20px {
  gap: var(--20) !important;
}

.gap-24px {
  gap: var(--24) !important;
}

.gap-28px {
  gap: var(--28) !important;
}

.gap-32px {
  gap: var(--32) !important;
}

.gap-38px {
  gap: var(--38) !important;
}

.gap-40px {
  gap: var(--40) !important;
}

.gap-42px {
  gap: var(--42) !important;
}

.gap-46px {
  gap: var(--46) !important;
}

.gap-48px {
  gap: var(--48) !important;
}

.gap-50px {
  gap: var(--50) !important;
}

.gap-56px {
  gap: var(--56) !important;
}

.gap-64px {
  gap: var(--64) !important;
}

.gap-72px {
  gap: var(--72) !important;
}

.br-4px {
  border-radius: var(--4) !important;
}

.br-6px {
  border-radius: var(--6) !important;
}

.br-8px {
  border-radius: var(--8) !important;
}

.br-10px {
  border-radius: var(--10) !important;
}

.br-12px {
  border-radius: var(--12) !important;
}

.br-14px {
  border-radius: var(--14) !important;
}

.br-16px {
  border-radius: var(--16) !important;
}

.br-18px {
  border-radius: var(--18) !important;
}

.br-20px {
  border-radius: var(--20) !important;
}

.br-24px {
  border-radius: var(--24) !important;
}

.br-28px {
  border-radius: var(--28) !important;
}

.br-32px {
  border-radius: var(--32) !important;
}

.br-38px {
  border-radius: var(--38) !important;
}

.br-40px {
  border-radius: var(--40) !important;
}

.br-42px {
  border-radius: var(--42) !important;
}

.br-46px {
  border-radius: var(--46) !important;
}

.br-48px {
  border-radius: var(--48) !important;
}

.br-50px {
  border-radius: var(--50) !important;
}

.br-56px {
  border-radius: var(--56) !important;
}

.br-64px {
  border-radius: var(--64) !important;
}

.br-72px {
  border-radius: var(--72) !important;
}

.br-circle {
  border-radius: 50% !important;
}

.border1-grey3 {
  border: 1px solid var(--grey3) !important;
}

.border-bottom1-grey2 {
  border-bottom: 1px solid var(--grey2) !important;
}

.border-bottom1-grey3 {
  border-bottom: 1px solid var(--grey3) !important;
}

.border-bottom2-teal6 {
  border-bottom: 2px solid var(--teal6) !important;
}

.border1-blue7 {
  border: 1px solid var(--blue7) !important;
}

.custom-accordionwitharrow .card + .card {
  margin-top: 0.5rem;
}
.custom-accordionwitharrow .card .card-header {
  background-color: transparent;
  position: relative;
}
.custom-accordionwitharrow .accordion-arrow {
  position: absolute;
  right: 1.25rem;
}
.custom-accordionwitharrow a.collapsed .accordion-arrow {
  transform: rotate(-90deg);
}

.custom-accordion .card {
  overflow: visible;
  border-color: transparent !important;
  border-left: 2px dashed #dee2e6 !important;
  box-shadow: none;
  padding-left: 40px;
}
.custom-accordion .card .card-header {
  border-radius: 7px !important;
}
.custom-accordion .card .card-header:before {
  content: "";
  position: absolute;
  left: 6px;
  top: 22px;
  width: 42px;
  height: 2px;
  background: #dee2e6;
}
.custom-accordion .card .icon {
  position: absolute;
  left: -18px;
  top: -2px;
}

.alert-dismissible {
  padding-right: 3.75rem;
}

.alert-primary {
  color: #343a40;
  border-color: #0b7f8e;
  background-color: #cee5e8;
}

.alert-secondary {
  color: #343a40;
  border-color: #495057;
  background-color: #dbdcdd;
}

.alert-success {
  color: #343a40;
  border-color: #3cd278;
  background-color: #d8f6e4;
}

.alert-info {
  color: #343a40;
  border-color: #17a2b8;
  background-color: #d1ecf1;
}

.alert-warning {
  color: #343a40;
  border-color: #ffc837;
  background-color: #fff4d7;
}

.alert-danger {
  color: #343a40;
  border-color: #f0323c;
  background-color: #fcd6d8;
}

.alert-light {
  color: #343a40;
  border-color: #f4f5f7;
  background-color: #fdfdfd;
}

.alert-dark {
  color: #343a40;
  border-color: #343a40;
  background-color: #d6d8d9;
}

.alert-orange {
  color: #343a40;
  border-color: #ff784b;
  background-color: #ffe4db;
}

.alert-teal {
  color: #343a40;
  border-color: #20c997;
  background-color: #d2f4ea;
}

.alert-gray-50 {
  color: #343a40;
  border-color: #fefefe;
  background-color: white;
}

.badge-soft {
  color: #343a40;
}

.badge-soft-primary {
  background-color: rgba(11, 127, 142, 0.12);
  color: #0b7f8e !important;
}

.badge-soft-secondary {
  background-color: rgba(73, 80, 87, 0.12);
  color: #495057 !important;
}

.badge-soft-success {
  background-color: rgba(60, 210, 120, 0.12);
  color: #3cd278 !important;
}

.badge-soft-info {
  background-color: rgba(23, 162, 184, 0.12);
  color: #17a2b8 !important;
}

.badge-soft-warning {
  background-color: rgba(255, 200, 55, 0.12);
  color: #ffc837 !important;
}

.badge-soft-danger {
  background-color: rgba(240, 50, 60, 0.12);
  color: #f0323c !important;
}

.badge-soft-light {
  background-color: rgba(244, 245, 247, 0.12);
  color: #f4f5f7 !important;
}

.badge-soft-dark {
  background-color: rgba(52, 58, 64, 0.12);
  color: #343a40 !important;
}

.badge-soft-orange {
  background-color: rgba(255, 120, 75, 0.12);
  color: #ff784b !important;
}

.badge-soft-teal {
  background-color: rgba(32, 201, 151, 0.12);
  color: #20c997 !important;
}

.badge-soft-gray-50 {
  background-color: rgba(254, 254, 254, 0.12);
  color: #fefefe !important;
}

.badge.badge-light {
  color: #343a40;
}
.badge.badge-pill {
  border-radius: 50px !important;
}
.badge.badge-md {
  padding: 4px 16px;
  font-size: 16px;
}
.badge.badge-lg {
  padding: 7px 20px;
  font-size: 17px;
}

.bg-soft-primary {
  background-color: rgba(11, 127, 142, 0.12) !important;
}

.bg-soft-secondary {
  background-color: rgba(73, 80, 87, 0.12) !important;
}

.bg-soft-success {
  background-color: rgba(60, 210, 120, 0.12) !important;
}

.bg-soft-info {
  background-color: rgba(23, 162, 184, 0.12) !important;
}

.bg-soft-warning {
  background-color: rgba(255, 200, 55, 0.12) !important;
}

.bg-soft-danger {
  background-color: rgba(240, 50, 60, 0.12) !important;
}

.bg-soft-light {
  background-color: rgba(244, 245, 247, 0.12) !important;
}

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.12) !important;
}

.bg-soft-orange {
  background-color: rgba(255, 120, 75, 0.12) !important;
}

.bg-soft-teal {
  background-color: rgba(32, 201, 151, 0.12) !important;
}

.bg-soft-gray-50 {
  background-color: rgba(254, 254, 254, 0.12) !important;
}

.bg-gray-100 {
  background-color: #f4f5f7 !important;
}

.bg-gray-200 {
  background-color: #f3f4f7 !important;
}

.bg-gray-300 {
  background-color: #dee2e6 !important;
}

.bg-gray-400 {
  background-color: #cdcdcd !important;
}

.bg-gray-500 {
  background-color: #adb5bd !important;
}

.bg-gray-600 {
  background-color: #787878 !important;
}

.bg-gray-700 {
  background-color: #495057 !important;
}

.bg-gray-800 {
  background-color: #343a40 !important;
}

.bg-gray-900 {
  background-color: #212529 !important;
}

.shape {
  position: absolute;
  pointer-events: none;
  overflow: hidden;
}
.shape.left {
  top: 0;
  bottom: 0;
  left: -1px;
}
.shape.right {
  top: 0;
  right: -1px;
  bottom: 0;
}
.shape.bottom {
  bottom: -2px;
  left: 0;
  right: 0;
}
.shape.bottom > svg {
  width: 100%;
}
.shape.top {
  top: -2px;
  left: 0;
  right: 0;
}
.shape.top > svg {
  width: 100%;
}
.shape > svg {
  width: auto;
  height: 100%;
}

@media (max-width: 768px) {
  .shape.bottom {
    bottom: -5px;
  }
}
.divider {
  position: absolute;
  pointer-events: none;
  overflow: hidden;
}
.divider.top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  height: 120px;
  transform: scaleX(-1);
}
.divider.bottom {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  bottom: 0px;
  left: 0;
  right: 0;
  width: 100%;
  height: 120px;
  transform: scaleX(1) scaleY(-1);
}

.animate {
  transform: scale(1);
  transition: 0.3s ease-in-out;
}

.animate:hover {
  transform: scale(1.1);
}

.bg-gradient {
  background: linear-gradient(180deg, rgba(11, 127, 142, 0.05) 0%, rgba(11, 127, 142, 0.02) 100%);
}

.bg-gradient2 {
  background: #f7f8fb;
}

.bg-gradient3 {
  background: linear-gradient(#f4f5f7 0, #fafafb 100%);
}

.bg-gradient4 {
  background: linear-gradient(rgba(255, 120, 75, 0.075) 0%, rgba(255, 200, 55, 0.1) 100%) no-repeat left center;
}

.bg-gradient5 {
  background: linear-gradient(rgba(255, 120, 75, 0.05) 0%, rgba(255, 120, 75, 0.07) 100%) no-repeat left center;
}

.bg-gradient6 {
  background: linear-gradient(rgba(11, 127, 142, 0.12) 0%, rgba(11, 127, 142, 0.02) 100%) no-repeat top center;
}

.breadcrumb-no-bg {
  background-color: transparent;
}

.breadcrumb-item + .breadcrumb-item {
  align-items: center !important;
}
.breadcrumb-item + .breadcrumb-item::before {
  vertical-align: middle;
  width: 1rem;
  height: 1rem;
}

.buttons-excel {
  color: #fff !important;
  background-color: #3cd278 !important;
  border-color: #3cd278 !important;
  color: white !important;
  border-radius: 5px;
}

.btn .icon svg {
  width: 1rem;
  height: 1rem;
  margin-left: 0.1rem;
  margin-top: -2px;
}

.btn-rounded {
  border-radius: 2.125rem;
}

.btn-rounded-circle {
  border-radius: 50%;
}

.btn-icon {
  padding: 0;
  width: 2.625rem;
  height: 2.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
  height: 1.75rem;
  width: 1.75rem;
}
.btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
  height: 2.875rem;
  width: 2.875rem;
}

.btn-link {
  font-weight: 400;
  color: #495057;
  background-color: transparent;
}
.btn-link:hover {
  color: #0b7f8e;
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
  border-color: transparent;
  box-shadow: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #787878;
  pointer-events: none;
}

.btn-primary:hover, .btn-primary:focus {
  border-color: #0b7f8e;
  box-shadow: 0px 8px 20px -6px rgba(11, 127, 142, 0.6);
  background: #0b7f8e;
}

.btn-outline-primary {
  --bs-btn-color: #0b7f8e;
  --bs-btn-border-color: #0b7f8e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b7f8e;
  --bs-btn-hover-border-color: #0b7f8e;
  --bs-btn-focus-shadow-rgb: 11, 127, 142;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0b7f8e;
  --bs-btn-active-border-color: #0b7f8e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0b7f8e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0b7f8e;
  --bs-gradient: none;
}
.btn-outline-primary:hover, .btn-outline-primary:focus {
  box-shadow: 0px 8px 20px -6px rgba(11, 127, 142, 0.6);
}

.btn-soft-primary {
  background-color: rgba(11, 127, 142, 0.1);
  color: #0b7f8e;
  border-color: transparent;
}
.btn-soft-primary:hover, .btn-soft-primary:focus {
  background-color: rgba(11, 127, 142, 0.15);
  border-color: rgba(11, 127, 142, 0.1);
  color: #0b7f8e;
  box-shadow: 0 1px 1px rgba(11, 127, 142, 0.1), 0 2px 4px 1px rgba(11, 127, 142, 0.1);
}

.btn-secondary:hover, .btn-secondary:focus {
  border-color: #495057;
  box-shadow: 0px 8px 20px -6px rgba(73, 80, 87, 0.6);
  background: #495057;
}

.btn-outline-secondary {
  --bs-btn-color: #495057;
  --bs-btn-border-color: #495057;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #495057;
  --bs-btn-hover-border-color: #495057;
  --bs-btn-focus-shadow-rgb: 73, 80, 87;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #495057;
  --bs-btn-active-border-color: #495057;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #495057;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #495057;
  --bs-gradient: none;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus {
  box-shadow: 0px 8px 20px -6px rgba(73, 80, 87, 0.6);
}

.btn-soft-secondary {
  background-color: rgba(73, 80, 87, 0.1);
  color: #495057;
  border-color: transparent;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus {
  background-color: rgba(73, 80, 87, 0.15);
  border-color: rgba(73, 80, 87, 0.1);
  color: #495057;
  box-shadow: 0 1px 1px rgba(73, 80, 87, 0.1), 0 2px 4px 1px rgba(73, 80, 87, 0.1);
}

.btn-success:hover, .btn-success:focus {
  border-color: #3cd278;
  box-shadow: 0px 8px 20px -6px rgba(60, 210, 120, 0.6);
  background: #3cd278;
}

.btn-outline-success {
  --bs-btn-color: #3cd278;
  --bs-btn-border-color: #3cd278;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3cd278;
  --bs-btn-hover-border-color: #3cd278;
  --bs-btn-focus-shadow-rgb: 60, 210, 120;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3cd278;
  --bs-btn-active-border-color: #3cd278;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3cd278;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3cd278;
  --bs-gradient: none;
}
.btn-outline-success:hover, .btn-outline-success:focus {
  box-shadow: 0px 8px 20px -6px rgba(60, 210, 120, 0.6);
}

.btn-soft-success {
  background-color: rgba(60, 210, 120, 0.1);
  color: #3cd278;
  border-color: transparent;
}
.btn-soft-success:hover, .btn-soft-success:focus {
  background-color: rgba(60, 210, 120, 0.15);
  border-color: rgba(60, 210, 120, 0.1);
  color: #3cd278;
  box-shadow: 0 1px 1px rgba(60, 210, 120, 0.1), 0 2px 4px 1px rgba(60, 210, 120, 0.1);
}

.btn-info:hover, .btn-info:focus {
  border-color: #17a2b8;
  box-shadow: 0px 8px 20px -6px rgba(23, 162, 184, 0.6);
  background: #17a2b8;
}

.btn-outline-info {
  --bs-btn-color: #17a2b8;
  --bs-btn-border-color: #17a2b8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #17a2b8;
  --bs-btn-hover-border-color: #17a2b8;
  --bs-btn-focus-shadow-rgb: 23, 162, 184;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #17a2b8;
  --bs-btn-active-border-color: #17a2b8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #17a2b8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #17a2b8;
  --bs-gradient: none;
}
.btn-outline-info:hover, .btn-outline-info:focus {
  box-shadow: 0px 8px 20px -6px rgba(23, 162, 184, 0.6);
}

.btn-soft-info {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
  border-color: transparent;
}
.btn-soft-info:hover, .btn-soft-info:focus {
  background-color: rgba(23, 162, 184, 0.15);
  border-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
  box-shadow: 0 1px 1px rgba(23, 162, 184, 0.1), 0 2px 4px 1px rgba(23, 162, 184, 0.1);
}

.btn-warning:hover, .btn-warning:focus {
  border-color: #ffc837;
  box-shadow: 0px 8px 20px -6px rgba(255, 200, 55, 0.6);
  background: #ffc837;
}

.btn-outline-warning {
  --bs-btn-color: #ffc837;
  --bs-btn-border-color: #ffc837;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #ffc837;
  --bs-btn-hover-border-color: #ffc837;
  --bs-btn-focus-shadow-rgb: 255, 200, 55;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #ffc837;
  --bs-btn-active-border-color: #ffc837;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc837;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc837;
  --bs-gradient: none;
}
.btn-outline-warning:hover, .btn-outline-warning:focus {
  box-shadow: 0px 8px 20px -6px rgba(255, 200, 55, 0.6);
}

.btn-soft-warning {
  background-color: rgba(255, 200, 55, 0.1);
  color: #ffc837;
  border-color: transparent;
}
.btn-soft-warning:hover, .btn-soft-warning:focus {
  background-color: rgba(255, 200, 55, 0.15);
  border-color: rgba(255, 200, 55, 0.1);
  color: #ffc837;
  box-shadow: 0 1px 1px rgba(255, 200, 55, 0.1), 0 2px 4px 1px rgba(255, 200, 55, 0.1);
}

.btn-danger:hover, .btn-danger:focus {
  border-color: #f0323c;
  box-shadow: 0px 8px 20px -6px rgba(240, 50, 60, 0.6);
  background: #f0323c;
}

.btn-outline-danger {
  --bs-btn-color: #f0323c;
  --bs-btn-border-color: #f0323c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f0323c;
  --bs-btn-hover-border-color: #f0323c;
  --bs-btn-focus-shadow-rgb: 240, 50, 60;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f0323c;
  --bs-btn-active-border-color: #f0323c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f0323c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f0323c;
  --bs-gradient: none;
}
.btn-outline-danger:hover, .btn-outline-danger:focus {
  box-shadow: 0px 8px 20px -6px rgba(240, 50, 60, 0.6);
}

.btn-soft-danger {
  background-color: rgba(240, 50, 60, 0.1);
  color: #f0323c;
  border-color: transparent;
}
.btn-soft-danger:hover, .btn-soft-danger:focus {
  background-color: rgba(240, 50, 60, 0.15);
  border-color: rgba(240, 50, 60, 0.1);
  color: #f0323c;
  box-shadow: 0 1px 1px rgba(240, 50, 60, 0.1), 0 2px 4px 1px rgba(240, 50, 60, 0.1);
}

.btn-light:hover, .btn-light:focus {
  border-color: #f4f5f7;
  box-shadow: 0px 8px 20px -6px rgba(244, 245, 247, 0.6);
  background: #f4f5f7;
}

.btn-outline-light {
  --bs-btn-color: #f4f5f7;
  --bs-btn-border-color: #f4f5f7;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #f4f5f7;
  --bs-btn-hover-border-color: #f4f5f7;
  --bs-btn-focus-shadow-rgb: 244, 245, 247;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #f4f5f7;
  --bs-btn-active-border-color: #f4f5f7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f4f5f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f4f5f7;
  --bs-gradient: none;
}
.btn-outline-light:hover, .btn-outline-light:focus {
  box-shadow: 0px 8px 20px -6px rgba(244, 245, 247, 0.6);
}

.btn-soft-light {
  background-color: rgba(244, 245, 247, 0.1);
  color: #f4f5f7;
  border-color: transparent;
}
.btn-soft-light:hover, .btn-soft-light:focus {
  background-color: rgba(244, 245, 247, 0.15);
  border-color: rgba(244, 245, 247, 0.1);
  color: #f4f5f7;
  box-shadow: 0 1px 1px rgba(244, 245, 247, 0.1), 0 2px 4px 1px rgba(244, 245, 247, 0.1);
}

.btn-dark:hover, .btn-dark:focus {
  border-color: #343a40;
  box-shadow: 0px 8px 20px -6px rgba(52, 58, 64, 0.6);
  background: #343a40;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}
.btn-outline-dark:hover, .btn-outline-dark:focus {
  box-shadow: 0px 8px 20px -6px rgba(52, 58, 64, 0.6);
}

.btn-soft-dark {
  background-color: rgba(52, 58, 64, 0.1);
  color: #343a40;
  border-color: transparent;
}
.btn-soft-dark:hover, .btn-soft-dark:focus {
  background-color: rgba(52, 58, 64, 0.15);
  border-color: rgba(52, 58, 64, 0.1);
  color: #343a40;
  box-shadow: 0 1px 1px rgba(52, 58, 64, 0.1), 0 2px 4px 1px rgba(52, 58, 64, 0.1);
}

.btn-orange:hover, .btn-orange:focus {
  border-color: #ff784b;
  box-shadow: 0px 8px 20px -6px rgba(255, 120, 75, 0.6);
  background: #ff784b;
}

.btn-outline-orange {
  --bs-btn-color: #ff784b;
  --bs-btn-border-color: #ff784b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff784b;
  --bs-btn-hover-border-color: #ff784b;
  --bs-btn-focus-shadow-rgb: 255, 120, 75;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff784b;
  --bs-btn-active-border-color: #ff784b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff784b;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff784b;
  --bs-gradient: none;
}
.btn-outline-orange:hover, .btn-outline-orange:focus {
  box-shadow: 0px 8px 20px -6px rgba(255, 120, 75, 0.6);
}

.btn-soft-orange {
  background-color: rgba(255, 120, 75, 0.1);
  color: #ff784b;
  border-color: transparent;
}
.btn-soft-orange:hover, .btn-soft-orange:focus {
  background-color: rgba(255, 120, 75, 0.15);
  border-color: rgba(255, 120, 75, 0.1);
  color: #ff784b;
  box-shadow: 0 1px 1px rgba(255, 120, 75, 0.1), 0 2px 4px 1px rgba(255, 120, 75, 0.1);
}

.btn-teal:hover, .btn-teal:focus {
  border-color: #20c997;
  box-shadow: 0px 8px 20px -6px rgba(32, 201, 151, 0.6);
  background: #20c997;
}

.btn-outline-teal {
  --bs-btn-color: #20c997;
  --bs-btn-border-color: #20c997;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #20c997;
  --bs-btn-hover-border-color: #20c997;
  --bs-btn-focus-shadow-rgb: 32, 201, 151;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #20c997;
  --bs-btn-active-border-color: #20c997;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #20c997;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #20c997;
  --bs-gradient: none;
}
.btn-outline-teal:hover, .btn-outline-teal:focus {
  box-shadow: 0px 8px 20px -6px rgba(32, 201, 151, 0.6);
}

.btn-soft-teal {
  background-color: rgba(32, 201, 151, 0.1);
  color: #20c997;
  border-color: transparent;
}
.btn-soft-teal:hover, .btn-soft-teal:focus {
  background-color: rgba(32, 201, 151, 0.15);
  border-color: rgba(32, 201, 151, 0.1);
  color: #20c997;
  box-shadow: 0 1px 1px rgba(32, 201, 151, 0.1), 0 2px 4px 1px rgba(32, 201, 151, 0.1);
}

.btn-gray-50:hover, .btn-gray-50:focus {
  border-color: #fefefe;
  box-shadow: 0px 8px 20px -6px rgba(254, 254, 254, 0.6);
  background: #fefefe;
}

.btn-outline-gray-50 {
  --bs-btn-color: #fefefe;
  --bs-btn-border-color: #fefefe;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #fefefe;
  --bs-btn-hover-border-color: #fefefe;
  --bs-btn-focus-shadow-rgb: 254, 254, 254;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #fefefe;
  --bs-btn-active-border-color: #fefefe;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fefefe;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fefefe;
  --bs-gradient: none;
}
.btn-outline-gray-50:hover, .btn-outline-gray-50:focus {
  box-shadow: 0px 8px 20px -6px rgba(254, 254, 254, 0.6);
}

.btn-soft-gray-50 {
  background-color: rgba(254, 254, 254, 0.1);
  color: #fefefe;
  border-color: transparent;
}
.btn-soft-gray-50:hover, .btn-soft-gray-50:focus {
  background-color: rgba(254, 254, 254, 0.15);
  border-color: rgba(254, 254, 254, 0.1);
  color: #fefefe;
  box-shadow: 0 1px 1px rgba(254, 254, 254, 0.1), 0 2px 4px 1px rgba(254, 254, 254, 0.1);
}

.btn-white {
  border-color: #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 0.375rem;
}
.btn-white:hover, .btn-white:focus {
  color: #343a40 !important;
  background-color: #fff !important;
  box-shadow: 0 1px 3px rgba(60, 72, 88, 0.15), 0 2px 4px 2px rgba(60, 72, 88, 0.18);
}

.btn-back-to-top {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  display: none;
  z-index: 10;
}
.btn-back-to-top.show {
  display: flex;
}

.btn-play {
  width: 3.5rem;
  height: 3.5rem;
  background: radial-gradient(#3cd278 98%, white 100%);
  border-radius: 50%;
  position: relative;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  /* triangle */
  /* pulse wave */
}
.btn-play.primary {
  background: radial-gradient(#0b7f8e 98%, white 100%);
}
.btn-play.secondary {
  background: radial-gradient(#495057 98%, white 100%);
}
.btn-play.success {
  background: radial-gradient(#3cd278 98%, white 100%);
}
.btn-play.info {
  background: radial-gradient(#17a2b8 98%, white 100%);
}
.btn-play.warning {
  background: radial-gradient(#ffc837 98%, white 100%);
}
.btn-play.danger {
  background: radial-gradient(#f0323c 98%, white 100%);
}
.btn-play.light {
  background: radial-gradient(#f4f5f7 98%, white 100%);
}
.btn-play.dark {
  background: radial-gradient(#343a40 98%, white 100%);
}
.btn-play.orange {
  background: radial-gradient(#ff784b 98%, white 100%);
}
.btn-play.teal {
  background: radial-gradient(#20c997 98%, white 100%);
}
.btn-play.gray-50 {
  background: radial-gradient(#fefefe 98%, white 100%);
}
.btn-play::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  transform-origin: center center;
  width: 0;
  height: 0;
  border-top: 0.5rem solid transparent;
  border-bottom: 0.5rem solid transparent;
  border-left: 0.75rem solid #fff;
  z-index: 100;
  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.btn-play::before {
  content: "";
  position: absolute;
  width: 130%;
  height: 130%;
  opacity: 1;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.75);
  top: -15%;
  left: -15%;
  background: rgba(198, 16, 0, 0);
  animation-delay: 0s;
  animation: pulsate1 2s;
  animation-direction: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: steps;
}
@keyframes pulsate1 {
  0% {
    transform: scale(0.6);
    opacity: 1;
    box-shadow: inset 0px 0px 25px 3px rgba(255, 255, 255, 0.75), 0px 0px 25px 10px rgba(255, 255, 255, 0.75);
  }
  100% {
    transform: scale(1);
    opacity: 0;
    box-shadow: none;
  }
}

.btn-outline-secondary {
  background: #fff;
  color: #202224;
  border: 1px solid #d0d5da;
}
.btn-outline-secondary.focus {
  background: transparent;
}

.btn-hover-img:hover img {
  filter: brightness(0) invert(1);
}

.btn-disabled {
  background: #eceef0 !important;
  border: 1px solid #d0d5da !important;
  color: #d0d5da !important;
  cursor: unset !important;
}
.btn-disabled img {
  filter: grayscale(100%) brightness(10) sepia(1) saturate(1000%) hue-rotate(180deg) brightness(0.9);
}

.btn-download {
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid var(--grey3);
  transition: all 0.1s ease-in-out !important;
}
.btn-download img {
  filter: brightness(0) saturate(100%) invert(15%) sepia(8%) saturate(377%) hue-rotate(180deg) brightness(91%) contrast(90%);
}
.btn-download:hover {
  color: var(--teal6) !important;
}
.btn-download:hover img {
  filter: brightness(0) saturate(100%) invert(20%) sepia(94%) saturate(715%) hue-rotate(145deg) brightness(96%) contrast(95%);
}

.card {
  margin-bottom: 1.5rem;
  position: relative;
  box-shadow: 0 0 0.25rem rgba(73, 80, 87, 0.05);
}
.card.hoverable {
  transition: all 0.3s ease-in-out;
}
.card.hoverable:hover {
  box-shadow: 0rem 0rem 1.5rem 0px rgba(0, 0, 0, 0.12);
  transform: translateY(-3px) !important;
}
.card .card-img-overlay .overlay-light-top {
  padding: 1rem 1rem 1.5rem 1rem;
  background: linear-gradient(180deg, #fff 0%, rgba(255, 255, 255, 0.95) 50%, rgba(255, 255, 255, 0.9) 75%, transparent 100%);
}
.card .card-img-overlay .overlay-light-bottom {
  position: absolute;
  bottom: 0;
  padding: 1.5rem 1rem 1rem 1rem;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 85%, transparent 100%);
}

.card-footer {
  border-color: #f6f7f9;
}

.card-drop {
  display: inline-block;
  font-size: 20px;
  line-height: 30px;
  color: inherit;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  text-align: center;
  margin-top: -6px;
}
.card-drop:hover {
  background-color: #f3f4f7;
  color: #343a40;
}

.card-title,
.card-header {
  margin-top: 0;
}

.card-nav {
  margin: -0.5rem 0;
}

.card-box {
  background-color: #fff;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border-radius: 0.1875rem;
}

.card-img-top-overlay {
  position: relative;
}
.card-img-top-overlay .overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(120, 120, 120, 0.4);
}
.card-img-top-overlay .overlay-light {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(243, 244, 247, 0.5);
}
.card-img-top-overlay .overlay-dark {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(33, 37, 41, 0.5);
}
.card-img-top-overlay .card-overlay-top {
  position: absolute;
  top: 0.75rem;
  right: 1.25rem;
  left: 1.25rem;
}
.card-img-top-overlay .card-overlay-bottom {
  position: absolute;
  right: 1.25rem;
  bottom: 0.75rem;
  left: 1.25rem;
}
.card-img-top-overlay .card-badge {
  position: absolute;
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 600;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-radius: 0.25rem;
  z-index: 1000;
}
.card-img-top-overlay .card-badge.top-left {
  top: 1rem;
  left: 1rem;
}
.card-img-top-overlay .card-badge.bottom-left {
  bottom: 1rem;
  left: 1rem;
}
.card-img-top-overlay .card-badge.top-right {
  top: 1rem;
  right: 1rem;
}
.card-img-top-overlay .card-badge.bottom-right {
  bottom: 1rem;
  right: 1rem;
}

.card-portfolio-item .card-zoom {
  overflow: hidden !important;
  border-radius: inherit;
}
.card-portfolio-item .card-zoom img {
  transition: all 0.3s ease-in-out;
  transform-origin: center center;
  border-radius: inherit;
}
.card-portfolio-item:hover .card-zoom img {
  transform: scale(1.1);
}

.card-listing-item {
  overflow: hidden !important;
  border: 1px solid #dee2e6 !important;
}
.card-listing-item.overlay .overlay-details {
  position: absolute;
  opacity: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.25);
  transform: translateY(10%);
  transition: all 0.3s ease-in-out;
}
.card-listing-item.overlay:hover .overlay-details {
  opacity: 1;
  transform: translateY(0px);
}

.sticky-el {
  position: sticky;
  top: 50px;
}

.dropdown .dropdown-menu {
  font-size: 0.9375rem;
  z-index: 1030;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  padding: 0.5rem 0.3rem;
  top: 100%;
}
.dropdown .dropdown-menu.dropdown-menu-sm {
  width: 5rem;
}
.dropdown .dropdown-menu.dropdown-menu-lg {
  width: 20rem;
}
.dropdown .dropdown-menu.dropdown-menu-xl {
  width: 30rem;
}
.dropdown .dropdown-menu .dropdown-item {
  border-radius: 0.25rem;
}
.dropdown.btn-group .btn:hover, .dropdown.btn-group .btn:active, .dropdown.btn-group .btn:focus {
  transform: translate3d(0, 0px, 0) !important;
}

.form-control-light {
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}

input.form-control[type=color],
input.form-control[type=range] {
  min-height: 39px;
}

.custom-select.is-invalid:focus,
.form-control.is-invalid:focus,
.custom-select:invalid:focus,
.form-control:invalid:focus,
.custom-select.is-valid:focus,
.form-control.is-valid:focus,
.custom-select:valid:focus,
.form-control:valid:focus {
  box-shadow: none !important;
}

.comment-area-box .form-control {
  border-color: #dee2e6;
  border-radius: 0.25rem 0.25rem 0 0;
}
.comment-area-box .comment-area-btn {
  background-color: #f4f5f7;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
}

input:focus {
  outline: none;
}

.form-control-with-hint {
  position: relative;
}
.form-control-with-hint .form-control {
  padding-right: 50px !important;
}
.form-control-with-hint .form-control-feedback {
  position: absolute;
  top: 2px;
  bottom: 2px;
  right: 0.75rem;
  display: flex;
  align-items: center;
  background: transparent;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c7681;
}

.form-check .form-check-input:checked ~ .form-label::after {
  background-image: none;
  font-family: "unicons";
  content: "\\e8d9";
  font-size: 1.25rem;
  top: -0.185rem;
  left: -1.7rem;
  color: #ffffff;
}

.color55 {
  color: #555555;
}

.rbt-aux {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
}

.t-sticky {
  position: sticky;
  top: 0;
}

.rbt-menu {
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.15) !important;
  z-index: 800 !important;
}

.label-length-data {
  padding-top: 5px;
  padding-bottom: 5px;
  width: max-content;
  border-radius: 5px;
  background: #e8edff;
  color: #0b7f8e;
}

.color-y {
  color: #f78216;
}

.react-datepicker-popper {
  z-index: 9 !important;
}

.text-color-blue {
  color: #0b7f8e;
  cursor: pointer;
}
.text-color-blue:hover {
  opacity: 0.8;
}

.rbt-token {
  color: #0b7f8e !important;
}

.color555 {
  color: #555555;
}

.text-align-right {
  text-align: right !important;
}

.fs-10 {
  font-size: 10px !important;
}

.border-blue {
  border-color: #0b7f8e;
}

.label-perusahaan {
  width: -moz-fit-content;
  width: fit-content;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background: #c1c1c1;
  color: white;
  font-weight: bold;
  padding: 0px 5px;
  margin-right: 10px;
}

.link {
  cursor: pointer;
  color: blue;
}
.link:hover {
  opacity: 0.8;
}

.blink {
  animation: blinkMe 2s linear infinite;
}

.text-load-sensor {
  position: relative;
  top: 95px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.x-icon {
  position: absolute;
  right: 5px;
  top: 20px;
}

@keyframes blinkMe {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.highlightOption {
  background: none !important;
  color: none !important;
}

.input-search-iot {
  max-width: 300px;
  float: right;
  position: relative;
  top: 25px;
}

.t-main-color {
  color: #0b7f8e;
}

.box-tab {
  border: 1px solid #0b7f8e;
  height: 40px;
  border-radius: 100px;
}

.box-tab-active {
  border: 1px solid #0b7f8e;
  height: 40px;
  border-radius: 100px;
  background: #0b7f8e;
  color: white;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-tab-non-active {
  color: #0b7f8e;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.box-tab2 {
  border: 1px solid #0b7f8e;
  height: 30px;
  border-radius: 100px;
  max-width: 210px;
}

.box-tab-active2 {
  border: 1px solid #0b7f8e;
  height: 30px;
  border-radius: 100px;
  background: #0b7f8e;
  color: white;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-tab-non-active2 {
  color: #0b7f8e;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.box-tab3 {
  border: 1px solid #0b7f8e;
  height: 40px;
  border-radius: 100px;
  max-width: 400px;
}

.box-tab3-active {
  border: 1px solid #0b7f8e;
  height: 40px;
  border-radius: 100px;
  background: #0b7f8e;
  color: white;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-tab3-non-active {
  color: #0b7f8e;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.txt-circle1 {
  position: absolute;
  bottom: 16px;
  right: 74px;
}

.txt-circle2 {
  position: absolute;
  bottom: 33px;
  right: 115px;
}

.txt-circle3 {
  position: absolute;
  bottom: 73px;
  right: 127px;
}

.txt-circle4 {
  position: absolute;
  top: 33px;
  right: 111px;
}

.txt-circle5 {
  position: absolute;
  top: 16px;
  right: 73px;
}

.txt-circle6 {
  position: absolute;
  top: 33px;
  right: 32px;
}

.txt-circle7 {
  position: absolute;
  top: 73px;
  right: 16px;
}

.txt-celcius {
  position: absolute;
  top: 50px;
}

.fs-8 {
  font-size: 8px !important;
}

.color33333 {
  color: #333333;
}

.color77777 {
  color: #777777;
}

.bgcolorf4f4f4 {
  background-color: #f4f4f4;
}

.card {
  border-radius: 10px;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.pos_blink {
  position: absolute;
  right: 85px;
  bottom: 29px;
}

.recharts-text {
  font-size: 12px;
}

.text-format {
  position: relative;
  bottom: 75px;
  /* right: -8px; */
}

.custom-form .rbt-input-multi {
  border: 1px solid #e3e5e8;
  border-radius: 8px;
}

.modal .modal-content .modal-body {
  padding: 0 1rem 1rem 1rem;
}

.modal-title {
  margin-top: 0;
}

.modal-full {
  width: 92%;
  max-width: none;
}

.modal-demo {
  background-color: #fff;
  width: 600px !important;
  border-radius: 4px;
  display: none;
  position: relative;
}
.modal-demo .close {
  position: absolute;
  top: 15px;
  right: 25px;
  color: #f4f5f7;
}

@media (max-width: 768px) {
  .modal-demo {
    width: 96% !important;
  }
}
.custom-modal-title {
  padding: 15px 25px 15px 25px;
  line-height: 22px;
  font-size: 18px;
  background-color: #343a40;
  color: #fff;
  text-align: left;
  margin: 0;
}

.custom-modal-text {
  padding: 20px;
}

.custombox-modal-wrapper {
  text-align: left;
}

.custombox-modal-flash .close,
.custombox-modal-rotatedown .close {
  top: 20px;
  z-index: 9999;
}

.modal-pakan .modal-content {
  border: none;
  border-radius: 8px;
}
.modal-pakan .modal-footer {
  border: none;
  display: block;
  padding: 24px 16px;
  box-shadow: 0px -2px 25px 0px rgba(0, 0, 0, 0.2);
}
.modal-pakan .modal-footer .btn-disabled {
  border: none !important;
  background: #aed4d9 !important;
  color: #fff !important;
}

.modal-rincian-produk.kirim-pakan .modal-content .modal-header .modal-title {
  display: flex;
  align-items: center;
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-header .modal-title .form-select {
  padding: 0;
  border: none;
  color: #202224;
  font-size: 20px;
  font-weight: 600;
  appearance: auto;
  background-image: none;
  cursor: pointer;
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-header .modal-title .form-select:focus {
  box-shadow: none;
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-header .modal-title .form-select option {
  font-size: 12px;
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-header .modal-title .form-select.ews {
  width: 100%;
  max-width: 12%;
  font-size: 12px;
  font-weight: 400;
  border: 1px solid #e3e5e8;
  padding: 8px 12px;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  appearance: none;
  background-position: right 10px center;
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-body .form-control {
  height: 32px;
  font-weight: 400;
  border-radius: 6px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  padding: 8px 12px 8px 35px;
  border: 1px solid var(--grey3);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
  background-position: 12px center;
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-body .form-control::placeholder {
  color: var(--grey5);
}
.modal-rincian-produk.kirim-pakan .modal-content .modal-body .form-control:focus {
  border: 1px solid var(--primary);
}
.modal-rincian-produk .modal-content {
  border: none;
  border-radius: 8px;
}
.modal-rincian-produk .modal-content .modal-header {
  padding: 24px 24px 0 24px;
}
.modal-rincian-produk .modal-content .modal-body {
  padding: 0 24px 24px 24px;
}

.modal-peran .modal-content {
  border: none;
  border-radius: 8px;
  overflow: hidden;
}

.custom-modal.telat-panen {
  opacity: 0.9;
}
.custom-modal.telat-panen .modal-dialog .modal-content {
  box-shadow: 0px 24px 48px -12px rgba(10, 13, 18, 0.18);
}
.custom-modal.pengajuan-detail .modal-dialog {
  max-width: 50%;
}
.custom-modal.pengajuan-detail .modal-dialog .modal-content {
  border: 1px solid var(--grey3);
}
.custom-modal.pengajuan-detail .modal-dialog .modal-content .modal-body .list-pengajuan {
  margin-bottom: 12px;
}
.custom-modal.pengajuan-detail .modal-dialog .modal-content .modal-body .list-pengajuan:last-child {
  margin-bottom: 0;
}
.custom-modal.modal-detail-flok .modal-dialog.modal-xl {
  max-width: 85%;
}
.custom-modal.announcement .modal-dialog {
  max-width: 35%;
}
.custom-modal.announcement .modal-dialog .modal-content .modal-header .btn-close {
  margin: 0;
  opacity: 1;
  border-radius: 50%;
  background-color: var(--grey2);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1em auto;
}
.custom-modal .modal-dialog.modal-xl {
  max-width: 90%;
}
.custom-modal .modal-content {
  border: none;
  border-radius: 8px;
  background: var(--white);
}
.custom-modal .modal-content .modal-header {
  padding: 24px 24px 0 24px;
}
.custom-modal .modal-content .modal-header .select .react-select__control {
  cursor: pointer;
  min-height: 32px;
  border-radius: 6px;
}
.custom-modal .modal-content .modal-header .select .react-select__control.react-select__control--menu-is-open {
  border: 1px solid var(--primary);
}
.custom-modal .modal-content .modal-header .select .react-select__control .react-select__value-container {
  padding: 0 0 0 12px;
}
.custom-modal .modal-content .modal-header .select .react-select__control .react-select__value-container .react-select__single-value {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--grey9);
  letter-spacing: -0.02em;
}
.custom-modal .modal-content .modal-header .select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0 12px 0 0;
}
.custom-modal .modal-content .modal-header .select .react-select__menu {
  width: 200px;
}
.custom-modal .modal-content .modal-header .select.none {
  width: -moz-fit-content;
  width: fit-content;
}
.custom-modal .modal-content .modal-header .select.none .react-select__control {
  border: none;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.custom-modal .modal-content .modal-header .select.none .react-select__control .react-select__value-container {
  padding: 0;
}
.custom-modal .modal-content .modal-header .select.none .react-select__control .react-select__value-container .react-select__single-value {
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
}
.custom-modal .modal-content .modal-header .select.none .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
}
.custom-modal .modal-content .modal-header .select.w-12 {
  width: 120px;
}
.custom-modal .modal-content .modal-header .btn-close {
  opacity: 1;
}
.custom-modal .modal-content .modal-body {
  padding: 28px 24px 24px 24px;
}
.custom-modal .modal-content .modal-body .tabs .rts___tabs___container {
  border-radius: 6px;
  background: var(--gray1);
  border: 1px solid var(--grey2);
}
.custom-modal .modal-content .modal-body .tabs .rts___tabs___container .rts___tabs {
  width: 100%;
  justify-content: space-between;
}
.custom-modal .modal-content .modal-body .tabs .rts___tabs___container .rts___tabs .rts___btn {
  width: 100%;
  border: none;
  color: var(--grey9);
  transition: all 0.3s ease-in-out;
}
.custom-modal .modal-content .modal-body .tabs .rts___tabs___container .rts___tabs .rts___btn.rts___tab___selected {
  border: none !important;
  color: var(--grey9) !important;
  background: var(--white) !important;
  box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.05) !important;
}
.custom-modal .modal-content .modal-body .rts___tabs___container {
  padding: 0;
  border-bottom: 1px solid var(--grey2);
}
.custom-modal .modal-content .modal-body .rts___tabs___container .rts___tabs .date-ranges {
  box-shadow: none;
  border-radius: 0;
  padding: 8px 12px;
  background: none !important;
  color: var(--grey6) !important;
  transition: all 0.3s ease-in-out;
  border-bottom: 1px solid transparent !important;
}
.custom-modal .modal-content .modal-body .rts___tabs___container .rts___tabs .date-ranges:hover {
  color: var(--primary) !important;
  border-bottom: 1px solid var(--primary) !important;
}
.custom-modal .modal-content .modal-body .rts___tabs___container .rts___tabs .date-ranges.rts___tab___selected {
  border-radius: 0;
  color: var(--primary) !important;
  border-bottom: 1px solid var(--primary) !important;
}
.custom-modal .modal-content .modal-body .rts___tabs___container:nth-child(2) {
  border: none !important;
}
.custom-modal .modal-content .modal-body .rts___tabs___container:nth-child(2) .rts___tabs .rts___btn {
  transition: all 0.3s ease-in-out;
}
.custom-modal .modal-content .modal-body .rts___tabs___container:nth-child(2) .rts___tabs .rts___btn:hover {
  color: var(--white) !important;
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
}
.custom-modal .modal-content .modal-body .rts___tabs___container:nth-child(2) .rts___tabs .rts___tab___selected {
  color: var(--white) !important;
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
}
.custom-modal .modal-content .modal-body .accordion-wrapper {
  height: 600px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.custom-modal .modal-content .modal-body .accordion-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-modal .modal-content .modal-body .accordion-wrapper .accordion {
  border: 1px solid #d0d5da;
  border-radius: 8px;
  background: #f4f5f6;
  padding: 8px 12px;
}
.custom-modal .modal-content .modal-body .date-wrapper {
  width: 110px;
  position: relative;
  justify-self: flex-end;
}
.custom-modal .modal-content .modal-body .date-wrapper .date {
  height: 32px;
  cursor: pointer;
  font-weight: 400;
  background: none;
  padding: 8px 32px;
  text-align: center;
  color: var(--grey9);
  letter-spacing: -0.02em;
  border: 1px solid var(--grey2);
  background-position: right 12px center;
}
.custom-modal .modal-content .modal-body .date-wrapper .date::placeholder {
  color: var(--grey5);
}
.custom-modal .modal-content .modal-body .date-wrapper .date:focus {
  border: 1px solid var(--primary);
}
.custom-modal .modal-content .modal-body .date-wrapper .calendar-icon {
  position: absolute;
  top: 16px;
  left: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}
.custom-modal .modal-content .modal-body .date-wrapper .chevron-icon {
  position: absolute;
  top: 16px;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker {
  border-radius: 8px;
  background: var(--white);
  border: 1px solid var(--grey2);
  box-shadow: 0px 4px 6px -2px rgba(26, 26, 26, 0.2);
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__triangle::after, .custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__triangle::before {
  border-bottom-color: var(--grey2) !important;
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__year--container .react-datepicker__header {
  font-weight: 500;
  color: var(--grey9);
  letter-spacing: -0.02em;
  background: var(--grey1);
  border-bottom: 1px solid var(--grey2);
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__year .react-datepicker__year-wrapper {
  justify-content: center;
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__year .react-datepicker__year-wrapper .react-datepicker__year-text {
  font-weight: 500;
  color: var(--grey9);
  letter-spacing: -0.02em;
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__year .react-datepicker__year-wrapper .react-datepicker__year-text.react-datepicker__year-text--disabled {
  color: #cccccc !important;
}
.custom-modal .modal-content .modal-body .date-wrapper .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__year .react-datepicker__year-wrapper .react-datepicker__year-text.react-datepicker__year-text--selected {
  color: var(--white) !important;
}

.modal-pilih-flok .modal-content {
  border: none;
  border-radius: 8px;
}
.modal-pilih-flok .modal-content .modal-header {
  border-bottom: none;
}
.modal-pilih-flok .modal-content .btn-close {
  opacity: 1;
}
.modal-pilih-flok .modal-content .modal-body .nav {
  border-bottom: 2px solid var(--grey3) !important;
}
.modal-pilih-flok .modal-content .modal-body .nav .nav-item a {
  transition: all 0.1s ease-in-out;
}
.modal-pilih-flok .modal-content .modal-body .nav .nav-item a:hover {
  color: var(--primary) !important;
  border-bottom: 2px solid var(--primary) !important;
}
.modal-pilih-flok .modal-content .modal-body .nav .nav-item a.active {
  border-bottom: 2px solid var(--primary) !important;
}
.modal-pilih-flok .modal-content .modal-body .pagination {
  margin: 0;
  padding: 28px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal-pilih-flok .modal-content .modal-body .pagination button:disabled {
  color: var(--grey3) !important;
  background: var(--grey1);
}
.modal-pilih-flok .modal-content .modal-body .pagination button:disabled svg {
  color: var(--grey3) !important;
}
.modal-pilih-flok .modal-content .modal-body .pagination .page-item {
  width: 40px;
  height: 32px;
}
.modal-pilih-flok .modal-content .modal-body .pagination .page-item.active .page-link {
  color: var(--primary);
  background-color: var(--teal1);
}
.modal-pilih-flok .modal-content .modal-body .pagination .page-item .page-link {
  width: 100%;
  height: 100%;
  border: none;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 5px;
  line-height: 18px;
  border-radius: 4px;
  align-items: center;
  color: var(--grey6);
  letter-spacing: -0.02em;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}
.modal-pilih-flok .modal-content .modal-body .pagination .page-item .page-link:hover {
  color: var(--primary);
  background-color: var(--teal1);
}

.modal-pilih-doc .modal-content {
  border: none;
  border-radius: 8px;
}
.modal-pilih-doc .modal-content .btn-close {
  opacity: 1;
}

.modal-pilih-pakan .modal-content {
  border: none;
  border-radius: 8px;
}
.modal-pilih-pakan .modal-content .btn-close {
  opacity: 1;
}
.modal-pilih-pakan .modal-content .modal-footer {
  box-shadow: 0px -2px 25px 0px rgba(0, 0, 0, 0.0705882353);
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 100%;
  }
  .custom-modal .modal-content .modal-header .modal-title {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .custom-modal .modal-content .modal-header .modal-title .div {
    display: none;
  }
  .custom-modal .modal-content .modal-body .custom-search {
    width: 100%;
  }
}
/* Medium mobile */
@media (min-width: 375px) and (max-width: 424px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 100%;
  }
  .custom-modal .modal-content .modal-header .select .react-select__menu {
    width: 160px;
  }
  .custom-modal .modal-content .modal-body .custom-search {
    width: 100%;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 100%;
  }
  .custom-modal .modal-content .modal-body .custom-search {
    width: 100%;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 85%;
  }
}
/* Medium tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 70%;
  }
}
/* Large tablet */
@media (min-width: 1024px) and (max-width: 1279px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 50%;
  }
}
/* Small laptop */
@media (min-width: 1280px) and (max-width: 1439px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 40%;
  }
}
/* Medium laptop */
/* Large laptop */
/* Small desktop */
@media (min-width: 1920px) and (max-width: 2559px) {
  .custom-modal.announcement .modal-dialog {
    max-width: 30%;
  }
}
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
.navbar {
  padding: 0;
}
.navbar .navbar-nav .nav-link {
  font-weight: 500;
  font-size: 0.9375rem;
}
.navbar .navbar-nav .nav-link [class^=icon-] {
  color: #495057;
}
.navbar .navbar-nav .nav-link [class^=icon-] > svg [fill]:not([fill=none]) {
  fill: #495057;
}
.navbar .navbar-nav .nav-link.active {
  color: #0b7f8e !important;
}
.navbar .navbar-nav .nav-link.active [class^=icon-] {
  color: #0b7f8e;
}
.navbar .navbar-nav .nav-link.active [class^=icon-] > svg [fill]:not([fill=none]) {
  fill: #0b7f8e;
}
.navbar .navbar-nav .nav-link:hover [class^=icon-] {
  color: #0b7f8e;
}
.navbar .navbar-nav .nav-link:hover [class^=icon-] > svg [fill]:not([fill=none]) {
  fill: #0b7f8e;
}
.navbar .navbar-nav.navbar-dropdown .nav-item .active {
  background: var(--teal1);
  color: var(--teal6);
  transition: all 0.2s ease-in-out;
}
.navbar .navbar-nav.navbar-dropdown .nav-item .active img {
  filter: invert(28%) sepia(35%) saturate(1400%) hue-rotate(151deg) brightness(90%) contrast(110%);
}
.navbar .navbar-nav.navbar-dropdown .nav-item .menu-dropdown {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform: translate3d(-50%, 30px, 0);
}
.navbar .navbar-nav.navbar-dropdown .nav-item .dropdown-toggle::after {
  display: none;
}
.navbar .navbar-nav.navbar-dropdown .nav-item.show .menu-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translate3d(-50%, 1px, 0);
}
.navbar .navbar-nav.navbar-dropdown .nav-item:hover {
  background: var(--teal1);
  color: var(--teal6);
}
.navbar .navbar-nav.navbar-dropdown .nav-item:hover img {
  filter: invert(28%) sepia(35%) saturate(1400%) hue-rotate(151deg) brightness(90%) contrast(110%);
}
.navbar .navbar-nav.navbar-dropdown .nav-item:hover .menu-dropdown {
  opacity: 0;
  visibility: hidden;
  transform: translate3d(-50%, 30px, 0);
}
.navbar .navbar-nav.navbar-dropdown .nav-item:hover.show .menu-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translate3d(-50%, 1px, 0);
}
.navbar.topnav-menu {
  height: 70px;
}
.navbar.topnav-menu .navbar-nav > .nav-item > .nav-link {
  padding: 0 1rem;
  display: block;
  max-height: 70px;
}
.navbar.navbar-sticky {
  transition: all 0.3s ease-in-out;
  box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06);
  background: #fff;
  z-index: 100000;
  position: fixed;
  width: 100%;
  top: 0;
}
.navbar .profile-dropdown .menu-dropdown {
  opacity: 0;
  left: -57px;
  visibility: hidden;
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform: translate3d(-50%, 30px, 0);
}
.navbar .profile-dropdown .dropdown-toggle::after {
  display: none;
}
.navbar .profile-dropdown.show .menu-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translate3d(-50%, 1px, 0);
}
.navbar .profile-dropdown:hover .menu-dropdown {
  opacity: 0 !important;
  visibility: hidden !important;
  transform: translate3d(-50%, 30px, 0) !important;
}
.navbar .profile-dropdown:hover.show .menu-dropdown {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translate3d(-50%, 1px, 0) !important;
}

.navbar-light .logo .logo-dark {
  display: inline-block;
}
.navbar-light .logo .logo-light {
  display: none;
}

.navbar-dark .logo .logo-dark {
  display: none;
}
.navbar-dark .logo .logo-light {
  display: inline-block;
}

.navbar .navbar-toggler:focus {
  box-shadow: none;
}

.navbar-nav .dropdown-menu {
  min-width: 0;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  box-shadow: none;
}
@media (min-width: 992px) {
  .navbar-nav .dropdown-menu {
    left: 50%;
    min-width: calc(10rem + 3rem);
    padding: 0.75rem 0;
    box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
    visibility: hidden;
    opacity: 0;
    transform: translate3d(-50%, 30px, 0);
    transition: all 0.3s ease-in-out;
    transition-property: opacity, visibility, transform;
    transform-origin: top center;
  }
  .navbar-nav .dropdown-menu.dropdown-menu-lg {
    min-width: 30rem;
  }
  .navbar-nav .dropdown-menu.dropdown-menu-xl {
    min-width: 48rem;
  }
  .navbar-nav .dropdown-menu .nav .nav-item.dropdown .dropdown-menu {
    position: absolute;
    top: 0;
    left: 150%;
    display: none;
  }
}
.navbar-nav .dropdown-menu .nav {
  display: block;
}
.navbar-nav .dropdown-menu .nav .nav-item .nav-link {
  padding: 0.25rem 0.75rem;
  font-weight: normal;
  margin: 0 0.5rem;
  position: relative;
}
.navbar-nav .dropdown-menu .nav .nav-item.dropdown:hover > .dropdown-menu.show {
  display: block;
}
.navbar-nav .dropdown-menu .nav .nav-item.dropdown .arrow::after {
  right: 22px;
  transform: rotate(-135deg) translateY(-50%);
  position: absolute;
}
.navbar-nav .dropdown-menu .arrow {
  display: inline-block;
}
.navbar-nav .dropdown-menu .arrow:after {
  border-color: initial;
  border-style: solid;
  border-width: 0 0 1px 1px;
  content: "";
  height: 0.4rem;
  display: inline-block;
  right: 5px;
  top: 50%;
  margin-left: 10px;
  transform: rotate(-45deg) translateY(-50%);
  transform-origin: top;
  transition: all 0.3s ease-out;
  width: 0.4rem;
}

@media (min-width: 992px) {
  .navbar-nav .dropdown .dropdown-menu {
    z-index: 1030;
    display: block;
  }
  .navbar-nav .dropdown:hover .dropdown-menu {
    opacity: 1;
    transform: translate3d(-50%, 1px, 0);
    visibility: visible;
  }
  .navbar-nav .dropdown:hover .dropdown-menu .dropdown:hover .dropdown-menu {
    opacity: 1;
    transform: translate3d(-50%, 1px, 0);
    visibility: visible;
    display: block;
  }
}
.navbar-dark .navbar-brand h4, .navbar-dark .navbar-brand .h4 {
  color: #fff;
}
.navbar-dark .dropdown-menu .nav-link {
  color: #495057 !important;
}

.nav-title {
  padding: 0.25rem 0.75rem;
  margin: 0 0.5rem;
}

@media (max-width: 991.98px) {
  .navbar.topnav-menu {
    background-color: #fff;
    padding: 8px 0;
    height: auto;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 1001;
  }
  .navbar.topnav-menu .dropdown .dropdown-menu.dropdown-menu-lg {
    width: 100%;
  }
  .navbar.topnav-menu.navbar-dark .logo .logo-dark {
    display: inline-block;
  }
  .navbar.topnav-menu.navbar-dark .logo .logo-light {
    display: none;
  }
  .navbar.topnav-menu.navbar-dark .navbar-toggler {
    color: #32373b;
    border-color: transparent;
  }
  .navbar.topnav-menu.navbar-dark .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  }
  .navbar.topnav-menu .navbar-nav > .nav-item > .nav-link {
    line-height: inherit;
    padding: 0.5rem 1em;
    color: #212529;
  }
  .navbar.topnav-menu .navbar-nav > .nav-item > .nav-link .feather {
    float: right;
  }
  .navbar.topnav-menu .navbar-nav > .nav-item .btn.btn-white.text-white {
    color: #343a40 !important;
  }
  .navbar.topnav-menu .navbar-nav > .dropdown .dropdown-menu .nav .dropdown .dropdown-menu .nav .nav-item > .nav-link {
    margin: 0 0.5rem 0 1.2rem;
  }
  .navbar.topnav-menu .navbar-nav .dropdown-menu .arrow:after {
    transform: rotate(-45deg) translateY(-50%) !important;
  }
  .navbar-collapse {
    max-height: 480px;
    overflow-y: auto;
  }
}
.nav-tabs {
  border-bottom: 2px solid rgba(120, 120, 120, 0.2);
}
.nav-tabs .nav-item {
  margin-bottom: -2px;
}
.nav-tabs li a {
  border-color: transparent !important;
  padding: 0.625rem 1.5rem;
}
.nav-tabs li a.active {
  border-bottom: 2px solid #0b7f8e !important;
}

.nav-tabs > li > a,
.nav-pills > li > a {
  color: #495057;
  font-weight: 500;
}

.nav-pills {
  background: #fff;
  border-radius: 0.25rem;
  padding: 6px;
}
.nav-pills .nav-link {
  background-color: transparent;
  color: #495057;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #495057;
  background-color: #fff;
  box-shadow: 0 0 0.25rem rgba(73, 80, 87, 0.05);
}

.navtab-bg {
  background-color: #f4f5f7 !important;
}

.tab-content {
  padding: 20px 0 0 0;
}

.nav .nav-link {
  color: #495057;
}
.nav .nav-link:hover, .nav .nav-link:focus, .nav .nav-link:active {
  color: #0b7f8e;
}
.nav .nav-link.active {
  color: #0b7f8e;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-rounded .page-link {
  border-radius: 100% !important;
  margin: 0 3px;
}

.popover {
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
}
.popover .popover-header {
  margin-top: 0;
  font-size: 0.8203125rem;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 15px;
}

.progress-xxl {
  height: 25px;
}

/* Progressbar Vertical */
.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-md {
  width: 8px;
}
.progress-vertical.progress-sm {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-md {
  width: 8px;
}
.progress-vertical-bottom.progress-sm {
  width: 5px;
}

.progress-w-percent {
  min-height: 20px;
  margin-bottom: 20px;
}
.progress-w-percent .progress {
  width: 80%;
  float: left;
  margin-top: 8px;
}
.progress-w-percent .progress-value {
  width: 20%;
  float: right;
  text-align: right;
  line-height: 20px;
}

.div-loading {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  display: flex;
}

.loading-container {
  position: relative;
  width: 110px;
  height: 110px;
  margin: auto;
}

.loading-container .item {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 5px solid #0b7f8e;
  border-radius: 50%;
  border-top-color: transparent;
  border-bottom-color: transparent;
  animation: spin 2s ease infinite;
}

.loading-container .item:nth-child(1) {
  width: 50px;
  height: 50px;
}

.loading-container .item:nth-child(2) {
  width: 70px;
  height: 70px;
  animation-delay: 0.1s;
}

.loading-container .item:nth-child(3) {
  width: 90px;
  height: 90px;
  animation-delay: 0.2s;
}

.loading-container .item:nth-child(4) {
  width: 110px;
  height: 110px;
  animation-delay: 0.3s;
}

@keyframes spin {
  50% {
    transform: translate(-50%, -50%) rotate(180deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
}
@keyframes growProgressBar {
  0%, 33% {
    --pgPercentage: 0;
  }
  100% {
    --pgPercentage: var(--value);
  }
}
@property --pgPercentage {
  syntax: "<number>";
  inherits: false;
  initial-value: 0;
}
div[role=progressbar] {
  --size: 12rem;
  --fg: #369;
  --bg: #def;
  --pgPercentage: var(--value);
  animation: growProgressBar 3s 1 forwards;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: radial-gradient(closest-side, white 80%, transparent 0 99.9%, white 0), conic-gradient(var(--fg) calc(var(--pgPercentage) * 1%), var(--bg) 0);
  font-family: Helvetica, Arial, sans-serif;
  font-size: calc(var(--size) / 5);
  color: var(--fg);
}

div[role=progressbar]::before {
  counter-reset: percentage var(--value);
  content: counter(percentage) "%";
}

body {
  letter-spacing: 0.02rem;
  font-family: "Be Vietnam Pro", sans-serif;
}

a {
  text-decoration: none !important;
  display: inline-block;
}
a:focus {
  outline: none;
}

.row > * {
  position: relative;
}

label {
  font-weight: 600;
  font-size: 0.8203125rem;
}

button:focus {
  outline: none;
}

.blockquote {
  padding: 10px 20px;
  margin-bottom: 20px;
  border-left: 4px solid #f3f4f7;
}
.blockquote.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #f3f4f7;
  text-align: right;
}

.zindex-1 {
  z-index: 1;
}

.zindex-5 {
  z-index: 5;
}

.zindex-10 {
  z-index: 10;
}

.zindex-20 {
  z-index: 20;
}

.dataTables_paginate {
  display: none;
}

.paginate_button {
  display: none;
}

.dataTables_info {
  display: none;
}

.dataTables_length {
  display: none;
}

.table-centered td,
.table-centered th {
  vertical-align: middle !important;
}

.table {
  border-collapse: collapse;
}
.table th {
  font-weight: 600;
}
.table .table-user img {
  height: 30px;
  width: 30px;
}

.action-icon {
  color: #787878;
  font-size: 1.2rem;
  display: inline-block;
  padding: 0 3px;
}
.action-icon:hover {
  color: #495057;
}

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap;
}

.custom-table .select-col {
  width: 100px;
}

.t-sticky-1 {
  position: sticky;
  left: 0;
  z-index: 1;
}

.t-sticky-2 {
  position: sticky;
  left: 44.6px;
  z-index: 1;
  min-width: 65px;
}

.t-sticky-3 {
  position: sticky;
  left: 100px;
  z-index: 1;
}

.t-sticky-4 {
  position: sticky;
  left: 40.6px;
  z-index: 1;
  min-width: 64px;
}

.v-align {
  vertical-align: middle;
}

.tableFixHead {
  overflow-y: auto;
  height: 200px;
}

.tableFixHead table {
  border-collapse: collapse;
  width: 100%;
}

.tableFixHead th {
  position: sticky;
  top: 0;
  background: #eee;
}

@media (min-width: 992px) {
  .navbar-nav .dropdown-menu {
    left: 50%;
    min-width: 13rem;
    padding: 0.75rem 0;
    box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
    visibility: hidden;
    opacity: 0;
    transform: translate3d(-50%, 30px, 0);
    transition: all 0.3s ease-in-out;
    transition-property: opacity, visibility, transform;
    transform-origin: top center;
  }
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  border-bottom-width: 0px;
}

.sticky-h-1 {
  position: sticky;
  top: -1px;
  z-index: 2;
}

.sticky-h-2 {
  position: sticky;
  top: 41px;
  z-index: 2;
}

.sticky-h-3 {
  position: sticky;
  top: 59px;
  z-index: 2;
}

.sticky-h-4 {
  position: sticky;
  top: 84px;
  z-index: 2;
}

.th-b-color {
  border: 1px solid #696969;
}

.td-bottom-none {
  border-bottom: none !important;
}

td {
  border-right: 1px solid #696969;
  border-bottom: none;
}

th {
  border: 1px solid #696969;
}

.div-th {
  width: initial;
  border-bottom: 0.5px solid #696969;
  position: relative;
  top: 21px;
}

.div-th-3 {
  width: initial;
  border-bottom: 0.5px solid #696969;
  position: relative;
  top: 29px;
}

.div-th-2 {
  width: initial;
  border-bottom: 0.5px solid #696969;
  position: relative;
  top: 20px;
}

.p0 {
  padding: 0 !important;
}

.bg-table-1 {
  background-color: #e9ebef;
}

.table-grey {
  --bs-table-bg: #dfe6eb;
  --bs-table-striped-bg: #dfe6eb;
  --bs-table-striped-color: #dfe6eb;
  --bs-table-active-bg: #dfe6eb;
  --bs-table-active-color: #dfe6eb;
  --bs-table-hover-bg: #dfe6eb;
  --bs-table-hover-color: #dfe6eb;
  color: black;
  border-color: #484e53;
}
.table-grey thead tr th {
  vertical-align: middle;
  font-size: 12px;
  text-align: center;
}

.table-grey-2 {
  width: 100%;
  border: 1px solid #858687;
}
.table-grey-2 thead tr th,
.table-grey-2 tfoot tr th {
  background: #ccd9e2;
  text-align: center;
}
.table-grey-2 tr th,
.table-grey-2 tr td {
  font-size: 11.5px;
  vertical-align: middle;
  padding: 0.4rem 0.5rem;
}
.table-grey-2 thead tr {
  box-shadow: 0px 1px 0px 0px #858687;
}
.table-grey-2 tbody tr:nth-child(even) {
  background-color: #dfe6eb;
}
.table-grey-2 tbody tr:nth-child(odd) {
  background-color: #f4f5f7;
}

.table-head td,
.table-head th {
  background: #ccd9e2 !important;
  text-align: center;
  font-weight: bold !important;
  border: 1px solid #858687;
}

.bottom-line {
  box-shadow: 0px 1px 0px 0px #858687;
}

.sticky-border-y-gray {
  box-shadow: 0px -1px 0px 0px #dee2e6, 0px 1px 0px 0px #dee2e6;
}

.table-border-outline {
  outline: 1px solid #484e53 !important;
  border: none;
  outline-offset: -1px;
}

.table-border-outline-right {
  box-shadow: -5px 0px 0px 0px black, 5px 0px 0px 0px black;
  border: none;
  outline-offset: -1px;
}

.b1234 {
  border-width: 1px;
  border-left: 1px solid rgb(204, 204, 204);
  border-top: 1px solid rgb(204, 204, 204);
  border-right: 1px solid rgb(204, 204, 204);
  border-bottom: 1px solid rgb(204, 204, 204);
}

.formheader {
  background: #efefef;
  border: 1px solid #03476f;
  padding: 5px;
}

.body-radar {
  background-color: #e5e5e5;
  height: 100vh;
}

.box-radar {
  max-width: 900px;
  width: 100%;
  background-color: #e5e5e5;
  border-radius: 10px;
}

.box-user {
  max-width: 284px;
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
}

.usr-icon {
  width: 29px;
  height: 29px;
  border-radius: 50%;
}

.icon-radar {
  position: absolute;
  right: 0;
}

.txt-radar1 {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #1d1d1d;
}

.txt-radar2 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #1d1d1d;
}

.btn-radar-close {
  width: 153px;
  padding: 10px;
  border: 1px solid rgba(240, 240, 240, 0.9411764706);
  border-radius: 6px;
}

.width-radar-modal {
  width: 401px !important;
}

.box-desc-radar {
  width: 321px;
  background: #e6fcff;
  border: 1px solid #8ed5de;
  border-radius: 6px;
  padding: 10px;
  position: relative;
}

.txt-edit-radar {
  color: #0f98d8;
  font-weight: bold;
  font-size: 10px;
  z-index: 68;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.btn-radar-save {
  width: 153px;
  padding: 10px;
  border: 1px solid #0b7f8e;
  border-radius: 6px;
  background: #0b7f8e;
  color: white;
}

.btn-batas-hari {
  width: 80px;
  padding: 10px;
  border: 1px solid #0b7f8e;
  border-radius: 6px;
  background: #0b7f8e;
  color: white;
}

.box-table-radar {
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.fl-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}
.fl-table.user-role thead tr th {
  border-top: none;
  border-bottom: 1px solid #e3e5e8;
  color: #51555a;
  font-weight: 500;
}
.fl-table.user-role tbody tr .disabled {
  background: #f4f5f6;
}
.fl-table.user-role tbody tr .edit-peran {
  padding: 16px 22px;
}

.fl-table td,
.fl-table th {
  padding: 8px;
  border: none;
  border-bottom: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
}

.bg-transparent {
  background: transparent !important;
}

.bg-white {
  background: white !important;
}

.fl-table td {
  font-size: 12px;
  padding: 12px 0;
}

.fl-table thead th {
  color: black;
  background: rgba(11, 127, 142, 0.1);
}

.tr-radar:hover {
  background: rgb(235, 235, 235);
}

.color-green {
  color: #0b7f8e;
}

.color-green-light {
  color: #2eb85c;
}

.color-red-light {
  color: #e91a26;
}

.t-green {
  color: #86efac;
}

.t-yellow {
  color: #fde047;
}

.t-red {
  color: #f87171;
}

.color-black-sensor {
  color: #000000;
}

.color-green-light-sensor {
  color: #26ff31;
}

.color-blue-sensor {
  color: #0b7f8e;
}

.color-yellow {
  color: #f78216;
}

.color-red {
  color: red;
}

.box-jml-ayam {
  background: white;
  padding: 15px;
  border-radius: 4px;
  height: 46px;
  position: absolute;
  right: 0;
  bottom: 15px;
}

.dataTables_scrollBody {
  max-height: 90vh !important;
}

/* Define the classes to be used in the table datatables stripe */
.stripe-1 {
  background-color: #f4f5f7 !important;
}

.stripe-2 {
  background-color: #dfe6eb !important;
}

.tdLeft {
  border: none !important;
}

.tdRight {
  border: none !important;
}

.tblChart td {
  border: none !important;
}

/* Responsive */
@media (max-width: 767px) {
  .fl-table {
    display: block;
    width: 100%;
  }
  .table-wrapper:before {
    content: "Scroll horizontally >";
    display: block;
    text-align: right;
    font-size: 11px;
    color: white;
    padding: 0 0 10px;
  }
  .fl-table thead,
  .fl-table tbody,
  .fl-table thead th {
    display: block;
  }
  .fl-table thead th:last-child {
    border-bottom: none;
  }
  .fl-table thead {
    float: left;
  }
  .fl-table tbody {
    width: auto;
    position: relative;
    overflow-x: auto;
  }
  .fl-table td,
  .fl-table th {
    padding: 20px 0.625em 0.625em 0.625em;
    height: 60px;
    vertical-align: middle;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    width: 120px;
    font-size: 13px;
    text-overflow: ellipsis;
  }
  .fl-table thead th {
    text-align: left;
    border-bottom: 1px solid #f7f7f9;
  }
  .fl-table tbody tr {
    display: table-cell;
  }
  .fl-table tbody tr:nth-child(odd) {
    background: none;
  }
  .fl-table tr:nth-child(even) {
    background: transparent;
  }
  .fl-table tr td:nth-child(odd) {
    background: #f8f8f8;
    border-bottom: 1px solid #bdb8b8;
  }
  .fl-table tr td:nth-child(even) {
    border-bottom: 1px solid #bdb8b8;
  }
  .fl-table tbody td {
    display: block;
    text-align: center;
  }
}
.details {
  display: none;
}

.details.collapsed {
  display: table-row;
}

.container-box {
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.custom-table-stripped {
  font-size: 12px;
}
.custom-table-stripped tr td,
.custom-table-stripped tr th {
  border: none;
  padding: 10px;
}
.custom-table-stripped thead tr {
  background-color: white;
}
.custom-table-stripped tbody tr:nth-child(odd) {
  background-color: var(--bs-table-striped-bg);
}
.custom-table-stripped tbody tr:nth-child(even) {
  background-color: white;
}

.custom-table-stripped-2 {
  font-size: 12px;
}
.custom-table-stripped-2 tr td,
.custom-table-stripped-2 tr th {
  border: none;
  padding: 10px;
}
.custom-table-stripped-2 thead tr {
  background-color: white;
}
.custom-table-stripped-2 tbody tr:nth-child(odd) {
  background-color: white;
}
.custom-table-stripped-2 tbody tr:nth-child(even) {
  background-color: var(--bs-table-striped-bg);
}

.custom-table {
  font-size: 12px;
}
.custom-table tr td,
.custom-table tr th {
  border: none;
  padding: 12px;
}
.custom-table thead tr {
  background-color: white;
}
.custom-table tr {
  border-bottom: 1px solid #ebebeb;
}

.custom-table-plain {
  font-size: 12px;
  letter-spacing: -0.02em;
}
.custom-table-plain tr td,
.custom-table-plain tr th {
  border: none;
  padding: 12px;
}
.custom-table-plain tr td {
  color: var(--grey9);
}
.custom-table-plain thead tr {
  background-color: transparent;
}
.custom-table-plain tr {
  border-bottom: none;
}

.custom-table-plain.compact tr td,
.custom-table-plain.compact tr th {
  padding: 6px 8px;
}

.custom-table.zonasi-harga-table {
  border-spacing: 0px 0.5rem;
  border-collapse: separate;
}
.custom-table.zonasi-harga-table tr td {
  background: #f3f4f7;
}
.custom-table.zonasi-harga-table td,
.custom-table.zonasi-harga-table th {
  vertical-align: middle;
  text-align: center;
}

.section-table-zonasi-harga {
  width: calc(-moz-fit-content * 2);
  width: calc(fit-content * 2);
}

.table-zonasi-harga tr:first-of-type th:first-of-type {
  border-top-left-radius: 8px;
}
.table-zonasi-harga tr:first-of-type th:last-of-type {
  border-top-right-radius: 8px;
}
.table-zonasi-harga tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 8px;
}
.table-zonasi-harga tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 8px;
}
.table-zonasi-harga tr {
  border: none;
}
.table-zonasi-harga tr th {
  min-width: 70px;
}
.table-zonasi-harga tr td,
.table-zonasi-harga tr th {
  padding: 6px 8px;
  border: 2px white solid;
  text-align: center;
  vertical-align: middle;
  text-wrap: nowrap;
}
.table-zonasi-harga.table-tanggal tr th {
  background-color: #dfe6eb;
}
.table-zonasi-harga.table-tanggal tr td {
  background-color: #f4f5f7;
}

.table-evaluasi-harga {
  border-collapse: separate;
}
.table-evaluasi-harga tr th {
  background-color: #dfe6eb;
  height: 45px;
  white-space: nowrap;
}
.table-evaluasi-harga tr td,
.table-evaluasi-harga tr th {
  vertical-align: middle;
  text-align: center;
}
.table-evaluasi-harga tr td {
  text-wrap: nowrap;
  border: 1px solid #f4f5f7;
}
.table-evaluasi-harga.table-tanggal.show-by-zona tr th {
  height: 92px;
}
.table-evaluasi-harga.table-tanggal.show-by-unit tr th {
  height: 134px;
}
.table-evaluasi-harga.table-tanggal tr td {
  background-color: #f4f5f7;
}

.table-laporan {
  font-size: 13px;
}
.table-laporan table {
  width: 100%;
}
.table-laporan tr td,
.table-laporan tr th {
  border: solid 1px #d3d4d6;
  padding: 12px;
}
.table-laporan tr th {
  background-color: #f3f4f7;
  text-align: center;
}
.table-laporan.table-laporan-primary tr th {
  background-color: #d0e6e8;
}
.table-laporan.striped tbody tr:nth-child(even) {
  background-color: #fbfbfc;
}
.table-laporan.striped tbody tr:nth-child(odd) {
  background-color: white;
}
.table-laporan .row-odd {
  background-color: #fbfbfc;
}
.table-laporan .row-even {
  background-color: white;
}
.table-laporan thead {
  position: sticky;
  top: 0;
}
.table-laporan thead th {
  border: none;
  outline: 0.5px solid #d3d4d6;
  outline-offset: -0.5px;
}
.table-laporan tfoot {
  position: relative !important;
}

.table-panduan-panen {
  margin-bottom: 8px;
}
.table-panduan-panen tr th,
.table-panduan-panen tr td {
  border: 1px solid #d0d5da;
  height: 32px;
  color: #555555;
  font-weight: 500;
  vertical-align: middle;
}
.table-panduan-panen tr td {
  height: 48px;
}

.table-list-ppic {
  font-size: 12px;
}
.table-list-ppic.kirim-pakan thead tr {
  background: #f4f5f6 !important;
  border-bottom: 1px solid #e3e5e8;
}
.table-list-ppic.kirim-pakan tbody tr {
  background: #fff !important;
}
.table-list-ppic.kirim-pakan tbody tr:last-child td {
  border-bottom: none;
}
.table-list-ppic.stok-pakan thead tr th:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.table-list-ppic.stok-pakan thead tr th:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.table-list-ppic tr td,
.table-list-ppic tr th {
  border: none;
  padding: 10px;
}
.table-list-ppic tr th {
  font-weight: 500;
  color: var(--grey6);
  letter-spacing: -0.02em;
}
.table-list-ppic tr td {
  font-weight: 400;
  color: var(--grey9);
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-list-ppic thead tr {
  background-color: var(--grey1);
}
.table-list-ppic.custom-table-ppic tr:last-child td {
  border-bottom: none;
}

.table-realisasi-terakhir thead tr th {
  background: #b9ecca;
}
.table-realisasi-terakhir tbody tr td {
  background: #ebfaf0;
}

.table-dashboard {
  border-spacing: 0;
  border-collapse: separate;
}
.table-dashboard tr th,
.table-dashboard tr td {
  border: none;
  padding: 10px;
}
.table-dashboard tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--grey6);
  letter-spacing: -0.02em;
}
.table-dashboard tr td {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-dashboard thead tr {
  background: var(--grey1);
}
.table-dashboard thead tr th {
  border-top: 1px solid var(--grey3);
  border-bottom: 1px solid var(--grey3);
}
.table-dashboard thead tr th:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--grey3);
}
.table-dashboard thead tr th:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--grey3);
}
.table-dashboard tbody tr td .sehat {
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 8px;
  color: var(--green6);
  background: var(--green1);
}
.table-dashboard tbody tr td .sakit {
  font-weight: 500;
  padding: 2px 8px;
  color: var(--red6);
  border-radius: 8px;
  background: var(--red1);
}
.table-dashboard tbody tr td .normal {
  background: transparent;
}
.table-dashboard tbody tr td .sudah {
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 8px;
  color: var(--green6);
  letter-spacing: -0.02em;
  background: var(--green1);
}
.table-dashboard tbody tr td .belum {
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 8px;
  color: var(--grey7);
  letter-spacing: -0.02em;
  background: var(--grey1);
}
.table-dashboard tbody tr td .link-to-plasma:hover {
  color: var(--teal7) !important;
}
.table-dashboard tfoot tr {
  background: var(--blue2);
}
.table-dashboard tfoot tr th {
  font-weight: 500;
  line-height: 16px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}

.table-stok-per-unit {
  border-spacing: 0;
  border-collapse: separate;
}
.table-stok-per-unit tr th,
.table-stok-per-unit tr td {
  border: none;
  padding: 10px;
}
.table-stok-per-unit tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--grey6);
  letter-spacing: -0.02em;
}
.table-stok-per-unit tr td {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 16px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-stok-per-unit thead tr {
  background: var(--grey1);
}
.table-stok-per-unit thead .first-th th {
  border-top: 1px solid var(--grey3);
}
.table-stok-per-unit thead .first-th th:first-child {
  border-top-left-radius: 8px;
  border-left: 1px solid var(--grey3);
}
.table-stok-per-unit thead .first-th th:last-child {
  border-top-right-radius: 8px;
  border-right: 1px solid var(--grey3);
}
.table-stok-per-unit thead .second-th th {
  border-bottom: 1px solid var(--grey3);
}
.table-stok-per-unit thead .second-th th:first-child {
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--grey3);
}
.table-stok-per-unit thead .second-th th:last-child {
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--grey3);
}
.table-stok-per-unit tbody tr td .over {
  display: block;
  padding: 2px 8px;
  border-radius: 8px;
  width: -moz-fit-content;
  width: fit-content;
  background: var(--red1);
  color: var(--red6) !important;
}
.table-stok-per-unit tbody tr td .normal {
  display: block;
  padding: 2px 8px;
  border-radius: 8px;
  width: -moz-fit-content;
  width: fit-content;
  background: var(--green1);
  color: var(--green6) !important;
}
.table-stok-per-unit tfoot tr {
  background: var(--grey2);
}
.table-stok-per-unit tfoot tr th {
  color: var(--grey9);
  border-bottom: 1px solid var(--grey3);
}

.table-informasi-batas-atas tr th,
.table-informasi-batas-atas tr td {
  border: none;
  padding: 8px 12px;
}
.table-informasi-batas-atas tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--grey6);
  letter-spacing: -0.02em;
  background: var(--grey2);
  border-bottom: 1px solid var(--grey3);
}
.table-informasi-batas-atas tr td {
  font-size: 12px;
  line-height: 16px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  background: var(--white);
}

.table-pilih-flok {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
}
.table-pilih-flok thead tr {
  background: var(--grey2);
}
.table-pilih-flok thead tr th {
  border: none;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
  background: var(--grey2);
  border-top: 1px solid var(--grey3);
  border-bottom: 1px solid var(--grey3);
}
.table-pilih-flok thead tr th:first-child {
  border-radius: 8px 0 0 8px;
  border-left: 1px solid var(--grey3);
}
.table-pilih-flok thead tr th:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid var(--grey3);
}
.table-pilih-flok tbody tr td {
  border: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}

.table-pilih-doc {
  width: 100%;
  margin-bottom: 0;
  border-spacing: 0;
  border-collapse: separate;
}
.table-pilih-doc tr th,
.table-pilih-doc tr td {
  border: none;
}
.table-pilih-doc thead tr {
  background: var(--grey2);
}
.table-pilih-doc thead tr th {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
  border-top: 1px solid var(--grey3);
  border-bottom: 1px solid var(--grey3);
}
.table-pilih-doc thead tr th:first-child {
  border-radius: 8px 0 0 8px;
  border-left: 1px solid var(--grey3);
}
.table-pilih-doc thead tr th:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid var(--grey3);
}
.table-pilih-doc tbody tr td {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}

.table-pilih-pakan {
  width: 100%;
  margin-bottom: 0;
  border-spacing: 0;
  border-collapse: separate;
}
.table-pilih-pakan tr th,
.table-pilih-pakan tr td {
  border: none;
}
.table-pilih-pakan thead tr {
  background: var(--grey2);
}
.table-pilih-pakan thead tr th {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
  border-top: 1px solid var(--grey3);
  border-bottom: 1px solid var(--grey3);
}
.table-pilih-pakan thead tr th:first-child {
  border-radius: 8px 0 0 8px;
  border-left: 1px solid var(--grey3);
}
.table-pilih-pakan thead tr th:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid var(--grey3);
}
.table-pilih-pakan tbody tr td {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-pilih-pakan tbody tr td .form-check-input {
  margin: 0;
  width: 12px;
  height: 12px;
  box-shadow: none;
  transform: scale(1.5);
  vertical-align: middle;
  border: 1.5px solid var(--grey5);
}
.table-pilih-pakan tbody tr td .form-check-input:checked {
  border: none;
  box-shadow: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) center;
}

.custom-table-planning {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
}
.custom-table-planning tr th,
.custom-table-planning tr td {
  border: none;
}
.custom-table-planning thead tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
  background: var(--grey2);
  border-top: 1px solid var(--grey3);
  border-bottom: 1px solid var(--grey3);
}
.custom-table-planning thead tr th:first-child {
  border-radius: 8px 0 0 8px;
  border-left: 1px solid var(--grey3);
}
.custom-table-planning thead tr th:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid var(--grey3);
}
.custom-table-planning tbody tr td {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.custom-table-planning tbody tr td .link-to-plasma:hover {
  color: var(--teal7) !important;
}
.custom-table-planning tfoot tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 16px 12px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  background: var(--grey1);
  border-bottom: 1px solid var(--grey3);
}

.table-harga-ayam-besar {
  width: 100%;
}
.table-harga-ayam-besar tr th,
.table-harga-ayam-besar tr td {
  border: none;
}
.table-harga-ayam-besar thead tr {
  background: var(--grey2);
}
.table-harga-ayam-besar thead tr th {
  width: 50%;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-harga-ayam-besar tbody tr td {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-harga-ayam-besar.realisasi tbody tr td {
  background: var(--green1);
}

.table-assessment {
  font-size: 12px;
  letter-spacing: -0.02em;
}
.table-assessment tr td,
.table-assessment tr th {
  border: none;
  vertical-align: middle;
}
.table-assessment tr th {
  height: 52px;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  color: var(--grey9);
}
.table-assessment tr td {
  font-weight: 400;
  padding: 18px 12px;
  color: var(--grey8);
  background: var(--white);
  border-top: 1px solid var(--grey3);
}
.table-assessment thead .custom-search {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) white no-repeat 12px center;
}
.table-assessment thead .select .react-select__control {
  min-height: 32px;
}
.table-assessment thead .select .react-select__control .react-select__value-container {
  padding: 0 0 0 12px;
}
.table-assessment thead .select .react-select__control .react-select__value-container .react-select__input-container {
  margin: 0;
  padding: 0;
}
.table-assessment thead .select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.table-assessment thead .select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0 12px 0 0;
}
.table-assessment thead .list-group {
  z-index: 1000;
  cursor: pointer;
  overflow-y: auto;
  max-height: 188px;
  border-radius: 8px;
  background: var(--white);
  border: 1px solid var(--grey2);
  box-shadow: 0px 4px 6px -2px rgba(26, 26, 26, 0.2);
}
.table-assessment thead .list-group .list-group-item {
  border: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 8px 16px;
  letter-spacing: -0.02em;
  transition: all ease-in-out 0.2s;
}
.table-assessment thead .list-group .list-group-item:hover {
  font-weight: 500;
  color: var(--blue6);
  background: var(--blue1);
}
.table-assessment thead .header-wrapper {
  padding: 0;
  display: flex;
  border-radius: 8px;
  align-items: center;
  background: var(--grey2);
  border: 1px solid var(--grey3);
  justify-content: space-between;
}
.table-assessment thead .header-wrapper th {
  width: 329px;
  height: auto;
}

.table-panen {
  border-spacing: 0 0;
  border-collapse: separate;
}
.table-panen tr th,
.table-panen tr td {
  white-space: nowrap;
  border: 1px solid var(--grey3);
}
.table-panen tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
}
.table-panen tr td {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 18px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-panen thead tr {
  background: var(--grey2);
}
.table-panen thead tr .col-sticky {
  position: sticky;
  left: 0;
  z-index: 9;
  background: var(--grey2);
}
.table-panen thead .first-th th:first-child {
  border-bottom: none;
  border-top-left-radius: 8px;
}
.table-panen thead .first-th th:last-child {
  border-top-right-radius: 8px;
}
.table-panen thead .first-th th:nth-child(2)::before {
  content: none;
}
.table-panen thead .first-th .group-col {
  position: relative;
}
.table-panen thead .first-th .group-col::before {
  content: "";
  position: absolute;
  left: 0;
  top: -1px;
  width: 8px;
  height: 34px;
  background: var(--white);
}
.table-panen thead .second-th th:first-child {
  border-top: none;
  border-bottom-left-radius: 8px;
}
.table-panen thead .second-th th:last-child {
  border-bottom-right-radius: 8px;
}
.table-panen thead .second-th th:nth-child(2)::before {
  content: none;
}
.table-panen thead .second-th .group-end {
  position: relative;
}
.table-panen thead .second-th .group-end::before {
  content: "";
  position: absolute;
  left: 0;
  top: -2px;
  width: 8px;
  height: 34px;
  background: var(--white);
}
.table-panen tbody tr td {
  border-top: none;
}
.table-panen tbody tr td:first-child {
  border-left: none;
}
.table-panen tbody tr td:last-child {
  border-right: none;
}
.table-panen tbody tr td:nth-child(2)::before {
  content: none;
}
.table-panen tbody tr .col-sticky {
  position: sticky;
  left: 0;
  z-index: 9;
  background: var(--white);
}
.table-panen tbody tr .group-end {
  position: relative;
}
.table-panen tbody tr .group-end::before {
  content: "";
  position: absolute;
  left: 0;
  top: -2px;
  width: 8px;
  height: 56px;
  background: var(--white);
}
.table-panen tfoot tr {
  background: var(--grey2);
}
.table-panen tfoot tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 16px 12px;
  color: var(--grey9);
  letter-spacing: -0.02em;
  border-top: none;
}
.table-panen tfoot tr th:first-child {
  border-left: none;
}
.table-panen tfoot tr th:last-child {
  border-right: none;
}
.table-panen tfoot tr th:nth-child(2)::before {
  content: none;
}
.table-panen tfoot tr .col-sticky {
  position: sticky;
  left: 0;
  z-index: 9;
  background: var(--grey2);
}
.table-panen tfoot tr .group-end {
  position: relative;
}
.table-panen tfoot tr .group-end::before {
  content: "";
  position: absolute;
  left: 0;
  top: -1px;
  width: 8px;
  height: 50px;
  background: var(--white);
}

.table-pengaturan-panen {
  border-spacing: 0;
  border-collapse: separate;
}
.table-pengaturan-panen tr th,
.table-pengaturan-panen tr td {
  border: none;
}
.table-pengaturan-panen tr th {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  color: var(--grey6);
  letter-spacing: -0.02em;
}
.table-pengaturan-panen tr td {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 18px 12px;
  color: var(--grey9);
  vertical-align: middle;
  letter-spacing: -0.02em;
  border-bottom: 1px solid var(--grey3);
}
.table-pengaturan-panen thead tr {
  background: var(--grey1);
}
.table-pengaturan-panen thead tr th {
  border-top: 1px solid var(--grey3);
  border-bottom: 1px solid var(--grey3);
}
.table-pengaturan-panen thead tr th:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--grey3);
}
.table-pengaturan-panen thead tr th:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--grey3);
}
.table-pengaturan-panen tbody tr td .penjarangan {
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 8px;
  width: -moz-fit-content;
  width: fit-content;
  color: var(--orange6);
  background: var(--orange2);
  text-transform: capitalize;
}
.table-pengaturan-panen tbody tr td .panen {
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 8px;
  width: -moz-fit-content;
  width: fit-content;
  color: var(--green6);
  background: var(--green2);
  text-transform: capitalize;
}
.table-pengaturan-panen tbody tr .react-datepicker-wrapper {
  width: -moz-fit-content;
  width: fit-content;
}
.table-pengaturan-panen tbody tr .react-datepicker-wrapper .react-datepicker__input-container {
  width: -moz-fit-content;
  width: fit-content;
}
.table-pengaturan-panen tbody tr .react-datepicker-wrapper .react-datepicker__input-container input {
  cursor: pointer;
  width: var(--56);
  background: transparent;
}
.table-pengaturan-panen tbody tr .select.none {
  width: 100%;
}
.table-pengaturan-panen tbody tr .select.none .react-select__control {
  background: transparent;
}
.table-pengaturan-panen tbody tr .select.none .react-select__control .react-select__value-container .react-select__single-value {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--grey9);
}
.table-pengaturan-panen tbody tr .select.none .react-select__control .react-select__indicators .react-select__indicator svg {
  width: 16px;
  height: 16px;
}
.table-pengaturan-panen tbody tr .select.none .react-select__control .react-select__indicators .react-select__indicator svg path {
  color: var(--grey9);
}

.row-border-y-0 tr:not(:last-child) td {
  border-bottom: none !important;
}

.row-border-y-0 tr td {
  border-top: none !important;
}

.table-master-batas-hari td:first-child,
.table-master-batas-hari th:first-child {
  position: sticky;
  left: 0;
  z-index: 6;
}
.table-master-batas-hari td:first-child {
  background-color: white;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 10px 0;
  font-family: "Be Vietnam Pro", sans-serif;
  color: #343a40;
  font-weight: 600;
}

p {
  line-height: 1.6;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-19 {
  font-size: 19px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.text-unline-dashed {
  border-bottom: #cdcdcd 1px dashed !important;
  padding-bottom: 1px;
}

.line-height-normal {
  line-height: 1;
}

.fw-regular {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}

.highlight {
  position: relative;
  z-index: 1;
  width: -moz-fit-content;
  width: fit-content;
}
.highlight::before {
  content: "";
  display: block;
  position: absolute;
  background: #f4f5f7;
  width: 100%;
  height: 1.2rem;
  z-index: -1;
  right: -0.5rem;
  bottom: 0.35rem;
}
.highlight.highlight-primary::before {
  background: #2ad8ef !important;
}
.highlight.highlight-secondary::before {
  background: #869099 !important;
}
.highlight.highlight-success::before {
  background: #a4eac0 !important;
}
.highlight.highlight-info::before {
  background: #63d9ec !important;
}
.highlight.highlight-warning::before {
  background: #ffebb7 !important;
}
.highlight.highlight-danger::before {
  background: #f9a9ad !important;
}
.highlight.highlight-light::before {
  background: white !important;
}
.highlight.highlight-dark::before {
  background: #6d7a86 !important;
}
.highlight.highlight-orange::before {
  background: #ffd8cb !important;
}
.highlight.highlight-teal::before {
  background: #7eeaca !important;
}
.highlight.highlight-gray-50::before {
  background: white !important;
}

.width-xs {
  min-width: 80px;
}

.width-sm {
  min-width: 95px;
}

.width-md {
  min-width: 110px;
}

.width-lg {
  min-width: 140px;
}

.width-xl {
  min-width: 160px;
}

.sp-line-1,
.sp-line-2,
.sp-line-3,
.sp-line-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.sp-line-1 {
  -webkit-line-clamp: 1;
}

.sp-line-2 {
  -webkit-line-clamp: 2;
}

.sp-line-3 {
  -webkit-line-clamp: 3;
}

.sp-line-4 {
  -webkit-line-clamp: 4;
}

.pull-in {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.rounded-sm {
  border-radius: 0.25rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-normal {
  cursor: default;
}

.list-with-separator li::after {
  content: "-";
  color: #cdcdcd;
  font-weight: 900;
  margin: 0 10px;
}
.list-with-separator li:last-child::after {
  content: "";
}

.widget-flat {
  position: relative;
  overflow: hidden;
}
.widget-flat i.widget-icon {
  font-size: 36px;
}

/* Chat widget */
.conversation-list {
  list-style: none;
  height: 332px;
  padding: 0 7px;
}
.conversation-list li {
  margin-bottom: 24px;
}
.conversation-list .chat-avatar {
  float: left;
  text-align: center;
  width: 34px;
}
.conversation-list .chat-avatar img {
  border-radius: 100%;
  width: 100%;
}
.conversation-list .chat-avatar i {
  font-size: 12px;
  font-style: normal;
}
.conversation-list .ctext-wrap {
  background: #4bdef1;
  color: #0b7f8e;
  border-radius: 0.375rem;
  display: inline-block;
  padding: 4px 12px;
  position: relative;
}
.conversation-list .ctext-wrap i {
  display: block;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  position: relative;
}
.conversation-list .ctext-wrap p {
  margin: 0;
  padding-top: 3px;
}
.conversation-list .ctext-wrap:after {
  right: 99%;
  top: 0;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: #4bdef1;
  border-width: 6px;
  margin-left: -1px;
  border-right-color: #4bdef1;
}
.conversation-list .conversation-text {
  float: left;
  font-size: 12px;
  margin-left: 12px;
  width: 70%;
}
.conversation-list .odd .chat-avatar {
  float: right !important;
}
.conversation-list .odd .conversation-text {
  float: right !important;
  margin-right: 12px;
  text-align: right;
  width: 70% !important;
}
.conversation-list .odd .ctext-wrap {
  background-color: #dee2e6;
  color: #495057;
}
.conversation-list .odd .ctext-wrap:after {
  border-color: transparent;
  border-left-color: #dee2e6;
  border-top-color: #dee2e6;
  left: 99% !important;
}

/* profile / users */
.profile-widget {
  position: relative;
}
.profile-widget .card-action {
  position: absolute;
  right: 7px;
  top: 12px;
  z-index: 100;
}
.profile-widget .card-img-top {
  max-height: 220px;
}
.profile-widget .profile-info {
  margin-top: -2.7rem;
}

.calendar-widget .flatpickr-calendar {
  box-shadow: none;
  border: 1px solid #dee2e6 !important;
}

.checkbox label {
  display: inline-block;
  padding-left: 8px;
  position: relative;
  font-weight: normal;
  margin-bottom: 0;
}
.checkbox label::before {
  background-color: #dee2e6;
  border-radius: 3px;
  border: 2px solid #dee2e6;
  content: "";
  display: inline-block;
  height: 18px;
  left: 0;
  margin-left: -18px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 18px;
  outline: none !important;
  top: 2px;
}
.checkbox label::after {
  color: #495057;
  display: inline-block;
  font-size: 11px;
  height: 18px;
  left: 0;
  margin-left: -18px;
  padding-left: 3px;
  padding-top: 2px;
  position: absolute;
  top: 0;
  width: 18px;
}
.checkbox input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.checkbox input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.checkbox input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
  outline: none;
}
.checkbox input[type=checkbox]:checked + label::after {
  content: "";
  position: absolute;
  top: 6px;
  left: 7px;
  display: table;
  width: 4px;
  height: 8px;
  border: 2px solid #495057;
  border-top-width: 0;
  border-left-width: 0;
  transform: rotate(45deg);
}
.checkbox input[type=checkbox]:disabled + label::before {
  background-color: #f4f5f7;
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  margin-top: 0;
}

.checkbox.checkbox-single input {
  height: 18px;
  width: 18px;
  position: absolute;
}
.checkbox.checkbox-single label {
  height: 18px;
  width: 18px;
}
.checkbox.checkbox-single label:before {
  margin-left: 0;
}
.checkbox.checkbox-single label:after {
  margin-left: 0;
}

.checkbox-primary input[type=checkbox]:checked + label::before {
  background-color: #0b7f8e;
  border-color: #0b7f8e;
}
.checkbox-primary input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-secondary input[type=checkbox]:checked + label::before {
  background-color: #495057;
  border-color: #495057;
}
.checkbox-secondary input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-success input[type=checkbox]:checked + label::before {
  background-color: #3cd278;
  border-color: #3cd278;
}
.checkbox-success input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-info input[type=checkbox]:checked + label::before {
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.checkbox-info input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-warning input[type=checkbox]:checked + label::before {
  background-color: #ffc837;
  border-color: #ffc837;
}
.checkbox-warning input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-danger input[type=checkbox]:checked + label::before {
  background-color: #f0323c;
  border-color: #f0323c;
}
.checkbox-danger input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-light input[type=checkbox]:checked + label::before {
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.checkbox-light input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-dark input[type=checkbox]:checked + label::before {
  background-color: #343a40;
  border-color: #343a40;
}
.checkbox-dark input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-orange input[type=checkbox]:checked + label::before {
  background-color: #ff784b;
  border-color: #ff784b;
}
.checkbox-orange input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-teal input[type=checkbox]:checked + label::before {
  background-color: #20c997;
  border-color: #20c997;
}
.checkbox-teal input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-gray-50 input[type=checkbox]:checked + label::before {
  background-color: #fefefe;
  border-color: #fefefe;
}
.checkbox-gray-50 input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

input[type=checkbox],
input[type=checkbox] + label {
  cursor: pointer;
}

.radio label {
  display: inline-block;
  padding-left: 8px;
  position: relative;
  font-weight: normal;
  margin-bottom: 0;
}
.radio label::before {
  -o-transition: border 0.5s ease-in-out;
  -webkit-transition: border 0.5s ease-in-out;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #787878;
  content: "";
  display: inline-block;
  height: 18px;
  left: 0;
  margin-left: -18px;
  position: absolute;
  transition: border 0.5s ease-in-out;
  width: 18px;
  outline: none !important;
}
.radio label::after {
  -moz-transition: -moz-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -ms-transform: scale(0, 0);
  -o-transform: scale(0, 0);
  -o-transition: -o-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -webkit-transform: scale(0, 0);
  -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  background-color: #495057;
  border-radius: 50%;
  content: " ";
  display: inline-block;
  height: 10px;
  left: 6px;
  margin-left: -20px;
  position: absolute;
  top: 4px;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  width: 10px;
}
.radio input[type=radio] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.radio input[type=radio]:disabled + label {
  opacity: 0.65;
}
.radio input[type=radio]:focus + label::before {
  outline-offset: -2px;
  outline: 5px auto -webkit-focus-ring-color;
  outline: thin dotted;
}
.radio input[type=radio]:checked + label::after {
  transform: scale(1, 1);
}
.radio input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}

.radio.radio-inline {
  margin-top: 0;
}

.radio.radio-single label {
  height: 17px;
}

.radio-primary input[type=radio] + label::after {
  background-color: #0b7f8e;
}
.radio-primary input[type=radio]:checked + label::before {
  border-color: #0b7f8e;
}
.radio-primary input[type=radio]:checked + label::after {
  background-color: #0b7f8e;
}

.radio-secondary input[type=radio] + label::after {
  background-color: #495057;
}
.radio-secondary input[type=radio]:checked + label::before {
  border-color: #495057;
}
.radio-secondary input[type=radio]:checked + label::after {
  background-color: #495057;
}

.radio-success input[type=radio] + label::after {
  background-color: #3cd278;
}
.radio-success input[type=radio]:checked + label::before {
  border-color: #3cd278;
}
.radio-success input[type=radio]:checked + label::after {
  background-color: #3cd278;
}

.radio-info input[type=radio] + label::after {
  background-color: #17a2b8;
}
.radio-info input[type=radio]:checked + label::before {
  border-color: #17a2b8;
}
.radio-info input[type=radio]:checked + label::after {
  background-color: #17a2b8;
}

.radio-warning input[type=radio] + label::after {
  background-color: #ffc837;
}
.radio-warning input[type=radio]:checked + label::before {
  border-color: #ffc837;
}
.radio-warning input[type=radio]:checked + label::after {
  background-color: #ffc837;
}

.radio-danger input[type=radio] + label::after {
  background-color: #f0323c;
}
.radio-danger input[type=radio]:checked + label::before {
  border-color: #f0323c;
}
.radio-danger input[type=radio]:checked + label::after {
  background-color: #f0323c;
}

.radio-light input[type=radio] + label::after {
  background-color: #f4f5f7;
}
.radio-light input[type=radio]:checked + label::before {
  border-color: #f4f5f7;
}
.radio-light input[type=radio]:checked + label::after {
  background-color: #f4f5f7;
}

.radio-dark input[type=radio] + label::after {
  background-color: #343a40;
}
.radio-dark input[type=radio]:checked + label::before {
  border-color: #343a40;
}
.radio-dark input[type=radio]:checked + label::after {
  background-color: #343a40;
}

.radio-orange input[type=radio] + label::after {
  background-color: #ff784b;
}
.radio-orange input[type=radio]:checked + label::before {
  border-color: #ff784b;
}
.radio-orange input[type=radio]:checked + label::after {
  background-color: #ff784b;
}

.radio-teal input[type=radio] + label::after {
  background-color: #20c997;
}
.radio-teal input[type=radio]:checked + label::before {
  border-color: #20c997;
}
.radio-teal input[type=radio]:checked + label::after {
  background-color: #20c997;
}

.radio-gray-50 input[type=radio] + label::after {
  background-color: #fefefe;
}
.radio-gray-50 input[type=radio]:checked + label::before {
  border-color: #fefefe;
}
.radio-gray-50 input[type=radio]:checked + label::after {
  background-color: #fefefe;
}

@media print {
  .left-side-menu,
  .right-bar,
  .page-title-box,
  .navbar-custom,
  .footer {
    display: none;
  }
  .card-body,
  .content-page,
  .right-bar,
  .content,
  body {
    padding: 0;
    margin: 0;
  }
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 9999;
}

#status {
  height: 80px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -40px 0 0 -40px;
}

.spinner > div {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #fff;
  border: 2px solid #0b7f8e;
  border-radius: 50%;
  animation: circle-loader 1s infinite ease-in-out both;
  margin: 0px 7px;
}
.spinner .circle1 {
  animation-delay: -0.24s;
}
.spinner .circle2 {
  animation-delay: -0.16s;
}
.spinner .circle3 {
  animation-delay: -0.08s;
}

@keyframes circle-loader {
  0%, 80%, 100% {
    transform: scale(0.4);
  }
  40% {
    transform: scale(1);
  }
}
#tooltip-top .tooltip-arrow {
  display: none;
}
#tooltip-top .tooltip-inner {
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--grey10);
}
#tooltip-top .tooltip-inner div {
  font-size: 12px;
  font-weight: 500;
  text-align: start;
  color: var(--white);
  letter-spacing: -0.02em;
}

.offcanvas {
  overflow-y: auto;
  border-radius: var(--8) 0 0 var(--8);
}
.offcanvas .tab-w-bg .rts___tabs___container .rts___tabs {
  width: 100%;
}
.offcanvas .tab-w-bg .rts___tabs___container .rts___tabs .rts___tab {
  width: 100%;
  white-space: nowrap;
}
.offcanvas .dual-slider-wrapper {
  position: relative;
}
.offcanvas .dual-slider-wrapper .track {
  width: 100%;
  height: 1px;
  overflow: hidden;
  position: relative;
  background: var(--pink6);
}
.offcanvas .dual-slider-wrapper .track .track-fill-left {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  background: var(--grey3);
}
.offcanvas .dual-slider-wrapper .track .track-fill-right {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  height: 100%;
  background: var(--grey3);
}
.offcanvas .dual-slider-wrapper .slider {
  appearance: none;
  position: absolute;
  top: 50%;
  width: 100%;
  height: 1px;
  background: transparent;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 3;
}
.offcanvas .dual-slider-wrapper .slider.slider-left {
  left: 0;
  z-index: 4;
}
.offcanvas .dual-slider-wrapper .slider.slider-right {
  right: 0;
  z-index: 5;
}
.offcanvas .dual-slider-wrapper .slider::-webkit-slider-thumb {
  pointer-events: auto;
  -webkit-appearance: none;
  cursor: pointer;
  width: var(--20);
  height: var(--20);
  border-radius: 50%;
  background: var(--white);
  border: 1px solid var(--grey3);
}
.offcanvas .dual-slider-wrapper .slider::-moz-range-thumb {
  pointer-events: auto;
  cursor: pointer;
  width: var(--20);
  height: var(--20);
  border-radius: 50%;
  background: var(--white);
  border: 1px solid var(--grey3);
}
.offcanvas .segmentasi {
  width: 100px;
}
.offcanvas .rerata-pengambilan {
  width: 140px;
}
.offcanvas .omset {
  width: 200px;
}
.offcanvas .custom-spinner {
  width: var(--20);
  height: var(--20);
  border: 3px solid #e3e5e8;
  border-top: 3px solid var(--primary);
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  .offcanvas .offcanvas-body .tab-w-bg .rts___tabs___container .rts___tabs {
    flex-direction: column;
  }
}
/* Medium mobile */
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  .offcanvas {
    width: 100% !important;
  }
}
/* Small tablet */
/* Medium tablet */
/* Large tablet */
/* Small laptop */
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
.customs-input {
  outline: none;
  font-weight: 400;
  color: var(--grey9);
  font-size: var(--12);
  line-height: var(--16);
  border-radius: var(--6);
  padding: var(--8) var(--12);
  border: 1px solid var(--grey3);
}
.customs-input::placeholder {
  color: var(--grey5);
}
.customs-input:focus {
  border: 1px solid var(--teal6);
}
.customs-input.textarea {
  height: 80px;
  resize: none;
}

.label-checkbox {
  margin-bottom: var(--12);
}
.label-checkbox:last-child {
  margin-bottom: 0;
}
.label-checkbox .custom-checkbox {
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  width: var(--12);
  height: var(--12);
  position: relative;
  border-radius: 3px;
  border: 1px solid var(--grey3);
}
.label-checkbox .custom-checkbox:checked {
  background: var(--blue7);
  border-color: var(--blue7);
}
.label-checkbox .custom-checkbox:checked::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 3px;
  width: var(--4);
  height: var(--8);
  border: solid var(--white);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.time-wrapper {
  position: relative;
  width: 100%;
}
.time-wrapper .time {
  width: 100%;
  cursor: pointer;
  appearance: none;
}
.time-wrapper .time::-webkit-calendar-picker-indicator {
  opacity: 0;
  display: none;
}
.time-wrapper .time::-webkit-clear-button {
  display: none;
}
.time-wrapper .time::-webkit-inner-spin-button {
  display: none;
}
.time-wrapper .time-icon {
  position: absolute;
  top: 50%;
  right: var(--12);
  width: var(--16);
  height: var(--16);
  transform: translateY(-50%);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat center;
  background-size: contain;
}

.customs-slider {
  --percent: 0%;
  appearance: none;
  width: 100%;
  height: 1px;
  border-radius: var(--10);
  background: linear-gradient(to right, var(--pink6) var(--percent), var(--grey3) var(--percent));
}
.customs-slider::-webkit-slider-runnable-track {
  height: 1px;
  background: transparent;
}
.customs-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  cursor: pointer;
  width: var(--20);
  height: var(--20);
  border-radius: 50%;
  background: var(--white);
  border: 1px solid var(--grey3);
  margin-top: calc((1px - var(--20)) / 2);
}
.customs-slider::-moz-range-track {
  height: 1px;
  background: var(--grey3);
}
.customs-slider::-moz-range-progress {
  height: 1px;
  background: var(--pink6);
}
.customs-slider::-moz-range-thumb {
  cursor: pointer;
  width: var(--20);
  height: var(--20);
  border-radius: 50%;
  background: var(--white);
  border: 1px solid var(--grey3);
}

.affix-wrapper {
  display: flex;
  align-items: center;
  border-radius: var(--6);
  border: 1px solid var(--grey3);
}
.affix-wrapper.error {
  border: 1px solid var(--red7) !important;
}
.affix-wrapper:focus-within {
  border: 1px solid var(--teal6);
}
.affix-wrapper:focus-within .affix.prefix {
  border-right: 1px solid var(--teal6);
}
.affix-wrapper:focus-within .affix.suffix {
  border-left: 1px solid var(--teal6);
}
.affix-wrapper .affix {
  font-weight: 400;
  white-space: nowrap;
  color: var(--grey6);
  font-size: var(--12);
  line-height: var(--16);
  background: var(--grey2);
}
.affix-wrapper .affix.prefix {
  border-right: 1px solid var(--grey3);
  border-radius: var(--6) 0 0 var(--6);
  padding: var(--8) var(--8) var(--8) var(--12);
}
.affix-wrapper .affix.suffix {
  border-left: 1px solid var(--grey3);
  border-radius: 0 var(--6) var(--6) 0;
  padding: var(--8) var(--12) var(--8) var(--8);
}
.affix-wrapper .customs-input {
  flex: 1 1;
  border: none;
}
.affix-wrapper .select {
  width: 100%;
}
.affix-wrapper .select .react-select__control {
  border: none;
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  #select .select-ap .react-select__menu {
    left: -20px;
  }
  #select .select-unit .react-select__menu {
    left: 0;
  }
}
/* Medium mobile */
@media (min-width: 375px) and (max-width: 424px) {
  #select .select-ap .react-select__menu {
    left: 0;
  }
  #select .select-unit .react-select__menu {
    left: 0;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  #select .select-ap .react-select__menu {
    left: 0;
  }
  #select .select-unit .react-select__menu {
    left: 0;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  #select .select-ap .react-select__menu {
    left: 0;
  }
}
/* Medium tablet */
/* Large tablet */
/* Small laptop */
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
.rateit {
  display: -moz-inline-box;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  -webkit-touch-callout: none;
}
.rateit .rateit-range * {
  display: block;
}
.rateit .rateit-hover,
.rateit .rateit-selected {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
}
.rateit .rateit-hover-rtl,
.rateit .rateit-selected-rtl {
  left: auto;
  right: 0;
}
.rateit .rateit-hover {
  color: #ffc837;
}
.rateit .rateit-hover-rtl {
  background-position: right -32px;
}
.rateit .rateit-selected {
  color: #f0323c;
}
.rateit .rateit-selected-rtl {
  background-position: right -16px;
}
.rateit .rateit-preset {
  color: #ffc837;
}
.rateit button.rateit-reset {
  width: 16px;
  height: 16px;
  float: left;
  outline: none;
  border: none;
  padding: 0;
}
.rateit .rateit-reset span {
  display: none;
}
.rateit .rateit-range {
  position: relative;
  display: -moz-inline-box;
  display: inline-block;
  height: 16px;
  outline: none;
}
.rateit.rateit-font .rateit-reset {
  width: 0.6em;
  height: 0.6em;
  margin-right: 5px;
  margin-top: 5px;
  background: #dee2e6;
  border-radius: 50%;
  position: relative;
}
.rateit.rateit-font .rateit-reset span {
  display: block;
  height: calc(50% - 0.045em);
  top: 2px;
  position: absolute;
  border-bottom: 2px solid #495057;
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;
}
.rateit.rateit-font .rateit-reset:hover,
.rateit.rateit-font button.rateit-reset:focus {
  background: #f0323c;
}
.rateit.rateit-font .rateit-reset:hover span,
.rateit.rateit-font button.rateit-reset:focus span {
  border-color: #fff;
}

.rateit-font {
  font-size: 24px;
  line-height: 1em;
}
.rateit-font .rateit-range {
  background: none;
  height: auto;
}
.rateit-font .rateit-range > div {
  background: none;
  overflow: hidden;
  cursor: default;
  white-space: nowrap;
}
.rateit-font .rateit-empty {
  color: #cdcdcd;
}

.mfp-image-holder .mfp-close,
.mfp-iframe-holder .mfp-close {
  width: 18px;
  height: 18px;
  background: center center url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat;
  top: 12px;
}

.mfp-arrow:before {
  width: 60px;
  height: 60px;
  opacity: 0.9;
  background: center center url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat;
}
.mfp-arrow:before, .mfp-arrow:after {
  border: none;
}

.mfp-arrow-left {
  left: 1rem;
}

.mfp-arrow-right {
  right: 1rem;
}
.mfp-arrow-right:before {
  background: center center url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat;
}

.mfp-with-zoom .mfp-container,
.mfp-with-zoom.mfp-bg {
  opacity: 0;
  backface-visibility: hidden;
  transition: all 0.3s ease-out;
}

.mfp-with-zoom.mfp-ready .mfp-container {
  opacity: 1;
}

.mfp-with-zoom.mfp-ready.mfp-bg {
  opacity: 0.8;
}

.mfp-with-zoom.mfp-removing .mfp-container,
.mfp-with-zoom.mfp-removing.mfp-bg {
  opacity: 0;
}

.daterangepicker {
  font-family: "Be Vietnam Pro", sans-serif;
  border: 0 solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06);
  background-color: #fff;
}
.daterangepicker .calendar-table {
  border: 1px solid #fff;
  background-color: #fff;
}
.daterangepicker .calendar-table td, .daterangepicker .calendar-table th {
  color: #787878;
}
.daterangepicker .calendar-table .next span,
.daterangepicker .calendar-table .prev span {
  border-color: #adb5bd;
}
.daterangepicker td.in-range {
  background-color: #edeff1;
  color: #495057;
}
.daterangepicker td.off, .daterangepicker td.off.end-date, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date {
  background-color: #fff;
  color: #787878;
  opacity: 0.5;
}
.daterangepicker td.active, .daterangepicker td.active:hover {
  background-color: #0b7f8e;
  color: #fff;
}
.daterangepicker td.available:hover,
.daterangepicker th.available:hover {
  background-color: #0b7f8e;
  color: #fff;
}
.daterangepicker:after {
  border-bottom: 6px solid #fff;
}
.daterangepicker:before {
  border-bottom: 7px solid rgba(0, 0, 0, 0.15);
}
.daterangepicker .ranges li.active {
  background-color: #0b7f8e;
}
.daterangepicker .ranges li:hover {
  background-color: #f3f4f7;
}
.daterangepicker .drp-buttons {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}
.daterangepicker select.ampmselect, .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect {
  background: white;
  border: 1px solid white;
  color: #fff;
}
.daterangepicker.show-ranges .drp-calendar.left {
  border-left: 1px solid rgba(0, 0, 0, 0.15);
}

.leaflet-container {
  font-family: "Be Vietnam Pro", sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
}
.leaflet-container a.leaflet-popup-close-button {
  color: #fff;
  font-size: 1.5rem;
  margin: 7px;
}

.custom-map-marker-popup .leaflet-popup-content-wrapper {
  padding: 0px !important;
}
.custom-map-marker-popup .leaflet-popup-content-wrapper .leaflet-popup-content {
  margin: 0px !important;
}
.custom-map-marker-popup .leaflet-popup-content-wrapper .leaflet-popup-content p {
  margin: inherit;
}

.custom-map-marker {
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #fff;
  color: #495057;
  border-color: #fff;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.275);
}
.custom-map-marker:before {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.275);
}
.custom-map-marker.active {
  background-color: #0b7f8e;
  border-color: #0b7f8e;
  color: #fff;
}
.custom-map-marker.active:before {
  border-top-color: #0b7f8e;
}

.custom-marker-icon {
  text-align: center; /* Horizontally center the text (icon) */
  line-height: 28px; /* Vertically center the text (icon) */
}

.jarallax {
  position: relative;
  z-index: 0;
}

.jarallax > .jarallax-img {
  position: absolute;
  object-fit: cover;
  /* support for plugin https://github.com/bfred-it/object-fit-images */
  font-family: "object-fit: cover;";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

@font-face {
  font-family: "swiper-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-pointer-events {
  touch-action: pan-y;
}
.swiper-pointer-events.swiper-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}
.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

/* 3D Effects */
.swiper-3d, .swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}
.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}
.swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.swiper-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

.swiper-centered > .swiper-wrapper::before {
  content: "";
  flex-shrink: 0;
  order: 9999;
}
.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
  margin-inline-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
  height: 100%;
  width: var(--swiper-centered-offset-after);
}
.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
  margin-block-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-vertical > .swiper-wrapper::before {
  width: 100%;
  height: var(--swiper-centered-offset-after);
}
.swiper-centered > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: center center;
}

:root {
  --swiper-navigation-size: 44px;
  /*
  --swiper-navigation-color: var(--swiper-theme-color);
  */
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(0px - var(--swiper-navigation-size) / 2);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  letter-spacing: 0;
  text-transform: none;
  font-feature-settings: ;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev,
.swiper-rtl .swiper-button-next {
  left: 10px;
  right: auto;
}
.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  content: "prev";
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev {
  right: 10px;
  left: auto;
}
.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: "next";
}

.swiper-button-lock {
  display: none;
}

:root {
  /*
  --swiper-pagination-color: var(--swiper-theme-color);
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-height: 8px;
  --swiper-pagination-bullet-inactive-color: #000;
  --swiper-pagination-bullet-inactive-opacity: 0.2;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bullet-vertical-gap: 6px;
  */
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display: inline-block;
  border-radius: 50%;
  background: var(--swiper-pagination-bullet-inactive-color, #000);
  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
}
button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
.swiper-pagination-bullet:only-child {
  display: none !important;
}

.swiper-pagination-bullet-active {
  opacity: var(--swiper-pagination-bullet-opacity, 1);
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}
.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
  display: block;
}
.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}
.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}
.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}
.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}
.swiper-horizontal > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal, .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
.swiper-vertical > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-vertical, .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-lock {
  display: none;
}

@keyframes closeWindow {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ril__outer {
  background-color: rgba(0, 0, 0, 0.85);
  outline: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  -ms-content-zooming: none;
  -ms-user-select: none;
  -ms-touch-select: none;
  touch-action: none;
}

.ril__outerClosing {
  opacity: 0;
}

.ril__inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.ril__image,
.ril__imagePrev,
.ril__imageNext {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  max-width: none;
  -ms-content-zooming: none;
  -ms-user-select: none;
  -ms-touch-select: none;
  touch-action: none;
}

.ril__imageDiscourager {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.ril__navButtons {
  border: none;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20px;
  height: 34px;
  padding: 40px 30px;
  margin: auto;
  cursor: pointer;
  opacity: 0.7;
}

.ril__navButtons:hover {
  opacity: 1;
}

.ril__navButtons:active {
  opacity: 0.7;
}

.ril__navButtonPrev {
  left: 0;
  background: rgba(0, 0, 0, 0.2) url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat center;
}

.ril__navButtonNext {
  right: 0;
  background: rgba(0, 0, 0, 0.2) url(${___CSS_LOADER_URL_REPLACEMENT_31___}) no-repeat center;
}

.ril__downloadBlocker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-size: cover;
}

.ril__caption,
.ril__toolbar {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
}

.ril__caption {
  bottom: 0;
  max-height: 150px;
  overflow: auto;
}

.ril__captionContent {
  padding: 10px 20px;
  color: #fff;
}

.ril__toolbar {
  top: 0;
  height: 50px;
}

.ril__toolbarSide {
  height: 50px;
  margin: 0;
}

.ril__toolbarLeftSide {
  padding-left: 20px;
  padding-right: 0;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ril__toolbarRightSide {
  padding-left: 0;
  padding-right: 20px;
  flex: 0 0 auto;
}

.ril__toolbarItem {
  display: inline-block;
  line-height: 50px;
  padding: 0;
  color: #fff;
  font-size: 120%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ril__toolbarItemChild {
  vertical-align: middle;
}

.ril__builtinButton {
  width: 40px;
  height: 35px;
  cursor: pointer;
  border: none;
  opacity: 0.7;
}

.ril__builtinButton:hover {
  opacity: 1;
}

.ril__builtinButton:active {
  outline: none;
}

.ril__builtinButtonDisabled {
  cursor: default;
  opacity: 0.5;
}

.ril__builtinButtonDisabled:hover {
  opacity: 0.5;
}

.ril__closeButton {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center;
}

.ril__zoomInButton {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat center;
}

.ril__zoomOutButton {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat center;
}

.ril__outerAnimating {
  animation-name: closeWindow;
}

@keyframes pointFade {
  0%, 19.999%, 100% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
}
.ril__loadingCircle {
  width: 60px;
  height: 60px;
  position: relative;
}

.ril__loadingCirclePoint {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.ril__loadingCirclePoint::before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 11%;
  height: 30%;
  background-color: #fff;
  border-radius: 30%;
  animation: pointFade 800ms infinite ease-in-out both;
}

.ril__loadingCirclePoint:nth-of-type(1) {
  transform: rotate(0deg);
}

.ril__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.ril__loadingCirclePoint:nth-of-type(1)::before,
.ril__loadingCirclePoint:nth-of-type(7)::before {
  animation-delay: -800ms;
}

.ril__loadingCirclePoint:nth-of-type(2) {
  transform: rotate(30deg);
}

.ril__loadingCirclePoint:nth-of-type(8) {
  transform: rotate(210deg);
}

.ril__loadingCirclePoint:nth-of-type(2)::before,
.ril__loadingCirclePoint:nth-of-type(8)::before {
  animation-delay: -666ms;
}

.ril__loadingCirclePoint:nth-of-type(3) {
  transform: rotate(60deg);
}

.ril__loadingCirclePoint:nth-of-type(9) {
  transform: rotate(240deg);
}

.ril__loadingCirclePoint:nth-of-type(3)::before,
.ril__loadingCirclePoint:nth-of-type(9)::before {
  animation-delay: -533ms;
}

.ril__loadingCirclePoint:nth-of-type(4) {
  transform: rotate(90deg);
}

.ril__loadingCirclePoint:nth-of-type(10) {
  transform: rotate(270deg);
}

.ril__loadingCirclePoint:nth-of-type(4)::before,
.ril__loadingCirclePoint:nth-of-type(10)::before {
  animation-delay: -400ms;
}

.ril__loadingCirclePoint:nth-of-type(5) {
  transform: rotate(120deg);
}

.ril__loadingCirclePoint:nth-of-type(11) {
  transform: rotate(300deg);
}

.ril__loadingCirclePoint:nth-of-type(5)::before,
.ril__loadingCirclePoint:nth-of-type(11)::before {
  animation-delay: -266ms;
}

.ril__loadingCirclePoint:nth-of-type(6) {
  transform: rotate(150deg);
}

.ril__loadingCirclePoint:nth-of-type(12) {
  transform: rotate(330deg);
}

.ril__loadingCirclePoint:nth-of-type(6)::before,
.ril__loadingCirclePoint:nth-of-type(12)::before {
  animation-delay: -133ms;
}

.ril__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.ril__loadingCirclePoint:nth-of-type(13) {
  transform: rotate(360deg);
}

.ril__loadingCirclePoint:nth-of-type(7)::before,
.ril__loadingCirclePoint:nth-of-type(13)::before {
  animation-delay: 0ms;
}

.ril__loadingContainer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ril__imagePrev .ril__loadingContainer,
.ril__imageNext .ril__loadingContainer {
  display: none;
}

.ril__errorContainer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.ril__imagePrev .ril__errorContainer,
.ril__imageNext .ril__errorContainer {
  display: none;
}

.ril__loadingContainer__icon {
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

[data-aos][data-aos][data-aos-duration="50"],
body[data-aos-duration="50"] [data-aos] {
  transition-duration: 50ms;
}

[data-aos][data-aos][data-aos-delay="50"],
body[data-aos-delay="50"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="50"].aos-animate,
body[data-aos-delay="50"] [data-aos].aos-animate {
  transition-delay: 50ms;
}

[data-aos][data-aos][data-aos-duration="100"],
body[data-aos-duration="100"] [data-aos] {
  transition-duration: 0.1s;
}

[data-aos][data-aos][data-aos-delay="100"],
body[data-aos-delay="100"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="100"].aos-animate,
body[data-aos-delay="100"] [data-aos].aos-animate {
  transition-delay: 0.1s;
}

[data-aos][data-aos][data-aos-duration="150"],
body[data-aos-duration="150"] [data-aos] {
  transition-duration: 0.15s;
}

[data-aos][data-aos][data-aos-delay="150"],
body[data-aos-delay="150"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="150"].aos-animate,
body[data-aos-delay="150"] [data-aos].aos-animate {
  transition-delay: 0.15s;
}

[data-aos][data-aos][data-aos-duration="200"],
body[data-aos-duration="200"] [data-aos] {
  transition-duration: 0.2s;
}

[data-aos][data-aos][data-aos-delay="200"],
body[data-aos-delay="200"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="200"].aos-animate,
body[data-aos-delay="200"] [data-aos].aos-animate {
  transition-delay: 0.2s;
}

[data-aos][data-aos][data-aos-duration="250"],
body[data-aos-duration="250"] [data-aos] {
  transition-duration: 0.25s;
}

[data-aos][data-aos][data-aos-delay="250"],
body[data-aos-delay="250"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="250"].aos-animate,
body[data-aos-delay="250"] [data-aos].aos-animate {
  transition-delay: 0.25s;
}

[data-aos][data-aos][data-aos-duration="300"],
body[data-aos-duration="300"] [data-aos] {
  transition-duration: 0.3s;
}

[data-aos][data-aos][data-aos-delay="300"],
body[data-aos-delay="300"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="300"].aos-animate,
body[data-aos-delay="300"] [data-aos].aos-animate {
  transition-delay: 0.3s;
}

[data-aos][data-aos][data-aos-duration="350"],
body[data-aos-duration="350"] [data-aos] {
  transition-duration: 0.35s;
}

[data-aos][data-aos][data-aos-delay="350"],
body[data-aos-delay="350"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="350"].aos-animate,
body[data-aos-delay="350"] [data-aos].aos-animate {
  transition-delay: 0.35s;
}

[data-aos][data-aos][data-aos-duration="400"],
body[data-aos-duration="400"] [data-aos] {
  transition-duration: 0.4s;
}

[data-aos][data-aos][data-aos-delay="400"],
body[data-aos-delay="400"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="400"].aos-animate,
body[data-aos-delay="400"] [data-aos].aos-animate {
  transition-delay: 0.4s;
}

[data-aos][data-aos][data-aos-duration="450"],
body[data-aos-duration="450"] [data-aos] {
  transition-duration: 0.45s;
}

[data-aos][data-aos][data-aos-delay="450"],
body[data-aos-delay="450"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="450"].aos-animate,
body[data-aos-delay="450"] [data-aos].aos-animate {
  transition-delay: 0.45s;
}

[data-aos][data-aos][data-aos-duration="500"],
body[data-aos-duration="500"] [data-aos] {
  transition-duration: 0.5s;
}

[data-aos][data-aos][data-aos-delay="500"],
body[data-aos-delay="500"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="500"].aos-animate,
body[data-aos-delay="500"] [data-aos].aos-animate {
  transition-delay: 0.5s;
}

[data-aos][data-aos][data-aos-duration="550"],
body[data-aos-duration="550"] [data-aos] {
  transition-duration: 0.55s;
}

[data-aos][data-aos][data-aos-delay="550"],
body[data-aos-delay="550"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="550"].aos-animate,
body[data-aos-delay="550"] [data-aos].aos-animate {
  transition-delay: 0.55s;
}

[data-aos][data-aos][data-aos-duration="600"],
body[data-aos-duration="600"] [data-aos] {
  transition-duration: 0.6s;
}

[data-aos][data-aos][data-aos-delay="600"],
body[data-aos-delay="600"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="600"].aos-animate,
body[data-aos-delay="600"] [data-aos].aos-animate {
  transition-delay: 0.6s;
}

[data-aos][data-aos][data-aos-duration="650"],
body[data-aos-duration="650"] [data-aos] {
  transition-duration: 0.65s;
}

[data-aos][data-aos][data-aos-delay="650"],
body[data-aos-delay="650"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="650"].aos-animate,
body[data-aos-delay="650"] [data-aos].aos-animate {
  transition-delay: 0.65s;
}

[data-aos][data-aos][data-aos-duration="700"],
body[data-aos-duration="700"] [data-aos] {
  transition-duration: 0.7s;
}

[data-aos][data-aos][data-aos-delay="700"],
body[data-aos-delay="700"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="700"].aos-animate,
body[data-aos-delay="700"] [data-aos].aos-animate {
  transition-delay: 0.7s;
}

[data-aos][data-aos][data-aos-duration="750"],
body[data-aos-duration="750"] [data-aos] {
  transition-duration: 0.75s;
}

[data-aos][data-aos][data-aos-delay="750"],
body[data-aos-delay="750"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="750"].aos-animate,
body[data-aos-delay="750"] [data-aos].aos-animate {
  transition-delay: 0.75s;
}

[data-aos][data-aos][data-aos-duration="800"],
body[data-aos-duration="800"] [data-aos] {
  transition-duration: 0.8s;
}

[data-aos][data-aos][data-aos-delay="800"],
body[data-aos-delay="800"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="800"].aos-animate,
body[data-aos-delay="800"] [data-aos].aos-animate {
  transition-delay: 0.8s;
}

[data-aos][data-aos][data-aos-duration="850"],
body[data-aos-duration="850"] [data-aos] {
  transition-duration: 0.85s;
}

[data-aos][data-aos][data-aos-delay="850"],
body[data-aos-delay="850"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="850"].aos-animate,
body[data-aos-delay="850"] [data-aos].aos-animate {
  transition-delay: 0.85s;
}

[data-aos][data-aos][data-aos-duration="900"],
body[data-aos-duration="900"] [data-aos] {
  transition-duration: 0.9s;
}

[data-aos][data-aos][data-aos-delay="900"],
body[data-aos-delay="900"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="900"].aos-animate,
body[data-aos-delay="900"] [data-aos].aos-animate {
  transition-delay: 0.9s;
}

[data-aos][data-aos][data-aos-duration="950"],
body[data-aos-duration="950"] [data-aos] {
  transition-duration: 0.95s;
}

[data-aos][data-aos][data-aos-delay="950"],
body[data-aos-delay="950"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="950"].aos-animate,
body[data-aos-delay="950"] [data-aos].aos-animate {
  transition-delay: 0.95s;
}

[data-aos][data-aos][data-aos-duration="1000"],
body[data-aos-duration="1000"] [data-aos] {
  transition-duration: 1s;
}

[data-aos][data-aos][data-aos-delay="1000"],
body[data-aos-delay="1000"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1000"].aos-animate,
body[data-aos-delay="1000"] [data-aos].aos-animate {
  transition-delay: 1s;
}

[data-aos][data-aos][data-aos-duration="1050"],
body[data-aos-duration="1050"] [data-aos] {
  transition-duration: 1.05s;
}

[data-aos][data-aos][data-aos-delay="1050"],
body[data-aos-delay="1050"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1050"].aos-animate,
body[data-aos-delay="1050"] [data-aos].aos-animate {
  transition-delay: 1.05s;
}

[data-aos][data-aos][data-aos-duration="1100"],
body[data-aos-duration="1100"] [data-aos] {
  transition-duration: 1.1s;
}

[data-aos][data-aos][data-aos-delay="1100"],
body[data-aos-delay="1100"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1100"].aos-animate,
body[data-aos-delay="1100"] [data-aos].aos-animate {
  transition-delay: 1.1s;
}

[data-aos][data-aos][data-aos-duration="1150"],
body[data-aos-duration="1150"] [data-aos] {
  transition-duration: 1.15s;
}

[data-aos][data-aos][data-aos-delay="1150"],
body[data-aos-delay="1150"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1150"].aos-animate,
body[data-aos-delay="1150"] [data-aos].aos-animate {
  transition-delay: 1.15s;
}

[data-aos][data-aos][data-aos-duration="1200"],
body[data-aos-duration="1200"] [data-aos] {
  transition-duration: 1.2s;
}

[data-aos][data-aos][data-aos-delay="1200"],
body[data-aos-delay="1200"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1200"].aos-animate,
body[data-aos-delay="1200"] [data-aos].aos-animate {
  transition-delay: 1.2s;
}

[data-aos][data-aos][data-aos-duration="1250"],
body[data-aos-duration="1250"] [data-aos] {
  transition-duration: 1.25s;
}

[data-aos][data-aos][data-aos-delay="1250"],
body[data-aos-delay="1250"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1250"].aos-animate,
body[data-aos-delay="1250"] [data-aos].aos-animate {
  transition-delay: 1.25s;
}

[data-aos][data-aos][data-aos-duration="1300"],
body[data-aos-duration="1300"] [data-aos] {
  transition-duration: 1.3s;
}

[data-aos][data-aos][data-aos-delay="1300"],
body[data-aos-delay="1300"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1300"].aos-animate,
body[data-aos-delay="1300"] [data-aos].aos-animate {
  transition-delay: 1.3s;
}

[data-aos][data-aos][data-aos-duration="1350"],
body[data-aos-duration="1350"] [data-aos] {
  transition-duration: 1.35s;
}

[data-aos][data-aos][data-aos-delay="1350"],
body[data-aos-delay="1350"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1350"].aos-animate,
body[data-aos-delay="1350"] [data-aos].aos-animate {
  transition-delay: 1.35s;
}

[data-aos][data-aos][data-aos-duration="1400"],
body[data-aos-duration="1400"] [data-aos] {
  transition-duration: 1.4s;
}

[data-aos][data-aos][data-aos-delay="1400"],
body[data-aos-delay="1400"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1400"].aos-animate,
body[data-aos-delay="1400"] [data-aos].aos-animate {
  transition-delay: 1.4s;
}

[data-aos][data-aos][data-aos-duration="1450"],
body[data-aos-duration="1450"] [data-aos] {
  transition-duration: 1.45s;
}

[data-aos][data-aos][data-aos-delay="1450"],
body[data-aos-delay="1450"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1450"].aos-animate,
body[data-aos-delay="1450"] [data-aos].aos-animate {
  transition-delay: 1.45s;
}

[data-aos][data-aos][data-aos-duration="1500"],
body[data-aos-duration="1500"] [data-aos] {
  transition-duration: 1.5s;
}

[data-aos][data-aos][data-aos-delay="1500"],
body[data-aos-delay="1500"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1500"].aos-animate,
body[data-aos-delay="1500"] [data-aos].aos-animate {
  transition-delay: 1.5s;
}

[data-aos][data-aos][data-aos-duration="1550"],
body[data-aos-duration="1550"] [data-aos] {
  transition-duration: 1.55s;
}

[data-aos][data-aos][data-aos-delay="1550"],
body[data-aos-delay="1550"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1550"].aos-animate,
body[data-aos-delay="1550"] [data-aos].aos-animate {
  transition-delay: 1.55s;
}

[data-aos][data-aos][data-aos-duration="1600"],
body[data-aos-duration="1600"] [data-aos] {
  transition-duration: 1.6s;
}

[data-aos][data-aos][data-aos-delay="1600"],
body[data-aos-delay="1600"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1600"].aos-animate,
body[data-aos-delay="1600"] [data-aos].aos-animate {
  transition-delay: 1.6s;
}

[data-aos][data-aos][data-aos-duration="1650"],
body[data-aos-duration="1650"] [data-aos] {
  transition-duration: 1.65s;
}

[data-aos][data-aos][data-aos-delay="1650"],
body[data-aos-delay="1650"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1650"].aos-animate,
body[data-aos-delay="1650"] [data-aos].aos-animate {
  transition-delay: 1.65s;
}

[data-aos][data-aos][data-aos-duration="1700"],
body[data-aos-duration="1700"] [data-aos] {
  transition-duration: 1.7s;
}

[data-aos][data-aos][data-aos-delay="1700"],
body[data-aos-delay="1700"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1700"].aos-animate,
body[data-aos-delay="1700"] [data-aos].aos-animate {
  transition-delay: 1.7s;
}

[data-aos][data-aos][data-aos-duration="1750"],
body[data-aos-duration="1750"] [data-aos] {
  transition-duration: 1.75s;
}

[data-aos][data-aos][data-aos-delay="1750"],
body[data-aos-delay="1750"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1750"].aos-animate,
body[data-aos-delay="1750"] [data-aos].aos-animate {
  transition-delay: 1.75s;
}

[data-aos][data-aos][data-aos-duration="1800"],
body[data-aos-duration="1800"] [data-aos] {
  transition-duration: 1.8s;
}

[data-aos][data-aos][data-aos-delay="1800"],
body[data-aos-delay="1800"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1800"].aos-animate,
body[data-aos-delay="1800"] [data-aos].aos-animate {
  transition-delay: 1.8s;
}

[data-aos][data-aos][data-aos-duration="1850"],
body[data-aos-duration="1850"] [data-aos] {
  transition-duration: 1.85s;
}

[data-aos][data-aos][data-aos-delay="1850"],
body[data-aos-delay="1850"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1850"].aos-animate,
body[data-aos-delay="1850"] [data-aos].aos-animate {
  transition-delay: 1.85s;
}

[data-aos][data-aos][data-aos-duration="1900"],
body[data-aos-duration="1900"] [data-aos] {
  transition-duration: 1.9s;
}

[data-aos][data-aos][data-aos-delay="1900"],
body[data-aos-delay="1900"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1900"].aos-animate,
body[data-aos-delay="1900"] [data-aos].aos-animate {
  transition-delay: 1.9s;
}

[data-aos][data-aos][data-aos-duration="1950"],
body[data-aos-duration="1950"] [data-aos] {
  transition-duration: 1.95s;
}

[data-aos][data-aos][data-aos-delay="1950"],
body[data-aos-delay="1950"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="1950"].aos-animate,
body[data-aos-delay="1950"] [data-aos].aos-animate {
  transition-delay: 1.95s;
}

[data-aos][data-aos][data-aos-duration="2000"],
body[data-aos-duration="2000"] [data-aos] {
  transition-duration: 2s;
}

[data-aos][data-aos][data-aos-delay="2000"],
body[data-aos-delay="2000"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2000"].aos-animate,
body[data-aos-delay="2000"] [data-aos].aos-animate {
  transition-delay: 2s;
}

[data-aos][data-aos][data-aos-duration="2050"],
body[data-aos-duration="2050"] [data-aos] {
  transition-duration: 2.05s;
}

[data-aos][data-aos][data-aos-delay="2050"],
body[data-aos-delay="2050"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2050"].aos-animate,
body[data-aos-delay="2050"] [data-aos].aos-animate {
  transition-delay: 2.05s;
}

[data-aos][data-aos][data-aos-duration="2100"],
body[data-aos-duration="2100"] [data-aos] {
  transition-duration: 2.1s;
}

[data-aos][data-aos][data-aos-delay="2100"],
body[data-aos-delay="2100"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2100"].aos-animate,
body[data-aos-delay="2100"] [data-aos].aos-animate {
  transition-delay: 2.1s;
}

[data-aos][data-aos][data-aos-duration="2150"],
body[data-aos-duration="2150"] [data-aos] {
  transition-duration: 2.15s;
}

[data-aos][data-aos][data-aos-delay="2150"],
body[data-aos-delay="2150"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2150"].aos-animate,
body[data-aos-delay="2150"] [data-aos].aos-animate {
  transition-delay: 2.15s;
}

[data-aos][data-aos][data-aos-duration="2200"],
body[data-aos-duration="2200"] [data-aos] {
  transition-duration: 2.2s;
}

[data-aos][data-aos][data-aos-delay="2200"],
body[data-aos-delay="2200"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2200"].aos-animate,
body[data-aos-delay="2200"] [data-aos].aos-animate {
  transition-delay: 2.2s;
}

[data-aos][data-aos][data-aos-duration="2250"],
body[data-aos-duration="2250"] [data-aos] {
  transition-duration: 2.25s;
}

[data-aos][data-aos][data-aos-delay="2250"],
body[data-aos-delay="2250"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2250"].aos-animate,
body[data-aos-delay="2250"] [data-aos].aos-animate {
  transition-delay: 2.25s;
}

[data-aos][data-aos][data-aos-duration="2300"],
body[data-aos-duration="2300"] [data-aos] {
  transition-duration: 2.3s;
}

[data-aos][data-aos][data-aos-delay="2300"],
body[data-aos-delay="2300"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2300"].aos-animate,
body[data-aos-delay="2300"] [data-aos].aos-animate {
  transition-delay: 2.3s;
}

[data-aos][data-aos][data-aos-duration="2350"],
body[data-aos-duration="2350"] [data-aos] {
  transition-duration: 2.35s;
}

[data-aos][data-aos][data-aos-delay="2350"],
body[data-aos-delay="2350"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2350"].aos-animate,
body[data-aos-delay="2350"] [data-aos].aos-animate {
  transition-delay: 2.35s;
}

[data-aos][data-aos][data-aos-duration="2400"],
body[data-aos-duration="2400"] [data-aos] {
  transition-duration: 2.4s;
}

[data-aos][data-aos][data-aos-delay="2400"],
body[data-aos-delay="2400"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2400"].aos-animate,
body[data-aos-delay="2400"] [data-aos].aos-animate {
  transition-delay: 2.4s;
}

[data-aos][data-aos][data-aos-duration="2450"],
body[data-aos-duration="2450"] [data-aos] {
  transition-duration: 2.45s;
}

[data-aos][data-aos][data-aos-delay="2450"],
body[data-aos-delay="2450"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2450"].aos-animate,
body[data-aos-delay="2450"] [data-aos].aos-animate {
  transition-delay: 2.45s;
}

[data-aos][data-aos][data-aos-duration="2500"],
body[data-aos-duration="2500"] [data-aos] {
  transition-duration: 2.5s;
}

[data-aos][data-aos][data-aos-delay="2500"],
body[data-aos-delay="2500"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2500"].aos-animate,
body[data-aos-delay="2500"] [data-aos].aos-animate {
  transition-delay: 2.5s;
}

[data-aos][data-aos][data-aos-duration="2550"],
body[data-aos-duration="2550"] [data-aos] {
  transition-duration: 2.55s;
}

[data-aos][data-aos][data-aos-delay="2550"],
body[data-aos-delay="2550"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2550"].aos-animate,
body[data-aos-delay="2550"] [data-aos].aos-animate {
  transition-delay: 2.55s;
}

[data-aos][data-aos][data-aos-duration="2600"],
body[data-aos-duration="2600"] [data-aos] {
  transition-duration: 2.6s;
}

[data-aos][data-aos][data-aos-delay="2600"],
body[data-aos-delay="2600"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2600"].aos-animate,
body[data-aos-delay="2600"] [data-aos].aos-animate {
  transition-delay: 2.6s;
}

[data-aos][data-aos][data-aos-duration="2650"],
body[data-aos-duration="2650"] [data-aos] {
  transition-duration: 2.65s;
}

[data-aos][data-aos][data-aos-delay="2650"],
body[data-aos-delay="2650"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2650"].aos-animate,
body[data-aos-delay="2650"] [data-aos].aos-animate {
  transition-delay: 2.65s;
}

[data-aos][data-aos][data-aos-duration="2700"],
body[data-aos-duration="2700"] [data-aos] {
  transition-duration: 2.7s;
}

[data-aos][data-aos][data-aos-delay="2700"],
body[data-aos-delay="2700"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2700"].aos-animate,
body[data-aos-delay="2700"] [data-aos].aos-animate {
  transition-delay: 2.7s;
}

[data-aos][data-aos][data-aos-duration="2750"],
body[data-aos-duration="2750"] [data-aos] {
  transition-duration: 2.75s;
}

[data-aos][data-aos][data-aos-delay="2750"],
body[data-aos-delay="2750"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2750"].aos-animate,
body[data-aos-delay="2750"] [data-aos].aos-animate {
  transition-delay: 2.75s;
}

[data-aos][data-aos][data-aos-duration="2800"],
body[data-aos-duration="2800"] [data-aos] {
  transition-duration: 2.8s;
}

[data-aos][data-aos][data-aos-delay="2800"],
body[data-aos-delay="2800"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2800"].aos-animate,
body[data-aos-delay="2800"] [data-aos].aos-animate {
  transition-delay: 2.8s;
}

[data-aos][data-aos][data-aos-duration="2850"],
body[data-aos-duration="2850"] [data-aos] {
  transition-duration: 2.85s;
}

[data-aos][data-aos][data-aos-delay="2850"],
body[data-aos-delay="2850"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2850"].aos-animate,
body[data-aos-delay="2850"] [data-aos].aos-animate {
  transition-delay: 2.85s;
}

[data-aos][data-aos][data-aos-duration="2900"],
body[data-aos-duration="2900"] [data-aos] {
  transition-duration: 2.9s;
}

[data-aos][data-aos][data-aos-delay="2900"],
body[data-aos-delay="2900"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2900"].aos-animate,
body[data-aos-delay="2900"] [data-aos].aos-animate {
  transition-delay: 2.9s;
}

[data-aos][data-aos][data-aos-duration="2950"],
body[data-aos-duration="2950"] [data-aos] {
  transition-duration: 2.95s;
}

[data-aos][data-aos][data-aos-delay="2950"],
body[data-aos-delay="2950"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="2950"].aos-animate,
body[data-aos-delay="2950"] [data-aos].aos-animate {
  transition-delay: 2.95s;
}

[data-aos][data-aos][data-aos-duration="3000"],
body[data-aos-duration="3000"] [data-aos] {
  transition-duration: 3s;
}

[data-aos][data-aos][data-aos-delay="3000"],
body[data-aos-delay="3000"] [data-aos] {
  transition-delay: 0;
}

[data-aos][data-aos][data-aos-delay="3000"].aos-animate,
body[data-aos-delay="3000"] [data-aos].aos-animate {
  transition-delay: 3s;
}

[data-aos][data-aos][data-aos-easing=linear],
body[data-aos-easing=linear] [data-aos] {
  transition-timing-function: cubic-bezier(0.25, 0.25, 0.75, 0.75);
}

[data-aos][data-aos][data-aos-easing=ease],
body[data-aos-easing=ease] [data-aos] {
  transition-timing-function: ease;
}

[data-aos][data-aos][data-aos-easing=ease-in],
body[data-aos-easing=ease-in] [data-aos] {
  transition-timing-function: ease-in;
}

[data-aos][data-aos][data-aos-easing=ease-out],
body[data-aos-easing=ease-out] [data-aos] {
  transition-timing-function: ease-out;
}

[data-aos][data-aos][data-aos-easing=ease-in-out],
body[data-aos-easing=ease-in-out] [data-aos] {
  transition-timing-function: ease-in-out;
}

[data-aos][data-aos][data-aos-easing=ease-in-back],
body[data-aos-easing=ease-in-back] [data-aos] {
  transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

[data-aos][data-aos][data-aos-easing=ease-out-back],
body[data-aos-easing=ease-out-back] [data-aos] {
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

[data-aos][data-aos][data-aos-easing=ease-in-out-back],
body[data-aos-easing=ease-in-out-back] [data-aos] {
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

[data-aos][data-aos][data-aos-easing=ease-in-sine],
body[data-aos-easing=ease-in-sine] [data-aos] {
  transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
}

[data-aos][data-aos][data-aos-easing=ease-out-sine],
body[data-aos-easing=ease-out-sine] [data-aos] {
  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
}

[data-aos][data-aos][data-aos-easing=ease-in-out-sine],
body[data-aos-easing=ease-in-out-sine] [data-aos] {
  transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

[data-aos][data-aos][data-aos-easing=ease-in-quad],
body[data-aos-easing=ease-in-quad] [data-aos] {
  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

[data-aos][data-aos][data-aos-easing=ease-out-quad],
body[data-aos-easing=ease-out-quad] [data-aos] {
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

[data-aos][data-aos][data-aos-easing=ease-in-out-quad],
body[data-aos-easing=ease-in-out-quad] [data-aos] {
  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

[data-aos][data-aos][data-aos-easing=ease-in-cubic],
body[data-aos-easing=ease-in-cubic] [data-aos] {
  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

[data-aos][data-aos][data-aos-easing=ease-out-cubic],
body[data-aos-easing=ease-out-cubic] [data-aos] {
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

[data-aos][data-aos][data-aos-easing=ease-in-out-cubic],
body[data-aos-easing=ease-in-out-cubic] [data-aos] {
  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

[data-aos][data-aos][data-aos-easing=ease-in-quart],
body[data-aos-easing=ease-in-quart] [data-aos] {
  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

[data-aos][data-aos][data-aos-easing=ease-out-quart],
body[data-aos-easing=ease-out-quart] [data-aos] {
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

[data-aos][data-aos][data-aos-easing=ease-in-out-quart],
body[data-aos-easing=ease-in-out-quart] [data-aos] {
  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

[data-aos^=fade][data-aos^=fade] {
  opacity: 0;
  transition-property: opacity, transform;
}
[data-aos^=fade][data-aos^=fade].aos-animate {
  opacity: 1;
  transform: translateZ(0);
}

[data-aos=fade-up] {
  transform: translate3d(0, 100px, 0);
}

[data-aos=fade-down] {
  transform: translate3d(0, -100px, 0);
}

[data-aos=fade-right] {
  transform: translate3d(-100px, 0, 0);
}

[data-aos=fade-left] {
  transform: translate3d(100px, 0, 0);
}

[data-aos=fade-up-right] {
  transform: translate3d(-100px, 100px, 0);
}

[data-aos=fade-up-left] {
  transform: translate3d(100px, 100px, 0);
}

[data-aos=fade-down-right] {
  transform: translate3d(-100px, -100px, 0);
}

[data-aos=fade-down-left] {
  transform: translate3d(100px, -100px, 0);
}

[data-aos^=zoom][data-aos^=zoom] {
  opacity: 0;
  transition-property: opacity, transform;
}
[data-aos^=zoom][data-aos^=zoom].aos-animate {
  opacity: 1;
  transform: translateZ(0) scale(1);
}

[data-aos=zoom-in] {
  transform: scale(0.6);
}

[data-aos=zoom-in-up] {
  transform: translate3d(0, 100px, 0) scale(0.6);
}

[data-aos=zoom-in-down] {
  transform: translate3d(0, -100px, 0) scale(0.6);
}

[data-aos=zoom-in-right] {
  transform: translate3d(-100px, 0, 0) scale(0.6);
}

[data-aos=zoom-in-left] {
  transform: translate3d(100px, 0, 0) scale(0.6);
}

[data-aos=zoom-out] {
  transform: scale(1.2);
}

[data-aos=zoom-out-up] {
  transform: translate3d(0, 100px, 0) scale(1.2);
}

[data-aos=zoom-out-down] {
  transform: translate3d(0, -100px, 0) scale(1.2);
}

[data-aos=zoom-out-right] {
  transform: translate3d(-100px, 0, 0) scale(1.2);
}

[data-aos=zoom-out-left] {
  transform: translate3d(100px, 0, 0) scale(1.2);
}

[data-aos^=slide][data-aos^=slide] {
  transition-property: transform;
}
[data-aos^=slide][data-aos^=slide].aos-animate {
  transform: translateZ(0);
}

[data-aos=slide-up] {
  transform: translate3d(0, 100%, 0);
}

[data-aos=slide-down] {
  transform: translate3d(0, -100%, 0);
}

[data-aos=slide-right] {
  transform: translate3d(-100%, 0, 0);
}

[data-aos=slide-left] {
  transform: translate3d(100%, 0, 0);
}

[data-aos^=flip][data-aos^=flip] {
  backface-visibility: hidden;
  transition-property: transform;
}

[data-aos=flip-left] {
  transform: perspective(2500px) rotateY(-100deg);
}
[data-aos=flip-left].aos-animate {
  transform: perspective(2500px) rotateY(0);
}

[data-aos=flip-right] {
  transform: perspective(2500px) rotateY(100deg);
}
[data-aos=flip-right].aos-animate {
  transform: perspective(2500px) rotateY(0);
}

[data-aos=flip-up] {
  transform: perspective(2500px) rotateX(-100deg);
}
[data-aos=flip-up].aos-animate {
  transform: perspective(2500px) rotateX(0);
}

[data-aos=flip-down] {
  transform: perspective(2500px) rotateX(100deg);
}
[data-aos=flip-down].aos-animate {
  transform: perspective(2500px) rotateX(0);
}

@media (min-width: 992px) {
  .sidenav {
    position: fixed;
    top: 7rem;
    height: calc(100vh - 7rem);
    overflow: auto;
  }
  .sidenav-left {
    left: 0;
  }
  .sidenav-right {
    right: 0;
  }
}

.footer .cta-content {
  position: relative;
  top: -90px;
}
.footer .footer-content {
  position: relative;
  z-index: 1;
}
.footer .footer-social-icon .footer-icon-bg {
  background: rgba(255, 255, 255, 0.08);
  display: inline-block;
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  transition: all 0.5s;
}
.footer .footer-social-icon .footer-icon-bg .footer-icon {
  height: 18px;
  width: 18px;
  strokewidth: 1.5px;
  color: #fff;
}
.footer .footer-social-icon .footer-icon-bg:hover {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.1);
}
.footer .footer-submenu li {
  margin: 14px 0;
}
.footer .footer-submenu li .footer-item {
  color: #979797;
  font-size: 14px;
  transition: all 0.3s ease 0s;
}
.footer .footer-submenu li .footer-item:hover {
  color: #0b7f8e;
  padding-left: 6px;
}
.footer .footer-bg-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.03;
}

.icon {
  position: relative;
  width: 3rem;
  height: 3rem;
}
.icon.icon-with-bg {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon > svg {
  width: 3rem;
  height: 3rem;
}

.icon-xxs.feather {
  width: 1rem;
  height: 1rem;
}
.icon-xxs > svg {
  width: 1.25rem;
  height: 1.25rem;
}

.icon-xs.feather {
  width: 1.2rem;
  height: 1.2rem;
}
.icon-xs > svg {
  width: 1.5rem;
  height: 1.5rem;
}

.icon-sm.feather {
  width: 1.8rem;
  height: 1.8rem;
}
.icon-sm > svg {
  width: 2.25rem;
  height: 2.25rem;
}

.icon-md.feather {
  width: 2.4rem;
  height: 2.4rem;
}
.icon-md > svg {
  width: 3rem;
  height: 3rem;
}

.icon-lg.feather {
  width: 3.2rem;
  height: 3.2rem;
}
.icon-lg > svg {
  width: 4rem;
  height: 4rem;
}

.icon-xl.feather {
  width: 4rem;
  height: 4rem;
}
.icon-xl > svg {
  width: 5rem;
  height: 5rem;
}

.icon-xxl.feather {
  width: 4.8rem;
  height: 4.8rem;
}
.icon-xxl > svg {
  width: 6rem;
  height: 6rem;
}

.icon[class*=text-] > svg [fill]:not([fill=none]) {
  fill: currentColor !important;
}

.icon-dual {
  color: #787878;
  fill: rgba(120, 120, 120, 0.12);
}

.icon-dual-primary {
  color: #0b7f8e;
  fill: rgba(11, 127, 142, 0.16);
}
.icon-dual-primary > svg {
  color: #0b7f8e;
  fill: rgba(11, 127, 142, 0.16);
}

.icon-fill-primary {
  fill: #0b7f8e;
}
.icon-fill-primary > svg {
  fill: #0b7f8e;
}

.icon-dual-secondary {
  color: #495057;
  fill: rgba(73, 80, 87, 0.16);
}
.icon-dual-secondary > svg {
  color: #495057;
  fill: rgba(73, 80, 87, 0.16);
}

.icon-fill-secondary {
  fill: #495057;
}
.icon-fill-secondary > svg {
  fill: #495057;
}

.icon-dual-success {
  color: #3cd278;
  fill: rgba(60, 210, 120, 0.16);
}
.icon-dual-success > svg {
  color: #3cd278;
  fill: rgba(60, 210, 120, 0.16);
}

.icon-fill-success {
  fill: #3cd278;
}
.icon-fill-success > svg {
  fill: #3cd278;
}

.icon-dual-info {
  color: #17a2b8;
  fill: rgba(23, 162, 184, 0.16);
}
.icon-dual-info > svg {
  color: #17a2b8;
  fill: rgba(23, 162, 184, 0.16);
}

.icon-fill-info {
  fill: #17a2b8;
}
.icon-fill-info > svg {
  fill: #17a2b8;
}

.icon-dual-warning {
  color: #ffc837;
  fill: rgba(255, 200, 55, 0.16);
}
.icon-dual-warning > svg {
  color: #ffc837;
  fill: rgba(255, 200, 55, 0.16);
}

.icon-fill-warning {
  fill: #ffc837;
}
.icon-fill-warning > svg {
  fill: #ffc837;
}

.icon-dual-danger {
  color: #f0323c;
  fill: rgba(240, 50, 60, 0.16);
}
.icon-dual-danger > svg {
  color: #f0323c;
  fill: rgba(240, 50, 60, 0.16);
}

.icon-fill-danger {
  fill: #f0323c;
}
.icon-fill-danger > svg {
  fill: #f0323c;
}

.icon-dual-light {
  color: #f4f5f7;
  fill: rgba(244, 245, 247, 0.16);
}
.icon-dual-light > svg {
  color: #f4f5f7;
  fill: rgba(244, 245, 247, 0.16);
}

.icon-fill-light {
  fill: #f4f5f7;
}
.icon-fill-light > svg {
  fill: #f4f5f7;
}

.icon-dual-dark {
  color: #343a40;
  fill: rgba(52, 58, 64, 0.16);
}
.icon-dual-dark > svg {
  color: #343a40;
  fill: rgba(52, 58, 64, 0.16);
}

.icon-fill-dark {
  fill: #343a40;
}
.icon-fill-dark > svg {
  fill: #343a40;
}

.icon-dual-orange {
  color: #ff784b;
  fill: rgba(255, 120, 75, 0.16);
}
.icon-dual-orange > svg {
  color: #ff784b;
  fill: rgba(255, 120, 75, 0.16);
}

.icon-fill-orange {
  fill: #ff784b;
}
.icon-fill-orange > svg {
  fill: #ff784b;
}

.icon-dual-teal {
  color: #20c997;
  fill: rgba(32, 201, 151, 0.16);
}
.icon-dual-teal > svg {
  color: #20c997;
  fill: rgba(32, 201, 151, 0.16);
}

.icon-fill-teal {
  fill: #20c997;
}
.icon-fill-teal > svg {
  fill: #20c997;
}

.icon-dual-gray-50 {
  color: #fefefe;
  fill: rgba(254, 254, 254, 0.16);
}
.icon-dual-gray-50 > svg {
  color: #fefefe;
  fill: rgba(254, 254, 254, 0.16);
}

.icon-fill-gray-50 {
  fill: #fefefe;
}
.icon-fill-gray-50 > svg {
  fill: #fefefe;
}

.icon-left-arrow,
.icon-right-arrow {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
}
.icon-left-arrow.icon-xxs,
.icon-right-arrow.icon-xxs {
  width: 1.25rem;
  height: 1.25rem;
}
.icon-left-arrow.icon-xs,
.icon-right-arrow.icon-xs {
  width: 1.5rem;
  height: 1.5rem;
}
.icon-left-arrow.icon-sm,
.icon-right-arrow.icon-sm {
  width: 2.25rem;
  height: 2.25rem;
}
.icon-left-arrow.icon-md,
.icon-right-arrow.icon-md {
  width: 3rem;
  height: 3rem;
}
.icon-left-arrow.icon-lg,
.icon-right-arrow.icon-lg {
  width: 4rem;
  height: 4rem;
}
.icon-left-arrow.icon-xl,
.icon-right-arrow.icon-xl {
  width: 5rem;
  height: 5rem;
}
.icon-left-arrow.icon-xxl,
.icon-right-arrow.icon-xxl {
  width: 6rem;
  height: 6rem;
}

.icon-left-arrow {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.icon-right-arrow {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #0b7f8e;
  color: #fff;
  display: flex;
  font-weight: 600;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
}
.avatar-group .avatar-group-item {
  margin: 0 0 10px -12px;
  display: inline-block;
}

.avatar-border {
  box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06) !important;
  border: 2px solid #fff !important;
}

.ribbon {
  position: absolute;
  padding-left: 0.5rem;
  padding-right: 1.4rem;
  clip-path: polygon(100% 0, 90% 50%, 100% 100%, 0 100%, 0 50%, 0 0);
  top: 1rem;
  left: 0px;
  color: #fff;
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 600;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  border-bottom-right-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.ribbon-primary {
  background: #0b7f8e;
}
.ribbon-primary:before {
  border-color: #096a76;
}

.ribbon-secondary {
  background: #495057;
}
.ribbon-secondary:before {
  border-color: #3d4349;
}

.ribbon-success {
  background: #3cd278;
}
.ribbon-success:before {
  border-color: #2ec76b;
}

.ribbon-info {
  background: #17a2b8;
}
.ribbon-info:before {
  border-color: #148ea1;
}

.ribbon-warning {
  background: #ffc837;
}
.ribbon-warning:before {
  border-color: #ffc11e;
}

.ribbon-danger {
  background: #f0323c;
}
.ribbon-danger:before {
  border-color: #ee1a25;
}

.ribbon-light {
  background: #f4f5f7;
}
.ribbon-light:before {
  border-color: #e5e8ec;
}

.ribbon-dark {
  background: #343a40;
}
.ribbon-dark:before {
  border-color: #292d32;
}

.ribbon-orange {
  background: #ff784b;
}
.ribbon-orange:before {
  border-color: #ff6532;
}

.ribbon-teal {
  background: #20c997;
}
.ribbon-teal:before {
  border-color: #1cb386;
}

.ribbon-gray-50 {
  background: #fefefe;
}
.ribbon-gray-50:before {
  border-color: #eff1f4;
}

.ribbon2 {
  padding: 2px 60px;
  transform: rotate(45deg);
  position: absolute;
  top: 16px;
  right: -56px;
}

.ribbon2-primary {
  background: #0b7f8e;
}
.ribbon2-primary:before {
  border-color: #096a76;
}

.ribbon2-secondary {
  background: #495057;
}
.ribbon2-secondary:before {
  border-color: #3d4349;
}

.ribbon2-success {
  background: #3cd278;
}
.ribbon2-success:before {
  border-color: #2ec76b;
}

.ribbon2-info {
  background: #17a2b8;
}
.ribbon2-info:before {
  border-color: #148ea1;
}

.ribbon2-warning {
  background: #ffc837;
}
.ribbon2-warning:before {
  border-color: #ffc11e;
}

.ribbon2-danger {
  background: #f0323c;
}
.ribbon2-danger:before {
  border-color: #ee1a25;
}

.ribbon2-light {
  background: #f4f5f7;
}
.ribbon2-light:before {
  border-color: #e5e8ec;
}

.ribbon2-dark {
  background: #343a40;
}
.ribbon2-dark:before {
  border-color: #292d32;
}

.ribbon2-orange {
  background: #ff784b;
}
.ribbon2-orange:before {
  border-color: #ff6532;
}

.ribbon2-teal {
  background: #20c997;
}
.ribbon2-teal:before {
  border-color: #1cb386;
}

.ribbon2-gray-50 {
  background: #fefefe;
}
.ribbon2-gray-50:before {
  border-color: #eff1f4;
}

.header-1 {
  position: relative;
}
.header-1::before {
  content: "";
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgba(11, 127, 142, 0.07) 0%, rgba(11, 127, 142, 0.05) 100%) no-repeat left center;
  background-size: calc(1240px + (100vw - 1240px) / 2) 100%;
  transform: skewY(-6deg);
  transform-origin: top left;
}
@media (max-width: 768px) {
  .header-1::before {
    background-size: 100% 100%;
  }
}

.header-2 {
  position: relative;
}
.header-2::before {
  content: "";
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgb(255, 255, 255) 0%, rgba(255, 200, 55, 0.05) 100%) no-repeat left center;
  background-size: calc(1240px + (100vw - 1240px) / 2) 100%;
  transform: skewY(3deg);
  transform-origin: top left;
}
.header-2.primary {
  padding-bottom: 5rem;
}
.header-2.primary::before {
  top: -6rem;
  background: linear-gradient(#f4f5f7 0%, #fafafb 100%) no-repeat left center;
  background-size: calc(1240px + (100vw - 1240px) / 2) 100%;
}
@media (max-width: 768px) {
  .header-2::before {
    background-size: 100% 100%;
  }
}

.header-3 {
  position: relative;
}
.header-3::before {
  content: "";
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgba(11, 127, 142, 0.07) 0%, rgba(11, 127, 142, 0.05) 100%) no-repeat right center;
}
@media (max-width: 768px) {
  .header-3::before {
    background-size: 100% 100%;
  }
}

.header-4 {
  position: relative;
}
.header-4::before {
  content: "";
  width: calc(100% - 60px);
  height: 100%;
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgba(255, 200, 55, 0.05) 0%, rgba(255, 200, 55, 0.07) 100%) no-repeat left center;
}

.header-5 {
  position: relative;
}
.header-5::before {
  content: "";
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgba(255, 120, 75, 0.05) 0%, rgba(255, 120, 75, 0.07) 100%) no-repeat left center;
}
@media (max-width: 768px) {
  .header-5::before {
    background-size: 100% 100%;
  }
}

.header-6 {
  position: relative;
}
.header-6::before {
  content: "";
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgba(255, 120, 75, 0.075) 0%, rgba(255, 200, 55, 0.1) 100%) no-repeat left center;
}

.header-7 {
  position: relative;
}
.header-7::before {
  content: "";
  display: block;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
  bottom: 0;
  background: linear-gradient(rgba(244, 245, 247, 0.25) 0%, rgba(244, 245, 247, 0.4) 100%) no-repeat right center;
}
.header-7 .overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(33, 37, 41, 0.25);
}

.hero-title {
  font-size: 3rem;
  line-height: 1.3;
  font-weight: 600;
}
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.6rem;
    line-height: 1.1;
  }
}
@media (max-width: 576px) {
  .hero-title {
    font-size: 2rem !important;
  }
}

.hero-1 {
  position: relative;
}
.hero-1 .slider {
  position: absolute;
  width: 320px;
  height: 240px;
  z-index: 10;
  bottom: 1rem;
  left: -15rem;
}
.hero-1 .slider .swiper-initialized {
  z-index: 100 !important;
  height: 100%;
  width: 100%;
}
.hero-1 .slider .swiper-initialized .swiper-slide .swiper-slide-content {
  max-width: 280px;
  text-align: left;
  padding-top: 2rem;
  position: relative;
}
.hero-1 .hero-container {
  position: relative;
}
.hero-1 .hero-container .hero-img {
  position: relative;
}
.hero-1 .hero-container .hero-img img {
  position: relative;
  z-index: 2;
}
.hero-1 .hero-container .hero-img::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 6rem;
  height: 6rem;
  position: absolute;
  bottom: 4rem;
  left: 0rem;
  z-index: 0;
}
.hero-1 .hero-container .hero-img::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 8rem;
  height: 8rem;
  position: absolute;
  top: 0rem;
  right: 0rem;
  z-index: 0;
}
.hero-1 .hero-container .quote {
  position: relative;
}
.hero-1 .hero-container .quote::before {
  font-size: 6rem;
  line-height: 0rem;
  color: rgba(240, 50, 60, 0.2);
  z-index: 0;
  content: "”";
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  position: absolute;
  bottom: 0;
  right: 0;
}
.hero-1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 22%;
  z-index: -2;
  background: linear-gradient(#f4f5f7 0%, #fafafb 100%);
}
@media (max-width: 768px) {
  .hero-1 .slider {
    display: none;
  }
  .hero-1 .hero-container::before, .hero-1 .hero-container::after {
    display: none;
  }
  .hero-1 .hero-container .action-buttons {
    justify-content: center !important;
  }
}

.hero-2 {
  height: 700px;
}
@media (max-width: 1024px) {
  .hero-2 {
    height: 700px;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .hero-2 {
    height: 48vh;
  }
}
.hero-2 .slider {
  position: relative;
}
.hero-2 .slider .form-container {
  position: absolute;
  top: 0rem;
  width: 100%;
  height: auto;
  z-index: 2;
  left: 0;
  right: 0;
}
.hero-2 .slider .navigations .swiper-custom-prev,
.hero-2 .slider .navigations .swiper-custom-next {
  padding: 0.15rem 0.3rem;
  line-height: 1.25;
  border-radius: 0.15rem;
}
.hero-2 .slider .slider-item {
  position: relative;
  height: 520px;
  background-size: cover;
}

@media (max-width: 768px) {
  .hero-2 .slider {
    position: relative;
  }
  .hero-2 .slider .form-container {
    position: absolute;
    top: -1rem;
    width: 100%;
    height: auto;
    z-index: 2;
    left: 0;
    right: 0;
  }
  .hero-2 .slider .navigations .swiper-custom-prev,
  .hero-2 .slider .navigations .swiper-custom-next {
    padding: 0.15rem 0.3rem;
    line-height: 1.25;
    border-radius: 0.15rem;
  }
  .hero-2 .slider .slider-item {
    position: relative;
    height: 240px;
    background-size: cover;
  }
}
@media (max-width: 1024px) {
  .hero-2 {
    height: auto;
    padding: 50px 0 0;
  }
}
@keyframes rotating {
  0% {
    transform: rotate(0deg);
    top: 10%;
    left: 5%;
  }
  100% {
    transform: rotate(360deg);
    top: 60%;
    left: 15%;
  }
}
@keyframes rotating2 {
  0% {
    transform: rotate(0deg);
    bottom: 10%;
    right: 10%;
  }
  100% {
    transform: rotate(360deg);
    bottom: 80%;
    right: 30%;
  }
}
@keyframes rotating3 {
  0% {
    transform: rotate(0deg);
    bottom: 0%;
    right: 65%;
  }
  100% {
    transform: rotate(360deg);
    bottom: 50%;
    right: 35%;
  }
}
.hero-with-shapes .shape1 {
  position: absolute;
  top: 5%;
  left: 5%;
  width: 7rem;
  height: 7rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  animation: rotating alternate ease-in-out infinite 6s;
}
.hero-with-shapes .shape2 {
  position: absolute;
  bottom: 20%;
  right: 10%;
  width: 7rem;
  height: 7rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  animation: rotating2 alternate ease-in-out infinite 6s;
}
.hero-with-shapes .shape3 {
  position: absolute;
  bottom: 0%;
  right: 65%;
  width: 7rem;
  height: 7rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  animation: rotating3 alternate ease-in-out infinite 6s;
}

.hero-3 .shape1 {
  position: absolute;
  bottom: 5%;
  left: 5%;
  width: 7rem;
  height: 7rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.hero-3 .shape2 {
  position: absolute;
  top: 40%;
  right: 10%;
  width: 7rem;
  height: 7rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.hero-3 .shape3 {
  position: absolute;
  top: 5%;
  right: 50%;
  width: 7rem;
  height: 7rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.hero-3 .img-container {
  position: relative;
}
.hero-3 .img-container img {
  position: relative;
  z-index: 1;
}

@media (max-width: 768px) {
  .hero-3 .img-container {
    margin-top: 1rem;
  }
  .hero-3 .img-container::before {
    left: 0;
    top: 0;
    height: 100%;
  }
}
.hero-5 {
  height: 65vh;
}
.hero-5 .links-social {
  position: absolute;
  top: 10%;
  right: 0px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

@media (max-width: 576px) {
  .hero-5 .shape.bottom {
    bottom: -5px;
  }
}
@media (max-width: 1024px) {
  .hero-5 {
    height: auto;
  }
}
.hero-6 {
  position: relative;
}
.hero-6::before {
  content: "";
  position: absolute;
  top: -12rem;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -2;
  background: linear-gradient(rgba(255, 120, 75, 0.02) 0, rgba(255, 120, 75, 0.03) 100%);
  transform: skewY(3deg);
  transform-origin: top left;
}
.hero-6 .shapes {
  position: relative;
  height: 100%;
}
.hero-6 .shapes .shape1 {
  position: absolute;
  bottom: 1%;
  left: 2%;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  border: 5px solid rgba(240, 50, 60, 0.3);
  background: transparent;
}
.hero-6 .shapes .shape2 {
  position: absolute;
  top: 50%;
  right: 20%;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  border: 5px solid rgba(255, 200, 55, 0.3);
  background: transparent;
}
.hero-6 .video-container .video-item {
  padding: 1rem 0 1rem 1rem;
  position: relative;
  width: 100%;
}
.hero-6 .video-container .video-item img {
  position: relative;
  z-index: 2;
  border-top-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.hero-6 .video-container .video-item .video-overlay {
  background: rgba(255, 255, 255, 0.1);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 3;
}
.hero-6 .video-container .video-item::before {
  position: absolute;
  width: calc(100% - 3rem);
  height: calc(100% - 2rem);
  top: 2rem;
  content: "";
  border: 2px dashed #ff784b;
  z-index: 1;
  left: 0rem;
  border-bottom-left-radius: 2.15rem;
  border-top-right-radius: 2.15rem;
}

@media (max-width: 768px) {
  .hero-6 .hero-sub-title {
    font-size: 14px !important;
    text-align: left;
  }
  .hero-6 .video-container {
    width: 100%;
  }
  .hero-6 .video-container .video-item {
    width: 100%;
    padding: 1rem 0 1rem 0rem;
  }
  .hero-6 .video-container .video-item::before {
    display: none;
  }
}
.hero-7 .hero-right .img-container {
  position: relative;
  padding: 0.6rem;
  z-index: 1;
  background: #fff;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  border-radius: 0.5rem;
  min-width: 150%;
}
.hero-7 .hero-right .img-container img {
  max-width: 100%;
  position: relative;
  z-index: 1;
}
.hero-7 .hero-right::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  width: 8rem;
  height: 8rem;
  position: absolute;
  bottom: -2.25rem;
  left: -2.25rem;
  z-index: 0;
}

@media (max-width: 1024px) {
  .hero-7 .hero-right .img-container {
    min-width: 100%;
  }
}
.hero-9 {
  position: relative;
}
.hero-9 .hero-top {
  position: relative;
  text-align: center;
  overflow: hidden;
}
.hero-9 .hero-top::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  position: absolute;
  width: 4rem;
  height: 4rem;
  right: -1rem;
  bottom: -1rem;
  transform: rotate(45deg);
}
.hero-9 .hero-cta {
  text-align: center;
  padding: 0;
  position: absolute;
  display: block;
  transform: translate3d(0, -50%, 0);
  left: 1rem;
  right: 1rem;
  margin: auto;
  z-index: 5;
}
.hero-9 .hero-cta .btn-cta {
  width: 18%;
  text-transform: uppercase;
  font-weight: 600;
}
.hero-9 .hero-bottom {
  position: relative;
}
.hero-9 .hero-bottom .hero-image {
  height: 560px;
}

@media (max-width: 768px) {
  .hero-9 .hero-cta .btn-cta {
    width: 75%;
  }
  .hero-9 .hero-bottom .hero-image {
    height: 260px;
  }
}
.hero-10 .img-container {
  position: relative;
  min-width: 140%;
  margin-left: -40%;
}
.hero-10 .img-container img {
  z-index: 1;
  position: relative;
}
@media (max-width: 768px) {
  .hero-10 .img-container {
    min-width: 100%;
    margin-left: 0;
  }
}

.hero-11 {
  position: relative;
}
.hero-11::before {
  background: linear-gradient(#f3f4f7 0%, #f4f5f7 100%) no-repeat left center;
  position: absolute;
  top: 0;
  bottom: 40%;
  left: 0;
  right: 0;
  content: "";
}
.hero-11 .hero-content {
  position: relative;
}
.hero-11 .slider-container {
  position: relative;
}
.hero-11 .slider-container .slider-container-body {
  position: relative;
  padding: 0.75rem;
  z-index: 1;
}
.hero-11 .slider-container::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 6rem;
  height: 6rem;
  position: absolute;
  top: -2.5rem;
  right: 4rem;
  z-index: 0;
}
.hero-11 .swiper-slide-content {
  position: relative;
}
.hero-11 .swiper-slide-content .video-overlay {
  background: rgba(255, 255, 255, 0.1);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
}

.hero-12 {
  height: 640px;
}
.hero-12 .hero-image {
  position: relative;
}
.hero-12 .hero-image img {
  position: relative;
  z-index: 1;
}
.hero-12 .hero-image::before, .hero-12 .hero-image::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 8rem;
  height: 8rem;
  position: absolute;
  z-index: 0;
}
.hero-12 .hero-image::before {
  bottom: 2rem;
}
@media (max-width: 768px) {
  .hero-12 .hero-image::before {
    top: 6rem;
  }
}
.hero-12 .hero-image::after {
  top: -2rem;
  right: 8rem;
}
@media (max-width: 768px) {
  .hero-12 .hero-image::after {
    display: none;
  }
}

.hero-13 .hero-right .slider-container {
  position: relative;
}
.hero-13 .hero-right .slider-container .slider-container-body {
  position: relative;
  padding: 0.5rem;
  z-index: 1;
}
.hero-13 .hero-right .slider-container::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 8rem;
  height: 8rem;
  position: absolute;
  top: -3rem;
  right: 3rem;
  z-index: 0;
}
.hero-13 .hero-right .swiper-slide-content {
  position: relative;
}
.hero-13 .hero-right .swiper-slide-content .video-overlay {
  background: rgba(255, 255, 255, 0.05);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
}
.hero-13 .hero-right .img-container {
  position: relative;
  padding: 0.3rem;
  z-index: 1;
  background: #fff;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08);
  border-radius: 0.5rem;
  min-width: 160%;
}
.hero-13 .hero-right::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  width: 6rem;
  height: 6rem;
  position: absolute;
  bottom: -2rem;
  left: -2rem;
  z-index: 0;
}
.hero-13 .hero-right::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 6rem;
  height: 6rem;
  position: absolute;
  top: -2.5rem;
  right: -6rem;
  transform: rotate(45deg);
  z-index: 0;
}

@media (max-width: 1024px) {
  .hero-13 .hero-right .img-container {
    min-width: 100%;
  }
  .hero-13 .hero-right::after {
    right: 2rem;
  }
}
.features-1 .img-content {
  position: relative;
}
.features-1 .img-content::before {
  content: "";
  background: linear-gradient(rgba(255, 120, 75, 0.1) 0, rgba(255, 120, 75, 0.15) 100%);
  width: 65%;
  height: 60%;
  position: absolute;
  bottom: 3rem;
  right: 5rem;
  z-index: -1;
  border-radius: 3rem;
  transform: rotate(20deg);
}
.features-1 .img-content::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  width: 100%;
  height: 100%;
  position: absolute;
  top: -3rem;
  right: 3rem;
  z-index: -1;
}
.features-1 .img-content .img-up {
  max-width: 80%;
}

@media (max-width: 768px) {
  .features-1 .img-content .img-up {
    max-width: 90%;
  }
}
.features-2 .shapes {
  position: relative;
}
.features-2 .shapes .shape1 {
  position: absolute;
  top: 30%;
  right: 3%;
  background: #0fa9bd;
  height: 0.6rem;
  width: 0.6rem;
  border-radius: 100%;
}
.features-2 .shapes .shape2 {
  position: absolute;
  bottom: 20%;
  left: 3%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 10.4px 6px 0;
  border-color: transparent #65dc95 transparent transparent;
}
.features-2 .shapes .shape3 {
  position: absolute;
  bottom: 5%;
  left: 5%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 10.4px 6px 0;
  border-color: transparent #f36269 transparent transparent;
}
.features-2 .shapes .shape4 {
  position: absolute;
  top: 35%;
  right: 30%;
  background: #ffd66a;
  height: 0.6rem;
  width: 0.6rem;
  border-radius: 100%;
}
.features-2 .shapes .shape5 {
  position: absolute;
  bottom: 5%;
  right: 5%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0 6px 10.4px;
  border-color: transparent transparent transparent #ffd66a;
}
.features-2 .shapes .shape6 {
  position: absolute;
  bottom: 40%;
  left: 5%;
  width: 10px;
  height: 10px;
  background: rgba(0, 0, 0, 0);
  border-radius: 100%;
  border: 1.5px solid #12d4ed;
  box-sizing: content-box;
}

.features-3 .img-content {
  position: relative;
}
.features-3 .img-content::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  top: -2rem;
  left: -2rem;
  z-index: -1;
}
.features-3 .img-content::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  bottom: -2rem;
  right: -2rem;
  z-index: -1;
}
.features-3 .img-content2 {
  position: relative;
}
.features-3 .img-content2::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  top: -2rem;
  right: -2rem;
  z-index: -1;
}
.features-3 .img-content2::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  bottom: -2rem;
  left: -2rem;
  z-index: -1;
}

@media (max-width: 768px) {
  .features-3 .img-content .img-up,
  .features-3 .img-content2 .img-up {
    margin: 0 auto;
    max-width: 90%;
  }
  .features-3 .img-content::after {
    right: 0rem;
  }
  .features-3 .img-content::before {
    left: 0rem;
  }
  .features-3 .img-content2::after {
    left: 0rem;
  }
  .features-3 .img-content2::before {
    right: 0rem;
  }
}
.features-4 .img-content img {
  border: 10px solid #fff;
}
.features-4 .img-content:after {
  content: "";
  background: linear-gradient(rgba(60, 210, 120, 0.1) 0, rgba(60, 210, 120, 0.15) 100%);
  position: absolute;
  border-radius: 70% 30% 76% 24%/68% 30% 73% 22%;
  top: -20px;
  bottom: -20px;
  height: 120%;
  width: 70%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: -1;
}
.features-4 .feature-content {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -100px;
}

@media (max-width: 768px) {
  .features-4 .feature-content {
    position: relative;
    top: 0;
    transform: none;
    left: 0;
  }
}
.features-5 .feature-item:hover {
  transition: box-shadow 0.25s ease-in-out 0.15s;
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08) !important;
}

.features-6 .feature-item {
  transition: all 0.3s ease-in-out;
  position: relative;
}
.features-6 .feature-item .overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
}
.features-6 .feature-item .btn-view {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
.features-6 .feature-item:hover {
  box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06) !important;
}
.features-6 .feature-item:hover .overlay {
  opacity: 1;
}

.features-7 .feature-item .number {
  position: absolute;
  top: 0;
  z-index: -1;
  opacity: 0.3;
}

.features-8 .feature-content {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 400px;
  z-index: 1;
}
.features-8 .feature-content .feature-text {
  position: relative;
  z-index: 1;
}
.features-8 .feature-content::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  bottom: -2rem;
  left: -2rem;
  z-index: -1;
}
.features-8 .feature-img .overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.25);
  z-index: 0;
}
.features-8 .feature-img::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  top: -2rem;
  right: -2rem;
  z-index: -1;
}
.features-8 .feature-img img {
  position: relative;
  z-index: -1;
  width: 85%;
}
@media (max-width: 576px) {
  .features-8 .feature-content {
    position: relative;
    top: 0;
    transform: none;
    max-width: 100%;
  }
  .features-8 .feature-content::after {
    left: -0.5rem;
  }
  .features-8 .feature-img img {
    width: 100%;
  }
  .features-8 .feature-img::before {
    right: -0.5rem;
  }
}

.features-9 .feature-item {
  transition: all 0.25s ease-in-out 0.15s;
}
.features-9 .feature-item .icon {
  border-bottom-left-radius: 0.75rem !important;
  border-top-right-radius: 0.75rem !important;
  transition: all 0.25s ease-in-out 0.15s;
}
.features-9 .feature-item:hover {
  box-shadow: 0 0.8rem 1.2rem rgba(52, 58, 64, 0.08) !important;
}
.features-9 .feature-item:hover .icon {
  border-top-left-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.testimonials-1 .slider {
  position: relative;
}
.testimonials-1 .slider::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 6rem;
  height: 6rem;
  position: absolute;
  bottom: -2.5rem;
  left: -2.5rem;
  z-index: 0;
}
.testimonials-1 .slider::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 6rem;
  height: 6rem;
  position: absolute;
  top: -2.5rem;
  right: -2.5rem;
  z-index: 0;
  transform: rotate(90deg);
}

@media (max-width: 768px) {
  .testimonials-1 .slider::after {
    display: none;
  }
}
.testimonials-2 .slider,
.testimonials-3 .slider {
  position: relative;
}
.testimonials-2 .slider .swiper-slide .img-author,
.testimonials-3 .slider .swiper-slide .img-author {
  max-height: 300px;
}
.testimonials-2 .slider::before,
.testimonials-3 .slider::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  bottom: -2.25rem;
  left: -2.25rem;
  z-index: 0;
}
.testimonials-2 .slider::after,
.testimonials-3 .slider::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  width: 5rem;
  height: 5rem;
  position: absolute;
  top: -2.25rem;
  right: -2.25rem;
  z-index: 0;
}
.testimonials-2 .slider .testimonial-body,
.testimonials-3 .slider .testimonial-body {
  padding: 2rem;
}
.testimonials-2 .slider .quotation-mark,
.testimonials-3 .slider .quotation-mark {
  font-weight: 700;
  font-size: 6rem;
  font-family: "Times New Roman", Georgia, Serif;
  line-height: 0.7;
}

@media (max-width: 768px) {
  .testimonials-2 .slider::after,
  .testimonials-3 .slider::after {
    display: none;
  }
}
.testimonials-3 .slider::before, .testimonials-3 .slider::after {
  background: none;
}

.testimonials-4 .client-img {
  background-size: cover;
  background-repeat: no-repeat;
}
.testimonials-4 .quotation-mark {
  font-weight: 700;
  font-size: 8rem;
  font-family: "Times New Roman", Georgia, Serif;
  line-height: 0.7;
}
.testimonials-4 .navigations {
  position: absolute;
  right: 10px;
  bottom: 25px;
  z-index: 1;
}

.code-block {
  position: relative;
  border: 1px solid #dee2e6 !important;
  padding: 1rem 1rem;
  background: #fff;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}
.code-block h6, .code-block .h6 {
  margin-top: 0px;
}
.code-block .prettyprint {
  background: #f4f5f7;
  border: none;
  padding: 1rem 1rem;
  margin-bottom: 0px;
}
.code-block .btn-copy-clipboard {
  position: absolute;
  top: 10px;
  right: 10px;
}

.doc-carousel .carousel-item {
  height: 400px;
}
.doc-carousel .carousel-item img {
  height: 400px;
  position: absolute;
  object-fit: cover;
  top: 0;
  left: 0;
}

.filter-menu .filter-menu-item {
  display: inline-block;
  font-weight: 500;
  color: #495057;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  font-size: 0.8203125rem;
  margin: 4px 2px;
  border-color: #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.filter-menu .filter-menu-item.active {
  color: #fff !important;
  background-color: #0b7f8e !important;
  border-color: #0b7f8e !important;
}
.filter-menu .filter-menu-item:focus, .filter-menu .filter-menu-item.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(11, 127, 142, 0.25);
}
.filter-menu .filter-menu-item.disabled, .filter-menu .filter-menu-item:disabled {
  opacity: 0.65;
}
.filter-menu .filter-menu-item:hover, .filter-menu .filter-menu-item:focus {
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(60, 72, 88, 0.15), 0 2px 4px 2px rgba(60, 72, 88, 0.18);
}

.masonry-grid {
  position: relative;
  padding: 0;
  margin: 0;
  opacity: 0;
  transition: height 0.3s ease-out, opacity 0.3s ease-out 0.3s;
}
.masonry-grid [data-masonry-el] {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
}

.filter-menu {
  margin-bottom: 20px;
}
.filter-menu a {
  transition: all 0.3s ease-out;
  color: #343a40;
  border-radius: 3px;
  padding: 5px 10px;
  display: inline-block;
  margin-bottom: 5px;
  font-weight: 500;
  font-family: "Be Vietnam Pro", sans-serif;
}
.filter-menu a:hover {
  background-color: rgba(11, 127, 142, 0.15);
  color: #0b7f8e;
}
.filter-menu a.active {
  background-color: #0b7f8e;
  color: #fff;
}

.gal-box {
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 7px 14px 0 rgba(52, 58, 64, 0.06);
  margin-bottom: 1.5rem;
}
.gal-box .image-popup {
  padding: 10px;
  display: block;
}
.gal-box .image-popup img {
  cursor: zoom-in;
}
.gal-box .gall-info {
  padding: 15px;
  border-top: 1px solid #f3f4f7;
  position: relative;
}
.gal-box .gall-info h4, .gal-box .gall-info .h4 {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gal-box .gall-info .gal-like-btn {
  position: absolute;
  right: 15px;
  font-size: 22px;
  top: 24px;
}

.ReactModal__Body--open .ReactModalPortal > div {
  z-index: 1031 !important;
}
.ReactModal__Body--open .ril-toolbar {
  align-items: center;
}
.ReactModal__Body--open .ril-toolbar .ril-toolbar__item__child p {
  margin-bottom: 0;
  line-height: 2.6;
}

#ppic .react-datepicker-wrapper {
  display: none;
}
#ppic .dates {
  display: flex;
  align-items: stretch;
  scrollbar-width: none;
}
#ppic .dates::-webkit-scrollbar {
  display: none;
}
#ppic .dates .range-date {
  width: 100%;
  padding: 8px 12px;
  text-align: center;
  border: 1px solid var(--grey3);
}
#ppic .dates .range-date:first-child {
  border-radius: 8px 0 0 8px;
}
#ppic .dates .range-date:last-child {
  border-radius: 0 8px 8px 0;
}
#ppic .card-flok {
  gap: 20px;
}
#ppic .card-flok .card {
  width: 100%;
  border: 1px solid var(--grey3);
}
#ppic .card-flok .card .card-body {
  padding: 16px 20px;
}
#ppic .link-to-plasma:hover {
  color: var(--teal7) !important;
}
#ppic .pagination {
  margin: 0;
  padding: 28px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#ppic .pagination button:disabled {
  color: var(--grey3) !important;
  background: var(--grey1);
}
#ppic .pagination button:disabled svg {
  color: var(--grey3) !important;
}
#ppic .pagination .page-item {
  width: 40px;
  height: 32px;
}
#ppic .pagination .page-item.active .page-link {
  color: var(--primary);
  background-color: var(--teal1);
}
#ppic .pagination .page-item .page-link {
  width: 100%;
  height: 100%;
  border: none;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 5px;
  line-height: 18px;
  border-radius: 4px;
  align-items: center;
  color: var(--grey6);
  letter-spacing: -0.02em;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}
#ppic .pagination .page-item .page-link:hover {
  color: var(--primary);
  background-color: var(--teal1);
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  #ppic .container-responsive {
    padding-top: 116px !important;
  }
  #ppic .dates {
    flex-direction: column;
  }
  #ppic .dates .range-date:first-child {
    border-radius: 0;
  }
  #ppic .dates .range-date:last-child {
    border-radius: 0;
  }
  #ppic .card-flok,
  #ppic .estimasi-card {
    flex-wrap: wrap;
  }
}
@media (min-width: 375px) and (max-width: 424px) {
  #ppic .container-responsive {
    padding-top: 116px !important;
  }
  #ppic .dates {
    flex-direction: column;
  }
  #ppic .dates .range-date:first-child {
    border-radius: 0;
  }
  #ppic .dates .range-date:last-child {
    border-radius: 0;
  }
  #ppic .card-flok,
  #ppic .estimasi-card {
    flex-wrap: wrap;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  #ppic .container-responsive {
    padding-top: 116px !important;
  }
  #ppic .dates {
    flex-direction: column;
  }
  #ppic .dates .range-date:first-child {
    border-radius: 0;
  }
  #ppic .dates .range-date:last-child {
    border-radius: 0;
  }
  #ppic .card-flok,
  #ppic .estimasi-card {
    flex-wrap: wrap;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  #ppic .container-responsive {
    padding-top: 116px !important;
  }
  #ppic .dates {
    flex-direction: column;
  }
  #ppic .dates .range-date:first-child {
    border-radius: 0;
  }
  #ppic .dates .range-date:last-child {
    border-radius: 0;
  }
  #ppic .card-flok,
  #ppic .estimasi-card {
    flex-wrap: wrap;
  }
}
/* Medium tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  #ppic .container-responsive {
    padding-top: 116px !important;
  }
  #ppic .dates {
    flex-direction: column;
  }
  #ppic .dates .range-date:first-child {
    border-radius: 0;
  }
  #ppic .dates .range-date:last-child {
    border-radius: 0;
  }
  #ppic .card-flok,
  #ppic .estimasi-card {
    flex-wrap: wrap;
  }
}
/* Large tablet */
@media (min-width: 1024px) and (max-width: 1279px) {
  #ppic .card-flok,
  #ppic .estimasi-card {
    flex-wrap: wrap;
  }
}
/* Small laptop */
@media (min-width: 1280px) and (max-width: 1439px) {
  #ppic .container {
    margin: 0;
    max-width: 100%;
  }
  #ppic .card-flok .subtitle4 {
    font-size: 12px !important;
  }
  #ppic .estimasi-card .subtitle2 {
    font-size: 16px !important;
  }
}
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
#dashboard {
  overflow: clip;
}
#dashboard .container-responsive {
  padding-top: 0 !important;
}
#dashboard .sticky {
  position: sticky;
  top: 0;
  z-index: 999;
  background: var(--white);
  box-shadow: 0px 4px 100px 25px rgba(0, 0, 0, 0.0196078431);
}
#dashboard .sticky::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 98px;
  background: var(--white);
  transition: all 0.1s ease-out;
}
#dashboard .sticky::before {
  content: "";
  position: absolute;
  top: 0;
  right: -100%;
  width: 100%;
  height: 98px;
  background: var(--white);
  transition: all 0.1s ease-out;
}
#dashboard .manuver .rts___tabs___container {
  padding: 0;
}
#dashboard .manuver .rts___tabs___container .rts___tabs {
  padding: 0;
}
#dashboard .manuver .rts___tabs___container .rts___tabs .rts___btn {
  margin: 0;
  border: none;
  box-shadow: none;
  border-radius: 0;
  background: none;
  padding: 8px 12px;
  transition: all 0.3s ease-in-out;
  border-bottom: 1px solid transparent;
}
#dashboard .manuver .rts___tabs___container .rts___tabs .rts___btn:hover {
  color: var(--primary) !important;
  border-bottom: 1px solid var(--primary);
}
#dashboard .manuver .rts___tabs___container .rts___tabs .rts___btn.rts___tab___selected {
  border-radius: 0;
  color: var(--primary) !important;
  border-bottom: 1px solid var(--primary);
}
#dashboard .recharts-responsive-container .recharts-wrapper .recharts-legend-wrapper .custom-legend .custom-checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 12px;
  height: 12px;
  position: relative;
  border-radius: 2px;
  cursor: pointer;
}
#dashboard .recharts-responsive-container .recharts-wrapper .recharts-legend-wrapper .custom-legend .custom-checkbox:checked::after {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  width: 4px;
  height: 8px;
  border: solid var(--white);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
#dashboard .accordion {
  padding-bottom: 16px;
}
#dashboard .accordion .accordion-item {
  border: none;
}
#dashboard .accordion .accordion-item .chevron {
  display: flex;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--grey3);
}
#dashboard .accordion .accordion-item .accordion-collapse .accordion-body {
  padding: 16px;
  border-radius: 12px;
  background: var(--blue1);
  border: 1px solid var(--blue6);
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
#dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
  max-width: 23%;
}
#dashboard .accordion .accordion-item .accordion-collapse .accordion-body .border-dashed {
  width: 1px;
  height: 124px;
  border: 1px dashed var(--blue4);
}
#dashboard .custom-tab {
  transition: all 0.3s ease-in-out;
  border-bottom: 2px solid transparent;
}
#dashboard .custom-tab.active, #dashboard .custom-tab:hover {
  border-bottom: 2px solid var(--primary);
}
#dashboard .tab-multi-unit .rts___tabs___container {
  overflow: unset;
  margin-bottom: 10px;
  border-bottom: 1px solid var(--grey3);
}
#dashboard .tab-multi-unit .rts___tabs___container .rts___tabs .rts___tab {
  box-shadow: none;
  padding: 8px 12px;
  margin: 0 !important;
  background: transparent;
  border-radius: 0 !important;
  border: 2px solid transparent;
  transition: all 0.2s ease-in-out;
}
#dashboard .tab-multi-unit .rts___tabs___container .rts___tabs .rts___tab:hover, #dashboard .tab-multi-unit .rts___tabs___container .rts___tabs .rts___tab.rts___tab___selected {
  color: var(--primary) !important;
  border-bottom: 2px solid var(--primary);
}
#dashboard .tab-multi-unit .scroll-icon {
  width: 44px;
  height: 44px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background: var(--white);
  transition: all 0.3s ease-in-out;
  box-shadow: -2px 0px 4px 0px rgba(156, 163, 175, 0.15);
}
#dashboard .tab-multi-unit .scroll-icon.left {
  position: absolute;
  top: -8px;
  left: -24px;
}
#dashboard .tab-multi-unit .scroll-icon.right {
  position: absolute;
  top: -8px;
  right: -24px;
}
#dashboard .tab-multi-unit .scroll-wrapper {
  scrollbar-width: none;
}
#dashboard .tab-multi-unit .scroll-wrapper::-webkit-scrollbar {
  display: none;
}

.custom-spinner {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 5px solid #e3e5e8;
  border-top: 5px solid var(--primary);
  animation: spiner 1s linear infinite;
}

@keyframes spiner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 14px;
  flex: none;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .slider {
  background-color: var(--blue6);
}
.toggle-switch input:checked + .slider::before {
  transform: translateX(6px);
}
.toggle-switch .slider {
  position: absolute;
  cursor: pointer;
  background-color: var(--grey3);
  border-radius: 34px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
}
.toggle-switch .slider::before {
  position: absolute;
  content: "";
  height: 6px;
  width: 6px;
  left: 4px;
  bottom: 4px;
  background-color: var(--white);
  transition: 0.4s;
  border-radius: 50%;
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  #dashboard .container-responsive {
    padding-top: 90px !important;
  }
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body {
    flex-direction: column;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 100%;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .border-dashed {
    width: 100%;
    height: 1px;
  }
  #dashboard .w-25 {
    width: 100% !important;
  }
  #dashboard .rencana-chickin .block {
    flex-direction: column;
  }
  #dashboard .tab-multi-unit .rts___tabs___container {
    padding: 0;
  }
}
/* Medium mobile */
@media (min-width: 375px) and (max-width: 424px) {
  #dashboard .container-responsive {
    padding-top: 90px !important;
  }
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body {
    flex-direction: column;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 100%;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .border-dashed {
    width: 100%;
    height: 1px;
  }
  #dashboard .w-25 {
    width: 100% !important;
  }
  #dashboard .rencana-chickin .block {
    flex-direction: column;
  }
  #dashboard .tab-multi-unit .rts___tabs___container {
    padding: 0;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  #dashboard .container-responsive {
    padding-top: 90px !important;
  }
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body {
    flex-direction: column;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 100%;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .border-dashed {
    width: 100%;
    height: 1px;
  }
  #dashboard .w-25 {
    width: 100% !important;
  }
  #dashboard .rencana-chickin .block {
    flex-direction: column;
  }
  #dashboard .tab-multi-unit .rts___tabs___container {
    padding: 0;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  #dashboard .container-responsive {
    padding-top: 90px !important;
  }
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body {
    flex-direction: column;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 100%;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .border-dashed {
    width: 100%;
    height: 1px;
  }
  #dashboard .w-25 {
    width: 100% !important;
  }
  #dashboard .rencana-chickin .block {
    flex-direction: column;
  }
  #dashboard .tab-multi-unit .rts___tabs___container {
    padding: 0;
  }
}
/* Medium tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  #dashboard .container-responsive {
    padding-top: 90px !important;
  }
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body {
    flex-direction: column;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 100%;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .border-dashed {
    width: 100%;
    height: 1px;
  }
  #dashboard .rencana-chickin .block {
    flex-direction: column;
  }
  #dashboard .tab-multi-unit .rts___tabs___container {
    padding: 0;
  }
}
/* Large tablet */
@media (min-width: 1024px) and (max-width: 1279px) {
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 34%;
  }
  #dashboard .w-25 {
    width: 100% !important;
  }
  #dashboard .rencana-chickin .block {
    flex-direction: column;
  }
}
/* Small laptop */
@media (min-width: 1280px) and (max-width: 1439px) {
  #dashboard .container {
    margin: 0;
    max-width: 100%;
  }
  #dashboard .sticky {
    position: static;
    background: transparent;
  }
  #dashboard .sticky::after, #dashboard .sticky::before {
    display: none;
  }
  #dashboard .accordion .accordion-item .accordion-collapse .accordion-body .information {
    max-width: 26%;
  }
  #dashboard .w-25 {
    width: 100% !important;
  }
}
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
#assessment {
  overflow: clip;
}
#assessment .container-responsive {
  padding-top: 0 !important;
}
#assessment .sticky {
  position: sticky;
  top: 0;
  z-index: 999;
  background: var(--white);
  box-shadow: 0px 4px 100px 25px rgba(0, 0, 0, 0.0196078431);
}
#assessment .sticky::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 156px;
  background: var(--white);
  transition: all 0.1s ease-out;
}
#assessment .sticky::before {
  content: "";
  position: absolute;
  top: 0;
  right: -100%;
  width: 100%;
  height: 156px;
  background: var(--white);
  transition: all 0.1s ease-out;
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  #assessment .container-responsive {
    padding-top: 90px !important;
  }
  #assessment .sticky {
    position: static;
    background: transparent;
  }
  #assessment .sticky::after, #assessment .sticky::before {
    display: none;
  }
  #assessment .header-scroll {
    display: none !important;
  }
  #assessment .table-wrapper {
    margin-top: 0 !important;
  }
  #assessment .table-assessment .d-none {
    display: flex !important;
    gap: 8px;
  }
}
@media (min-width: 375px) and (max-width: 424px) {
  #assessment .container-responsive {
    padding-top: 90px !important;
  }
  #assessment .sticky {
    position: static;
    background: transparent;
  }
  #assessment .sticky::after, #assessment .sticky::before {
    display: none;
  }
  #assessment .header-scroll {
    display: none !important;
  }
  #assessment .table-wrapper {
    margin-top: 0 !important;
  }
  #assessment .table-assessment .d-none {
    display: flex !important;
    gap: 8px;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  #assessment .container-responsive {
    padding-top: 90px !important;
  }
  #assessment .sticky {
    position: static;
    background: transparent;
  }
  #assessment .sticky::after, #assessment .sticky::before {
    display: none;
  }
  #assessment .header-scroll {
    display: none !important;
  }
  #assessment .table-wrapper {
    margin-top: 0 !important;
  }
  #assessment .table-assessment .d-none {
    display: flex !important;
    gap: 8px;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  #assessment .container-responsive {
    padding-top: 90px !important;
  }
  #assessment .sticky {
    position: static;
    background: transparent;
  }
  #assessment .sticky::after, #assessment .sticky::before {
    display: none;
  }
  #assessment .header-scroll {
    display: none !important;
  }
  #assessment .table-wrapper {
    margin-top: 0 !important;
  }
  #assessment .table-assessment .d-none {
    display: flex !important;
    gap: 8px;
  }
}
/* Medium tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  #assessment .container-responsive {
    padding-top: 90px !important;
  }
  #assessment .sticky {
    position: static;
    background: transparent;
  }
  #assessment .sticky::after, #assessment .sticky::before {
    display: none;
  }
  #assessment .header-scroll {
    display: none !important;
  }
  #assessment .table-wrapper {
    margin-top: 0 !important;
  }
  #assessment .table-assessment .d-none {
    display: flex !important;
    gap: 8px;
  }
}
/* Large tablet */
@media (min-width: 1024px) and (max-width: 1279px) {
  #assessment .sticky::after, #assessment .sticky::before {
    height: 86px;
  }
  #assessment .header-scroll {
    display: none !important;
  }
  #assessment .table-wrapper {
    margin-top: 0 !important;
  }
  #assessment .table-assessment .d-none {
    display: flex !important;
    gap: 8px;
  }
}
/* Small laptop */
@media (min-width: 1280px) and (max-width: 1439px) {
  #assessment .container {
    margin: 0;
    max-width: 100%;
  }
  #assessment .sticky::after, #assessment .sticky::before {
    height: 136px;
  }
  #assessment .header-scroll .table-assessment thead .header-wrapper th {
    width: 289px;
  }
}
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
.auth-spinner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid var(--white);
  border-top: 3px solid var(--teal2);
  animation: spiner 1s linear infinite;
}

@keyframes spiner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.tambah-planning.cancel .swal2-icon {
  background: var(--yellow1) !important;
}
.tambah-planning.cancel .swal2-icon .swal2-icon-content {
  width: 100%;
  height: 100%;
}
.tambah-planning.cancel .swal2-icon .swal2-icon-content .icon-wrapper-yellow {
  width: 100%;
  height: 100%;
}
.tambah-planning.cancel .swal2-icon .swal2-icon-content .icon-wrapper-yellow .info-yellow6 {
  display: block;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat center center;
}
.tambah-planning .swal2-popup {
  padding: 0;
  width: 550px;
  border-radius: 8px;
}
.tambah-planning .swal2-popup .swal2-icon {
  border: none;
  margin: 16px 24px 0 24px;
  background: var(--blue1);
}
.tambah-planning .swal2-popup .swal2-icon .swal2-icon-content {
  width: 100%;
  height: 100%;
}
.tambah-planning .swal2-popup .swal2-icon .swal2-icon-content .icon-wrapper-blue {
  width: 100%;
  height: 100%;
}
.tambah-planning .swal2-popup .swal2-icon .swal2-icon-content .icon-wrapper-blue .info-blue6 {
  display: block;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) no-repeat center center;
}
.tambah-planning .swal2-popup .swal2-title {
  text-align: start;
  margin: 20px 24px 12px 24px;
}
.tambah-planning .swal2-popup .swal2-html-container {
  margin: 0 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: start;
  color: var(--grey6);
  letter-spacing: -0.32px;
}
.tambah-planning .swal2-popup .swal2-actions {
  border-radius: 0 0 8px 8px;
}

#bakul {
  /* ===== list bakul ===== */
  /* ===== detail bakul ===== */
}
#bakul .custom-search {
  width: 260px;
  height: var(--32);
  padding: var(--8) var(--12) var(--8) var(--38);
}
#bakul .filter {
  height: var(--32);
}
#bakul .table tbody tr td {
  font-weight: 400;
}
#bakul .individu {
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px var(--8);
  border-radius: var(--8);
  font-weight: 400 !important;
  color: var(--blue6) !important;
  background: var(--blue1) !important;
}
#bakul .badan-usaha {
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px var(--8);
  border-radius: var(--8);
  font-weight: 400 !important;
  color: var(--purple7) !important;
  background: var(--purple2) !important;
}
#bakul .pagination {
  align-items: center;
  justify-content: space-between;
  border-radius: var(--8);
  margin: 16px 0 0 auto;
}
#bakul .pagination .arrow {
  border-radius: var(--6);
}
#bakul .pagination .arrow:hover {
  background: var(--grey2);
}
#bakul .pagination .arrow:disabled {
  background: transparent;
}
#bakul .pagination .page-item {
  width: var(--40);
  height: var(--32);
}
#bakul .pagination .page-item .page-link {
  height: 100%;
  border: none;
  display: flex;
  font-weight: 500;
  border-radius: 0;
  line-height: 18px;
  align-items: center;
  color: var(--grey6);
  font-size: var(--14);
  padding: var(--4) 5px;
  letter-spacing: -0.02em;
  justify-content: center;
  border-radius: var(--4);
  transition: all 0.3s ease-in-out;
}
#bakul .pagination .page-item .page-link:hover {
  color: var(--teal6);
  background: var(--teal1);
}
#bakul .pagination .page-item.active .page-link {
  color: var(--teal6);
  background: var(--teal1);
}
#bakul .rts___tabs___container .rts___tabs .rts___btn {
  transition: all 0.2s ease-in-out;
}
#bakul .rts___tabs___container .rts___tabs .rts___btn:hover {
  background: var(--white);
  color: var(--teal6) !important;
}
#bakul .leaflet-container .leaflet-map-pane .leaflet-tooltip-pane .leaflet-tooltip {
  padding: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  margin: var(--8) 0 0;
  background: transparent;
}
#bakul .leaflet-container .leaflet-control-container .leaflet-top .leaflet-control-zoom {
  display: none;
}
#bakul .leaflet-container .leaflet-control-container .leaflet-bottom.leaflet-right {
  display: none;
}
#bakul .select-periode .react-select__control {
  border-radius: var(--6);
}
#bakul .tab .rts___tabs___container .rts___tabs {
  border-bottom: 1px solid var(--grey2);
}
#bakul .tab .rts___tabs___container .rts___tabs .rts___tab {
  border: none;
  padding: var(--8) var(--12);
  border-bottom: 2px solid transparent;
}
#bakul .tab .rts___tabs___container .rts___tabs .rts___tab:hover {
  border: none !important;
  color: var(--teal6) !important;
  background: transparent !important;
  border-bottom: 2px solid var(--teal6) !important;
}
#bakul .bermasalah {
  margin-left: auto;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px var(--8);
  border-radius: var(--8);
  color: var(--red6) !important;
  background: var(--red1) !important;
}
#bakul .lancar {
  margin-left: auto;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px var(--8);
  border-radius: var(--8);
  color: var(--green6) !important;
  background: var(--green1) !important;
}
#bakul .custom-toast {
  font-weight: 500;
  color: var(--white);
  font-size: var(--16);
  line-height: var(--20);
  border-radius: var(--8);
  letter-spacing: -0.02em;
  background: var(--green7);
  position: fixed;
  top: var(--16);
  left: 0;
  right: 0;
  z-index: 9999;
  margin: 0 auto;
  width: -moz-fit-content;
  width: fit-content;
  padding: var(--10) var(--12);
  animation: slideIn 0.3s ease, fadeOut 0.5s ease 1.5s forwards;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
#bakul .recharts-responsive-container .recharts-wrapper .recharts-legend-wrapper .custom-legend .custom-checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: var(--12);
  height: var(--12);
  position: relative;
  border-radius: 2px;
  cursor: pointer;
}
#bakul .recharts-responsive-container .recharts-wrapper .recharts-legend-wrapper .custom-legend .custom-checkbox:checked::after {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  width: var(--4);
  height: var(--8);
  border: solid var(--white);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
#bakul .date-picker-wrapper {
  width: 100%;
}
#bakul .date-picker-wrapper .react-datepicker-wrapper .react-datepicker__input-container .customs-input {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  background-repeat: no-repeat;
  background-position: left;
  background-position-x: var(--12);
  padding-left: 34px;
}
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__triangle,
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__navigation {
  display: none;
}
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__current-month {
  display: none;
}
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__header__dropdown .react-datepicker__month-select,
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__header__dropdown .react-datepicker__year-select {
  background: transparent;
}
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__header__dropdown .react-datepicker__month-read-view,
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__header__dropdown .react-datepicker__year-read-view {
  visibility: unset !important;
}
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__header__dropdown .react-datepicker__month-read-view--down-arrow,
#bakul .react-datepicker__tab-loop .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__header__dropdown .react-datepicker__year-read-view--down-arrow {
  top: var(--6);
  right: -12px;
  width: var(--6);
  height: var(--6);
  border-width: 2px 2px 0 0;
  border-color: var(--grey9);
}
#bakul .select .react-select__control {
  border-radius: var(--6);
}
#bakul .select .react-select__control .react-select__value-container .react-select__single-value {
  color: var(--grey9);
  font-size: var(--12);
  line-height: var(--16);
}
#bakul .select .react-select__control .react-select__value-container .react-select__placeholder {
  font-weight: 400;
  color: var(--grey5);
  font-size: var(--12);
  line-height: var(--16);
}
#bakul .label-checkbox {
  margin-bottom: 0 !important;
}
#bakul .label-checkbox .custom-checkbox {
  width: var(--14);
  height: var(--14);
}
#bakul .label-checkbox .custom-checkbox:checked::after {
  top: 1px;
  left: var(--4);
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  #bakul .container-responsive {
    padding: 90px var(--16) var(--16) var(--16) !important;
  }
  #bakul .rts___tabs___container .rts___tabs {
    flex-direction: column;
  }
  #bakul .overview {
    flex-direction: column;
  }
  #bakul .produk {
    flex-direction: column;
  }
  #bakul .produk .d-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
/* Medium mobile */
@media (min-width: 375px) and (max-width: 424px) {
  #bakul .container-responsive {
    padding: 90px var(--16) var(--16) var(--16) !important;
  }
  #bakul .rts___tabs___container .rts___tabs {
    flex-direction: column;
  }
  #bakul .overview {
    flex-direction: column;
  }
  #bakul .produk {
    flex-direction: column;
  }
  #bakul .produk .d-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  #bakul .container-responsive {
    padding: 90px var(--16) var(--16) var(--16) !important;
  }
  #bakul .rts___tabs___container .rts___tabs {
    flex-direction: column;
  }
  #bakul .overview {
    flex-direction: column;
  }
  #bakul .produk {
    flex-direction: column;
  }
  #bakul .produk .d-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  #bakul .container-responsive {
    padding-top: 116px !important;
  }
  #bakul .rts___tabs___container .rts___tabs {
    flex-direction: column;
  }
  #bakul .overview {
    flex-direction: column;
  }
  #bakul .produk .d-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
/* Medium tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  #bakul .container-responsive {
    padding-top: 116px !important;
  }
  #bakul .rts___tabs___container .rts___tabs {
    flex-direction: column;
  }
  #bakul .overview {
    flex-direction: column;
  }
  #bakul .produk .d-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
/* Large tablet */
/* Small laptop */
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
/* Small mobile */
/* Large mobile */
/* Small tablet */
/* Medium tablet */
/* Large tablet */
/* Small laptop */
@media (min-width: 1280px) and (max-width: 1439px) {
  #create-ppic .container-responsive .container {
    margin: 0;
    max-width: 100%;
  }
}
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
#panen .checkbox {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 12px;
  height: 12px;
  display: flex;
  outline: none;
  cursor: pointer;
  position: relative;
  border-radius: 2px;
  background-color: var(--white);
  border: 1px solid var(--grey7);
}
#panen .checkbox:checked {
  background: var(--teal6);
  border: 1px solid var(--teal7);
}
#panen .checkbox:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 8px;
  transform: translate(-50%, -50%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-size: contain;
  background-repeat: no-repeat;
}
#panen .rts___tabs___container {
  padding: 0;
  display: flex;
  align-items: center;
}
#panen .rts___tabs___container .rts___tabs {
  padding: 0;
}
#panen .rts___tabs___container .rts___tabs .rts___btn {
  margin: 0;
  border: none;
  box-shadow: none;
  border-radius: 0;
  background: none;
  padding: 8px 12px;
  transition: all 0.3s ease-in-out;
  border-bottom: 1px solid transparent;
}
#panen .rts___tabs___container .rts___tabs .rts___btn:hover {
  color: var(--primary) !important;
  border-bottom: 1px solid var(--primary);
}
#panen .rts___tabs___container .rts___tabs .rts___btn.rts___tab___selected {
  border-radius: 0;
  color: var(--primary) !important;
  border-bottom: 1px solid var(--primary);
}
#panen .pagination {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#panen .pagination button:disabled {
  color: var(--grey3) !important;
  background: var(--grey1);
}
#panen .pagination button:disabled svg {
  color: var(--grey3) !important;
}
#panen .pagination .page-item {
  width: 40px;
  height: 32px;
}
#panen .pagination .page-item.active .page-link {
  color: var(--primary);
  background-color: var(--teal1);
}
#panen .pagination .page-item .page-link {
  width: 100%;
  height: 100%;
  border: none;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 5px;
  line-height: 18px;
  border-radius: 4px;
  align-items: center;
  color: var(--grey6);
  letter-spacing: -0.02em;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}
#panen .pagination .page-item .page-link:hover {
  color: var(--primary);
  background-color: var(--teal1);
}

/* Small mobile */
@media (min-width: 320px) and (max-width: 374px) {
  #panen .container-responsive {
    padding-top: 86px !important;
  }
  #panen .select.select-ap .react-select__menu {
    left: 0;
    width: 276px;
  }
  #panen .setting-panen .select,
  #panen .setting-panen .custom-search {
    width: 100%;
  }
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Medium mobile */
@media (min-width: 375px) and (max-width: 424px) {
  #panen .container-responsive {
    padding-top: 86px !important;
  }
  #panen .setting-panen .filter {
    width: 100%;
  }
  #panen .setting-panen .select,
  #panen .setting-panen .custom-search {
    width: 100%;
  }
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Large mobile */
@media (min-width: 425px) and (max-width: 599px) {
  #panen .container-responsive {
    padding-top: 86px !important;
  }
  #panen .setting-panen .filter {
    width: 100%;
  }
  #panen .setting-panen .select,
  #panen .setting-panen .custom-search {
    width: 100%;
  }
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Small tablet */
@media (min-width: 600px) and (max-width: 767px) {
  #panen .container-responsive {
    padding-top: 86px !important;
  }
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Medium tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  #panen .container-responsive {
    padding-top: 86px !important;
  }
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Large tablet */
@media (min-width: 1024px) and (max-width: 1279px) {
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Small laptop */
@media (min-width: 1280px) and (max-width: 1439px) {
  .table-pengaturan-panen .cta {
    padding: 0;
  }
  .table-pengaturan-panen .cta .btn-wrapper {
    flex-wrap: wrap;
  }
}
/* Medium laptop */
/* Large laptop */
/* Small desktop */
/* Large desktop */
/* Ultra-Wide screens */
/* 4K screens */
.hover\\:tw-cursor-pointer:hover{
  cursor: pointer;
}
.hover\\:\\!tw-bg-\\[\\#0B7F8E\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(11 127 142 / var(--tw-bg-opacity)) !important;
}
@media (min-width: 768px){
  .md\\:tw-grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px){
  .lg\\:tw-h-\\[150px\\]{
    height: 150px;
  }
  .lg\\:tw-w-\\[150px\\]{
    width: 150px;
  }
  .lg\\:tw-max-w-\\[200px\\]{
    max-width: 200px;
  }
  .lg\\:tw-columns-2{
    columns: 2;
  }
  .lg\\:tw-grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:tw-grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:tw-grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:tw-gap-y-0{
    row-gap: 0px;
  }
}
@media (min-width: 1280px){
  .xl\\:tw-grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:tw-overflow-x-visible{
    overflow-x: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme.scss","webpack://./node_modules/tailwindcss/base.css","webpack://./node_modules/tailwindcss/utilities.css","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/skins/default/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/_colors.scss","webpack://./src/assets/scss/custom/_general.scss","webpack://./src/assets/scss/custom/_typography.scss","webpack://./src/assets/scss/custom/spacing.scss","webpack://./src/assets/scss/components/_accordions.scss","webpack://./src/assets/scss/components/_alerts.scss","webpack://./src/assets/scss/components/_badge.scss","webpack://./src/assets/scss/components/_backgrounds.scss","webpack://./src/assets/scss/components/_breadcrumb.scss","webpack://./src/assets/scss/components/_buttons.scss","webpack://./src/assets/scss/components/_card.scss","webpack://./src/assets/scss/components/_dropdown.scss","webpack://./src/assets/scss/skins/default/_custom-variables.scss","webpack://./src/assets/scss/components/_forms.scss","webpack://./src/assets/scss/components/_modal.scss","webpack://./src/assets/scss/components/_navbar.scss","webpack://./src/assets/scss/components/_nav.scss","webpack://./src/assets/scss/components/_pagination.scss","webpack://./src/assets/scss/components/_popover.scss","webpack://./src/assets/scss/components/_progress.scss","webpack://./src/assets/scss/components/_reboot.scss","webpack://./src/assets/scss/components/_tables.scss","webpack://./src/assets/scss/components/_type.scss","webpack://./src/assets/scss/components/_helper.scss","webpack://./src/assets/scss/components/_list.scss","webpack://./src/assets/scss/components/_widgets.scss","webpack://./src/assets/scss/components/_custom-checkbox.scss","webpack://./src/assets/scss/components/_custom-radio.scss","webpack://./src/assets/scss/components/_print.scss","webpack://./src/assets/scss/components/_preloader.scss","webpack://./src/assets/scss/components/_tooltip.scss","webpack://./src/assets/scss/components/_sidebar.scss","webpack://./src/assets/scss/components/_input.scss","webpack://./src/assets/scss/components/_select-ap.scss","webpack://./src/assets/scss/custom/plugins/_rateit.scss","webpack://./src/assets/scss/custom/plugins/_gallery.scss","webpack://./src/assets/scss/custom/plugins/_daterange.scss","webpack://./src/assets/scss/custom/plugins/_leaflet.scss","webpack://./src/assets/scss/custom/plugins/_jarallex.scss","webpack://./node_modules/swiper/swiper.scss","webpack://./node_modules/swiper/modules/navigation/navigation.scss","webpack://./node_modules/swiper/modules/pagination/pagination.scss","webpack://./src/assets/scss/custom/plugins/_lightbox.scss","webpack://./src/assets/scss/custom/plugins/_aos.scss","webpack://./src/assets/scss/custom/structure/_sidenav.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/components/_icons.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_ribbon.scss","webpack://./src/assets/scss/custom/components/_header.scss","webpack://./src/assets/scss/custom/components/_hero.scss","webpack://./src/assets/scss/custom/components/_features.scss","webpack://./src/assets/scss/custom/components/_testimonials.scss","webpack://./src/assets/scss/custom/pages/_docs.scss","webpack://./src/assets/scss/custom/pages/_portfolio.scss","webpack://./src/assets/scss/custom/pages/_gallery.scss","webpack://./src/assets/scss/custom/pages/_ppic.scss","webpack://./src/assets/scss/custom/pages/_dashboard.scss","webpack://./src/assets/scss/custom/pages/_assessment.scss","webpack://./src/assets/scss/custom/pages/_auth.scss","webpack://./src/assets/scss/custom/pages/_planning.scss","webpack://./src/assets/scss/custom/pages/_bakul.scss","webpack://./src/assets/scss/custom/pages/_create-ppic.scss","webpack://./src/assets/scss/custom/pages/_panen.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;CAAA;ACAA;;CAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;CAAA;AAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,4NAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;ACAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,qBAAA;EAIA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,+BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,kDAAA;EACA,yGAAA;EACA,yFAAA;EAOA,mDAAA;EC2OI,8BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,+BAAA;EACA,0BAAA;EAEA,8BAAA;EACA,uCAAA;EAGE,qCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,oDAAA;EACA,sDAAA;EACA,0DAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AJgBF;;AMhII;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AJgBJ;;AOxLA;;;EAGE,sBAAA;AP2LF;;AO5KI;EANJ;IAOM,uBAAA;EPgLJ;AACF;;AOnKA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;APsKF;;AO7JA;EACE,cAAA;EACA,cC9CS;ED+CT,SAAA;EACA,mBAAA;EACA,YC0mBW;AR1cb;;AOtJA;EACE,aAAA;EACA,qBCmjBuB;EDhjBvB,gBCmjBqB;EDljBrB,gBCmjBqB;EDljBrB,8BAAA;APuJF;;AOpJA;EFuMQ,uCAAA;AL/CR;AK7GI;EE3CJ;IF8MQ,qBAAA;ELlDN;AACF;;AOxJA;EFkMQ,yCAAA;ALtCR;AKtHI;EEtCJ;IFyMQ,sBAAA;ELzCN;AACF;;AO5JA;EF6LQ,qCAAA;AL7BR;AK/HI;EEjCJ;IFoMQ,oBAAA;ELhCN;AACF;;AOhKA;EFoLM,sBALI;ALXV;;AO/JA;EF+KM,oBALI;ALPV;;AO9JA;EF0KM,qBALI;ALHV;;AOvJA;EACE,aAAA;EACA,mBCqWwB;AR3M1B;;AOhJA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;APmJF;;AO7IA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;APgJF;;AO1IA;;EAEE,kBAAA;AP6IF;;AO1IA;;;EAGE,aAAA;EACA,mBAAA;AP6IF;;AO1IA;;;;EAIE,gBAAA;AP6IF;;AO1IA;EACE,gBCwbiB;AR3SnB;;AOxIA;EACE,qBAAA;EACA,cAAA;AP2IF;;AOrIA;EACE,gBAAA;APwIF;;AOhIA;;EAEE,gBCiamB;AR9RrB;;AO3HA;EF6EM,kBALI;ALuDV;;AOxHA;EACE,cC8da;ED7db,gCAAA;EACA,wCAAA;AP2HF;;AOlHA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;APqHF;;AOlHA;EAAM,eAAA;APsHN;;AOrHA;EAAM,WAAA;APyHN;;AOpHA;EACE,gEAAA;EACA,qBCsOgB;AR/GlB;AOrHE;EACE,mDAAA;EACA,0BCqOoB;AR9GxB;;AO7GE;EAEE,cAAA;EACA,qBAAA;AP+GJ;;AOxGA;;;;EAIE,qCC6UiB;EH/Tb,cALI;ALmGV;;AOpGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AL2GV;AOnGE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;APqGJ;;AOjGA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;APoGF;AOjGE;EACE,cAAA;APmGJ;;AO/FA;EACE,kBAAA;EFtBI,kBALI;EE6BR,WCvSM;EDwSN,yBC/RS;ECNP,sBAAA;ATwYJ;AOhGE;EACE,UAAA;EF7BE,cALI;EEoCN,gBC4Se;AR1MnB;;AOzFA;EACE,gBAAA;AP4FF;;AOtFA;;EAEE,sBAAA;APyFF;;AOjFA;EACE,oBAAA;EACA,yBAAA;APoFF;;AOjFA;EACE,oBC0WqB;EDzWrB,uBCyWqB;EDxWrB,cCoUW;EDnUX,gBAAA;APoFF;;AO7EA;EAEE,mBAAA;EACA,gCAAA;AP+EF;;AO5EA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AP+EF;;AOvEA;EACE,qBAAA;AP0EF;;AOpEA;EAEE,gBAAA;APsEF;;AO9DA;EACE,UAAA;APiEF;;AO5DA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AP+DF;;AO3DA;;EAEE,oBAAA;AP8DF;;AOzDA;EACE,eAAA;AP4DF;;AOzDA;EAGE,iBAAA;AP0DF;AOvDE;EACE,UAAA;APyDJ;;AOlDA;EACE,wBAAA;APqDF;;AO7CA;;;;EAIE,0BAAA;APgDF;AO7CI;;;;EACE,eAAA;APkDN;;AO3CA;EACE,UAAA;EACA,kBAAA;AP8CF;;AOzCA;EACE,gBAAA;AP4CF;;AOlCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;APqCF;;AO7BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCgMqB;EHjZf,iCAAA;EEoNN,oBAAA;AP+BF;AK/YI;EEyWJ;IFtMQ,iBAAA;ELgPN;AACF;AOlCE;EACE,WAAA;APoCJ;;AO7BA;;;;;;;EAOE,UAAA;APgCF;;AO7BA;EACE,YAAA;APgCF;;AOvBA;EACE,6BAAA;EACA,oBAAA;AP0BF;;AOlBA;;;;;;;CAAA;AAWA;EACE,wBAAA;APkBF;;AObA;EACE,UAAA;APgBF;;AOTA;EACE,aAAA;EACA,0BAAA;APYF;;AOPA;EACE,qBAAA;APUF;;AOLA;EACE,SAAA;APQF;;AODA;EACE,kBAAA;EACA,eAAA;APIF;;AOIA;EACE,wBAAA;APDF;;AOSA;EACE,wBAAA;APNF;;AU/jBA;ELmQM,sBALI;EK5PR,gBFgoBiB;AR9DnB;;AU7jBE;ELgQM,iCAAA;EK5PJ,gBFinBkB;EEhnBlB,gBFinBkB;ARnDtB;AK/dI;EKpGF;ILuQM,eAAA;ELgUN;AACF;;AUxkBE;ELgQM,iCAAA;EK5PJ,gBFinBkB;EEhnBlB,gBFinBkB;ARxCtB;AK1eI;EKpGF;ILuQM,eAAA;EL2UN;AACF;;AUnlBE;ELgQM,iCAAA;EK5PJ,gBFinBkB;EEhnBlB,gBFinBkB;AR7BtB;AKrfI;EKpGF;ILuQM,eAAA;ELsVN;AACF;;AU9lBE;ELgQM,iCAAA;EK5PJ,gBFinBkB;EEhnBlB,gBFinBkB;ARlBtB;AKhgBI;EKpGF;ILuQM,eAAA;ELiWN;AACF;;AUzmBE;EL4PI,eALI;EKnPN,gBFinBkB;EEhnBlB,gBFinBkB;ARPtB;;AUvlBA;ECvDE,eAAA;EACA,gBAAA;AXkpBF;;AUvlBA;EC5DE,eAAA;EACA,gBAAA;AXupBF;;AUzlBA;EACE,qBAAA;AV4lBF;AU1lBE;EACE,oBFunBkB;AR3BtB;;AUllBA;EL8MM,kBALI;EKvMR,yBAAA;AVqlBF;;AUjlBA;EACE,mBFqSO;EH9FH,sBALI;ALmZV;AUllBE;EACE,gBAAA;AVolBJ;;AUhlBA;EACE,iBAAA;EACA,mBF2RO;EH9FH,kBALI;EKtLR,cF9ES;ARiqBX;AUjlBE;EACE,aAAA;AVmlBJ;;AYnrBA;ECIE,eAAA;EAGA,YAAA;AbirBF;;AYlrBA;EACE,gBJm+CkB;EIl+ClB,sBJCM;EIAN,yBAAA;EHGE,uBAAA;EIRF,eAAA;EAGA,YAAA;Ab0rBF;;AY5qBA;EAEE,qBAAA;AZ8qBF;;AY3qBA;EACE,qBAAA;EACA,cAAA;AZ8qBF;;AY3qBA;EPyPM,kBALI;EOlPR,cJlBS;ARgsBX;;AchtBE;;;;;;;ECHA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Af6tBF;;AgBvqBI;EF5CE;IACE,gBN6ee;ER0OrB;AACF;AgB7qBI;EF5CE;IACE,gBN6ee;ER+OrB;AACF;AgBlrBI;EF5CE;IACE,gBN6ee;ERoPrB;AACF;AgBvrBI;EF5CE;IACE,iBN6ee;ERyPrB;AACF;AgB5rBI;EF5CE;IACE,iBN6ee;ER8PrB;AACF;AiB5vBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AjBkwBJ;;AiB7vBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AlBswBF;AiBpwBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AlBgwBF;;AkBjtBM;EACE,SAAA;AlBotBR;;AkBjtBM;EApCJ,cAAA;EACA,WAAA;AlByvBF;;AkB3uBE;EACE,cAAA;EACA,WAAA;AlB8uBJ;;AkBhvBE;EACE,cAAA;EACA,UAAA;AlBmvBJ;;AkBrvBE;EACE,cAAA;EACA,mBAAA;AlBwvBJ;;AkB1vBE;EACE,cAAA;EACA,UAAA;AlB6vBJ;;AkB/vBE;EACE,cAAA;EACA,UAAA;AlBkwBJ;;AkBpwBE;EACE,cAAA;EACA,mBAAA;AlBuwBJ;;AkBxuBM;EAhDJ,cAAA;EACA,WAAA;AlB4xBF;;AkBvuBU;EAhEN,cAAA;EACA,kBAAA;AlB2yBJ;;AkB5uBU;EAhEN,cAAA;EACA,mBAAA;AlBgzBJ;;AkBjvBU;EAhEN,cAAA;EACA,UAAA;AlBqzBJ;;AkBtvBU;EAhEN,cAAA;EACA,mBAAA;AlB0zBJ;;AkB3vBU;EAhEN,cAAA;EACA,mBAAA;AlB+zBJ;;AkBhwBU;EAhEN,cAAA;EACA,UAAA;AlBo0BJ;;AkBrwBU;EAhEN,cAAA;EACA,mBAAA;AlBy0BJ;;AkB1wBU;EAhEN,cAAA;EACA,mBAAA;AlB80BJ;;AkB/wBU;EAhEN,cAAA;EACA,UAAA;AlBm1BJ;;AkBpxBU;EAhEN,cAAA;EACA,mBAAA;AlBw1BJ;;AkBzxBU;EAhEN,cAAA;EACA,mBAAA;AlB61BJ;;AkB9xBU;EAhEN,cAAA;EACA,WAAA;AlBk2BJ;;AkB3xBY;EAxDV,wBAAA;AlBu1BF;;AkB/xBY;EAxDV,yBAAA;AlB21BF;;AkBnyBY;EAxDV,gBAAA;AlB+1BF;;AkBvyBY;EAxDV,yBAAA;AlBm2BF;;AkB3yBY;EAxDV,yBAAA;AlBu2BF;;AkB/yBY;EAxDV,gBAAA;AlB22BF;;AkBnzBY;EAxDV,yBAAA;AlB+2BF;;AkBvzBY;EAxDV,yBAAA;AlBm3BF;;AkB3zBY;EAxDV,gBAAA;AlBu3BF;;AkB/zBY;EAxDV,yBAAA;AlB23BF;;AkBn0BY;EAxDV,yBAAA;AlB+3BF;;AkB5zBQ;;EAEE,gBAAA;AlB+zBV;;AkB5zBQ;;EAEE,gBAAA;AlB+zBV;;AkBt0BQ;;EAEE,sBAAA;AlBy0BV;;AkBt0BQ;;EAEE,sBAAA;AlBy0BV;;AkBh1BQ;;EAEE,qBAAA;AlBm1BV;;AkBh1BQ;;EAEE,qBAAA;AlBm1BV;;AkB11BQ;;EAEE,mBAAA;AlB61BV;;AkB11BQ;;EAEE,mBAAA;AlB61BV;;AkBp2BQ;;EAEE,qBAAA;AlBu2BV;;AkBp2BQ;;EAEE,qBAAA;AlBu2BV;;AkB92BQ;;EAEE,mBAAA;AlBi3BV;;AkB92BQ;;EAEE,mBAAA;AlBi3BV;;AkBx3BQ;;EAEE,qBAAA;AlB23BV;;AkBx3BQ;;EAEE,qBAAA;AlB23BV;;AkBl4BQ;;EAEE,mBAAA;AlBq4BV;;AkBl4BQ;;EAEE,mBAAA;AlBq4BV;;AkB54BQ;;EAEE,qBAAA;AlB+4BV;;AkB54BQ;;EAEE,qBAAA;AlB+4BV;;AkBt5BQ;;EAEE,mBAAA;AlBy5BV;;AkBt5BQ;;EAEE,mBAAA;AlBy5BV;;AkBh6BQ;;EAEE,sBAAA;AlBm6BV;;AkBh6BQ;;EAEE,sBAAA;AlBm6BV;;AgB79BI;EEUE;IACE,SAAA;ElBu9BN;EkBp9BI;IApCJ,cAAA;IACA,WAAA;ElB2/BA;EkB7+BA;IACE,cAAA;IACA,WAAA;ElB++BF;EkBj/BA;IACE,cAAA;IACA,UAAA;ElBm/BF;EkBr/BA;IACE,cAAA;IACA,mBAAA;ElBu/BF;EkBz/BA;IACE,cAAA;IACA,UAAA;ElB2/BF;EkB7/BA;IACE,cAAA;IACA,UAAA;ElB+/BF;EkBjgCA;IACE,cAAA;IACA,mBAAA;ElBmgCF;EkBp+BI;IAhDJ,cAAA;IACA,WAAA;ElBuhCA;EkBl+BQ;IAhEN,cAAA;IACA,kBAAA;ElBqiCF;EkBt+BQ;IAhEN,cAAA;IACA,mBAAA;ElByiCF;EkB1+BQ;IAhEN,cAAA;IACA,UAAA;ElB6iCF;EkB9+BQ;IAhEN,cAAA;IACA,mBAAA;ElBijCF;EkBl/BQ;IAhEN,cAAA;IACA,mBAAA;ElBqjCF;EkBt/BQ;IAhEN,cAAA;IACA,UAAA;ElByjCF;EkB1/BQ;IAhEN,cAAA;IACA,mBAAA;ElB6jCF;EkB9/BQ;IAhEN,cAAA;IACA,mBAAA;ElBikCF;EkBlgCQ;IAhEN,cAAA;IACA,UAAA;ElBqkCF;EkBtgCQ;IAhEN,cAAA;IACA,mBAAA;ElBykCF;EkB1gCQ;IAhEN,cAAA;IACA,mBAAA;ElB6kCF;EkB9gCQ;IAhEN,cAAA;IACA,WAAA;ElBilCF;EkB1gCU;IAxDV,cAAA;ElBqkCA;EkB7gCU;IAxDV,wBAAA;ElBwkCA;EkBhhCU;IAxDV,yBAAA;ElB2kCA;EkBnhCU;IAxDV,gBAAA;ElB8kCA;EkBthCU;IAxDV,yBAAA;ElBilCA;EkBzhCU;IAxDV,yBAAA;ElBolCA;EkB5hCU;IAxDV,gBAAA;ElBulCA;EkB/hCU;IAxDV,yBAAA;ElB0lCA;EkBliCU;IAxDV,yBAAA;ElB6lCA;EkBriCU;IAxDV,gBAAA;ElBgmCA;EkBxiCU;IAxDV,yBAAA;ElBmmCA;EkB3iCU;IAxDV,yBAAA;ElBsmCA;EkBniCM;;IAEE,gBAAA;ElBqiCR;EkBliCM;;IAEE,gBAAA;ElBoiCR;EkB3iCM;;IAEE,sBAAA;ElB6iCR;EkB1iCM;;IAEE,sBAAA;ElB4iCR;EkBnjCM;;IAEE,qBAAA;ElBqjCR;EkBljCM;;IAEE,qBAAA;ElBojCR;EkB3jCM;;IAEE,mBAAA;ElB6jCR;EkB1jCM;;IAEE,mBAAA;ElB4jCR;EkBnkCM;;IAEE,qBAAA;ElBqkCR;EkBlkCM;;IAEE,qBAAA;ElBokCR;EkB3kCM;;IAEE,mBAAA;ElB6kCR;EkB1kCM;;IAEE,mBAAA;ElB4kCR;EkBnlCM;;IAEE,qBAAA;ElBqlCR;EkBllCM;;IAEE,qBAAA;ElBolCR;EkB3lCM;;IAEE,mBAAA;ElB6lCR;EkB1lCM;;IAEE,mBAAA;ElB4lCR;EkBnmCM;;IAEE,qBAAA;ElBqmCR;EkBlmCM;;IAEE,qBAAA;ElBomCR;EkB3mCM;;IAEE,mBAAA;ElB6mCR;EkB1mCM;;IAEE,mBAAA;ElB4mCR;EkBnnCM;;IAEE,sBAAA;ElBqnCR;EkBlnCM;;IAEE,sBAAA;ElBonCR;AACF;AgB/qCI;EEUE;IACE,SAAA;ElBwqCN;EkBrqCI;IApCJ,cAAA;IACA,WAAA;ElB4sCA;EkB9rCA;IACE,cAAA;IACA,WAAA;ElBgsCF;EkBlsCA;IACE,cAAA;IACA,UAAA;ElBosCF;EkBtsCA;IACE,cAAA;IACA,mBAAA;ElBwsCF;EkB1sCA;IACE,cAAA;IACA,UAAA;ElB4sCF;EkB9sCA;IACE,cAAA;IACA,UAAA;ElBgtCF;EkBltCA;IACE,cAAA;IACA,mBAAA;ElBotCF;EkBrrCI;IAhDJ,cAAA;IACA,WAAA;ElBwuCA;EkBnrCQ;IAhEN,cAAA;IACA,kBAAA;ElBsvCF;EkBvrCQ;IAhEN,cAAA;IACA,mBAAA;ElB0vCF;EkB3rCQ;IAhEN,cAAA;IACA,UAAA;ElB8vCF;EkB/rCQ;IAhEN,cAAA;IACA,mBAAA;ElBkwCF;EkBnsCQ;IAhEN,cAAA;IACA,mBAAA;ElBswCF;EkBvsCQ;IAhEN,cAAA;IACA,UAAA;ElB0wCF;EkB3sCQ;IAhEN,cAAA;IACA,mBAAA;ElB8wCF;EkB/sCQ;IAhEN,cAAA;IACA,mBAAA;ElBkxCF;EkBntCQ;IAhEN,cAAA;IACA,UAAA;ElBsxCF;EkBvtCQ;IAhEN,cAAA;IACA,mBAAA;ElB0xCF;EkB3tCQ;IAhEN,cAAA;IACA,mBAAA;ElB8xCF;EkB/tCQ;IAhEN,cAAA;IACA,WAAA;ElBkyCF;EkB3tCU;IAxDV,cAAA;ElBsxCA;EkB9tCU;IAxDV,wBAAA;ElByxCA;EkBjuCU;IAxDV,yBAAA;ElB4xCA;EkBpuCU;IAxDV,gBAAA;ElB+xCA;EkBvuCU;IAxDV,yBAAA;ElBkyCA;EkB1uCU;IAxDV,yBAAA;ElBqyCA;EkB7uCU;IAxDV,gBAAA;ElBwyCA;EkBhvCU;IAxDV,yBAAA;ElB2yCA;EkBnvCU;IAxDV,yBAAA;ElB8yCA;EkBtvCU;IAxDV,gBAAA;ElBizCA;EkBzvCU;IAxDV,yBAAA;ElBozCA;EkB5vCU;IAxDV,yBAAA;ElBuzCA;EkBpvCM;;IAEE,gBAAA;ElBsvCR;EkBnvCM;;IAEE,gBAAA;ElBqvCR;EkB5vCM;;IAEE,sBAAA;ElB8vCR;EkB3vCM;;IAEE,sBAAA;ElB6vCR;EkBpwCM;;IAEE,qBAAA;ElBswCR;EkBnwCM;;IAEE,qBAAA;ElBqwCR;EkB5wCM;;IAEE,mBAAA;ElB8wCR;EkB3wCM;;IAEE,mBAAA;ElB6wCR;EkBpxCM;;IAEE,qBAAA;ElBsxCR;EkBnxCM;;IAEE,qBAAA;ElBqxCR;EkB5xCM;;IAEE,mBAAA;ElB8xCR;EkB3xCM;;IAEE,mBAAA;ElB6xCR;EkBpyCM;;IAEE,qBAAA;ElBsyCR;EkBnyCM;;IAEE,qBAAA;ElBqyCR;EkB5yCM;;IAEE,mBAAA;ElB8yCR;EkB3yCM;;IAEE,mBAAA;ElB6yCR;EkBpzCM;;IAEE,qBAAA;ElBszCR;EkBnzCM;;IAEE,qBAAA;ElBqzCR;EkB5zCM;;IAEE,mBAAA;ElB8zCR;EkB3zCM;;IAEE,mBAAA;ElB6zCR;EkBp0CM;;IAEE,sBAAA;ElBs0CR;EkBn0CM;;IAEE,sBAAA;ElBq0CR;AACF;AgBh4CI;EEUE;IACE,SAAA;ElBy3CN;EkBt3CI;IApCJ,cAAA;IACA,WAAA;ElB65CA;EkB/4CA;IACE,cAAA;IACA,WAAA;ElBi5CF;EkBn5CA;IACE,cAAA;IACA,UAAA;ElBq5CF;EkBv5CA;IACE,cAAA;IACA,mBAAA;ElBy5CF;EkB35CA;IACE,cAAA;IACA,UAAA;ElB65CF;EkB/5CA;IACE,cAAA;IACA,UAAA;ElBi6CF;EkBn6CA;IACE,cAAA;IACA,mBAAA;ElBq6CF;EkBt4CI;IAhDJ,cAAA;IACA,WAAA;ElBy7CA;EkBp4CQ;IAhEN,cAAA;IACA,kBAAA;ElBu8CF;EkBx4CQ;IAhEN,cAAA;IACA,mBAAA;ElB28CF;EkB54CQ;IAhEN,cAAA;IACA,UAAA;ElB+8CF;EkBh5CQ;IAhEN,cAAA;IACA,mBAAA;ElBm9CF;EkBp5CQ;IAhEN,cAAA;IACA,mBAAA;ElBu9CF;EkBx5CQ;IAhEN,cAAA;IACA,UAAA;ElB29CF;EkB55CQ;IAhEN,cAAA;IACA,mBAAA;ElB+9CF;EkBh6CQ;IAhEN,cAAA;IACA,mBAAA;ElBm+CF;EkBp6CQ;IAhEN,cAAA;IACA,UAAA;ElBu+CF;EkBx6CQ;IAhEN,cAAA;IACA,mBAAA;ElB2+CF;EkB56CQ;IAhEN,cAAA;IACA,mBAAA;ElB++CF;EkBh7CQ;IAhEN,cAAA;IACA,WAAA;ElBm/CF;EkB56CU;IAxDV,cAAA;ElBu+CA;EkB/6CU;IAxDV,wBAAA;ElB0+CA;EkBl7CU;IAxDV,yBAAA;ElB6+CA;EkBr7CU;IAxDV,gBAAA;ElBg/CA;EkBx7CU;IAxDV,yBAAA;ElBm/CA;EkB37CU;IAxDV,yBAAA;ElBs/CA;EkB97CU;IAxDV,gBAAA;ElBy/CA;EkBj8CU;IAxDV,yBAAA;ElB4/CA;EkBp8CU;IAxDV,yBAAA;ElB+/CA;EkBv8CU;IAxDV,gBAAA;ElBkgDA;EkB18CU;IAxDV,yBAAA;ElBqgDA;EkB78CU;IAxDV,yBAAA;ElBwgDA;EkBr8CM;;IAEE,gBAAA;ElBu8CR;EkBp8CM;;IAEE,gBAAA;ElBs8CR;EkB78CM;;IAEE,sBAAA;ElB+8CR;EkB58CM;;IAEE,sBAAA;ElB88CR;EkBr9CM;;IAEE,qBAAA;ElBu9CR;EkBp9CM;;IAEE,qBAAA;ElBs9CR;EkB79CM;;IAEE,mBAAA;ElB+9CR;EkB59CM;;IAEE,mBAAA;ElB89CR;EkBr+CM;;IAEE,qBAAA;ElBu+CR;EkBp+CM;;IAEE,qBAAA;ElBs+CR;EkB7+CM;;IAEE,mBAAA;ElB++CR;EkB5+CM;;IAEE,mBAAA;ElB8+CR;EkBr/CM;;IAEE,qBAAA;ElBu/CR;EkBp/CM;;IAEE,qBAAA;ElBs/CR;EkB7/CM;;IAEE,mBAAA;ElB+/CR;EkB5/CM;;IAEE,mBAAA;ElB8/CR;EkBrgDM;;IAEE,qBAAA;ElBugDR;EkBpgDM;;IAEE,qBAAA;ElBsgDR;EkB7gDM;;IAEE,mBAAA;ElB+gDR;EkB5gDM;;IAEE,mBAAA;ElB8gDR;EkBrhDM;;IAEE,sBAAA;ElBuhDR;EkBphDM;;IAEE,sBAAA;ElBshDR;AACF;AgBjlDI;EEUE;IACE,SAAA;ElB0kDN;EkBvkDI;IApCJ,cAAA;IACA,WAAA;ElB8mDA;EkBhmDA;IACE,cAAA;IACA,WAAA;ElBkmDF;EkBpmDA;IACE,cAAA;IACA,UAAA;ElBsmDF;EkBxmDA;IACE,cAAA;IACA,mBAAA;ElB0mDF;EkB5mDA;IACE,cAAA;IACA,UAAA;ElB8mDF;EkBhnDA;IACE,cAAA;IACA,UAAA;ElBknDF;EkBpnDA;IACE,cAAA;IACA,mBAAA;ElBsnDF;EkBvlDI;IAhDJ,cAAA;IACA,WAAA;ElB0oDA;EkBrlDQ;IAhEN,cAAA;IACA,kBAAA;ElBwpDF;EkBzlDQ;IAhEN,cAAA;IACA,mBAAA;ElB4pDF;EkB7lDQ;IAhEN,cAAA;IACA,UAAA;ElBgqDF;EkBjmDQ;IAhEN,cAAA;IACA,mBAAA;ElBoqDF;EkBrmDQ;IAhEN,cAAA;IACA,mBAAA;ElBwqDF;EkBzmDQ;IAhEN,cAAA;IACA,UAAA;ElB4qDF;EkB7mDQ;IAhEN,cAAA;IACA,mBAAA;ElBgrDF;EkBjnDQ;IAhEN,cAAA;IACA,mBAAA;ElBorDF;EkBrnDQ;IAhEN,cAAA;IACA,UAAA;ElBwrDF;EkBznDQ;IAhEN,cAAA;IACA,mBAAA;ElB4rDF;EkB7nDQ;IAhEN,cAAA;IACA,mBAAA;ElBgsDF;EkBjoDQ;IAhEN,cAAA;IACA,WAAA;ElBosDF;EkB7nDU;IAxDV,cAAA;ElBwrDA;EkBhoDU;IAxDV,wBAAA;ElB2rDA;EkBnoDU;IAxDV,yBAAA;ElB8rDA;EkBtoDU;IAxDV,gBAAA;ElBisDA;EkBzoDU;IAxDV,yBAAA;ElBosDA;EkB5oDU;IAxDV,yBAAA;ElBusDA;EkB/oDU;IAxDV,gBAAA;ElB0sDA;EkBlpDU;IAxDV,yBAAA;ElB6sDA;EkBrpDU;IAxDV,yBAAA;ElBgtDA;EkBxpDU;IAxDV,gBAAA;ElBmtDA;EkB3pDU;IAxDV,yBAAA;ElBstDA;EkB9pDU;IAxDV,yBAAA;ElBytDA;EkBtpDM;;IAEE,gBAAA;ElBwpDR;EkBrpDM;;IAEE,gBAAA;ElBupDR;EkB9pDM;;IAEE,sBAAA;ElBgqDR;EkB7pDM;;IAEE,sBAAA;ElB+pDR;EkBtqDM;;IAEE,qBAAA;ElBwqDR;EkBrqDM;;IAEE,qBAAA;ElBuqDR;EkB9qDM;;IAEE,mBAAA;ElBgrDR;EkB7qDM;;IAEE,mBAAA;ElB+qDR;EkBtrDM;;IAEE,qBAAA;ElBwrDR;EkBrrDM;;IAEE,qBAAA;ElBurDR;EkB9rDM;;IAEE,mBAAA;ElBgsDR;EkB7rDM;;IAEE,mBAAA;ElB+rDR;EkBtsDM;;IAEE,qBAAA;ElBwsDR;EkBrsDM;;IAEE,qBAAA;ElBusDR;EkB9sDM;;IAEE,mBAAA;ElBgtDR;EkB7sDM;;IAEE,mBAAA;ElB+sDR;EkBttDM;;IAEE,qBAAA;ElBwtDR;EkBrtDM;;IAEE,qBAAA;ElButDR;EkB9tDM;;IAEE,mBAAA;ElBguDR;EkB7tDM;;IAEE,mBAAA;ElB+tDR;EkBtuDM;;IAEE,sBAAA;ElBwuDR;EkBruDM;;IAEE,sBAAA;ElBuuDR;AACF;AgBlyDI;EEUE;IACE,SAAA;ElB2xDN;EkBxxDI;IApCJ,cAAA;IACA,WAAA;ElB+zDA;EkBjzDA;IACE,cAAA;IACA,WAAA;ElBmzDF;EkBrzDA;IACE,cAAA;IACA,UAAA;ElBuzDF;EkBzzDA;IACE,cAAA;IACA,mBAAA;ElB2zDF;EkB7zDA;IACE,cAAA;IACA,UAAA;ElB+zDF;EkBj0DA;IACE,cAAA;IACA,UAAA;ElBm0DF;EkBr0DA;IACE,cAAA;IACA,mBAAA;ElBu0DF;EkBxyDI;IAhDJ,cAAA;IACA,WAAA;ElB21DA;EkBtyDQ;IAhEN,cAAA;IACA,kBAAA;ElBy2DF;EkB1yDQ;IAhEN,cAAA;IACA,mBAAA;ElB62DF;EkB9yDQ;IAhEN,cAAA;IACA,UAAA;ElBi3DF;EkBlzDQ;IAhEN,cAAA;IACA,mBAAA;ElBq3DF;EkBtzDQ;IAhEN,cAAA;IACA,mBAAA;ElBy3DF;EkB1zDQ;IAhEN,cAAA;IACA,UAAA;ElB63DF;EkB9zDQ;IAhEN,cAAA;IACA,mBAAA;ElBi4DF;EkBl0DQ;IAhEN,cAAA;IACA,mBAAA;ElBq4DF;EkBt0DQ;IAhEN,cAAA;IACA,UAAA;ElBy4DF;EkB10DQ;IAhEN,cAAA;IACA,mBAAA;ElB64DF;EkB90DQ;IAhEN,cAAA;IACA,mBAAA;ElBi5DF;EkBl1DQ;IAhEN,cAAA;IACA,WAAA;ElBq5DF;EkB90DU;IAxDV,cAAA;ElBy4DA;EkBj1DU;IAxDV,wBAAA;ElB44DA;EkBp1DU;IAxDV,yBAAA;ElB+4DA;EkBv1DU;IAxDV,gBAAA;ElBk5DA;EkB11DU;IAxDV,yBAAA;ElBq5DA;EkB71DU;IAxDV,yBAAA;ElBw5DA;EkBh2DU;IAxDV,gBAAA;ElB25DA;EkBn2DU;IAxDV,yBAAA;ElB85DA;EkBt2DU;IAxDV,yBAAA;ElBi6DA;EkBz2DU;IAxDV,gBAAA;ElBo6DA;EkB52DU;IAxDV,yBAAA;ElBu6DA;EkB/2DU;IAxDV,yBAAA;ElB06DA;EkBv2DM;;IAEE,gBAAA;ElBy2DR;EkBt2DM;;IAEE,gBAAA;ElBw2DR;EkB/2DM;;IAEE,sBAAA;ElBi3DR;EkB92DM;;IAEE,sBAAA;ElBg3DR;EkBv3DM;;IAEE,qBAAA;ElBy3DR;EkBt3DM;;IAEE,qBAAA;ElBw3DR;EkB/3DM;;IAEE,mBAAA;ElBi4DR;EkB93DM;;IAEE,mBAAA;ElBg4DR;EkBv4DM;;IAEE,qBAAA;ElBy4DR;EkBt4DM;;IAEE,qBAAA;ElBw4DR;EkB/4DM;;IAEE,mBAAA;ElBi5DR;EkB94DM;;IAEE,mBAAA;ElBg5DR;EkBv5DM;;IAEE,qBAAA;ElBy5DR;EkBt5DM;;IAEE,qBAAA;ElBw5DR;EkB/5DM;;IAEE,mBAAA;ElBi6DR;EkB95DM;;IAEE,mBAAA;ElBg6DR;EkBv6DM;;IAEE,qBAAA;ElBy6DR;EkBt6DM;;IAEE,qBAAA;ElBw6DR;EkB/6DM;;IAEE,mBAAA;ElBi7DR;EkB96DM;;IAEE,mBAAA;ElBg7DR;EkBv7DM;;IAEE,sBAAA;ElBy7DR;EkBt7DM;;IAEE,sBAAA;ElBw7DR;AACF;AmB9iEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXsWO;EWrWP,mBXqrB0B;EWprB1B,0CAAA;AnB6iEF;AmBtiEE;EACE,wBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,wBX0fW;EWzfX,2GAAA;AnBuiEJ;AmBpiEE;EACE,uBAAA;AnBsiEJ;AmBniEE;EACE,sBAAA;AnBqiEJ;;AmBjiEA;EACE,uCAAA;AnBoiEF;;AmB7hEA;EACE,iBAAA;AnBgiEF;;AmBthEE;EACE,wBAAA;AnByhEJ;;AmB1gEE;EACE,mBAAA;AnB6gEJ;AmB1gEI;EACE,mBAAA;AnB4gEN;;AmBrgEE;EACE,sBAAA;AnBwgEJ;AmBrgEE;EACE,mBAAA;AnBugEJ;;AmB7/DE;EACE,oDAAA;EACA,8CAAA;AnBggEJ;;AmB1/DE;EACE,oDAAA;EACA,8CAAA;AnB6/DJ;;AmBr/DA;EACE,oDAAA;EACA,8CAAA;AnBw/DF;;AmBh/DE;EACE,mDAAA;EACA,6CAAA;AnBm/DJ;;AoB/nEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApB2nEJ;;AoB7oEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApByoEJ;;AoB3pEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApBupEJ;;AoBzqEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApBqqEJ;;AoBvrEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApBmrEJ;;AoBrsEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApBisEJ;;AoBntEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApB+sEJ;;AoBjuEE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,4BAAA;EACA,iCAAA;EACA,2BAAA;EACA,gCAAA;EACA,0BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB6tEJ;;AmB5kEI;EACE,gBAAA;EACA,iCAAA;AnB+kEN;;AgB1qEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBqlEJ;AACF;AgBjrEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB2lEJ;AACF;AgBvrEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBimEJ;AACF;AgB7rEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBumEJ;AACF;AgBnsEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB6mEJ;AACF;AqBjxEA;EACE,sBbg1ByB;Ea70BzB,gBbLqB;ARsxEvB;;AqB3wEA;EACE,kCAAA;EACA,qCAAA;EACA,gBAAA;EhB8QI,kBALI;EgBtQR,gBbjBqB;EakBrB,gBb0lBiB;ARmrDnB;;AqBzwEA;EACE,kCAAA;EACA,qCAAA;EhBoQI,sBALI;AL8gEV;;AqBzwEA;EACE,iCAAA;EACA,oCAAA;EhB8PI,uBALI;ALohEV;;AsB1yEA;EACE,mBdw0BqB;EH9iBjB,kBALI;EiBjRR,cd2pBW;ARgpDb;;AuBhzEA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;ElBwRI,oBALI;EkBhRR,gBf+lBmB;Ee9lBnB,gBfomBiB;EenmBjB,cfWS;EeVT,gBAAA;EACA,sBfEM;EeDN,4BAAA;EACA,yBAAA;EdGE,sBAAA;EeHE,wEDMJ;AvB8yEF;AwBhzEM;EDhBN;ICiBQ,gBAAA;ExBmzEN;AACF;AuBjzEE;EACE,gBAAA;AvBmzEJ;AuBjzEI;EACE,eAAA;AvBmzEN;AuB9yEE;EACE,cfXO;EeYP,sBfnBI;EeoBJ,iCfs1BuB;Eer1BvB,UAAA;EAKE,gBfm1BmB;ARy9CzB;AuBxyEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvB4xEJ;AuBvxEE;EACE,cAAA;EACA,UAAA;AvByxEJ;AuBrxEE;EACE,cfvDO;EeyDP,UAAA;AvBsxEJ;AuB9wEE;EAEE,sBfvEI;Ee0EJ,UAAA;AvB6wEJ;AuBzwEE;EACE,uBAAA;EACA,wBAAA;EACA,uBfgqBkB;Ee/pBlB,cf3EO;EiBnBT,yBjBcS;EekFP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bf0wBiB;EezwBjB,gBAAA;ECzFE,qID0FF;AvB2wEJ;AwBj2EM;ED0EJ;ICzEM,gBAAA;ExBo2EN;AACF;AuB7wEE;EACE,yBfq6BwB;AR02C5B;;AuBtwEA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBfmfiB;EelfjB,cftGS;EeuGT,6BAAA;EACA,yBAAA;EACA,mBAAA;AvBywEF;AuBvwEE;EACE,UAAA;AvBywEJ;AuBtwEE;EAEE,gBAAA;EACA,eAAA;AvBuwEJ;;AuB5vEA;EACE,uCfovBgB;EenvBhB,yBAAA;ElByII,uBALI;EIvQN,sBAAA;ATo4EJ;AuB7vEE;EACE,yBAAA;EACA,0BAAA;EACA,0BfgnBqB;AR+oDzB;;AuB3vEA;EACE,wCfwuBgB;EevuBhB,0BAAA;ElB4HI,sBALI;EIvQN,sBAAA;ATg5EJ;AuB5vEE;EACE,0BAAA;EACA,2BAAA;EACA,0BfumBqB;ARupDzB;;AuBtvEE;EACE,wCfqtBW;ARoiDf;AuBtvEE;EACE,uCfktBc;ARsiDlB;AuBrvEE;EACE,wCf+sBc;ARwiDlB;;AuBlvEA;EACE,Wf6sBiB;Ee5sBjB,oCfssBa;EersBb,kBf6jBoB;ARwrDtB;AuBnvEE;EACE,eAAA;AvBqvEJ;AuBlvEE;EACE,oBAAA;EdvLA,sBAAA;AT46EJ;AuBjvEE;EACE,oBAAA;Ed5LA,sBAAA;ATg7EJ;AuBhvEE;EAAoB,mCfsrBJ;AR6jDlB;AuBlvEE;EAAoB,oCfsrBJ;AR+jDlB;;A0Bp8EA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,sCAAA;ErBqRI,oBALI;EqB7QR,gBlB4lBmB;EkB3lBnB,gBlBimBiB;EkBhmBjB,clBQS;EkBPT,gBAAA;EACA,sBlBDM;EkBEN,mFAAA;EACA,4BAAA;EACA,sClBu8BwB;EkBt8BxB,0BlBu8BoB;EkBt8BpB,yBAAA;EjBHE,sBAAA;EeHE,wEESJ;A1Bo8EF;AwBz8EM;EEfN;IFgBQ,gBAAA;ExB48EN;AACF;A0Bv8EE;EACE,iClB81BuB;EkB71BvB,UAAA;EAKE,kDlBy8ByB;AR4/C/B;A0Bj8EE;EAEE,mBlBytBkB;EkBxtBlB,sBAAA;A1Bk8EJ;A0B/7EE;EAEE,yBlB5BO;AR49EX;A0B37EE;EACE,kBAAA;EACA,0BAAA;A1B67EJ;;A0Bz7EA;EACE,qBlBktBuB;EkBjtBvB,wBlBitBuB;EkBhtBvB,qBlBitBuB;EH9enB,uBALI;EIvQN,sBAAA;ATu+EJ;;A0Bz7EA;EACE,sBlB8sBuB;EkB7sBvB,yBlB6sBuB;EkB5sBvB,qBlB6sBuB;EHlfnB,sBALI;EIvQN,sBAAA;AT++EJ;;A0Bv7EI;EACE,gEAAA;A1B07EN;;A2BlgFA;EACE,cAAA;EACA,sBnB64BsB;EmB54BtB,mBnB64ByB;EmB54BzB,uBnB64ByB;ARwnD3B;A2BngFE;EACE,WAAA;EACA,mBAAA;A3BqgFJ;;A2BjgFA;EACE,oBnBm4ByB;EmBl4BzB,eAAA;EACA,iBAAA;A3BogFF;A2BlgFE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A3BogFJ;;A2BhgFA;EACE,wBAAA;EAEA,cAAA;EACA,UnBk3BuB;EmBj3BvB,WnBi3BuB;EmBh3BvB,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCnBm3BwB;EmBl3BxB,iCAAA;UAAA,yBAAA;A3BkgFF;A2B//EE;ElB3BE,sBAAA;AT6hFJ;A2B9/EE;EAEE,kBnB22B6B;ARopDjC;A2B5/EE;EACE,uBnBk2B6B;AR4pDjC;A2B3/EE;EACE,iCnB8zBuB;EmB7zBvB,UAAA;EACA,kDnB4sByB;ARizD7B;A2B1/EE;EACE,yBnBpBG;EmBqBH,qBnBrBG;ARihFP;A2B1/EI;EAII,iEAAA;A3By/ER;A2Br/EI;EAII,iEAAA;A3Bo/ER;A2B/+EE;EACE,yBnBzCG;EmB0CH,qBnB1CG;EmB+CD,iEAAA;A3B6+EN;A2Bz+EE;EACE,oBAAA;EACA,YAAA;EACA,YnB00BgC;ARiqDpC;A2Bp+EI;EACE,eAAA;EACA,YnBi0B8B;ARqqDpC;;A2Bx9EA;EACE,mBnB4zB0B;AR+pD5B;A2Bz9EE;EACE,4DAAA;EAEA,UnBszBgB;EmBrzBhB,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A3B09EJ;AwB5kFM;EG0GJ;IHzGM,gBAAA;ExB+kFN;AACF;A2B79EI;EACE,4DAAA;A3B+9EN;A2B59EI;EACE,iCnBqzB4B;EmBhzB1B,4DAAA;A3B09ER;A2Br9EE;EACE,oBnBgyBwB;EmB/xBxB,eAAA;A3Bu9EJ;A2Br9EI;EACE,oBAAA;EACA,cAAA;A3Bu9EN;;A2Bl9EA;EACE,qBAAA;EACA,kBnB8wB6B;ARusD/B;;A2Bl9EA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3Bq9EF;A2Bj9EI;EACE,oBAAA;EACA,YAAA;EACA,anBgoBiB;ARm1DvB;;A2B58EI;EACE,4DAAA;A3B+8EN;;A4BloFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5BqoFF;A4BnoFE;EACE,UAAA;A5BqoFJ;A4BjoFI;EAA0B,gCpBs/BM;AR8oDpC;A4BnoFI;EAA0B,gCpBq/BM;ARipDpC;A4BnoFE;EACE,SAAA;A5BqoFJ;A4BloFE;EACE,WpBu+BqB;EoBt+BrB,YpBs+BqB;EoBr+BrB,oBAAA;EACA,gBAAA;EH1BF,yBjB0CK;EoBdH,SpBq+BsB;ECl/BtB,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A5BmoFJ;AwBlpFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ExBqpFN;AACF;A4BtoFI;EHjCF,yBjBsgC2B;ARoqD7B;A4BpoFE;EACE,WpBg9BqB;EoB/8BrB,cpBg9BsB;EoB/8BtB,kBAAA;EACA,epB+8BsB;EoB98BtB,yBpB5BO;EoB6BP,yBAAA;EnB7BA,mBAAA;AToqFJ;A4BloFE;EACE,WpB48BqB;EoB38BrB,YpB28BqB;EoB18BrB,gBAAA;EHpDF,yBjB0CK;EoBYH,SpB28BsB;ECl/BtB,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A5BmoFJ;AwB5qFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ExB+qFN;AACF;A4BtoFI;EH3DF,yBjBsgC2B;AR8rD7B;A4BpoFE;EACE,WpBs7BqB;EoBr7BrB,cpBs7BsB;EoBr7BtB,kBAAA;EACA,epBq7BsB;EoBp7BtB,yBpBtDO;EoBuDP,yBAAA;EnBvDA,mBAAA;AT8rFJ;A4BloFE;EACE,oBAAA;A5BooFJ;A4BloFI;EACE,yBpB9DK;ARksFX;A4BjoFI;EACE,yBpBlEK;ARqsFX;;A6B1tFA;EACE,kBAAA;A7B6tFF;A6B3tFE;;;EAGE,0BrBihCmB;EqBhhCnB,8BrBghCmB;EqB/gCnB,iBrBghCwB;AR6sD5B;A6B1tFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELRE,gEKSF;A7B4tFJ;AwBjuFM;EKTJ;ILUM,gBAAA;ExBouFN;AACF;A6B9tFE;;EAEE,kBAAA;A7BguFJ;A6B9tFI;;EACE,kBAAA;A7BiuFN;A6B9tFI;;;EAEE,qBrBq/B0B;EqBp/B1B,wBrBq/B0B;AR4uDhC;A6B9tFI;;EACE,qBrBg/B0B;EqB/+B1B,wBrBg/B0B;ARivDhC;A6B7tFE;EACE,qBrB0+B4B;EqBz+B5B,wBrB0+B4B;ARqvDhC;A6BxtFI;;;;EACE,2CAAA;EACA,8DrBm+B0B;AR0vDhC;A6B3tFM;;;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aCm/BgC;EDl/BhC,WAAA;EACA,sBrBnDA;ECGJ,sBAAA;ATixFJ;A6B1tFI;EACE,2CAAA;EACA,8DrBk9B0B;AR0wDhC;A6BvtFI;EACE,mBAAA;A7BytFN;A6BrtFE;;EAEE,cC1EO;A9BiyFX;A6BrtFI;;EACE,sBrB3EE;ARmyFR;;A+B/yFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/BkzFF;A+BhzFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A/BkzFJ;A+B9yFE;;;EAGE,UAAA;A/BgzFJ;A+B1yFE;EACE,kBAAA;EACA,UAAA;A/B4yFJ;A+B1yFI;EACE,UAAA;A/B4yFN;;A+BjyFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;E1B8OI,oBALI;E0BvOR,gBvBsjBmB;EuBrjBnB,gBvB2jBiB;EuB1jBjB,cvB9BS;EuB+BT,kBAAA;EACA,mBAAA;EACA,yBvBtCS;EuBuCT,yBAAA;EtBtCE,sBAAA;AT20FJ;;A+B3xFA;;;;EAIE,0BAAA;E1BwNI,sBALI;EIvQN,sBAAA;ATo1FJ;;A+B3xFA;;;;EAIE,yBAAA;E1B+MI,uBALI;EIvQN,sBAAA;AT61FJ;;A+B3xFA;;EAEE,mBAAA;A/B8xFF;;A+BjxFI;;;;EtBjEA,0BAAA;EACA,6BAAA;ATy1FJ;A+BhxFI;;;;EtB1EA,0BAAA;EACA,6BAAA;ATg2FJ;A+B1wFE;EACE,2BAAA;EtB1EA,yBAAA;EACA,4BAAA;ATu1FJ;A+B1wFE;;EtB9EE,yBAAA;EACA,4BAAA;AT41FJ;;AgCp3FE;EACE,aAAA;EACA,WAAA;EACA,mBxBgzBmB;EH9iBjB,kBALI;E2B1PN,cxBkhCqB;ARo2DzB;;AgCn3FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,oBALI;E2B7ON,WAxBc;EAyBd,yCAxBiB;EvBHjB,sBAAA;ATi5FJ;;AgCj3FI;;;;EAEE,cAAA;AhCs3FN;;AgCr6FI;EAqDE,qBxBu/BmB;EwBp/BjB,qCxBs0Ba;EwBr0Bb,yDAAA;EACA,4BAAA;EACA,4DAAA;EACA,kEAAA;AhCk3FR;AgC/2FM;EACE,qBxB4+BiB;EwB3+BjB,kDAhDa;AhCi6FrB;;AgCl7FI;EA0EI,qCxBozBa;EwBnzBb,oFAAA;AhC42FR;;AgCv7FI;EAkFE,qBxB09BmB;AR+4DzB;AgCt2FQ;EAEE,iEAAA;EACA,qBxBk4B8B;EwBj4B9B,yDAAA;EACA,6EAAA;AhCu2FV;AgCn2FM;EACE,qBxB68BiB;EwB58BjB,kDA/Ea;AhCo7FrB;;AgCr8FI;EAwGI,0CAAA;AhCi2FR;;AgCz8FI;EA+GE,qBxB67BmB;ARi6DzB;AgC51FM;EACE,yBxB07BiB;ARo6DzB;AgC31FM;EACE,kDArGa;AhCk8FrB;AgC11FM;EACE,cxBk7BiB;AR06DzB;;AgCv1FI;EACE,kBAAA;AhC01FN;;AgC19FI;;;;;EA0IM,UAAA;AhCw1FV;;AgC98FE;EACE,aAAA;EACA,WAAA;EACA,mBxBgzBmB;EH9iBjB,kBALI;E2B1PN,cxBkhCqB;AR87DzB;;AgC78FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,oBALI;E2B7ON,WAxBc;EAyBd,wCAxBiB;EvBHjB,sBAAA;AT2+FJ;;AgC38FI;;;;EAEE,cAAA;AhCg9FN;;AgC//FI;EAqDE,qBxBu/BmB;EwBp/BjB,qCxBs0Ba;EwBr0Bb,yDAAA;EACA,4BAAA;EACA,4DAAA;EACA,kEAAA;AhC48FR;AgCz8FM;EACE,qBxB4+BiB;EwB3+BjB,iDAhDa;AhC2/FrB;;AgC5gGI;EA0EI,qCxBozBa;EwBnzBb,oFAAA;AhCs8FR;;AgCjhGI;EAkFE,qBxB09BmB;ARy+DzB;AgCh8FQ;EAEE,iEAAA;EACA,qBxBk4B8B;EwBj4B9B,yDAAA;EACA,6EAAA;AhCi8FV;AgC77FM;EACE,qBxB68BiB;EwB58BjB,iDA/Ea;AhC8gGrB;;AgC/hGI;EAwGI,0CAAA;AhC27FR;;AgCniGI;EA+GE,qBxB67BmB;AR2/DzB;AgCt7FM;EACE,yBxB07BiB;AR8/DzB;AgCr7FM;EACE,iDArGa;AhC4hGrB;AgCp7FM;EACE,cxBk7BiB;ARogEzB;;AgCj7FI;EACE,kBAAA;AhCo7FN;;AgCpjGI;;;;;EA4IM,UAAA;AhCg7FV;;AiC9jGA;EAEE,wBAAA;EACA,6BAAA;EACA,sBAAA;E5BuRI,6BALI;E4BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,wCAAA;EACA,yBAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EgBfF,kCQkCqB;ETtBjB,qISwBJ;AjC2jGF;AwB/kGM;EShBN;ITiBQ,gBAAA;ExBklGN;AACF;AiC9jGE;EACE,gCAAA;EACA,qBAAA;EACA,wCAAA;EACA,8CAAA;AjCgkGJ;AiC7jGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AjC8jGJ;AiC3jGE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AjCyjGN;AiCrjGE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AjCmjGN;AiC/iGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AjC2iGJ;AiCxiGI;EAKI,0CAAA;AjCsiGR;AiCjiGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AjCgiGJ;;AiCphGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlC8nGF;;AiCriGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlC+oGF;;AiCtjGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCgqGF;;AiCvkGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCirGF;;AiCxlGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCksGF;;AiCzmGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCmtGF;;AiC1nGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCouGF;;AiC3oGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCqvGF;;AiC5pGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCswGF;;AiC7qGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AlCuxGF;;AiC9rGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AlCwyGF;;AiCrrGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCgyGF;;AiCtsGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCizGF;;AiCvtGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCk0GF;;AiCxuGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCm1GF;;AiCzvGE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCo2GF;;AiC1wGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCq3GF;;AiC3xGE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCs4GF;;AiC5yGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCu5GF;;AiC7zGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCw6GF;;AiC90GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCy7GF;;AiC/1GE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC08GF;;AiCp2GA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBzB6SgB;ARyjGlB;AiCj2GE;EAEE,0BzBySoB;ARyjGxB;AiC/1GE;EACE,0BAAA;AjCi2GJ;AiC91GE;EACE,gCAAA;AjCg2GJ;;AiCr1GA;ECxIE,6BAAA;EACA,2BAAA;E7B8NI,+BALI;E6BvNR,8BAAA;AlCi+GF;;AiCx1GA;EC5IE,4BAAA;EACA,2BAAA;E7B8NI,gCALI;E6BvNR,+BAAA;AlCw+GF;;AmC3iHA;EXgBM,gCWfJ;AnC8iHF;AwB3hHM;EWpBN;IXqBQ,gBAAA;ExB8hHN;AACF;AmCjjHE;EACE,UAAA;AnCmjHJ;;AmC7iHE;EACE,aAAA;AnCgjHJ;;AmC5iHA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;AnC+iHF;AwB7iHM;EWLN;IXMQ,gBAAA;ExBgjHN;AACF;AmCljHE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;AnCojHJ;AwBvjHM;EWAJ;IXCM,gBAAA;ExB0jHN;AACF;;AoC/kHA;;;;;;EAME,kBAAA;ApCklHF;;AoC/kHA;EACE,mBAAA;ApCklHF;;AoC3kHA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;E/BuQI,kCALI;E+BhQR,4BAAA;EACA,sBAAA;EACA,+CAAA;EACA,oCAAA;EACA,6BAAA;EACA,0CAAA;EACA,iCAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;ATqnHJ;AoCxkHE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;ApC0kHJ;;AoCljHI;EACE,oBAAA;ApCqjHN;AoCnjHM;EACE,WAAA;EACA,OAAA;ApCqjHR;;AoCjjHI;EACE,kBAAA;ApCojHN;AoCljHM;EACE,QAAA;EACA,UAAA;ApCojHR;;AgB9lHI;EoB4BA;IACE,oBAAA;EpCskHJ;EoCpkHI;IACE,WAAA;IACA,OAAA;EpCskHN;EoClkHE;IACE,kBAAA;EpCokHJ;EoClkHI;IACE,QAAA;IACA,UAAA;EpCokHN;AACF;AgB/mHI;EoB4BA;IACE,oBAAA;EpCslHJ;EoCplHI;IACE,WAAA;IACA,OAAA;EpCslHN;EoCllHE;IACE,kBAAA;EpColHJ;EoCllHI;IACE,QAAA;IACA,UAAA;EpColHN;AACF;AgB/nHI;EoB4BA;IACE,oBAAA;EpCsmHJ;EoCpmHI;IACE,WAAA;IACA,OAAA;EpCsmHN;EoClmHE;IACE,kBAAA;EpComHJ;EoClmHI;IACE,QAAA;IACA,UAAA;EpComHN;AACF;AgB/oHI;EoB4BA;IACE,oBAAA;EpCsnHJ;EoCpnHI;IACE,WAAA;IACA,OAAA;EpCsnHN;EoClnHE;IACE,kBAAA;EpConHJ;EoClnHI;IACE,QAAA;IACA,UAAA;EpConHN;AACF;AgB/pHI;EoB4BA;IACE,oBAAA;EpCsoHJ;EoCpoHI;IACE,WAAA;IACA,OAAA;EpCsoHN;EoCloHE;IACE,kBAAA;EpCooHJ;EoCloHI;IACE,QAAA;IACA,UAAA;EpCooHN;AACF;AoC3nHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;ApC6nHJ;AoCpnHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;ApCsnHJ;AoCjnHI;EACE,iBAAA;ApCmnHN;;AoC7mHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;ApCgnHJ;AoC3mHI;EACE,iBAAA;ApC6mHN;;AoCtmHA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;ApCymHF;;AoCnmHA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5BsbmB;E4BrbnB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;AT4wHJ;AoCnmHE;EAEE,0CAAA;EACA,qBAAA;EX3LF,kDW4LuB;ApComHzB;AoCjmHE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;ApCkmHzB;AoC/lHE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;ApCgmHJ;;AoC1lHA;EACE,cAAA;ApC6lHF;;AoCzlHA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,uBALI;E+B5DR,sCAAA;EACA,mBAAA;ApC4lHF;;AoCxlHA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;ApC2lHF;;AoCvlHA;EAEE,4BAAA;EACA,yBAAA;EACA,+CAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sDAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;ApCylHF;;AqC/0HA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArCk1HF;AqCh1HE;;EACE,kBAAA;EACA,cAAA;ArCm1HJ;AqC90HE;;;;;;;;;;;;EAME,UAAA;ArCs1HJ;;AqCj1HA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArCo1HF;AqCl1HE;EACE,WAAA;ArCo1HJ;;AqCh1HA;E5BhBI,uBAAA;ATo2HJ;AqCh1HE;;EAEE,2BAAA;ArCk1HJ;AqC90HE;;;E5BVE,0BAAA;EACA,6BAAA;AT61HJ;AqC10HE;;;E5BNE,yBAAA;EACA,4BAAA;ATq1HJ;;AqC7zHA;EACE,sBAAA;EACA,qBAAA;ArCg0HF;AqC9zHE;EAGE,cAAA;ArC8zHJ;AqC3zHE;EACE,eAAA;ArC6zHJ;;AqCzzHA;EACE,wBAAA;EACA,uBAAA;ArC4zHF;;AqCzzHA;EACE,wBAAA;EACA,uBAAA;ArC4zHF;;AqCxyHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArC2yHF;AqCzyHE;;EAEE,WAAA;ArC2yHJ;AqCxyHE;;EAEE,0BAAA;ArC0yHJ;AqCtyHE;;E5B1FE,6BAAA;EACA,4BAAA;ATo4HJ;AqCtyHE;;E5B7GE,yBAAA;EACA,0BAAA;ATu5HJ;;AsC/6HA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC86HF;;AsC36HA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AtC66HF;AwBz7HM;EcGN;IdFQ,gBAAA;ExB47HN;AACF;AsCh7HE;EAEE,qCAAA;EACA,qBAAA;AtCi7HJ;AsC96HE;EACE,UAAA;EACA,kDRkhBoB;A9B85GxB;AsC56HE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtC66HJ;;AsCr6HA;EAEE,6BAAA;EACA,uCAAA;EACA,8BAAA;EACA,kEAAA;EACA,wCAAA;EACA,kCAAA;EACA,4DAAA;EAGA,oFAAA;AtCq6HF;AsCn6HE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;ATm9HJ;AsCp6HI;EAGE,kBAAA;EACA,wDAAA;AtCo6HN;AsCh6HE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtCk6HJ;AsC/5HE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;ATk+HJ;;AsCv5HA;EAEE,qCAAA;EACA,sCAAA;EACA,sCAAA;AtCy5HF;AsCt5HE;E7B5FE,gDAAA;ATq/HJ;AsCr5HE;;EAEE,4CAAA;EbjHF,oDakHuB;AtCu5HzB;;AsC94HA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtC84HF;AsC54HE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtC84HJ;AsC54HI;EAEE,iCAAA;AtC64HN;AsCz4HE;;EAEE,gB9Bqde;E8Bpdf,gDAAA;EACA,iCAAA;AtC24HJ;;AsCj4HE;;EAEE,cAAA;EACA,kBAAA;AtCo4HJ;;AsC/3HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtCk4HJ;;AsC53HE;;EACE,WAAA;AtCg4HJ;;AsCt3HE;EACE,aAAA;AtCy3HJ;AsCv3HE;EACE,cAAA;AtCy3HJ;;AuCtjIA;EAEE,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;EACA,kCAAA;EACA,wCAAA;EACA,gCAAA;EACA,sCAAA;EACA,uCAAA;EACA,sCAAA;EACA,gCAAA;EACA,0CAAA;EACA,qEAAA;EACA,6CAAA;EACA,2CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvCsjIF;AuChjIE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvCwjIJ;AuCpiIA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EAEA,mBAAA;AvCqiIF;AuCniIE;EAEE,yCAAA;EACA,qBAAA;AvCoiIJ;;AuC3hIA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvC0hIF;AuCvhII;EAEE,oCAAA;AvCwhIN;AuCphIE;EACE,gBAAA;AvCshIJ;;AuC7gIA;EACE,mB/B09BmB;E+Bz9BnB,sB/By9BmB;E+Bx9BnB,6BAAA;AvCghIF;AuC9gIE;;;EAGE,oCAAA;AvCghIJ;;AuCngIA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvCogIF;;AuChgIA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AvCmgIF;AwB5oIM;EeiIN;IfhIQ,gBAAA;ExB+oIN;AACF;AuCtgIE;EACE,qBAAA;AvCwgIJ;AuCrgIE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvCugIJ;;AuCjgIA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvCogIF;;AuCjgIA;EACE,yCAAA;EACA,gBAAA;AvCogIF;;AgB9nII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvC2/HN;EuCz/HM;IACE,mBAAA;EvC2/HR;EuCz/HQ;IACE,kBAAA;EvC2/HV;EuCx/HQ;IACE,kDAAA;IACA,iDAAA;EvC0/HV;EuCt/HM;IACE,iBAAA;EvCw/HR;EuCr/HM;IACE,wBAAA;IACA,gBAAA;EvCu/HR;EuCp/HM;IACE,aAAA;EvCs/HR;EuCn/HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCm/HR;EuCh/HQ;IACE,aAAA;EvCk/HV;EuC/+HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCi/HV;AACF;AgB9qII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvC0iIN;EuCxiIM;IACE,mBAAA;EvC0iIR;EuCxiIQ;IACE,kBAAA;EvC0iIV;EuCviIQ;IACE,kDAAA;IACA,iDAAA;EvCyiIV;EuCriIM;IACE,iBAAA;EvCuiIR;EuCpiIM;IACE,wBAAA;IACA,gBAAA;EvCsiIR;EuCniIM;IACE,aAAA;EvCqiIR;EuCliIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCkiIR;EuC/hIQ;IACE,aAAA;EvCiiIV;EuC9hIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCgiIV;AACF;AgB7tII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCylIN;EuCvlIM;IACE,mBAAA;EvCylIR;EuCvlIQ;IACE,kBAAA;EvCylIV;EuCtlIQ;IACE,kDAAA;IACA,iDAAA;EvCwlIV;EuCplIM;IACE,iBAAA;EvCslIR;EuCnlIM;IACE,wBAAA;IACA,gBAAA;EvCqlIR;EuCllIM;IACE,aAAA;EvColIR;EuCjlIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCilIR;EuC9kIQ;IACE,aAAA;EvCglIV;EuC7kIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC+kIV;AACF;AgB5wII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCwoIN;EuCtoIM;IACE,mBAAA;EvCwoIR;EuCtoIQ;IACE,kBAAA;EvCwoIV;EuCroIQ;IACE,kDAAA;IACA,iDAAA;EvCuoIV;EuCnoIM;IACE,iBAAA;EvCqoIR;EuCloIM;IACE,wBAAA;IACA,gBAAA;EvCooIR;EuCjoIM;IACE,aAAA;EvCmoIR;EuChoIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCgoIR;EuC7nIQ;IACE,aAAA;EvC+nIV;EuC5nIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC8nIV;AACF;AgB3zII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCurIN;EuCrrIM;IACE,mBAAA;EvCurIR;EuCrrIQ;IACE,kBAAA;EvCurIV;EuCprIQ;IACE,kDAAA;IACA,iDAAA;EvCsrIV;EuClrIM;IACE,iBAAA;EvCorIR;EuCjrIM;IACE,wBAAA;IACA,gBAAA;EvCmrIR;EuChrIM;IACE,aAAA;EvCkrIR;EuC/qIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvC+qIR;EuC5qIQ;IACE,aAAA;EvC8qIV;EuC3qIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC6qIV;AACF;AuCpuII;EAEI,iBAAA;EACA,2BAAA;AvCquIR;AuCnuIQ;EACE,mBAAA;AvCquIV;AuCnuIU;EACE,kBAAA;AvCquIZ;AuCluIU;EACE,kDAAA;EACA,iDAAA;AvCouIZ;AuChuIQ;EACE,iBAAA;AvCkuIV;AuC/tIQ;EACE,wBAAA;EACA,gBAAA;AvCiuIV;AuC9tIQ;EACE,aAAA;AvCguIV;AuC7tIQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AvC6tIV;AuC1tIU;EACE,aAAA;AvC4tIZ;AuCztIU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvC2tIZ;;AuC1sIA;;EAGE,2CAAA;EACA,8BAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AvC4sIF;;AuCtsII;EACE,qEAAA;AvCysIN;;AwCl+IA;EAEE,0BAAA;EACA,0BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4CAAA;EACA,kCAAA;EACA,sBAAA;EACA,oDAAA;EACA,gCAAA;EACA,+BAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;ATo/IJ;AwC/9IE;EACE,eAAA;EACA,cAAA;AxCi+IJ;AwC99IE;EACE,mBAAA;EACA,sBAAA;AxCg+IJ;AwC99II;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;ATu/IJ;AwC99II;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AT8+IJ;AwC39IE;;EAEE,aAAA;AxC69IJ;;AwCz9IA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxC09IF;;AwCv9IA;EACE,4CAAA;EACA,iCAAA;AxC09IF;;AwCv9IA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AxC09IF;;AwCv9IA;EACE,gBAAA;AxC09IF;;AwCt9IE;EACE,qBAAA;AxCy9IJ;AwCt9IE;EACE,oCAAA;AxCw9IJ;;AwCh9IA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxCm9IF;AwCj9IE;E/B7FE,wFAAA;ATijJJ;;AwC/8IA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxCk9IF;AwCh9IE;E/BxGE,wFAAA;AT2jJJ;;AwCz8IA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AxC48IF;AwC18IE;EACE,mCAAA;EACA,sCAAA;AxC48IJ;;AwCx8IA;EACE,uDAAA;EACA,sDAAA;AxC28IF;;AwCv8IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;ATqlJJ;;AwCv8IA;;;EAGE,WAAA;AxC08IF;;AwCv8IA;;E/B3II,0DAAA;EACA,2DAAA;ATulJJ;;AwCx8IA;;E/BlII,8DAAA;EACA,6DAAA;AT+kJJ;;AwCj8IE;EACE,0CAAA;AxCo8IJ;AgB/jJI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;ExCo8IF;EwCj8IE;IAEE,SAAA;IACA,gBAAA;ExCk8IJ;EwCh8II;IACE,cAAA;IACA,cAAA;ExCk8IN;EwC77IM;I/B3KJ,0BAAA;IACA,6BAAA;ET2mJF;EwC97IQ;;IAGE,0BAAA;ExC+7IV;EwC77IQ;;IAGE,6BAAA;ExC87IV;EwC17IM;I/B5KJ,yBAAA;IACA,4BAAA;ETymJF;EwC37IQ;;IAGE,yBAAA;ExC47IV;EwC17IQ;;IAGE,4BAAA;ExC27IV;AACF;;AyChqJA;EAEE,6BAAA;EACA,uBAAA;EACA,8KAAA;EACA,iDAAA;EACA,gCAAA;EACA,sCAAA;EACA,wDAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,2BAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,0DAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;AzCkqJF;;AyC9pJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC2PI,oBALI;EoCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,0CiB4BJ;AzCiqJF;AwBzrJM;EiBWN;IjBVQ,gBAAA;ExB4rJN;AACF;AyCpqJE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzCsqJJ;AyCpqJI;EACE,qDAAA;EACA,iDAAA;AzCsqJN;AyCjqJE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AzCmqJJ;AwBltJM;EiBsCJ;IjBrCM,gBAAA;ExBqtJN;AACF;AyCrqJE;EACE,UAAA;AzCuqJJ;AyCpqJE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AzCsqJJ;;AyClqJA;EACE,gBAAA;AzCqqJF;;AyClqJA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzCqqJF;AyCnqJE;EhC/DE,yDAAA;EACA,0DAAA;ATquJJ;AyCpqJI;EhClEA,+DAAA;EACA,gEAAA;ATyuJJ;AyCnqJE;EACE,aAAA;AzCqqJJ;AyCjqJE;EhC9DE,6DAAA;EACA,4DAAA;ATkuJJ;AyCjqJM;EhClEF,mEAAA;EACA,kEAAA;ATsuJJ;AyChqJI;EhCvEA,6DAAA;EACA,4DAAA;AT0uJJ;;AyC9pJA;EACE,8EAAA;AzCiqJF;;AyCxpJE;EACE,eAAA;AzC2pJJ;AyCxpJE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;AT+wJJ;AyCxpJI;EAAgB,aAAA;AzC2pJpB;AyC1pJI;EAAe,gBAAA;AzC6pJnB;AyC1pJM;EhC3HF,gBAAA;ATwxJJ;;AyCnpJI;EACE,iEAAA;EACA,wEAAA;AzCspJN;;A0ChzJA;EAEE,+BAAA;EACA,kCAAA;EACA,mCAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;ATgzJJ;;A0C1yJE;EACE,iDAAA;A1C6yJJ;A0C3yJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1C6yJN;A0CzyJE;EACE,6CAAA;A1C2yJJ;;A2Ch1JA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,8BAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,uCAAA;EACA,oCAAA;EACA,iCAAA;EACA,2CAAA;EACA,oCAAA;EACA,iCAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AXq2JF;;A2C90JA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A3Cg1JF;AwBj2JM;EmBQN;InBPQ,gBAAA;ExBo2JN;AACF;A2Cn1JE;EACE,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,+CAAA;EACA,qDAAA;A3Cq1JJ;A2Cl1JE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnCwqCuB;EmCvqCvB,iDAAA;A3Co1JJ;A2Cj1JE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A3Ck1JJ;A2C/0JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3Cg1JJ;;A2C30JE;EACE,iBnC2oCsB;ARmsH1B;A2C7zJI;ElCxEA,iDAAA;ATw4JJ;;A2CrzJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,sCALI;EuCnRR,qCAAA;A5C25JF;;A2CxzJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,uCALI;EuCnRR,sCAAA;A5Ck6JF;;A6Cp6JA;EAEE,2BAAA;EACA,2BAAA;ExCuRI,yBALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ATy6JJ;A6Ch6JE;EACE,aAAA;A7Ck6JJ;;A6C75JA;EACE,kBAAA;EACA,SAAA;A7Cg6JF;;A8Ch8JA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;ATo8JJ;;A8C57JA;EAEE,cAAA;A9C87JF;;A8C17JA;EACE,gBtCwkBiB;EsCvkBjB,iCAAA;A9C67JF;;A8Cr7JA;EACE,sBtCo5C4B;ARoiH9B;A8Cr7JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;A9Cu7JJ;;A8C/6JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Ck7JJ;;A8Ct7JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9Cy7JJ;;A8C77JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cg8JJ;;A8Cp8JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Cu8JJ;;A8C38JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C88JJ;;A8Cl9JE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9Cq9JJ;;A8Cz9JE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9C49JJ;;A8Ch+JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Cm+JJ;;A8Cv+JE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9C0+JJ;;A8C9+JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Ci/JJ;;A8Cr/JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cw/JJ;;A+CpjKE;EACE;IAAK,8BvCi8CS;ERunHhB;AACF;A+CpjKA;;EAGE,6BAAA;E1CkRI,oCALI;E0C3QR,yBAAA;EACA,oCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AT4jKJ;;A+C/iKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A/CkjKF;AwBvkKM;EuBYN;IvBXQ,gBAAA;ExB0kKN;AACF;;A+CpjKA;EtBAE,qMAAA;EsBEA,oEAAA;A/CujKF;;A+CpjKA;EACE,iBAAA;A/CujKF;;A+CpjKA;EACE,WAAA;A/CujKF;;A+CnjKE;EACE,kDAAA;A/CsjKJ;A+CnjKM;EAJJ;IAKM,eAAA;E/CsjKN;AACF;;AgDlnKA;EAEE,8BAAA;EACA,wBAAA;EACA,kDAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AT4nKJ;;AgD7mKA;EACE,qBAAA;EACA,sBAAA;AhDgnKF;AgD9mKE;EAEE,oCAAA;EACA,0BAAA;AhD+mKJ;;AgDtmKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhDymKF;AgDtmKE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhDumKJ;AgDpmKE;EACE,+CAAA;EACA,uDAAA;AhDsmKJ;;AgD9lKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;AhDgmKF;AgD9lKE;EvCvDE,+BAAA;EACA,gCAAA;ATwpKJ;AgD9lKE;EvC7CE,mCAAA;EACA,kCAAA;AT8oKJ;AgD9lKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhD+lKJ;AgD3lKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhD6lKJ;AgDzlKE;EACE,mBAAA;AhD2lKJ;AgDzlKI;EACE,wDAAA;EACA,mDAAA;AhD2lKN;;AgD9kKI;EACE,mBAAA;AhDilKN;AgD9kKQ;EvCvDJ,6DAAA;EAZA,0BAAA;ATqpKJ;AgD7kKQ;EvCxEJ,2DAAA;EAYA,4BAAA;AT6oKJ;AgD5kKQ;EACE,aAAA;AhD8kKV;AgD3kKQ;EACE,mDAAA;EACA,oBAAA;AhD6kKV;AgD3kKU;EACE,yDAAA;EACA,oDAAA;AhD6kKZ;;AgBnqKI;EgC8DA;IACE,mBAAA;EhDymKJ;EgDtmKM;IvCvDJ,6DAAA;IAZA,0BAAA;ET6qKF;EgDrmKM;IvCxEJ,2DAAA;IAYA,4BAAA;ETqqKF;EgDpmKM;IACE,aAAA;EhDsmKR;EgDnmKM;IACE,mDAAA;IACA,oBAAA;EhDqmKR;EgDnmKQ;IACE,yDAAA;IACA,oDAAA;EhDqmKV;AACF;AgB5rKI;EgC8DA;IACE,mBAAA;EhDioKJ;EgD9nKM;IvCvDJ,6DAAA;IAZA,0BAAA;ETqsKF;EgD7nKM;IvCxEJ,2DAAA;IAYA,4BAAA;ET6rKF;EgD5nKM;IACE,aAAA;EhD8nKR;EgD3nKM;IACE,mDAAA;IACA,oBAAA;EhD6nKR;EgD3nKQ;IACE,yDAAA;IACA,oDAAA;EhD6nKV;AACF;AgBptKI;EgC8DA;IACE,mBAAA;EhDypKJ;EgDtpKM;IvCvDJ,6DAAA;IAZA,0BAAA;ET6tKF;EgDrpKM;IvCxEJ,2DAAA;IAYA,4BAAA;ETqtKF;EgDppKM;IACE,aAAA;EhDspKR;EgDnpKM;IACE,mDAAA;IACA,oBAAA;EhDqpKR;EgDnpKQ;IACE,yDAAA;IACA,oDAAA;EhDqpKV;AACF;AgB5uKI;EgC8DA;IACE,mBAAA;EhDirKJ;EgD9qKM;IvCvDJ,6DAAA;IAZA,0BAAA;ETqvKF;EgD7qKM;IvCxEJ,2DAAA;IAYA,4BAAA;ET6uKF;EgD5qKM;IACE,aAAA;EhD8qKR;EgD3qKM;IACE,mDAAA;IACA,oBAAA;EhD6qKR;EgD3qKQ;IACE,yDAAA;IACA,oDAAA;EhD6qKV;AACF;AgBpwKI;EgC8DA;IACE,mBAAA;EhDysKJ;EgDtsKM;IvCvDJ,6DAAA;IAZA,0BAAA;ET6wKF;EgDrsKM;IvCxEJ,2DAAA;IAYA,4BAAA;ETqwKF;EgDpsKM;IACE,aAAA;EhDssKR;EgDnsKM;IACE,mDAAA;IACA,oBAAA;EhDqsKR;EgDnsKQ;IACE,yDAAA;IACA,oDAAA;EhDqsKV;AACF;AgDxrKA;EvChJI,gBAAA;AT20KJ;AgDxrKE;EACE,mDAAA;AhD0rKJ;AgDxrKI;EACE,sBAAA;AhD0rKN;;AgD7qKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDgrKJ;;AgD1rKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhD6rKJ;;AgDvsKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD0sKJ;;AgDptKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDutKJ;;AgDjuKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDouKJ;;AgD9uKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhDivKJ;;AgD3vKE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhD8vKJ;;AgDxwKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhD2wKJ;;AgDrxKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhDwxKJ;;AgDlyKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDqyKJ;;AgD/yKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDkzKJ;;AiD9+KA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCmjDgB;EyCljDhB,WzCkjDgB;EyCjjDhB,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;AjD8+KF;AiD3+KE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjD6+KJ;AiD1+KE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjD4+KJ;AiDz+KE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AjD0+KJ;;AiDl+KA;EAHE,wCAAA;AjDy+KF;;AiDh+KI;EATF,wCAAA;AjD6+KF;;AkD9hLA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2CAAA;EACA,kCAAA;EACA,0DAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;ATuiLJ;AkD5hLE;EACE,UAAA;AlD8hLJ;AkD3hLE;EACE,aAAA;AlD6hLJ;;AkDzhLA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlD2hLF;AkDzhLE;EACE,sCAAA;AlD2hLJ;;AkDvhLA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AT2jLJ;AkDzhLE;EACE,oDAAA;EACA,sCAAA;AlD2hLJ;;AkDvhLA;EACE,kCAAA;EACA,qBAAA;AlD0hLF;;AmDxlLA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,4BAAA;EACA,iCAAA;EACA,yDAAA;EACA,mDAAA;EACA,iCAAA;EACA,iCAAA;EACA,sCAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnDslLF;;AmD/kLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AnDilLF;AmD9kLE;E3B5CI,mC2B6CF;EACA,8B3C82CmB;ARkuIvB;AwB1nLM;E2BwCJ;I3BvCM,gBAAA;ExB6nLN;AACF;AmDnlLE;EACE,e3C42CmB;ARyuIvB;AmDjlLE;EACE,sB3Cy2CoB;AR0uIxB;;AmD/kLA;EACE,+CAAA;AnDklLF;AmDhlLE;EACE,gBAAA;EACA,gBAAA;AnDklLJ;AmD/kLE;EACE,gBAAA;AnDilLJ;;AmD7kLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AnDglLF;;AmD5kLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AnD4kLF;;AmDxkLA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AnD8kL9D;AoD1rLE;EAAS,UAAA;ApD6rLX;AoD5rLE;EAAS,mCD2GiF;AnDolL5F;;AmD/kLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E1CtGE,2DAAA;EACA,4DAAA;ATyrLJ;AmDjlLE;EACE,kGAAA;EACA,sJAAA;AnDmlLJ;;AmD9kLA;EACE,gBAAA;EACA,8CAAA;AnDilLF;;AmD5kLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AnD6kLF;;AmDzkLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C1HE,+DAAA;EACA,8DAAA;ATusLJ;AmDxkLE;EACE,8CAAA;AnD0kLJ;;AgBtrLI;EmCkHF;IACE,0BAAA;IACA,0DAAA;EnDwkLF;EmDpkLA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EnDskLF;EmDnkLA;IACE,uBAAA;EnDqkLF;AACF;AgBrsLI;EmCoIF;;IAEE,uBAAA;EnDokLF;AACF;AgB3sLI;EmC2IF;IACE,wBAAA;EnDmkLF;AACF;AmD1jLI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnD4jLN;AmD1jLM;EACE,YAAA;EACA,SAAA;E1C1MJ,gBAAA;ATuwLJ;AmDzjLM;;E1C9MF,gBAAA;AT2wLJ;AmDxjLM;EACE,gBAAA;AnD0jLR;;AgBrtLI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDglLJ;EmD9kLI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ET2xLF;EmD7kLI;;I1C9MF,gBAAA;ET+xLF;EmD5kLI;IACE,gBAAA;EnD8kLN;AACF;AgB1uLI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDomLJ;EmDlmLI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ET+yLF;EmDjmLI;;I1C9MF,gBAAA;ETmzLF;EmDhmLI;IACE,gBAAA;EnDkmLN;AACF;AgB9vLI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDwnLJ;EmDtnLI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETm0LF;EmDrnLI;;I1C9MF,gBAAA;ETu0LF;EmDpnLI;IACE,gBAAA;EnDsnLN;AACF;AgBlxLI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD4oLJ;EmD1oLI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETu1LF;EmDzoLI;;I1C9MF,gBAAA;ET21LF;EmDxoLI;IACE,gBAAA;EnD0oLN;AACF;AgBtyLI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDgqLJ;EmD9pLI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ET22LF;EmD7pLI;;I1C9MF,gBAAA;ET+2LF;EmD5pLI;IACE,gBAAA;EnD8pLN;AACF;AqDr4LA;EAEE,yBAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,sBAAA;EhDwRI,iCALI;EgDjRR,wBAAA;EACA,wBAAA;EACA,mCAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,yC9CylBuB;E8CvlBvB,kBAAA;EACA,gB9CqmBmB;E8CpmBnB,gB9C0mBiB;E8CzmBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;ArD64LF;AqD34LE;EAAS,kCAAA;ArD84LX;AqD54LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArD84LJ;AqD54LI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArD84LN;;AqDz4LA;EACE,iDAAA;ArD44LF;AqD14LE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ArD44LJ;;AqDx4LA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ArD24LF;AqDz4LE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ArD24LJ;;AqDv4LA,mBAAA;AAEA;EACE,8CAAA;ArDy4LF;AqDv4LE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ArDy4LJ;;AqDr4LA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ArDw4LF;AqDt4LE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ArDw4LJ;;AqDp4LA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;ATw9LJ;;AuD3+LA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,iCALI;EkDrRR,qBAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;EACA,qDAAA;EACA,+DAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,+BAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,yC9CylBuB;E8CvlBvB,kBAAA;EACA,gB9CqmBmB;E8CpmBnB,gB9C0mBiB;E8CzmBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;ATsgMJ;AuDl/LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvDo/LJ;AuDl/LI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvDm/LN;;AuD7+LE;EACE,oFAAA;AvDg/LJ;AuD9+LI;EAEE,wFAAA;AvD++LN;AuD5+LI;EACE,SAAA;EACA,gDAAA;AvD8+LN;AuD3+LI;EACE,sCAAA;EACA,sCAAA;AvD6+LN;;AuDx+LA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AvD0+LJ;AuDx+LI;EAEE,kIAAA;AvDy+LN;AuDt+LI;EACE,OAAA;EACA,kDAAA;AvDw+LN;AuDr+LI;EACE,oCAAA;EACA,wCAAA;AvDu+LN;;AuDl+LA,mBAAA;AAGE;EACE,iFAAA;AvDm+LJ;AuDj+LI;EAEE,wFAAA;AvDk+LN;AuD/9LI;EACE,MAAA;EACA,mDAAA;AvDi+LN;AuD99LI;EACE,mCAAA;EACA,yCAAA;AvDg+LN;AuD39LE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AvD69LJ;;AuDz9LA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AvD29LJ;AuDz9LI;EAEE,kIAAA;AvD09LN;AuDv9LI;EACE,QAAA;EACA,iDAAA;AvDy9LN;AuDt9LI;EACE,qCAAA;EACA,uCAAA;AvDw9LN;;AuDn9LA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;ATkmMJ;AuDp8LE;EACE,aAAA;AvDs8LJ;;AuDl8LA;EACE,0EAAA;EACA,mCAAA;AvDq8LF;;AwD1nMA;EACE,kBAAA;AxD6nMF;;AwD1nMA;EACE,mBAAA;AxD6nMF;;AwD1nMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxD6nMF;AyDnpME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDqpMJ;;AwD9nMA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AxDioMF;AwBhpMM;EgCQN;IhCPQ,gBAAA;ExBmpMN;AACF;;AwDnoMA;;;EAGE,cAAA;AxDsoMF;;AwDnoMA;;EAEE,2BAAA;AxDsoMF;;AwDnoMA;;EAEE,4BAAA;AxDsoMF;;AwD7nME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxDgoMJ;AwD7nME;;;EAGE,UAAA;EACA,UAAA;AxD+nMJ;AwD5nME;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AxD8nMJ;AwBvrMM;EgCqDJ;;IhCpDM,gBAAA;ExB2rMN;AACF;;AwD3nMA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDo7CuB;EgDn7CvB,UAAA;EACA,WhDlFM;EgDmFN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD+6CyB;EgBrgDrB,8BgCuFJ;AxD6nMF;AwBhtMM;EgCkEN;;IhCjEQ,gBAAA;ExBotMN;AACF;AwDhoME;;;EAEE,WhD5FI;EgD6FJ,qBAAA;EACA,UAAA;EACA,YhDu6C6B;AR4tJjC;;AwDhoMA;EACE,OAAA;AxDmoMF;;AwDhoMA;EACE,QAAA;AxDmoMF;;AwD9nMA;;EAEE,qBAAA;EACA,WhDw6C4B;EgDv6C5B,YhDu6C4B;EgDt6C5B,4BAAA;EACA,wBAAA;EACA,0BAAA;AxDioMF;;AwD9nMA;;;;;;;GAAA;AAQA;EACE,0DAAA;AxDioMF;;AwD/nMA;EACE,0DAAA;AxDkoMF;;AwD1nMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDg3CuB;EgD/2CvB,mBAAA;EACA,gBhD82CuB;AR8wJzB;AwD1nME;EACE,uBAAA;EACA,cAAA;EACA,WhD82CuB;EgD72CvB,WhD82CwB;EgD72CxB,UAAA;EACA,iBhD82CwB;EgD72CxB,gBhD62CwB;EgD52CxB,mBAAA;EACA,eAAA;EACA,sBhDlKI;EgDmKJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhDq2CyB;EgB7gDvB,6BgCyKF;AxD2nMJ;AwBhyMM;EgCoJJ;IhCnJM,gBAAA;ExBmyMN;AACF;AwD7nME;EACE,UhDk2CgC;AR6xJpC;;AwDtnMA;EACE,kBAAA;EACA,UAAA;EACA,ehD41CwB;EgD31CxB,SAAA;EACA,oBhDy1C2B;EgDx1C3B,uBhDw1C2B;EgDv1C3B,WhD7LM;EgD8LN,kBAAA;AxDynMF;;AwDnnME;;EAEE,gChD21CgC;AR2xJpC;AwDnnME;EACE,sBhDhMI;ARqzMR;AwDlnME;EACE,WhDpMI;ARwzMR;;AwD9nME;;;EAEE,gChD21CgC;ARuyJpC;AwD/nME;EACE,sBhDhMI;ARi0MR;AwD9nME;EACE,WhDpMI;ARo0MR;;A0D11MA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A1D41MF;;A0Dx1MA;EACE;IAAK,0CAAA;E1D41ML;AACF;A0Dz1MA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A1Dw1MF;;A0Dr1MA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A1Du1MF;;A0D90MA;EACE;IACE,mBAAA;E1Di1MF;E0D/0MA;IACE,UAAA;IACA,eAAA;E1Di1MF;AACF;A0D70MA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A1D40MF;;A0Dz0MA;EACE,wBAAA;EACA,yBAAA;A1D40MF;;A0Dx0ME;EACE;;IAEE,kCAAA;E1D20MJ;AACF;A2D35MA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,uBAAA;EACA,gCAAA;EACA,+CAAA;EACA,6DAAA;EACA,qDAAA;EACA,qCAAA;A3D45MF;;AgB/1MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D64MJ;AACF;AwBx6MM;EmCYJ;InCXM,gBAAA;ExB26MN;AACF;AgBr3MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Do5MN;E2Dj5MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Dm5MN;E2Dh5MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Dk5MN;E2D/4MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Di5MN;E2D94MI;IAEE,eAAA;E3D+4MN;E2D54MI;IAGE,mBAAA;E3D44MN;AACF;AgBz6MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D24MN;E2Dz4MM;IACE,aAAA;E3D24MR;E2Dx4MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3Dy4MR;AACF;;AgB76MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D29MJ;AACF;AwBt/MM;EmCYJ;InCXM,gBAAA;ExBy/MN;AACF;AgBn8MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Dk+MN;E2D/9MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Di+MN;E2D99MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Dg+MN;E2D79MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D+9MN;E2D59MI;IAEE,eAAA;E3D69MN;E2D19MI;IAGE,mBAAA;E3D09MN;AACF;AgBv/MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3Dy9MN;E2Dv9MM;IACE,aAAA;E3Dy9MR;E2Dt9MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3Du9MR;AACF;;AgB3/MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DyiNJ;AACF;AwBpkNM;EmCYJ;InCXM,gBAAA;ExBukNN;AACF;AgBjhNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DgjNN;E2D7iNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D+iNN;E2D5iNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D8iNN;E2D3iNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D6iNN;E2D1iNI;IAEE,eAAA;E3D2iNN;E2DxiNI;IAGE,mBAAA;E3DwiNN;AACF;AgBrkNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DuiNN;E2DriNM;IACE,aAAA;E3DuiNR;E2DpiNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DqiNR;AACF;;AgBzkNI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DunNJ;AACF;AwBlpNM;EmCYJ;InCXM,gBAAA;ExBqpNN;AACF;AgB/lNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3D8nNN;E2D3nNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D6nNN;E2D1nNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D4nNN;E2DznNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D2nNN;E2DxnNI;IAEE,eAAA;E3DynNN;E2DtnNI;IAGE,mBAAA;E3DsnNN;AACF;AgBnpNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DqnNN;E2DnnNM;IACE,aAAA;E3DqnNR;E2DlnNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DmnNR;AACF;;AgBvpNI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DqsNJ;AACF;AwBhuNM;EmCYJ;InCXM,gBAAA;ExBmuNN;AACF;AgB7qNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3D4sNN;E2DzsNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D2sNN;E2DxsNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D0sNN;E2DvsNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3DysNN;E2DtsNI;IAEE,eAAA;E3DusNN;E2DpsNI;IAGE,mBAAA;E3DosNN;AACF;AgBjuNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DmsNN;E2DjsNM;IACE,aAAA;E3DmsNR;E2DhsNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DisNR;AACF;;A2DjxNE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A3DkxNN;AwB5yNM;EmCYJ;InCXM,gBAAA;ExB+yNN;AACF;A2DrxNM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A3DuxNR;A2DpxNM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A3DsxNR;A2DnxNM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A3DqxNR;A2DlxNM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A3DoxNR;A2DjxNM;EAEE,eAAA;A3DkxNR;A2D/wNM;EAGE,mBAAA;A3D+wNR;;A2DpvNA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CkkC0B;E4CjkC1B,YAAA;EACA,aAAA;EACA,sB5CkBM;AR01NR;AoDz2NE;EAAS,UAAA;ApD42NX;AoD32NE;EAAS,Y5Ck5Cc;AR49KzB;;A2DhwNA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A3DmwNF;A2DjwNE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A3DmwNJ;;A2D/vNA;EACE,gBAAA;EACA,kDAAA;A3DkwNF;;A2D/vNA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A3DkwNF;;A4Dl5NA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpD6uCwB;ARwqL1B;A4Dn5NE;EACE,qBAAA;EACA,WAAA;A5Dq5NJ;;A4Dh5NA;EACE,iBAAA;A5Dm5NF;;A4Dh5NA;EACE,iBAAA;A5Dm5NF;;A4Dh5NA;EACE,iBAAA;A5Dm5NF;;A4D94NE;EACE,mDAAA;A5Di5NJ;;A4D74NA;EACE;IACE,YpDgtCsB;ERgsLxB;AACF;A4D74NA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A5D+4NF;;A4D54NA;EACE;IACE,+BAAA;YAAA,uBAAA;E5D+4NF;AACF;AyD97NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDg8NJ;;A6Dn8NE;EACE,sBAAA;EACA,iFAAA;A7Ds8NJ;;A6Dx8NE;EACE,sBAAA;EACA,mFAAA;A7D28NJ;;A6D78NE;EACE,sBAAA;EACA,iFAAA;A7Dg9NJ;;A6Dl9NE;EACE,sBAAA;EACA,8EAAA;A7Dq9NJ;;A6Dv9NE;EACE,yBAAA;EACA,iFAAA;A7D09NJ;;A6D59NE;EACE,sBAAA;EACA,gFAAA;A7D+9NJ;;A6Dj+NE;EACE,yBAAA;EACA,+EAAA;A7Do+NJ;;A6Dt+NE;EACE,sBAAA;EACA,8EAAA;A7Dy+NJ;;A6D3+NE;EACE,sBAAA;EACA,gFAAA;A7D8+NJ;;A6Dh/NE;EACE,sBAAA;EACA,8EAAA;A7Dm/NJ;;A6Dr/NE;EACE,yBAAA;EACA,iFAAA;A7Dw/NJ;;A8D1/NE;EACE,wEAAA;EACA,kGAAA;A9D6/NJ;A8D1/NM;EAGE,4DAAA;EACA,sFAAA;A9D0/NR;;A8DngOE;EACE,0EAAA;EACA,oGAAA;A9DsgOJ;A8DngOM;EAGE,6DAAA;EACA,uFAAA;A9DmgOR;;A8D5gOE;EACE,wEAAA;EACA,kGAAA;A9D+gOJ;A8D5gOM;EAGE,8DAAA;EACA,wFAAA;A9D4gOR;;A8DrhOE;EACE,qEAAA;EACA,+FAAA;A9DwhOJ;A8DrhOM;EAGE,+DAAA;EACA,yFAAA;A9DqhOR;;A8D9hOE;EACE,wEAAA;EACA,kGAAA;A9DiiOJ;A8D9hOM;EAGE,gEAAA;EACA,0FAAA;A9D8hOR;;A8DviOE;EACE,uEAAA;EACA,iGAAA;A9D0iOJ;A8DviOM;EAGE,8DAAA;EACA,wFAAA;A9DuiOR;;A8DhjOE;EACE,sEAAA;EACA,gGAAA;A9DmjOJ;A8DhjOM;EAGE,gEAAA;EACA,0FAAA;A9DgjOR;;A8DzjOE;EACE,qEAAA;EACA,+FAAA;A9D4jOJ;A8DzjOM;EAGE,6DAAA;EACA,uFAAA;A9DyjOR;;A8DlkOE;EACE,uEAAA;EACA,iGAAA;A9DqkOJ;A8DlkOM;EAGE,8DAAA;EACA,wFAAA;A9DkkOR;;A8D3kOE;EACE,qEAAA;EACA,+FAAA;A9D8kOJ;A8D3kOM;EAGE,+DAAA;EACA,yFAAA;A9D2kOR;;A8DplOE;EACE,wEAAA;EACA,kGAAA;A9DulOJ;A8DplOM;EAGE,gEAAA;EACA,0FAAA;A9DolOR;;A8D7kOA;EACE,+EAAA;EACA,yGAAA;A9DglOF;A8D7kOI;EAEE,kFAAA;EACA,4GAAA;A9D8kON;;A+DxmOA;EACE,UAAA;EAEA,kJAAA;A/D0mOF;;AgE7mOA;EACE,oBAAA;EACA,alC6c4B;EkC5c5B,mBAAA;EACA,kFAAA;EACA,6BlC2c4B;EkC1c5B,2BAAA;AhEgnOF;AgE9mOE;EACE,cAAA;EACA,UlCuc0B;EkCtc1B,WlCsc0B;EkCrc1B,kBAAA;ExCIE,sCwCHF;AhEgnOJ;AwBzmOM;EwCZJ;IxCaM,gBAAA;ExB4mON;AACF;;AgE9mOI;EACE,mEAAA;AhEinON;;AiEpoOA;EACE,kBAAA;EACA,WAAA;AjEuoOF;AiEroOE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AjEuoOJ;AiEpoOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AjEsoOJ;;AiEjoOE;EACE,uBAAA;AjEooOJ;;AiEroOE;EACE,sBAAA;AjEwoOJ;;AiEzoOE;EACE,yBAAA;AjE4oOJ;;AiE7oOE;EACE,iCAAA;AjEgpOJ;;AkErqOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1D+jCa;ARymMf;;AkErqOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1DujCa;ARinMf;;AkEhqOI;EACE,gBAAA;EACA,MAAA;EACA,a1D2iCU;ARwnMhB;;AkEhqOI;EACE,gBAAA;EACA,SAAA;EACA,a1DqiCU;AR8nMhB;;AgBpoOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2iCU;ERqoMd;EkE7qOE;IACE,gBAAA;IACA,SAAA;IACA,a1DqiCU;ER0oMd;AACF;AgBjpOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2iCU;ERipMd;EkEzrOE;IACE,gBAAA;IACA,SAAA;IACA,a1DqiCU;ERspMd;AACF;AgB7pOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2iCU;ER6pMd;EkErsOE;IACE,gBAAA;IACA,SAAA;IACA,a1DqiCU;ERkqMd;AACF;AgBzqOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2iCU;ERyqMd;EkEjtOE;IACE,gBAAA;IACA,SAAA;IACA,a1DqiCU;ER8qMd;AACF;AgBrrOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2iCU;ERqrMd;EkE7tOE;IACE,gBAAA;IACA,SAAA;IACA,a1DqiCU;ER0rMd;AACF;AmE/vOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AnEiwOF;;AmE9vOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AnEiwOF;;AoEzwOA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ArE0wOF;AqEvwOE;;EACE,6BAAA;ArE0wOJ;;AsExxOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DsdqB;E8DrdrB,WAAA;AtE2xOJ;;AuEnyOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AxEuyOF;;AyE7yOA;EACE,qBAAA;EACA,mBAAA;EACA,6B3CisB4B;E2ChsB5B,eAAA;EACA,8BAAA;EACA,YjE4qBW;ARooNb;;A0EpvOQ;EAOI,mCAAA;A1EivOZ;;A0ExvOQ;EAOI,8BAAA;A1EqvOZ;;A0E5vOQ;EAOI,iCAAA;A1EyvOZ;;A0EhwOQ;EAOI,iCAAA;A1E6vOZ;;A0EpwOQ;EAOI,sCAAA;A1EiwOZ;;A0ExwOQ;EAOI,mCAAA;A1EqwOZ;;A0E5wOQ;EAOI,sBAAA;A1EywOZ;;A0EhxOQ;EAOI,uBAAA;A1E6wOZ;;A0EpxOQ;EAOI,sBAAA;A1EixOZ;;A0ExxOQ;EAOI,8BAAA;A1EqxOZ;;A0E5xOQ;EAOI,4BAAA;A1EyxOZ;;A0EhyOQ;EAOI,2BAAA;A1E6xOZ;;A0EpyOQ;EAOI,iCAAA;A1EiyOZ;;A0ExyOQ;EAOI,2BAAA;A1EqyOZ;;A0E5yOQ;EAOI,qBAAA;A1EyyOZ;;A0EhzOQ;EAOI,wBAAA;A1E6yOZ;;A0EpzOQ;EAOI,uBAAA;A1EizOZ;;A0ExzOQ;EAOI,wBAAA;A1EqzOZ;;A0E5zOQ;EAOI,qBAAA;A1EyzOZ;;A0Eh0OQ;EAOI,yBAAA;A1E6zOZ;;A0Ep0OQ;EAOI,2BAAA;A1Ei0OZ;;A0Ex0OQ;EAOI,4BAAA;A1Eq0OZ;;A0E50OQ;EAOI,2BAAA;A1Ey0OZ;;A0Eh1OQ;EAOI,2BAAA;A1E60OZ;;A0Ep1OQ;EAOI,6BAAA;A1Ei1OZ;;A0Ex1OQ;EAOI,8BAAA;A1Eq1OZ;;A0E51OQ;EAOI,6BAAA;A1Ey1OZ;;A0Eh2OQ;EAOI,2BAAA;A1E61OZ;;A0Ep2OQ;EAOI,6BAAA;A1Ei2OZ;;A0Ex2OQ;EAOI,8BAAA;A1Eq2OZ;;A0E52OQ;EAOI,6BAAA;A1Ey2OZ;;A0Eh3OQ;EAOI,0BAAA;A1E62OZ;;A0Ep3OQ;EAOI,gCAAA;A1Ei3OZ;;A0Ex3OQ;EAOI,yBAAA;A1Eq3OZ;;A0E53OQ;EAOI,wBAAA;A1Ey3OZ;;A0Eh4OQ;EAOI,+BAAA;A1E63OZ;;A0Ep4OQ;EAOI,yBAAA;A1Ei4OZ;;A0Ex4OQ;EAOI,6BAAA;A1Eq4OZ;;A0E54OQ;EAOI,8BAAA;A1Ey4OZ;;A0Eh5OQ;EAOI,wBAAA;A1E64OZ;;A0Ep5OQ;EAOI,+BAAA;A1Ei5OZ;;A0Ex5OQ;EAOI,wBAAA;A1Eq5OZ;;A0E55OQ;EAOI,2CAAA;A1Ey5OZ;;A0Eh6OQ;EAOI,8CAAA;A1E65OZ;;A0Ep6OQ;EAOI,8CAAA;A1Ei6OZ;;A0Ex6OQ;EAOI,2BAAA;A1Eq6OZ;;A0Et7OQ;EACE,gFAAA;A1Ey7OV;;A0E17OQ;EACE,kFAAA;A1E67OV;;A0E97OQ;EACE,gFAAA;A1Ei8OV;;A0El8OQ;EACE,6EAAA;A1Eq8OV;;A0Et8OQ;EACE,gFAAA;A1Ey8OV;;A0E18OQ;EACE,+EAAA;A1E68OV;;A0E98OQ;EACE,8EAAA;A1Ei9OV;;A0El9OQ;EACE,6EAAA;A1Eq9OV;;A0Et9OQ;EACE,+EAAA;A1Ey9OV;;A0E19OQ;EACE,6EAAA;A1E69OV;;A0E99OQ;EACE,gFAAA;A1Ei+OV;;A0Ex9OQ;EAOI,2BAAA;A1Eq9OZ;;A0E59OQ;EAOI,6BAAA;A1Ey9OZ;;A0Eh+OQ;EAOI,6BAAA;A1E69OZ;;A0Ep+OQ;EAOI,0BAAA;A1Ei+OZ;;A0Ex+OQ;EAOI,2BAAA;A1Eq+OZ;;A0E5+OQ;EAOI,iBAAA;A1Ey+OZ;;A0Eh/OQ;EAOI,mBAAA;A1E6+OZ;;A0Ep/OQ;EAOI,oBAAA;A1Ei/OZ;;A0Ex/OQ;EAOI,oBAAA;A1Eq/OZ;;A0E5/OQ;EAOI,sBAAA;A1Ey/OZ;;A0EhgPQ;EAOI,uBAAA;A1E6/OZ;;A0EpgPQ;EAOI,kBAAA;A1EigPZ;;A0ExgPQ;EAOI,oBAAA;A1EqgPZ;;A0E5gPQ;EAOI,qBAAA;A1EygPZ;;A0EhhPQ;EAOI,mBAAA;A1E6gPZ;;A0EphPQ;EAOI,qBAAA;A1EihPZ;;A0ExhPQ;EAOI,sBAAA;A1EqhPZ;;A0E5hPQ;EAOI,2CAAA;A1EyhPZ;;A0EhiPQ;EAOI,sCAAA;A1E6hPZ;;A0EpiPQ;EAOI,sCAAA;A1EiiPZ;;A0ExiPQ;EAOI,uFAAA;A1EqiPZ;;A0E5iPQ;EAOI,oBAAA;A1EyiPZ;;A0EhjPQ;EAOI,2FAAA;A1E6iPZ;;A0EpjPQ;EAOI,wBAAA;A1EijPZ;;A0ExjPQ;EAOI,6FAAA;A1EqjPZ;;A0E5jPQ;EAOI,0BAAA;A1EyjPZ;;A0EhkPQ;EAOI,8FAAA;A1E6jPZ;;A0EpkPQ;EAOI,2BAAA;A1EikPZ;;A0ExkPQ;EAOI,4FAAA;A1EqkPZ;;A0E5kPQ;EAOI,yBAAA;A1EykPZ;;A0EhlPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E8kPZ;;A0ErlPQ;EAIQ,sBAAA;EAGJ,gFAAA;A1EmlPZ;;A0E1lPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1EwlPZ;;A0E/lPQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E6lPZ;;A0EpmPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1EkmPZ;;A0EzmPQ;EAIQ,sBAAA;EAGJ,6EAAA;A1EumPZ;;A0E9mPQ;EAIQ,sBAAA;EAGJ,4EAAA;A1E4mPZ;;A0EnnPQ;EAIQ,sBAAA;EAGJ,2EAAA;A1EinPZ;;A0ExnPQ;EAIQ,sBAAA;EAGJ,6EAAA;A1EsnPZ;;A0E7nPQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E2nPZ;;A0EloPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1EgoPZ;;A0EvoPQ;EAIQ,sBAAA;EAGJ,4EAAA;A1EqoPZ;;A0E5oPQ;EAIQ,sBAAA;EAGJ,4EAAA;A1E0oPZ;;A0EjpPQ;EAOI,wDAAA;A1E8oPZ;;A0ErpPQ;EAOI,0DAAA;A1EkpPZ;;A0EzpPQ;EAOI,wDAAA;A1EspPZ;;A0E7pPQ;EAOI,qDAAA;A1E0pPZ;;A0EjqPQ;EAOI,wDAAA;A1E8pPZ;;A0ErqPQ;EAOI,uDAAA;A1EkqPZ;;A0EzqPQ;EAOI,sDAAA;A1EsqPZ;;A0E7qPQ;EAOI,qDAAA;A1E0qPZ;;A0EjrPQ;EAOI,4BAAA;A1E8qPZ;;A0ErrPQ;EAOI,4BAAA;A1EkrPZ;;A0EzrPQ;EAOI,4BAAA;A1EsrPZ;;A0E7rPQ;EAOI,4BAAA;A1E0rPZ;;A0EjsPQ;EAOI,4BAAA;A1E8rPZ;;A0E/sPQ;EACE,wBAAA;A1EktPV;;A0EntPQ;EACE,yBAAA;A1EstPV;;A0EvtPQ;EACE,wBAAA;A1E0tPV;;A0E3tPQ;EACE,yBAAA;A1E8tPV;;A0E/tPQ;EACE,sBAAA;A1EkuPV;;A0EztPQ;EAOI,qBAAA;A1EstPZ;;A0E7tPQ;EAOI,qBAAA;A1E0tPZ;;A0EjuPQ;EAOI,qBAAA;A1E8tPZ;;A0EruPQ;EAOI,sBAAA;A1EkuPZ;;A0EzuPQ;EAOI,sBAAA;A1EsuPZ;;A0E7uPQ;EAOI,0BAAA;A1E0uPZ;;A0EjvPQ;EAOI,uBAAA;A1E8uPZ;;A0ErvPQ;EAOI,2BAAA;A1EkvPZ;;A0EzvPQ;EAOI,sBAAA;A1EsvPZ;;A0E7vPQ;EAOI,sBAAA;A1E0vPZ;;A0EjwPQ;EAOI,sBAAA;A1E8vPZ;;A0ErwPQ;EAOI,uBAAA;A1EkwPZ;;A0EzwPQ;EAOI,uBAAA;A1EswPZ;;A0E7wPQ;EAOI,2BAAA;A1E0wPZ;;A0EjxPQ;EAOI,wBAAA;A1E8wPZ;;A0ErxPQ;EAOI,4BAAA;A1EkxPZ;;A0EzxPQ;EAOI,yBAAA;A1EsxPZ;;A0E7xPQ;EAOI,8BAAA;A1E0xPZ;;A0EjyPQ;EAOI,iCAAA;A1E8xPZ;;A0EryPQ;EAOI,sCAAA;A1EkyPZ;;A0EzyPQ;EAOI,yCAAA;A1EsyPZ;;A0E7yPQ;EAOI,uBAAA;A1E0yPZ;;A0EjzPQ;EAOI,uBAAA;A1E8yPZ;;A0ErzPQ;EAOI,yBAAA;A1EkzPZ;;A0EzzPQ;EAOI,yBAAA;A1EszPZ;;A0E7zPQ;EAOI,0BAAA;A1E0zPZ;;A0Ej0PQ;EAOI,4BAAA;A1E8zPZ;;A0Er0PQ;EAOI,kCAAA;A1Ek0PZ;;A0Ez0PQ;EAOI,sCAAA;A1Es0PZ;;A0E70PQ;EAOI,oCAAA;A1E00PZ;;A0Ej1PQ;EAOI,kCAAA;A1E80PZ;;A0Er1PQ;EAOI,yCAAA;A1Ek1PZ;;A0Ez1PQ;EAOI,wCAAA;A1Es1PZ;;A0E71PQ;EAOI,wCAAA;A1E01PZ;;A0Ej2PQ;EAOI,kCAAA;A1E81PZ;;A0Er2PQ;EAOI,gCAAA;A1Ek2PZ;;A0Ez2PQ;EAOI,8BAAA;A1Es2PZ;;A0E72PQ;EAOI,gCAAA;A1E02PZ;;A0Ej3PQ;EAOI,+BAAA;A1E82PZ;;A0Er3PQ;EAOI,oCAAA;A1Ek3PZ;;A0Ez3PQ;EAOI,kCAAA;A1Es3PZ;;A0E73PQ;EAOI,gCAAA;A1E03PZ;;A0Ej4PQ;EAOI,uCAAA;A1E83PZ;;A0Er4PQ;EAOI,sCAAA;A1Ek4PZ;;A0Ez4PQ;EAOI,iCAAA;A1Es4PZ;;A0E74PQ;EAOI,2BAAA;A1E04PZ;;A0Ej5PQ;EAOI,iCAAA;A1E84PZ;;A0Er5PQ;EAOI,+BAAA;A1Ek5PZ;;A0Ez5PQ;EAOI,6BAAA;A1Es5PZ;;A0E75PQ;EAOI,+BAAA;A1E05PZ;;A0Ej6PQ;EAOI,8BAAA;A1E85PZ;;A0Er6PQ;EAOI,oBAAA;A1Ek6PZ;;A0Ez6PQ;EAOI,mBAAA;A1Es6PZ;;A0E76PQ;EAOI,mBAAA;A1E06PZ;;A0Ej7PQ;EAOI,mBAAA;A1E86PZ;;A0Er7PQ;EAOI,mBAAA;A1Ek7PZ;;A0Ez7PQ;EAOI,mBAAA;A1Es7PZ;;A0E77PQ;EAOI,mBAAA;A1E07PZ;;A0Ej8PQ;EAOI,mBAAA;A1E87PZ;;A0Er8PQ;EAOI,oBAAA;A1Ek8PZ;;A0Ez8PQ;EAOI,0BAAA;A1Es8PZ;;A0E78PQ;EAOI,yBAAA;A1E08PZ;;A0Ej9PQ;EAOI,uBAAA;A1E88PZ;;A0Er9PQ;EAOI,yBAAA;A1Ek9PZ;;A0Ez9PQ;EAOI,uBAAA;A1Es9PZ;;A0E79PQ;EAOI,yBAAA;A1E09PZ;;A0Ej+PQ;EAOI,uBAAA;A1E89PZ;;A0Er+PQ;EAOI,yBAAA;A1Ek+PZ;;A0Ez+PQ;EAOI,uBAAA;A1Es+PZ;;A0E7+PQ;EAOI,0BAAA;A1E0+PZ;;A0Ej/PQ;EAOI,uBAAA;A1E8+PZ;;A0Er/PQ;EAOI,0BAAA;EAAA,yBAAA;A1Em/PZ;;A0E1/PQ;EAOI,gCAAA;EAAA,+BAAA;A1Ew/PZ;;A0E//PQ;EAOI,+BAAA;EAAA,8BAAA;A1E6/PZ;;A0EpgQQ;EAOI,6BAAA;EAAA,4BAAA;A1EkgQZ;;A0EzgQQ;EAOI,+BAAA;EAAA,8BAAA;A1EugQZ;;A0E9gQQ;EAOI,6BAAA;EAAA,4BAAA;A1E4gQZ;;A0EnhQQ;EAOI,+BAAA;EAAA,8BAAA;A1EihQZ;;A0ExhQQ;EAOI,6BAAA;EAAA,4BAAA;A1EshQZ;;A0E7hQQ;EAOI,+BAAA;EAAA,8BAAA;A1E2hQZ;;A0EliQQ;EAOI,6BAAA;EAAA,4BAAA;A1EgiQZ;;A0EviQQ;EAOI,gCAAA;EAAA,+BAAA;A1EqiQZ;;A0E5iQQ;EAOI,6BAAA;EAAA,4BAAA;A1E0iQZ;;A0EjjQQ;EAOI,wBAAA;EAAA,2BAAA;A1E+iQZ;;A0EtjQQ;EAOI,8BAAA;EAAA,iCAAA;A1EojQZ;;A0E3jQQ;EAOI,6BAAA;EAAA,gCAAA;A1EyjQZ;;A0EhkQQ;EAOI,2BAAA;EAAA,8BAAA;A1E8jQZ;;A0ErkQQ;EAOI,6BAAA;EAAA,gCAAA;A1EmkQZ;;A0E1kQQ;EAOI,2BAAA;EAAA,8BAAA;A1EwkQZ;;A0E/kQQ;EAOI,6BAAA;EAAA,gCAAA;A1E6kQZ;;A0EplQQ;EAOI,2BAAA;EAAA,8BAAA;A1EklQZ;;A0EzlQQ;EAOI,6BAAA;EAAA,gCAAA;A1EulQZ;;A0E9lQQ;EAOI,2BAAA;EAAA,8BAAA;A1E4lQZ;;A0EnmQQ;EAOI,8BAAA;EAAA,iCAAA;A1EimQZ;;A0ExmQQ;EAOI,2BAAA;EAAA,8BAAA;A1EsmQZ;;A0E7mQQ;EAOI,wBAAA;A1E0mQZ;;A0EjnQQ;EAOI,8BAAA;A1E8mQZ;;A0ErnQQ;EAOI,6BAAA;A1EknQZ;;A0EznQQ;EAOI,2BAAA;A1EsnQZ;;A0E7nQQ;EAOI,6BAAA;A1E0nQZ;;A0EjoQQ;EAOI,2BAAA;A1E8nQZ;;A0EroQQ;EAOI,6BAAA;A1EkoQZ;;A0EzoQQ;EAOI,2BAAA;A1EsoQZ;;A0E7oQQ;EAOI,6BAAA;A1E0oQZ;;A0EjpQQ;EAOI,2BAAA;A1E8oQZ;;A0ErpQQ;EAOI,8BAAA;A1EkpQZ;;A0EzpQQ;EAOI,2BAAA;A1EspQZ;;A0E7pQQ;EAOI,0BAAA;A1E0pQZ;;A0EjqQQ;EAOI,gCAAA;A1E8pQZ;;A0ErqQQ;EAOI,+BAAA;A1EkqQZ;;A0EzqQQ;EAOI,6BAAA;A1EsqQZ;;A0E7qQQ;EAOI,+BAAA;A1E0qQZ;;A0EjrQQ;EAOI,6BAAA;A1E8qQZ;;A0ErrQQ;EAOI,+BAAA;A1EkrQZ;;A0EzrQQ;EAOI,6BAAA;A1EsrQZ;;A0E7rQQ;EAOI,+BAAA;A1E0rQZ;;A0EjsQQ;EAOI,6BAAA;A1E8rQZ;;A0ErsQQ;EAOI,gCAAA;A1EksQZ;;A0EzsQQ;EAOI,6BAAA;A1EssQZ;;A0E7sQQ;EAOI,2BAAA;A1E0sQZ;;A0EjtQQ;EAOI,iCAAA;A1E8sQZ;;A0ErtQQ;EAOI,gCAAA;A1EktQZ;;A0EztQQ;EAOI,8BAAA;A1EstQZ;;A0E7tQQ;EAOI,gCAAA;A1E0tQZ;;A0EjuQQ;EAOI,8BAAA;A1E8tQZ;;A0EruQQ;EAOI,gCAAA;A1EkuQZ;;A0EzuQQ;EAOI,8BAAA;A1EsuQZ;;A0E7uQQ;EAOI,gCAAA;A1E0uQZ;;A0EjvQQ;EAOI,8BAAA;A1E8uQZ;;A0ErvQQ;EAOI,iCAAA;A1EkvQZ;;A0EzvQQ;EAOI,8BAAA;A1EsvQZ;;A0E7vQQ;EAOI,yBAAA;A1E0vQZ;;A0EjwQQ;EAOI,+BAAA;A1E8vQZ;;A0ErwQQ;EAOI,8BAAA;A1EkwQZ;;A0EzwQQ;EAOI,4BAAA;A1EswQZ;;A0E7wQQ;EAOI,8BAAA;A1E0wQZ;;A0EjxQQ;EAOI,4BAAA;A1E8wQZ;;A0ErxQQ;EAOI,8BAAA;A1EkxQZ;;A0EzxQQ;EAOI,4BAAA;A1EsxQZ;;A0E7xQQ;EAOI,8BAAA;A1E0xQZ;;A0EjyQQ;EAOI,4BAAA;A1E8xQZ;;A0EryQQ;EAOI,+BAAA;A1EkyQZ;;A0EzyQQ;EAOI,4BAAA;A1EsyQZ;;A0E7yQQ;EAOI,2BAAA;A1E0yQZ;;A0EjzQQ;EAOI,0BAAA;A1E8yQZ;;A0ErzQQ;EAOI,wBAAA;A1EkzQZ;;A0EzzQQ;EAOI,0BAAA;A1EszQZ;;A0E7zQQ;EAOI,wBAAA;A1E0zQZ;;A0Ej0QQ;EAOI,0BAAA;A1E8zQZ;;A0Er0QQ;EAOI,wBAAA;A1Ek0QZ;;A0Ez0QQ;EAOI,0BAAA;A1Es0QZ;;A0E70QQ;EAOI,wBAAA;A1E00QZ;;A0Ej1QQ;EAOI,2BAAA;A1E80QZ;;A0Er1QQ;EAOI,iCAAA;EAAA,gCAAA;A1Em1QZ;;A0E11QQ;EAOI,gCAAA;EAAA,+BAAA;A1Ew1QZ;;A0E/1QQ;EAOI,8BAAA;EAAA,6BAAA;A1E61QZ;;A0Ep2QQ;EAOI,gCAAA;EAAA,+BAAA;A1Ek2QZ;;A0Ez2QQ;EAOI,8BAAA;EAAA,6BAAA;A1Eu2QZ;;A0E92QQ;EAOI,gCAAA;EAAA,+BAAA;A1E42QZ;;A0En3QQ;EAOI,8BAAA;EAAA,6BAAA;A1Ei3QZ;;A0Ex3QQ;EAOI,gCAAA;EAAA,+BAAA;A1Es3QZ;;A0E73QQ;EAOI,8BAAA;EAAA,6BAAA;A1E23QZ;;A0El4QQ;EAOI,iCAAA;EAAA,gCAAA;A1Eg4QZ;;A0Ev4QQ;EAOI,+BAAA;EAAA,kCAAA;A1Eq4QZ;;A0E54QQ;EAOI,8BAAA;EAAA,iCAAA;A1E04QZ;;A0Ej5QQ;EAOI,4BAAA;EAAA,+BAAA;A1E+4QZ;;A0Et5QQ;EAOI,8BAAA;EAAA,iCAAA;A1Eo5QZ;;A0E35QQ;EAOI,4BAAA;EAAA,+BAAA;A1Ey5QZ;;A0Eh6QQ;EAOI,8BAAA;EAAA,iCAAA;A1E85QZ;;A0Er6QQ;EAOI,4BAAA;EAAA,+BAAA;A1Em6QZ;;A0E16QQ;EAOI,8BAAA;EAAA,iCAAA;A1Ew6QZ;;A0E/6QQ;EAOI,4BAAA;EAAA,+BAAA;A1E66QZ;;A0Ep7QQ;EAOI,+BAAA;EAAA,kCAAA;A1Ek7QZ;;A0Ez7QQ;EAOI,+BAAA;A1Es7QZ;;A0E77QQ;EAOI,8BAAA;A1E07QZ;;A0Ej8QQ;EAOI,4BAAA;A1E87QZ;;A0Er8QQ;EAOI,8BAAA;A1Ek8QZ;;A0Ez8QQ;EAOI,4BAAA;A1Es8QZ;;A0E78QQ;EAOI,8BAAA;A1E08QZ;;A0Ej9QQ;EAOI,4BAAA;A1E88QZ;;A0Er9QQ;EAOI,8BAAA;A1Ek9QZ;;A0Ez9QQ;EAOI,4BAAA;A1Es9QZ;;A0E79QQ;EAOI,+BAAA;A1E09QZ;;A0Ej+QQ;EAOI,iCAAA;A1E89QZ;;A0Er+QQ;EAOI,gCAAA;A1Ek+QZ;;A0Ez+QQ;EAOI,8BAAA;A1Es+QZ;;A0E7+QQ;EAOI,gCAAA;A1E0+QZ;;A0Ej/QQ;EAOI,8BAAA;A1E8+QZ;;A0Er/QQ;EAOI,gCAAA;A1Ek/QZ;;A0Ez/QQ;EAOI,8BAAA;A1Es/QZ;;A0E7/QQ;EAOI,gCAAA;A1E0/QZ;;A0EjgRQ;EAOI,8BAAA;A1E8/QZ;;A0ErgRQ;EAOI,iCAAA;A1EkgRZ;;A0EzgRQ;EAOI,kCAAA;A1EsgRZ;;A0E7gRQ;EAOI,iCAAA;A1E0gRZ;;A0EjhRQ;EAOI,+BAAA;A1E8gRZ;;A0ErhRQ;EAOI,iCAAA;A1EkhRZ;;A0EzhRQ;EAOI,+BAAA;A1EshRZ;;A0E7hRQ;EAOI,iCAAA;A1E0hRZ;;A0EjiRQ;EAOI,+BAAA;A1E8hRZ;;A0EriRQ;EAOI,iCAAA;A1EkiRZ;;A0EziRQ;EAOI,+BAAA;A1EsiRZ;;A0E7iRQ;EAOI,kCAAA;A1E0iRZ;;A0EjjRQ;EAOI,gCAAA;A1E8iRZ;;A0ErjRQ;EAOI,+BAAA;A1EkjRZ;;A0EzjRQ;EAOI,6BAAA;A1EsjRZ;;A0E7jRQ;EAOI,+BAAA;A1E0jRZ;;A0EjkRQ;EAOI,6BAAA;A1E8jRZ;;A0ErkRQ;EAOI,+BAAA;A1EkkRZ;;A0EzkRQ;EAOI,6BAAA;A1EskRZ;;A0E7kRQ;EAOI,+BAAA;A1E0kRZ;;A0EjlRQ;EAOI,6BAAA;A1E8kRZ;;A0ErlRQ;EAOI,gCAAA;A1EklRZ;;A0EzlRQ;EAOI,qBAAA;A1EslRZ;;A0E7lRQ;EAOI,2BAAA;A1E0lRZ;;A0EjmRQ;EAOI,0BAAA;A1E8lRZ;;A0ErmRQ;EAOI,wBAAA;A1EkmRZ;;A0EzmRQ;EAOI,0BAAA;A1EsmRZ;;A0E7mRQ;EAOI,wBAAA;A1E0mRZ;;A0EjnRQ;EAOI,0BAAA;A1E8mRZ;;A0ErnRQ;EAOI,wBAAA;A1EknRZ;;A0EznRQ;EAOI,0BAAA;A1EsnRZ;;A0E7nRQ;EAOI,wBAAA;A1E0nRZ;;A0EjoRQ;EAOI,2BAAA;A1E8nRZ;;A0EroRQ;EAOI,2BAAA;EAAA,0BAAA;A1EmoRZ;;A0E1oRQ;EAOI,iCAAA;EAAA,gCAAA;A1EwoRZ;;A0E/oRQ;EAOI,gCAAA;EAAA,+BAAA;A1E6oRZ;;A0EppRQ;EAOI,8BAAA;EAAA,6BAAA;A1EkpRZ;;A0EzpRQ;EAOI,gCAAA;EAAA,+BAAA;A1EupRZ;;A0E9pRQ;EAOI,8BAAA;EAAA,6BAAA;A1E4pRZ;;A0EnqRQ;EAOI,gCAAA;EAAA,+BAAA;A1EiqRZ;;A0ExqRQ;EAOI,8BAAA;EAAA,6BAAA;A1EsqRZ;;A0E7qRQ;EAOI,gCAAA;EAAA,+BAAA;A1E2qRZ;;A0ElrRQ;EAOI,8BAAA;EAAA,6BAAA;A1EgrRZ;;A0EvrRQ;EAOI,iCAAA;EAAA,gCAAA;A1EqrRZ;;A0E5rRQ;EAOI,yBAAA;EAAA,4BAAA;A1E0rRZ;;A0EjsRQ;EAOI,+BAAA;EAAA,kCAAA;A1E+rRZ;;A0EtsRQ;EAOI,8BAAA;EAAA,iCAAA;A1EosRZ;;A0E3sRQ;EAOI,4BAAA;EAAA,+BAAA;A1EysRZ;;A0EhtRQ;EAOI,8BAAA;EAAA,iCAAA;A1E8sRZ;;A0ErtRQ;EAOI,4BAAA;EAAA,+BAAA;A1EmtRZ;;A0E1tRQ;EAOI,8BAAA;EAAA,iCAAA;A1EwtRZ;;A0E/tRQ;EAOI,4BAAA;EAAA,+BAAA;A1E6tRZ;;A0EpuRQ;EAOI,8BAAA;EAAA,iCAAA;A1EkuRZ;;A0EzuRQ;EAOI,4BAAA;EAAA,+BAAA;A1EuuRZ;;A0E9uRQ;EAOI,+BAAA;EAAA,kCAAA;A1E4uRZ;;A0EnvRQ;EAOI,yBAAA;A1EgvRZ;;A0EvvRQ;EAOI,+BAAA;A1EovRZ;;A0E3vRQ;EAOI,8BAAA;A1EwvRZ;;A0E/vRQ;EAOI,4BAAA;A1E4vRZ;;A0EnwRQ;EAOI,8BAAA;A1EgwRZ;;A0EvwRQ;EAOI,4BAAA;A1EowRZ;;A0E3wRQ;EAOI,8BAAA;A1EwwRZ;;A0E/wRQ;EAOI,4BAAA;A1E4wRZ;;A0EnxRQ;EAOI,8BAAA;A1EgxRZ;;A0EvxRQ;EAOI,4BAAA;A1EoxRZ;;A0E3xRQ;EAOI,+BAAA;A1EwxRZ;;A0E/xRQ;EAOI,2BAAA;A1E4xRZ;;A0EnyRQ;EAOI,iCAAA;A1EgyRZ;;A0EvyRQ;EAOI,gCAAA;A1EoyRZ;;A0E3yRQ;EAOI,8BAAA;A1EwyRZ;;A0E/yRQ;EAOI,gCAAA;A1E4yRZ;;A0EnzRQ;EAOI,8BAAA;A1EgzRZ;;A0EvzRQ;EAOI,gCAAA;A1EozRZ;;A0E3zRQ;EAOI,8BAAA;A1EwzRZ;;A0E/zRQ;EAOI,gCAAA;A1E4zRZ;;A0En0RQ;EAOI,8BAAA;A1Eg0RZ;;A0Ev0RQ;EAOI,iCAAA;A1Eo0RZ;;A0E30RQ;EAOI,4BAAA;A1Ew0RZ;;A0E/0RQ;EAOI,kCAAA;A1E40RZ;;A0En1RQ;EAOI,iCAAA;A1Eg1RZ;;A0Ev1RQ;EAOI,+BAAA;A1Eo1RZ;;A0E31RQ;EAOI,iCAAA;A1Ew1RZ;;A0E/1RQ;EAOI,+BAAA;A1E41RZ;;A0En2RQ;EAOI,iCAAA;A1Eg2RZ;;A0Ev2RQ;EAOI,+BAAA;A1Eo2RZ;;A0E32RQ;EAOI,iCAAA;A1Ew2RZ;;A0E/2RQ;EAOI,+BAAA;A1E42RZ;;A0En3RQ;EAOI,kCAAA;A1Eg3RZ;;A0Ev3RQ;EAOI,0BAAA;A1Eo3RZ;;A0E33RQ;EAOI,gCAAA;A1Ew3RZ;;A0E/3RQ;EAOI,+BAAA;A1E43RZ;;A0En4RQ;EAOI,6BAAA;A1Eg4RZ;;A0Ev4RQ;EAOI,+BAAA;A1Eo4RZ;;A0E34RQ;EAOI,6BAAA;A1Ew4RZ;;A0E/4RQ;EAOI,+BAAA;A1E44RZ;;A0En5RQ;EAOI,6BAAA;A1Eg5RZ;;A0Ev5RQ;EAOI,+BAAA;A1Eo5RZ;;A0E35RQ;EAOI,6BAAA;A1Ew5RZ;;A0E/5RQ;EAOI,gCAAA;A1E45RZ;;A0En6RQ;EAOI,iBAAA;A1Eg6RZ;;A0Ev6RQ;EAOI,uBAAA;A1Eo6RZ;;A0E36RQ;EAOI,sBAAA;A1Ew6RZ;;A0E/6RQ;EAOI,oBAAA;A1E46RZ;;A0En7RQ;EAOI,sBAAA;A1Eg7RZ;;A0Ev7RQ;EAOI,oBAAA;A1Eo7RZ;;A0E37RQ;EAOI,sBAAA;A1Ew7RZ;;A0E/7RQ;EAOI,oBAAA;A1E47RZ;;A0En8RQ;EAOI,sBAAA;A1Eg8RZ;;A0Ev8RQ;EAOI,oBAAA;A1Eo8RZ;;A0E38RQ;EAOI,uBAAA;A1Ew8RZ;;A0E/8RQ;EAOI,qBAAA;A1E48RZ;;A0En9RQ;EAOI,2BAAA;A1Eg9RZ;;A0Ev9RQ;EAOI,0BAAA;A1Eo9RZ;;A0E39RQ;EAOI,wBAAA;A1Ew9RZ;;A0E/9RQ;EAOI,0BAAA;A1E49RZ;;A0En+RQ;EAOI,wBAAA;A1Eg+RZ;;A0Ev+RQ;EAOI,0BAAA;A1Eo+RZ;;A0E3+RQ;EAOI,wBAAA;A1Ew+RZ;;A0E/+RQ;EAOI,0BAAA;A1E4+RZ;;A0En/RQ;EAOI,wBAAA;A1Eg/RZ;;A0Ev/RQ;EAOI,2BAAA;A1Eo/RZ;;A0E3/RQ;EAOI,wBAAA;A1Ew/RZ;;A0E//RQ;EAOI,8BAAA;A1E4/RZ;;A0EngSQ;EAOI,6BAAA;A1EggSZ;;A0EvgSQ;EAOI,2BAAA;A1EogSZ;;A0E3gSQ;EAOI,6BAAA;A1EwgSZ;;A0E/gSQ;EAOI,2BAAA;A1E4gSZ;;A0EnhSQ;EAOI,6BAAA;A1EghSZ;;A0EvhSQ;EAOI,2BAAA;A1EohSZ;;A0E3hSQ;EAOI,6BAAA;A1EwhSZ;;A0E/hSQ;EAOI,2BAAA;A1E4hSZ;;A0EniSQ;EAOI,8BAAA;A1EgiSZ;;A0EviSQ;EAOI,gDAAA;A1EoiSZ;;A0E3iSQ;EAOI,kDAAA;A1EwiSZ;;A0E/iSQ;EAOI,oDAAA;A1E4iSZ;;A0EnjSQ;EAOI,gDAAA;A1EgjSZ;;A0EvjSQ;EAOI,iCAAA;A1EojSZ;;A0E3jSQ;EAOI,+BAAA;A1EwjSZ;;A0E/jSQ;EAOI,gCAAA;A1E4jSZ;;A0EnkSQ;EAOI,6BAAA;A1EgkSZ;;A0EvkSQ;EAOI,6BAAA;A1EokSZ;;A0E3kSQ;EAOI,+BAAA;A1EwkSZ;;A0E/kSQ;EAOI,2BAAA;A1E4kSZ;;A0EnlSQ;EAOI,2BAAA;A1EglSZ;;A0EvlSQ;EAOI,2BAAA;A1EolSZ;;A0E3lSQ;EAOI,2BAAA;A1EwlSZ;;A0E/lSQ;EAOI,2BAAA;A1E4lSZ;;A0EnmSQ;EAOI,2BAAA;A1EgmSZ;;A0EvmSQ;EAOI,yBAAA;A1EomSZ;;A0E3mSQ;EAOI,4BAAA;A1EwmSZ;;A0E/mSQ;EAOI,2BAAA;A1E4mSZ;;A0EnnSQ;EAOI,yBAAA;A1EgnSZ;;A0EvnSQ;EAOI,2BAAA;A1EonSZ;;A0E3nSQ;EAOI,4BAAA;A1EwnSZ;;A0E/nSQ;EAOI,6BAAA;A1E4nSZ;;A0EnoSQ;EAOI,gCAAA;A1EgoSZ;;A0EvoSQ;EAOI,qCAAA;A1EooSZ;;A0E3oSQ;EAOI,wCAAA;A1EwoSZ;;A0E/oSQ;EAOI,oCAAA;A1E4oSZ;;A0EnpSQ;EAOI,oCAAA;A1EgpSZ;;A0EvpSQ;EAOI,qCAAA;A1EopSZ;;A0E3pSQ;EAOI,8BAAA;A1EwpSZ;;A0E/pSQ;EAOI,8BAAA;A1E4pSZ;;A0EjrSQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A1EkqSZ;;A0E/oSQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A1EwqSZ;;A0E/qSQ;EAIQ,oBAAA;EAGJ,uEAAA;A1E6qSZ;;A0EprSQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EkrSZ;;A0EzrSQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EurSZ;;A0E9rSQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E4rSZ;;A0EnsSQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EisSZ;;A0ExsSQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EssSZ;;A0E7sSQ;EAIQ,oBAAA;EAGJ,kEAAA;A1E2sSZ;;A0EltSQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EgtSZ;;A0EvtSQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EqtSZ;;A0E5tSQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E0tSZ;;A0EjuSQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E+tSZ;;A0EtuSQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EouSZ;;A0E3uSQ;EAIQ,oBAAA;EAGJ,wEAAA;A1EyuSZ;;A0EhvSQ;EAIQ,oBAAA;EAGJ,2CAAA;A1E8uSZ;;A0ErvSQ;EAIQ,oBAAA;EAGJ,oCAAA;A1EmvSZ;;A0E1vSQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EwvSZ;;A0E/vSQ;EAIQ,oBAAA;EAGJ,2CAAA;A1E6vSZ;;A0EpwSQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EkwSZ;;A0EzwSQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EuwSZ;;A0E9wSQ;EAIQ,oBAAA;EAGJ,yBAAA;A1E4wSZ;;A0E7xSQ;EACE,uBAAA;A1EgySV;;A0EjySQ;EACE,sBAAA;A1EoySV;;A0ErySQ;EACE,uBAAA;A1EwySV;;A0EzySQ;EACE,oBAAA;A1E4ySV;;A0EnySQ;EAOI,iDAAA;A1EgySZ;;A0EvySQ;EAOI,mDAAA;A1EoySZ;;A0E3ySQ;EAOI,iDAAA;A1EwySZ;;A0E/ySQ;EAOI,8CAAA;A1E4ySZ;;A0EnzSQ;EAOI,iDAAA;A1EgzSZ;;A0EvzSQ;EAOI,gDAAA;A1EozSZ;;A0E3zSQ;EAOI,+CAAA;A1EwzSZ;;A0E/zSQ;EAOI,8CAAA;A1E4zSZ;;A0E70SQ;EACE,sBAAA;A1Eg1SV;;A0E50SU;EACE,sBAAA;A1E+0SZ;;A0Er1SQ;EACE,uBAAA;A1Ew1SV;;A0Ep1SU;EACE,uBAAA;A1Eu1SZ;;A0E71SQ;EACE,sBAAA;A1Eg2SV;;A0E51SU;EACE,sBAAA;A1E+1SZ;;A0Er2SQ;EACE,uBAAA;A1Ew2SV;;A0Ep2SU;EACE,uBAAA;A1Eu2SZ;;A0E72SQ;EACE,oBAAA;A1Eg3SV;;A0E52SU;EACE,oBAAA;A1E+2SZ;;A0E32SQ;EAOI,yCAAA;A1Ew2SZ;;A0En2SU;EAOI,yCAAA;A1Eg2Sd;;A0En3SQ;EAOI,wCAAA;A1Eg3SZ;;A0E32SU;EAOI,wCAAA;A1Ew2Sd;;A0E33SQ;EAOI,yCAAA;A1Ew3SZ;;A0En3SU;EAOI,yCAAA;A1Eg3Sd;;A0En4SQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ei4SZ;;A0Ex4SQ;EAIQ,8BAAA;EAGJ,iGAAA;A1Es4SZ;;A0E74SQ;EAIQ,8BAAA;EAGJ,+FAAA;A1E24SZ;;A0El5SQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Eg5SZ;;A0Ev5SQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Eq5SZ;;A0E55SQ;EAIQ,8BAAA;EAGJ,8FAAA;A1E05SZ;;A0Ej6SQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E+5SZ;;A0Et6SQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Eo6SZ;;A0E36SQ;EAIQ,8BAAA;EAGJ,8FAAA;A1Ey6SZ;;A0Eh7SQ;EAIQ,8BAAA;EAGJ,4FAAA;A1E86SZ;;A0Er7SQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Em7SZ;;A0E17SQ;EAIQ,8BAAA;EAGJ,qGAAA;A1Ew7SZ;;A0Ez8SQ;EACE,8BAAA;A1E48SV;;A0Ex8SU;EACE,8BAAA;A1E28SZ;;A0Ej9SQ;EACE,gCAAA;A1Eo9SV;;A0Eh9SU;EACE,gCAAA;A1Em9SZ;;A0Ez9SQ;EACE,iCAAA;A1E49SV;;A0Ex9SU;EACE,iCAAA;A1E29SZ;;A0Ej+SQ;EACE,gCAAA;A1Eo+SV;;A0Eh+SU;EACE,gCAAA;A1Em+SZ;;A0Ez+SQ;EACE,iCAAA;A1E4+SV;;A0Ex+SU;EACE,iCAAA;A1E2+SZ;;A0Ej/SQ;EACE,8BAAA;A1Eo/SV;;A0Eh/SU;EACE,8BAAA;A1Em/SZ;;A0E/+SQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E6+SZ;;A0Ep/SQ;EAIQ,kBAAA;EAGJ,gFAAA;A1Ek/SZ;;A0Ez/SQ;EAIQ,kBAAA;EAGJ,8EAAA;A1Eu/SZ;;A0E9/SQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E4/SZ;;A0EngTQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EigTZ;;A0ExgTQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EsgTZ;;A0E7gTQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E2gTZ;;A0ElhTQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EghTZ;;A0EvhTQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EqhTZ;;A0E5hTQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E0hTZ;;A0EjiTQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E+hTZ;;A0EtiTQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EoiTZ;;A0E3iTQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EyiTZ;;A0EhjTQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E8iTZ;;A0ErjTQ;EAIQ,kBAAA;EAGJ,wCAAA;A1EmjTZ;;A0E1jTQ;EAIQ,kBAAA;EAGJ,mFAAA;A1EwjTZ;;A0E/jTQ;EAIQ,kBAAA;EAGJ,kFAAA;A1E6jTZ;;A0E9kTQ;EACE,oBAAA;A1EilTV;;A0EllTQ;EACE,qBAAA;A1EqlTV;;A0EtlTQ;EACE,oBAAA;A1EylTV;;A0E1lTQ;EACE,qBAAA;A1E6lTV;;A0E9lTQ;EACE,kBAAA;A1EimTV;;A0ExlTQ;EAOI,wDAAA;A1EqlTZ;;A0E5lTQ;EAOI,0DAAA;A1EylTZ;;A0EhmTQ;EAOI,wDAAA;A1E6lTZ;;A0EpmTQ;EAOI,qDAAA;A1EimTZ;;A0ExmTQ;EAOI,wDAAA;A1EqmTZ;;A0E5mTQ;EAOI,uDAAA;A1EymTZ;;A0EhnTQ;EAOI,sDAAA;A1E6mTZ;;A0EpnTQ;EAOI,qDAAA;A1EinTZ;;A0ExnTQ;EAOI,+CAAA;A1EqnTZ;;A0E5nTQ;EAOI,mCAAA;UAAA,2BAAA;A1EynTZ;;A0EhoTQ;EAOI,oCAAA;UAAA,4BAAA;A1E6nTZ;;A0EpoTQ;EAOI,oCAAA;UAAA,4BAAA;A1EioTZ;;A0ExoTQ;EAOI,+BAAA;A1EqoTZ;;A0E5oTQ;EAOI,+BAAA;A1EyoTZ;;A0EhpTQ;EAOI,iDAAA;A1E6oTZ;;A0EppTQ;EAOI,2BAAA;A1EipTZ;;A0ExpTQ;EAOI,oDAAA;A1EqpTZ;;A0E5pTQ;EAOI,iDAAA;A1EypTZ;;A0EhqTQ;EAOI,oDAAA;A1E6pTZ;;A0EpqTQ;EAOI,oDAAA;A1EiqTZ;;A0ExqTQ;EAOI,qDAAA;A1EqqTZ;;A0E5qTQ;EAOI,6BAAA;A1EyqTZ;;A0EhrTQ;EAOI,sDAAA;A1E6qTZ;;A0EprTQ;EAOI,0DAAA;EAAA,2DAAA;A1EkrTZ;;A0EzrTQ;EAOI,oCAAA;EAAA,qCAAA;A1EurTZ;;A0E9rTQ;EAOI,6DAAA;EAAA,8DAAA;A1E4rTZ;;A0EnsTQ;EAOI,0DAAA;EAAA,2DAAA;A1EisTZ;;A0ExsTQ;EAOI,6DAAA;EAAA,8DAAA;A1EssTZ;;A0E7sTQ;EAOI,6DAAA;EAAA,8DAAA;A1E2sTZ;;A0EltTQ;EAOI,8DAAA;EAAA,+DAAA;A1EgtTZ;;A0EvtTQ;EAOI,sCAAA;EAAA,uCAAA;A1EqtTZ;;A0E5tTQ;EAOI,+DAAA;EAAA,gEAAA;A1E0tTZ;;A0EjuTQ;EAOI,2DAAA;EAAA,8DAAA;A1E+tTZ;;A0EtuTQ;EAOI,qCAAA;EAAA,wCAAA;A1EouTZ;;A0E3uTQ;EAOI,8DAAA;EAAA,iEAAA;A1EyuTZ;;A0EhvTQ;EAOI,2DAAA;EAAA,8DAAA;A1E8uTZ;;A0ErvTQ;EAOI,8DAAA;EAAA,iEAAA;A1EmvTZ;;A0E1vTQ;EAOI,8DAAA;EAAA,iEAAA;A1EwvTZ;;A0E/vTQ;EAOI,+DAAA;EAAA,kEAAA;A1E6vTZ;;A0EpwTQ;EAOI,uCAAA;EAAA,0CAAA;A1EkwTZ;;A0EzwTQ;EAOI,gEAAA;EAAA,mEAAA;A1EuwTZ;;A0E9wTQ;EAOI,8DAAA;EAAA,6DAAA;A1E4wTZ;;A0EnxTQ;EAOI,wCAAA;EAAA,uCAAA;A1EixTZ;;A0ExxTQ;EAOI,iEAAA;EAAA,gEAAA;A1EsxTZ;;A0E7xTQ;EAOI,8DAAA;EAAA,6DAAA;A1E2xTZ;;A0ElyTQ;EAOI,iEAAA;EAAA,gEAAA;A1EgyTZ;;A0EvyTQ;EAOI,iEAAA;EAAA,gEAAA;A1EqyTZ;;A0E5yTQ;EAOI,kEAAA;EAAA,iEAAA;A1E0yTZ;;A0EjzTQ;EAOI,0CAAA;EAAA,yCAAA;A1E+yTZ;;A0EtzTQ;EAOI,mEAAA;EAAA,kEAAA;A1EozTZ;;A0E3zTQ;EAOI,6DAAA;EAAA,0DAAA;A1EyzTZ;;A0Eh0TQ;EAOI,uCAAA;EAAA,oCAAA;A1E8zTZ;;A0Er0TQ;EAOI,gEAAA;EAAA,6DAAA;A1Em0TZ;;A0E10TQ;EAOI,6DAAA;EAAA,0DAAA;A1Ew0TZ;;A0E/0TQ;EAOI,gEAAA;EAAA,6DAAA;A1E60TZ;;A0Ep1TQ;EAOI,gEAAA;EAAA,6DAAA;A1Ek1TZ;;A0Ez1TQ;EAOI,iEAAA;EAAA,8DAAA;A1Eu1TZ;;A0E91TQ;EAOI,yCAAA;EAAA,sCAAA;A1E41TZ;;A0En2TQ;EAOI,kEAAA;EAAA,+DAAA;A1Ei2TZ;;A0Ex2TQ;EAOI,8BAAA;A1Eq2TZ;;A0E52TQ;EAOI,6BAAA;A1Ey2TZ;;A0Eh3TQ;EAOI,sBAAA;A1E62TZ;;A0Ep3TQ;EAOI,qBAAA;A1Ei3TZ;;A0Ex3TQ;EAOI,qBAAA;A1Eq3TZ;;A0E53TQ;EAOI,qBAAA;A1Ey3TZ;;A0Eh4TQ;EAOI,qBAAA;A1E63TZ;;AgBv4TI;E0DGI;IAOI,sBAAA;E1Ek4TV;E0Ez4TM;IAOI,uBAAA;E1Eq4TV;E0E54TM;IAOI,sBAAA;E1Ew4TV;E0E/4TM;IAOI,8BAAA;E1E24TV;E0El5TM;IAOI,4BAAA;E1E84TV;E0Er5TM;IAOI,2BAAA;E1Ei5TV;E0Ex5TM;IAOI,iCAAA;E1Eo5TV;E0E35TM;IAOI,2BAAA;E1Eu5TV;E0E95TM;IAOI,0BAAA;E1E05TV;E0Ej6TM;IAOI,gCAAA;E1E65TV;E0Ep6TM;IAOI,yBAAA;E1Eg6TV;E0Ev6TM;IAOI,wBAAA;E1Em6TV;E0E16TM;IAOI,+BAAA;E1Es6TV;E0E76TM;IAOI,yBAAA;E1Ey6TV;E0Eh7TM;IAOI,6BAAA;E1E46TV;E0En7TM;IAOI,8BAAA;E1E+6TV;E0Et7TM;IAOI,wBAAA;E1Ek7TV;E0Ez7TM;IAOI,+BAAA;E1Eq7TV;E0E57TM;IAOI,wBAAA;E1Ew7TV;E0E/7TM;IAOI,yBAAA;E1E27TV;E0El8TM;IAOI,8BAAA;E1E87TV;E0Er8TM;IAOI,iCAAA;E1Ei8TV;E0Ex8TM;IAOI,sCAAA;E1Eo8TV;E0E38TM;IAOI,yCAAA;E1Eu8TV;E0E98TM;IAOI,uBAAA;E1E08TV;E0Ej9TM;IAOI,uBAAA;E1E68TV;E0Ep9TM;IAOI,yBAAA;E1Eg9TV;E0Ev9TM;IAOI,yBAAA;E1Em9TV;E0E19TM;IAOI,0BAAA;E1Es9TV;E0E79TM;IAOI,4BAAA;E1Ey9TV;E0Eh+TM;IAOI,kCAAA;E1E49TV;E0En+TM;IAOI,sCAAA;E1E+9TV;E0Et+TM;IAOI,oCAAA;E1Ek+TV;E0Ez+TM;IAOI,kCAAA;E1Eq+TV;E0E5+TM;IAOI,yCAAA;E1Ew+TV;E0E/+TM;IAOI,wCAAA;E1E2+TV;E0El/TM;IAOI,wCAAA;E1E8+TV;E0Er/TM;IAOI,kCAAA;E1Ei/TV;E0Ex/TM;IAOI,gCAAA;E1Eo/TV;E0E3/TM;IAOI,8BAAA;E1Eu/TV;E0E9/TM;IAOI,gCAAA;E1E0/TV;E0EjgUM;IAOI,+BAAA;E1E6/TV;E0EpgUM;IAOI,oCAAA;E1EggUV;E0EvgUM;IAOI,kCAAA;E1EmgUV;E0E1gUM;IAOI,gCAAA;E1EsgUV;E0E7gUM;IAOI,uCAAA;E1EygUV;E0EhhUM;IAOI,sCAAA;E1E4gUV;E0EnhUM;IAOI,iCAAA;E1E+gUV;E0EthUM;IAOI,2BAAA;E1EkhUV;E0EzhUM;IAOI,iCAAA;E1EqhUV;E0E5hUM;IAOI,+BAAA;E1EwhUV;E0E/hUM;IAOI,6BAAA;E1E2hUV;E0EliUM;IAOI,+BAAA;E1E8hUV;E0EriUM;IAOI,8BAAA;E1EiiUV;E0ExiUM;IAOI,oBAAA;E1EoiUV;E0E3iUM;IAOI,mBAAA;E1EuiUV;E0E9iUM;IAOI,mBAAA;E1E0iUV;E0EjjUM;IAOI,mBAAA;E1E6iUV;E0EpjUM;IAOI,mBAAA;E1EgjUV;E0EvjUM;IAOI,mBAAA;E1EmjUV;E0E1jUM;IAOI,mBAAA;E1EsjUV;E0E7jUM;IAOI,mBAAA;E1EyjUV;E0EhkUM;IAOI,oBAAA;E1E4jUV;E0EnkUM;IAOI,0BAAA;E1E+jUV;E0EtkUM;IAOI,yBAAA;E1EkkUV;E0EzkUM;IAOI,uBAAA;E1EqkUV;E0E5kUM;IAOI,yBAAA;E1EwkUV;E0E/kUM;IAOI,uBAAA;E1E2kUV;E0EllUM;IAOI,yBAAA;E1E8kUV;E0ErlUM;IAOI,uBAAA;E1EilUV;E0ExlUM;IAOI,yBAAA;E1EolUV;E0E3lUM;IAOI,uBAAA;E1EulUV;E0E9lUM;IAOI,0BAAA;E1E0lUV;E0EjmUM;IAOI,uBAAA;E1E6lUV;E0EpmUM;IAOI,0BAAA;IAAA,yBAAA;E1EimUV;E0ExmUM;IAOI,gCAAA;IAAA,+BAAA;E1EqmUV;E0E5mUM;IAOI,+BAAA;IAAA,8BAAA;E1EymUV;E0EhnUM;IAOI,6BAAA;IAAA,4BAAA;E1E6mUV;E0EpnUM;IAOI,+BAAA;IAAA,8BAAA;E1EinUV;E0ExnUM;IAOI,6BAAA;IAAA,4BAAA;E1EqnUV;E0E5nUM;IAOI,+BAAA;IAAA,8BAAA;E1EynUV;E0EhoUM;IAOI,6BAAA;IAAA,4BAAA;E1E6nUV;E0EpoUM;IAOI,+BAAA;IAAA,8BAAA;E1EioUV;E0ExoUM;IAOI,6BAAA;IAAA,4BAAA;E1EqoUV;E0E5oUM;IAOI,gCAAA;IAAA,+BAAA;E1EyoUV;E0EhpUM;IAOI,6BAAA;IAAA,4BAAA;E1E6oUV;E0EppUM;IAOI,wBAAA;IAAA,2BAAA;E1EipUV;E0ExpUM;IAOI,8BAAA;IAAA,iCAAA;E1EqpUV;E0E5pUM;IAOI,6BAAA;IAAA,gCAAA;E1EypUV;E0EhqUM;IAOI,2BAAA;IAAA,8BAAA;E1E6pUV;E0EpqUM;IAOI,6BAAA;IAAA,gCAAA;E1EiqUV;E0ExqUM;IAOI,2BAAA;IAAA,8BAAA;E1EqqUV;E0E5qUM;IAOI,6BAAA;IAAA,gCAAA;E1EyqUV;E0EhrUM;IAOI,2BAAA;IAAA,8BAAA;E1E6qUV;E0EprUM;IAOI,6BAAA;IAAA,gCAAA;E1EirUV;E0ExrUM;IAOI,2BAAA;IAAA,8BAAA;E1EqrUV;E0E5rUM;IAOI,8BAAA;IAAA,iCAAA;E1EyrUV;E0EhsUM;IAOI,2BAAA;IAAA,8BAAA;E1E6rUV;E0EpsUM;IAOI,wBAAA;E1EgsUV;E0EvsUM;IAOI,8BAAA;E1EmsUV;E0E1sUM;IAOI,6BAAA;E1EssUV;E0E7sUM;IAOI,2BAAA;E1EysUV;E0EhtUM;IAOI,6BAAA;E1E4sUV;E0EntUM;IAOI,2BAAA;E1E+sUV;E0EttUM;IAOI,6BAAA;E1EktUV;E0EztUM;IAOI,2BAAA;E1EqtUV;E0E5tUM;IAOI,6BAAA;E1EwtUV;E0E/tUM;IAOI,2BAAA;E1E2tUV;E0EluUM;IAOI,8BAAA;E1E8tUV;E0EruUM;IAOI,2BAAA;E1EiuUV;E0ExuUM;IAOI,0BAAA;E1EouUV;E0E3uUM;IAOI,gCAAA;E1EuuUV;E0E9uUM;IAOI,+BAAA;E1E0uUV;E0EjvUM;IAOI,6BAAA;E1E6uUV;E0EpvUM;IAOI,+BAAA;E1EgvUV;E0EvvUM;IAOI,6BAAA;E1EmvUV;E0E1vUM;IAOI,+BAAA;E1EsvUV;E0E7vUM;IAOI,6BAAA;E1EyvUV;E0EhwUM;IAOI,+BAAA;E1E4vUV;E0EnwUM;IAOI,6BAAA;E1E+vUV;E0EtwUM;IAOI,gCAAA;E1EkwUV;E0EzwUM;IAOI,6BAAA;E1EqwUV;E0E5wUM;IAOI,2BAAA;E1EwwUV;E0E/wUM;IAOI,iCAAA;E1E2wUV;E0ElxUM;IAOI,gCAAA;E1E8wUV;E0ErxUM;IAOI,8BAAA;E1EixUV;E0ExxUM;IAOI,gCAAA;E1EoxUV;E0E3xUM;IAOI,8BAAA;E1EuxUV;E0E9xUM;IAOI,gCAAA;E1E0xUV;E0EjyUM;IAOI,8BAAA;E1E6xUV;E0EpyUM;IAOI,gCAAA;E1EgyUV;E0EvyUM;IAOI,8BAAA;E1EmyUV;E0E1yUM;IAOI,iCAAA;E1EsyUV;E0E7yUM;IAOI,8BAAA;E1EyyUV;E0EhzUM;IAOI,yBAAA;E1E4yUV;E0EnzUM;IAOI,+BAAA;E1E+yUV;E0EtzUM;IAOI,8BAAA;E1EkzUV;E0EzzUM;IAOI,4BAAA;E1EqzUV;E0E5zUM;IAOI,8BAAA;E1EwzUV;E0E/zUM;IAOI,4BAAA;E1E2zUV;E0El0UM;IAOI,8BAAA;E1E8zUV;E0Er0UM;IAOI,4BAAA;E1Ei0UV;E0Ex0UM;IAOI,8BAAA;E1Eo0UV;E0E30UM;IAOI,4BAAA;E1Eu0UV;E0E90UM;IAOI,+BAAA;E1E00UV;E0Ej1UM;IAOI,4BAAA;E1E60UV;E0Ep1UM;IAOI,2BAAA;E1Eg1UV;E0Ev1UM;IAOI,0BAAA;E1Em1UV;E0E11UM;IAOI,wBAAA;E1Es1UV;E0E71UM;IAOI,0BAAA;E1Ey1UV;E0Eh2UM;IAOI,wBAAA;E1E41UV;E0En2UM;IAOI,0BAAA;E1E+1UV;E0Et2UM;IAOI,wBAAA;E1Ek2UV;E0Ez2UM;IAOI,0BAAA;E1Eq2UV;E0E52UM;IAOI,wBAAA;E1Ew2UV;E0E/2UM;IAOI,2BAAA;E1E22UV;E0El3UM;IAOI,iCAAA;IAAA,gCAAA;E1E+2UV;E0Et3UM;IAOI,gCAAA;IAAA,+BAAA;E1Em3UV;E0E13UM;IAOI,8BAAA;IAAA,6BAAA;E1Eu3UV;E0E93UM;IAOI,gCAAA;IAAA,+BAAA;E1E23UV;E0El4UM;IAOI,8BAAA;IAAA,6BAAA;E1E+3UV;E0Et4UM;IAOI,gCAAA;IAAA,+BAAA;E1Em4UV;E0E14UM;IAOI,8BAAA;IAAA,6BAAA;E1Eu4UV;E0E94UM;IAOI,gCAAA;IAAA,+BAAA;E1E24UV;E0El5UM;IAOI,8BAAA;IAAA,6BAAA;E1E+4UV;E0Et5UM;IAOI,iCAAA;IAAA,gCAAA;E1Em5UV;E0E15UM;IAOI,+BAAA;IAAA,kCAAA;E1Eu5UV;E0E95UM;IAOI,8BAAA;IAAA,iCAAA;E1E25UV;E0El6UM;IAOI,4BAAA;IAAA,+BAAA;E1E+5UV;E0Et6UM;IAOI,8BAAA;IAAA,iCAAA;E1Em6UV;E0E16UM;IAOI,4BAAA;IAAA,+BAAA;E1Eu6UV;E0E96UM;IAOI,8BAAA;IAAA,iCAAA;E1E26UV;E0El7UM;IAOI,4BAAA;IAAA,+BAAA;E1E+6UV;E0Et7UM;IAOI,8BAAA;IAAA,iCAAA;E1Em7UV;E0E17UM;IAOI,4BAAA;IAAA,+BAAA;E1Eu7UV;E0E97UM;IAOI,+BAAA;IAAA,kCAAA;E1E27UV;E0El8UM;IAOI,+BAAA;E1E87UV;E0Er8UM;IAOI,8BAAA;E1Ei8UV;E0Ex8UM;IAOI,4BAAA;E1Eo8UV;E0E38UM;IAOI,8BAAA;E1Eu8UV;E0E98UM;IAOI,4BAAA;E1E08UV;E0Ej9UM;IAOI,8BAAA;E1E68UV;E0Ep9UM;IAOI,4BAAA;E1Eg9UV;E0Ev9UM;IAOI,8BAAA;E1Em9UV;E0E19UM;IAOI,4BAAA;E1Es9UV;E0E79UM;IAOI,+BAAA;E1Ey9UV;E0Eh+UM;IAOI,iCAAA;E1E49UV;E0En+UM;IAOI,gCAAA;E1E+9UV;E0Et+UM;IAOI,8BAAA;E1Ek+UV;E0Ez+UM;IAOI,gCAAA;E1Eq+UV;E0E5+UM;IAOI,8BAAA;E1Ew+UV;E0E/+UM;IAOI,gCAAA;E1E2+UV;E0El/UM;IAOI,8BAAA;E1E8+UV;E0Er/UM;IAOI,gCAAA;E1Ei/UV;E0Ex/UM;IAOI,8BAAA;E1Eo/UV;E0E3/UM;IAOI,iCAAA;E1Eu/UV;E0E9/UM;IAOI,kCAAA;E1E0/UV;E0EjgVM;IAOI,iCAAA;E1E6/UV;E0EpgVM;IAOI,+BAAA;E1EggVV;E0EvgVM;IAOI,iCAAA;E1EmgVV;E0E1gVM;IAOI,+BAAA;E1EsgVV;E0E7gVM;IAOI,iCAAA;E1EygVV;E0EhhVM;IAOI,+BAAA;E1E4gVV;E0EnhVM;IAOI,iCAAA;E1E+gVV;E0EthVM;IAOI,+BAAA;E1EkhVV;E0EzhVM;IAOI,kCAAA;E1EqhVV;E0E5hVM;IAOI,gCAAA;E1EwhVV;E0E/hVM;IAOI,+BAAA;E1E2hVV;E0EliVM;IAOI,6BAAA;E1E8hVV;E0EriVM;IAOI,+BAAA;E1EiiVV;E0ExiVM;IAOI,6BAAA;E1EoiVV;E0E3iVM;IAOI,+BAAA;E1EuiVV;E0E9iVM;IAOI,6BAAA;E1E0iVV;E0EjjVM;IAOI,+BAAA;E1E6iVV;E0EpjVM;IAOI,6BAAA;E1EgjVV;E0EvjVM;IAOI,gCAAA;E1EmjVV;E0E1jVM;IAOI,qBAAA;E1EsjVV;E0E7jVM;IAOI,2BAAA;E1EyjVV;E0EhkVM;IAOI,0BAAA;E1E4jVV;E0EnkVM;IAOI,wBAAA;E1E+jVV;E0EtkVM;IAOI,0BAAA;E1EkkVV;E0EzkVM;IAOI,wBAAA;E1EqkVV;E0E5kVM;IAOI,0BAAA;E1EwkVV;E0E/kVM;IAOI,wBAAA;E1E2kVV;E0EllVM;IAOI,0BAAA;E1E8kVV;E0ErlVM;IAOI,wBAAA;E1EilVV;E0ExlVM;IAOI,2BAAA;E1EolVV;E0E3lVM;IAOI,2BAAA;IAAA,0BAAA;E1EwlVV;E0E/lVM;IAOI,iCAAA;IAAA,gCAAA;E1E4lVV;E0EnmVM;IAOI,gCAAA;IAAA,+BAAA;E1EgmVV;E0EvmVM;IAOI,8BAAA;IAAA,6BAAA;E1EomVV;E0E3mVM;IAOI,gCAAA;IAAA,+BAAA;E1EwmVV;E0E/mVM;IAOI,8BAAA;IAAA,6BAAA;E1E4mVV;E0EnnVM;IAOI,gCAAA;IAAA,+BAAA;E1EgnVV;E0EvnVM;IAOI,8BAAA;IAAA,6BAAA;E1EonVV;E0E3nVM;IAOI,gCAAA;IAAA,+BAAA;E1EwnVV;E0E/nVM;IAOI,8BAAA;IAAA,6BAAA;E1E4nVV;E0EnoVM;IAOI,iCAAA;IAAA,gCAAA;E1EgoVV;E0EvoVM;IAOI,yBAAA;IAAA,4BAAA;E1EooVV;E0E3oVM;IAOI,+BAAA;IAAA,kCAAA;E1EwoVV;E0E/oVM;IAOI,8BAAA;IAAA,iCAAA;E1E4oVV;E0EnpVM;IAOI,4BAAA;IAAA,+BAAA;E1EgpVV;E0EvpVM;IAOI,8BAAA;IAAA,iCAAA;E1EopVV;E0E3pVM;IAOI,4BAAA;IAAA,+BAAA;E1EwpVV;E0E/pVM;IAOI,8BAAA;IAAA,iCAAA;E1E4pVV;E0EnqVM;IAOI,4BAAA;IAAA,+BAAA;E1EgqVV;E0EvqVM;IAOI,8BAAA;IAAA,iCAAA;E1EoqVV;E0E3qVM;IAOI,4BAAA;IAAA,+BAAA;E1EwqVV;E0E/qVM;IAOI,+BAAA;IAAA,kCAAA;E1E4qVV;E0EnrVM;IAOI,yBAAA;E1E+qVV;E0EtrVM;IAOI,+BAAA;E1EkrVV;E0EzrVM;IAOI,8BAAA;E1EqrVV;E0E5rVM;IAOI,4BAAA;E1EwrVV;E0E/rVM;IAOI,8BAAA;E1E2rVV;E0ElsVM;IAOI,4BAAA;E1E8rVV;E0ErsVM;IAOI,8BAAA;E1EisVV;E0ExsVM;IAOI,4BAAA;E1EosVV;E0E3sVM;IAOI,8BAAA;E1EusVV;E0E9sVM;IAOI,4BAAA;E1E0sVV;E0EjtVM;IAOI,+BAAA;E1E6sVV;E0EptVM;IAOI,2BAAA;E1EgtVV;E0EvtVM;IAOI,iCAAA;E1EmtVV;E0E1tVM;IAOI,gCAAA;E1EstVV;E0E7tVM;IAOI,8BAAA;E1EytVV;E0EhuVM;IAOI,gCAAA;E1E4tVV;E0EnuVM;IAOI,8BAAA;E1E+tVV;E0EtuVM;IAOI,gCAAA;E1EkuVV;E0EzuVM;IAOI,8BAAA;E1EquVV;E0E5uVM;IAOI,gCAAA;E1EwuVV;E0E/uVM;IAOI,8BAAA;E1E2uVV;E0ElvVM;IAOI,iCAAA;E1E8uVV;E0ErvVM;IAOI,4BAAA;E1EivVV;E0ExvVM;IAOI,kCAAA;E1EovVV;E0E3vVM;IAOI,iCAAA;E1EuvVV;E0E9vVM;IAOI,+BAAA;E1E0vVV;E0EjwVM;IAOI,iCAAA;E1E6vVV;E0EpwVM;IAOI,+BAAA;E1EgwVV;E0EvwVM;IAOI,iCAAA;E1EmwVV;E0E1wVM;IAOI,+BAAA;E1EswVV;E0E7wVM;IAOI,iCAAA;E1EywVV;E0EhxVM;IAOI,+BAAA;E1E4wVV;E0EnxVM;IAOI,kCAAA;E1E+wVV;E0EtxVM;IAOI,0BAAA;E1EkxVV;E0EzxVM;IAOI,gCAAA;E1EqxVV;E0E5xVM;IAOI,+BAAA;E1EwxVV;E0E/xVM;IAOI,6BAAA;E1E2xVV;E0ElyVM;IAOI,+BAAA;E1E8xVV;E0EryVM;IAOI,6BAAA;E1EiyVV;E0ExyVM;IAOI,+BAAA;E1EoyVV;E0E3yVM;IAOI,6BAAA;E1EuyVV;E0E9yVM;IAOI,+BAAA;E1E0yVV;E0EjzVM;IAOI,6BAAA;E1E6yVV;E0EpzVM;IAOI,gCAAA;E1EgzVV;E0EvzVM;IAOI,iBAAA;E1EmzVV;E0E1zVM;IAOI,uBAAA;E1EszVV;E0E7zVM;IAOI,sBAAA;E1EyzVV;E0Eh0VM;IAOI,oBAAA;E1E4zVV;E0En0VM;IAOI,sBAAA;E1E+zVV;E0Et0VM;IAOI,oBAAA;E1Ek0VV;E0Ez0VM;IAOI,sBAAA;E1Eq0VV;E0E50VM;IAOI,oBAAA;E1Ew0VV;E0E/0VM;IAOI,sBAAA;E1E20VV;E0El1VM;IAOI,oBAAA;E1E80VV;E0Er1VM;IAOI,uBAAA;E1Ei1VV;E0Ex1VM;IAOI,qBAAA;E1Eo1VV;E0E31VM;IAOI,2BAAA;E1Eu1VV;E0E91VM;IAOI,0BAAA;E1E01VV;E0Ej2VM;IAOI,wBAAA;E1E61VV;E0Ep2VM;IAOI,0BAAA;E1Eg2VV;E0Ev2VM;IAOI,wBAAA;E1Em2VV;E0E12VM;IAOI,0BAAA;E1Es2VV;E0E72VM;IAOI,wBAAA;E1Ey2VV;E0Eh3VM;IAOI,0BAAA;E1E42VV;E0En3VM;IAOI,wBAAA;E1E+2VV;E0Et3VM;IAOI,2BAAA;E1Ek3VV;E0Ez3VM;IAOI,wBAAA;E1Eq3VV;E0E53VM;IAOI,8BAAA;E1Ew3VV;E0E/3VM;IAOI,6BAAA;E1E23VV;E0El4VM;IAOI,2BAAA;E1E83VV;E0Er4VM;IAOI,6BAAA;E1Ei4VV;E0Ex4VM;IAOI,2BAAA;E1Eo4VV;E0E34VM;IAOI,6BAAA;E1Eu4VV;E0E94VM;IAOI,2BAAA;E1E04VV;E0Ej5VM;IAOI,6BAAA;E1E64VV;E0Ep5VM;IAOI,2BAAA;E1Eg5VV;E0Ev5VM;IAOI,8BAAA;E1Em5VV;E0E15VM;IAOI,2BAAA;E1Es5VV;E0E75VM;IAOI,4BAAA;E1Ey5VV;E0Eh6VM;IAOI,6BAAA;E1E45VV;AACF;AgBv6VI;E0DGI;IAOI,sBAAA;E1Ei6VV;E0Ex6VM;IAOI,uBAAA;E1Eo6VV;E0E36VM;IAOI,sBAAA;E1Eu6VV;E0E96VM;IAOI,8BAAA;E1E06VV;E0Ej7VM;IAOI,4BAAA;E1E66VV;E0Ep7VM;IAOI,2BAAA;E1Eg7VV;E0Ev7VM;IAOI,iCAAA;E1Em7VV;E0E17VM;IAOI,2BAAA;E1Es7VV;E0E77VM;IAOI,0BAAA;E1Ey7VV;E0Eh8VM;IAOI,gCAAA;E1E47VV;E0En8VM;IAOI,yBAAA;E1E+7VV;E0Et8VM;IAOI,wBAAA;E1Ek8VV;E0Ez8VM;IAOI,+BAAA;E1Eq8VV;E0E58VM;IAOI,yBAAA;E1Ew8VV;E0E/8VM;IAOI,6BAAA;E1E28VV;E0El9VM;IAOI,8BAAA;E1E88VV;E0Er9VM;IAOI,wBAAA;E1Ei9VV;E0Ex9VM;IAOI,+BAAA;E1Eo9VV;E0E39VM;IAOI,wBAAA;E1Eu9VV;E0E99VM;IAOI,yBAAA;E1E09VV;E0Ej+VM;IAOI,8BAAA;E1E69VV;E0Ep+VM;IAOI,iCAAA;E1Eg+VV;E0Ev+VM;IAOI,sCAAA;E1Em+VV;E0E1+VM;IAOI,yCAAA;E1Es+VV;E0E7+VM;IAOI,uBAAA;E1Ey+VV;E0Eh/VM;IAOI,uBAAA;E1E4+VV;E0En/VM;IAOI,yBAAA;E1E++VV;E0Et/VM;IAOI,yBAAA;E1Ek/VV;E0Ez/VM;IAOI,0BAAA;E1Eq/VV;E0E5/VM;IAOI,4BAAA;E1Ew/VV;E0E//VM;IAOI,kCAAA;E1E2/VV;E0ElgWM;IAOI,sCAAA;E1E8/VV;E0ErgWM;IAOI,oCAAA;E1EigWV;E0ExgWM;IAOI,kCAAA;E1EogWV;E0E3gWM;IAOI,yCAAA;E1EugWV;E0E9gWM;IAOI,wCAAA;E1E0gWV;E0EjhWM;IAOI,wCAAA;E1E6gWV;E0EphWM;IAOI,kCAAA;E1EghWV;E0EvhWM;IAOI,gCAAA;E1EmhWV;E0E1hWM;IAOI,8BAAA;E1EshWV;E0E7hWM;IAOI,gCAAA;E1EyhWV;E0EhiWM;IAOI,+BAAA;E1E4hWV;E0EniWM;IAOI,oCAAA;E1E+hWV;E0EtiWM;IAOI,kCAAA;E1EkiWV;E0EziWM;IAOI,gCAAA;E1EqiWV;E0E5iWM;IAOI,uCAAA;E1EwiWV;E0E/iWM;IAOI,sCAAA;E1E2iWV;E0EljWM;IAOI,iCAAA;E1E8iWV;E0ErjWM;IAOI,2BAAA;E1EijWV;E0ExjWM;IAOI,iCAAA;E1EojWV;E0E3jWM;IAOI,+BAAA;E1EujWV;E0E9jWM;IAOI,6BAAA;E1E0jWV;E0EjkWM;IAOI,+BAAA;E1E6jWV;E0EpkWM;IAOI,8BAAA;E1EgkWV;E0EvkWM;IAOI,oBAAA;E1EmkWV;E0E1kWM;IAOI,mBAAA;E1EskWV;E0E7kWM;IAOI,mBAAA;E1EykWV;E0EhlWM;IAOI,mBAAA;E1E4kWV;E0EnlWM;IAOI,mBAAA;E1E+kWV;E0EtlWM;IAOI,mBAAA;E1EklWV;E0EzlWM;IAOI,mBAAA;E1EqlWV;E0E5lWM;IAOI,mBAAA;E1EwlWV;E0E/lWM;IAOI,oBAAA;E1E2lWV;E0ElmWM;IAOI,0BAAA;E1E8lWV;E0ErmWM;IAOI,yBAAA;E1EimWV;E0ExmWM;IAOI,uBAAA;E1EomWV;E0E3mWM;IAOI,yBAAA;E1EumWV;E0E9mWM;IAOI,uBAAA;E1E0mWV;E0EjnWM;IAOI,yBAAA;E1E6mWV;E0EpnWM;IAOI,uBAAA;E1EgnWV;E0EvnWM;IAOI,yBAAA;E1EmnWV;E0E1nWM;IAOI,uBAAA;E1EsnWV;E0E7nWM;IAOI,0BAAA;E1EynWV;E0EhoWM;IAOI,uBAAA;E1E4nWV;E0EnoWM;IAOI,0BAAA;IAAA,yBAAA;E1EgoWV;E0EvoWM;IAOI,gCAAA;IAAA,+BAAA;E1EooWV;E0E3oWM;IAOI,+BAAA;IAAA,8BAAA;E1EwoWV;E0E/oWM;IAOI,6BAAA;IAAA,4BAAA;E1E4oWV;E0EnpWM;IAOI,+BAAA;IAAA,8BAAA;E1EgpWV;E0EvpWM;IAOI,6BAAA;IAAA,4BAAA;E1EopWV;E0E3pWM;IAOI,+BAAA;IAAA,8BAAA;E1EwpWV;E0E/pWM;IAOI,6BAAA;IAAA,4BAAA;E1E4pWV;E0EnqWM;IAOI,+BAAA;IAAA,8BAAA;E1EgqWV;E0EvqWM;IAOI,6BAAA;IAAA,4BAAA;E1EoqWV;E0E3qWM;IAOI,gCAAA;IAAA,+BAAA;E1EwqWV;E0E/qWM;IAOI,6BAAA;IAAA,4BAAA;E1E4qWV;E0EnrWM;IAOI,wBAAA;IAAA,2BAAA;E1EgrWV;E0EvrWM;IAOI,8BAAA;IAAA,iCAAA;E1EorWV;E0E3rWM;IAOI,6BAAA;IAAA,gCAAA;E1EwrWV;E0E/rWM;IAOI,2BAAA;IAAA,8BAAA;E1E4rWV;E0EnsWM;IAOI,6BAAA;IAAA,gCAAA;E1EgsWV;E0EvsWM;IAOI,2BAAA;IAAA,8BAAA;E1EosWV;E0E3sWM;IAOI,6BAAA;IAAA,gCAAA;E1EwsWV;E0E/sWM;IAOI,2BAAA;IAAA,8BAAA;E1E4sWV;E0EntWM;IAOI,6BAAA;IAAA,gCAAA;E1EgtWV;E0EvtWM;IAOI,2BAAA;IAAA,8BAAA;E1EotWV;E0E3tWM;IAOI,8BAAA;IAAA,iCAAA;E1EwtWV;E0E/tWM;IAOI,2BAAA;IAAA,8BAAA;E1E4tWV;E0EnuWM;IAOI,wBAAA;E1E+tWV;E0EtuWM;IAOI,8BAAA;E1EkuWV;E0EzuWM;IAOI,6BAAA;E1EquWV;E0E5uWM;IAOI,2BAAA;E1EwuWV;E0E/uWM;IAOI,6BAAA;E1E2uWV;E0ElvWM;IAOI,2BAAA;E1E8uWV;E0ErvWM;IAOI,6BAAA;E1EivWV;E0ExvWM;IAOI,2BAAA;E1EovWV;E0E3vWM;IAOI,6BAAA;E1EuvWV;E0E9vWM;IAOI,2BAAA;E1E0vWV;E0EjwWM;IAOI,8BAAA;E1E6vWV;E0EpwWM;IAOI,2BAAA;E1EgwWV;E0EvwWM;IAOI,0BAAA;E1EmwWV;E0E1wWM;IAOI,gCAAA;E1EswWV;E0E7wWM;IAOI,+BAAA;E1EywWV;E0EhxWM;IAOI,6BAAA;E1E4wWV;E0EnxWM;IAOI,+BAAA;E1E+wWV;E0EtxWM;IAOI,6BAAA;E1EkxWV;E0EzxWM;IAOI,+BAAA;E1EqxWV;E0E5xWM;IAOI,6BAAA;E1EwxWV;E0E/xWM;IAOI,+BAAA;E1E2xWV;E0ElyWM;IAOI,6BAAA;E1E8xWV;E0EryWM;IAOI,gCAAA;E1EiyWV;E0ExyWM;IAOI,6BAAA;E1EoyWV;E0E3yWM;IAOI,2BAAA;E1EuyWV;E0E9yWM;IAOI,iCAAA;E1E0yWV;E0EjzWM;IAOI,gCAAA;E1E6yWV;E0EpzWM;IAOI,8BAAA;E1EgzWV;E0EvzWM;IAOI,gCAAA;E1EmzWV;E0E1zWM;IAOI,8BAAA;E1EszWV;E0E7zWM;IAOI,gCAAA;E1EyzWV;E0Eh0WM;IAOI,8BAAA;E1E4zWV;E0En0WM;IAOI,gCAAA;E1E+zWV;E0Et0WM;IAOI,8BAAA;E1Ek0WV;E0Ez0WM;IAOI,iCAAA;E1Eq0WV;E0E50WM;IAOI,8BAAA;E1Ew0WV;E0E/0WM;IAOI,yBAAA;E1E20WV;E0El1WM;IAOI,+BAAA;E1E80WV;E0Er1WM;IAOI,8BAAA;E1Ei1WV;E0Ex1WM;IAOI,4BAAA;E1Eo1WV;E0E31WM;IAOI,8BAAA;E1Eu1WV;E0E91WM;IAOI,4BAAA;E1E01WV;E0Ej2WM;IAOI,8BAAA;E1E61WV;E0Ep2WM;IAOI,4BAAA;E1Eg2WV;E0Ev2WM;IAOI,8BAAA;E1Em2WV;E0E12WM;IAOI,4BAAA;E1Es2WV;E0E72WM;IAOI,+BAAA;E1Ey2WV;E0Eh3WM;IAOI,4BAAA;E1E42WV;E0En3WM;IAOI,2BAAA;E1E+2WV;E0Et3WM;IAOI,0BAAA;E1Ek3WV;E0Ez3WM;IAOI,wBAAA;E1Eq3WV;E0E53WM;IAOI,0BAAA;E1Ew3WV;E0E/3WM;IAOI,wBAAA;E1E23WV;E0El4WM;IAOI,0BAAA;E1E83WV;E0Er4WM;IAOI,wBAAA;E1Ei4WV;E0Ex4WM;IAOI,0BAAA;E1Eo4WV;E0E34WM;IAOI,wBAAA;E1Eu4WV;E0E94WM;IAOI,2BAAA;E1E04WV;E0Ej5WM;IAOI,iCAAA;IAAA,gCAAA;E1E84WV;E0Er5WM;IAOI,gCAAA;IAAA,+BAAA;E1Ek5WV;E0Ez5WM;IAOI,8BAAA;IAAA,6BAAA;E1Es5WV;E0E75WM;IAOI,gCAAA;IAAA,+BAAA;E1E05WV;E0Ej6WM;IAOI,8BAAA;IAAA,6BAAA;E1E85WV;E0Er6WM;IAOI,gCAAA;IAAA,+BAAA;E1Ek6WV;E0Ez6WM;IAOI,8BAAA;IAAA,6BAAA;E1Es6WV;E0E76WM;IAOI,gCAAA;IAAA,+BAAA;E1E06WV;E0Ej7WM;IAOI,8BAAA;IAAA,6BAAA;E1E86WV;E0Er7WM;IAOI,iCAAA;IAAA,gCAAA;E1Ek7WV;E0Ez7WM;IAOI,+BAAA;IAAA,kCAAA;E1Es7WV;E0E77WM;IAOI,8BAAA;IAAA,iCAAA;E1E07WV;E0Ej8WM;IAOI,4BAAA;IAAA,+BAAA;E1E87WV;E0Er8WM;IAOI,8BAAA;IAAA,iCAAA;E1Ek8WV;E0Ez8WM;IAOI,4BAAA;IAAA,+BAAA;E1Es8WV;E0E78WM;IAOI,8BAAA;IAAA,iCAAA;E1E08WV;E0Ej9WM;IAOI,4BAAA;IAAA,+BAAA;E1E88WV;E0Er9WM;IAOI,8BAAA;IAAA,iCAAA;E1Ek9WV;E0Ez9WM;IAOI,4BAAA;IAAA,+BAAA;E1Es9WV;E0E79WM;IAOI,+BAAA;IAAA,kCAAA;E1E09WV;E0Ej+WM;IAOI,+BAAA;E1E69WV;E0Ep+WM;IAOI,8BAAA;E1Eg+WV;E0Ev+WM;IAOI,4BAAA;E1Em+WV;E0E1+WM;IAOI,8BAAA;E1Es+WV;E0E7+WM;IAOI,4BAAA;E1Ey+WV;E0Eh/WM;IAOI,8BAAA;E1E4+WV;E0En/WM;IAOI,4BAAA;E1E++WV;E0Et/WM;IAOI,8BAAA;E1Ek/WV;E0Ez/WM;IAOI,4BAAA;E1Eq/WV;E0E5/WM;IAOI,+BAAA;E1Ew/WV;E0E//WM;IAOI,iCAAA;E1E2/WV;E0ElgXM;IAOI,gCAAA;E1E8/WV;E0ErgXM;IAOI,8BAAA;E1EigXV;E0ExgXM;IAOI,gCAAA;E1EogXV;E0E3gXM;IAOI,8BAAA;E1EugXV;E0E9gXM;IAOI,gCAAA;E1E0gXV;E0EjhXM;IAOI,8BAAA;E1E6gXV;E0EphXM;IAOI,gCAAA;E1EghXV;E0EvhXM;IAOI,8BAAA;E1EmhXV;E0E1hXM;IAOI,iCAAA;E1EshXV;E0E7hXM;IAOI,kCAAA;E1EyhXV;E0EhiXM;IAOI,iCAAA;E1E4hXV;E0EniXM;IAOI,+BAAA;E1E+hXV;E0EtiXM;IAOI,iCAAA;E1EkiXV;E0EziXM;IAOI,+BAAA;E1EqiXV;E0E5iXM;IAOI,iCAAA;E1EwiXV;E0E/iXM;IAOI,+BAAA;E1E2iXV;E0EljXM;IAOI,iCAAA;E1E8iXV;E0ErjXM;IAOI,+BAAA;E1EijXV;E0ExjXM;IAOI,kCAAA;E1EojXV;E0E3jXM;IAOI,gCAAA;E1EujXV;E0E9jXM;IAOI,+BAAA;E1E0jXV;E0EjkXM;IAOI,6BAAA;E1E6jXV;E0EpkXM;IAOI,+BAAA;E1EgkXV;E0EvkXM;IAOI,6BAAA;E1EmkXV;E0E1kXM;IAOI,+BAAA;E1EskXV;E0E7kXM;IAOI,6BAAA;E1EykXV;E0EhlXM;IAOI,+BAAA;E1E4kXV;E0EnlXM;IAOI,6BAAA;E1E+kXV;E0EtlXM;IAOI,gCAAA;E1EklXV;E0EzlXM;IAOI,qBAAA;E1EqlXV;E0E5lXM;IAOI,2BAAA;E1EwlXV;E0E/lXM;IAOI,0BAAA;E1E2lXV;E0ElmXM;IAOI,wBAAA;E1E8lXV;E0ErmXM;IAOI,0BAAA;E1EimXV;E0ExmXM;IAOI,wBAAA;E1EomXV;E0E3mXM;IAOI,0BAAA;E1EumXV;E0E9mXM;IAOI,wBAAA;E1E0mXV;E0EjnXM;IAOI,0BAAA;E1E6mXV;E0EpnXM;IAOI,wBAAA;E1EgnXV;E0EvnXM;IAOI,2BAAA;E1EmnXV;E0E1nXM;IAOI,2BAAA;IAAA,0BAAA;E1EunXV;E0E9nXM;IAOI,iCAAA;IAAA,gCAAA;E1E2nXV;E0EloXM;IAOI,gCAAA;IAAA,+BAAA;E1E+nXV;E0EtoXM;IAOI,8BAAA;IAAA,6BAAA;E1EmoXV;E0E1oXM;IAOI,gCAAA;IAAA,+BAAA;E1EuoXV;E0E9oXM;IAOI,8BAAA;IAAA,6BAAA;E1E2oXV;E0ElpXM;IAOI,gCAAA;IAAA,+BAAA;E1E+oXV;E0EtpXM;IAOI,8BAAA;IAAA,6BAAA;E1EmpXV;E0E1pXM;IAOI,gCAAA;IAAA,+BAAA;E1EupXV;E0E9pXM;IAOI,8BAAA;IAAA,6BAAA;E1E2pXV;E0ElqXM;IAOI,iCAAA;IAAA,gCAAA;E1E+pXV;E0EtqXM;IAOI,yBAAA;IAAA,4BAAA;E1EmqXV;E0E1qXM;IAOI,+BAAA;IAAA,kCAAA;E1EuqXV;E0E9qXM;IAOI,8BAAA;IAAA,iCAAA;E1E2qXV;E0ElrXM;IAOI,4BAAA;IAAA,+BAAA;E1E+qXV;E0EtrXM;IAOI,8BAAA;IAAA,iCAAA;E1EmrXV;E0E1rXM;IAOI,4BAAA;IAAA,+BAAA;E1EurXV;E0E9rXM;IAOI,8BAAA;IAAA,iCAAA;E1E2rXV;E0ElsXM;IAOI,4BAAA;IAAA,+BAAA;E1E+rXV;E0EtsXM;IAOI,8BAAA;IAAA,iCAAA;E1EmsXV;E0E1sXM;IAOI,4BAAA;IAAA,+BAAA;E1EusXV;E0E9sXM;IAOI,+BAAA;IAAA,kCAAA;E1E2sXV;E0EltXM;IAOI,yBAAA;E1E8sXV;E0ErtXM;IAOI,+BAAA;E1EitXV;E0ExtXM;IAOI,8BAAA;E1EotXV;E0E3tXM;IAOI,4BAAA;E1EutXV;E0E9tXM;IAOI,8BAAA;E1E0tXV;E0EjuXM;IAOI,4BAAA;E1E6tXV;E0EpuXM;IAOI,8BAAA;E1EguXV;E0EvuXM;IAOI,4BAAA;E1EmuXV;E0E1uXM;IAOI,8BAAA;E1EsuXV;E0E7uXM;IAOI,4BAAA;E1EyuXV;E0EhvXM;IAOI,+BAAA;E1E4uXV;E0EnvXM;IAOI,2BAAA;E1E+uXV;E0EtvXM;IAOI,iCAAA;E1EkvXV;E0EzvXM;IAOI,gCAAA;E1EqvXV;E0E5vXM;IAOI,8BAAA;E1EwvXV;E0E/vXM;IAOI,gCAAA;E1E2vXV;E0ElwXM;IAOI,8BAAA;E1E8vXV;E0ErwXM;IAOI,gCAAA;E1EiwXV;E0ExwXM;IAOI,8BAAA;E1EowXV;E0E3wXM;IAOI,gCAAA;E1EuwXV;E0E9wXM;IAOI,8BAAA;E1E0wXV;E0EjxXM;IAOI,iCAAA;E1E6wXV;E0EpxXM;IAOI,4BAAA;E1EgxXV;E0EvxXM;IAOI,kCAAA;E1EmxXV;E0E1xXM;IAOI,iCAAA;E1EsxXV;E0E7xXM;IAOI,+BAAA;E1EyxXV;E0EhyXM;IAOI,iCAAA;E1E4xXV;E0EnyXM;IAOI,+BAAA;E1E+xXV;E0EtyXM;IAOI,iCAAA;E1EkyXV;E0EzyXM;IAOI,+BAAA;E1EqyXV;E0E5yXM;IAOI,iCAAA;E1EwyXV;E0E/yXM;IAOI,+BAAA;E1E2yXV;E0ElzXM;IAOI,kCAAA;E1E8yXV;E0ErzXM;IAOI,0BAAA;E1EizXV;E0ExzXM;IAOI,gCAAA;E1EozXV;E0E3zXM;IAOI,+BAAA;E1EuzXV;E0E9zXM;IAOI,6BAAA;E1E0zXV;E0Ej0XM;IAOI,+BAAA;E1E6zXV;E0Ep0XM;IAOI,6BAAA;E1Eg0XV;E0Ev0XM;IAOI,+BAAA;E1Em0XV;E0E10XM;IAOI,6BAAA;E1Es0XV;E0E70XM;IAOI,+BAAA;E1Ey0XV;E0Eh1XM;IAOI,6BAAA;E1E40XV;E0En1XM;IAOI,gCAAA;E1E+0XV;E0Et1XM;IAOI,iBAAA;E1Ek1XV;E0Ez1XM;IAOI,uBAAA;E1Eq1XV;E0E51XM;IAOI,sBAAA;E1Ew1XV;E0E/1XM;IAOI,oBAAA;E1E21XV;E0El2XM;IAOI,sBAAA;E1E81XV;E0Er2XM;IAOI,oBAAA;E1Ei2XV;E0Ex2XM;IAOI,sBAAA;E1Eo2XV;E0E32XM;IAOI,oBAAA;E1Eu2XV;E0E92XM;IAOI,sBAAA;E1E02XV;E0Ej3XM;IAOI,oBAAA;E1E62XV;E0Ep3XM;IAOI,uBAAA;E1Eg3XV;E0Ev3XM;IAOI,qBAAA;E1Em3XV;E0E13XM;IAOI,2BAAA;E1Es3XV;E0E73XM;IAOI,0BAAA;E1Ey3XV;E0Eh4XM;IAOI,wBAAA;E1E43XV;E0En4XM;IAOI,0BAAA;E1E+3XV;E0Et4XM;IAOI,wBAAA;E1Ek4XV;E0Ez4XM;IAOI,0BAAA;E1Eq4XV;E0E54XM;IAOI,wBAAA;E1Ew4XV;E0E/4XM;IAOI,0BAAA;E1E24XV;E0El5XM;IAOI,wBAAA;E1E84XV;E0Er5XM;IAOI,2BAAA;E1Ei5XV;E0Ex5XM;IAOI,wBAAA;E1Eo5XV;E0E35XM;IAOI,8BAAA;E1Eu5XV;E0E95XM;IAOI,6BAAA;E1E05XV;E0Ej6XM;IAOI,2BAAA;E1E65XV;E0Ep6XM;IAOI,6BAAA;E1Eg6XV;E0Ev6XM;IAOI,2BAAA;E1Em6XV;E0E16XM;IAOI,6BAAA;E1Es6XV;E0E76XM;IAOI,2BAAA;E1Ey6XV;E0Eh7XM;IAOI,6BAAA;E1E46XV;E0En7XM;IAOI,2BAAA;E1E+6XV;E0Et7XM;IAOI,8BAAA;E1Ek7XV;E0Ez7XM;IAOI,2BAAA;E1Eq7XV;E0E57XM;IAOI,4BAAA;E1Ew7XV;E0E/7XM;IAOI,6BAAA;E1E27XV;AACF;AgBt8XI;E0DGI;IAOI,sBAAA;E1Eg8XV;E0Ev8XM;IAOI,uBAAA;E1Em8XV;E0E18XM;IAOI,sBAAA;E1Es8XV;E0E78XM;IAOI,8BAAA;E1Ey8XV;E0Eh9XM;IAOI,4BAAA;E1E48XV;E0En9XM;IAOI,2BAAA;E1E+8XV;E0Et9XM;IAOI,iCAAA;E1Ek9XV;E0Ez9XM;IAOI,2BAAA;E1Eq9XV;E0E59XM;IAOI,0BAAA;E1Ew9XV;E0E/9XM;IAOI,gCAAA;E1E29XV;E0El+XM;IAOI,yBAAA;E1E89XV;E0Er+XM;IAOI,wBAAA;E1Ei+XV;E0Ex+XM;IAOI,+BAAA;E1Eo+XV;E0E3+XM;IAOI,yBAAA;E1Eu+XV;E0E9+XM;IAOI,6BAAA;E1E0+XV;E0Ej/XM;IAOI,8BAAA;E1E6+XV;E0Ep/XM;IAOI,wBAAA;E1Eg/XV;E0Ev/XM;IAOI,+BAAA;E1Em/XV;E0E1/XM;IAOI,wBAAA;E1Es/XV;E0E7/XM;IAOI,yBAAA;E1Ey/XV;E0EhgYM;IAOI,8BAAA;E1E4/XV;E0EngYM;IAOI,iCAAA;E1E+/XV;E0EtgYM;IAOI,sCAAA;E1EkgYV;E0EzgYM;IAOI,yCAAA;E1EqgYV;E0E5gYM;IAOI,uBAAA;E1EwgYV;E0E/gYM;IAOI,uBAAA;E1E2gYV;E0ElhYM;IAOI,yBAAA;E1E8gYV;E0ErhYM;IAOI,yBAAA;E1EihYV;E0ExhYM;IAOI,0BAAA;E1EohYV;E0E3hYM;IAOI,4BAAA;E1EuhYV;E0E9hYM;IAOI,kCAAA;E1E0hYV;E0EjiYM;IAOI,sCAAA;E1E6hYV;E0EpiYM;IAOI,oCAAA;E1EgiYV;E0EviYM;IAOI,kCAAA;E1EmiYV;E0E1iYM;IAOI,yCAAA;E1EsiYV;E0E7iYM;IAOI,wCAAA;E1EyiYV;E0EhjYM;IAOI,wCAAA;E1E4iYV;E0EnjYM;IAOI,kCAAA;E1E+iYV;E0EtjYM;IAOI,gCAAA;E1EkjYV;E0EzjYM;IAOI,8BAAA;E1EqjYV;E0E5jYM;IAOI,gCAAA;E1EwjYV;E0E/jYM;IAOI,+BAAA;E1E2jYV;E0ElkYM;IAOI,oCAAA;E1E8jYV;E0ErkYM;IAOI,kCAAA;E1EikYV;E0ExkYM;IAOI,gCAAA;E1EokYV;E0E3kYM;IAOI,uCAAA;E1EukYV;E0E9kYM;IAOI,sCAAA;E1E0kYV;E0EjlYM;IAOI,iCAAA;E1E6kYV;E0EplYM;IAOI,2BAAA;E1EglYV;E0EvlYM;IAOI,iCAAA;E1EmlYV;E0E1lYM;IAOI,+BAAA;E1EslYV;E0E7lYM;IAOI,6BAAA;E1EylYV;E0EhmYM;IAOI,+BAAA;E1E4lYV;E0EnmYM;IAOI,8BAAA;E1E+lYV;E0EtmYM;IAOI,oBAAA;E1EkmYV;E0EzmYM;IAOI,mBAAA;E1EqmYV;E0E5mYM;IAOI,mBAAA;E1EwmYV;E0E/mYM;IAOI,mBAAA;E1E2mYV;E0ElnYM;IAOI,mBAAA;E1E8mYV;E0ErnYM;IAOI,mBAAA;E1EinYV;E0ExnYM;IAOI,mBAAA;E1EonYV;E0E3nYM;IAOI,mBAAA;E1EunYV;E0E9nYM;IAOI,oBAAA;E1E0nYV;E0EjoYM;IAOI,0BAAA;E1E6nYV;E0EpoYM;IAOI,yBAAA;E1EgoYV;E0EvoYM;IAOI,uBAAA;E1EmoYV;E0E1oYM;IAOI,yBAAA;E1EsoYV;E0E7oYM;IAOI,uBAAA;E1EyoYV;E0EhpYM;IAOI,yBAAA;E1E4oYV;E0EnpYM;IAOI,uBAAA;E1E+oYV;E0EtpYM;IAOI,yBAAA;E1EkpYV;E0EzpYM;IAOI,uBAAA;E1EqpYV;E0E5pYM;IAOI,0BAAA;E1EwpYV;E0E/pYM;IAOI,uBAAA;E1E2pYV;E0ElqYM;IAOI,0BAAA;IAAA,yBAAA;E1E+pYV;E0EtqYM;IAOI,gCAAA;IAAA,+BAAA;E1EmqYV;E0E1qYM;IAOI,+BAAA;IAAA,8BAAA;E1EuqYV;E0E9qYM;IAOI,6BAAA;IAAA,4BAAA;E1E2qYV;E0ElrYM;IAOI,+BAAA;IAAA,8BAAA;E1E+qYV;E0EtrYM;IAOI,6BAAA;IAAA,4BAAA;E1EmrYV;E0E1rYM;IAOI,+BAAA;IAAA,8BAAA;E1EurYV;E0E9rYM;IAOI,6BAAA;IAAA,4BAAA;E1E2rYV;E0ElsYM;IAOI,+BAAA;IAAA,8BAAA;E1E+rYV;E0EtsYM;IAOI,6BAAA;IAAA,4BAAA;E1EmsYV;E0E1sYM;IAOI,gCAAA;IAAA,+BAAA;E1EusYV;E0E9sYM;IAOI,6BAAA;IAAA,4BAAA;E1E2sYV;E0EltYM;IAOI,wBAAA;IAAA,2BAAA;E1E+sYV;E0EttYM;IAOI,8BAAA;IAAA,iCAAA;E1EmtYV;E0E1tYM;IAOI,6BAAA;IAAA,gCAAA;E1EutYV;E0E9tYM;IAOI,2BAAA;IAAA,8BAAA;E1E2tYV;E0EluYM;IAOI,6BAAA;IAAA,gCAAA;E1E+tYV;E0EtuYM;IAOI,2BAAA;IAAA,8BAAA;E1EmuYV;E0E1uYM;IAOI,6BAAA;IAAA,gCAAA;E1EuuYV;E0E9uYM;IAOI,2BAAA;IAAA,8BAAA;E1E2uYV;E0ElvYM;IAOI,6BAAA;IAAA,gCAAA;E1E+uYV;E0EtvYM;IAOI,2BAAA;IAAA,8BAAA;E1EmvYV;E0E1vYM;IAOI,8BAAA;IAAA,iCAAA;E1EuvYV;E0E9vYM;IAOI,2BAAA;IAAA,8BAAA;E1E2vYV;E0ElwYM;IAOI,wBAAA;E1E8vYV;E0ErwYM;IAOI,8BAAA;E1EiwYV;E0ExwYM;IAOI,6BAAA;E1EowYV;E0E3wYM;IAOI,2BAAA;E1EuwYV;E0E9wYM;IAOI,6BAAA;E1E0wYV;E0EjxYM;IAOI,2BAAA;E1E6wYV;E0EpxYM;IAOI,6BAAA;E1EgxYV;E0EvxYM;IAOI,2BAAA;E1EmxYV;E0E1xYM;IAOI,6BAAA;E1EsxYV;E0E7xYM;IAOI,2BAAA;E1EyxYV;E0EhyYM;IAOI,8BAAA;E1E4xYV;E0EnyYM;IAOI,2BAAA;E1E+xYV;E0EtyYM;IAOI,0BAAA;E1EkyYV;E0EzyYM;IAOI,gCAAA;E1EqyYV;E0E5yYM;IAOI,+BAAA;E1EwyYV;E0E/yYM;IAOI,6BAAA;E1E2yYV;E0ElzYM;IAOI,+BAAA;E1E8yYV;E0ErzYM;IAOI,6BAAA;E1EizYV;E0ExzYM;IAOI,+BAAA;E1EozYV;E0E3zYM;IAOI,6BAAA;E1EuzYV;E0E9zYM;IAOI,+BAAA;E1E0zYV;E0Ej0YM;IAOI,6BAAA;E1E6zYV;E0Ep0YM;IAOI,gCAAA;E1Eg0YV;E0Ev0YM;IAOI,6BAAA;E1Em0YV;E0E10YM;IAOI,2BAAA;E1Es0YV;E0E70YM;IAOI,iCAAA;E1Ey0YV;E0Eh1YM;IAOI,gCAAA;E1E40YV;E0En1YM;IAOI,8BAAA;E1E+0YV;E0Et1YM;IAOI,gCAAA;E1Ek1YV;E0Ez1YM;IAOI,8BAAA;E1Eq1YV;E0E51YM;IAOI,gCAAA;E1Ew1YV;E0E/1YM;IAOI,8BAAA;E1E21YV;E0El2YM;IAOI,gCAAA;E1E81YV;E0Er2YM;IAOI,8BAAA;E1Ei2YV;E0Ex2YM;IAOI,iCAAA;E1Eo2YV;E0E32YM;IAOI,8BAAA;E1Eu2YV;E0E92YM;IAOI,yBAAA;E1E02YV;E0Ej3YM;IAOI,+BAAA;E1E62YV;E0Ep3YM;IAOI,8BAAA;E1Eg3YV;E0Ev3YM;IAOI,4BAAA;E1Em3YV;E0E13YM;IAOI,8BAAA;E1Es3YV;E0E73YM;IAOI,4BAAA;E1Ey3YV;E0Eh4YM;IAOI,8BAAA;E1E43YV;E0En4YM;IAOI,4BAAA;E1E+3YV;E0Et4YM;IAOI,8BAAA;E1Ek4YV;E0Ez4YM;IAOI,4BAAA;E1Eq4YV;E0E54YM;IAOI,+BAAA;E1Ew4YV;E0E/4YM;IAOI,4BAAA;E1E24YV;E0El5YM;IAOI,2BAAA;E1E84YV;E0Er5YM;IAOI,0BAAA;E1Ei5YV;E0Ex5YM;IAOI,wBAAA;E1Eo5YV;E0E35YM;IAOI,0BAAA;E1Eu5YV;E0E95YM;IAOI,wBAAA;E1E05YV;E0Ej6YM;IAOI,0BAAA;E1E65YV;E0Ep6YM;IAOI,wBAAA;E1Eg6YV;E0Ev6YM;IAOI,0BAAA;E1Em6YV;E0E16YM;IAOI,wBAAA;E1Es6YV;E0E76YM;IAOI,2BAAA;E1Ey6YV;E0Eh7YM;IAOI,iCAAA;IAAA,gCAAA;E1E66YV;E0Ep7YM;IAOI,gCAAA;IAAA,+BAAA;E1Ei7YV;E0Ex7YM;IAOI,8BAAA;IAAA,6BAAA;E1Eq7YV;E0E57YM;IAOI,gCAAA;IAAA,+BAAA;E1Ey7YV;E0Eh8YM;IAOI,8BAAA;IAAA,6BAAA;E1E67YV;E0Ep8YM;IAOI,gCAAA;IAAA,+BAAA;E1Ei8YV;E0Ex8YM;IAOI,8BAAA;IAAA,6BAAA;E1Eq8YV;E0E58YM;IAOI,gCAAA;IAAA,+BAAA;E1Ey8YV;E0Eh9YM;IAOI,8BAAA;IAAA,6BAAA;E1E68YV;E0Ep9YM;IAOI,iCAAA;IAAA,gCAAA;E1Ei9YV;E0Ex9YM;IAOI,+BAAA;IAAA,kCAAA;E1Eq9YV;E0E59YM;IAOI,8BAAA;IAAA,iCAAA;E1Ey9YV;E0Eh+YM;IAOI,4BAAA;IAAA,+BAAA;E1E69YV;E0Ep+YM;IAOI,8BAAA;IAAA,iCAAA;E1Ei+YV;E0Ex+YM;IAOI,4BAAA;IAAA,+BAAA;E1Eq+YV;E0E5+YM;IAOI,8BAAA;IAAA,iCAAA;E1Ey+YV;E0Eh/YM;IAOI,4BAAA;IAAA,+BAAA;E1E6+YV;E0Ep/YM;IAOI,8BAAA;IAAA,iCAAA;E1Ei/YV;E0Ex/YM;IAOI,4BAAA;IAAA,+BAAA;E1Eq/YV;E0E5/YM;IAOI,+BAAA;IAAA,kCAAA;E1Ey/YV;E0EhgZM;IAOI,+BAAA;E1E4/YV;E0EngZM;IAOI,8BAAA;E1E+/YV;E0EtgZM;IAOI,4BAAA;E1EkgZV;E0EzgZM;IAOI,8BAAA;E1EqgZV;E0E5gZM;IAOI,4BAAA;E1EwgZV;E0E/gZM;IAOI,8BAAA;E1E2gZV;E0ElhZM;IAOI,4BAAA;E1E8gZV;E0ErhZM;IAOI,8BAAA;E1EihZV;E0ExhZM;IAOI,4BAAA;E1EohZV;E0E3hZM;IAOI,+BAAA;E1EuhZV;E0E9hZM;IAOI,iCAAA;E1E0hZV;E0EjiZM;IAOI,gCAAA;E1E6hZV;E0EpiZM;IAOI,8BAAA;E1EgiZV;E0EviZM;IAOI,gCAAA;E1EmiZV;E0E1iZM;IAOI,8BAAA;E1EsiZV;E0E7iZM;IAOI,gCAAA;E1EyiZV;E0EhjZM;IAOI,8BAAA;E1E4iZV;E0EnjZM;IAOI,gCAAA;E1E+iZV;E0EtjZM;IAOI,8BAAA;E1EkjZV;E0EzjZM;IAOI,iCAAA;E1EqjZV;E0E5jZM;IAOI,kCAAA;E1EwjZV;E0E/jZM;IAOI,iCAAA;E1E2jZV;E0ElkZM;IAOI,+BAAA;E1E8jZV;E0ErkZM;IAOI,iCAAA;E1EikZV;E0ExkZM;IAOI,+BAAA;E1EokZV;E0E3kZM;IAOI,iCAAA;E1EukZV;E0E9kZM;IAOI,+BAAA;E1E0kZV;E0EjlZM;IAOI,iCAAA;E1E6kZV;E0EplZM;IAOI,+BAAA;E1EglZV;E0EvlZM;IAOI,kCAAA;E1EmlZV;E0E1lZM;IAOI,gCAAA;E1EslZV;E0E7lZM;IAOI,+BAAA;E1EylZV;E0EhmZM;IAOI,6BAAA;E1E4lZV;E0EnmZM;IAOI,+BAAA;E1E+lZV;E0EtmZM;IAOI,6BAAA;E1EkmZV;E0EzmZM;IAOI,+BAAA;E1EqmZV;E0E5mZM;IAOI,6BAAA;E1EwmZV;E0E/mZM;IAOI,+BAAA;E1E2mZV;E0ElnZM;IAOI,6BAAA;E1E8mZV;E0ErnZM;IAOI,gCAAA;E1EinZV;E0ExnZM;IAOI,qBAAA;E1EonZV;E0E3nZM;IAOI,2BAAA;E1EunZV;E0E9nZM;IAOI,0BAAA;E1E0nZV;E0EjoZM;IAOI,wBAAA;E1E6nZV;E0EpoZM;IAOI,0BAAA;E1EgoZV;E0EvoZM;IAOI,wBAAA;E1EmoZV;E0E1oZM;IAOI,0BAAA;E1EsoZV;E0E7oZM;IAOI,wBAAA;E1EyoZV;E0EhpZM;IAOI,0BAAA;E1E4oZV;E0EnpZM;IAOI,wBAAA;E1E+oZV;E0EtpZM;IAOI,2BAAA;E1EkpZV;E0EzpZM;IAOI,2BAAA;IAAA,0BAAA;E1EspZV;E0E7pZM;IAOI,iCAAA;IAAA,gCAAA;E1E0pZV;E0EjqZM;IAOI,gCAAA;IAAA,+BAAA;E1E8pZV;E0ErqZM;IAOI,8BAAA;IAAA,6BAAA;E1EkqZV;E0EzqZM;IAOI,gCAAA;IAAA,+BAAA;E1EsqZV;E0E7qZM;IAOI,8BAAA;IAAA,6BAAA;E1E0qZV;E0EjrZM;IAOI,gCAAA;IAAA,+BAAA;E1E8qZV;E0ErrZM;IAOI,8BAAA;IAAA,6BAAA;E1EkrZV;E0EzrZM;IAOI,gCAAA;IAAA,+BAAA;E1EsrZV;E0E7rZM;IAOI,8BAAA;IAAA,6BAAA;E1E0rZV;E0EjsZM;IAOI,iCAAA;IAAA,gCAAA;E1E8rZV;E0ErsZM;IAOI,yBAAA;IAAA,4BAAA;E1EksZV;E0EzsZM;IAOI,+BAAA;IAAA,kCAAA;E1EssZV;E0E7sZM;IAOI,8BAAA;IAAA,iCAAA;E1E0sZV;E0EjtZM;IAOI,4BAAA;IAAA,+BAAA;E1E8sZV;E0ErtZM;IAOI,8BAAA;IAAA,iCAAA;E1EktZV;E0EztZM;IAOI,4BAAA;IAAA,+BAAA;E1EstZV;E0E7tZM;IAOI,8BAAA;IAAA,iCAAA;E1E0tZV;E0EjuZM;IAOI,4BAAA;IAAA,+BAAA;E1E8tZV;E0EruZM;IAOI,8BAAA;IAAA,iCAAA;E1EkuZV;E0EzuZM;IAOI,4BAAA;IAAA,+BAAA;E1EsuZV;E0E7uZM;IAOI,+BAAA;IAAA,kCAAA;E1E0uZV;E0EjvZM;IAOI,yBAAA;E1E6uZV;E0EpvZM;IAOI,+BAAA;E1EgvZV;E0EvvZM;IAOI,8BAAA;E1EmvZV;E0E1vZM;IAOI,4BAAA;E1EsvZV;E0E7vZM;IAOI,8BAAA;E1EyvZV;E0EhwZM;IAOI,4BAAA;E1E4vZV;E0EnwZM;IAOI,8BAAA;E1E+vZV;E0EtwZM;IAOI,4BAAA;E1EkwZV;E0EzwZM;IAOI,8BAAA;E1EqwZV;E0E5wZM;IAOI,4BAAA;E1EwwZV;E0E/wZM;IAOI,+BAAA;E1E2wZV;E0ElxZM;IAOI,2BAAA;E1E8wZV;E0ErxZM;IAOI,iCAAA;E1EixZV;E0ExxZM;IAOI,gCAAA;E1EoxZV;E0E3xZM;IAOI,8BAAA;E1EuxZV;E0E9xZM;IAOI,gCAAA;E1E0xZV;E0EjyZM;IAOI,8BAAA;E1E6xZV;E0EpyZM;IAOI,gCAAA;E1EgyZV;E0EvyZM;IAOI,8BAAA;E1EmyZV;E0E1yZM;IAOI,gCAAA;E1EsyZV;E0E7yZM;IAOI,8BAAA;E1EyyZV;E0EhzZM;IAOI,iCAAA;E1E4yZV;E0EnzZM;IAOI,4BAAA;E1E+yZV;E0EtzZM;IAOI,kCAAA;E1EkzZV;E0EzzZM;IAOI,iCAAA;E1EqzZV;E0E5zZM;IAOI,+BAAA;E1EwzZV;E0E/zZM;IAOI,iCAAA;E1E2zZV;E0El0ZM;IAOI,+BAAA;E1E8zZV;E0Er0ZM;IAOI,iCAAA;E1Ei0ZV;E0Ex0ZM;IAOI,+BAAA;E1Eo0ZV;E0E30ZM;IAOI,iCAAA;E1Eu0ZV;E0E90ZM;IAOI,+BAAA;E1E00ZV;E0Ej1ZM;IAOI,kCAAA;E1E60ZV;E0Ep1ZM;IAOI,0BAAA;E1Eg1ZV;E0Ev1ZM;IAOI,gCAAA;E1Em1ZV;E0E11ZM;IAOI,+BAAA;E1Es1ZV;E0E71ZM;IAOI,6BAAA;E1Ey1ZV;E0Eh2ZM;IAOI,+BAAA;E1E41ZV;E0En2ZM;IAOI,6BAAA;E1E+1ZV;E0Et2ZM;IAOI,+BAAA;E1Ek2ZV;E0Ez2ZM;IAOI,6BAAA;E1Eq2ZV;E0E52ZM;IAOI,+BAAA;E1Ew2ZV;E0E/2ZM;IAOI,6BAAA;E1E22ZV;E0El3ZM;IAOI,gCAAA;E1E82ZV;E0Er3ZM;IAOI,iBAAA;E1Ei3ZV;E0Ex3ZM;IAOI,uBAAA;E1Eo3ZV;E0E33ZM;IAOI,sBAAA;E1Eu3ZV;E0E93ZM;IAOI,oBAAA;E1E03ZV;E0Ej4ZM;IAOI,sBAAA;E1E63ZV;E0Ep4ZM;IAOI,oBAAA;E1Eg4ZV;E0Ev4ZM;IAOI,sBAAA;E1Em4ZV;E0E14ZM;IAOI,oBAAA;E1Es4ZV;E0E74ZM;IAOI,sBAAA;E1Ey4ZV;E0Eh5ZM;IAOI,oBAAA;E1E44ZV;E0En5ZM;IAOI,uBAAA;E1E+4ZV;E0Et5ZM;IAOI,qBAAA;E1Ek5ZV;E0Ez5ZM;IAOI,2BAAA;E1Eq5ZV;E0E55ZM;IAOI,0BAAA;E1Ew5ZV;E0E/5ZM;IAOI,wBAAA;E1E25ZV;E0El6ZM;IAOI,0BAAA;E1E85ZV;E0Er6ZM;IAOI,wBAAA;E1Ei6ZV;E0Ex6ZM;IAOI,0BAAA;E1Eo6ZV;E0E36ZM;IAOI,wBAAA;E1Eu6ZV;E0E96ZM;IAOI,0BAAA;E1E06ZV;E0Ej7ZM;IAOI,wBAAA;E1E66ZV;E0Ep7ZM;IAOI,2BAAA;E1Eg7ZV;E0Ev7ZM;IAOI,wBAAA;E1Em7ZV;E0E17ZM;IAOI,8BAAA;E1Es7ZV;E0E77ZM;IAOI,6BAAA;E1Ey7ZV;E0Eh8ZM;IAOI,2BAAA;E1E47ZV;E0En8ZM;IAOI,6BAAA;E1E+7ZV;E0Et8ZM;IAOI,2BAAA;E1Ek8ZV;E0Ez8ZM;IAOI,6BAAA;E1Eq8ZV;E0E58ZM;IAOI,2BAAA;E1Ew8ZV;E0E/8ZM;IAOI,6BAAA;E1E28ZV;E0El9ZM;IAOI,2BAAA;E1E88ZV;E0Er9ZM;IAOI,8BAAA;E1Ei9ZV;E0Ex9ZM;IAOI,2BAAA;E1Eo9ZV;E0E39ZM;IAOI,4BAAA;E1Eu9ZV;E0E99ZM;IAOI,6BAAA;E1E09ZV;AACF;AgBr+ZI;E0DGI;IAOI,sBAAA;E1E+9ZV;E0Et+ZM;IAOI,uBAAA;E1Ek+ZV;E0Ez+ZM;IAOI,sBAAA;E1Eq+ZV;E0E5+ZM;IAOI,8BAAA;E1Ew+ZV;E0E/+ZM;IAOI,4BAAA;E1E2+ZV;E0El/ZM;IAOI,2BAAA;E1E8+ZV;E0Er/ZM;IAOI,iCAAA;E1Ei/ZV;E0Ex/ZM;IAOI,2BAAA;E1Eo/ZV;E0E3/ZM;IAOI,0BAAA;E1Eu/ZV;E0E9/ZM;IAOI,gCAAA;E1E0/ZV;E0EjgaM;IAOI,yBAAA;E1E6/ZV;E0EpgaM;IAOI,wBAAA;E1EggaV;E0EvgaM;IAOI,+BAAA;E1EmgaV;E0E1gaM;IAOI,yBAAA;E1EsgaV;E0E7gaM;IAOI,6BAAA;E1EygaV;E0EhhaM;IAOI,8BAAA;E1E4gaV;E0EnhaM;IAOI,wBAAA;E1E+gaV;E0EthaM;IAOI,+BAAA;E1EkhaV;E0EzhaM;IAOI,wBAAA;E1EqhaV;E0E5haM;IAOI,yBAAA;E1EwhaV;E0E/haM;IAOI,8BAAA;E1E2haV;E0EliaM;IAOI,iCAAA;E1E8haV;E0EriaM;IAOI,sCAAA;E1EiiaV;E0ExiaM;IAOI,yCAAA;E1EoiaV;E0E3iaM;IAOI,uBAAA;E1EuiaV;E0E9iaM;IAOI,uBAAA;E1E0iaV;E0EjjaM;IAOI,yBAAA;E1E6iaV;E0EpjaM;IAOI,yBAAA;E1EgjaV;E0EvjaM;IAOI,0BAAA;E1EmjaV;E0E1jaM;IAOI,4BAAA;E1EsjaV;E0E7jaM;IAOI,kCAAA;E1EyjaV;E0EhkaM;IAOI,sCAAA;E1E4jaV;E0EnkaM;IAOI,oCAAA;E1E+jaV;E0EtkaM;IAOI,kCAAA;E1EkkaV;E0EzkaM;IAOI,yCAAA;E1EqkaV;E0E5kaM;IAOI,wCAAA;E1EwkaV;E0E/kaM;IAOI,wCAAA;E1E2kaV;E0EllaM;IAOI,kCAAA;E1E8kaV;E0ErlaM;IAOI,gCAAA;E1EilaV;E0ExlaM;IAOI,8BAAA;E1EolaV;E0E3laM;IAOI,gCAAA;E1EulaV;E0E9laM;IAOI,+BAAA;E1E0laV;E0EjmaM;IAOI,oCAAA;E1E6laV;E0EpmaM;IAOI,kCAAA;E1EgmaV;E0EvmaM;IAOI,gCAAA;E1EmmaV;E0E1maM;IAOI,uCAAA;E1EsmaV;E0E7maM;IAOI,sCAAA;E1EymaV;E0EhnaM;IAOI,iCAAA;E1E4maV;E0EnnaM;IAOI,2BAAA;E1E+maV;E0EtnaM;IAOI,iCAAA;E1EknaV;E0EznaM;IAOI,+BAAA;E1EqnaV;E0E5naM;IAOI,6BAAA;E1EwnaV;E0E/naM;IAOI,+BAAA;E1E2naV;E0EloaM;IAOI,8BAAA;E1E8naV;E0EroaM;IAOI,oBAAA;E1EioaV;E0ExoaM;IAOI,mBAAA;E1EooaV;E0E3oaM;IAOI,mBAAA;E1EuoaV;E0E9oaM;IAOI,mBAAA;E1E0oaV;E0EjpaM;IAOI,mBAAA;E1E6oaV;E0EppaM;IAOI,mBAAA;E1EgpaV;E0EvpaM;IAOI,mBAAA;E1EmpaV;E0E1paM;IAOI,mBAAA;E1EspaV;E0E7paM;IAOI,oBAAA;E1EypaV;E0EhqaM;IAOI,0BAAA;E1E4paV;E0EnqaM;IAOI,yBAAA;E1E+paV;E0EtqaM;IAOI,uBAAA;E1EkqaV;E0EzqaM;IAOI,yBAAA;E1EqqaV;E0E5qaM;IAOI,uBAAA;E1EwqaV;E0E/qaM;IAOI,yBAAA;E1E2qaV;E0ElraM;IAOI,uBAAA;E1E8qaV;E0ErraM;IAOI,yBAAA;E1EiraV;E0ExraM;IAOI,uBAAA;E1EoraV;E0E3raM;IAOI,0BAAA;E1EuraV;E0E9raM;IAOI,uBAAA;E1E0raV;E0EjsaM;IAOI,0BAAA;IAAA,yBAAA;E1E8raV;E0ErsaM;IAOI,gCAAA;IAAA,+BAAA;E1EksaV;E0EzsaM;IAOI,+BAAA;IAAA,8BAAA;E1EssaV;E0E7saM;IAOI,6BAAA;IAAA,4BAAA;E1E0saV;E0EjtaM;IAOI,+BAAA;IAAA,8BAAA;E1E8saV;E0ErtaM;IAOI,6BAAA;IAAA,4BAAA;E1EktaV;E0EztaM;IAOI,+BAAA;IAAA,8BAAA;E1EstaV;E0E7taM;IAOI,6BAAA;IAAA,4BAAA;E1E0taV;E0EjuaM;IAOI,+BAAA;IAAA,8BAAA;E1E8taV;E0EruaM;IAOI,6BAAA;IAAA,4BAAA;E1EkuaV;E0EzuaM;IAOI,gCAAA;IAAA,+BAAA;E1EsuaV;E0E7uaM;IAOI,6BAAA;IAAA,4BAAA;E1E0uaV;E0EjvaM;IAOI,wBAAA;IAAA,2BAAA;E1E8uaV;E0ErvaM;IAOI,8BAAA;IAAA,iCAAA;E1EkvaV;E0EzvaM;IAOI,6BAAA;IAAA,gCAAA;E1EsvaV;E0E7vaM;IAOI,2BAAA;IAAA,8BAAA;E1E0vaV;E0EjwaM;IAOI,6BAAA;IAAA,gCAAA;E1E8vaV;E0ErwaM;IAOI,2BAAA;IAAA,8BAAA;E1EkwaV;E0EzwaM;IAOI,6BAAA;IAAA,gCAAA;E1EswaV;E0E7waM;IAOI,2BAAA;IAAA,8BAAA;E1E0waV;E0EjxaM;IAOI,6BAAA;IAAA,gCAAA;E1E8waV;E0ErxaM;IAOI,2BAAA;IAAA,8BAAA;E1EkxaV;E0EzxaM;IAOI,8BAAA;IAAA,iCAAA;E1EsxaV;E0E7xaM;IAOI,2BAAA;IAAA,8BAAA;E1E0xaV;E0EjyaM;IAOI,wBAAA;E1E6xaV;E0EpyaM;IAOI,8BAAA;E1EgyaV;E0EvyaM;IAOI,6BAAA;E1EmyaV;E0E1yaM;IAOI,2BAAA;E1EsyaV;E0E7yaM;IAOI,6BAAA;E1EyyaV;E0EhzaM;IAOI,2BAAA;E1E4yaV;E0EnzaM;IAOI,6BAAA;E1E+yaV;E0EtzaM;IAOI,2BAAA;E1EkzaV;E0EzzaM;IAOI,6BAAA;E1EqzaV;E0E5zaM;IAOI,2BAAA;E1EwzaV;E0E/zaM;IAOI,8BAAA;E1E2zaV;E0El0aM;IAOI,2BAAA;E1E8zaV;E0Er0aM;IAOI,0BAAA;E1Ei0aV;E0Ex0aM;IAOI,gCAAA;E1Eo0aV;E0E30aM;IAOI,+BAAA;E1Eu0aV;E0E90aM;IAOI,6BAAA;E1E00aV;E0Ej1aM;IAOI,+BAAA;E1E60aV;E0Ep1aM;IAOI,6BAAA;E1Eg1aV;E0Ev1aM;IAOI,+BAAA;E1Em1aV;E0E11aM;IAOI,6BAAA;E1Es1aV;E0E71aM;IAOI,+BAAA;E1Ey1aV;E0Eh2aM;IAOI,6BAAA;E1E41aV;E0En2aM;IAOI,gCAAA;E1E+1aV;E0Et2aM;IAOI,6BAAA;E1Ek2aV;E0Ez2aM;IAOI,2BAAA;E1Eq2aV;E0E52aM;IAOI,iCAAA;E1Ew2aV;E0E/2aM;IAOI,gCAAA;E1E22aV;E0El3aM;IAOI,8BAAA;E1E82aV;E0Er3aM;IAOI,gCAAA;E1Ei3aV;E0Ex3aM;IAOI,8BAAA;E1Eo3aV;E0E33aM;IAOI,gCAAA;E1Eu3aV;E0E93aM;IAOI,8BAAA;E1E03aV;E0Ej4aM;IAOI,gCAAA;E1E63aV;E0Ep4aM;IAOI,8BAAA;E1Eg4aV;E0Ev4aM;IAOI,iCAAA;E1Em4aV;E0E14aM;IAOI,8BAAA;E1Es4aV;E0E74aM;IAOI,yBAAA;E1Ey4aV;E0Eh5aM;IAOI,+BAAA;E1E44aV;E0En5aM;IAOI,8BAAA;E1E+4aV;E0Et5aM;IAOI,4BAAA;E1Ek5aV;E0Ez5aM;IAOI,8BAAA;E1Eq5aV;E0E55aM;IAOI,4BAAA;E1Ew5aV;E0E/5aM;IAOI,8BAAA;E1E25aV;E0El6aM;IAOI,4BAAA;E1E85aV;E0Er6aM;IAOI,8BAAA;E1Ei6aV;E0Ex6aM;IAOI,4BAAA;E1Eo6aV;E0E36aM;IAOI,+BAAA;E1Eu6aV;E0E96aM;IAOI,4BAAA;E1E06aV;E0Ej7aM;IAOI,2BAAA;E1E66aV;E0Ep7aM;IAOI,0BAAA;E1Eg7aV;E0Ev7aM;IAOI,wBAAA;E1Em7aV;E0E17aM;IAOI,0BAAA;E1Es7aV;E0E77aM;IAOI,wBAAA;E1Ey7aV;E0Eh8aM;IAOI,0BAAA;E1E47aV;E0En8aM;IAOI,wBAAA;E1E+7aV;E0Et8aM;IAOI,0BAAA;E1Ek8aV;E0Ez8aM;IAOI,wBAAA;E1Eq8aV;E0E58aM;IAOI,2BAAA;E1Ew8aV;E0E/8aM;IAOI,iCAAA;IAAA,gCAAA;E1E48aV;E0En9aM;IAOI,gCAAA;IAAA,+BAAA;E1Eg9aV;E0Ev9aM;IAOI,8BAAA;IAAA,6BAAA;E1Eo9aV;E0E39aM;IAOI,gCAAA;IAAA,+BAAA;E1Ew9aV;E0E/9aM;IAOI,8BAAA;IAAA,6BAAA;E1E49aV;E0En+aM;IAOI,gCAAA;IAAA,+BAAA;E1Eg+aV;E0Ev+aM;IAOI,8BAAA;IAAA,6BAAA;E1Eo+aV;E0E3+aM;IAOI,gCAAA;IAAA,+BAAA;E1Ew+aV;E0E/+aM;IAOI,8BAAA;IAAA,6BAAA;E1E4+aV;E0En/aM;IAOI,iCAAA;IAAA,gCAAA;E1Eg/aV;E0Ev/aM;IAOI,+BAAA;IAAA,kCAAA;E1Eo/aV;E0E3/aM;IAOI,8BAAA;IAAA,iCAAA;E1Ew/aV;E0E//aM;IAOI,4BAAA;IAAA,+BAAA;E1E4/aV;E0EngbM;IAOI,8BAAA;IAAA,iCAAA;E1EggbV;E0EvgbM;IAOI,4BAAA;IAAA,+BAAA;E1EogbV;E0E3gbM;IAOI,8BAAA;IAAA,iCAAA;E1EwgbV;E0E/gbM;IAOI,4BAAA;IAAA,+BAAA;E1E4gbV;E0EnhbM;IAOI,8BAAA;IAAA,iCAAA;E1EghbV;E0EvhbM;IAOI,4BAAA;IAAA,+BAAA;E1EohbV;E0E3hbM;IAOI,+BAAA;IAAA,kCAAA;E1EwhbV;E0E/hbM;IAOI,+BAAA;E1E2hbV;E0ElibM;IAOI,8BAAA;E1E8hbV;E0EribM;IAOI,4BAAA;E1EiibV;E0ExibM;IAOI,8BAAA;E1EoibV;E0E3ibM;IAOI,4BAAA;E1EuibV;E0E9ibM;IAOI,8BAAA;E1E0ibV;E0EjjbM;IAOI,4BAAA;E1E6ibV;E0EpjbM;IAOI,8BAAA;E1EgjbV;E0EvjbM;IAOI,4BAAA;E1EmjbV;E0E1jbM;IAOI,+BAAA;E1EsjbV;E0E7jbM;IAOI,iCAAA;E1EyjbV;E0EhkbM;IAOI,gCAAA;E1E4jbV;E0EnkbM;IAOI,8BAAA;E1E+jbV;E0EtkbM;IAOI,gCAAA;E1EkkbV;E0EzkbM;IAOI,8BAAA;E1EqkbV;E0E5kbM;IAOI,gCAAA;E1EwkbV;E0E/kbM;IAOI,8BAAA;E1E2kbV;E0EllbM;IAOI,gCAAA;E1E8kbV;E0ErlbM;IAOI,8BAAA;E1EilbV;E0ExlbM;IAOI,iCAAA;E1EolbV;E0E3lbM;IAOI,kCAAA;E1EulbV;E0E9lbM;IAOI,iCAAA;E1E0lbV;E0EjmbM;IAOI,+BAAA;E1E6lbV;E0EpmbM;IAOI,iCAAA;E1EgmbV;E0EvmbM;IAOI,+BAAA;E1EmmbV;E0E1mbM;IAOI,iCAAA;E1EsmbV;E0E7mbM;IAOI,+BAAA;E1EymbV;E0EhnbM;IAOI,iCAAA;E1E4mbV;E0EnnbM;IAOI,+BAAA;E1E+mbV;E0EtnbM;IAOI,kCAAA;E1EknbV;E0EznbM;IAOI,gCAAA;E1EqnbV;E0E5nbM;IAOI,+BAAA;E1EwnbV;E0E/nbM;IAOI,6BAAA;E1E2nbV;E0ElobM;IAOI,+BAAA;E1E8nbV;E0ErobM;IAOI,6BAAA;E1EiobV;E0ExobM;IAOI,+BAAA;E1EoobV;E0E3obM;IAOI,6BAAA;E1EuobV;E0E9obM;IAOI,+BAAA;E1E0obV;E0EjpbM;IAOI,6BAAA;E1E6obV;E0EppbM;IAOI,gCAAA;E1EgpbV;E0EvpbM;IAOI,qBAAA;E1EmpbV;E0E1pbM;IAOI,2BAAA;E1EspbV;E0E7pbM;IAOI,0BAAA;E1EypbV;E0EhqbM;IAOI,wBAAA;E1E4pbV;E0EnqbM;IAOI,0BAAA;E1E+pbV;E0EtqbM;IAOI,wBAAA;E1EkqbV;E0EzqbM;IAOI,0BAAA;E1EqqbV;E0E5qbM;IAOI,wBAAA;E1EwqbV;E0E/qbM;IAOI,0BAAA;E1E2qbV;E0ElrbM;IAOI,wBAAA;E1E8qbV;E0ErrbM;IAOI,2BAAA;E1EirbV;E0ExrbM;IAOI,2BAAA;IAAA,0BAAA;E1EqrbV;E0E5rbM;IAOI,iCAAA;IAAA,gCAAA;E1EyrbV;E0EhsbM;IAOI,gCAAA;IAAA,+BAAA;E1E6rbV;E0EpsbM;IAOI,8BAAA;IAAA,6BAAA;E1EisbV;E0ExsbM;IAOI,gCAAA;IAAA,+BAAA;E1EqsbV;E0E5sbM;IAOI,8BAAA;IAAA,6BAAA;E1EysbV;E0EhtbM;IAOI,gCAAA;IAAA,+BAAA;E1E6sbV;E0EptbM;IAOI,8BAAA;IAAA,6BAAA;E1EitbV;E0ExtbM;IAOI,gCAAA;IAAA,+BAAA;E1EqtbV;E0E5tbM;IAOI,8BAAA;IAAA,6BAAA;E1EytbV;E0EhubM;IAOI,iCAAA;IAAA,gCAAA;E1E6tbV;E0EpubM;IAOI,yBAAA;IAAA,4BAAA;E1EiubV;E0ExubM;IAOI,+BAAA;IAAA,kCAAA;E1EqubV;E0E5ubM;IAOI,8BAAA;IAAA,iCAAA;E1EyubV;E0EhvbM;IAOI,4BAAA;IAAA,+BAAA;E1E6ubV;E0EpvbM;IAOI,8BAAA;IAAA,iCAAA;E1EivbV;E0ExvbM;IAOI,4BAAA;IAAA,+BAAA;E1EqvbV;E0E5vbM;IAOI,8BAAA;IAAA,iCAAA;E1EyvbV;E0EhwbM;IAOI,4BAAA;IAAA,+BAAA;E1E6vbV;E0EpwbM;IAOI,8BAAA;IAAA,iCAAA;E1EiwbV;E0ExwbM;IAOI,4BAAA;IAAA,+BAAA;E1EqwbV;E0E5wbM;IAOI,+BAAA;IAAA,kCAAA;E1EywbV;E0EhxbM;IAOI,yBAAA;E1E4wbV;E0EnxbM;IAOI,+BAAA;E1E+wbV;E0EtxbM;IAOI,8BAAA;E1EkxbV;E0EzxbM;IAOI,4BAAA;E1EqxbV;E0E5xbM;IAOI,8BAAA;E1EwxbV;E0E/xbM;IAOI,4BAAA;E1E2xbV;E0ElybM;IAOI,8BAAA;E1E8xbV;E0ErybM;IAOI,4BAAA;E1EiybV;E0ExybM;IAOI,8BAAA;E1EoybV;E0E3ybM;IAOI,4BAAA;E1EuybV;E0E9ybM;IAOI,+BAAA;E1E0ybV;E0EjzbM;IAOI,2BAAA;E1E6ybV;E0EpzbM;IAOI,iCAAA;E1EgzbV;E0EvzbM;IAOI,gCAAA;E1EmzbV;E0E1zbM;IAOI,8BAAA;E1EszbV;E0E7zbM;IAOI,gCAAA;E1EyzbV;E0Eh0bM;IAOI,8BAAA;E1E4zbV;E0En0bM;IAOI,gCAAA;E1E+zbV;E0Et0bM;IAOI,8BAAA;E1Ek0bV;E0Ez0bM;IAOI,gCAAA;E1Eq0bV;E0E50bM;IAOI,8BAAA;E1Ew0bV;E0E/0bM;IAOI,iCAAA;E1E20bV;E0El1bM;IAOI,4BAAA;E1E80bV;E0Er1bM;IAOI,kCAAA;E1Ei1bV;E0Ex1bM;IAOI,iCAAA;E1Eo1bV;E0E31bM;IAOI,+BAAA;E1Eu1bV;E0E91bM;IAOI,iCAAA;E1E01bV;E0Ej2bM;IAOI,+BAAA;E1E61bV;E0Ep2bM;IAOI,iCAAA;E1Eg2bV;E0Ev2bM;IAOI,+BAAA;E1Em2bV;E0E12bM;IAOI,iCAAA;E1Es2bV;E0E72bM;IAOI,+BAAA;E1Ey2bV;E0Eh3bM;IAOI,kCAAA;E1E42bV;E0En3bM;IAOI,0BAAA;E1E+2bV;E0Et3bM;IAOI,gCAAA;E1Ek3bV;E0Ez3bM;IAOI,+BAAA;E1Eq3bV;E0E53bM;IAOI,6BAAA;E1Ew3bV;E0E/3bM;IAOI,+BAAA;E1E23bV;E0El4bM;IAOI,6BAAA;E1E83bV;E0Er4bM;IAOI,+BAAA;E1Ei4bV;E0Ex4bM;IAOI,6BAAA;E1Eo4bV;E0E34bM;IAOI,+BAAA;E1Eu4bV;E0E94bM;IAOI,6BAAA;E1E04bV;E0Ej5bM;IAOI,gCAAA;E1E64bV;E0Ep5bM;IAOI,iBAAA;E1Eg5bV;E0Ev5bM;IAOI,uBAAA;E1Em5bV;E0E15bM;IAOI,sBAAA;E1Es5bV;E0E75bM;IAOI,oBAAA;E1Ey5bV;E0Eh6bM;IAOI,sBAAA;E1E45bV;E0En6bM;IAOI,oBAAA;E1E+5bV;E0Et6bM;IAOI,sBAAA;E1Ek6bV;E0Ez6bM;IAOI,oBAAA;E1Eq6bV;E0E56bM;IAOI,sBAAA;E1Ew6bV;E0E/6bM;IAOI,oBAAA;E1E26bV;E0El7bM;IAOI,uBAAA;E1E86bV;E0Er7bM;IAOI,qBAAA;E1Ei7bV;E0Ex7bM;IAOI,2BAAA;E1Eo7bV;E0E37bM;IAOI,0BAAA;E1Eu7bV;E0E97bM;IAOI,wBAAA;E1E07bV;E0Ej8bM;IAOI,0BAAA;E1E67bV;E0Ep8bM;IAOI,wBAAA;E1Eg8bV;E0Ev8bM;IAOI,0BAAA;E1Em8bV;E0E18bM;IAOI,wBAAA;E1Es8bV;E0E78bM;IAOI,0BAAA;E1Ey8bV;E0Eh9bM;IAOI,wBAAA;E1E48bV;E0En9bM;IAOI,2BAAA;E1E+8bV;E0Et9bM;IAOI,wBAAA;E1Ek9bV;E0Ez9bM;IAOI,8BAAA;E1Eq9bV;E0E59bM;IAOI,6BAAA;E1Ew9bV;E0E/9bM;IAOI,2BAAA;E1E29bV;E0El+bM;IAOI,6BAAA;E1E89bV;E0Er+bM;IAOI,2BAAA;E1Ei+bV;E0Ex+bM;IAOI,6BAAA;E1Eo+bV;E0E3+bM;IAOI,2BAAA;E1Eu+bV;E0E9+bM;IAOI,6BAAA;E1E0+bV;E0Ej/bM;IAOI,2BAAA;E1E6+bV;E0Ep/bM;IAOI,8BAAA;E1Eg/bV;E0Ev/bM;IAOI,2BAAA;E1Em/bV;E0E1/bM;IAOI,4BAAA;E1Es/bV;E0E7/bM;IAOI,6BAAA;E1Ey/bV;AACF;AgBpgcI;E0DGI;IAOI,sBAAA;E1E8/bV;E0ErgcM;IAOI,uBAAA;E1EigcV;E0ExgcM;IAOI,sBAAA;E1EogcV;E0E3gcM;IAOI,8BAAA;E1EugcV;E0E9gcM;IAOI,4BAAA;E1E0gcV;E0EjhcM;IAOI,2BAAA;E1E6gcV;E0EphcM;IAOI,iCAAA;E1EghcV;E0EvhcM;IAOI,2BAAA;E1EmhcV;E0E1hcM;IAOI,0BAAA;E1EshcV;E0E7hcM;IAOI,gCAAA;E1EyhcV;E0EhicM;IAOI,yBAAA;E1E4hcV;E0EnicM;IAOI,wBAAA;E1E+hcV;E0EticM;IAOI,+BAAA;E1EkicV;E0EzicM;IAOI,yBAAA;E1EqicV;E0E5icM;IAOI,6BAAA;E1EwicV;E0E/icM;IAOI,8BAAA;E1E2icV;E0EljcM;IAOI,wBAAA;E1E8icV;E0ErjcM;IAOI,+BAAA;E1EijcV;E0ExjcM;IAOI,wBAAA;E1EojcV;E0E3jcM;IAOI,yBAAA;E1EujcV;E0E9jcM;IAOI,8BAAA;E1E0jcV;E0EjkcM;IAOI,iCAAA;E1E6jcV;E0EpkcM;IAOI,sCAAA;E1EgkcV;E0EvkcM;IAOI,yCAAA;E1EmkcV;E0E1kcM;IAOI,uBAAA;E1EskcV;E0E7kcM;IAOI,uBAAA;E1EykcV;E0EhlcM;IAOI,yBAAA;E1E4kcV;E0EnlcM;IAOI,yBAAA;E1E+kcV;E0EtlcM;IAOI,0BAAA;E1EklcV;E0EzlcM;IAOI,4BAAA;E1EqlcV;E0E5lcM;IAOI,kCAAA;E1EwlcV;E0E/lcM;IAOI,sCAAA;E1E2lcV;E0ElmcM;IAOI,oCAAA;E1E8lcV;E0ErmcM;IAOI,kCAAA;E1EimcV;E0ExmcM;IAOI,yCAAA;E1EomcV;E0E3mcM;IAOI,wCAAA;E1EumcV;E0E9mcM;IAOI,wCAAA;E1E0mcV;E0EjncM;IAOI,kCAAA;E1E6mcV;E0EpncM;IAOI,gCAAA;E1EgncV;E0EvncM;IAOI,8BAAA;E1EmncV;E0E1ncM;IAOI,gCAAA;E1EsncV;E0E7ncM;IAOI,+BAAA;E1EyncV;E0EhocM;IAOI,oCAAA;E1E4ncV;E0EnocM;IAOI,kCAAA;E1E+ncV;E0EtocM;IAOI,gCAAA;E1EkocV;E0EzocM;IAOI,uCAAA;E1EqocV;E0E5ocM;IAOI,sCAAA;E1EwocV;E0E/ocM;IAOI,iCAAA;E1E2ocV;E0ElpcM;IAOI,2BAAA;E1E8ocV;E0ErpcM;IAOI,iCAAA;E1EipcV;E0ExpcM;IAOI,+BAAA;E1EopcV;E0E3pcM;IAOI,6BAAA;E1EupcV;E0E9pcM;IAOI,+BAAA;E1E0pcV;E0EjqcM;IAOI,8BAAA;E1E6pcV;E0EpqcM;IAOI,oBAAA;E1EgqcV;E0EvqcM;IAOI,mBAAA;E1EmqcV;E0E1qcM;IAOI,mBAAA;E1EsqcV;E0E7qcM;IAOI,mBAAA;E1EyqcV;E0EhrcM;IAOI,mBAAA;E1E4qcV;E0EnrcM;IAOI,mBAAA;E1E+qcV;E0EtrcM;IAOI,mBAAA;E1EkrcV;E0EzrcM;IAOI,mBAAA;E1EqrcV;E0E5rcM;IAOI,oBAAA;E1EwrcV;E0E/rcM;IAOI,0BAAA;E1E2rcV;E0ElscM;IAOI,yBAAA;E1E8rcV;E0ErscM;IAOI,uBAAA;E1EiscV;E0ExscM;IAOI,yBAAA;E1EoscV;E0E3scM;IAOI,uBAAA;E1EuscV;E0E9scM;IAOI,yBAAA;E1E0scV;E0EjtcM;IAOI,uBAAA;E1E6scV;E0EptcM;IAOI,yBAAA;E1EgtcV;E0EvtcM;IAOI,uBAAA;E1EmtcV;E0E1tcM;IAOI,0BAAA;E1EstcV;E0E7tcM;IAOI,uBAAA;E1EytcV;E0EhucM;IAOI,0BAAA;IAAA,yBAAA;E1E6tcV;E0EpucM;IAOI,gCAAA;IAAA,+BAAA;E1EiucV;E0ExucM;IAOI,+BAAA;IAAA,8BAAA;E1EqucV;E0E5ucM;IAOI,6BAAA;IAAA,4BAAA;E1EyucV;E0EhvcM;IAOI,+BAAA;IAAA,8BAAA;E1E6ucV;E0EpvcM;IAOI,6BAAA;IAAA,4BAAA;E1EivcV;E0ExvcM;IAOI,+BAAA;IAAA,8BAAA;E1EqvcV;E0E5vcM;IAOI,6BAAA;IAAA,4BAAA;E1EyvcV;E0EhwcM;IAOI,+BAAA;IAAA,8BAAA;E1E6vcV;E0EpwcM;IAOI,6BAAA;IAAA,4BAAA;E1EiwcV;E0ExwcM;IAOI,gCAAA;IAAA,+BAAA;E1EqwcV;E0E5wcM;IAOI,6BAAA;IAAA,4BAAA;E1EywcV;E0EhxcM;IAOI,wBAAA;IAAA,2BAAA;E1E6wcV;E0EpxcM;IAOI,8BAAA;IAAA,iCAAA;E1EixcV;E0ExxcM;IAOI,6BAAA;IAAA,gCAAA;E1EqxcV;E0E5xcM;IAOI,2BAAA;IAAA,8BAAA;E1EyxcV;E0EhycM;IAOI,6BAAA;IAAA,gCAAA;E1E6xcV;E0EpycM;IAOI,2BAAA;IAAA,8BAAA;E1EiycV;E0ExycM;IAOI,6BAAA;IAAA,gCAAA;E1EqycV;E0E5ycM;IAOI,2BAAA;IAAA,8BAAA;E1EyycV;E0EhzcM;IAOI,6BAAA;IAAA,gCAAA;E1E6ycV;E0EpzcM;IAOI,2BAAA;IAAA,8BAAA;E1EizcV;E0ExzcM;IAOI,8BAAA;IAAA,iCAAA;E1EqzcV;E0E5zcM;IAOI,2BAAA;IAAA,8BAAA;E1EyzcV;E0Eh0cM;IAOI,wBAAA;E1E4zcV;E0En0cM;IAOI,8BAAA;E1E+zcV;E0Et0cM;IAOI,6BAAA;E1Ek0cV;E0Ez0cM;IAOI,2BAAA;E1Eq0cV;E0E50cM;IAOI,6BAAA;E1Ew0cV;E0E/0cM;IAOI,2BAAA;E1E20cV;E0El1cM;IAOI,6BAAA;E1E80cV;E0Er1cM;IAOI,2BAAA;E1Ei1cV;E0Ex1cM;IAOI,6BAAA;E1Eo1cV;E0E31cM;IAOI,2BAAA;E1Eu1cV;E0E91cM;IAOI,8BAAA;E1E01cV;E0Ej2cM;IAOI,2BAAA;E1E61cV;E0Ep2cM;IAOI,0BAAA;E1Eg2cV;E0Ev2cM;IAOI,gCAAA;E1Em2cV;E0E12cM;IAOI,+BAAA;E1Es2cV;E0E72cM;IAOI,6BAAA;E1Ey2cV;E0Eh3cM;IAOI,+BAAA;E1E42cV;E0En3cM;IAOI,6BAAA;E1E+2cV;E0Et3cM;IAOI,+BAAA;E1Ek3cV;E0Ez3cM;IAOI,6BAAA;E1Eq3cV;E0E53cM;IAOI,+BAAA;E1Ew3cV;E0E/3cM;IAOI,6BAAA;E1E23cV;E0El4cM;IAOI,gCAAA;E1E83cV;E0Er4cM;IAOI,6BAAA;E1Ei4cV;E0Ex4cM;IAOI,2BAAA;E1Eo4cV;E0E34cM;IAOI,iCAAA;E1Eu4cV;E0E94cM;IAOI,gCAAA;E1E04cV;E0Ej5cM;IAOI,8BAAA;E1E64cV;E0Ep5cM;IAOI,gCAAA;E1Eg5cV;E0Ev5cM;IAOI,8BAAA;E1Em5cV;E0E15cM;IAOI,gCAAA;E1Es5cV;E0E75cM;IAOI,8BAAA;E1Ey5cV;E0Eh6cM;IAOI,gCAAA;E1E45cV;E0En6cM;IAOI,8BAAA;E1E+5cV;E0Et6cM;IAOI,iCAAA;E1Ek6cV;E0Ez6cM;IAOI,8BAAA;E1Eq6cV;E0E56cM;IAOI,yBAAA;E1Ew6cV;E0E/6cM;IAOI,+BAAA;E1E26cV;E0El7cM;IAOI,8BAAA;E1E86cV;E0Er7cM;IAOI,4BAAA;E1Ei7cV;E0Ex7cM;IAOI,8BAAA;E1Eo7cV;E0E37cM;IAOI,4BAAA;E1Eu7cV;E0E97cM;IAOI,8BAAA;E1E07cV;E0Ej8cM;IAOI,4BAAA;E1E67cV;E0Ep8cM;IAOI,8BAAA;E1Eg8cV;E0Ev8cM;IAOI,4BAAA;E1Em8cV;E0E18cM;IAOI,+BAAA;E1Es8cV;E0E78cM;IAOI,4BAAA;E1Ey8cV;E0Eh9cM;IAOI,2BAAA;E1E48cV;E0En9cM;IAOI,0BAAA;E1E+8cV;E0Et9cM;IAOI,wBAAA;E1Ek9cV;E0Ez9cM;IAOI,0BAAA;E1Eq9cV;E0E59cM;IAOI,wBAAA;E1Ew9cV;E0E/9cM;IAOI,0BAAA;E1E29cV;E0El+cM;IAOI,wBAAA;E1E89cV;E0Er+cM;IAOI,0BAAA;E1Ei+cV;E0Ex+cM;IAOI,wBAAA;E1Eo+cV;E0E3+cM;IAOI,2BAAA;E1Eu+cV;E0E9+cM;IAOI,iCAAA;IAAA,gCAAA;E1E2+cV;E0El/cM;IAOI,gCAAA;IAAA,+BAAA;E1E++cV;E0Et/cM;IAOI,8BAAA;IAAA,6BAAA;E1Em/cV;E0E1/cM;IAOI,gCAAA;IAAA,+BAAA;E1Eu/cV;E0E9/cM;IAOI,8BAAA;IAAA,6BAAA;E1E2/cV;E0ElgdM;IAOI,gCAAA;IAAA,+BAAA;E1E+/cV;E0EtgdM;IAOI,8BAAA;IAAA,6BAAA;E1EmgdV;E0E1gdM;IAOI,gCAAA;IAAA,+BAAA;E1EugdV;E0E9gdM;IAOI,8BAAA;IAAA,6BAAA;E1E2gdV;E0ElhdM;IAOI,iCAAA;IAAA,gCAAA;E1E+gdV;E0EthdM;IAOI,+BAAA;IAAA,kCAAA;E1EmhdV;E0E1hdM;IAOI,8BAAA;IAAA,iCAAA;E1EuhdV;E0E9hdM;IAOI,4BAAA;IAAA,+BAAA;E1E2hdV;E0ElidM;IAOI,8BAAA;IAAA,iCAAA;E1E+hdV;E0EtidM;IAOI,4BAAA;IAAA,+BAAA;E1EmidV;E0E1idM;IAOI,8BAAA;IAAA,iCAAA;E1EuidV;E0E9idM;IAOI,4BAAA;IAAA,+BAAA;E1E2idV;E0EljdM;IAOI,8BAAA;IAAA,iCAAA;E1E+idV;E0EtjdM;IAOI,4BAAA;IAAA,+BAAA;E1EmjdV;E0E1jdM;IAOI,+BAAA;IAAA,kCAAA;E1EujdV;E0E9jdM;IAOI,+BAAA;E1E0jdV;E0EjkdM;IAOI,8BAAA;E1E6jdV;E0EpkdM;IAOI,4BAAA;E1EgkdV;E0EvkdM;IAOI,8BAAA;E1EmkdV;E0E1kdM;IAOI,4BAAA;E1EskdV;E0E7kdM;IAOI,8BAAA;E1EykdV;E0EhldM;IAOI,4BAAA;E1E4kdV;E0EnldM;IAOI,8BAAA;E1E+kdV;E0EtldM;IAOI,4BAAA;E1EkldV;E0EzldM;IAOI,+BAAA;E1EqldV;E0E5ldM;IAOI,iCAAA;E1EwldV;E0E/ldM;IAOI,gCAAA;E1E2ldV;E0ElmdM;IAOI,8BAAA;E1E8ldV;E0ErmdM;IAOI,gCAAA;E1EimdV;E0ExmdM;IAOI,8BAAA;E1EomdV;E0E3mdM;IAOI,gCAAA;E1EumdV;E0E9mdM;IAOI,8BAAA;E1E0mdV;E0EjndM;IAOI,gCAAA;E1E6mdV;E0EpndM;IAOI,8BAAA;E1EgndV;E0EvndM;IAOI,iCAAA;E1EmndV;E0E1ndM;IAOI,kCAAA;E1EsndV;E0E7ndM;IAOI,iCAAA;E1EyndV;E0EhodM;IAOI,+BAAA;E1E4ndV;E0EnodM;IAOI,iCAAA;E1E+ndV;E0EtodM;IAOI,+BAAA;E1EkodV;E0EzodM;IAOI,iCAAA;E1EqodV;E0E5odM;IAOI,+BAAA;E1EwodV;E0E/odM;IAOI,iCAAA;E1E2odV;E0ElpdM;IAOI,+BAAA;E1E8odV;E0ErpdM;IAOI,kCAAA;E1EipdV;E0ExpdM;IAOI,gCAAA;E1EopdV;E0E3pdM;IAOI,+BAAA;E1EupdV;E0E9pdM;IAOI,6BAAA;E1E0pdV;E0EjqdM;IAOI,+BAAA;E1E6pdV;E0EpqdM;IAOI,6BAAA;E1EgqdV;E0EvqdM;IAOI,+BAAA;E1EmqdV;E0E1qdM;IAOI,6BAAA;E1EsqdV;E0E7qdM;IAOI,+BAAA;E1EyqdV;E0EhrdM;IAOI,6BAAA;E1E4qdV;E0EnrdM;IAOI,gCAAA;E1E+qdV;E0EtrdM;IAOI,qBAAA;E1EkrdV;E0EzrdM;IAOI,2BAAA;E1EqrdV;E0E5rdM;IAOI,0BAAA;E1EwrdV;E0E/rdM;IAOI,wBAAA;E1E2rdV;E0ElsdM;IAOI,0BAAA;E1E8rdV;E0ErsdM;IAOI,wBAAA;E1EisdV;E0ExsdM;IAOI,0BAAA;E1EosdV;E0E3sdM;IAOI,wBAAA;E1EusdV;E0E9sdM;IAOI,0BAAA;E1E0sdV;E0EjtdM;IAOI,wBAAA;E1E6sdV;E0EptdM;IAOI,2BAAA;E1EgtdV;E0EvtdM;IAOI,2BAAA;IAAA,0BAAA;E1EotdV;E0E3tdM;IAOI,iCAAA;IAAA,gCAAA;E1EwtdV;E0E/tdM;IAOI,gCAAA;IAAA,+BAAA;E1E4tdV;E0EnudM;IAOI,8BAAA;IAAA,6BAAA;E1EgudV;E0EvudM;IAOI,gCAAA;IAAA,+BAAA;E1EoudV;E0E3udM;IAOI,8BAAA;IAAA,6BAAA;E1EwudV;E0E/udM;IAOI,gCAAA;IAAA,+BAAA;E1E4udV;E0EnvdM;IAOI,8BAAA;IAAA,6BAAA;E1EgvdV;E0EvvdM;IAOI,gCAAA;IAAA,+BAAA;E1EovdV;E0E3vdM;IAOI,8BAAA;IAAA,6BAAA;E1EwvdV;E0E/vdM;IAOI,iCAAA;IAAA,gCAAA;E1E4vdV;E0EnwdM;IAOI,yBAAA;IAAA,4BAAA;E1EgwdV;E0EvwdM;IAOI,+BAAA;IAAA,kCAAA;E1EowdV;E0E3wdM;IAOI,8BAAA;IAAA,iCAAA;E1EwwdV;E0E/wdM;IAOI,4BAAA;IAAA,+BAAA;E1E4wdV;E0EnxdM;IAOI,8BAAA;IAAA,iCAAA;E1EgxdV;E0EvxdM;IAOI,4BAAA;IAAA,+BAAA;E1EoxdV;E0E3xdM;IAOI,8BAAA;IAAA,iCAAA;E1EwxdV;E0E/xdM;IAOI,4BAAA;IAAA,+BAAA;E1E4xdV;E0EnydM;IAOI,8BAAA;IAAA,iCAAA;E1EgydV;E0EvydM;IAOI,4BAAA;IAAA,+BAAA;E1EoydV;E0E3ydM;IAOI,+BAAA;IAAA,kCAAA;E1EwydV;E0E/ydM;IAOI,yBAAA;E1E2ydV;E0ElzdM;IAOI,+BAAA;E1E8ydV;E0ErzdM;IAOI,8BAAA;E1EizdV;E0ExzdM;IAOI,4BAAA;E1EozdV;E0E3zdM;IAOI,8BAAA;E1EuzdV;E0E9zdM;IAOI,4BAAA;E1E0zdV;E0Ej0dM;IAOI,8BAAA;E1E6zdV;E0Ep0dM;IAOI,4BAAA;E1Eg0dV;E0Ev0dM;IAOI,8BAAA;E1Em0dV;E0E10dM;IAOI,4BAAA;E1Es0dV;E0E70dM;IAOI,+BAAA;E1Ey0dV;E0Eh1dM;IAOI,2BAAA;E1E40dV;E0En1dM;IAOI,iCAAA;E1E+0dV;E0Et1dM;IAOI,gCAAA;E1Ek1dV;E0Ez1dM;IAOI,8BAAA;E1Eq1dV;E0E51dM;IAOI,gCAAA;E1Ew1dV;E0E/1dM;IAOI,8BAAA;E1E21dV;E0El2dM;IAOI,gCAAA;E1E81dV;E0Er2dM;IAOI,8BAAA;E1Ei2dV;E0Ex2dM;IAOI,gCAAA;E1Eo2dV;E0E32dM;IAOI,8BAAA;E1Eu2dV;E0E92dM;IAOI,iCAAA;E1E02dV;E0Ej3dM;IAOI,4BAAA;E1E62dV;E0Ep3dM;IAOI,kCAAA;E1Eg3dV;E0Ev3dM;IAOI,iCAAA;E1Em3dV;E0E13dM;IAOI,+BAAA;E1Es3dV;E0E73dM;IAOI,iCAAA;E1Ey3dV;E0Eh4dM;IAOI,+BAAA;E1E43dV;E0En4dM;IAOI,iCAAA;E1E+3dV;E0Et4dM;IAOI,+BAAA;E1Ek4dV;E0Ez4dM;IAOI,iCAAA;E1Eq4dV;E0E54dM;IAOI,+BAAA;E1Ew4dV;E0E/4dM;IAOI,kCAAA;E1E24dV;E0El5dM;IAOI,0BAAA;E1E84dV;E0Er5dM;IAOI,gCAAA;E1Ei5dV;E0Ex5dM;IAOI,+BAAA;E1Eo5dV;E0E35dM;IAOI,6BAAA;E1Eu5dV;E0E95dM;IAOI,+BAAA;E1E05dV;E0Ej6dM;IAOI,6BAAA;E1E65dV;E0Ep6dM;IAOI,+BAAA;E1Eg6dV;E0Ev6dM;IAOI,6BAAA;E1Em6dV;E0E16dM;IAOI,+BAAA;E1Es6dV;E0E76dM;IAOI,6BAAA;E1Ey6dV;E0Eh7dM;IAOI,gCAAA;E1E46dV;E0En7dM;IAOI,iBAAA;E1E+6dV;E0Et7dM;IAOI,uBAAA;E1Ek7dV;E0Ez7dM;IAOI,sBAAA;E1Eq7dV;E0E57dM;IAOI,oBAAA;E1Ew7dV;E0E/7dM;IAOI,sBAAA;E1E27dV;E0El8dM;IAOI,oBAAA;E1E87dV;E0Er8dM;IAOI,sBAAA;E1Ei8dV;E0Ex8dM;IAOI,oBAAA;E1Eo8dV;E0E38dM;IAOI,sBAAA;E1Eu8dV;E0E98dM;IAOI,oBAAA;E1E08dV;E0Ej9dM;IAOI,uBAAA;E1E68dV;E0Ep9dM;IAOI,qBAAA;E1Eg9dV;E0Ev9dM;IAOI,2BAAA;E1Em9dV;E0E19dM;IAOI,0BAAA;E1Es9dV;E0E79dM;IAOI,wBAAA;E1Ey9dV;E0Eh+dM;IAOI,0BAAA;E1E49dV;E0En+dM;IAOI,wBAAA;E1E+9dV;E0Et+dM;IAOI,0BAAA;E1Ek+dV;E0Ez+dM;IAOI,wBAAA;E1Eq+dV;E0E5+dM;IAOI,0BAAA;E1Ew+dV;E0E/+dM;IAOI,wBAAA;E1E2+dV;E0El/dM;IAOI,2BAAA;E1E8+dV;E0Er/dM;IAOI,wBAAA;E1Ei/dV;E0Ex/dM;IAOI,8BAAA;E1Eo/dV;E0E3/dM;IAOI,6BAAA;E1Eu/dV;E0E9/dM;IAOI,2BAAA;E1E0/dV;E0EjgeM;IAOI,6BAAA;E1E6/dV;E0EpgeM;IAOI,2BAAA;E1EggeV;E0EvgeM;IAOI,6BAAA;E1EmgeV;E0E1geM;IAOI,2BAAA;E1EsgeV;E0E7geM;IAOI,6BAAA;E1EygeV;E0EhheM;IAOI,2BAAA;E1E4geV;E0EnheM;IAOI,8BAAA;E1E+geV;E0EtheM;IAOI,2BAAA;E1EkheV;E0EzheM;IAOI,4BAAA;E1EqheV;E0E5heM;IAOI,6BAAA;E1EwheV;AACF;A2E/keA;ED+CQ;IAOI,gCAAA;E1E6heV;E0EpieM;IAOI,iCAAA;E1EgieV;E0EvieM;IAOI,+BAAA;E1EmieV;AACF;A2EvkeA;ED4BQ;IAOI,0BAAA;E1EwieV;E0E/ieM;IAOI,gCAAA;E1E2ieV;E0EljeM;IAOI,yBAAA;E1E8ieV;E0ErjeM;IAOI,wBAAA;E1EijeV;E0ExjeM;IAOI,+BAAA;E1EojeV;E0E3jeM;IAOI,yBAAA;E1EujeV;E0E9jeM;IAOI,6BAAA;E1E0jeV;E0EjkeM;IAOI,8BAAA;E1E6jeV;E0EpkeM;IAOI,wBAAA;E1EgkeV;E0EvkeM;IAOI,+BAAA;E1EmkeV;E0E1keM;IAOI,wBAAA;E1EskeV;AACF;A4EhpeA;EAEI,gBAAA;EACA,gBAAA;EAGA,kBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAGA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAGA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;A5E6neJ;;A4EzneA;EACI,8BAAA;A5E4neJ;;A4E1neA;EACI,8BAAA;A5E6neJ;;A4EzneA;EACI,gCAAA;A5E4neJ;;A4ExneA;EACI,8BAAA;A5E2neJ;;A4EzneA;EACI,8BAAA;A5E4neJ;;A4E1neA;EACI,8BAAA;A5E6neJ;;A4E3neA;EACI,8BAAA;A5E8neJ;;A4E5neA;EACI,8BAAA;A5E+neJ;;A4E7neA;EACI,8BAAA;A5EgoeJ;;A4E9neA;EACI,8BAAA;A5EioeJ;;A4E/neA;EACI,8BAAA;A5EkoeJ;;A4EhoeA;EACI,8BAAA;A5EmoeJ;;A4EjoeA;EACI,+BAAA;A5EooeJ;;A4EhoeA;EACI,8BAAA;A5EmoeJ;;A4EjoeA;EACI,8BAAA;A5EooeJ;;A4EloeA;EACI,8BAAA;A5EqoeJ;;A4EnoeA;EACI,8BAAA;A5EsoeJ;;A4EpoeA;EACI,8BAAA;A5EuoeJ;;A4EroeA;EACI,8BAAA;A5EwoeJ;;A4EtoeA;EACI,8BAAA;A5EyoeJ;;A4EvoeA;EACI,8BAAA;A5E0oeJ;;A4ExoeA;EACI,8BAAA;A5E2oeJ;;A4EzoeA;EACI,+BAAA;A5E4oeJ;;A4ExoeA;EACI,+BAAA;A5E2oeJ;;A4EzoeA;EACI,+BAAA;A5E4oeJ;;A4E1oeA;EACI,+BAAA;A5E6oeJ;;A4E3oeA;EACI,+BAAA;A5E8oeJ;;A4E5oeA;EACI,+BAAA;A5E+oeJ;;A4E7oeA;EACI,+BAAA;A5EgpeJ;;A4E9oeA;EACI,+BAAA;A5EipeJ;;A4E/oeA;EACI,+BAAA;A5EkpeJ;;A4EhpeA;EACI,+BAAA;A5EmpeJ;;A4EjpeA;EACI,gCAAA;A5EopeJ;;A4EhpeA;EACI,8BAAA;A5EmpeJ;;A4EjpeA;EACI,8BAAA;A5EopeJ;;A4ElpeA;EACI,8BAAA;A5EqpeJ;;A4EnpeA;EACI,8BAAA;A5EspeJ;;A4EppeA;EACI,8BAAA;A5EupeJ;;A4ErpeA;EACI,8BAAA;A5EwpeJ;;A4EtpeA;EACI,8BAAA;A5EypeJ;;A4EvpeA;EACI,8BAAA;A5E0peJ;;A4ExpeA;EACI,8BAAA;A5E2peJ;;A4EzpeA;EACI,+BAAA;A5E4peJ;;A4ExpeA;EACI,6BAAA;A5E2peJ;;A4EzpeA;EACI,6BAAA;A5E4peJ;;A4E1peA;EACI,6BAAA;A5E6peJ;;A4E3peA;EACI,6BAAA;A5E8peJ;;A4E5peA;EACI,6BAAA;A5E+peJ;;A4E7peA;EACI,6BAAA;A5EgqeJ;;A4E9peA;EACI,6BAAA;A5EiqeJ;;A4E/peA;EACI,6BAAA;A5EkqeJ;;A4EhqeA;EACI,6BAAA;A5EmqeJ;;A4EjqeA;EACI,8BAAA;A5EoqeJ;;A4EhqeA;EACI,gCAAA;A5EmqeJ;;A4EjqeA;EACI,gCAAA;A5EoqeJ;;A4ElqeA;EACI,gCAAA;A5EqqeJ;;A4EnqeA;EACI,gCAAA;A5EsqeJ;;A4EpqeA;EACI,gCAAA;A5EuqeJ;;A4ErqeA;EACI,gCAAA;A5EwqeJ;;A4EtqeA;EACI,gCAAA;A5EyqeJ;;A4EvqeA;EACI,gCAAA;A5E0qeJ;;A4ExqeA;EACI,gCAAA;A5E2qeJ;;A4EzqeA;EACI,iCAAA;A5E4qeJ;;A4ExqeA;EACI,gCAAA;A5E2qeJ;;A4EzqeA;EACI,gCAAA;A5E4qeJ;;A4E1qeA;EACI,gCAAA;A5E6qeJ;;A4E3qeA;EACI,gCAAA;A5E8qeJ;;A4E5qeA;EACI,gCAAA;A5E+qeJ;;A4E7qeA;EACI,gCAAA;A5EgreJ;;A4E9qeA;EACI,gCAAA;A5EireJ;;A4E/qeA;EACI,gCAAA;A5EkreJ;;A4EhreA;EACI,gCAAA;A5EmreJ;;A4EjreA;EACI,iCAAA;A5EoreJ;;A4EhreA;EACI,gCAAA;A5EmreJ;;A4EjreA;EACI,gCAAA;A5EoreJ;;A4ElreA;EACI,gCAAA;A5EqreJ;;A4EnreA;EACI,gCAAA;A5EsreJ;;A4EpreA;EACI,gCAAA;A5EureJ;;A4ErreA;EACI,gCAAA;A5EwreJ;;A4EtreA;EACI,gCAAA;A5EyreJ;;A4EvreA;EACI,gCAAA;A5E0reJ;;A4ExreA;EACI,gCAAA;A5E2reJ;;A4EzreA;EACI,iCAAA;A5E4reJ;;A4ExreA;EACI,8BAAA;A5E2reJ;;A4EzreA;EACI,8BAAA;A5E4reJ;;A4E1reA;EACI,8BAAA;A5E6reJ;;A4E3reA;EACI,8BAAA;A5E8reJ;;A4E5reA;EACI,8BAAA;A5E+reJ;;A4E7reA;EACI,8BAAA;A5EgseJ;;A4E9reA;EACI,8BAAA;A5EiseJ;;A4E/reA;EACI,8BAAA;A5EkseJ;;A4EhseA;EACI,8BAAA;A5EmseJ;;A4EjseA;EACI,+BAAA;A5EoseJ;;A6EnmfA;EACI,4BAAA;EACA,iCAAA;A7EsmfJ;;A6EnmfA;EACI,+BAAA;A7EsmfJ;;A6EnmfA;EACI,qBrEoCG;ARkkfP;;A6EnmfA;EACI;IACI,4BAAA;E7EsmfN;E6EnmfE;IACI,kBAAA;IACA,gBAAA;E7EqmfN;AACF;A6ElmfA;EACI,oCAAA;A7EomfJ;;A6EjmfA;EACI,mBAAA;A7EomfJ;;A6EjmfA;EACI,yBAAA;UAAA,iBAAA;A7EomfJ;;A6EhmfI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;A7EmmfR;A6EhmfI;EACI,sBAAA;EACA,gBAAA;EACA,aAAA;A7EkmfR;A6E/lfI;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;A7EimfR;A6E9lfI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;A7EgmfR;A6E7lfI;EACI,YAAA;A7E+lfR;A6E5lfI;EACI,UAAA;A7E8lfR;;A6E1lfA;EACI;IACI,aAAA;IACA,sBAAA;IACA,WAAA;E7E6lfN;AACF;A6E1lfA;EACI,uBAAA;EACA,oCAAA;A7E4lfJ;;A6EzlfA;EACI,8CAAA;A7E4lfJ;;A6EzlfA;EACI,iBAAA;EACA,crE1EO;EqE2EP,yBAAA;UAAA,iBAAA;A7E4lfJ;;A6EzlfA;EAEI,iBAAA;EACA,yBAAA;EACA,4BAAA;A7E2lfJ;;A6ExlfA;;;;EAKI,kBAAA;EACA,0BAAA;EACA,6BAAA;A7E0lfJ;;A6EvlfA;EAEI,qBrEpEE;AR6pfN;;A6EtlfA;EAEI,qBrEvEK;AR+pfT;;A6ErlfA;;;;EASI,qBrErFE;ARwqfN;;A6EhlfA;;;;EASI,qBrE/FK;AR6qfT;;A6E3kfA;EACI,qEAAA;EACA,4BAAA;EACA,4DAAA;A7E8kfJ;;A6E3kfA;EACI,iCAAA;A7E8kfJ;;A6E3kfA;EACI,iCAAA;A7E8kfJ;;A6E3kfA;EACI,yBrEnJO;ARiufX;;A6E3kfA;EACI,yBrEvJO;ARqufX;;A6E3kfA;EACI,yBrE3JO;ARyufX;;A6E3kfA;EACI,yBrE/JO;AR6ufX;;A6E3kfA;EACI,yBrEjKO;AR+ufX;;A6E3kfA;EACI,kBAAA;A7E8kfJ;A6E5kfI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBrEjJF;AR+tfN;;A6E1kfA;EACI,kCAAA;EAAA,6BAAA;A7E6kfJ;;A6EzkfA;EACI,qBAAA;A7E4kfJ;A6E1kfI;EACI,UAAA;EACA,aAAA;A7E4kfR;A6EzkfI;EACI,mBAAA;EACA,8BAAA;A7E2kfR;;A6EpkfQ;EACI,YAAA;EACA,QAAA;A7EukfZ;A6EnkfQ;EACI,YAAA;EACA,QAAA;A7EqkfZ;A6EhkfQ;EACI,wBAAA;A7EkkfZ;A6EhkfgB;EACI,mBAAA;A7EkkfpB;A6E9jfgB;EACI,aAAA;A7EgkfpB;A6E3jfI;EACI,uBAAA;EAAA,kBAAA;A7E6jfR;A6E3jfQ;EACI,uBAAA;EACA,4BAAA;EAAA,uBAAA;A7E6jfZ;A6E5jfY;EACI,UAAA;A7E8jfhB;A6E7jfgB;EACI,gBAAA;EACA,oBAAA;A7E+jfpB;A6E3jfgB;EACI,UAAA;A7E6jfpB;A6EvjfQ;EACI,YAAA;A7EyjfZ;A6ErjfQ;EACI,gBAAA;A7EujfZ;A6ErjfQ;EACI,WAAA;A7EujfZ;A6EnjfQ;EACI,wCAAA;A7EqjfZ;A6EhjfI;EACI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;A7EkjfR;A6EjjfQ;EACI,8BAAA;A7EmjfZ;A6EjjfQ;EACI,gBAAA;EACA,gCAAA;A7EmjfZ;A6EjjfQ;EACI,wBAAA;A7EmjfZ;A6EljfY;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;A7EojfhB;A6EljfY;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;A7EojfhB;A6EljfY;EACI,SAAA;EACA,UAAA;A7EojfhB;A6EhjfY;EACI,aAAA;A7EkjfhB;A6EhjfY;EACI,wBAAA;A7EkjfhB;A6EjjfgB;EACI,kBAAA;A7EmjfpB;A6E5ifI;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kDAAA;A7E8ifR;A6E7ifQ;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EAEA,qBAAA;A7E+ifZ;A6E9ifY;EACI,UAAA;EACA,aAAA;A7EgjfhB;A6E9ifY;EACI,mBAAA;EACA,8BAAA;A7EgjfhB;A6E9ifY;EACI,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;A7EgjfhB;A6E/ifgB;EACI,gBAAA;EACA,mBAAA;EACA,mCAAA;A7EijfpB;A6E/ifgB;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;A7EijfpB;A6EhjfoB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,4EAAA;A7EkjfxB;A6E/ifgB;EACI,uBAAA;A7EijfpB;;A6E1ifI;EACI,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8BAAA;A7E6ifR;A6E3ifY;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;A7E6ifhB;A6ExifgB;EACI,6BAAA;A7E0ifpB;;A6ElifA;EACI,qBAAA;A7EqifJ;A6EnifI;EACI,UAAA;EACA,aAAA;A7EqifR;A6ElifI;EACI,mBAAA;EACA,8BAAA;A7EoifR;;A6E/hfA;EACI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8DAAA;EACA,gCAAA;A7EkifJ;A6EjifI;EACI,gCAAA;A7EmifR;A6EjifI;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;A7EmifR;;A6E9hfA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;A7EiifJ;A6EhifI;EACI,mBAAA;A7EkifR;A6EhifI;EACI,gCAAA;A7EkifR;;A6E7hfA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;A7EgifJ;A6E/hfI;EACI,gCAAA;A7EiifR;A6E/hfI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;A7EiifR;A6E/hfI;EACI,sBAAA;A7EiifR;A6E/hfI;EACI,6BAAA;A7EiifR;;A6E5hfA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;A7E+hfJ;;A6E3hfA;EACI,WAAA;EACA,aAAA;EAEA,kBAAA;EACA,oBAAA;A7E6hfJ;A6E5hfI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;A7E8hfR;;A6EzhfA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,kBAAA;A7E4hfJ;A6E3hfI;EACI,2CAAA;EACA,6BAAA;A7E6hfR;A6E5hfQ;EACI,2CAAA;A7E8hfZ;A6E3hfI;EACI,wCAAA;EACA,6BAAA;A7E6hfR;A6E5hfQ;EACI,wCAAA;A7E8hfZ;A6E3hfI;EACI,QAAA;EACA,0BAAA;EACA,8BAAA;EACA,iBAAA;A7E6hfR;A6E5hfQ;EACI,2CAAA;EACA,4BAAA;A7E8hfZ;A6E7hfY;EACI,2CAAA;A7E+hfhB;A6E5hfQ;EACI,wCAAA;EACA,4BAAA;A7E8hfZ;A6E7hfY;EACI,wCAAA;A7E+hfhB;A6E3hfI;EACI,kBAAA;EACA,8BAAA;A7E6hfR;A6E5hfQ;EACI,2CAAA;A7E8hfZ;A6E7hfY;EACI,2CAAA;A7E+hfhB;A6E5hfQ;EACI,wCAAA;A7E8hfZ;A6E7hfY;EACI,wCAAA;A7E+hfhB;;A6ExhfA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,8BAAA;A7E2hfJ;A6E1hfI;EACI,0BAAA;A7E4hfR;;A6EvhfA;EACI,WAAA;A7E0hfJ;A6ExhfQ;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;A7E0hfZ;A6EzhfY;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;A7E2hfhB;A6E1hfgB;EACI,2CAAA;EACA,6BAAA;A7E4hfpB;A6E3hfoB;EACI,2CAAA;EACA,4BAAA;A7E6hfxB;A6E1hfgB;EACI,wCAAA;EACA,6BAAA;A7E4hfpB;A6E3hfoB;EACI,wCAAA;A7E6hfxB;A6E1hfgB;EACI,wBAAA;A7E4hfpB;A6E3hfoB;EACI,wBAAA;A7E6hfxB;A6EzhfY;EACI,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,0BAAA;EACA,8BAAA;EACA,4BAAA;A7E2hfhB;A6E1hfgB;EACI,WAAA;EACA,YAAA;A7E4hfpB;;A6EnhfI;EACI,UAAA;EACA,YAAA;EACA,kBAAA;A7EshfR;A6EphfQ;EACI,YAAA;EACA,wBAAA;EACA,uBAAA;A7EshfZ;A6ErhfY;EACI,WAAA;EACA,YAAA;A7EuhfhB;A6EthfgB;EACI,WAAA;EACA,YAAA;A7EwhfpB;A6EvhfoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,4EAAA;A7EyhfxB;A6EnhfQ;EACI,iBAAA;EACA,2BAAA;A7EqhfZ;A6ElhfQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;A7EohfZ;A6EjhfQ;EACI,0BAAA;A7EmhfZ;;A6E7gfA;EACI,uBAAA;A7EghfJ;A6E/gfI;EACI,uBAAA;A7EihfR;A6E/gfY;EACI,SAAA;EACA,gCAAA;A7EihfhB;A6EhhfgB;EACI,8BAAA;EACA,qCAAA;EACA,2CAAA;A7EkhfpB;A6E/gfY;EACI,8BAAA;EACA,qCAAA;EACA,2CAAA;A7EihfhB;;A6ExgfQ;EACI,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;A7E2gfZ;A6E1gfY;EACI,oBAAA;EACA,uBAAA;EACA,4BAAA;EACA,2CAAA;A7E4gfhB;A6E3gfgB;EAEI,6BAAA;EACA,gCAAA;EACA,mCAAA;EACA,yDAAA;A7E4gfpB;A6E3gfoB;EACI,2HAAA;A7E6gfxB;;A6EpgfA;EACI,mBAAA;A7EugfJ;;A6EpgfA;EACI,qBAAA;A7EugfJ;;A8EhygBA;EACI,2BAAA;EACA,kCAAA;A9EmygBJ;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;;A8EhygBA;EACI,2BAAA;EACA,kCAAA;A9EmygBJ;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;;A8EhygBA;EACI,2BAAA;EACA,kCAAA;A9EmygBJ;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;;A8EhygBA;EACI,2BAAA;EACA,kCAAA;A9EmygBJ;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;;A8EhygBA;EACI,2BAAA;EACA,kCAAA;A9EmygBJ;A8ElygBI;EACI,0BAAA;EACA,4BAAA;A9EoygBR;A8ElygBI;EACI,0BAAA;EACA,2BAAA;EACA,4BAAA;A9EoygBR;;A8EhygBA;EACI,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;A9EmygBJ;;A+E73gBA;EACI,QAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A/Eg4gBJ;;A+E93gBA;EACI,2BAAA;A/Ei4gBJ;;A+E/3gBA;EACI,2BAAA;A/Ek4gBJ;;A+Eh4gBA;EACI,2BAAA;A/Em4gBJ;;A+Ej4gBA;EACI,4BAAA;A/Eo4gBJ;;A+El4gBA;EACI,4BAAA;A/Eq4gBJ;;A+En4gBA;EACI,4BAAA;A/Es4gBJ;;A+Ep4gBA;EACI,4BAAA;A/Eu4gBJ;;A+Er4gBA;EACI,4BAAA;A/Ew4gBJ;;A+Et4gBA;EACI,4BAAA;A/Ey4gBJ;;A+Ev4gBA;EACI,4BAAA;A/E04gBJ;;A+Ex4gBA;EACI,4BAAA;A/E24gBJ;;A+Ez4gBA;EACI,4BAAA;A/E44gBJ;;A+E14gBA;EACI,4BAAA;A/E64gBJ;;A+E34gBA;EACI,4BAAA;A/E84gBJ;;A+E54gBA;EACI,4BAAA;A/E+4gBJ;;A+E74gBA;EACI,4BAAA;A/Eg5gBJ;;A+E94gBA;EACI,4BAAA;A/Ei5gBJ;;A+E/4gBA;EACI,4BAAA;A/Ek5gBJ;;A+Eh5gBA;EACI,4BAAA;A/Em5gBJ;;A+Ej5gBA;EACI,4BAAA;A/Eo5gBJ;;A+El5gBA;EACI,4BAAA;A/Eq5gBJ;;A+Ej5gBA;EACI,+BAAA;A/Eo5gBJ;;A+El5gBA;EACI,+BAAA;A/Eq5gBJ;;A+En5gBA;EACI,+BAAA;A/Es5gBJ;;A+Ep5gBA;EACI,gCAAA;A/Eu5gBJ;;A+Er5gBA;EACI,gCAAA;A/Ew5gBJ;;A+Et5gBA;EACI,gCAAA;A/Ey5gBJ;;A+Ev5gBA;EACI,gCAAA;A/E05gBJ;;A+Ex5gBA;EACI,gCAAA;A/E25gBJ;;A+Ez5gBA;EACI,gCAAA;A/E45gBJ;;A+E15gBA;EACI,gCAAA;A/E65gBJ;;A+E35gBA;EACI,gCAAA;A/E85gBJ;;A+E55gBA;EACI,gCAAA;A/E+5gBJ;;A+E75gBA;EACI,gCAAA;A/Eg6gBJ;;A+E95gBA;EACI,gCAAA;A/Ei6gBJ;;A+E/5gBA;EACI,gCAAA;A/Ek6gBJ;;A+Eh6gBA;EACI,gCAAA;A/Em6gBJ;;A+Ej6gBA;EACI,gCAAA;A/Eo6gBJ;;A+El6gBA;EACI,gCAAA;A/Eq6gBJ;;A+En6gBA;EACI,gCAAA;A/Es6gBJ;;A+Ep6gBA;EACI,gCAAA;A/Eu6gBJ;;A+Er6gBA;EACI,gCAAA;A/Ew6gBJ;;A+Ep6gBA;EACI,kCAAA;A/Eu6gBJ;;A+Er6gBA;EACI,kCAAA;A/Ew6gBJ;;A+Et6gBA;EACI,kCAAA;A/Ey6gBJ;;A+Ev6gBA;EACI,mCAAA;A/E06gBJ;;A+Ex6gBA;EACI,mCAAA;A/E26gBJ;;A+Ez6gBA;EACI,mCAAA;A/E46gBJ;;A+E16gBA;EACI,mCAAA;A/E66gBJ;;A+E36gBA;EACI,mCAAA;A/E86gBJ;;A+E56gBA;EACI,mCAAA;A/E+6gBJ;;A+E76gBA;EACI,mCAAA;A/Eg7gBJ;;A+E96gBA;EACI,mCAAA;A/Ei7gBJ;;A+E/6gBA;EACI,mCAAA;A/Ek7gBJ;;A+Eh7gBA;EACI,mCAAA;A/Em7gBJ;;A+Ej7gBA;EACI,mCAAA;A/Eo7gBJ;;A+El7gBA;EACI,mCAAA;A/Eq7gBJ;;A+En7gBA;EACI,mCAAA;A/Es7gBJ;;A+Ep7gBA;EACI,mCAAA;A/Eu7gBJ;;A+Er7gBA;EACI,mCAAA;A/Ew7gBJ;;A+Et7gBA;EACI,mCAAA;A/Ey7gBJ;;A+Ev7gBA;EACI,mCAAA;A/E07gBJ;;A+Ex7gBA;EACI,mCAAA;A/E27gBJ;;A+Ev7gBA;EACI,gCAAA;A/E07gBJ;;A+Ex7gBA;EACI,gCAAA;A/E27gBJ;;A+Ez7gBA;EACI,gCAAA;A/E47gBJ;;A+E17gBA;EACI,iCAAA;A/E67gBJ;;A+E37gBA;EACI,iCAAA;A/E87gBJ;;A+E57gBA;EACI,iCAAA;A/E+7gBJ;;A+E77gBA;EACI,iCAAA;A/Eg8gBJ;;A+E97gBA;EACI,iCAAA;A/Ei8gBJ;;A+E/7gBA;EACI,iCAAA;A/Ek8gBJ;;A+Eh8gBA;EACI,iCAAA;A/Em8gBJ;;A+Ej8gBA;EACI,iCAAA;A/Eo8gBJ;;A+El8gBA;EACI,iCAAA;A/Eq8gBJ;;A+En8gBA;EACI,iCAAA;A/Es8gBJ;;A+Ep8gBA;EACI,iCAAA;A/Eu8gBJ;;A+Er8gBA;EACI,iCAAA;A/Ew8gBJ;;A+Et8gBA;EACI,iCAAA;A/Ey8gBJ;;A+Ev8gBA;EACI,iCAAA;A/E08gBJ;;A+Ex8gBA;EACI,iCAAA;A/E28gBJ;;A+Ez8gBA;EACI,iCAAA;A/E48gBJ;;A+E18gBA;EACI,iCAAA;A/E68gBJ;;A+E38gBA;EACI,iCAAA;A/E88gBJ;;A+E18gBA;EACI,iCAAA;A/E68gBJ;;A+E38gBA;EACI,iCAAA;A/E88gBJ;;A+E58gBA;EACI,iCAAA;A/E+8gBJ;;A+E78gBA;EACI,kCAAA;A/Eg9gBJ;;A+E98gBA;EACI,kCAAA;A/Ei9gBJ;;A+E/8gBA;EACI,kCAAA;A/Ek9gBJ;;A+Eh9gBA;EACI,kCAAA;A/Em9gBJ;;A+Ej9gBA;EACI,kCAAA;A/Eo9gBJ;;A+El9gBA;EACI,kCAAA;A/Eq9gBJ;;A+En9gBA;EACI,kCAAA;A/Es9gBJ;;A+Ep9gBA;EACI,kCAAA;A/Eu9gBJ;;A+Er9gBA;EACI,kCAAA;A/Ew9gBJ;;A+Et9gBA;EACI,kCAAA;A/Ey9gBJ;;A+Ev9gBA;EACI,kCAAA;A/E09gBJ;;A+Ex9gBA;EACI,kCAAA;A/E29gBJ;;A+Ez9gBA;EACI,kCAAA;A/E49gBJ;;A+E19gBA;EACI,kCAAA;A/E69gBJ;;A+E39gBA;EACI,kCAAA;A/E89gBJ;;A+E59gBA;EACI,kCAAA;A/E+9gBJ;;A+E79gBA;EACI,kCAAA;A/Eg+gBJ;;A+E99gBA;EACI,kCAAA;A/Ei+gBJ;;A+E79gBA;EACI,gCAAA;EACA,iCAAA;A/Eg+gBJ;;A+E99gBA;EACI,gCAAA;EACA,iCAAA;A/Ei+gBJ;;A+E/9gBA;EACI,gCAAA;EACA,iCAAA;A/Ek+gBJ;;A+Eh+gBA;EACI,iCAAA;EACA,kCAAA;A/Em+gBJ;;A+Ej+gBA;EACI,iCAAA;EACA,kCAAA;A/Eo+gBJ;;A+El+gBA;EACI,iCAAA;EACA,kCAAA;A/Eq+gBJ;;A+En+gBA;EACI,iCAAA;EACA,kCAAA;A/Es+gBJ;;A+Ep+gBA;EACI,iCAAA;EACA,kCAAA;A/Eu+gBJ;;A+Er+gBA;EACI,iCAAA;EACA,kCAAA;A/Ew+gBJ;;A+Et+gBA;EACI,iCAAA;EACA,kCAAA;A/Ey+gBJ;;A+Ev+gBA;EACI,iCAAA;EACA,kCAAA;A/E0+gBJ;;A+Ex+gBA;EACI,iCAAA;EACA,kCAAA;A/E2+gBJ;;A+Ez+gBA;EACI,iCAAA;EACA,kCAAA;A/E4+gBJ;;A+E1+gBA;EACI,iCAAA;EACA,kCAAA;A/E6+gBJ;;A+E3+gBA;EACI,iCAAA;EACA,kCAAA;A/E8+gBJ;;A+E5+gBA;EACI,iCAAA;EACA,kCAAA;A/E++gBJ;;A+E7+gBA;EACI,iCAAA;EACA,kCAAA;A/Eg/gBJ;;A+E9+gBA;EACI,iCAAA;EACA,kCAAA;A/Ei/gBJ;;A+E/+gBA;EACI,iCAAA;EACA,kCAAA;A/Ek/gBJ;;A+Eh/gBA;EACI,iCAAA;EACA,kCAAA;A/Em/gBJ;;A+Ej/gBA;EACI,iCAAA;EACA,kCAAA;A/Eo/gBJ;;A+Eh/gBA;EACI,+BAAA;EACA,kCAAA;A/Em/gBJ;;A+Ej/gBA;EACI,+BAAA;EACA,kCAAA;A/Eo/gBJ;;A+El/gBA;EACI,+BAAA;EACA,kCAAA;A/Eq/gBJ;;A+En/gBA;EACI,gCAAA;EACA,mCAAA;A/Es/gBJ;;A+Ep/gBA;EACI,gCAAA;EACA,mCAAA;A/Eu/gBJ;;A+Er/gBA;EACI,gCAAA;EACA,mCAAA;A/Ew/gBJ;;A+Et/gBA;EACI,gCAAA;EACA,mCAAA;A/Ey/gBJ;;A+Ev/gBA;EACI,gCAAA;EACA,mCAAA;A/E0/gBJ;;A+Ex/gBA;EACI,gCAAA;EACA,mCAAA;A/E2/gBJ;;A+Ez/gBA;EACI,gCAAA;EACA,mCAAA;A/E4/gBJ;;A+E1/gBA;EACI,gCAAA;EACA,mCAAA;A/E6/gBJ;;A+E3/gBA;EACI,gCAAA;EACA,mCAAA;A/E8/gBJ;;A+E5/gBA;EACI,gCAAA;EACA,mCAAA;A/E+/gBJ;;A+E7/gBA;EACI,gCAAA;EACA,mCAAA;A/EgghBJ;;A+E9/gBA;EACI,gCAAA;EACA,mCAAA;A/EighBJ;;A+E//gBA;EACI,gCAAA;EACA,mCAAA;A/EkghBJ;;A+EhghBA;EACI,gCAAA;EACA,mCAAA;A/EmghBJ;;A+EjghBA;EACI,gCAAA;EACA,mCAAA;A/EoghBJ;;A+ElghBA;EACI,gCAAA;EACA,mCAAA;A/EqghBJ;;A+EnghBA;EACI,gCAAA;EACA,mCAAA;A/EsghBJ;;A+EpghBA;EACI,gCAAA;EACA,mCAAA;A/EughBJ;;A+EnghBA;EACI,4BAAA;A/EsghBJ;;A+EpghBA;EACI,4BAAA;A/EughBJ;;A+ErghBA;EACI,4BAAA;A/EwghBJ;;A+EtghBA;EACI,6BAAA;A/EyghBJ;;A+EvghBA;EACI,6BAAA;A/E0ghBJ;;A+ExghBA;EACI,6BAAA;A/E2ghBJ;;A+EzghBA;EACI,6BAAA;A/E4ghBJ;;A+E1ghBA;EACI,6BAAA;A/E6ghBJ;;A+E3ghBA;EACI,6BAAA;A/E8ghBJ;;A+E5ghBA;EACI,6BAAA;A/E+ghBJ;;A+E7ghBA;EACI,6BAAA;A/EghhBJ;;A+E9ghBA;EACI,6BAAA;A/EihhBJ;;A+E/ghBA;EACI,6BAAA;A/EkhhBJ;;A+EhhhBA;EACI,6BAAA;A/EmhhBJ;;A+EjhhBA;EACI,6BAAA;A/EohhBJ;;A+ElhhBA;EACI,6BAAA;A/EqhhBJ;;A+EnhhBA;EACI,6BAAA;A/EshhBJ;;A+EphhBA;EACI,6BAAA;A/EuhhBJ;;A+ErhhBA;EACI,6BAAA;A/EwhhBJ;;A+EthhBA;EACI,6BAAA;A/EyhhBJ;;A+EvhhBA;EACI,6BAAA;A/E0hhBJ;;A+EthhBA;EACI,gCAAA;A/EyhhBJ;;A+EvhhBA;EACI,gCAAA;A/E0hhBJ;;A+ExhhBA;EACI,gCAAA;A/E2hhBJ;;A+EzhhBA;EACI,iCAAA;A/E4hhBJ;;A+E1hhBA;EACI,iCAAA;A/E6hhBJ;;A+E3hhBA;EACI,iCAAA;A/E8hhBJ;;A+E5hhBA;EACI,iCAAA;A/E+hhBJ;;A+E7hhBA;EACI,iCAAA;A/EgihBJ;;A+E9hhBA;EACI,iCAAA;A/EiihBJ;;A+E/hhBA;EACI,iCAAA;A/EkihBJ;;A+EhihBA;EACI,iCAAA;A/EmihBJ;;A+EjihBA;EACI,iCAAA;A/EoihBJ;;A+ElihBA;EACI,iCAAA;A/EqihBJ;;A+EnihBA;EACI,iCAAA;A/EsihBJ;;A+EpihBA;EACI,iCAAA;A/EuihBJ;;A+ErihBA;EACI,iCAAA;A/EwihBJ;;A+EtihBA;EACI,iCAAA;A/EyihBJ;;A+EvihBA;EACI,iCAAA;A/E0ihBJ;;A+ExihBA;EACI,iCAAA;A/E2ihBJ;;A+EzihBA;EACI,iCAAA;A/E4ihBJ;;A+E1ihBA;EACI,iCAAA;A/E6ihBJ;;A+EzihBA;EACI,mCAAA;A/E4ihBJ;;A+E1ihBA;EACI,mCAAA;A/E6ihBJ;;A+E3ihBA;EACI,mCAAA;A/E8ihBJ;;A+E5ihBA;EACI,oCAAA;A/E+ihBJ;;A+E7ihBA;EACI,oCAAA;A/EgjhBJ;;A+E9ihBA;EACI,oCAAA;A/EijhBJ;;A+E/ihBA;EACI,oCAAA;A/EkjhBJ;;A+EhjhBA;EACI,oCAAA;A/EmjhBJ;;A+EjjhBA;EACI,oCAAA;A/EojhBJ;;A+EljhBA;EACI,oCAAA;A/EqjhBJ;;A+EnjhBA;EACI,oCAAA;A/EsjhBJ;;A+EpjhBA;EACI,oCAAA;A/EujhBJ;;A+ErjhBA;EACI,oCAAA;A/EwjhBJ;;A+EtjhBA;EACI,oCAAA;A/EyjhBJ;;A+EvjhBA;EACI,oCAAA;A/E0jhBJ;;A+ExjhBA;EACI,oCAAA;A/E2jhBJ;;A+EzjhBA;EACI,oCAAA;A/E4jhBJ;;A+E1jhBA;EACI,oCAAA;A/E6jhBJ;;A+E3jhBA;EACI,oCAAA;A/E8jhBJ;;A+E5jhBA;EACI,oCAAA;A/E+jhBJ;;A+E7jhBA;EACI,oCAAA;A/EgkhBJ;;A+E5jhBA;EACI,iCAAA;A/E+jhBJ;;A+E7jhBA;EACI,iCAAA;A/EgkhBJ;;A+E9jhBA;EACI,iCAAA;A/EikhBJ;;A+E/jhBA;EACI,kCAAA;A/EkkhBJ;;A+EhkhBA;EACI,kCAAA;A/EmkhBJ;;A+EjkhBA;EACI,kCAAA;A/EokhBJ;;A+ElkhBA;EACI,kCAAA;A/EqkhBJ;;A+EnkhBA;EACI,kCAAA;A/EskhBJ;;A+EpkhBA;EACI,kCAAA;A/EukhBJ;;A+ErkhBA;EACI,kCAAA;A/EwkhBJ;;A+EtkhBA;EACI,kCAAA;A/EykhBJ;;A+EvkhBA;EACI,kCAAA;A/E0khBJ;;A+ExkhBA;EACI,kCAAA;A/E2khBJ;;A+EzkhBA;EACI,kCAAA;A/E4khBJ;;A+E1khBA;EACI,kCAAA;A/E6khBJ;;A+E3khBA;EACI,kCAAA;A/E8khBJ;;A+E5khBA;EACI,kCAAA;A/E+khBJ;;A+E7khBA;EACI,kCAAA;A/EglhBJ;;A+E9khBA;EACI,kCAAA;A/EilhBJ;;A+E/khBA;EACI,kCAAA;A/EklhBJ;;A+EhlhBA;EACI,kCAAA;A/EmlhBJ;;A+E/khBA;EACI,kCAAA;A/EklhBJ;;A+EhlhBA;EACI,kCAAA;A/EmlhBJ;;A+EjlhBA;EACI,kCAAA;A/EolhBJ;;A+EllhBA;EACI,mCAAA;A/EqlhBJ;;A+EnlhBA;EACI,mCAAA;A/EslhBJ;;A+EplhBA;EACI,mCAAA;A/EulhBJ;;A+ErlhBA;EACI,mCAAA;A/EwlhBJ;;A+EtlhBA;EACI,mCAAA;A/EylhBJ;;A+EvlhBA;EACI,mCAAA;A/E0lhBJ;;A+ExlhBA;EACI,mCAAA;A/E2lhBJ;;A+EzlhBA;EACI,mCAAA;A/E4lhBJ;;A+E1lhBA;EACI,mCAAA;A/E6lhBJ;;A+E3lhBA;EACI,mCAAA;A/E8lhBJ;;A+E5lhBA;EACI,mCAAA;A/E+lhBJ;;A+E7lhBA;EACI,mCAAA;A/EgmhBJ;;A+E9lhBA;EACI,mCAAA;A/EimhBJ;;A+E/lhBA;EACI,mCAAA;A/EkmhBJ;;A+EhmhBA;EACI,mCAAA;A/EmmhBJ;;A+EjmhBA;EACI,mCAAA;A/EomhBJ;;A+ElmhBA;EACI,mCAAA;A/EqmhBJ;;A+EnmhBA;EACI,mCAAA;A/EsmhBJ;;A+ElmhBA;EACI,iCAAA;EACA,kCAAA;A/EqmhBJ;;A+EnmhBA;EACI,iCAAA;EACA,kCAAA;A/EsmhBJ;;A+EpmhBA;EACI,iCAAA;EACA,kCAAA;A/EumhBJ;;A+ErmhBA;EACI,kCAAA;EACA,mCAAA;A/EwmhBJ;;A+EtmhBA;EACI,kCAAA;EACA,mCAAA;A/EymhBJ;;A+EvmhBA;EACI,kCAAA;EACA,mCAAA;A/E0mhBJ;;A+ExmhBA;EACI,kCAAA;EACA,mCAAA;A/E2mhBJ;;A+EzmhBA;EACI,kCAAA;EACA,mCAAA;A/E4mhBJ;;A+E1mhBA;EACI,kCAAA;EACA,mCAAA;A/E6mhBJ;;A+E3mhBA;EACI,kCAAA;EACA,mCAAA;A/E8mhBJ;;A+E5mhBA;EACI,kCAAA;EACA,mCAAA;A/E+mhBJ;;A+E7mhBA;EACI,kCAAA;EACA,mCAAA;A/EgnhBJ;;A+E9mhBA;EACI,kCAAA;EACA,mCAAA;A/EinhBJ;;A+E/mhBA;EACI,kCAAA;EACA,mCAAA;A/EknhBJ;;A+EhnhBA;EACI,kCAAA;EACA,mCAAA;A/EmnhBJ;;A+EjnhBA;EACI,kCAAA;EACA,mCAAA;A/EonhBJ;;A+ElnhBA;EACI,kCAAA;EACA,mCAAA;A/EqnhBJ;;A+EnnhBA;EACI,kCAAA;EACA,mCAAA;A/EsnhBJ;;A+EpnhBA;EACI,kCAAA;EACA,mCAAA;A/EunhBJ;;A+ErnhBA;EACI,kCAAA;EACA,mCAAA;A/EwnhBJ;;A+EtnhBA;EACI,kCAAA;EACA,mCAAA;A/EynhBJ;;A+ErnhBA;EACI,gCAAA;EACA,mCAAA;A/EwnhBJ;;A+EtnhBA;EACI,gCAAA;EACA,mCAAA;A/EynhBJ;;A+EvnhBA;EACI,gCAAA;EACA,mCAAA;A/E0nhBJ;;A+ExnhBA;EACI,iCAAA;EACA,oCAAA;A/E2nhBJ;;A+EznhBA;EACI,iCAAA;EACA,oCAAA;A/E4nhBJ;;A+E1nhBA;EACI,iCAAA;EACA,oCAAA;A/E6nhBJ;;A+E3nhBA;EACI,iCAAA;EACA,oCAAA;A/E8nhBJ;;A+E5nhBA;EACI,iCAAA;EACA,oCAAA;A/E+nhBJ;;A+E7nhBA;EACI,iCAAA;EACA,oCAAA;A/EgohBJ;;A+E9nhBA;EACI,iCAAA;EACA,oCAAA;A/EiohBJ;;A+E/nhBA;EACI,iCAAA;EACA,oCAAA;A/EkohBJ;;A+EhohBA;EACI,iCAAA;EACA,oCAAA;A/EmohBJ;;A+EjohBA;EACI,iCAAA;EACA,oCAAA;A/EoohBJ;;A+ElohBA;EACI,iCAAA;EACA,oCAAA;A/EqohBJ;;A+EnohBA;EACI,iCAAA;EACA,oCAAA;A/EsohBJ;;A+EpohBA;EACI,iCAAA;EACA,oCAAA;A/EuohBJ;;A+ErohBA;EACI,iCAAA;EACA,oCAAA;A/EwohBJ;;A+EtohBA;EACI,iCAAA;EACA,oCAAA;A/EyohBJ;;A+EvohBA;EACI,iCAAA;EACA,oCAAA;A/E0ohBJ;;A+ExohBA;EACI,iCAAA;EACA,oCAAA;A/E2ohBJ;;A+EzohBA;EACI,iCAAA;EACA,oCAAA;A/E4ohBJ;;A+ExohBA;EACI,wBAAA;A/E2ohBJ;;A+EzohBA;EACI,wBAAA;A/E4ohBJ;;A+E1ohBA;EACI,wBAAA;A/E6ohBJ;;A+E3ohBA;EACI,yBAAA;A/E8ohBJ;;A+E5ohBA;EACI,yBAAA;A/E+ohBJ;;A+E7ohBA;EACI,yBAAA;A/EgphBJ;;A+E9ohBA;EACI,yBAAA;A/EiphBJ;;A+E/ohBA;EACI,yBAAA;A/EkphBJ;;A+EhphBA;EACI,yBAAA;A/EmphBJ;;A+EjphBA;EACI,yBAAA;A/EophBJ;;A+ElphBA;EACI,yBAAA;A/EqphBJ;;A+EnphBA;EACI,yBAAA;A/EsphBJ;;A+EpphBA;EACI,yBAAA;A/EuphBJ;;A+ErphBA;EACI,yBAAA;A/EwphBJ;;A+EtphBA;EACI,yBAAA;A/EyphBJ;;A+EvphBA;EACI,yBAAA;A/E0phBJ;;A+ExphBA;EACI,yBAAA;A/E2phBJ;;A+EzphBA;EACI,yBAAA;A/E4phBJ;;A+E1phBA;EACI,yBAAA;A/E6phBJ;;A+E3phBA;EACI,yBAAA;A/E8phBJ;;A+E5phBA;EACI,yBAAA;A/E+phBJ;;A+E3phBA;EACI,kCAAA;A/E8phBJ;;A+E5phBA;EACI,kCAAA;A/E+phBJ;;A+E7phBA;EACI,kCAAA;A/EgqhBJ;;A+E9phBA;EACI,mCAAA;A/EiqhBJ;;A+E/phBA;EACI,mCAAA;A/EkqhBJ;;A+EhqhBA;EACI,mCAAA;A/EmqhBJ;;A+EjqhBA;EACI,mCAAA;A/EoqhBJ;;A+ElqhBA;EACI,mCAAA;A/EqqhBJ;;A+EnqhBA;EACI,mCAAA;A/EsqhBJ;;A+EpqhBA;EACI,mCAAA;A/EuqhBJ;;A+ErqhBA;EACI,mCAAA;A/EwqhBJ;;A+EtqhBA;EACI,mCAAA;A/EyqhBJ;;A+EvqhBA;EACI,mCAAA;A/E0qhBJ;;A+ExqhBA;EACI,mCAAA;A/E2qhBJ;;A+EzqhBA;EACI,mCAAA;A/E4qhBJ;;A+E1qhBA;EACI,mCAAA;A/E6qhBJ;;A+E3qhBA;EACI,mCAAA;A/E8qhBJ;;A+E5qhBA;EACI,mCAAA;A/E+qhBJ;;A+E7qhBA;EACI,mCAAA;A/EgrhBJ;;A+E9qhBA;EACI,mCAAA;A/EirhBJ;;A+E/qhBA;EACI,mCAAA;A/EkrhBJ;;A+EhrhBA;EACI,6BAAA;A/EmrhBJ;;A+E/qhBA;EACI,yCAAA;A/EkrhBJ;;A+E9qhBA;EACI,gDAAA;A/EirhBJ;;A+E/qhBA;EACI,gDAAA;A/EkrhBJ;;A+E/qhBA;EACI,gDAAA;A/EkrhBJ;;A+E/qhBA;EACI,yCAAA;A/EkrhBJ;;AgF3zjBQ;EACI,kBAAA;AhF8zjBZ;AgF5zjBQ;EACI,6BAAA;EACA,kBAAA;AhF8zjBZ;AgF1zjBI;EACI,kBAAA;EACA,cAAA;AhF4zjBR;AgFvzjBY;EACI,yBAAA;AhFyzjBhB;;AgFhzjBI;EACI,iBAAA;EACA,oCAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;AhFmzjBR;AgFjzjBQ;EACI,6BAAA;AhFmzjBZ;AgFjzjBY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBxE9BL;ARi1jBX;AgF/yjBQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AhFizjBZ;;AiFp2jBA;EACI,sBzE07C0B;AR66gB9B;;AiFh1jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFm1jBN;;AiFt1jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFy1jBN;;AiF51jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjF+1jBN;;AiFl2jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFq2jBN;;AiFx2jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjF22jBN;;AiF92jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFi3jBN;;AiFp3jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFu3jBN;;AiF13jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjF63jBN;;AiFh4jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFm4jBN;;AiFt4jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,yBAAA;AjFy4jBN;;AiF54jBI;EACE,czENK;EyEOL,qBzE0DS;EyEzDT,uBAAA;AjF+4jBN;;AkF56jBA;EACI,c1EoBO;AR25jBX;;AkFp6jBI;EALA,0CAAA;EACA,yBAAA;AlF66jBJ;;AkFz6jBI;EALA,wCAAA;EACA,yBAAA;AlFk7jBJ;;AkF96jBI;EALA,0CAAA;EACA,yBAAA;AlFu7jBJ;;AkFn7jBI;EALA,0CAAA;EACA,yBAAA;AlF47jBJ;;AkFx7jBI;EALA,0CAAA;EACA,yBAAA;AlFi8jBJ;;AkF77jBI;EALA,yCAAA;EACA,yBAAA;AlFs8jBJ;;AkFl8jBI;EALA,2CAAA;EACA,yBAAA;AlF28jBJ;;AkFv8jBI;EALA,wCAAA;EACA,yBAAA;AlFg9jBJ;;AkF58jBI;EALA,0CAAA;EACA,yBAAA;AlFq9jBJ;;AkFj9jBI;EALA,0CAAA;EACA,yBAAA;AlF09jBJ;;AkFt9jBI;EALA,2CAAA;EACA,yBAAA;AlF+9jBJ;;AkFn9jBI;EACI,cAAA;AlFs9jBR;AkFp9jBI;EACI,8BAAA;AlFs9jBR;AkFp9jBI;EACI,iBAAA;EACA,eAAA;AlFs9jBR;AkFp9jBI;EACI,iBAAA;EACA,eAAA;AlFs9jBR;;AmFn/jBI;EACI,qDAAA;AnFs/jBR;;AmFv/jBI;EACI,mDAAA;AnF0/jBR;;AmF3/jBI;EACI,qDAAA;AnF8/jBR;;AmF//jBI;EACI,qDAAA;AnFkgkBR;;AmFngkBI;EACI,qDAAA;AnFsgkBR;;AmFvgkBI;EACI,oDAAA;AnF0gkBR;;AmF3gkBI;EACI,sDAAA;AnF8gkBR;;AmF/gkBI;EACI,mDAAA;AnFkhkBR;;AmFnhkBI;EACI,qDAAA;AnFshkBR;;AmFvhkBI;EACI,qDAAA;AnF0hkBR;;AmF3hkBI;EACI,sDAAA;AnF8hkBR;;AmFxhkBI;EACI,oCAAA;AnF2hkBR;;AmF5hkBI;EACI,oCAAA;AnF+hkBR;;AmFhikBI;EACI,oCAAA;AnFmikBR;;AmFpikBI;EACI,oCAAA;AnFuikBR;;AmFxikBI;EACI,oCAAA;AnF2ikBR;;AmF5ikBI;EACI,oCAAA;AnF+ikBR;;AmFhjkBI;EACI,oCAAA;AnFmjkBR;;AmFpjkBI;EACI,oCAAA;AnFujkBR;;AmFxjkBI;EACI,oCAAA;AnF2jkBR;;AmFtjkBA;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;AnFyjkBJ;AmFvjkBI;EACI,MAAA;EACA,SAAA;EACA,UAAA;AnFyjkBR;AmFtjkBI;EACI,MAAA;EACA,WAAA;EACA,SAAA;AnFwjkBR;AmFrjkBI;EACI,YAAA;EACA,OAAA;EACA,QAAA;AnFujkBR;AmFrjkBQ;EACI,WAAA;AnFujkBZ;AmFnjkBI;EACI,SAAA;EACA,OAAA;EACA,QAAA;AnFqjkBR;AmFnjkBQ;EACI,WAAA;AnFqjkBZ;AmFjjkBI;EACI,WAAA;EACA,YAAA;AnFmjkBR;;AmF/ikBA;EAEQ;IACI,YAAA;EnFijkBV;AACF;AmF5ikBA;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;AnF8ikBJ;AmF5ikBI;EACI,0DAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;AnF8ikBR;AmF3ikBI;EACI,0DAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;AnF6ikBR;;AmFxikBA;EAEI,mBAAA;EAEA,4BAAA;AnF2ikBJ;;AmFxikBA;EAEI,qBAAA;AnF2ikBJ;;AmFvikBA;EACI,+FAAA;AnF0ikBJ;;AmFvikBA;EACI,mBAAA;AnF0ikBJ;;AmFvikBA;EACI,oDAAA;AnF0ikBJ;;AmFvikBA;EACI,6GAAA;AnF0ikBJ;;AmFvikBA;EACI,6GAAA;AnF0ikBJ;;AmFvikBA;EACI,4GAAA;AnF0ikBJ;;AoFzqkBA;EACI,6BAAA;ApF4qkBJ;;AoFvqkBI;EACI,8BAAA;ApF0qkBR;AoFxqkBQ;EAEI,sBAAA;EACA,WAAA;EACA,YAAA;ApFyqkBZ;;AqFvrkBA;EACI,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,uBAAA;EACA,kBAAA;ArF0rkBJ;;AqFrrkBQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;ArFwrkBZ;;AqFnrkBA;EACI,uBAAA;ArFsrkBJ;;AqFnrkBA;EACI,kBAAA;ArFsrkBJ;;AqFlrkBA;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ArFqrkBJ;AqFnrkBI;EACI,eAAA;EACA,cAAA;ArFqrkBR;AqFlrkBI;EACI,gBAAA;EACA,eAAA;ArForkBR;;AqF5qkBA;EACI,gB7EijBiB;E6EhjBjB,c7ElCO;E6EmCP,6BAAA;ArF+qkBJ;AqF7qkBI;EACI,c7EfD;E6EgBC,0B7EgagB;E6E/ZhB,6BAAA;EACA,yBAAA;ArF+qkBR;AqF5qkBI;EAEI,0B7EyZgB;E6ExZhB,yBAAA;EACA,gBAAA;ArF6qkBR;AqF1qkBI;EAEI,c7EtDG;E6EuDH,oBAAA;ArF2qkBR;;AqFnqkBQ;EAEI,qB7EEG;E6EDH,qDAAA;EACA,mBAAA;ArFqqkBZ;;AqFjqkBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCqtkBF;AqF/qkBQ;EAEI,qDAAA;ArFgrkBZ;;AqF5qkBI;EACI,yCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArF+qkBR;AqF7qkBQ;EAEI,0CAAA;EACA,qCAAA;EACA,c7EtBG;E6EuBH,oFAAA;ArF8qkBZ;;AqFzskBQ;EAEI,qB7EEG;E6EDH,mDAAA;EACA,mBAAA;ArF2skBZ;;AqFvskBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC2vkBF;AqFrtkBQ;EAEI,mDAAA;ArFstkBZ;;AqFltkBI;EACI,uCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArFqtkBR;AqFntkBQ;EAEI,wCAAA;EACA,mCAAA;EACA,c7EtBG;E6EuBH,gFAAA;ArFotkBZ;;AqF/ukBQ;EAEI,qB7EEG;E6EDH,qDAAA;EACA,mBAAA;ArFivkBZ;;AqF7ukBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCiykBF;AqF3vkBQ;EAEI,qDAAA;ArF4vkBZ;;AqFxvkBI;EACI,yCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArF2vkBR;AqFzvkBQ;EAEI,0CAAA;EACA,qCAAA;EACA,c7EtBG;E6EuBH,oFAAA;ArF0vkBZ;;AqFrxkBQ;EAEI,qB7EEG;E6EDH,qDAAA;EACA,mBAAA;ArFuxkBZ;;AqFnxkBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCu0kBF;AqFjykBQ;EAEI,qDAAA;ArFkykBZ;;AqF9xkBI;EACI,yCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArFiykBR;AqF/xkBQ;EAEI,0CAAA;EACA,qCAAA;EACA,c7EtBG;E6EuBH,oFAAA;ArFgykBZ;;AqF3zkBQ;EAEI,qB7EEG;E6EDH,qDAAA;EACA,mBAAA;ArF6zkBZ;;AqFzzkBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC62kBF;AqFv0kBQ;EAEI,qDAAA;ArFw0kBZ;;AqFp0kBI;EACI,yCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArFu0kBR;AqFr0kBQ;EAEI,0CAAA;EACA,qCAAA;EACA,c7EtBG;E6EuBH,oFAAA;ArFs0kBZ;;AqFj2kBQ;EAEI,qB7EEG;E6EDH,oDAAA;EACA,mBAAA;ArFm2kBZ;;AqF/1kBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCm5kBF;AqF72kBQ;EAEI,oDAAA;ArF82kBZ;;AqF12kBI;EACI,wCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArF62kBR;AqF32kBQ;EAEI,yCAAA;EACA,oCAAA;EACA,c7EtBG;E6EuBH,kFAAA;ArF42kBZ;;AqFv4kBQ;EAEI,qB7EEG;E6EDH,sDAAA;EACA,mBAAA;ArFy4kBZ;;AqFr4kBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCy7kBF;AqFn5kBQ;EAEI,sDAAA;ArFo5kBZ;;AqFh5kBI;EACI,0CAAA;EACA,c7EfO;E6EgBP,yBAAA;ArFm5kBR;AqFj5kBQ;EAEI,2CAAA;EACA,sCAAA;EACA,c7EtBG;E6EuBH,sFAAA;ArFk5kBZ;;AqF76kBQ;EAEI,qB7EEG;E6EDH,mDAAA;EACA,mBAAA;ArF+6kBZ;;AqF36kBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC+9kBF;AqFz7kBQ;EAEI,mDAAA;ArF07kBZ;;AqFt7kBI;EACI,uCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArFy7kBR;AqFv7kBQ;EAEI,wCAAA;EACA,mCAAA;EACA,c7EtBG;E6EuBH,gFAAA;ArFw7kBZ;;AqFn9kBQ;EAEI,qB7EEG;E6EDH,qDAAA;EACA,mBAAA;ArFq9kBZ;;AqFj9kBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCqglBF;AqF/9kBQ;EAEI,qDAAA;ArFg+kBZ;;AqF59kBI;EACI,yCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArF+9kBR;AqF79kBQ;EAEI,0CAAA;EACA,qCAAA;EACA,c7EtBG;E6EuBH,oFAAA;ArF89kBZ;;AqFz/kBQ;EAEI,qB7EEG;E6EDH,qDAAA;EACA,mBAAA;ArF2/kBZ;;AqFv/kBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC2ilBF;AqFrglBQ;EAEI,qDAAA;ArFsglBZ;;AqFlglBI;EACI,yCAAA;EACA,c7EfO;E6EgBP,yBAAA;ArFqglBR;AqFnglBQ;EAEI,0CAAA;EACA,qCAAA;EACA,c7EtBG;E6EuBH,oFAAA;ArFoglBZ;;AqF/hlBQ;EAEI,qB7EEG;E6EDH,sDAAA;EACA,mBAAA;ArFiilBZ;;AqF7hlBI;EnDhDF,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCillBF;AqF3ilBQ;EAEI,sDAAA;ArF4ilBZ;;AqFxilBI;EACI,0CAAA;EACA,c7EfO;E6EgBP,yBAAA;ArF2ilBR;AqFzilBQ;EAEI,2CAAA;EACA,sCAAA;EACA,c7EtBG;E6EuBH,sFAAA;ArF0ilBZ;;AqFlilBA;EACI,qB7EtGO;E6EuGP,qI7EmsBa;E6ElsBb,uB7EibY;ARonkBhB;AqFnilBI;EAEI,yBAAA;EACA,iCAAA;EACA,kFAAA;ArFoilBR;;AqF7hlBA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;ArFgilBJ;AqF9hlBI;EACI,aAAA;ArFgilBR;;AqFzhlBA;EACI,aAAA;EACA,cAAA;EACA,oDAAA;EACA,kBAAA;EACA,kBAAA;EACA,kD7EwZY;E6EhZZ,aAAA;EAiBA,eAAA;ArFqglBJ;AqF3hlBQ;EACI,oDAAA;ArF6hlBZ;AqF9hlBQ;EACI,oDAAA;ArFgilBZ;AqFjilBQ;EACI,oDAAA;ArFmilBZ;AqFpilBQ;EACI,oDAAA;ArFsilBZ;AqFvilBQ;EACI,oDAAA;ArFyilBZ;AqF1ilBQ;EACI,oDAAA;ArF4ilBZ;AqF7ilBQ;EACI,oDAAA;ArF+ilBZ;AqFhjlBQ;EACI,oDAAA;ArFkjlBZ;AqFnjlBQ;EACI,oDAAA;ArFqjlBZ;AqFtjlBQ;EACI,oDAAA;ArFwjlBZ;AqFzjlBQ;EACI,oDAAA;ArF2jlBZ;AqFtjlBI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,+BAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,uCAAA;EACA,+BAAA;EACA,YAAA;EACA,4DAAA;ArFwjlBR;AqFpjlBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,2CAAA;EACA,SAAA;EACA,UAAA;EACA,+BAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,mCAAA;EACA,gCAAA;ArFsjlBR;AqFnjlBI;EACI;IAEI,qBAAA;IACA,UAAA;IACA,yGAAA;ErFqjlBV;EqFljlBM;IAEI,mBAAA;IACA,UAAA;IACA,gBAAA;ErFojlBV;AACF;;AqFhjlBA;EACI,gBAAA;EACA,cAAA;EACA,yBAAA;ArFmjlBJ;AqFljlBI;EACI,uBAAA;ArFojlBR;;AqF9ilBQ;EACI,+BAAA;ArFijlBZ;;AqF5ilBA;EACI,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,wBAAA;ArF+ilBJ;AqF9ilBI;EACI,kGAAA;ArFgjlBR;;AqF3ilBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,2CAAA;ArF8ilBJ;AqF7ilBI;EACI,0HAAA;ArF+ilBR;AqF5ilBI;EACI,8BAAA;ArF8ilBR;AqF7ilBQ;EACI,2HAAA;ArF+ilBZ;;AsF9ylBA;EACI,qB9E4gBgB;E8E3gBhB,kBAAA;EACA,8C9E6iBY;ARowkBhB;AsF/ylBI;EACI,gC9EwjBU;ARyvkBlB;AsF/ylBQ;EACI,oDAAA;EACA,sCAAA;AtFizlBZ;AsF5ylBQ;EACI,8BAAA;EACA,2HAAA;AtF8ylBZ;AsF3ylBQ;EACI,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,8IAAA;AtF6ylBZ;;AsFxylBA;EACI,qBAAA;AtF2ylBJ;;AsFxylBA;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AtF2ylBJ;AsFzylBI;EACI,yB9E/BG;E8EgCH,c9E1BG;ARq0lBX;;AsFrylBA;;EAEI,aAAA;AtFwylBJ;;AsFrylBA;EACI,iBAAA;AtFwylBJ;;AsFpylBA;EACI,sB9EnDI;E8EoDJ,e9EurCY;E8EtrCZ,qB9E4cgB;EC9fhB,wBAAA;AT01lBJ;;AsFlylBA;EACI,kBAAA;AtFqylBJ;AsFnylBI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;AtFqylBR;AsFlylBI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;AtFoylBR;AsFjylBI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iCAAA;AtFmylBR;AsFhylBI;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;AtFkylBR;AsF/xlBI;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AtFiylBR;AsF9xlBI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gB9E+eW;E8E9eX,kD9EybQ;E8ExbR,qBAAA;EACA,sBAAA;EACA,sB9E8aW;E8E7aX,aAAA;AtFgylBR;AsF9xlBQ;EACI,SAAA;EACA,UAAA;AtFgylBZ;AsF7xlBQ;EACI,YAAA;EACA,UAAA;AtF+xlBZ;AsF5xlBQ;EACI,SAAA;EACA,WAAA;AtF8xlBZ;AsF3xlBQ;EACI,YAAA;EACA,WAAA;AtF6xlBZ;;AsFvxlBI;EACI,2BAAA;EACA,sBAAA;AtF0xlBR;AsFxxlBQ;EACI,gC9EoaM;E8EnaN,+BAAA;EACA,sBAAA;AtF0xlBZ;AsFnxlBY;EACI,qBAAA;AtFqxlBhB;;AsF/wlBA;EACI,2BAAA;EACA,oCAAA;AtFkxlBJ;AsF/wlBQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,kCAAA;UAAA,0BAAA;EACA,+BAAA;EACA,0BAAA;EACA,gC9EsYM;AR24kBlB;AsF7wlBY;EACI,UAAA;EACA,0BAAA;AtF+wlBhB;;AsFzwlBA;EACI,gBAAA;EACA,SAAA;AtF4wlBJ;;AuFh9lBI;EACI,oB/E4lBS;E+E3lBT,a/E8jCO;E+E7jCP,kD/E4iBQ;E+E3iBR,sBAAA;EACA,SAAA;AvFm9lBR;AuFj9lBQ;EACI,WCCY;AxFk9lBxB;AuFh9lBQ;EACI,YCFY;AxFo9lBxB;AuF/8lBQ;EACI,YCLY;AxFs9lBxB;AuF/8lBQ;EACI,sB/EohBO;AR67kBnB;AuF18lBY;EAGI,4CAAA;AvF08lBhB;;AyFx+lBA;EACI,yBjFWO;EiFVP,qBjFUO;ARi+lBX;;AyFv+lBA;;EAEI,gBAAA;AzF0+lBJ;;AyF99lBI;;;;;;;;EACI,2BAAA;AzFw+lBR;;AyFl+lBI;EACI,qBjFdG;EiFeH,kCAAA;AzFq+lBR;AyFn+lBI;EACI,yBjFpBG;EiFqBH,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;AzFq+lBR;;AyF/9lBI;EACI,aAAA;AzFk+lBR;;AyF79lBA;EACI,kBAAA;AzFg+lBJ;AyF/9lBI;EACI,8BAAA;AzFi+lBR;AyF/9lBI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBjFhEe;EiFiEf,cAAA;AzFi+lBR;;AyFv9lBQ;EACI,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AzF09lBZ;;AyFr9lBA;EACI,cAAA;AzFw9lBJ;;AyFr9lBA;EACI,6BAAA;EACA,oBAAA;EACA,sBAAA;AzFw9lBJ;;AyFr9lBA;EAEI,gBAAA;EACA,MAAA;AzFw9lBJ;;AyFr9lBA;EACI,sDAAA;EACA,uBAAA;AzFw9lBJ;;AyFr9lBA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AzFw9lBJ;;AyFr9lBA;EACI,cAAA;AzFw9lBJ;;AyFr9lBA;EACI,qBAAA;AzFw9lBJ;;AyFr9lBA;EACI,cAAA;EACA,eAAA;AzFw9lBJ;AyFv9lBI;EACI,YAAA;AzFy9lBR;;AyFt9lBA;EACI,yBAAA;AzFy9lBJ;;AyFt9lBA;EACI,cAAA;AzFy9lBJ;;AyFt9lBA;EACI,4BAAA;AzFy9lBJ;;AyFt9lBA;EACI,0BAAA;AzFy9lBJ;;AyFv9lBA;EACI,qBAAA;AzF09lBJ;;AyFv9lBA;EACI,uBAAA;EAAA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EAEA,gBAAA;EACA,kBAAA;AzFy9lBJ;;AyFt9lBA;EACI,eAAA;EACA,WAAA;AzFy9lBJ;AyFx9lBI;EACI,YAAA;AzF09lBR;;AyFt9lBA;EACI,qCAAA;AzFy9lBJ;;AyFt9lBA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;AzFy9lBJ;;AyFt9lBA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AzFy9lBJ;;AyFv9lBA;EACI;IACI,UAAA;EzF09lBN;EyFx9lBE;IACI,UAAA;EzF09lBN;EyFx9lBE;IACI,UAAA;EzF09lBN;AACF;AyFv9lBA,gCAAA;AACA;;EAEI,wBAAA;EACA,SAAA;AzFy9lBJ;;AyFt9lBA,YAAA;AACA;EACI,0BAAA;AzFy9lBJ;;AyFt9lBA;EACI,2BAAA;EACA,sBAAA;AzFy9lBJ;;AyFt9lBA;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AzFy9lBJ;;AyFt9lBA;EACI,cAAA;AzFy9lBJ;;AyFt9lBA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;AzFy9lBJ;;AyFt9lBA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzFy9lBJ;;AyFt9lBA;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AzFy9lBJ;;AyFt9lBA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;AzFy9lBJ;;AyFt9lBA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzFy9lBJ;;AyFt9lBA;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AzFy9lBJ;;AyFr9lBA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;AzFw9lBJ;;AyFr9lBA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzFw9lBJ;;AyFr9lBA;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,SAAA;EACA,YAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AzFw9lBJ;;AyFr9lBA;EACI,kBAAA;EACA,SAAA;AzFw9lBJ;;AyFr9lBA;EACI,yBAAA;AzFw9lBJ;;AyFr9lBA;EACI,cAAA;AzFw9lBJ;;AyFr9lBA;EACI,cAAA;AzFw9lBJ;;AyFr9lBA;EACI,yBAAA;AzFw9lBJ;;AyFr9lBA;EACI,mBAAA;AzFw9lBJ;;AyFr9lBA;EACI,qCAAA;AzFw9lBJ;;AyFr9lBA;EACI;IACI,UAAA;EzFw9lBN;AACF;AyFr9lBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AzFu9lBJ;;AyFp9lBA;EACI,eAAA;AzFu9lBJ;;AyFp9lBA;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;AzFu9lBJ;;AyFn9lBI;EACI,yBAAA;EACA,kBAAA;AzFs9lBR;;A0F12mBQ;EACI,yBAAA;A1F62mBZ;;A0Fv2mBA;EACI,aAAA;A1F02mBJ;;A0Ft2mBA;EACI,UAAA;EACA,eAAA;A1Fy2mBJ;;A0Fr2mBA;EACI,sBlFTI;EkFUJ,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;A1Fw2mBJ;A0Fv2mBI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,clFjBG;AR03mBX;;A0Fr2mBA;EACI;IACI,qBAAA;E1Fw2mBN;AACF;A0Fr2mBA;EACI,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,yBlFxBO;EkFyBP,WlFjCI;EkFkCJ,gBAAA;EACA,SAAA;A1Fu2mBJ;;A0Fp2mBA;EACI,aAAA;A1Fu2mBJ;;A0Fp2mBA;EACI,gBAAA;A1Fu2mBJ;;A0Fl2mBI;;EACI,SAAA;EACA,aAAA;A1Fs2mBR;;A0Fj2mBI;EACI,YAAA;EACA,kBAAA;A1Fo2mBR;A0Fl2mBI;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;A1Fo2mBR;A0Fn2mBQ;EACI,uBAAA;EACA,8BAAA;EACA,sBAAA;A1Fq2mBZ;;A0F51mBgB;EACI,aAAA;EACA,mBAAA;A1F+1mBpB;A0F91mBoB;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;A1Fg2mBxB;A0F/1mBwB;EACI,gBAAA;A1Fi2mB5B;A0F/1mBwB;EACI,eAAA;A1Fi2mB5B;A0F91mBwB;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mFAAA;EACA,gBAAA;EACA,sCAAA;A1Fg2mB5B;A0F11mBgB;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,8DAAA;EACA,gCAAA;A1F41mBpB;A0F31mBoB;EACI,mBAAA;A1F61mBxB;A0F31mBoB;EACI,gCAAA;A1F61mBxB;A0Ft1mBI;EACI,YAAA;EACA,kBAAA;A1Fw1mBR;A0Fv1mBQ;EACI,yBAAA;A1Fy1mBZ;A0Fv1mBQ;EACI,yBAAA;A1Fy1mBZ;;A0Fn1mBI;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;A1Fs1mBR;;A0Fh1mBI;EACI,YAAA;A1Fm1mBR;A0Fj1mBY;EACI,sDAAA;A1Fm1mBhB;A0F90mBQ;EACI,cAAA;A1Fg1mBZ;A0F/0mBY;EACI,8BAAA;A1Fi1mBhB;A0F/0mBoB;EACI,mBAAA;A1Fi1mBxB;A0Fh1mBwB;EACI,gBAAA;A1Fk1mB5B;A0Fz0mBY;EACI,cAAA;A1F20mBhB;A0Ft0mBQ;EACI,cAAA;A1Fw0mBZ;A0Fr0mBoB;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;EACA,0DAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;A1Fu0mBxB;A0Fh0mBQ;EACI,cAAA;A1Fk0mBZ;A0F/zmBI;EACI,YAAA;EACA,kBAAA;EACA,wBAAA;A1Fi0mBR;A0Fh0mBQ;EACI,yBAAA;A1Fk0mBZ;A0F7zmBgB;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;A1F+zmBpB;A0F9zmBoB;EACI,gCAAA;A1Fg0mBxB;A0F9zmBoB;EACI,mBAAA;A1Fg0mBxB;A0F/zmBwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;A1Fi0mB5B;A0F7zmBwB;EACI,mBAAA;A1F+zmB5B;A0F1zmBgB;EACI,YAAA;A1F4zmBpB;A0F1zmBgB;EACI,uBAAA;EAAA,kBAAA;A1F4zmBpB;A0F1zmBoB;EACI,YAAA;EACA,4BAAA;EAAA,uBAAA;A1F4zmBxB;A0F3zmBwB;EACI,UAAA;A1F6zmB5B;A0F5zmB4B;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;A1F8zmBhC;A0F1zmB4B;EACI,UAAA;A1F4zmBhC;A0FvzmBgB;EACI,YAAA;A1FyzmBpB;A0FrzmBY;EACI,UAAA;A1FuzmBhB;A0FpzmBQ;EACI,4BAAA;A1FszmBZ;A0FlzmBgB;EACI,kBAAA;EACA,wBAAA;EACA,8BAAA;A1FozmBpB;A0FnzmBoB;EACI,WAAA;EACA,8BAAA;A1FqzmBxB;A0FpzmBwB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;A1FszmB5B;A0FrzmB4B;EACI,uBAAA;EACA,8BAAA;EACA,mCAAA;EACA,yDAAA;A1FuzmBhC;A0FjzmBY;EACI,UAAA;EACA,qCAAA;A1FmzmBhB;A0FhzmBoB;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,gCAAA;EACA,+CAAA;A1FkzmBxB;A0FjzmBwB;EACI,gCAAA;EACA,kDAAA;A1FmzmB5B;A0FjzmBwB;EACI,gBAAA;EACA,gCAAA;EACA,kDAAA;A1FmzmB5B;A0F9ymBgB;EACI,uBAAA;A1FgzmBpB;A0F9ymBwB;EACI,gCAAA;A1FgzmB5B;A0F/ymB4B;EACI,8BAAA;EACA,qCAAA;EACA,2CAAA;A1FizmBhC;A0F9ymBwB;EACI,8BAAA;EACA,qCAAA;EACA,2CAAA;A1FgzmB5B;A0FzymBY;EACI,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;A1F2ymBhB;A0F1ymBgB;EACI,aAAA;A1F4ymBpB;A0F1ymBgB;EACI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;A1F4ymBpB;A0FvymBY;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;A1FyymBhB;A0FxymBgB;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,sCAAA;A1F0ymBpB;A0FzymBoB;EACI,mBAAA;A1F2ymBxB;A0FzymBoB;EACI,gCAAA;A1F2ymBxB;A0FxymBgB;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;EACA,oBAAA;A1F0ymBpB;A0FxymBgB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;A1F0ymBpB;A0FtymBwB;EACI,kBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kDAAA;A1FwymB5B;A0FtymBgC;EAEI,4CAAA;A1FuymBpC;A0FnymBgC;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qCAAA;A1FqymBpC;A0FjymBgC;EACI,uBAAA;A1FmymBpC;A0FlymBoC;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;A1FoymBxC;A0FnymBwC;EACI,yBAAA;A1FqymB5C;A0FnymBwC;EACI,8BAAA;A1FqymB5C;;A0FrxmBI;EACI,YAAA;EACA,kBAAA;A1FwxmBR;A0FvxmBQ;EACI,mBAAA;A1FyxmBZ;A0FvxmBQ;EACI,UAAA;A1FyxmBZ;A0FpxmBY;EACI,gDAAA;A1FsxmBhB;A0FpxmBoB;EACI,gCAAA;A1FsxmBxB;A0FrxmBwB;EACI,gCAAA;EACA,kDAAA;A1FuxmB5B;A0FrxmBwB;EACI,kDAAA;A1FuxmB5B;A0FjxmBY;EACI,SAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A1FmxmBhB;A0FjxmBoB;EACI,8BAAA;EACA,wBAAA;A1FmxmBxB;A0FlxmBwB;EACI,8BAAA;A1FoxmB5B;A0FhxmBgB;EACI,WAAA;EACA,YAAA;A1FkxmBpB;A0FhxmBwB;EACI,qBAAA;EACA,8BAAA;A1FkxmB5B;A0F/wmBoB;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;A1FixmBxB;A0FhxmBwB;EACI,qBAAA;EACA,8BAAA;A1FkxmB5B;;A0FtwmBI;EACI,YAAA;EACA,kBAAA;A1FywmBR;A0FxwmBQ;EACI,UAAA;A1F0wmBZ;;A0FlwmBI;EACI,YAAA;EACA,kBAAA;A1FqwmBR;A0FpwmBQ;EACI,UAAA;A1FswmBZ;A0FlwmBQ;EACI,yDAAA;A1FowmBZ;;A0F/vmBA,iBAAA;AACA;EAIY;IACI,eAAA;E1F+vmBd;E0F1vmBc;IACI,sBAAA;IACA,kCAAA;E1F4vmBlB;E0F3vmBkB;IACI,aAAA;E1F6vmBtB;E0FxvmBc;IACI,WAAA;E1F0vmBlB;AACF;A0FpvmBA,kBAAA;AACA;EAIY;IACI,eAAA;E1FmvmBd;E0F5umBkB;IACI,YAAA;E1F8umBtB;E0FzumBc;IACI,WAAA;E1F2umBlB;AACF;A0FrumBA,iBAAA;AACA;EAIY;IACI,eAAA;E1FoumBd;E0F/tmBc;IACI,WAAA;E1FiumBlB;AACF;A0F3tmBA,iBAAA;AACA;EAIY;IACI,cAAA;E1F0tmBd;AACF;A0FrtmBA,kBAAA;AACA;EAIY;IACI,cAAA;E1FotmBd;AACF;A0F/smBA,iBAAA;AACA;EAIY;IACI,cAAA;E1F8smBd;AACF;A0FzsmBA,iBAAA;AACA;EAIY;IACI,cAAA;E1FwsmBd;AACF;A0FnsmBA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AACA;EAIY;IACI,cAAA;E1F4rmBd;AACF;A0FvrmBA,kBAAA;AAIA,uBAAA;AAIA,eAAA;AChtBA;EACI,UAAA;A3Fo4nBJ;A2Fl4nBQ;EACI,gBnFNS;EmFOT,oBAAA;A3Fo4nBZ;A2Fn4nBY;EACI,cnFYL;ARy3nBX;A2Fp4nBgB;EACI,anFUT;AR43nBX;A2Fn4nBY;EACI,yBAAA;A3Fq4nBhB;A2Fp4nBgB;EACI,cnF2Bb;AR22nBP;A2Fr4nBoB;EACI,anFyBjB;AR82nBP;A2Fl4nBgB;EACI,cnFmBb;ARi3nBP;A2Fn4nBoB;EACI,anFiBjB;ARo3nBP;A2F93nBgB;EACI,wBAAA;EACA,mBAAA;EACA,gCAAA;A3Fg4nBpB;A2F/3nBoB;EACI,gGAAA;A3Fi4nBxB;A2F93nBgB;EACI,UAAA;EACA,kBAAA;EACA,kDAAA;EACA,qCAAA;A3Fg4nBpB;A2F73nBoB;EACI,aAAA;A3F+3nBxB;A2F33nBoB;EACI,UAAA;EACA,mBAAA;EACA,oCAAA;A3F63nBxB;A2F13nBgB;EACI,wBAAA;EACA,mBAAA;A3F43nBpB;A2F33nBoB;EACI,gGAAA;A3F63nBxB;A2F33nBoB;EACI,UAAA;EACA,kBAAA;EACA,qCAAA;A3F63nBxB;A2F13nBwB;EACI,UAAA;EACA,mBAAA;EACA,oCAAA;A3F43nB5B;A2Fr3nBI;EACI,YAAA;A3Fu3nBR;A2Fp3nBgB;EACI,eAAA;EACA,cAAA;EAEA,gBAAA;A3Fq3nBpB;A2Fh3nBI;EACI,gCnFgeU;EmF/dV,+CnFgdK;EmF/cL,gBnFpFA;EmFqFA,eAAA;EACA,eAAA;EACA,WAAA;EACA,MAAA;A3Fk3nBR;A2F/2nBQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kDAAA;EACA,qCAAA;A3Fi3nBZ;A2F92nBY;EACI,aAAA;A3Fg3nBhB;A2F52nBY;EACI,UAAA;EACA,mBAAA;EACA,oCAAA;A3F82nBhB;A2F12nBY;EACI,qBAAA;EACA,6BAAA;EACA,gDAAA;A3F42nBhB;A2Fz2nBgB;EACI,qBAAA;EACA,8BAAA;EACA,+CAAA;A3F22nBpB;;A2Fn2nBQ;EACI,qBAAA;A3Fs2nBZ;A2Fp2nBQ;EACI,aAAA;A3Fs2nBZ;;A2F/1nBQ;EACI,aAAA;A3Fk2nBZ;A2Fh2nBQ;EACI,qBAAA;A3Fk2nBZ;;A2F31nBQ;EACI,gBAAA;A3F81nBZ;;A2Fz1nBA;EACI,YAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;A3F41nBJ;AgB98nBI;E2E6GJ;IAOQ,SAAA;IACA,6BHhKoB;IGiKpB,kBAAA;IACA,kDnF+XQ;ImF9XR,kBAAA;IACA,UAAA;IACA,qCAAA;IACA,gCnFwYU;ImFvYV,mDAAA;IACA,4BAAA;E3F81nBN;E2F71nBM;IACI,gBHzKmB;ExFwgoB7B;E2F71nBM;IACI,gBH3KmB;ExF0goB7B;E2F11nBkB;IACI,kBAAA;IACA,MAAA;IACA,UAAA;IACA,aAAA;E3F41nBtB;AACF;A2Fv1nBI;EACI,cAAA;A3Fy1nBR;A2Fv1nBY;EACI,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A3Fy1nBhB;A2Fr1nBoB;EACI,cAAA;A3Fu1nBxB;A2Fn1nBoB;EACI,WAAA;EACA,2CAAA;EACA,kBAAA;A3Fq1nBxB;A2F/0nBI;EACI,qBAAA;A3Fi1nBR;A2Fh1nBQ;EACI,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;A3Fk1nBZ;;AgB3goBI;E2EgMA;IACI,anFs0BO;ImFr0BP,cAAA;E3F+0nBN;E2F10nBc;IACI,UAAA;IACA,oCAAA;IACA,mBAAA;E3F40nBlB;E2Fz0nB0B;IACI,UAAA;IACA,oCAAA;IACA,mBAAA;IACA,cAAA;E3F20nB9B;AACF;A2Fh0nBQ;EACI,WnF7QJ;AR+koBR;A2F9znBQ;EACI,yBAAA;A3Fg0nBZ;;A2F3znBA;EACI,wBAAA;EACA,gBAAA;A3F8znBJ;;AgB3hoBI;E2EiOA;IACI,sBnF9RA;ImF+RA,cAAA;IACA,YAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;E3F8znBN;E2F3znBc;IACI,WAAA;E3F6znBlB;E2FvznBc;IACI,qBAAA;E3FyznBlB;E2FvznBc;IACI,aAAA;E3FyznBlB;E2FtznBU;IACI,cnFi0BK;ImFh0BL,yBnFq0BoB;ERm/lBlC;E2FrznBU;IACI,0DAAA;E3FuznBd;E2FlznBc;IACI,oBAAA;IACA,mBAAA;IACA,cnF1TT;ER8moBT;E2FnznBkB;IACI,YAAA;E3FqznBtB;E2FlznBc;IACI,yBAAA;E3FoznBlB;E2F1ynBsC;IACI,yBAAA;E3F4ynB1C;E2FhynBkB;IACI,qDAAA;E3FkynBtB;E2F5xnBE;IACI,iBAAA;IACA,gBAAA;E3F8xnBN;AACF;A4FlpoBA;EACI,iDAAA;A5FopoBJ;A4FlpoBI;EACI,mBAAA;A5FopoBR;A4FhpoBQ;EACI,oCAAA;EACA,wBAAA;A5FkpoBZ;A4FhpoBQ;EACI,2CAAA;A5FkpoBZ;;A4FzooBQ;;EACI,cpFND;EoFOC,gBpF5BS;ARyqoBrB;;A4FxooBA;EACI,gBpFpBI;EoFqBJ,sBpFwgBe;EoFvgBf,YAAA;A5F2ooBJ;A4FzooBI;EACI,6BAAA;EACA,cpFnBG;AR8poBX;A4FxooBI;;EAEI,cpFxBG;EoFyBH,sBpFhCA;EoFiCA,8CpFmgBQ;ARuonBhB;;A4FrooBA;EACI,oCAAA;A5FwooBJ;;A4F/noBA;EACI,mBAAA;A5FkooBJ;;A4F9noBI;EACI,cpF/CG;ARgroBX;A4F/noBQ;EAGI,cpF7BL;AR4poBP;A4F5noBQ;EACI,cpFjCL;AR+poBP;;A6FtsoBI;EACE,+BrFqiBa;EqFpiBb,kCrFoiBa;ARqqnBnB;A6FrsoBI;EACE,gCrF+hBa;EqF9hBb,mCrF8hBa;ARyqnBnB;;A6FhsoBE;EACE,8BAAA;EACA,aAAA;A7FmsoBJ;;A8FvtoBA;EACI,kDtFgjBY;AR0qnBhB;A8FxtoBI;EACI,aAAA;EACA,uBtF2lBO;AR+nnBf;;A+F5toBA;EACI,WAAA;A/F+toBJ;;A+F3toBA;EACI,WAAA;A/F8toBJ;;A+F1toBA;EACI,YAAA;A/F6toBJ;;A+FztoBA;EACI,YAAA;A/F4toBJ;;A+FxtoBA;EACI,YAAA;A/F2toBJ;;A+FxtoBA,yBAAA;AACA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;A/F2toBJ;A+FztoBI;EACI,WAAA;A/F2toBR;A+FxtoBI;EACI,WAAA;A/F0toBR;A+FvtoBI;EACI,WAAA;A/FytoBR;A+FttoBI;EACI,UAAA;A/FwtoBR;A+FrtoBI;EACI,UAAA;A/FutoBR;;A+FntoBA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;A/FstoBJ;A+FptoBI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;A/FstoBR;A+FntoBI;EACI,WAAA;A/FqtoBR;A+FltoBI;EACI,WAAA;A/FotoBR;A+FjtoBI;EACI,UAAA;A/FmtoBR;A+FhtoBI;EACI,UAAA;A/FktoBR;;A+F5soBA;EACI,gBAAA;EACA,mBAAA;A/F+soBJ;A+F7soBI;EACI,UAAA;EACA,WAAA;EACA,eAAA;A/F+soBR;A+F5soBI;EACI,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;A/F8soBR;;A+F1soBA;EACI,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;A/F6soBJ;;A+F1soBA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;A/F6soBJ;;A+F3soBA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,gCAAA;A/F8soBJ;;A+F5soBA;EACI,WAAA;EACA,YAAA;A/F+soBJ;;A+F7soBA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;A/FgtoBJ;;A+F9soBA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;A/FitoBJ;;A+F/soBA;EACI,YAAA;EACA,aAAA;EACA,qBAAA;A/FktoBJ;;A+FhtoBA;EACI;IACI,+CAAA;E/FmtoBN;E+FjtoBE;IACI,6CAAA;E/FmtoBN;AACF;A+FhtoBA;EACI;IAEI,iBAAA;E/FitoBN;E+F/soBE;IACI,4BAAA;E/FitoBN;AACF;A+F9soBA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;A/FgtoBJ;A+F7soBA;EACI,aAAA;EACA,UAAA;EACA,UAAA;EACA,4BAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yJAAA;EAEA,yCAAA;EACA,gCAAA;EACA,gBAAA;A/F8soBJ;;A+F3soBA;EACI,sCAAA;EACA,gCAAA;A/F8soBJ;;AgGp5oBA;EACE,uBAAA;EACA,yCxFmlBuB;ARo0nBzB;;AgGl5oBA;EACE,gCAAA;EACA,qBAAA;AhGq5oBF;AgGn5oBE;EACE,aAAA;AhGq5oBJ;;AgGj5oBA;EACE,kBAAA;AhGo5oBF;;AgGh5oBA;EACE,gBxFxBqB;EwFyBrB,uBxFwkBa;AR20nBf;;AgG/4oBA;EACE,aAAA;AhGk5oBF;;AgG74oBA;EACE,kBAAA;EACA,mBAAA;EACA,8BAAA;AhGg5oBF;AgG94oBE;EACE,cAAA;EACA,+BAAA;EACA,iBAAA;AhGg5oBJ;;AgG34oBA;EACE,UAAA;AhG84oBF;;AgG34oBA;EACE,UAAA;AhG84oBF;;AgG34oBA;EACE,WAAA;AhG84oBF;;AgG34oBA;EACE,WAAA;AhG84oBF;;AiG18oBA;EACI,aAAA;AjG68oBJ;;AiG18oBA;EACI,aAAA;AjG68oBJ;;AiG38oBA;EACI,aAAA;AjG88oBJ;;AiG58oBA;EACI,aAAA;AjG+8oBJ;;AiG18oBI;;EAEI,iCAAA;AjG68oBR;;AiGx8oBA;EAUI,yBAAA;AjGk8oBJ;AiG38oBI;EACI,gBAAA;AjG68oBR;AiG18oBQ;EACI,YAAA;EACA,WAAA;AjG48oBZ;;AiGt8oBA;EACI,czFnBO;EyFoBP,iBAAA;EACA,qBAAA;EACA,cAAA;AjGy8oBJ;AiGv8oBI;EACI,czFxBG;ARi+oBX;;AiGn8oBI;;EAEI,mBAAA;AjGs8oBR;;AiGh8oBI;EACI,YAAA;AjGm8oBR;;AiG/7oBA;EAEI,gBAAA;EACA,OAAA;EACA,UAAA;AjGk8oBJ;;AiG/7oBA;EAEI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AjGk8oBJ;;AiG/7oBA;EAEI,gBAAA;EACA,WAAA;EACA,UAAA;AjGk8oBJ;;AiG/7oBA;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AjGk8oBJ;;AiG/7oBA;EACI,sBAAA;AjGk8oBJ;;AiG/7oBA;EACI,gBAAA;EACA,aAAA;AjGk8oBJ;;AiG/7oBA;EACI,yBAAA;EACA,WAAA;AjGk8oBJ;;AiG/7oBA;EACI,gBAAA;EACA,MAAA;EACA,gBAAA;AjGk8oBJ;;AiG/7oBA;EACI;IACI,SAAA;IACA,gBAAA;IACA,kBAAA;IACA,kDAAA;IACA,kBAAA;IACA,UAAA;IACA,qCAAA;IACA,gCAAA;IACA,mDAAA;IACA,4BAAA;EjGk8oBN;AACF;AiG/7oBA;EACI,wBAAA;EACA,wDAAA;EACA,wBAAA;AjGi8oBJ;;AiG97oBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AjGi8oBJ;;AiG97oBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AjGi8oBJ;;AiG97oBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AjGi8oBJ;;AiG/7oBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AjGk8oBJ;;AiG/7oBA;EACI,yBAAA;AjGk8oBJ;;AiG/7oBA;EACI,8BAAA;AjGk8oBJ;;AiG/7oBA;EACI,+BAAA;EACA,mBAAA;AjGk8oBJ;;AiGh8oBA;EACI,yBAAA;AjGm8oBJ;;AiGh8oBA;EACI,cAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;AjGm8oBJ;;AiGh8oBA;EACI,cAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;AjGm8oBJ;;AiGh8oBA;EACI,cAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;AjGm8oBJ;;AiGh8oBA;EACI,qBAAA;AjGm8oBJ;;AiGj8oBA;EACI,yBAAA;AjGo8oBJ;;AiGj8oBA;EACI,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;EACA,qBAAA;AjGo8oBJ;AiGl8oBI;EACI,sBAAA;EACA,eAAA;EACA,kBAAA;AjGo8oBR;;AiGh8oBA;EACI,WAAA;EACA,yBAAA;AjGm8oBJ;AiG/7oBQ;;EACI,mBAAA;EACA,kBAAA;AjGk8oBZ;AiG97oBI;;EAEI,iBAAA;EACA,sBAAA;EACA,sBAAA;AjGg8oBR;AiG77oBI;EACI,mCAAA;AjG+7oBR;AiG57oBI;EACI,yBAAA;AjG87oBR;AiG37oBI;EACI,yBAAA;AjG67oBR;;AiGx7oBI;;EAEI,8BAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;AjG27oBR;;AiGv7oBA;EACI,mCAAA;AjG07oBJ;;AiGv7oBA;EAEI,6DAAA;AjG07oBJ;;AiGv7oBA;EACI,qCAAA;EACA,YAAA;EACA,oBAAA;AjG07oBJ;;AiGv7oBA;EACI,yDAAA;EACA,YAAA;EACA,oBAAA;AjG07oBJ;;AiGv7oBA;EACI,iBAAA;EACA,yCAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;AjG07oBJ;;AiGv7oBA;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;AjG07oBJ;;AiGr7oBA;EACI,yBAAA;EACA,aAAA;AjGw7oBJ;;AiGr7oBA;EACI,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AjGw7oBJ;;AiGr7oBA;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AjGw7oBJ;;AiGr7oBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AjGw7oBJ;;AiGr7oBA;EACI,kBAAA;EACA,QAAA;AjGw7oBJ;;AiGr7oBA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AjGu7oBJ;;AiGp7oBA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EAEA,cAAA;AjGs7oBJ;;AiGn7oBA;EACI,YAAA;EACA,aAAA;EACA,mDAAA;EACA,kBAAA;AjGs7oBJ;;AiGn7oBA;EACI,uBAAA;AjGs7oBJ;;AiGn7oBA;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AjGs7oBJ;;AiGn7oBA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AjGs7oBJ;;AiGn7oBA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AjGs7oBJ;;AiGn7oBA;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AjGs7oBJ;;AiGn7oBA;EACI,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AjGs7oBJ;;AiGn7oBA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EAEA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AjGq7oBJ;AiGh7oBgB;EACI,gBAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;AjGk7oBpB;AiG56oBgB;EACI,mBAAA;AjG86oBpB;AiG56oBgB;EACI,kBAAA;AjG86oBpB;;AiGv6oBA;;EAEI,YAAA;EACA,YAAA;EACA,gCAAA;EACA,6BAAA;AjG06oBJ;;AiGv6oBA;EACI,kCAAA;AjG06oBJ;;AiGv6oBA;EACI,4BAAA;AjG06oBJ;;AiGv6oBA;EAEI,eAAA;EACA,eAAA;AjGy6oBJ;;AiGt6oBA;EACI,YAAA;EACA,mCAAA;AjGy6oBJ;;AiGr6oBI;EACI,8BAAA;AjGw6oBR;;AiGp6oBA;EACI,cAAA;AjGu6oBJ;;AiGr6oBA;EACI,cAAA;AjGw6oBJ;;AiGt6oBA;EACI,cAAA;AjGy6oBJ;;AiGv6oBA;EACI,cAAA;AjG06oBJ;;AiGx6oBA;EACI,cAAA;AjG26oBJ;;AiGz6oBA;EACI,cAAA;AjG46oBJ;;AiGz6oBA;EACI,cAAA;AjG46oBJ;;AiGz6oBA;EACI,cAAA;AjG46oBJ;;AiGz6oBA;EACI,cAAA;AjG46oBJ;;AiGz6oBA;EACI,cAAA;AjG46oBJ;;AiGz6oBA;EACI,UAAA;AjG46oBJ;;AiGz6oBA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AjG46oBJ;;AiGz6oBA;EACI,2BAAA;AjG46oBJ;;AiGz6oBA,iEAAA;AACA;EACI,oCAAA;AjG46oBJ;;AiGz6oBA;EACI,oCAAA;AjG46oBJ;;AiGz6oBA;EACI,uBAAA;AjG46oBJ;;AiGz6oBA;EACI,uBAAA;AjG46oBJ;;AiGz6oBA;EACI,uBAAA;AjG46oBJ;;AiGz6oBA,eAAA;AAEA;EACI;IACI,cAAA;IACA,WAAA;EjG26oBN;EiGz6oBE;IACI,gCAAA;IACA,cAAA;IACA,iBAAA;IACA,eAAA;IACA,YAAA;IACA,iBAAA;EjG26oBN;EiGz6oBE;;;IAGI,cAAA;EjG26oBN;EiGz6oBE;IACI,mBAAA;EjG26oBN;EiGz6oBE;IACI,WAAA;EjG26oBN;EiGz6oBE;IACI,WAAA;IACA,kBAAA;IACA,gBAAA;EjG26oBN;EiGz6oBE;;IAEI,qCAAA;IACA,YAAA;IACA,sBAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;IACA,uBAAA;EjG26oBN;EiGz6oBE;IACI,gBAAA;IACA,gCAAA;EjG26oBN;EiGz6oBE;IACI,mBAAA;EjG26oBN;EiGz6oBE;IACI,gBAAA;EjG26oBN;EiGz6oBE;IACI,uBAAA;EjG26oBN;EiGz6oBE;IACI,mBAAA;IACA,gCAAA;EjG26oBN;EiGz6oBE;IACI,gCAAA;EjG26oBN;EiGz6oBE;IACI,cAAA;IACA,kBAAA;EjG26oBN;AACF;AiGx6oBA;EACI,aAAA;AjG06oBJ;;AiGv6oBA;EACI,kBAAA;AjG06oBJ;;AiGv6oBA;EACI,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AjG06oBJ;;AiGv6oBA;EACI,eAAA;AjG06oBJ;AiGx6oBI;;EAEI,YAAA;EACA,aAAA;AjG06oBR;AiGv6oBI;EACI,uBAAA;AjGy6oBR;AiGt6oBI;EACI,4CAAA;AjGw6oBR;AiGt6oBI;EACI,uBAAA;AjGw6oBR;;AiGp6oBA;EACI,eAAA;AjGu6oBJ;AiGr6oBI;;EAEI,YAAA;EACA,aAAA;AjGu6oBR;AiGp6oBI;EACI,uBAAA;AjGs6oBR;AiGn6oBI;EACI,uBAAA;AjGq6oBR;AiGn6oBI;EACI,4CAAA;AjGq6oBR;;AiGj6oBA;EACI,eAAA;AjGo6oBJ;AiGl6oBI;;EAEI,YAAA;EACA,aAAA;AjGo6oBR;AiGj6oBI;EACI,uBAAA;AjGm6oBR;AiGh6oBI;EACI,gCAAA;AjGk6oBR;;AiG95oBA;EACI,eAAA;EACA,uBAAA;AjGi6oBJ;AiG/5oBI;;EAEI,YAAA;EACA,aAAA;AjGi6oBR;AiG95oBI;EACI,mBAAA;AjGg6oBR;AiG75oBI;EACI,6BAAA;AjG+5oBR;AiG55oBI;EACI,mBAAA;AjG85oBR;;AiGz5oBI;;EAEI,gBAAA;AjG45oBR;;AiGx5oBA;EACI,0BAAA;EACA,yBAAA;AjG25oBJ;AiGz5oBI;EACI,mBAAA;AjG25oBR;AiGx5oBI;;EAEI,sBAAA;EACA,kBAAA;AjG05oBR;;AiGt5oBA;EACI,iCAAA;EAAA,4BAAA;AjGy5oBJ;;AiGr5oBI;EACI,2BAAA;AjGw5oBR;AiGt5oBI;EACI,4BAAA;AjGw5oBR;AiGt5oBI;EACI,8BAAA;AjGw5oBR;AiGt5oBI;EACI,+BAAA;AjGw5oBR;AiGr5oBI;EACI,YAAA;AjGu5oBR;AiGp5oBI;EACI,eAAA;AjGs5oBR;AiGn5oBI;;EAEI,gBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,sBAAA;EAEA,iBAAA;AjGm5oBR;AiG/4oBQ;EACI,yBAAA;AjGi5oBZ;AiG94oBQ;EACI,yBAAA;AjGg5oBZ;;AiG34oBA;EACI,yBAAA;AjG84oBJ;AiG54oBI;EACI,yBAAA;EACA,YAAA;EACA,mBAAA;AjG84oBR;AiG34oBI;;EAEI,sBAAA;EACA,kBAAA;AjG64oBR;AiG14oBI;EACI,iBAAA;EACA,yBAAA;AjG44oBR;AiGv4oBY;EACI,YAAA;AjGy4oBhB;AiGp4oBY;EACI,aAAA;AjGs4oBhB;AiGl4oBQ;EACI,yBAAA;AjGo4oBZ;;AiG/3oBA;EACI,eAAA;AjGk4oBJ;AiGj4oBI;EACI,WAAA;AjGm4oBR;AiGh4oBI;;EAEI,yBAAA;EACA,aAAA;AjGk4oBR;AiG93oBQ;EACI,yBAAA;EACA,kBAAA;AjGg4oBZ;AiG33oBQ;EACI,yBAAA;AjG63oBZ;AiGz3oBI;EACI,yBAAA;AjG23oBR;AiGz3oBI;EACI,uBAAA;AjG23oBR;AiGx3oBI;EACI,yBAAA;AjG03oBR;AiGv3oBI;EACI,uBAAA;AjGy3oBR;AiGt3oBI;EACI,gBAAA;EACA,MAAA;AjGw3oBR;AiGt3oBQ;EACI,YAAA;EACA,4BAAA;EACA,sBAAA;AjGw3oBZ;AiGp3oBI;EACI,6BAAA;AjGs3oBR;;AiGl3oBA;EACI,kBAAA;AjGq3oBJ;AiGn3oBI;;EAEI,yBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AjGq3oBR;AiGl3oBI;EACI,YAAA;AjGo3oBR;;AiGh3oBA;EACI,eAAA;AjGm3oBJ;AiG/2oBY;EACI,8BAAA;EACA,gCAAA;AjGi3oBhB;AiG72oBY;EACI,2BAAA;AjG+2oBhB;AiG72oBoB;EACI,mBAAA;AjG+2oBxB;AiGp2oBoB;EACI,2BAAA;EACA,8BAAA;AjGs2oBxB;AiGp2oBoB;EACI,4BAAA;EACA,+BAAA;AjGs2oBxB;AiG/1oBI;;EAEI,YAAA;EACA,aAAA;AjGi2oBR;AiG91oBI;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;AjGg2oBR;AiG71oBI;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;AjG+1oBR;AiG51oBI;EACI,8BAAA;AjG81oBR;AiGx1oBgB;EACI,mBAAA;AjG01oBpB;;AiGh1oBY;EACI,mBAAA;AjGm1oBhB;AiG70oBY;EACI,mBAAA;AjG+0oBhB;;AiGx0oBA;EACI,iBAAA;EACA,yBAAA;AjG20oBJ;AiGz0oBI;;EAEI,YAAA;EACA,aAAA;AjG20oBR;AiGx0oBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AjG00oBR;AiGv0oBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjGy0oBR;AiGp0oBQ;EACI,wBAAA;AjGs0oBZ;AiGr0oBY;EACI,kCAAA;EACA,qCAAA;AjGu0oBhB;AiGt0oBgB;EACI,2BAAA;EACA,8BAAA;EACA,mCAAA;AjGw0oBpB;AiGt0oBgB;EACI,4BAAA;EACA,+BAAA;EACA,oCAAA;AjGw0oBpB;AiG7zoBgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AjG+zoBpB;AiG7zoBgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AjG+zoBpB;AiG7zoBgB;EACI,uBAAA;AjG+zoBpB;AiG3zoBgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,yBAAA;AjG6zoBpB;AiG3zoBgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AjG6zoBpB;AiGxzoBoB;EACI,8BAAA;AjG0zoBxB;AiGjzoBQ;EACI,wBAAA;AjGmzoBZ;AiGlzoBY;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;AjGozoBhB;;AiG7yoBA;EACI,iBAAA;EACA,yBAAA;AjGgzoBJ;AiG9yoBI;;EAEI,YAAA;EACA,aAAA;AjGgzoBR;AiG7yoBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AjG+yoBR;AiG5yoBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjG8yoBR;AiGzyoBQ;EACI,wBAAA;AjG2yoBZ;AiGxyoBY;EACI,kCAAA;AjG0yoBhB;AiGzyoBgB;EACI,2BAAA;EACA,mCAAA;AjG2yoBpB;AiGzyoBgB;EACI,4BAAA;EACA,oCAAA;AjG2yoBpB;AiGtyoBY;EACI,qCAAA;AjGwyoBhB;AiGvyoBgB;EACI,8BAAA;EACA,mCAAA;AjGyyoBpB;AiGvyoBgB;EACI,+BAAA;EACA,oCAAA;AjGyyoBpB;AiG/xoBgB;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,uBAAA;EACA,6BAAA;AjGiyoBpB;AiG/xoBgB;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,yBAAA;EACA,+BAAA;AjGiyoBpB;AiGzxoBQ;EACI,wBAAA;AjG2xoBZ;AiG1xoBY;EACI,mBAAA;EACA,qCAAA;AjG4xoBhB;;AiGpxoBI;;EAEI,YAAA;EACA,iBAAA;AjGuxoBR;AiGpxoBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qCAAA;AjGsxoBR;AiGnxoBI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AjGqxoBR;;AiGhxoBA;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;AjGmxoBJ;AiG/woBQ;EACI,wBAAA;AjGixoBZ;AiGhxoBY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;AjGkxoBhB;AiGjxoBgB;EACI,0BAAA;EACA,mCAAA;AjGmxoBpB;AiGjxoBgB;EACI,0BAAA;EACA,oCAAA;AjGmxoBpB;AiG1woBY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjG4woBhB;;AiGrwoBA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AjGwwoBJ;AiGtwoBI;;EAEI,YAAA;AjGwwoBR;AiGnwoBQ;EACI,wBAAA;AjGqwoBZ;AiGpwoBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,qCAAA;AjGswoBhB;AiGrwoBgB;EACI,0BAAA;EACA,mCAAA;AjGuwoBpB;AiGrwoBgB;EACI,0BAAA;EACA,oCAAA;AjGuwoBpB;AiG9voBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjGgwoBhB;;AiGzvoBA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AjG4voBJ;AiG1voBI;;EAEI,YAAA;AjG4voBR;AiGvvoBQ;EACI,wBAAA;AjGyvoBZ;AiGxvoBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,qCAAA;AjG0voBhB;AiGzvoBgB;EACI,0BAAA;EACA,mCAAA;AjG2voBpB;AiGzvoBgB;EACI,0BAAA;EACA,oCAAA;AjG2voBpB;AiGlvoBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjGovoBhB;AiGjvoBgB;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AjGmvoBpB;AiGlvoBoB;EACI,YAAA;EACA,gBAAA;EACA,2DAAA;AjGovoBxB;;AiG3uoBA;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;AjG8uoBJ;AiG5uoBI;;EAEI,YAAA;AjG8uoBR;AiGxuoBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;AjG0uoBhB;AiGzuoBgB;EACI,0BAAA;EACA,mCAAA;AjG2uoBpB;AiGzuoBgB;EACI,0BAAA;EACA,oCAAA;AjG2uoBpB;AiGluoBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjGouoBhB;AiGluoBoB;EACI,8BAAA;AjGouoBxB;AiG1toBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qCAAA;AjG4toBhB;;AiGrtoBA;EACI,WAAA;AjGwtoBJ;AiGttoBI;;EAEI,YAAA;AjGwtoBR;AiGntoBQ;EACI,wBAAA;AjGqtoBZ;AiGptoBY;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;AjGstoBhB;AiG9soBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjGgtoBhB;AiGvsoBgB;EACI,yBAAA;AjGysoBpB;;AiGjsoBA;EACI,eAAA;EACA,uBAAA;AjGosoBJ;AiGlsoBI;;EAEI,YAAA;EACA,sBAAA;AjGosoBR;AiGjsoBI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AjGmsoBR;AiGhsoBI;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;AjGksoBR;AiG5roBQ;EACI,gFAAA;AjG8roBZ;AiGzroBY;EACI,gBAAA;AjG2roBhB;AiG1roBgB;EACI,mBAAA;AjG4roBpB;AiG3roBoB;EACI,SAAA;EACA,UAAA;AjG6roBxB;AiGzroBoB;EACI,aAAA;AjG2roBxB;AiGzroBoB;EACI,mBAAA;AjG2roBxB;AiGproBQ;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kDAAA;AjGsroBZ;AiGrroBY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gCAAA;AjGuroBhB;AiGtroBgB;EACI,gBAAA;EACA,mBAAA;EACA,wBAAA;AjGwroBpB;AiGlroBQ;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;AjGoroBZ;AiGnroBY;EACI,YAAA;EACA,YAAA;AjGqroBhB;;AiG9qoBA;EACI,mBAAA;EACA,yBAAA;AjGiroBJ;AiG/qoBI;;EAEI,mBAAA;EACA,8BAAA;AjGiroBR;AiG9qoBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AjGgroBR;AiG7qoBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjG+qoBR;AiG1qoBQ;EACI,wBAAA;AjG4qoBZ;AiG3qoBY;EACI,gBAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;AjG6qoBhB;AiGxqoBgB;EACI,mBAAA;EACA,2BAAA;AjG0qoBpB;AiGxqoBgB;EACI,4BAAA;AjG0qoBpB;AiGvqoBoB;EACI,aAAA;AjGyqoBxB;AiGrqoBY;EACI,kBAAA;AjGuqoBhB;AiGtqoBgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AjGwqoBpB;AiGlqoBgB;EACI,gBAAA;EACA,8BAAA;AjGoqoBpB;AiGlqoBgB;EACI,+BAAA;AjGoqoBpB;AiGjqoBoB;EACI,aAAA;AjGmqoBxB;AiG/poBY;EACI,kBAAA;AjGiqoBhB;AiGhqoBgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AjGkqoBpB;AiGzpoBY;EACI,gBAAA;AjG2poBhB;AiG1poBgB;EACI,iBAAA;AjG4poBpB;AiG1poBgB;EACI,kBAAA;AjG4poBpB;AiGzpoBoB;EACI,aAAA;AjG2poBxB;AiGvpoBY;EACI,gBAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;AjGypoBhB;AiGppoBY;EACI,kBAAA;AjGspoBhB;AiGrpoBgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AjGupoBpB;AiG/ooBQ;EACI,wBAAA;AjGipoBZ;AiGhpoBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AjGkpoBhB;AiGjpoBgB;EACI,iBAAA;AjGmpoBpB;AiGjpoBgB;EACI,kBAAA;AjGmpoBpB;AiGhpoBoB;EACI,aAAA;AjGkpoBxB;AiG9ooBY;EACI,gBAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;AjGgpoBhB;AiG9ooBY;EACI,kBAAA;AjGgpoBhB;AiG/ooBgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AjGipoBpB;;AiGzooBA;EACI,iBAAA;EACA,yBAAA;AjG4ooBJ;AiG1ooBI;;EAEI,YAAA;AjG4ooBR;AiGzooBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AjG2ooBR;AiGxooBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AjG0ooBR;AiGrooBQ;EACI,wBAAA;AjGuooBZ;AiGtooBY;EACI,kCAAA;EACA,qCAAA;AjGwooBhB;AiGvooBgB;EACI,2BAAA;EACA,8BAAA;EACA,mCAAA;AjGyooBpB;AiGvooBgB;EACI,4BAAA;EACA,+BAAA;EACA,oCAAA;AjGyooBpB;AiG/noBgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;AjGiooBpB;AiG/noBgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;AjGiooBpB;AiG9noBY;EACI,uBAAA;EAAA,kBAAA;AjGgooBhB;AiG/noBgB;EACI,uBAAA;EAAA,kBAAA;AjGiooBpB;AiGhooBoB;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;AjGkooBxB;AiG7noBgB;EACI,WAAA;AjG+noBpB;AiG9noBoB;EACI,uBAAA;AjGgooBxB;AiG9noB4B;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AjGgooBhC;AiG3noBgC;EACI,WAAA;EACA,YAAA;AjG6noBpC;AiG5noBoC;EACI,mBAAA;AjG8noBxC;;AiGlnoBA;EACI,8BAAA;AjGqnoBJ;;AiGlnoBA;EACI,2BAAA;AjGqnoBJ;;AiGjnoBI;;EAEI,gBAAA;EACA,OAAA;EACA,UAAA;AjGonoBR;AiGjnoBI;EACI,uBAAA;AjGmnoBR;;AkG5gsBA;;;;;;;;;;;;EAYI,cAAA;EACA,yC1FykBqB;E0FxkBrB,c1FMO;E0FLP,gBAAA;AlG+gsBJ;;AkG5gsBA;EACI,gBAAA;AlG+gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG3gsBA;EACI,0BAAA;AlG8gsBJ;;AkG1gsBA;EACI,4CAAA;EACA,mBAAA;AlG6gsBJ;;AkG1gsBA;EACI,cAAA;AlG6gsBJ;;AkGrgsBA;EACI,2BAAA;AlGwgsBJ;;AkGtgsBA;EACI,gB1F5FiB;ARqmsBrB;;AkGtgsBA;EACI,gB1F/FmB;ARwmsBvB;;AkGtgsBA;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;EAAA,kBAAA;AlGygsBJ;AkGvgsBI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mB1F7FG;E0F8FH,WAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AlGygsBR;AkGpgsBY;EACI,8BAAA;AlGsgsBhB;AkGvgsBY;EACI,8BAAA;AlGygsBhB;AkG1gsBY;EACI,8BAAA;AlG4gsBhB;AkG7gsBY;EACI,8BAAA;AlG+gsBhB;AkGhhsBY;EACI,8BAAA;AlGkhsBhB;AkGnhsBY;EACI,8BAAA;AlGqhsBhB;AkGthsBY;EACI,4BAAA;AlGwhsBhB;AkGzhsBY;EACI,8BAAA;AlG2hsBhB;AkG5hsBY;EACI,8BAAA;AlG8hsBhB;AkG/hsBY;EACI,8BAAA;AlGiisBhB;AkGlisBY;EACI,4BAAA;AlGoisBhB;;AmGvpsBA;EACI,eAAA;AnG0psBJ;;AmGvpsBA;EACI,eAAA;AnG0psBJ;;AmGvpsBA;EACI,gBAAA;AnG0psBJ;;AmGvpsBA;EACI,gBAAA;AnG0psBJ;;AmGvpsBA;EACI,gBAAA;AnG0psBJ;;AmGrpsBA;;;;EAII,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;AnGwpsBJ;;AmGrpsBA;EACI,qBAAA;AnGwpsBJ;;AmGrpsBA;EACI,qBAAA;AnGwpsBJ;;AmGrpsBA;EACI,qBAAA;AnGwpsBJ;;AmGrpsBA;EACI,qBAAA;AnGwpsBJ;;AmGppsBA;EACI,oBAAA;EACA,qBAAA;AnGupsBJ;;AmGnpsBA;EACI,sB3F+ee;ARuqrBnB;;AmGppsBA;EACI,qB3F6ee;AR0qrBnB;;AmGppsBA;EACI,eAAA;AnGupsBJ;;AmGppsBA;EACI,eAAA;AnGupsBJ;;AoG1tsBQ;EACI,YAAA;EACA,c5FYD;E4FXC,gBAAA;EACA,cAAA;ApG6tsBZ;AoGxtsBQ;EACI,WAAA;ApG0tsBZ;;AqGpusBA;EACI,kBAAA;EACA,gBAAA;ArGuusBJ;AqGrusBI;EACI,eAAA;ArGuusBR;;AqGnusBA,gBAAA;AAEA;EACI,gBAAA;EACA,aAAA;EACA,cAAA;ArGqusBJ;AqGnusBI;EACI,mBAAA;ArGqusBR;AqGlusBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;ArGousBR;AqGlusBQ;EACI,mBAAA;EACA,WAAA;ArGousBZ;AqGjusBQ;EACI,eAAA;EACA,kBAAA;ArGmusBZ;AqG/tsBI;EACI,mBAAA;EACA,c7FED;E6FDC,uB7F+fQ;E6F9fR,qBAAA;EACA,iBAAA;EACA,kBAAA;ArGiusBR;AqG/tsBQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gB7FnDW;E6FoDX,kBAAA;ArGiusBZ;AqG9tsBQ;EACI,SAAA;EACA,gBAAA;ArGgusBZ;AqG7tsBQ;EACI,UAAA;EACA,MAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;ArG+tsBZ;AqG3tsBI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;ArG6tsBR;AqGztsBQ;EACI,uBAAA;ArG2tsBZ;AqGxtsBQ;EACI,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;ArG0tsBZ;AqGvtsBQ;EACI,yB7FhFD;E6FiFC,c7F7ED;ARsysBX;AqGxtsBY;EACI,yBAAA;EACA,0B7FpFL;E6FqFK,yB7FrFL;E6FsFK,oBAAA;ArG0tsBhB;;AqGptsBA,oBAAA;AACA;EACI,kBAAA;ArGutsBJ;AqGrtsBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;ArGutsBR;AqGptsBI;EACI,iBAAA;ArGstsBR;AqGntsBI;EACI,mBAAA;ArGqtsBR;;AqGhtsBI;EACI,gBAAA;EACA,oCAAA;ArGmtsBR;;AsGp1sBI;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AtGu1sBR;AsGt1sBQ;EACI,yB9FOD;E8FNC,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,wBAAA;EACA,QAAA;AtGw1sBZ;AsGt1sBQ;EACI,c9FJD;E8FKC,qBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AtGw1sBZ;AsGr1sBI;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AtGu1sBR;AsGt1sBQ;EACI,aAAA;AtGw1sBZ;AsGp1sBQ;EACI,oBAAA;EACA,aAAA;AtGs1sBZ;AsGl1sBQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EAIA,wBAAA;AtGo1sBZ;AsGh1sBQ;EACI,yB9F1DD;E8F2DC,mBAAA;AtGk1sBZ;;AsG30sBQ;EACI,kBAAA;AtG80sBZ;;AsGz0sBA;EACI,aAAA;AtG40sBJ;;AsGx0sBI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AtG20sBR;AsGz0sBI;EACI,YAAA;EACA,WAAA;AtG20sBR;AsG10sBQ;EACI,cAAA;AtG40sBZ;AsG10sBQ;EACI,cAAA;AtG40sBZ;;AsGp0sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;ARk2sBf;AsGr0sBY;EACI,kB9FvGR;AR86sBR;;AsG50sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;AR02sBf;AsG70sBY;EACI,kB9FvGR;ARs7sBR;;AsGp1sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;ARk3sBf;AsGr1sBY;EACI,kB9FvGR;AR87sBR;;AsG51sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;AR03sBf;AsG71sBY;EACI,kB9FvGR;ARs8sBR;;AsGp2sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;ARk4sBf;AsGr2sBY;EACI,kB9FvGR;AR88sBR;;AsG52sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;AR04sBf;AsG72sBY;EACI,kB9FvGR;ARs9sBR;;AsGp3sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;ARk5sBf;AsGr3sBY;EACI,kB9FvGR;AR89sBR;;AsG53sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;AR05sBf;AsG73sBY;EACI,kB9FvGR;ARs+sBR;;AsGp4sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;ARk6sBf;AsGr4sBY;EACI,kB9FvGR;AR8+sBR;;AsG54sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;AR06sBf;AsG74sBY;EACI,kB9FvGR;ARs/sBR;;AsGp5sBY;EACI,yB9F1BD;E8F2BC,qB9F3BD;ARk7sBf;AsGr5sBY;EACI,kB9FvGR;AR8/sBR;;AsGj5sBA;;EAEI,eAAA;AtGo5sBJ;;AuG9gtBI;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AvGihtBR;AuGhhtBQ;EACI,sCAAA;EACA,2CAAA;EACA,sB/FEJ;E+FDI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,WAAA;EACA,wBAAA;AvGkhtBZ;AuGhhtBQ;EACI,wEAAA;EACA,0BAAA;EACA,yBAAA;EACA,oEAAA;EACA,8BAAA;EACA,8EAAA;EACA,yB/FXD;E+FYC,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,8DAAA;EACA,WAAA;AvGkhtBZ;AuG/gtBI;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AvGihtBR;AuGhhtBQ;EACI,aAAA;AvGkhtBZ;AuG9gtBQ;EACI,oBAAA;EACA,0CAAA;EACA,oBAAA;AvGghtBZ;AuG5gtBQ;EAII,sBAAA;AvG8gtBZ;AuG1gtBQ;EACI,mBAAA;AvG4gtBZ;;AuGvgtBA;EACI,aAAA;AvG0gtBJ;;AuGtgtBI;EACI,YAAA;AvGygtBR;;AuGjgtBY;EACI,yB/FLD;ARygtBf;AuGhgtBY;EACI,qB/FVD;AR4gtBf;AuGhgtBY;EACI,yB/FbD;AR+gtBf;;AuG3gtBY;EACI,yB/FLD;ARmhtBf;AuG1gtBY;EACI,qB/FVD;ARshtBf;AuG1gtBY;EACI,yB/FbD;ARyhtBf;;AuGrhtBY;EACI,yB/FLD;AR6htBf;AuGphtBY;EACI,qB/FVD;ARgitBf;AuGphtBY;EACI,yB/FbD;ARmitBf;;AuG/htBY;EACI,yB/FLD;ARuitBf;AuG9htBY;EACI,qB/FVD;AR0itBf;AuG9htBY;EACI,yB/FbD;AR6itBf;;AuGzitBY;EACI,yB/FLD;ARijtBf;AuGxitBY;EACI,qB/FVD;ARojtBf;AuGxitBY;EACI,yB/FbD;ARujtBf;;AuGnjtBY;EACI,yB/FLD;AR2jtBf;AuGljtBY;EACI,qB/FVD;AR8jtBf;AuGljtBY;EACI,yB/FbD;ARiktBf;;AuG7jtBY;EACI,yB/FLD;ARqktBf;AuG5jtBY;EACI,qB/FVD;ARwktBf;AuG5jtBY;EACI,yB/FbD;AR2ktBf;;AuGvktBY;EACI,yB/FLD;AR+ktBf;AuGtktBY;EACI,qB/FVD;ARkltBf;AuGtktBY;EACI,yB/FbD;ARqltBf;;AuGjltBY;EACI,yB/FLD;ARyltBf;AuGhltBY;EACI,qB/FVD;AR4ltBf;AuGhltBY;EACI,yB/FbD;AR+ltBf;;AuG3ltBY;EACI,yB/FLD;ARmmtBf;AuG1ltBY;EACI,qB/FVD;ARsmtBf;AuG1ltBY;EACI,yB/FbD;ARymtBf;;AuGrmtBY;EACI,yB/FLD;AR6mtBf;AuGpmtBY;EACI,qB/FVD;ARgntBf;AuGpmtBY;EACI,yB/FbD;ARmntBf;;AwGvstBA;EACI;;;;;IAKI,aAAA;ExG0stBN;EwGxstBE;;;;;IAKI,UAAA;IACA,SAAA;ExG0stBN;AACF;AyG1ttBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBjGMI;EiGLJ,aAAA;AzG4ttBJ;;AyGzttBA;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;AzG4ttBJ;;AyGxttBI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBjGXA;EiGYA,yBAAA;EACA,kBAAA;EACA,qDAAA;EACA,eAAA;AzG2ttBR;AyGzttBI;EACI,uBAAA;AzG2ttBR;AyGzttBI;EACI,uBAAA;AzG2ttBR;AyGzttBI;EACI,uBAAA;AzG2ttBR;;AyGvttBA;EACI;IAGI,qBAAA;EzGwttBN;EyGtttBE;IACI,mBAAA;EzGwttBN;AACF;A0G3wtBI;EACI,aAAA;A1G6wtBR;A0G1wtBI;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;A1G4wtBR;A0G3wtBQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;A1G6wtBZ;;A2G5xtBA;EACI,gBAAA;EACA,oCAAA;A3G+xtBJ;A2G1xtBY;EACI,WAAA;A3G4xtBhB;A2G3xtBgB;EACI,WAAA;EACA,mBAAA;A3G6xtBpB;A2GtxtBI;EACI,kBAAA;A3GwxtBR;A2GvxtBQ;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;A3GyxtBZ;A2GxxtBY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;A3G0xtBhB;A2GxxtBY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;A3G0xtBhB;A2GvxtBQ;EAEI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,UAAA;A3GyxtBZ;A2GxxtBY;EACI,OAAA;EACA,UAAA;A3G0xtBhB;A2GxxtBY;EACI,QAAA;EACA,UAAA;A3G0xtBhB;A2GxxtBY;EACI,oBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8BAAA;A3G0xtBhB;A2GxxtBY;EACI,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8BAAA;A3G0xtBhB;A2GrxtBI;EACI,YAAA;A3GuxtBR;A2GpxtBI;EACI,YAAA;A3GsxtBR;A2GnxtBI;EACI,YAAA;A3GqxtBR;A2GlxtBC;EACC,gBAAA;EACG,iBAAA;EACA,yBAAA;EACA,oCAAA;A3GoxtBL;;A2GhxtBA,iBAAA;AACA;EAKoB;IACI,sBAAA;E3G+wtBtB;AACF;A2GtwtBA,kBAAA;AAIA,iBAAA;AACA;EACI;IACI,sBAAA;E3GqwtBN;AACF;A2GlwtBA,iBAAA;AAIA,kBAAA;AAIA,iBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;ACvKA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;A5Gi5tBJ;A4Gh5tBI;EACI,mBAAA;A5Gk5tBR;A4Gh5tBI;EACI,8BAAA;A5Gk5tBR;A4Gh5tBI;EACI,YAAA;EACA,YAAA;A5Gk5tBR;;A4G74tBA;EACI,wBAAA;A5Gg5tBJ;A4G/4tBI;EACI,gBAAA;A5Gi5tBR;A4G/4tBI;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;A5Gi5tBR;A4Gh5tBQ;EACI,wBAAA;EACA,0BAAA;A5Gk5tBZ;A4Gj5tBY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;A5Gm5tBhB;;A4G54tBA;EACI,kBAAA;EACA,WAAA;A5G+4tBJ;A4G94tBI;EACI,WAAA;EACA,eAAA;EAGA,gBAAA;A5Gg5tBR;A4G/4tBQ;EACI,UAAA;EACA,aAAA;A5Gi5tBZ;A4G/4tBQ;EACI,aAAA;A5Gi5tBZ;A4G/4tBQ;EACI,aAAA;A5Gi5tBZ;A4G94tBI;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,qEAAA;EACA,wBAAA;A5Gg5tBR;;A4G34tBA;EACI,aAAA;EAEA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,+FAAA;A5G84tBJ;A4G74tBI;EACI,WAAA;EACA,uBAAA;A5G+4tBR;A4G74tBI;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8BAAA;EACA,uCAAA;A5G+4tBR;A4G74tBI;EACI,WAAA;EACA,wBAAA;A5G+4tBR;A4G74tBI;EACI,WAAA;EACA,wBAAA;A5G+4tBR;A4G74tBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8BAAA;A5G+4tBR;;A4G14tBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;A5G64tBJ;A4G54tBI;EACI,wCAAA;A5G84tBR;A4G54tBI;EACI,8BAAA;A5G84tBR;A4G54tBY;EACI,oCAAA;A5G84tBhB;A4G54tBY;EACI,mCAAA;A5G84tBhB;A4G14tBI;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,wBAAA;A5G44tBR;A4G34tBQ;EACI,oCAAA;EACA,oCAAA;EACA,6CAAA;A5G64tBZ;A4G34tBQ;EACI,mCAAA;EACA,oCAAA;EACA,6CAAA;A5G64tBZ;A4G14tBI;EACI,SAAA;EACA,YAAA;A5G44tBR;A4G14tBI;EACI,WAAA;A5G44tBR;A4G34tBQ;EACI,YAAA;A5G64tBZ;;A6G3juBA,iBAAA;AACA;EAGY;IACI,WAAA;E7G4juBd;E6GxjuBU;IACI,OAAA;E7G0juBd;AACF;A6GrjuBA,kBAAA;AACA;EAGY;IACI,OAAA;E7GqjuBd;E6GjjuBU;IACI,OAAA;E7GmjuBd;AACF;A6G9iuBA,iBAAA;AACA;EAGY;IACI,OAAA;E7G8iuBd;E6G1iuBU;IACI,OAAA;E7G4iuBd;AACF;A6GviuBA,iBAAA;AACA;EAGY;IACI,OAAA;E7GuiuBd;AACF;A6GliuBA,kBAAA;AAIA,iBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;ACvFA;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2BAAA;A9GomuBJ;A8GlmuBI;EACI,cAAA;A9GomuBR;A8GjmuBI;;EAEI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;A9GmmuBR;A8GhmuBI;;EAEI,UAAA;EACA,QAAA;A9GkmuBR;A8G/luBI;EACI,ctGsBC;AR2kuBT;A8G9luBI;EACI,gCAAA;A9GgmuBR;A8G7luBI;EACI,ctGYF;ARmluBN;A8G5luBI;EACI,gCAAA;A9G8luBR;A8G3luBI;EACI,ctGMC;ARuluBT;A8G1luBI;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;A9G4luBR;A8GzluBI;EACI,aAAA;A9G2luBR;A8GvluBI;EACI,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;A9GyluBR;A8GrluBQ;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,mBtG1DD;EsG2DC,kBAAA;EACA,kBAAA;A9GuluBZ;A8GrluBY;EACI,cAAA;EACA,2BAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;A9GuluBhB;A8GpluBQ;;EAEI,mBtG5CN;ARkouBN;A8GpluBY;;EACI,kBtGjFR;ARwquBR;;A8GjluBA;EACI,eAAA;EACA,gBAAA;A9GoluBJ;A8GlluBI;EACI,gBAAA;EACA,YAAA;A9GoluBR;A8GlluBQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;A9GoluBZ;A8GhluBI;EACI,ctGpGG;ARsruBX;;A+G1suBA;;EAEI,WAAA;EACA,YAAA;EACA,4EAAA;EACA,SAAA;A/G6suBJ;;A+GzsuBI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,4EAAA;A/G4suBR;A+GzsuBI;EAEI,YAAA;A/G0suBR;;A+GtsuBA;EACI,UAAA;A/GysuBJ;;A+GtsuBA;EACI,WAAA;A/GysuBJ;A+GvsuBI;EACI,4EAAA;A/GysuBR;;A+GrsuBA;;EAEI,UAAA;EACA,2BAAA;EACA,6BAAA;A/GwsuBJ;;A+GrsuBA;EACI,UAAA;A/GwsuBJ;;A+GrsuBA;EACI,YAAA;A/GwsuBJ;;A+GrsuBA;;EAEI,UAAA;A/GwsuBJ;;AgHvvuBA;EACI,yCxGqlBqB;EwGplBrB,mCAAA;EACA,+CxG4iBS;EwG3iBT,sBxGQI;ARkvuBR;AgHxvuBI;EACI,sBAAA;EACA,sBxGIA;ARsvuBR;AgHxvuBQ;EACI,cxGOD;ARmvuBX;AgHrvuBY;;EACI,qBAAA;AhHwvuBhB;AgHlvuBQ;EACI,yBAAA;EACA,cxGND;AR0vuBX;AgHlvuBQ;EAII,sBxGnBJ;EwGoBI,cxGdD;EwGeC,YAAA;AhHivuBZ;AgH9uuBQ;EACI,yBxGKL;EwGJK,WxG1BJ;AR0wuBR;AgH5uuBI;;EAEI,yBxGFD;EwGGC,WxGjCA;AR+wuBR;AgH3uuBI;EACI,6BAAA;AhH6uuBR;AgH3uuBI;EACI,4CAAA;AhH6uuBR;AgHxuuBY;EACI,yBxGhBT;AR0vuBP;AgHxuuBY;EACI,yBxG/CL;ARyxuBX;AgHruuBI;EACI,yCAAA;AhHuuuBR;AgHnuuBQ;EAII,iBAAA;EACA,uBAAA;EACA,WxGjEJ;ARmyuBR;AgH7tuBQ;EACI,0CAAA;AhH+tuBZ;;AiHrzuBA;EACI,yCzGwlBqB;EH3TnB,oBALI;E4GtRN,gBzGqmBiB;EyGpmBjB,gBzG0mBe;EyGzmBf,czGiBO;ARuyuBX;AiHtzuBI;EACI,WAAA;EACA,iBAAA;EACA,WAAA;AjHwzuBR;;AiHnzuBI;EACI,uBAAA;AjHszuBR;AiHpzuBQ;EACI,sBAAA;AjHszuBZ;AiHpzuBY;EACI,eAAA;AjHszuBhB;;AiH/yuBA;EACI,kBAAA;EACA,gBzG7BmB;EyG8BnB,sBzGjBI;EyGkBJ,czGXO;EyGYP,kBzGnBI;EyGoBJ,4CAAA;AjHkzuBJ;AiHhzuBI;EACI,4CAAA;AjHkzuBR;AiH/yuBI;EACI,yBzGGD;EyGFC,qBzGED;EyGDC,WzG7BA;AR80uBR;AiH/yuBQ;EACI,yBzGFL;ARmzuBP;;AiH5yuBA;EACI,kBAAA,EAAA,wCAAA;EACA,iBAAA,EAAA,sCAAA;AjH+yuBJ;;AkHt2uBA;EACI,kBAAA;EACA,UAAA;AlHy2uBJ;;AkHt2uBA;EACI,kBAAA;EACA,iBAAA;EACA,qEAAA;EACA,iCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AlHy2uBJ;;AmHr3uBA;EACE,2BAAA;EACA,4DAAA;EAEA,gBAAA;EACA,kBAAA;AnHu3uBF;AmHp3uBA;EACE,6BAAA;AnHs3uBF;;AmHp3uBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AnHu3uBF;;AmHr3uBA;EACE,sBAAA;AnHw3uBF;;AmHt3uBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AnHy3uBF;;AmHv3uBA;;EAEE,iCAAA;AnH03uBF;;AmHx3uBA;EACE,mBAAA;AnH23uBF;AmH13uBE;EACE,mBAAA;AnH43uBJ;;AmHz3uBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;AnH43uBF;;AmH13uBA;EACE,kBAAA;AnH63uBF;;AmH33uBA,gBAAA;AAEE;;EAEE,YAAA;AnH63uBJ;AmH13uBE;EACE,uBAAA;EACA,sCAAA;AnH43uBJ;;AmHx3uBA,eAAA;AAEE;EAEE,mBAAA;AnHy3uBJ;AmHv3uBE;;;;;;;;EAQE,4BAAA;AnHy3uBJ;AmHv3uBE;;;;;EAKE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AnHy3uBJ;AmHv3uBE;EACE,+BAAA;AnHy3uBJ;AmHv3uBE;EACE,gFAAA;AnHy3uBJ;AmHv3uBE;EACE,iFAAA;AnHy3uBJ;AmHv3uBE;EACE,+EAAA;AnHy3uBJ;AmHv3uBE;EACE,kFAAA;AnHy3uBJ;;AmHr3uBA,aAAA;AAEE;EACE,cAAA;EACA,qBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,mCAAA;AnHu3uBJ;AmHt3uBI;EACE,aAAA;AnHw3uBN;AmHr3uBE;EACE,8BAAA;AnHu3uBJ;;AmHn3uBE;EACE,6BAAA;AnHs3uBJ;;AmHl3uBE;EACE,6BAAA;AnHq3uBJ;;AmHj3uBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AnHo3uBJ;AmHj3uBI;EACE,yDAAA;AnHm3uBN;AmHj3uBI;EACE,YAAA;EACA,0CAAA;AnHm3uBN;AmH/2uBI;EACE,wDAAA;AnHi3uBN;AmH/2uBI;EACE,WAAA;EACA,2CAAA;AnHi3uBN;AmH72uBE;EACE,gCAAA;AnH+2uBJ;;AoHjhvBA;EACE,8BAAA;EACA;;GAAA;ApHshvBF;;AoHlhvBA;;EAEE,kBAAA;EACA,QAAA;EACA,oDAAA;EACA,qCAAA;EACA,yDAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gEAAA;ApHqhvBF;AoHphvBE;;EACE,aAAA;EACA,YAAA;EACA,oBAAA;ApHuhvBJ;AoHrhvBE;;EACE,yBAAA;EACA,wCAAA;EAEA,iBAAA;EACA,oBAAA;EACA,uBAAA;EAAA,qBAAA;EACA,cAAA;ApHwhvBJ;;AoHrhvBA;;EAKE,UAAA;EACA,WAAA;ApHqhvBF;AoHzhvBE;;EACE,eAAA;ApH4hvBJ;;AoHvhvBA;;EAKE,WAAA;EACA,UAAA;ApHuhvBF;AoH3hvBE;;EACE,eAAA;ApH8hvBJ;;AoHxhvBA;EACE,aAAA;ApH2hvBF;;AqH/kvBA;EACE;;;;;;;;;;GAAA;ArH4lvBF;;AqHhlvBA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;ArHmlvBF;AqHllvBE;EACE,UAAA;ArHolvBJ;;AqHjlvBA,kBAAA;AACA;;;;EAIE,YAAA;EACA,OAAA;EACA,WAAA;ArHolvBF;;AqHllvBA,YAAA;AACA;EACE,gBAAA;EACA,YAAA;ArHqlvBF;AqHplvBE;EACE,sBAAA;EACA,kBAAA;ArHslvBJ;AqHplvBE;EACE,mBAAA;ArHslvBJ;AqHplvBE;EACE,mBAAA;ArHslvBJ;AqHplvBE;EACE,sBAAA;ArHslvBJ;AqHplvBE;EACE,sBAAA;ArHslvBJ;AqHplvBE;EACE,sBAAA;ArHslvBJ;AqHplvBE;EACE,sBAAA;ArHslvBJ;;AqHnlvBA;EACE,uFAAA;EACA,yFAAA;EACA,qBAAA;EACA,kBAAA;EACA,gEAAA;EACA,8DAAA;ArHslvBF;AqHrlvBW;EACP,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;ArHulvBJ;;AqHrlvBE;EACE,eAAA;ArHwlvBJ;AqHrlvBE;EACE,wBAAA;ArHulvBJ;;AqHplvBA;EACE,mDAAA;EACA,qEAAA;ArHulvBF;;AqHplvBA;;EAEE,WAAA;EACA,QAAA;EACA,oCAAA;ArHulvBF;AqHtlvBE;;EACE,2DAAA;EACA,cAAA;ArHylvBJ;AqHvlvBE;;EACE,QAAA;EACA,2BAAA;EACA,UAAA;ArH0lvBJ;AqHzlvBI;;EACE,qBAAA;EACA,sCAAA;ArH4lvBN;;AqHtlvBE;;EACE,6DAAA;ArH0lvBJ;AqHxlvBE;;EACE,SAAA;EACA,2BAAA;EACA,mBAAA;ArH2lvBJ;AqH1lvBI;;EACE,uCAAA;ArH6lvBN;;AqHzlvBA;EACE,wCAAA;ArH4lvBF;;AqH1lvBA,aAAA;AACA;EACE,+BAAA;EACA,kBAAA;ArH6lvBF;AqH5lvBE;EACE,qEAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;ArH8lvBJ;AqH5lvBE;EACE,2BAAA;ArH8lvBJ;AqH5lvBE;EAIE,WAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;ArH2lvBJ;AqHzlvBE;EAIE,UAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;ArHwlvBJ;;AqHrlvBA;EACE,aAAA;ArHwlvBF;;AsHzvvBA;EACI;IACI,UAAA;EtH4vvBN;EsH1vvBE;IACI,UAAA;EtH4vvBN;AACF;AsHzvvBA;EACI,qCAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AtH2vvBJ;;AsHxvvBA;EACI,UAAA;AtH2vvBJ;;AsHxvvBA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AtH2vvBJ;;AsHxvvBA;;;EAGI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AtH2vvBJ;;AsHxvvBA;EACI,4BAAA;EACA,2BAAA;EACA,wBAAA;AtH2vvBJ;;AsHxvvBA;EACI,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AtH2vvBJ;;AsHzvvBA;EACI,UAAA;AtH4vvBJ;;AsH1vvBA;EACI,YAAA;AtH6vvBJ;;AsH1vvBA;EACI,OAAA;EACA,wFAAA;AtH6vvBJ;;AsHxvvBA;EACI,QAAA;EACA,wFAAA;AtH2vvBJ;;AsHtvvBA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0DAAA;EACA,sBAAA;AtHyvvBJ;;AsHtvvBA;;EAEI,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,8BAAA;AtHyvvBJ;;AsHtvvBA;EACI,SAAA;EACA,iBAAA;EACA,cAAA;AtHyvvBJ;;AsHtvvBA;EACI,kBAAA;EACA,WAAA;AtHyvvBJ;;AsHtvvBA;EACI,MAAA;EACA,YAAA;AtHyvvBJ;;AsHtvvBA;EACI,YAAA;EACA,SAAA;AtHyvvBJ;;AsHtvvBA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AtHyvvBJ;;AsHtvvBA;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AtHyvvBJ;;AsHtvvBA;EACI,qBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AtHyvvBJ;;AsHtvvBA;EACI,sBAAA;AtHyvvBJ;;AsHtvvBA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AtHyvvBJ;;AsHvvvBA;EACI,UAAA;AtH0vvBJ;;AsHxvvBA;EACI,aAAA;AtH2vvBJ;;AsHxvvBA;EACI,eAAA;EACA,YAAA;AtH2vvBJ;;AsHzvvBA;EACI,YAAA;AtH4vvBJ;;AsHzvvBA;EACI,qEAAA;AtH4vvBJ;;AsHxvvBA;EACI,qEAAA;AtH2vvBJ;;AsHvvvBA;EACI,qEAAA;AtH0vvBJ;;AsHtvvBA;EACI,2BAAA;AtHyvvBJ;;AsHtvvBA;EACI;IAGI,UAAA;EtHuvvBN;EsHrvvBE;IACI,UAAA;EtHuvvBN;AACF;AsHpvvBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AtHsvvBJ;;AsHnvvBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AtHsvvBJ;;AsHpvvBA;EACI,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,oDAAA;AtHuvvBJ;;AsHrvvBA;EACI,uBAAA;AtHwvvBJ;;AsHtvvBA;EACI,yBAAA;AtHyvvBJ;;AsHvvvBA;;EAEI,uBAAA;AtH0vvBJ;;AsHxvvBA;EACI,wBAAA;AtH2vvBJ;;AsHzvvBA;EACI,yBAAA;AtH4vvBJ;;AsH1vvBA;;EAEI,uBAAA;AtH6vvBJ;;AsH3vvBA;EACI,wBAAA;AtH8vvBJ;;AsH5vvBA;EACI,yBAAA;AtH+vvBJ;;AsH7vvBA;;EAEI,uBAAA;AtHgwvBJ;;AsH9vvBA;EACI,wBAAA;AtHiwvBJ;;AsH/vvBA;EACI,yBAAA;AtHkwvBJ;;AsHhwvBA;;EAEI,uBAAA;AtHmwvBJ;;AsHjwvBA;EACI,yBAAA;AtHowvBJ;;AsHlwvBA;EACI,yBAAA;AtHqwvBJ;;AsHnwvBA;;EAEI,uBAAA;AtHswvBJ;;AsHpwvBA;EACI,yBAAA;AtHuwvBJ;;AsHrwvBA;EACI,yBAAA;AtHwwvBJ;;AsHtwvBA;;EAEI,uBAAA;AtHywvBJ;;AsHvwvBA;EACI,yBAAA;AtH0wvBJ;;AsHxwvBA;EACI,yBAAA;AtH2wvBJ;;AsHzwvBA;;EAEI,oBAAA;AtH4wvBJ;;AsHzwvBA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AtH4wvBJ;;AsH1wvBA;;EAEI,aAAA;AtH6wvBJ;;AsH1wvBA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AtH6wvBJ;;AsH3wvBA;;EAEI,aAAA;AtH8wvBJ;;AsH3wvBA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;AtH8wvBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,oBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,oBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,yBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,sBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,0BAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,oBAAA;AvHumwBJ;;AuHpmwBA;;EAEI,gEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,gCAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mCAAA;AvHumwBJ;;AuHpmwBA;;EAEI,oCAAA;AvHumwBJ;;AuHpmwBA;;EAEI,uCAAA;AvHumwBJ;;AuHpmwBA;;EAEI,kEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,kEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,+DAAA;AvHumwBJ;;AuHpmwBA;;EAEI,+DAAA;AvHumwBJ;;AuHpmwBA;;EAEI,iEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,iEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,gEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,iEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,gEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,iEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,gEAAA;AvHumwBJ;;AuHpmwBA;;EAEI,mEAAA;AvHumwBJ;;AuHpmwBA;EACI,UAAA;EACA,uCAAA;AvHumwBJ;AuHrmwBI;EACI,UAAA;EACA,wBAAA;AvHumwBR;;AuHnmwBA;EACI,mCAAA;AvHsmwBJ;;AuHnmwBA;EACI,oCAAA;AvHsmwBJ;;AuHnmwBA;EACI,oCAAA;AvHsmwBJ;;AuHnmwBA;EACI,mCAAA;AvHsmwBJ;;AuHnmwBA;EACI,wCAAA;AvHsmwBJ;;AuHnmwBA;EACI,uCAAA;AvHsmwBJ;;AuHnmwBA;EACI,yCAAA;AvHsmwBJ;;AuHnmwBA;EACI,wCAAA;AvHsmwBJ;;AuHnmwBA;EACI,UAAA;EACA,uCAAA;AvHsmwBJ;AuHpmwBI;EACI,UAAA;EACA,iCAAA;AvHsmwBR;;AuHlmwBA;EACI,qBAAA;AvHqmwBJ;;AuHlmwBA;EACI,8CAAA;AvHqmwBJ;;AuHlmwBA;EACI,+CAAA;AvHqmwBJ;;AuHlmwBA;EACI,+CAAA;AvHqmwBJ;;AuHlmwBA;EACI,8CAAA;AvHqmwBJ;;AuHlmwBA;EACI,qBAAA;AvHqmwBJ;;AuHlmwBA;EACI,8CAAA;AvHqmwBJ;;AuHlmwBA;EACI,+CAAA;AvHqmwBJ;;AuHlmwBA;EACI,+CAAA;AvHqmwBJ;;AuHlmwBA;EACI,8CAAA;AvHqmwBJ;;AuHlmwBA;EACI,8BAAA;AvHqmwBJ;AuHnmwBI;EACI,wBAAA;AvHqmwBR;;AuHjmwBA;EACI,kCAAA;AvHomwBJ;;AuHjmwBA;EACI,mCAAA;AvHomwBJ;;AuHjmwBA;EACI,mCAAA;AvHomwBJ;;AuHjmwBA;EACI,kCAAA;AvHomwBJ;;AuHjmwBA;EACI,2BAAA;EACA,8BAAA;AvHomwBJ;;AuHjmwBA;EACI,+CAAA;AvHomwBJ;AuHlmwBI;EACI,yCAAA;AvHomwBR;;AuHhmwBA;EACI,8CAAA;AvHmmwBJ;AuHjmwBI;EACI,yCAAA;AvHmmwBR;;AuH/lwBA;EACI,+CAAA;AvHkmwBJ;AuHhmwBI;EACI,yCAAA;AvHkmwBR;;AuH9lwBA;EACI,8CAAA;AvHimwBJ;AuH/lwBI;EACI,yCAAA;AvHimwBR;;AgB/pyBI;EwG1DJ;IAEI,eAAA;IACA,SAAA;IACA,0BAAA;IACA,cAAA;ExH4tyBF;EwHxtyBF;IAEI,OAAA;ExH4tyBF;EwHxtyBF;IAEI,QAAA;ExH4tyBF;AAXF;;AyHruyBI;EACI,kBAAA;EACA,UAAA;AzHovyBR;AyHlvyBI;EACI,kBAAA;EACA,UAAA;AzHovyBR;AyHjvyBQ;EACI,qCAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;AzHmvyBZ;AyHlvyBY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WjHRR;AR4vyBR;AyHlvyBY;EACI,oCAAA;EACA,8CAAA;AzHovyBhB;AyH/uyBQ;EACI,cAAA;AzHivyBZ;AyHhvyBY;EACI,cAAA;EACA,eAAA;EACA,4BAAA;AzHkvyBhB;AyHjvyBgB;EACI,cjHMb;EiHLa,iBAAA;AzHmvyBpB;AyH9uyBI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AzHgvyBR;;A0HlyyBA;EACI,kBAAA;EACA,WlCFa;EkCGb,YlCHa;AxFwyyBjB;A0HlyyBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;A1HoyyBR;A0HjyyBI;EACI,WlCbS;EkCcT,YlCdS;AxFizyBjB;;A0H3xyBQ;EACI,WAAA;EACA,YAAA;A1H8xyBZ;A0H3xyBQ;EACI,clCxBM;EkCyBN,elCzBM;AxFszyBlB;;A0HpyyBQ;EACI,aAAA;EACA,cAAA;A1HuyyBZ;A0HpyyBQ;EACI,alCxBM;EkCyBN,clCzBM;AxF+zyBlB;;A0H7yyBQ;EACI,aAAA;EACA,cAAA;A1HgzyBZ;A0H7yyBQ;EACI,clCxBM;EkCyBN,elCzBM;AxFw0yBlB;;A0HtzyBQ;EACI,aAAA;EACA,cAAA;A1HyzyBZ;A0HtzyBQ;EACI,WlCxBM;EkCyBN,YlCzBM;AxFi1yBlB;;A0H/zyBQ;EACI,aAAA;EACA,cAAA;A1Hk0yBZ;A0H/zyBQ;EACI,WlCxBM;EkCyBN,YlCzBM;AxF01yBlB;;A0Hx0yBQ;EACI,WAAA;EACA,YAAA;A1H20yBZ;A0Hx0yBQ;EACI,WlCxBM;EkCyBN,YlCzBM;AxFm2yBlB;;A0Hj1yBQ;EACI,aAAA;EACA,cAAA;A1Ho1yBZ;A0Hj1yBQ;EACI,WlCxBM;EkCyBN,YlCzBM;AxF42yBlB;;A0H70yBA;EACI,6BAAA;A1Hg1yBJ;;A0H10yBA;EACI,clHtBO;EkHuBP,+BAAA;A1H60yBJ;;A0Hx0yBI;EACI,clHsCO;EkHrCP,8BAAA;A1H20yBR;A0Hz0yBQ;EACI,clHkCG;EkHjCH,8BAAA;A1H20yBZ;;A0Hv0yBI;EACI,aAAA;A1H00yBR;A0Hx0yBQ;EACI,aAAA;A1H00yBZ;;A0Hx1yBI;EACI,clHsCO;EkHrCP,4BAAA;A1H21yBR;A0Hz1yBQ;EACI,clHkCG;EkHjCH,4BAAA;A1H21yBZ;;A0Hv1yBI;EACI,aAAA;A1H01yBR;A0Hx1yBQ;EACI,aAAA;A1H01yBZ;;A0Hx2yBI;EACI,clHsCO;EkHrCP,8BAAA;A1H22yBR;A0Hz2yBQ;EACI,clHkCG;EkHjCH,8BAAA;A1H22yBZ;;A0Hv2yBI;EACI,aAAA;A1H02yBR;A0Hx2yBQ;EACI,aAAA;A1H02yBZ;;A0Hx3yBI;EACI,clHsCO;EkHrCP,8BAAA;A1H23yBR;A0Hz3yBQ;EACI,clHkCG;EkHjCH,8BAAA;A1H23yBZ;;A0Hv3yBI;EACI,aAAA;A1H03yBR;A0Hx3yBQ;EACI,aAAA;A1H03yBZ;;A0Hx4yBI;EACI,clHsCO;EkHrCP,8BAAA;A1H24yBR;A0Hz4yBQ;EACI,clHkCG;EkHjCH,8BAAA;A1H24yBZ;;A0Hv4yBI;EACI,aAAA;A1H04yBR;A0Hx4yBQ;EACI,aAAA;A1H04yBZ;;A0Hx5yBI;EACI,clHsCO;EkHrCP,6BAAA;A1H25yBR;A0Hz5yBQ;EACI,clHkCG;EkHjCH,6BAAA;A1H25yBZ;;A0Hv5yBI;EACI,aAAA;A1H05yBR;A0Hx5yBQ;EACI,aAAA;A1H05yBZ;;A0Hx6yBI;EACI,clHsCO;EkHrCP,+BAAA;A1H26yBR;A0Hz6yBQ;EACI,clHkCG;EkHjCH,+BAAA;A1H26yBZ;;A0Hv6yBI;EACI,aAAA;A1H06yBR;A0Hx6yBQ;EACI,aAAA;A1H06yBZ;;A0Hx7yBI;EACI,clHsCO;EkHrCP,4BAAA;A1H27yBR;A0Hz7yBQ;EACI,clHkCG;EkHjCH,4BAAA;A1H27yBZ;;A0Hv7yBI;EACI,aAAA;A1H07yBR;A0Hx7yBQ;EACI,aAAA;A1H07yBZ;;A0Hx8yBI;EACI,clHsCO;EkHrCP,8BAAA;A1H28yBR;A0Hz8yBQ;EACI,clHkCG;EkHjCH,8BAAA;A1H28yBZ;;A0Hv8yBI;EACI,aAAA;A1H08yBR;A0Hx8yBQ;EACI,aAAA;A1H08yBZ;;A0Hx9yBI;EACI,clHsCO;EkHrCP,8BAAA;A1H29yBR;A0Hz9yBQ;EACI,clHkCG;EkHjCH,8BAAA;A1H29yBZ;;A0Hv9yBI;EACI,aAAA;A1H09yBR;A0Hx9yBQ;EACI,aAAA;A1H09yBZ;;A0Hx+yBI;EACI,clHsCO;EkHrCP,+BAAA;A1H2+yBR;A0Hz+yBQ;EACI,clHkCG;EkHjCH,+BAAA;A1H2+yBZ;;A0Hv+yBI;EACI,aAAA;A1H0+yBR;A0Hx+yBQ;EACI,aAAA;A1H0+yBZ;;A0Hp+yBA;;EAWI,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;A1H89yBJ;A0Hv+yBQ;;EACI,clCvEM;EkCwEN,elCxEM;AxFkjzBlB;A0H5+yBQ;;EACI,alCvEM;EkCwEN,clCxEM;AxFujzBlB;A0Hj/yBQ;;EACI,clCvEM;EkCwEN,elCxEM;AxF4jzBlB;A0Ht/yBQ;;EACI,WlCvEM;EkCwEN,YlCxEM;AxFikzBlB;A0H3/yBQ;;EACI,WlCvEM;EkCwEN,YlCxEM;AxFskzBlB;A0HhgzBQ;;EACI,WlCvEM;EkCwEN,YlCxEM;AxF2kzBlB;A0HrgzBQ;;EACI,WlCvEM;EkCwEN,YlCxEM;AxFglzBlB;;A0H9/yBA;EACI,0DAAA;A1HigzBJ;;A0H9/yBA;EACI,0DAAA;A1HigzBJ;;A2H1lzBA;EACE,YAAA;EACA,WAAA;A3H6lzBF;;A2H1lzBA;EACE,YAAA;EACA,WAAA;A3H6lzBF;;A2H1lzBA;EACE,cAAA;EACA,aAAA;A3H6lzBF;;A2H1lzBA;EACE,YAAA;EACA,WAAA;A3H6lzBF;;A2H1lzBA;EACE,cAAA;EACA,aAAA;A3H6lzBF;;A2H1lzBA;EACE,mBAAA;EACA,yBnHgBK;EmHfL,WnHfM;EmHgBN,aAAA;EACA,gBnH9BqB;EmH+BrB,YAAA;EACA,uBAAA;EACA,WAAA;A3H6lzBF;;A2H1lzBA;EACE,kBAAA;A3H6lzBF;A2H5lzBE;EACE,sBAAA;EACA,qBAAA;A3H8lzBJ;;A2HzlzBA;EACE,0DAAA;EACA,iCAAA;A3H4lzBF;;A4H9ozBA;EACI,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kEAAA;EACA,SAAA;EACA,SAAA;EACA,WpHSI;EoHRJ,oBAAA;EACA,mBAAA;EACA,gBpHgmBe;EoH/lBf,kDpH0iBY;EoHziBZ,mCpHiiBe;EoHhiBf,gCpHgiBe;ARinyBnB;;A4H5ozBI;EACI,mBAAA;A5H+ozBR;A4H7ozBQ;EACI,qBAAA;A5H+ozBZ;;A4HnpzBI;EACI,mBAAA;A5HspzBR;A4HppzBQ;EACI,qBAAA;A5HspzBZ;;A4H1pzBI;EACI,mBAAA;A5H6pzBR;A4H3pzBQ;EACI,qBAAA;A5H6pzBZ;;A4HjqzBI;EACI,mBAAA;A5HoqzBR;A4HlqzBQ;EACI,qBAAA;A5HoqzBZ;;A4HxqzBI;EACI,mBAAA;A5H2qzBR;A4HzqzBQ;EACI,qBAAA;A5H2qzBZ;;A4H/qzBI;EACI,mBAAA;A5HkrzBR;A4HhrzBQ;EACI,qBAAA;A5HkrzBZ;;A4HtrzBI;EACI,mBAAA;A5HyrzBR;A4HvrzBQ;EACI,qBAAA;A5HyrzBZ;;A4H7rzBI;EACI,mBAAA;A5HgszBR;A4H9rzBQ;EACI,qBAAA;A5HgszBZ;;A4HpszBI;EACI,mBAAA;A5HuszBR;A4HrszBQ;EACI,qBAAA;A5HuszBZ;;A4H3szBI;EACI,mBAAA;A5H8szBR;A4H5szBQ;EACI,qBAAA;A5H8szBZ;;A4HltzBI;EACI,mBAAA;A5HqtzBR;A4HntzBQ;EACI,qBAAA;A5HqtzBZ;;A4HhtzBA;EACI,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;A5HmtzBJ;;A4H9szBI;EACI,mBAAA;A5HitzBR;A4H/szBQ;EACI,qBAAA;A5HitzBZ;;A4HrtzBI;EACI,mBAAA;A5HwtzBR;A4HttzBQ;EACI,qBAAA;A5HwtzBZ;;A4H5tzBI;EACI,mBAAA;A5H+tzBR;A4H7tzBQ;EACI,qBAAA;A5H+tzBZ;;A4HnuzBI;EACI,mBAAA;A5HsuzBR;A4HpuzBQ;EACI,qBAAA;A5HsuzBZ;;A4H1uzBI;EACI,mBAAA;A5H6uzBR;A4H3uzBQ;EACI,qBAAA;A5H6uzBZ;;A4HjvzBI;EACI,mBAAA;A5HovzBR;A4HlvzBQ;EACI,qBAAA;A5HovzBZ;;A4HxvzBI;EACI,mBAAA;A5H2vzBR;A4HzvzBQ;EACI,qBAAA;A5H2vzBZ;;A4H/vzBI;EACI,mBAAA;A5HkwzBR;A4HhwzBQ;EACI,qBAAA;A5HkwzBZ;;A4HtwzBI;EACI,mBAAA;A5HywzBR;A4HvwzBQ;EACI,qBAAA;A5HywzBZ;;A4H7wzBI;EACI,mBAAA;A5HgxzBR;A4H9wzBQ;EACI,qBAAA;A5HgxzBZ;;A4HpxzBI;EACI,mBAAA;A5HuxzBR;A4HrxzBQ;EACI,qBAAA;A5HuxzBZ;;A6Hh0zBA;EACI,kBAAA;A7Hm0zBJ;A6Hj0zBI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,6GAAA;EACA,yDAAA;EACA,uBAAA;EACA,0BAAA;A7Hm0zBR;A6Hh0zBI;EACI;IACI,0BAAA;E7Hk0zBV;AACF;;A6H9zzBA;EACI,kBAAA;A7Hi0zBJ;A6H/zzBI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,uGAAA;EACA,yDAAA;EACA,sBAAA;EACA,0BAAA;A7Hi0zBR;A6H9zzBI;EACI,oBAAA;A7Hg0zBR;A6H/zzBQ;EACI,UAAA;EACA,2EAAA;EACA,yDAAA;A7Hi0zBZ;A6H7zzBI;EACI;IACI,0BAAA;E7H+zzBV;AACF;;A6H1zzBA;EACI,kBAAA;A7H6zzBJ;A6H3zzBI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,8GAAA;A7H6zzBR;A6HzzzBI;EACI;IACI,0BAAA;E7H2zzBV;AACF;;A6HvzzBA;EACI,kBAAA;A7H0zzBJ;A6HxzzBI;EACI,WAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,6GAAA;A7H0zzBR;;A6HtzzBA;EACI,kBAAA;A7HyzzBJ;A6HvzzBI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,6GAAA;A7HyzzBR;A6HtzzBI;EACI;IACI,0BAAA;E7HwzzBV;AACF;;A6HpzzBA;EACI,kBAAA;A7HuzzBJ;A6HrzzBI;EACI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,6GAAA;A7HuzzBR;;A6HnzzBA;EACI,kBAAA;A7HszzBJ;A6HpzzBI;EACI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,+GAAA;A7HszzBR;A6HnzzBI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;A7HqzzBR;;A8H59zBA;EACI,eAAA;EACA,gBAAA;EACA,gBtHHmB;ARk+zBvB;A8H79zBI;EALJ;IAMQ,iBAAA;IACA,gBAAA;E9Hg+zBN;AACF;A8H/9zBI;EATJ;IAUQ,0BAAA;E9Hk+zBN;AACF;;A8H99zBA;EACI,kBAAA;A9Hi+zBJ;A8H/9zBI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A9Hi+zBR;A8H/9zBQ;EACI,uBAAA;EACA,YAAA;EACA,WAAA;A9Hi+zBZ;A8H99zBgB;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A9Hg+zBpB;A8H19zBI;EACI,kBAAA;A9H49zBR;A8H19zBQ;EACI,kBAAA;A9H49zBZ;A8H19zBY;EACI,kBAAA;EACA,UAAA;A9H49zBhB;A8Hz9zBY;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;A9H29zBhB;A8Hx9zBY;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;A9H09zBhB;A8Ht9zBQ;EACI,kBAAA;A9Hw9zBZ;A8Ht9zBY;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EAEA,0JAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;A9Hw9zBhB;A8Hn9zBI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,qDAAA;A9Hq9zBR;A8Hl9zBI;EACI;IACI,aAAA;E9Ho9zBV;E8H/8zBU;IAEI,aAAA;E9Hg9zBd;E8H78zBU;IACI,kCAAA;E9H+8zBd;AACF;;A8Hx8zBA;EACI,atCnGW;AxF8i0Bf;A8Hz8zBI;EAHJ;IAIQ,atCtGO;ExFkj0Bb;AACF;A8H18zBI;EAPJ;IAQQ,YAAA;E9H68zBN;AACF;A8H38zBI;EACI,kBAAA;A9H68zBR;A8H38zBQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;A9H68zBZ;A8Hz8zBY;;EAEI,uBAAA;EACA,iBAAA;EACA,sBAAA;A9H28zBhB;A8Hv8zBQ;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;A9Hy8zBZ;;A8Hp8zBA;EAEQ;IACI,kBAAA;E9Hs8zBV;E8Hp8zBU;IACI,kBAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,OAAA;IACA,QAAA;E9Hs8zBd;E8Hl8zBc;;IAEI,uBAAA;IACA,iBAAA;IACA,sBAAA;E9Ho8zBlB;E8Hh8zBU;IACI,kBAAA;IACA,aAAA;IACA,sBAAA;E9Hk8zBd;AACF;A8H77zBA;EACI;IACI,YAAA;IACA,iBAAA;E9H+7zBN;AACF;A8H17zBI;EACI;IACI,uBAAA;IACA,QAAA;IACA,QAAA;E9H47zBV;E8H17zBM;IACI,yBAAA;IACA,QAAA;IACA,SAAA;E9H47zBV;AACF;A8Hz7zBI;EACI;IACI,uBAAA;IACA,WAAA;IACA,UAAA;E9H27zBV;E8Hz7zBM;IACI,yBAAA;IACA,WAAA;IACA,UAAA;E9H27zBV;AACF;A8Hx7zBI;EACI;IACI,uBAAA;IACA,UAAA;IACA,UAAA;E9H07zBV;E8Hx7zBM;IACI,yBAAA;IACA,WAAA;IACA,UAAA;E9H07zBV;AACF;A8Hv7zBI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;EACA,qDAAA;A9Hy7zBR;A8Ht7zBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;EACA,sDAAA;A9Hw7zBR;A8Hr7zBI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;EACA,sDAAA;A9Hu7zBR;;A8Hh7zBI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;A9Hm7zBR;A8Hh7zBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;A9Hk7zBR;A8H/6zBI;EACI,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;A9Hi7zBR;A8H96zBI;EACI,kBAAA;A9Hg7zBR;A8H96zBQ;EACI,kBAAA;EACA,UAAA;A9Hg7zBZ;;A8H36zBA;EAEQ;IACI,gBAAA;E9H66zBV;E8H36zBU;IACI,OAAA;IACA,MAAA;IACA,YAAA;E9H66zBd;AACF;A8Hr6zBA;EACI,YAAA;A9Hu6zBJ;A8Hr6zBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,uBAAA;A9Hu6zBR;;A8Hn6zBA;EAEQ;IACI,YAAA;E9Hq6zBV;AACF;A8Hj6zBA;EACI;IACI,YAAA;E9Hm6zBN;AACF;A8H95zBA;EACI,kBAAA;A9Hg6zBJ;A8H95zBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,sFAAA;EACA,sBAAA;EACA,0BAAA;A9Hg6zBR;A8H75zBI;EACI,kBAAA;EACA,YAAA;A9H+5zBR;A8H75zBQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,uBAAA;A9H+5zBZ;A8H55zBQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,uBAAA;A9H85zBZ;A8Hz5zBQ;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;A9H25zBZ;A8Hz5zBY;EACI,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,iCAAA;A9H25zBhB;A8Hx5zBY;EACI,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;A9H05zBhB;A8Hv5zBY;EACI,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;EACA,UAAA;EACA,kCAAA;EACA,gCAAA;A9Hy5zBhB;;A8Hn5zBA;EAEQ;IACI,0BAAA;IACA,gBAAA;E9Hq5zBV;E8Hl5zBM;IACI,WAAA;E9Ho5zBV;E8Hl5zBU;IACI,WAAA;IACA,yBAAA;E9Ho5zBd;E8Hn5zBc;IACI,aAAA;E9Hq5zBlB;AACF;A8H34zBQ;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,gBtH9cJ;EsH+cI,kDtHsFI;EsHrFJ,qBtH8EO;EsH7EP,eAAA;A9H64zBZ;A8H34zBY;EACI,eAAA;EACA,kBAAA;EACA,UAAA;A9H64zBhB;A8Hz4zBQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;A9H24zBZ;;A8Ht4zBA;EAGY;IACI,eAAA;E9Hu4zBd;AACF;A8Hj4zBA;EACI,kBAAA;A9Hm4zBJ;A8Hj4zBI;EACI,kBAAA;EAEA,kBAAA;EACA,gBAAA;A9Hk4zBR;A8Hh4zBQ;EACI,WAAA;EACA,oDAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;A9Hk4zBZ;A8H93zBI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A9Hg4zBR;A8H93zBQ;EACI,UAAA;EACA,yBAAA;EACA,gBtHliBW;ARk60BvB;A8H33zBI;EACI,kBAAA;A9H63zBR;A8H33zBQ;EACI,aAAA;A9H63zBZ;;A8Hx3zBA;EAGY;IACI,UAAA;E9Hy3zBd;E8Hp3zBU;IACI,aAAA;E9Hs3zBd;AACF;A8H/2zBI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;A9Hi3zBR;A8H/2zBQ;EACI,UAAA;EACA,kBAAA;A9Hi3zBZ;A8H72zBI;EACI;IACI,eAAA;IACA,cAAA;E9H+2zBV;AACF;;A8Hz2zBA;EACI,kBAAA;A9H42zBJ;A8H12zBI;EACI,2EAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;A9H42zBR;A8Hx2zBI;EACI,kBAAA;A9H02zBR;A8Hv2zBI;EACI,kBAAA;A9Hy2zBR;A8Hv2zBQ;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;A9Hy2zBZ;A8Ht2zBQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;A9Hw2zBZ;A8Hp2zBI;EACI,kBAAA;A9Hs2zBR;A8Hp2zBQ;EACI,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;A9Hs2zBZ;;A8Hh2zBA;EACI,aAAA;A9Hm2zBJ;A8Hj2zBI;EACI,kBAAA;A9Hm2zBR;A8Hj2zBQ;EACI,kBAAA;EACA,UAAA;A9Hm2zBZ;A8Hh2zBQ;EAEI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;A9Hi2zBZ;A8H91zBQ;EACI,YAAA;A9Hg2zBZ;A8H/1zBY;EAFJ;IAGQ,SAAA;E9Hk2zBd;AACF;A8H/1zBQ;EACI,UAAA;EACA,WAAA;A9Hi2zBZ;A8H71zBI;EAEQ;IACI,aAAA;E9H81zBd;AACF;;A8Ht1zBQ;EACI,kBAAA;A9Hy1zBZ;A8Hv1zBY;EACI,kBAAA;EACA,eAAA;EACA,UAAA;A9Hy1zBhB;A8Ht1zBY;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A9Hw1zBhB;A8Hp1zBQ;EACI,kBAAA;A9Hs1zBZ;A8Hp1zBY;EACI,qCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;A9Hs1zBhB;A8Hl1zBQ;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,gBtHttBJ;EsHutBI,kDtHlLI;EsHmLJ,qBtH1LO;EsH2LP,eAAA;A9Ho1zBZ;A8Hl1zBQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;A9Ho1zBZ;A8Hj1zBQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAEA,wBAAA;EACA,UAAA;A9Hm1zBZ;;A8H90zBA;EAGY;IACI,eAAA;E9H+0zBd;E8H70zBU;IACI,WAAA;E9H+0zBd;AACF;A+H1l1BI;EACI,kBAAA;A/H4l1BR;A+H1l1BQ;EACI,WAAA;EACA,qFAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;A/H4l1BZ;A+Hzl1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;A/H2l1BZ;A+Hxl1BQ;EACI,cAAA;A/H0l1BZ;;A+Hrl1BA;EAGY;IACI,cAAA;E/Hsl1Bd;AACF;A+Hhl1BI;EACI,kBAAA;A/Hkl1BR;A+Hhl1BQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;A/Hkl1BZ;A+H/k1BQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,yDAAA;A/Hil1BZ;A+H9k1BQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,yDAAA;A/Hgl1BZ;A+H7k1BQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;A/H+k1BZ;A+H5k1BQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,yDAAA;A/H8k1BZ;A+H3k1BQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;A/H6k1BZ;;A+Hrk1BI;EACI,kBAAA;A/Hwk1BR;A+Htk1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;A/Hwk1BZ;A+Hrk1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;A/Huk1BZ;A+Hnk1BI;EACI,kBAAA;A/Hqk1BR;A+Hnk1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;A/Hqk1BZ;A+Hlk1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;A/Hok1BZ;;A+H/j1BA;EAIY;;IACI,cAAA;IACA,cAAA;E/Hgk1Bd;E+H5j1BU;IACI,WAAA;E/H8j1Bd;E+H5j1BU;IACI,UAAA;E/H8j1Bd;E+H1j1BU;IACI,UAAA;E/H4j1Bd;E+H1j1BU;IACI,WAAA;E/H4j1Bd;AACF;A+Hnj1BQ;EACI,uBAAA;A/Hqj1BZ;A+Hlj1BQ;EACI,WAAA;EACA,qFAAA;EACA,kBAAA;EACA,8CAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;A/Hoj1BZ;A+Hhj1BI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;A/Hkj1BR;;A+H9i1BA;EAEQ;IACI,kBAAA;IACA,MAAA;IACA,eAAA;IACA,OAAA;E/Hgj1BV;AACF;A+Hzi1BQ;EACI,8CAAA;EACA,6DAAA;A/H2i1BZ;;A+Hpi1BI;EACI,gCvHkUU;EuHjUV,kBAAA;A/Hui1BR;A+Hri1BQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,oCAAA;EACA,UAAA;A/Hui1BZ;A+Hpi1BQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;A/Hsi1BZ;A+Hni1BQ;EACI,0DAAA;A/Hqi1BZ;A+Hni1BY;EACI,UAAA;A/Hqi1BhB;;A+H5h1BQ;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;A/H+h1BZ;;A+Hxh1BI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;A/H2h1BR;A+Hzh1BQ;EACI,kBAAA;EACA,UAAA;A/H2h1BZ;A+Hxh1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;A/H0h1BZ;A+Hrh1BQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,qCAAA;EACA,UAAA;A/Huh1BZ;A+Hph1BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;A/Hsh1BZ;A+Hnh1BQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;A/Hqh1BZ;A+Hjh1BI;EACI;IACI,kBAAA;IACA,MAAA;IACA,eAAA;IACA,eAAA;E/Hmh1BV;E+Hlh1BU;IACI,aAAA;E/Hoh1Bd;E+Hhh1BU;IACI,WAAA;E/Hkh1Bd;E+Hhh1BU;IACI,cAAA;E/Hkh1Bd;AACF;;A+H3g1BI;EACI,uCAAA;A/H8g1BR;A+H5g1BQ;EACI,6CAAA;EACA,2CAAA;EACA,uCAAA;A/H8g1BZ;A+H3g1BQ;EACI,6DAAA;A/H6g1BZ;A+H3g1BY;EACI,0CAAA;EACA,8CAAA;EACA,uCAAA;EACA,qCAAA;A/H6g1BhB;;AgIn51BI;EACI,kBAAA;AhIs51BR;AgIp51BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AhIs51BZ;AgIn51BQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;AhIq51BZ;;AgIh51BA;EAGY;IACI,aAAA;EhIi51Bd;AACF;AgIx41BI;;EACI,kBAAA;AhI241BR;AgIv41BY;;EACI,iBAAA;AhI041BhB;AgIt41BQ;;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AhIy41BZ;AgIt41BQ;;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AhIy41BZ;AgIt41BQ;;EACI,aAAA;AhIy41BZ;AgIt41BQ;;EACI,gBAAA;EACA,eAAA;EACA,8CAAA;EACA,gBAAA;AhIy41BZ;;AgIp41BA;EAKY;;IACI,aAAA;EhIo41Bd;AACF;AgI531BQ;EAEI,gBAAA;AhI631BZ;;AgIp31BI;EACI,sBAAA;EACA,4BAAA;AhIu31BR;AgIr31BI;EACI,gBAAA;EACA,eAAA;EACA,8CAAA;EACA,gBAAA;AhIu31BR;AgIr31BI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AhIu31BR;;AiIz/1BA;EACI,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBzHYI;EyHXJ,sBzHwiBe;EyHviBf,mBAAA;AjI4/1BJ;AiI1/1BI;EACI,eAAA;AjI4/1BR;AiIz/1BI;EACI,mBzHIG;EyHHH,YAAA;EACA,kBAAA;EACA,kBAAA;AjI2/1BR;AiIx/1BI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AjI0/1BR;;AiIr/1BI;EACI,aAAA;AjIw/1BR;AiIr/1BI;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;AjIu/1BR;;AkI1h2BI;EACI,qBAAA;EAEA,gB1HFa;E0HGb,c1HkBG;E0HjBH,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,gB1HimBW;E0HhmBX,sB1H8hBW;E0H7hBX,uB1HolBO;E0HnlBP,eAAA;EAGA,qB1HDG;E0HEH,qI1HwyBS;ARgv0BjB;AkIth2BQ;EACI,sBAAA;EACA,oCAAA;EACA,gCAAA;AlIwh2BZ;AkIrh2BQ;EAEI,UAAA;EACA,kD1H0uBiB;AR4y0B7B;AkIlh2BQ;EAEI,a1H2wBW;ARww0BvB;AkIlg2BQ;EAEI,sB1HzCJ;E0H0CI,kFAAA;AlImg2BZ;;AkI9/1BA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,4DAAA;AlIig2BJ;AkIhg2BI;EACI,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sCAAA;AlIkg2BR;;AmIxk2BA;EACI,mBAAA;AnI2k2BJ;AmIzk2BI;EACI,6BAAA;EACA,c3HeG;E2HdH,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gB3HZa;E2Hab,yC3H2kBiB;ARgg1BzB;AmIzk2BQ;EACI,0CAAA;EACA,c3H2BL;ARgj2BP;AmIxk2BQ;EACI,yB3HuBL;E2HtBK,W3HRJ;ARkl2BR;;AmIpk2BA;EACI,sB3HfI;E2HgBJ,kBAAA;EACA,+C3HkhBS;E2HjhBT,qB3H+egB;ARwl1BpB;AmIrk2BI;EACI,aAAA;EACA,cAAA;AnIuk2BR;AmIrk2BQ;EACI,eAAA;AnIuk2BZ;AmInk2BI;EACI,aAAA;EACA,6BAAA;EACA,kBAAA;AnIqk2BR;AmInk2BQ;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AnIqk2BZ;AmIlk2BQ;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AnIok2BZ;;AmI5j2BQ;EACI,wBAAA;AnI+j2BZ;AmI5j2BI;EACI,mBAAA;AnI8j2BR;AmI5j2BY;EACI,gBAAA;EACA,gBAAA;AnI8j2BhB;;AoI1o2BI;EACI,aAAA;ApI6o2BR;AoI3o2BI;EACI,aAAA;EACA,oBAAA;EACA,qBAAA;ApI6o2BR;AoI5o2BQ;EACI,aAAA;ApI8o2BZ;AoI5o2BQ;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;ApI8o2BZ;AoI7o2BY;EACI,0BAAA;ApI+o2BhB;AoI7o2BY;EACI,0BAAA;ApI+o2BhB;AoIzo2BI;EACI,SAAA;ApI2o2BR;AoI1o2BQ;EACI,WAAA;EACA,8BAAA;ApI4o2BZ;AoI3o2BY;EACI,kBAAA;ApI6o2BhB;AoIto2BQ;EACI,8BAAA;ApIwo2BZ;AoIno2BI;EACI,SAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ApIqo2BR;AoIno2BY;EACI,8BAAA;EACA,wBAAA;ApIqo2BhB;AoIpo2BgB;EACI,8BAAA;ApIso2BpB;AoIlo2BQ;EACI,WAAA;EACA,YAAA;ApIoo2BZ;AoIlo2BgB;EACI,qBAAA;EACA,8BAAA;ApIoo2BpB;AoIjo2BY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;ApImo2BhB;AoIlo2BgB;EACI,qBAAA;EACA,8BAAA;ApIoo2BpB;;AoI7n2BA,iBAAA;AACA;EAGQ;IACI,6BAAA;EpI8n2BV;EoI1n2BM;IACI,sBAAA;EpI4n2BV;EoI1n2Bc;IACI,gBAAA;EpI4n2BlB;EoI1n2Bc;IACI,gBAAA;EpI4n2BlB;EoItn2BM;;IAEI,eAAA;EpIwn2BV;AACF;AoIpn2BA;EAGQ;IACI,6BAAA;EpIon2BV;EoIhn2BM;IACI,sBAAA;EpIkn2BV;EoIhn2Bc;IACI,gBAAA;EpIkn2BlB;EoIhn2Bc;IACI,gBAAA;EpIkn2BlB;EoI5m2BM;;IAEI,eAAA;EpI8m2BV;AACF;AoI1m2BA,iBAAA;AACA;EAGQ;IACI,6BAAA;EpI0m2BV;EoItm2BM;IACI,sBAAA;EpIwm2BV;EoItm2Bc;IACI,gBAAA;EpIwm2BlB;EoItm2Bc;IACI,gBAAA;EpIwm2BlB;EoIlm2BM;;IAEI,eAAA;EpIom2BV;AACF;AoIhm2BA,iBAAA;AACA;EAGQ;IACI,6BAAA;EpIgm2BV;EoI5l2BM;IACI,sBAAA;EpI8l2BV;EoI5l2Bc;IACI,gBAAA;EpI8l2BlB;EoI5l2Bc;IACI,gBAAA;EpI8l2BlB;EoIxl2BM;;IAEI,eAAA;EpI0l2BV;AACF;AoItl2BA,kBAAA;AACA;EAGQ;IACI,6BAAA;EpIsl2BV;EoIll2BM;IACI,sBAAA;EpIol2BV;EoIll2Bc;IACI,gBAAA;EpIol2BlB;EoIll2Bc;IACI,gBAAA;EpIol2BlB;EoI9k2BM;;IAEI,eAAA;EpIgl2BV;AACF;AoI5k2BA,iBAAA;AACA;EAGQ;;IAEI,eAAA;EpI4k2BV;AACF;AoIxk2BA,iBAAA;AACA;EAGQ;IACI,SAAA;IACA,eAAA;EpIwk2BV;EoInk2BU;IACI,0BAAA;EpIqk2Bd;EoI/j2BU;IACI,0BAAA;EpIik2Bd;AACF;AoI5j2BA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;ACtSA;EACI,cAAA;ArIs12BJ;AqIn12BI;EACI,yBAAA;ArIq12BR;AqIj12BI;EACI,gBAAA;EACA,MAAA;EACA,YAAA;EACA,wBAAA;EACA,0DAAA;ArIm12BR;AqIl12BQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,6BAAA;ArIo12BZ;AqIl12BQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,6BAAA;ArIo12BZ;AqI902BQ;EACI,UAAA;ArIg12BZ;AqI902BY;EACI,UAAA;ArIg12BhB;AqI/02BgB;EACI,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,oCAAA;ArIi12BpB;AqIh12BoB;EACI,gCAAA;EACA,uCAAA;ArIk12BxB;AqIh12BoB;EACI,gBAAA;EACA,gCAAA;EACA,uCAAA;ArIk12BxB;AqIv02BoB;EACI,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;ArIy02BxB;AqIv02B4B;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;ArIy02BhC;AqI/z2BI;EACI,oBAAA;ArIi02BR;AqIh02BQ;EACI,YAAA;ArIk02BZ;AqIj02BY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;ArIm02BhB;AqIh02BgB;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;ArIk02BpB;AqIj02BoB;EACI,cAAA;ArIm02BxB;AqIj02BoB;EACI,UAAA;EACA,aAAA;EACA,+BAAA;ArIm02BxB;AqI3z2BI;EACI,gCAAA;EACA,oCAAA;ArI6z2BR;AqI5z2BQ;EAEI,uCAAA;ArI6z2BZ;AqIvz2BQ;EACI,eAAA;EACA,mBAAA;EACA,qCAAA;ArIyz2BZ;AqIvz2BgB;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;ArIyz2BpB;AqIxz2BoB;EAEI,gCAAA;EACA,uCAAA;ArIyz2BxB;AqIpz2BQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;EACA,sDAAA;ArIsz2BZ;AqIrz2BY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;ArIuz2BhB;AqIrz2BY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;ArIuz2BhB;AqIpz2BQ;EACI,qBAAA;ArIsz2BZ;AqIrz2BY;EACI,aAAA;ArIuz2BhB;;AqIhz2BA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,oCAAA;ArImz2BJ;;AqIjz2BA;EACI;IACI,uBAAA;ErIoz2BN;EqIlz2BE;IACI,yBAAA;ErIoz2BN;AACF;AqIhz2BA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ArIkz2BJ;AqIjz2BI;EACI,UAAA;EACA,QAAA;EACA,SAAA;ArImz2BR;AqIlz2BQ;EACI,8BAAA;ArIoz2BZ;AqInz2BY;EACI,0BAAA;ArIqz2BhB;AqIjz2BI;EACI,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;ArImz2BR;AqIlz2BQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;ArIoz2BZ;;AqI/y2BA,iBAAA;AACA;EAGQ;IACI,4BAAA;ErIgz2BV;EqI5y2BM;IACI,gBAAA;IACA,uBAAA;ErI8y2BV;EqI7y2BU;IAEI,aAAA;ErI8y2Bd;EqIty2BkB;IACI,sBAAA;ErIwy2BtB;EqIvy2BsB;IACI,eAAA;ErIyy2B1B;EqIvy2BsB;IACI,WAAA;IACA,WAAA;ErIyy2B1B;EqIjy2BM;IACI,sBAAA;ErImy2BV;EqI9x2BU;IACI,sBAAA;ErIgy2Bd;EqI1x2BU;IACI,UAAA;ErI4x2Bd;AACF;AqIvx2BA,kBAAA;AACA;EAGQ;IACI,4BAAA;ErIux2BV;EqInx2BM;IACI,gBAAA;IACA,uBAAA;ErIqx2BV;EqIpx2BU;IAEI,aAAA;ErIqx2Bd;EqI7w2BkB;IACI,sBAAA;ErI+w2BtB;EqI9w2BsB;IACI,eAAA;ErIgx2B1B;EqI9w2BsB;IACI,WAAA;IACA,WAAA;ErIgx2B1B;EqIxw2BM;IACI,sBAAA;ErI0w2BV;EqIrw2BU;IACI,sBAAA;ErIuw2Bd;EqIjw2BU;IACI,UAAA;ErImw2Bd;AACF;AqI9v2BA,iBAAA;AACA;EAGQ;IACI,4BAAA;ErI8v2BV;EqI1v2BM;IACI,gBAAA;IACA,uBAAA;ErI4v2BV;EqI3v2BU;IAEI,aAAA;ErI4v2Bd;EqIpv2BkB;IACI,sBAAA;ErIsv2BtB;EqIrv2BsB;IACI,eAAA;ErIuv2B1B;EqIrv2BsB;IACI,WAAA;IACA,WAAA;ErIuv2B1B;EqI/u2BM;IACI,sBAAA;ErIiv2BV;EqI5u2BU;IACI,sBAAA;ErI8u2Bd;EqIxu2BU;IACI,UAAA;ErI0u2Bd;AACF;AqIru2BA,iBAAA;AACA;EAGQ;IACI,4BAAA;ErIqu2BV;EqIju2BM;IACI,gBAAA;IACA,uBAAA;ErImu2BV;EqIlu2BU;IAEI,aAAA;ErImu2Bd;EqI3t2BkB;IACI,sBAAA;ErI6t2BtB;EqI5t2BsB;IACI,eAAA;ErI8t2B1B;EqI5t2BsB;IACI,WAAA;IACA,WAAA;ErI8t2B1B;EqItt2BM;IACI,sBAAA;ErIwt2BV;EqInt2BU;IACI,sBAAA;ErIqt2Bd;EqI/s2BU;IACI,UAAA;ErIit2Bd;AACF;AqI5s2BA,kBAAA;AACA;EAGQ;IACI,4BAAA;ErI4s2BV;EqIxs2BM;IACI,gBAAA;IACA,uBAAA;ErI0s2BV;EqIzs2BU;IAEI,aAAA;ErI0s2Bd;EqIls2BkB;IACI,sBAAA;ErIos2BtB;EqIns2BsB;IACI,eAAA;ErIqs2B1B;EqIns2BsB;IACI,WAAA;IACA,WAAA;ErIqs2B1B;EqI5r2BU;IACI,sBAAA;ErI8r2Bd;EqIxr2BU;IACI,UAAA;ErI0r2Bd;AACF;AqIrr2BA,iBAAA;AACA;EAGQ;IACI,gBAAA;IACA,uBAAA;ErIqr2BV;EqIpr2BU;IAEI,aAAA;ErIqr2Bd;EqI5q2BsB;IACI,cAAA;ErI8q2B1B;EqItq2BM;IACI,sBAAA;ErIwq2BV;EqInq2BU;IACI,sBAAA;ErIqq2Bd;AACF;AqIhq2BA,iBAAA;AACA;EAGQ;IACI,SAAA;IACA,eAAA;ErIgq2BV;EqI5p2BM;IACI,gBAAA;IACA,uBAAA;ErI8p2BV;EqI7p2BU;IAEI,aAAA;ErI8p2Bd;EqIrp2BsB;IACI,cAAA;ErIup2B1B;EqI/o2BM;IACI,sBAAA;ErIip2BV;AACF;AqI7o2BA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;AC5nBA;EACI,cAAA;AtI6v3BJ;AsI1v3BI;EACI,yBAAA;AtI4v3BR;AsIxv3BI;EACI,gBAAA;EACA,MAAA;EACA,YAAA;EACA,wBAAA;EACA,0DAAA;AtI0v3BR;AsIzv3BQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,6BAAA;AtI2v3BZ;AsIzv3BQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,6BAAA;AtI2v3BZ;;AsItv3BA,iBAAA;AACA;EAGQ;IACI,4BAAA;EtIuv3BV;EsInv3BM;IACI,gBAAA;IACA,uBAAA;EtIqv3BV;EsIpv3BU;IAEI,aAAA;EtIqv3Bd;EsIhv3BM;IACI,wBAAA;EtIkv3BV;EsI9u3BM;IACI,wBAAA;EtIgv3BV;EsI3u3BU;IACI,wBAAA;IACA,QAAA;EtI6u3Bd;AACF;AsIxu3BA;EAGQ;IACI,4BAAA;EtIwu3BV;EsIpu3BM;IACI,gBAAA;IACA,uBAAA;EtIsu3BV;EsIru3BU;IAEI,aAAA;EtIsu3Bd;EsIju3BM;IACI,wBAAA;EtImu3BV;EsI/t3BM;IACI,wBAAA;EtIiu3BV;EsI5t3BU;IACI,wBAAA;IACA,QAAA;EtI8t3Bd;AACF;AsIzt3BA,iBAAA;AACA;EAGQ;IACI,4BAAA;EtIyt3BV;EsIrt3BM;IACI,gBAAA;IACA,uBAAA;EtIut3BV;EsItt3BU;IAEI,aAAA;EtIut3Bd;EsIlt3BM;IACI,wBAAA;EtIot3BV;EsIht3BM;IACI,wBAAA;EtIkt3BV;EsI7s3BU;IACI,wBAAA;IACA,QAAA;EtI+s3Bd;AACF;AsI1s3BA,iBAAA;AACA;EAGQ;IACI,4BAAA;EtI0s3BV;EsIts3BM;IACI,gBAAA;IACA,uBAAA;EtIws3BV;EsIvs3BU;IAEI,aAAA;EtIws3Bd;EsIns3BM;IACI,wBAAA;EtIqs3BV;EsIjs3BM;IACI,wBAAA;EtIms3BV;EsI9r3BU;IACI,wBAAA;IACA,QAAA;EtIgs3Bd;AACF;AsI3r3BA,kBAAA;AACA;EAGQ;IACI,4BAAA;EtI2r3BV;EsIvr3BM;IACI,gBAAA;IACA,uBAAA;EtIyr3BV;EsIxr3BU;IAEI,aAAA;EtIyr3Bd;EsIpr3BM;IACI,wBAAA;EtIsr3BV;EsIlr3BM;IACI,wBAAA;EtIor3BV;EsI/q3BU;IACI,wBAAA;IACA,QAAA;EtIir3Bd;AACF;AsI5q3BA,iBAAA;AACA;EAIY;IAEI,YAAA;EtI0q3Bd;EsIrq3BM;IACI,wBAAA;EtIuq3BV;EsInq3BM;IACI,wBAAA;EtIqq3BV;EsIhq3BU;IACI,wBAAA;IACA,QAAA;EtIkq3Bd;AACF;AsI7p3BA,iBAAA;AACA;EAGQ;IACI,SAAA;IACA,eAAA;EtI6p3BV;EsIxp3BU;IAEI,aAAA;EtIyp3Bd;EsIhp3BsB;IACI,YAAA;EtIkp3B1B;AACF;AsI1o3BA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;ACrTA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;AvIm73BJ;;AuIj73BA;EACI;IACI,uBAAA;EvIo73BN;EuIl73BE;IACI,yBAAA;EvIo73BN;AACF;AwIh83BQ;EACI,qCAAA;AxIk83BZ;AwIj83BY;EACI,WAAA;EACA,YAAA;AxIm83BhB;AwIl83BgB;EACI,WAAA;EACA,YAAA;AxIo83BpB;AwIn83BoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,4EAAA;AxIq83BxB;AwI/73BI;EACI,UAAA;EACA,YAAA;EACA,kBAAA;AxIi83BR;AwI/73BQ;EACI,YAAA;EACA,wBAAA;EACA,wBAAA;AxIi83BZ;AwIh83BY;EACI,WAAA;EACA,YAAA;AxIk83BhB;AwIj83BgB;EACI,WAAA;EACA,YAAA;AxIm83BpB;AwIl83BoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,4EAAA;AxIo83BxB;AwI773BQ;EACI,iBAAA;EACA,2BAAA;AxI+73BZ;AwI573BQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AxI873BZ;AwI573BQ;EACI,0BAAA;AxI873BZ;;AyI5/3BA;EACI,2BAAA;EAsFA,6BAAA;AzI063BJ;AyI9/3BI;EACI,YAAA;EACA,iBAAA;EACA,8CAAA;AzIgg4BR;AyI7/3BI;EACI,iBAAA;AzI+/3BR;AyIz/3BgB;EACI,gBAAA;AzI2/3BpB;AyIr/3BI;EACI,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;AzIu/3BR;AyIr/3BI;EACI,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gCAAA;EACA,qCAAA;AzIu/3BR;AyIp/3BI;EACI,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,qBAAA;AzIs/3BR;AyIr/3BQ;EACI,uBAAA;AzIu/3BZ;AyIt/3BY;EACI,wBAAA;AzIw/3BhB;AyIt/3BY;EACI,uBAAA;AzIw/3BhB;AyIp/3BQ;EACI,gBAAA;EACA,iBAAA;AzIs/3BZ;AyIr/3BY;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;AzIu/3BhB;AyIt/3BgB;EACI,mBAAA;EACA,wBAAA;AzIw/3BpB;AyIp/3BgB;EACI,mBAAA;EACA,wBAAA;AzIs/3BpB;AyI5+3BY;EACI,gCAAA;AzI8+3BhB;AyI7+3BgB;EACI,wBAAA;EACA,8BAAA;AzI++3BpB;AyIt+3BgB;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;AzIw+3BpB;AyIl+3BgB;EACI,aAAA;AzIo+3BpB;AyIh+3BgB;EACI,aAAA;AzIk+3BpB;AyI393BQ;EACI,uBAAA;AzI693BZ;AyIx93BY;EACI,qCAAA;AzI093BhB;AyIz93BgB;EACI,YAAA;EACA,2BAAA;EACA,oCAAA;AzI293BpB;AyI193BoB;EACI,uBAAA;EACA,8BAAA;EACA,kCAAA;EACA,gDAAA;AzI493BxB;AyIr93BI;EACI,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kCAAA;AzIu93BR;AyIr93BI;EACI,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,oCAAA;AzIu93BR;AyIp93BI;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EAAA,kBAAA;EACA,4BAAA;EACA,6DAAA;AzIs93BR;AyIp93BI;EACI;IACI,UAAA;IACA,4BAAA;EzIs93BV;EyIp93BM;IACI,UAAA;IACA,wBAAA;EzIs93BV;AACF;AyIp93BI;EACI;IACI,UAAA;IACA,4BAAA;EzIs93BV;AACF;AyI/83BoB;EACI,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AzIi93BxB;AyI/83B4B;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;AzIi93BhC;AyIx83BI;EACI,WAAA;AzI083BR;AyIv83BgB;EACI,oDAAA;EACA,4BAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;AzIy83BpB;AyIj83BgB;;EAEI,aAAA;AzIm83BpB;AyI/73BwB;EACI,aAAA;AzIi83B5B;AyI973B4B;;EAEI,uBAAA;AzIg83BhC;AyI973B4B;;EAEI,4BAAA;AzIg83BhC;AyI973B4B;;EAEI,aAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;AzIg83BhC;AyIt73BQ;EACI,uBAAA;AzIw73BZ;AyIt73BgB;EACI,mBAAA;EACA,oBAAA;EACA,sBAAA;AzIw73BpB;AyIt73BgB;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;AzIw73BpB;AyIl73BI;EACI,2BAAA;AzIo73BR;AyIn73BQ;EACI,gBAAA;EACA,iBAAA;AzIq73BZ;AyIn73BgB;EACI,QAAA;EACA,cAAA;AzIq73BpB;;AyI963BA,iBAAA;AACA;EAEQ;IACI,sDAAA;EzIg73BV;EyI563BU;IACI,sBAAA;EzI863Bd;EyI163BM;IACI,sBAAA;EzI463BV;EyIz63BM;IACI,sBAAA;EzI263BV;EyI163BU;IACI,gDAAA;EzI463Bd;AACF;AyIv63BA,kBAAA;AACA;EAEQ;IACI,sDAAA;EzIw63BV;EyIp63BU;IACI,sBAAA;EzIs63Bd;EyIl63BM;IACI,sBAAA;EzIo63BV;EyIj63BM;IACI,sBAAA;EzIm63BV;EyIl63BU;IACI,gDAAA;EzIo63Bd;AACF;AyI/53BA,iBAAA;AACA;EAEQ;IACI,sDAAA;EzIg63BV;EyI553BU;IACI,sBAAA;EzI853Bd;EyI153BM;IACI,sBAAA;EzI453BV;EyIz53BM;IACI,sBAAA;EzI253BV;EyI153BU;IACI,gDAAA;EzI453Bd;AACF;AyIv53BA,iBAAA;AACA;EAEQ;IACI,6BAAA;EzIw53BV;EyIp53BU;IACI,sBAAA;EzIs53Bd;EyIl53BM;IACI,sBAAA;EzIo53BV;EyIh53BU;IACI,gDAAA;EzIk53Bd;AACF;AyI743BA,kBAAA;AACA;EAEQ;IACI,6BAAA;EzI843BV;EyI143BU;IACI,sBAAA;EzI443Bd;EyIx43BM;IACI,sBAAA;EzI043BV;EyIt43BU;IACI,gDAAA;EzIw43Bd;AACF;AyIn43BA,iBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;AC5dA,iBAAA;AAOA,iBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,iBAAA;AAIA,iBAAA;AACA;EAGY;IACI,SAAA;IACA,eAAA;E1Iyz4Bd;AACF;A0Ipz4BA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;ACtDI;EACI,gBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,8BAAA;A3I614BR;A2I514BQ;EACI,wBAAA;EACA,8BAAA;A3I814BZ;A2I714BY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,0DAAA;EACA,wBAAA;EACA,4BAAA;A3I+14BhB;A2I314BI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;A3I614BR;A2I514BQ;EACI,UAAA;A3I814BZ;A2I714BY;EACI,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,oCAAA;A3I+14BhB;A2I914BgB;EACI,gCAAA;EACA,uCAAA;A3Ig24BpB;A2I914BgB;EACI,gBAAA;EACA,gCAAA;EACA,uCAAA;A3Ig24BpB;A2I314BI;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A3I614BR;A2I314BY;EACI,8BAAA;EACA,wBAAA;A3I614BhB;A2I514BgB;EACI,8BAAA;A3I814BpB;A2I114BQ;EACI,WAAA;EACA,YAAA;A3I414BZ;A2I114BgB;EACI,qBAAA;EACA,8BAAA;A3I414BpB;A2Iz14BY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;A3I214BhB;A2I114BgB;EACI,qBAAA;EACA,8BAAA;A3I414BpB;;A2Ir14BA,iBAAA;AACA;EAEQ;IACI,4BAAA;E3Iu14BV;E2In14Bc;IACI,OAAA;IACA,YAAA;E3Iq14BlB;E2Ih14BU;;IAEI,WAAA;E3Ik14Bd;E2I704BM;IACI,UAAA;E3I+04BV;E2I904BU;IACI,eAAA;E3Ig14Bd;AACF;A2I304BA,kBAAA;AACA;EAEQ;IACI,4BAAA;E3I404BV;E2Iz04BU;IACI,WAAA;E3I204Bd;E2Iz04BU;;IAEI,WAAA;E3I204Bd;E2It04BM;IACI,UAAA;E3Iw04BV;E2Iv04BU;IACI,eAAA;E3Iy04Bd;AACF;A2Ip04BA,iBAAA;AACA;EAEQ;IACI,4BAAA;E3Iq04BV;E2Il04BU;IACI,WAAA;E3Io04Bd;E2Il04BU;;IAEI,WAAA;E3Io04Bd;E2I/z4BM;IACI,UAAA;E3Ii04BV;E2Ih04BU;IACI,eAAA;E3Ik04Bd;AACF;A2I7z4BA,iBAAA;AACA;EAEQ;IACI,4BAAA;E3I8z4BV;E2I1z4BM;IACI,UAAA;E3I4z4BV;E2I3z4BU;IACI,eAAA;E3I6z4Bd;AACF;A2Ixz4BA,kBAAA;AACA;EAEQ;IACI,4BAAA;E3Iyz4BV;E2Irz4BM;IACI,UAAA;E3Iuz4BV;E2Itz4BU;IACI,eAAA;E3Iwz4Bd;AACF;A2Inz4BA,iBAAA;AACA;EAEQ;IACI,UAAA;E3Ioz4BV;E2Inz4BU;IACI,eAAA;E3Iqz4Bd;AACF;A2Ihz4BA,iBAAA;AACA;EAEQ;IACI,UAAA;E3Iiz4BV;E2Ihz4BU;IACI,eAAA;E3Ikz4Bd;AACF;A2I7y4BA,kBAAA;AAIA,iBAAA;AAIA,kBAAA;AAIA,kBAAA;AAIA,uBAAA;AAIA,eAAA;A3I3QA;EAAA;A2I2QA;A3I3QA;EAAA,6B2I2QA;E3I3QA;A2I2QA;A3I3QA;EAAA;IAAA;E2I2QA;AAAA;A3I3QA;EAAA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;AAAA;A3I3QA;EAAA;IAAA;E2I2QA;E3I3QA;IAAA;E2I2QA;AAAA","sourcesContent":["/*\nTemplate Name: Prompt Kit\nAuthor: CoderThemes\nVersion: 1.0.0\nWebsite: https://coderthemes.com/\nContact: support@coderthemes.com\nFile: Main Css File\n*/\n\n@import 'tailwindcss/base';\n\n@import 'tailwindcss/components';\n\n@import 'tailwindcss/utilities';\n\n// FONTS\n@import 'custom/fonts';\n\n//CORE FILES\n@import '../../../node_modules/bootstrap/scss/functions';\n@import '../../../node_modules/bootstrap/scss/variables';\n@import 'skins/default/variables';\n@import 'skins/default/custom-variables';\n@import '../../../node_modules/bootstrap/scss/bootstrap';\n\n// general\n@import 'custom/colors';\n@import 'custom/general';\n@import 'custom/typography';\n@import 'custom/spacing.scss';\n\n// components\n@import 'components/accordions';\n@import 'components/alerts';\n@import 'components/badge';\n@import 'components/backgrounds';\n@import 'components/breadcrumb';\n@import 'components/buttons';\n@import 'components/card';\n@import 'components/dropdown';\n@import 'components/forms';\n@import 'components/modal';\n@import 'components/navbar';\n@import 'components/nav';\n@import 'components/pagination';\n@import 'components/popover';\n@import 'components/progress';\n@import 'components/reboot';\n@import 'components/tables';\n@import 'components/type';\n@import 'components/helper';\n@import 'components/list';\n@import 'components/widgets';\n@import 'components/custom-checkbox';\n@import 'components/custom-radio';\n@import 'components/print';\n@import 'components/preloader';\n@import 'components/tooltip';\n@import 'components/sidebar';\n@import 'components/input';\n@import 'components/select-ap';\n\n// custom plugins\n@import 'custom/plugins/rateit';\n@import 'custom/plugins/gallery';\n@import 'custom/plugins/daterange';\n@import 'custom/plugins/leaflet';\n@import 'custom/plugins/jarallex';\n@import 'custom/plugins/swiper';\n@import 'custom/plugins/lightbox';\n@import 'custom/plugins/aos';\n\n// structure\n@import 'custom/structure/sidenav';\n@import 'custom/structure/footer';\n\n// custom components\n@import 'custom/components/icons';\n@import 'custom/components/avatar';\n@import 'custom/components/ribbon';\n\n// theme components\n@import 'custom/components/header';\n@import 'custom/components/hero';\n@import 'custom/components/features';\n@import 'custom/components/testimonials';\n\n// pages\n@import 'custom/pages/docs';\n@import 'custom/pages/portfolio';\n@import 'custom/pages/gallery';\n@import 'custom/pages/ppic';\n@import 'custom/pages/dashboard';\n@import 'custom/pages/assessment';\n@import 'custom/pages/auth';\n@import 'custom/pages/planning';\n@import 'custom/pages/bakul';\n@import 'custom/pages/create-ppic';\n@import 'custom/pages/panen';\n","@tailwind base;\n","@tailwind utilities;\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.2 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Font weight\r\n$font-weight-regular: 400;\r\n$font-weight-medium: 500;\r\n$font-weight-semibold: 600;\r\n\r\n// custom-color\r\n$gray-50: lighten($gray-100, 2%);\r\n\r\n// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n// Color system\r\n\r\n// scss-docs-start gray-color-variables\r\n$white: #fff;\r\n$gray-100: #f4f5f7;\r\n$gray-200: #f3f4f7;\r\n$gray-300: #dee2e6;\r\n$gray-400: #cdcdcd;\r\n$gray-500: #adb5bd;\r\n$gray-600: #787878;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black: #000;\r\n// scss-docs-end gray-color-variables\r\n\r\n// fusv-disable\r\n// scss-docs-start gray-colors-map\r\n$grays: (\r\n    '100': $gray-100,\r\n    '200': $gray-200,\r\n    '300': $gray-300,\r\n    '400': $gray-400,\r\n    '500': $gray-500,\r\n    '600': $gray-600,\r\n    '700': $gray-700,\r\n    '800': $gray-800,\r\n    '900': $gray-900,\r\n);\r\n// scss-docs-end gray-colors-map\r\n// fusv-enable\r\n\r\n// scss-docs-start color-variables\r\n$blue: #0b7f8e;\r\n$indigo: #5c7cfa;\r\n$purple: #a499ff;\r\n$pink: #f06595;\r\n$red: #f0323c;\r\n$orange: #ff784b;\r\n$yellow: #ffc837;\r\n$green: #3cd278;\r\n$teal: #20c997;\r\n$cyan: #17a2b8;\r\n// scss-docs-end color-variables\r\n\r\n// scss-docs-start colors-map\r\n$colors: (\r\n    'blue': $blue,\r\n    'indigo': $indigo,\r\n    'purple': $purple,\r\n    'pink': $pink,\r\n    'red': $red,\r\n    'orange': $orange,\r\n    'yellow': $yellow,\r\n    'green': $green,\r\n    'teal': $teal,\r\n    'cyan': $cyan,\r\n    'white': $white,\r\n    'gray': $gray-600,\r\n    'gray-dark': $gray-800,\r\n);\r\n// scss-docs-end colors-map\r\n\r\n// scss-docs-start theme-color-variables\r\n$primary: $blue;\r\n$secondary: $gray-700;\r\n$success: $green;\r\n$info: $cyan;\r\n$warning: $yellow;\r\n$danger: $red;\r\n$light: $gray-100;\r\n$dark: $gray-800;\r\n$gray-50: $gray-50;\r\n// scss-docs-end theme-color-variables\r\n\r\n// scss-docs-start theme-colors-map\r\n$theme-colors: (\r\n    'primary': $primary,\r\n    'secondary': $secondary,\r\n    'success': $success,\r\n    'info': $info,\r\n    'warning': $warning,\r\n    'danger': $danger,\r\n    'light': $light,\r\n    'dark': $dark,\r\n    'orange': $orange,\r\n    'teal': $teal,\r\n    'gray-50': $gray-50,\r\n);\r\n// scss-docs-end theme-colors-map\r\n\r\n// scss-docs-start theme-colors-rgb\r\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, '$value');\r\n// scss-docs-end theme-colors-rgb\r\n\r\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\r\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\r\n$min-contrast-ratio: 1.8;\r\n\r\n// Customize the light and dark text colors for use in our color contrast function.\r\n$color-contrast-dark: $gray-900;\r\n$color-contrast-light: $white;\r\n\r\n// fusv-disable\r\n$blue-100: tint-color($blue, 80%);\r\n$blue-200: tint-color($blue, 60%);\r\n$blue-300: tint-color($blue, 40%);\r\n$blue-400: tint-color($blue, 20%);\r\n$blue-500: $blue;\r\n$blue-600: shade-color($blue, 20%);\r\n$blue-700: shade-color($blue, 40%);\r\n$blue-800: shade-color($blue, 60%);\r\n$blue-900: shade-color($blue, 80%);\r\n\r\n$indigo-100: tint-color($indigo, 80%);\r\n$indigo-200: tint-color($indigo, 60%);\r\n$indigo-300: tint-color($indigo, 40%);\r\n$indigo-400: tint-color($indigo, 20%);\r\n$indigo-500: $indigo;\r\n$indigo-600: shade-color($indigo, 20%);\r\n$indigo-700: shade-color($indigo, 40%);\r\n$indigo-800: shade-color($indigo, 60%);\r\n$indigo-900: shade-color($indigo, 80%);\r\n\r\n$purple-100: tint-color($purple, 80%);\r\n$purple-200: tint-color($purple, 60%);\r\n$purple-300: tint-color($purple, 40%);\r\n$purple-400: tint-color($purple, 20%);\r\n$purple-500: $purple;\r\n$purple-600: shade-color($purple, 20%);\r\n$purple-700: shade-color($purple, 40%);\r\n$purple-800: shade-color($purple, 60%);\r\n$purple-900: shade-color($purple, 80%);\r\n\r\n$pink-100: tint-color($pink, 80%);\r\n$pink-200: tint-color($pink, 60%);\r\n$pink-300: tint-color($pink, 40%);\r\n$pink-400: tint-color($pink, 20%);\r\n$pink-500: $pink;\r\n$pink-600: shade-color($pink, 20%);\r\n$pink-700: shade-color($pink, 40%);\r\n$pink-800: shade-color($pink, 60%);\r\n$pink-900: shade-color($pink, 80%);\r\n\r\n$red-100: tint-color($red, 80%);\r\n$red-200: tint-color($red, 60%);\r\n$red-300: tint-color($red, 40%);\r\n$red-400: tint-color($red, 20%);\r\n$red-500: $red;\r\n$red-600: shade-color($red, 20%);\r\n$red-700: shade-color($red, 40%);\r\n$red-800: shade-color($red, 60%);\r\n$red-900: shade-color($red, 80%);\r\n\r\n$orange-100: tint-color($orange, 80%);\r\n$orange-200: tint-color($orange, 60%);\r\n$orange-300: tint-color($orange, 40%);\r\n$orange-400: tint-color($orange, 20%);\r\n$orange-500: $orange;\r\n$orange-600: shade-color($orange, 20%);\r\n$orange-700: shade-color($orange, 40%);\r\n$orange-800: shade-color($orange, 60%);\r\n$orange-900: shade-color($orange, 80%);\r\n\r\n$yellow-100: tint-color($yellow, 80%);\r\n$yellow-200: tint-color($yellow, 60%);\r\n$yellow-300: tint-color($yellow, 40%);\r\n$yellow-400: tint-color($yellow, 20%);\r\n$yellow-500: $yellow;\r\n$yellow-600: shade-color($yellow, 20%);\r\n$yellow-700: shade-color($yellow, 40%);\r\n$yellow-800: shade-color($yellow, 60%);\r\n$yellow-900: shade-color($yellow, 80%);\r\n\r\n$green-100: tint-color($green, 80%);\r\n$green-200: tint-color($green, 60%);\r\n$green-300: tint-color($green, 40%);\r\n$green-400: tint-color($green, 20%);\r\n$green-500: $green;\r\n$green-600: shade-color($green, 20%);\r\n$green-700: shade-color($green, 40%);\r\n$green-800: shade-color($green, 60%);\r\n$green-900: shade-color($green, 80%);\r\n\r\n$teal-100: tint-color($teal, 80%);\r\n$teal-200: tint-color($teal, 60%);\r\n$teal-300: tint-color($teal, 40%);\r\n$teal-400: tint-color($teal, 20%);\r\n$teal-500: $teal;\r\n$teal-600: shade-color($teal, 20%);\r\n$teal-700: shade-color($teal, 40%);\r\n$teal-800: shade-color($teal, 60%);\r\n$teal-900: shade-color($teal, 80%);\r\n\r\n$cyan-100: tint-color($cyan, 80%);\r\n$cyan-200: tint-color($cyan, 60%);\r\n$cyan-300: tint-color($cyan, 40%);\r\n$cyan-400: tint-color($cyan, 20%);\r\n$cyan-500: $cyan;\r\n$cyan-600: shade-color($cyan, 20%);\r\n$cyan-700: shade-color($cyan, 40%);\r\n$cyan-800: shade-color($cyan, 60%);\r\n$cyan-900: shade-color($cyan, 80%);\r\n\r\n$blues: (\r\n    'blue-100': $blue-100,\r\n    'blue-200': $blue-200,\r\n    'blue-300': $blue-300,\r\n    'blue-400': $blue-400,\r\n    'blue-500': $blue-500,\r\n    'blue-600': $blue-600,\r\n    'blue-700': $blue-700,\r\n    'blue-800': $blue-800,\r\n    'blue-900': $blue-900,\r\n);\r\n\r\n$indigos: (\r\n    'indigo-100': $indigo-100,\r\n    'indigo-200': $indigo-200,\r\n    'indigo-300': $indigo-300,\r\n    'indigo-400': $indigo-400,\r\n    'indigo-500': $indigo-500,\r\n    'indigo-600': $indigo-600,\r\n    'indigo-700': $indigo-700,\r\n    'indigo-800': $indigo-800,\r\n    'indigo-900': $indigo-900,\r\n);\r\n\r\n$purples: (\r\n    'purple-100': $purple-200,\r\n    'purple-200': $purple-100,\r\n    'purple-300': $purple-300,\r\n    'purple-400': $purple-400,\r\n    'purple-500': $purple-500,\r\n    'purple-600': $purple-600,\r\n    'purple-700': $purple-700,\r\n    'purple-800': $purple-800,\r\n    'purple-900': $purple-900,\r\n);\r\n\r\n$pinks: (\r\n    'pink-100': $pink-100,\r\n    'pink-200': $pink-200,\r\n    'pink-300': $pink-300,\r\n    'pink-400': $pink-400,\r\n    'pink-500': $pink-500,\r\n    'pink-600': $pink-600,\r\n    'pink-700': $pink-700,\r\n    'pink-800': $pink-800,\r\n    'pink-900': $pink-900,\r\n);\r\n\r\n$reds: (\r\n    'red-100': $red-100,\r\n    'red-200': $red-200,\r\n    'red-300': $red-300,\r\n    'red-400': $red-400,\r\n    'red-500': $red-500,\r\n    'red-600': $red-600,\r\n    'red-700': $red-700,\r\n    'red-800': $red-800,\r\n    'red-900': $red-900,\r\n);\r\n\r\n$oranges: (\r\n    'orange-100': $orange-100,\r\n    'orange-200': $orange-200,\r\n    'orange-300': $orange-300,\r\n    'orange-400': $orange-400,\r\n    'orange-500': $orange-500,\r\n    'orange-600': $orange-600,\r\n    'orange-700': $orange-700,\r\n    'orange-800': $orange-800,\r\n    'orange-900': $orange-900,\r\n);\r\n\r\n$yellows: (\r\n    'yellow-100': $yellow-100,\r\n    'yellow-200': $yellow-200,\r\n    'yellow-300': $yellow-300,\r\n    'yellow-400': $yellow-400,\r\n    'yellow-500': $yellow-500,\r\n    'yellow-600': $yellow-600,\r\n    'yellow-700': $yellow-700,\r\n    'yellow-800': $yellow-800,\r\n    'yellow-900': $yellow-900,\r\n);\r\n\r\n$greens: (\r\n    'green-100': $green-100,\r\n    'green-200': $green-200,\r\n    'green-300': $green-300,\r\n    'green-400': $green-400,\r\n    'green-500': $green-500,\r\n    'green-600': $green-600,\r\n    'green-700': $green-700,\r\n    'green-800': $green-800,\r\n    'green-900': $green-900,\r\n);\r\n\r\n$teals: (\r\n    'teal-100': $teal-100,\r\n    'teal-200': $teal-200,\r\n    'teal-300': $teal-300,\r\n    'teal-400': $teal-400,\r\n    'teal-500': $teal-500,\r\n    'teal-600': $teal-600,\r\n    'teal-700': $teal-700,\r\n    'teal-800': $teal-800,\r\n    'teal-900': $teal-900,\r\n);\r\n\r\n$cyans: (\r\n    'cyan-100': $cyan-100,\r\n    'cyan-200': $cyan-200,\r\n    'cyan-300': $cyan-300,\r\n    'cyan-400': $cyan-400,\r\n    'cyan-500': $cyan-500,\r\n    'cyan-600': $cyan-600,\r\n    'cyan-700': $cyan-700,\r\n    'cyan-800': $cyan-800,\r\n    'cyan-900': $cyan-900,\r\n);\r\n// fusv-enable\r\n\r\n// Characters which are escaped by the escape-svg function\r\n$escaped-characters: (('<', '%3c'), ('>', '%3e'), ('#', '%23'), ('(', '%28'), (')', '%29'));\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret: false;\r\n$enable-rounded: true;\r\n$enable-shadows: false;\r\n$enable-gradients: false;\r\n$enable-transitions: true;\r\n$enable-reduced-motion: true;\r\n$enable-smooth-scroll: true;\r\n$enable-grid-classes: true;\r\n$enable-container-classes: true;\r\n$enable-cssgrid: false;\r\n$enable-button-pointers: true;\r\n$enable-rfs: true;\r\n$enable-validation-icons: true;\r\n$enable-negative-margins: true;\r\n$enable-deprecation-messages: true;\r\n$enable-important-utilities: true;\r\n\r\n// Prefix for :root CSS variables\r\n\r\n$variable-prefix: bs-;\r\n\r\n// Gradient\r\n//\r\n// The gradient which is added to components if `$enable-gradients` is `true`\r\n// This gradient is also added to elements with `.bg-gradient`\r\n// scss-docs-start variable-gradient\r\n$gradient: linear-gradient(180deg, rgba($white, 0.15), rgba($white, 0));\r\n// scss-docs-end variable-gradient\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// scss-docs-start spacer-variables-maps\r\n$spacer: 1rem;\r\n$spacers: (\r\n    0: 0,\r\n    1: (\r\n        $spacer * 0.25,\r\n    ),\r\n    2: (\r\n        $spacer * 0.5,\r\n    ),\r\n    3: $spacer,\r\n    4: (\r\n        $spacer * 1.5,\r\n    ),\r\n    5: (\r\n        $spacer * 3,\r\n    ),\r\n    6: (\r\n        $spacer * 4.5,\r\n    ),\r\n    7: (\r\n        $spacer * 6,\r\n    ),\r\n    8: (\r\n        $spacer * 7.5,\r\n    ),\r\n    9: (\r\n        $spacer * 9,\r\n    ),\r\n    10: (\r\n        $spacer * 11.5,\r\n    ),\r\n);\r\n\r\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\r\n// scss-docs-end spacer-variables-maps\r\n\r\n// Position\r\n//\r\n// Define the edge positioning anchors of the position utilities.\r\n\r\n// scss-docs-start position-map\r\n$position-values: (\r\n    0: 0,\r\n    50: 50%,\r\n    100: 100%,\r\n);\r\n// scss-docs-end position-map\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg: $white;\r\n$body-color: $gray-700;\r\n$body-text-align: null;\r\n\r\n// Utilities maps\r\n//\r\n// Extends the default `$theme-colors` maps to help create our utilities.\r\n\r\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\r\n// scss-docs-start utilities-colors\r\n$utilities-colors: $theme-colors-rgb;\r\n// scss-docs-end utilities-colors\r\n\r\n// scss-docs-start utilities-text-colors\r\n$utilities-text: map-merge(\r\n    $utilities-colors,\r\n    (\r\n        'black': to-rgb($black),\r\n        'white': to-rgb($white),\r\n        'body': to-rgb($body-color),\r\n    )\r\n);\r\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, '$key', 'text');\r\n// scss-docs-end utilities-text-colors\r\n\r\n// scss-docs-start utilities-bg-colors\r\n$utilities-bg: map-merge(\r\n    $utilities-colors,\r\n    (\r\n        'black': to-rgb($black),\r\n        'white': to-rgb($white),\r\n        'body': to-rgb($body-bg),\r\n    )\r\n);\r\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, '$key', 'bg');\r\n// scss-docs-end utilities-bg-colors\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color: $body-color;\r\n$link-decoration: none;\r\n$link-shade-percentage: 30%;\r\n$link-hover-color: $primary;\r\n$link-hover-decoration: underline;\r\n\r\n$stretched-link-pseudo-element: after;\r\n$stretched-link-z-index: 1;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom: 1rem;\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n// scss-docs-start grid-breakpoints\r\n$grid-breakpoints: (\r\n    xs: 0,\r\n    sm: 576px,\r\n    md: 768px,\r\n    lg: 992px,\r\n    xl: 1200px,\r\n    xxl: 1400px,\r\n);\r\n// scss-docs-end grid-breakpoints\r\n\r\n@include _assert-ascending($grid-breakpoints, '$grid-breakpoints');\r\n@include _assert-starts-at-zero($grid-breakpoints, '$grid-breakpoints');\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n// scss-docs-start container-max-widths\r\n$container-max-widths: (\r\n    sm: 570px,\r\n    md: 720px,\r\n    lg: 960px,\r\n    xl: 1140px,\r\n    xxl: 1440px,\r\n);\r\n// scss-docs-end container-max-widths\r\n\r\n@include _assert-ascending($container-max-widths, '$container-max-widths');\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns: 12;\r\n$grid-gutter-width: 1.5rem;\r\n$grid-row-columns: 6;\r\n\r\n$gutters: $spacers;\r\n\r\n// Container padding\r\n\r\n$container-padding-x: $grid-gutter-width * 0.5;\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n// scss-docs-start border-variables\r\n$border-width: 1px;\r\n$border-widths: (\r\n    1: 1px,\r\n    2: 2px,\r\n    3: 3px,\r\n    4: 4px,\r\n    5: 5px,\r\n);\r\n\r\n$border-color: $gray-300;\r\n// scss-docs-end border-variables\r\n\r\n// scss-docs-start border-radius-variables\r\n$border-radius: 0.375rem;\r\n$border-radius-sm: 0.25rem;\r\n$border-radius-lg: 0.5rem;\r\n$border-radius-pill: 50rem;\r\n// scss-docs-end border-radius-variables\r\n\r\n// scss-docs-start box-shadow-variables\r\n$box-shadow: 0 7px 14px 0 rgba($dark, 0.06);\r\n$box-shadow-sm: 0 0 0.25rem rgba($gray-700, 0.05);\r\n$box-shadow-lg: 0 0.8rem 1.2rem rgba($dark, 0.08);\r\n$box-shadow-inset: inset 0 1px 2px rgba($black, 0.075);\r\n// scss-docs-end box-shadow-variables\r\n\r\n$component-active-color: $white;\r\n$component-active-bg: $primary;\r\n\r\n// scss-docs-start caret-variables\r\n$caret-width: 0.3em;\r\n$caret-vertical-align: $caret-width * 0.85;\r\n$caret-spacing: $caret-width * 0.85;\r\n// scss-docs-end caret-variables\r\n\r\n$transition-base: all 0.3s ease-in-out;\r\n$transition-fade: opacity 0.15s linear;\r\n// scss-docs-start collapse-transition\r\n$transition-collapse: height 0.35s ease;\r\n$transition-collapse-width: width 0.35s ease;\r\n// scss-docs-end collapse-transition\r\n\r\n// stylelint-disable function-disallowed-list\r\n// scss-docs-start aspect-ratios\r\n$aspect-ratios: (\r\n    '1x1': 100%,\r\n    '4x3': calc(3 / 4 * 100%),\r\n    '16x9': calc(9 / 16 * 100%),\r\n    '21x9': calc(9 / 21 * 100%),\r\n);\r\n// scss-docs-end aspect-ratios\r\n// stylelint-enable function-disallowed-list\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// scss-docs-start font-variables\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Be Vietnam Pro', sans-serif;\r\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\r\n// stylelint-enable value-keyword-case\r\n$font-family-base: $font-family-sans-serif;\r\n$font-family-code: var(--#{$variable-prefix}font-monospace);\r\n\r\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\r\n// $font-size-base affects the font size of the body text\r\n$font-size-root: null;\r\n$font-size-base: 0.9375rem; // Assumes the browser default, typically `16px`\r\n$font-size-sm: $font-size-base * 0.875;\r\n$font-size-lg: $font-size-base * 1.25;\r\n\r\n$font-weight-lighter: lighter;\r\n$font-weight-light: 300;\r\n$font-weight-normal: 400;\r\n$font-weight-bold: 600;\r\n$font-weight-bolder: 700;\r\n\r\n$font-weight-base: $font-weight-normal;\r\n\r\n$line-height-base: 1.5;\r\n$line-height-sm: 1.25;\r\n$line-height-lg: 2;\r\n\r\n$h1-font-size: $font-size-base * 1.9;\r\n$h2-font-size: $font-size-base * 1.65;\r\n$h3-font-size: $font-size-base * 1.4;\r\n$h4-font-size: $font-size-base * 1.15;\r\n$h5-font-size: $font-size-base;\r\n$h6-font-size: $font-size-base * 0.9;\r\n// scss-docs-end font-variables\r\n\r\n// scss-docs-start font-sizes\r\n$font-sizes: (\r\n    1: $h1-font-size,\r\n    2: $h2-font-size,\r\n    3: $h3-font-size,\r\n    4: $h4-font-size,\r\n    5: $h5-font-size,\r\n    6: $h6-font-size,\r\n);\r\n// scss-docs-end font-sizes\r\n\r\n// scss-docs-start headings-variables\r\n$headings-margin-bottom: $spacer * 0.5;\r\n$headings-font-family: null;\r\n$headings-font-style: null;\r\n$headings-font-weight: 500;\r\n$headings-line-height: 1.4;\r\n$headings-color: null;\r\n// scss-docs-end headings-variables\r\n\r\n// scss-docs-start display-headings\r\n$display-font-sizes: (\r\n    1: 5rem,\r\n    2: 4rem,\r\n    3: 3rem,\r\n    4: 2rem,\r\n    6: 1rem,\r\n);\r\n\r\n$display-font-weight: 300;\r\n$display-line-height: 1.2;\r\n// scss-docs-end display-headings\r\n\r\n// scss-docs-start type-variables\r\n$lead-font-size: $font-size-base * 1.25;\r\n$lead-font-weight: 300;\r\n\r\n$small-font-size: 0.875em;\r\n\r\n$sub-sup-font-size: 0.75em;\r\n\r\n$text-muted: #8a90a2;\r\n\r\n$initialism-font-size: $small-font-size;\r\n\r\n$blockquote-margin-y: $spacer;\r\n$blockquote-font-size: $font-size-base * 1.25;\r\n$blockquote-footer-color: $gray-600;\r\n$blockquote-footer-font-size: $small-font-size;\r\n\r\n$hr-margin-y: $spacer;\r\n$hr-color: $gray-700;\r\n$hr-bg-color: currentColor;\r\n$hr-border-width: 0;\r\n$hr-height: $border-width;\r\n$hr-opacity: 0.1;\r\n\r\n$legend-margin-bottom: 0.5rem;\r\n$legend-font-size: 1.5rem;\r\n$legend-font-weight: null;\r\n\r\n$mark-padding: 0.2em;\r\n\r\n$dt-font-weight: $font-weight-bold;\r\n\r\n$nested-kbd-font-weight: $font-weight-bold;\r\n\r\n$list-inline-padding: 0.5rem;\r\n\r\n$mark-bg: #fcf8e3;\r\n// scss-docs-end type-variables\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n// scss-docs-start table-variables\r\n$table-cell-padding-y: 0.75rem;\r\n$table-cell-padding-x: 0.75rem;\r\n$table-cell-padding-y-sm: $table-cell-padding-y * 5;\r\n$table-cell-padding-x-sm: $table-cell-padding-x * 5;\r\n\r\n$table-cell-vertical-align: top;\r\n\r\n$table-color: $body-color;\r\n$table-bg: transparent;\r\n$table-accent-bg: transparent;\r\n\r\n$table-th-font-weight: null;\r\n\r\n$table-striped-color: $table-color;\r\n$table-striped-bg-factor: 1;\r\n$table-striped-bg: rgba($gray-200, $table-striped-bg-factor);\r\n\r\n$table-active-color: $table-color;\r\n$table-active-bg-factor: 1;\r\n$table-active-bg: rgba($gray-200, $table-active-bg-factor);\r\n\r\n$table-hover-color: $table-color;\r\n$table-hover-bg-factor: 1;\r\n$table-hover-bg: rgba($gray-200, $table-hover-bg-factor);\r\n\r\n$table-border-factor: 0.1;\r\n$table-border-width: $border-width;\r\n$table-border-color: $border-color;\r\n\r\n$table-striped-order: odd;\r\n\r\n$table-group-separator-color: $gray-300;\r\n\r\n$table-caption-color: $text-muted;\r\n\r\n$table-bg-scale: -80%;\r\n// scss-docs-end table-variables\r\n\r\n// scss-docs-start table-loop\r\n$table-variants: (\r\n    'primary': shift-color($primary, $table-bg-scale),\r\n    'secondary': shift-color($secondary, $table-bg-scale),\r\n    'success': shift-color($success, $table-bg-scale),\r\n    'info': shift-color($info, $table-bg-scale),\r\n    'warning': shift-color($warning, $table-bg-scale),\r\n    'danger': shift-color($danger, $table-bg-scale),\r\n    'light': $gray-100,\r\n    'dark': $dark,\r\n);\r\n// scss-docs-end table-loop\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n// scss-docs-start input-btn-variables\r\n$input-btn-padding-y: 0.5625rem;\r\n$input-btn-padding-x: 1rem;\r\n$input-btn-font-family: null;\r\n$input-btn-font-size: $font-size-base;\r\n$input-btn-line-height: $line-height-base;\r\n\r\n$input-btn-focus-width: 0.15rem;\r\n$input-btn-focus-color-opacity: 0.25;\r\n$input-btn-focus-color: rgba($component-active-bg, $input-btn-focus-color-opacity);\r\n$input-btn-focus-blur: 0;\r\n$input-btn-focus-box-shadow: 0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\r\n\r\n$input-btn-padding-y-sm: 0.375rem;\r\n$input-btn-padding-x-sm: 0.75rem;\r\n$input-btn-font-size-sm: $font-size-sm;\r\n\r\n$input-btn-padding-y-lg: 0.9375rem;\r\n$input-btn-padding-x-lg: 1.25rem;\r\n$input-btn-font-size-lg: $font-size-lg;\r\n\r\n$input-btn-border-width: $border-width;\r\n// scss-docs-end input-btn-variables\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n// scss-docs-start btn-variables\r\n$btn-padding-y: $input-btn-padding-y;\r\n$btn-padding-x: $input-btn-padding-x;\r\n$btn-font-family: $input-btn-font-family;\r\n$btn-font-size: $input-btn-font-size;\r\n$btn-line-height: $input-btn-line-height;\r\n$btn-white-space: null; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm: $input-btn-padding-y-sm;\r\n$btn-padding-x-sm: $input-btn-padding-x-sm;\r\n$btn-font-size-sm: $input-btn-font-size-sm;\r\n\r\n$btn-padding-y-lg: $input-btn-padding-y-lg;\r\n$btn-padding-x-lg: $input-btn-padding-x-lg;\r\n$btn-font-size-lg: $input-btn-font-size-lg;\r\n\r\n$btn-border-width: $input-btn-border-width;\r\n\r\n$btn-font-weight: $font-weight-medium;\r\n$btn-box-shadow: none;\r\n$btn-focus-width: $input-btn-focus-width;\r\n$btn-focus-box-shadow: $input-btn-focus-box-shadow;\r\n$btn-disabled-opacity: 0.65;\r\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, 0.125);\r\n\r\n$btn-link-color: $link-color;\r\n$btn-link-hover-color: $link-hover-color;\r\n$btn-link-disabled-color: $gray-600;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius: $border-radius;\r\n$btn-border-radius-sm: $border-radius-sm;\r\n$btn-border-radius-lg: $border-radius-lg;\r\n\r\n$btn-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n\r\n$btn-hover-bg-shade-amount: 15%;\r\n$btn-hover-bg-tint-amount: 15%;\r\n$btn-hover-border-shade-amount: 20%;\r\n$btn-hover-border-tint-amount: 10%;\r\n$btn-active-bg-shade-amount: 20%;\r\n$btn-active-bg-tint-amount: 20%;\r\n$btn-active-border-shade-amount: 25%;\r\n$btn-active-border-tint-amount: 10%;\r\n// scss-docs-end btn-variables\r\n\r\n// Forms\r\n\r\n// scss-docs-start form-text-variables\r\n$form-text-margin-top: 0.25rem;\r\n$form-text-font-size: $small-font-size;\r\n$form-text-font-style: null;\r\n$form-text-font-weight: null;\r\n$form-text-color: $text-muted;\r\n// scss-docs-end form-text-variables\r\n\r\n// scss-docs-start form-label-variables\r\n$form-label-margin-bottom: 0.25rem;\r\n$form-label-font-size: null;\r\n$form-label-font-style: null;\r\n$form-label-font-weight: $font-weight-semibold;\r\n$form-label-color: null;\r\n// scss-docs-end form-label-variables\r\n\r\n// scss-docs-start form-input-variables\r\n$input-padding-y: $input-btn-padding-y;\r\n$input-padding-x: $input-btn-padding-x;\r\n$input-font-family: $input-btn-font-family;\r\n$input-font-size: $input-btn-font-size;\r\n$input-font-weight: $font-weight-base;\r\n$input-line-height: $input-btn-line-height;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm;\r\n$input-padding-x-sm: $input-btn-padding-x-sm;\r\n$input-font-size-sm: $input-btn-font-size-sm;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg;\r\n$input-padding-x-lg: $input-btn-padding-x-lg;\r\n$input-font-size-lg: $input-btn-font-size-lg;\r\n\r\n$input-bg: $white;\r\n$input-disabled-bg: $white;\r\n$input-disabled-border-color: null;\r\n\r\n$input-color: $body-color;\r\n$input-border-color: $gray-300;\r\n$input-border-width: 1px;\r\n$input-box-shadow: 0px 0px 5px 1px rgba(229, 229, 229, 0.5);\r\n\r\n$input-border-radius: $border-radius-sm;\r\n$input-border-radius-sm: $border-radius-sm;\r\n$input-border-radius-lg: $border-radius-sm;\r\n\r\n$input-focus-bg: $input-bg;\r\n$input-focus-border-color: rgba($black, 0.25);\r\n$input-focus-color: $input-color;\r\n$input-focus-width: $input-btn-focus-width;\r\n$input-focus-box-shadow: none;\r\n\r\n$input-placeholder-color: $gray-400;\r\n$input-plaintext-color: $body-color;\r\n\r\n$input-height-border: $input-border-width * 2;\r\n\r\n$input-height-inner: add($input-line-height * 1em, $input-padding-y * 2);\r\n$input-height-inner-half: add($input-line-height * 0.5em, $input-padding-y);\r\n$input-height-inner-quarter: add($input-line-height * 0.25em, $input-padding-y * 0.5);\r\n\r\n$input-height: add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\r\n$input-height-sm: add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\r\n$input-height-lg: add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\r\n\r\n$input-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n\r\n$form-color-width: 3rem;\r\n// scss-docs-end form-input-variables\r\n\r\n// scss-docs-start form-check-variables\r\n$form-check-input-width: 1em;\r\n$form-check-min-height: $font-size-base * $line-height-base;\r\n$form-check-padding-start: $form-check-input-width + 0.5em;\r\n$form-check-margin-bottom: 0.125rem;\r\n$form-check-label-color: null;\r\n$form-check-label-cursor: null;\r\n$form-check-transition: null;\r\n\r\n$form-check-input-active-filter: brightness(90%);\r\n\r\n$form-check-input-bg: $input-bg;\r\n$form-check-input-border: 1px solid rgba($black, 0.25);\r\n$form-check-input-border-radius: $border-radius-sm;\r\n$form-check-radio-border-radius: 50%;\r\n$form-check-input-focus-border: $input-focus-border-color;\r\n$form-check-input-focus-box-shadow: $input-btn-focus-box-shadow;\r\n\r\n$form-check-input-checked-color: $component-active-color;\r\n$form-check-input-checked-bg-color: $component-active-bg;\r\n$form-check-input-checked-border-color: $form-check-input-checked-bg-color;\r\n$form-check-input-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' strokeWidth='3' d='M6 10l3 3l6-6'/></svg>\");\r\n$form-check-radio-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\r\n\r\n$form-check-input-indeterminate-color: $component-active-color;\r\n$form-check-input-indeterminate-bg-color: $component-active-bg;\r\n$form-check-input-indeterminate-border-color: $form-check-input-indeterminate-bg-color;\r\n$form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' strokeWidth='3' d='M6 10h8'/></svg>\");\r\n\r\n$form-check-input-disabled-opacity: 0.5;\r\n$form-check-label-disabled-opacity: $form-check-input-disabled-opacity;\r\n$form-check-btn-check-disabled-opacity: $btn-disabled-opacity;\r\n\r\n$form-check-inline-margin-end: 1rem;\r\n// scss-docs-end form-check-variables\r\n\r\n// scss-docs-start form-switch-variables\r\n$form-switch-color: rgba(0, 0, 0, 0.25);\r\n$form-switch-width: 2em;\r\n$form-switch-padding-start: $form-switch-width + 0.5em;\r\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\r\n$form-switch-border-radius: $form-switch-width;\r\n$form-switch-transition: background-position 0.15s ease-in-out;\r\n\r\n$form-switch-focus-color: $input-focus-border-color;\r\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\r\n\r\n$form-switch-checked-color: $component-active-color;\r\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\r\n$form-switch-checked-bg-position: right center;\r\n// scss-docs-end form-switch-variables\r\n\r\n// scss-docs-start input-group-variables\r\n$input-group-addon-padding-y: $input-padding-y;\r\n$input-group-addon-padding-x: $input-padding-x;\r\n$input-group-addon-font-weight: $input-font-weight;\r\n$input-group-addon-color: $input-color;\r\n$input-group-addon-bg: $gray-200;\r\n$input-group-addon-border-color: $input-border-color;\r\n// scss-docs-end input-group-variables\r\n\r\n// scss-docs-start form-select-variables\r\n$form-select-padding-y: $input-padding-y;\r\n$form-select-padding-x: $input-padding-x;\r\n$form-select-font-family: $input-font-family;\r\n$form-select-font-size: $input-font-size;\r\n$form-select-indicator-padding: $form-select-padding-x * 3; // Extra padding for background-image\r\n$form-select-font-weight: $input-font-weight;\r\n$form-select-line-height: $input-line-height;\r\n$form-select-color: $input-color;\r\n$form-select-bg: $input-bg;\r\n$form-select-disabled-color: null;\r\n$form-select-disabled-bg: $gray-200;\r\n$form-select-disabled-border-color: $input-disabled-border-color;\r\n$form-select-bg-position: right $form-select-padding-x center;\r\n$form-select-bg-size: 14px 12px; // In pixels because image dimensions\r\n$form-select-indicator-color: $gray-800;\r\n$form-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' strokeWidth='2' d='M2 5l6 6 6-6'/></svg>\");\r\n\r\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\r\n$form-select-feedback-icon-position: center right $form-select-indicator-padding;\r\n$form-select-feedback-icon-size: $input-height-inner-half $input-height-inner-half;\r\n\r\n$form-select-border-width: $input-border-width;\r\n$form-select-border-color: $input-border-color;\r\n$form-select-border-radius: $border-radius-sm;\r\n$form-select-box-shadow: $box-shadow-inset;\r\n\r\n$form-select-focus-border-color: $input-focus-border-color;\r\n$form-select-focus-width: $input-focus-width;\r\n$form-select-focus-box-shadow: 0 0 0 $form-select-focus-width $input-btn-focus-color;\r\n\r\n$form-select-padding-y-sm: $input-padding-y-sm;\r\n$form-select-padding-x-sm: $input-padding-x-sm;\r\n$form-select-font-size-sm: $input-font-size-sm;\r\n$form-select-border-radius-sm: $input-border-radius-sm;\r\n\r\n$form-select-padding-y-lg: $input-padding-y-lg;\r\n$form-select-padding-x-lg: $input-padding-x-lg;\r\n$form-select-font-size-lg: $input-font-size-lg;\r\n$form-select-border-radius-lg: $input-border-radius-lg;\r\n\r\n$form-select-transition: $input-transition;\r\n// scss-docs-end form-select-variables\r\n\r\n// scss-docs-start form-range-variables\r\n$form-range-track-width: 100%;\r\n$form-range-track-height: 0.5rem;\r\n$form-range-track-cursor: pointer;\r\n$form-range-track-bg: $gray-300;\r\n$form-range-track-border-radius: 1rem;\r\n$form-range-track-box-shadow: $box-shadow-inset;\r\n\r\n$form-range-thumb-width: 1rem;\r\n$form-range-thumb-height: $form-range-thumb-width;\r\n$form-range-thumb-bg: $component-active-bg;\r\n$form-range-thumb-border: 0;\r\n$form-range-thumb-border-radius: 1rem;\r\n$form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba($black, 0.1);\r\n$form-range-thumb-focus-box-shadow: 0 0 0 1px $body-bg, $input-focus-box-shadow;\r\n$form-range-thumb-focus-box-shadow-width: $input-focus-width; // For focus box shadow issue in Edge\r\n$form-range-thumb-active-bg: tint-color($component-active-bg, 70%);\r\n$form-range-thumb-disabled-bg: $gray-500;\r\n$form-range-thumb-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n// scss-docs-end form-range-variables\r\n\r\n// scss-docs-start form-file-variables\r\n$form-file-button-color: $input-color;\r\n$form-file-button-bg: $input-group-addon-bg;\r\n$form-file-button-hover-bg: shade-color($form-file-button-bg, 5%);\r\n// scss-docs-end form-file-variables\r\n\r\n// scss-docs-start form-floating-variables\r\n$form-floating-height: add(3.5rem, $input-height-border);\r\n$form-floating-line-height: 1.25;\r\n$form-floating-padding-x: $input-padding-x;\r\n$form-floating-padding-y: 1rem;\r\n$form-floating-input-padding-t: 1.625rem;\r\n$form-floating-input-padding-b: 0.625rem;\r\n$form-floating-label-opacity: 0.65;\r\n$form-floating-label-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\r\n$form-floating-transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\r\n// scss-docs-end form-floating-variables\r\n\r\n// Form validation\r\n\r\n// scss-docs-start form-feedback-variables\r\n$form-feedback-margin-top: $form-text-margin-top;\r\n$form-feedback-font-size: $form-text-font-size;\r\n$form-feedback-font-style: $form-text-font-style;\r\n$form-feedback-valid-color: $success;\r\n$form-feedback-invalid-color: $danger;\r\n\r\n$form-feedback-icon-valid-color: $form-feedback-valid-color;\r\n$form-feedback-icon-valid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\r\n$form-feedback-icon-invalid-color: $form-feedback-invalid-color;\r\n$form-feedback-icon-invalid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\r\n// scss-docs-end form-feedback-variables\r\n\r\n// scss-docs-start form-validation-states\r\n$form-validation-states: (\r\n    'valid': (\r\n        'color': $form-feedback-valid-color,\r\n        'icon': $form-feedback-icon-valid,\r\n    ),\r\n    'invalid': (\r\n        'color': $form-feedback-invalid-color,\r\n        'icon': $form-feedback-icon-invalid,\r\n    ),\r\n);\r\n// scss-docs-end form-validation-states\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n// scss-docs-start zindex-stack\r\n$zindex-dropdown: 1000;\r\n$zindex-sticky: 1020;\r\n$zindex-fixed: 1030;\r\n$zindex-offcanvas-backdrop: 1040;\r\n$zindex-offcanvas: 1045;\r\n$zindex-modal-backdrop: 1050;\r\n$zindex-modal: 1055;\r\n$zindex-popover: 1070;\r\n$zindex-tooltip: 1080;\r\n// scss-docs-end zindex-stack\r\n\r\n// Navs\r\n\r\n// scss-docs-start nav-variables\r\n$nav-link-padding-y: 0.5rem;\r\n$nav-link-padding-x: 1rem;\r\n$nav-link-font-size: null;\r\n$nav-link-font-weight: null;\r\n$nav-link-color: $gray-900;\r\n$nav-link-hover-color: $link-hover-color;\r\n$nav-link-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\r\n$nav-link-disabled-color: $gray-600;\r\n\r\n$nav-tabs-border-color: 'transparent';\r\n$nav-tabs-border-width: 0;\r\n$nav-tabs-border-radius: 0;\r\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color;\r\n$nav-tabs-link-active-color: $gray-700;\r\n$nav-tabs-link-active-bg: $body-bg;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg;\r\n\r\n$nav-pills-border-radius: $border-radius-sm;\r\n$nav-pills-link-active-color: $component-active-color;\r\n$nav-pills-link-active-bg: $component-active-bg;\r\n// scss-docs-end nav-variables\r\n\r\n// Navbar\r\n\r\n// scss-docs-start navbar-variables\r\n$navbar-padding-y: $spacer;\r\n$navbar-padding-x: $spacer;\r\n\r\n$navbar-nav-link-padding-x: 0.75rem;\r\n\r\n$navbar-brand-font-size: $font-size-lg;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2;\r\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base;\r\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) * 0.5;\r\n$navbar-brand-margin-end: 1rem;\r\n\r\n$navbar-toggler-padding-y: 0.75rem;\r\n$navbar-toggler-padding-x: 0;\r\n$navbar-toggler-font-size: $font-size-lg;\r\n$navbar-toggler-border-radius: $btn-border-radius;\r\n$navbar-toggler-focus-width: $btn-focus-width;\r\n$navbar-toggler-transition: box-shadow 0.15s ease-in-out;\r\n// scss-docs-end navbar-variables\r\n\r\n// scss-docs-start navbar-theme-variables\r\n$navbar-dark-color: rgba($white, 0.9);\r\n$navbar-dark-hover-color: rgba($white, 1);\r\n$navbar-dark-active-color: $white;\r\n$navbar-dark-disabled-color: rgba($white, 0.25);\r\n$navbar-dark-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' strokeWidth='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-dark-toggler-border-color: rgba($white, 0.1);\r\n\r\n$navbar-light-color: darken($body-color, 10%);\r\n$navbar-light-hover-color: darken($body-color, 25%);\r\n$navbar-light-active-color: darken($body-color, 25%);\r\n$navbar-light-disabled-color: rgba($black, 0.3);\r\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' strokeWidth='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-light-toggler-border-color: transparent;\r\n\r\n$navbar-light-brand-color: $navbar-light-active-color;\r\n$navbar-light-brand-hover-color: $navbar-light-active-color;\r\n$navbar-dark-brand-color: $navbar-dark-active-color;\r\n$navbar-dark-brand-hover-color: $navbar-dark-active-color;\r\n// scss-docs-end navbar-theme-variables\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n// scss-docs-start dropdown-variables\r\n$dropdown-min-width: 10rem;\r\n$dropdown-padding-x: 0.3rem;\r\n$dropdown-padding-y: 0.5rem;\r\n$dropdown-spacer: 0.125rem;\r\n$dropdown-font-size: $font-size-base;\r\n$dropdown-color: $body-color;\r\n$dropdown-bg: $white;\r\n$dropdown-border-color: rgba($black, 0.15);\r\n$dropdown-border-radius: $border-radius-sm;\r\n$dropdown-border-width: 0;\r\n$dropdown-inner-border-radius: subtract($dropdown-border-radius, $dropdown-border-width);\r\n$dropdown-divider-bg: $gray-200;\r\n// $dropdown-divider-margin-y: $spacer / 2;\r\n$dropdown-box-shadow: $box-shadow-lg;\r\n\r\n$dropdown-link-color: $gray-600;\r\n$dropdown-link-hover-color: shade-color($gray-900, 10%);\r\n$dropdown-link-hover-bg: $gray-200;\r\n\r\n$dropdown-link-active-color: darken($gray-900, 5%);\r\n$dropdown-link-active-bg: $gray-100;\r\n\r\n$dropdown-link-disabled-color: $gray-500;\r\n\r\n$dropdown-item-padding-y: 0.35rem;\r\n$dropdown-item-padding-x: 1.5rem;\r\n\r\n$dropdown-header-color: $gray-600;\r\n$dropdown-header-padding: $dropdown-padding-y $dropdown-item-padding-x;\r\n// scss-docs-end dropdown-variables\r\n\r\n// scss-docs-start dropdown-dark-variables\r\n$dropdown-dark-color: $gray-300;\r\n$dropdown-dark-bg: $gray-800;\r\n$dropdown-dark-border-color: $dropdown-border-color;\r\n$dropdown-dark-divider-bg: $dropdown-divider-bg;\r\n$dropdown-dark-box-shadow: null;\r\n$dropdown-dark-link-color: $dropdown-dark-color;\r\n$dropdown-dark-link-hover-color: $white;\r\n$dropdown-dark-link-hover-bg: rgba($white, 0.15);\r\n$dropdown-dark-link-active-color: $dropdown-link-active-color;\r\n$dropdown-dark-link-active-bg: $dropdown-link-active-bg;\r\n$dropdown-dark-link-disabled-color: $gray-500;\r\n$dropdown-dark-header-color: $gray-500;\r\n// scss-docs-end dropdown-dark-variables\r\n\r\n// Pagination\r\n\r\n// scss-docs-start pagination-variables\r\n$pagination-padding-y: 0.375rem;\r\n$pagination-padding-x: 0.75rem;\r\n$pagination-padding-y-sm: 0.25rem;\r\n$pagination-padding-x-sm: 0.5rem;\r\n$pagination-padding-y-lg: 0.75rem;\r\n$pagination-padding-x-lg: 1.5rem;\r\n\r\n$pagination-color: $primary;\r\n$pagination-bg: $white;\r\n$pagination-border-width: $border-width;\r\n$pagination-border-radius: $border-radius;\r\n$pagination-margin-start: -$pagination-border-width;\r\n$pagination-border-color: $gray-300;\r\n\r\n$pagination-focus-color: $link-hover-color;\r\n$pagination-focus-bg: $gray-200;\r\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow;\r\n$pagination-focus-outline: 0;\r\n\r\n$pagination-hover-color: $link-hover-color;\r\n$pagination-hover-bg: $gray-200;\r\n$pagination-hover-border-color: $gray-300;\r\n\r\n$pagination-active-color: $component-active-color;\r\n$pagination-active-bg: $component-active-bg;\r\n$pagination-active-border-color: $pagination-active-bg;\r\n\r\n$pagination-disabled-color: $gray-600;\r\n$pagination-disabled-bg: $white;\r\n$pagination-disabled-border-color: $gray-300;\r\n\r\n$pagination-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n\r\n$pagination-border-radius-sm: $border-radius-sm;\r\n$pagination-border-radius-lg: $border-radius-lg;\r\n// scss-docs-end pagination-variables\r\n\r\n// Placeholders\r\n\r\n// scss-docs-start placeholders\r\n$placeholder-opacity-max: 0.5;\r\n$placeholder-opacity-min: 0.2;\r\n// scss-docs-end placeholders\r\n\r\n// Cards\r\n\r\n// scss-docs-start card-variables\r\n$card-spacer-y: $spacer * 1.5;\r\n$card-spacer-x: $spacer * 1.5;\r\n$card-title-spacer-y: $spacer * 0.5;\r\n$card-border-width: 0px;\r\n$card-border-color: rgba($black, 0.125);\r\n$card-border-radius: 0.1875rem;\r\n$card-box-shadow: null;\r\n$card-inner-border-radius: subtract($card-border-radius, $card-border-width);\r\n$card-cap-padding-y: 0.75rem;\r\n$card-cap-padding-x: $card-spacer-x;\r\n$card-cap-bg: $gray-200;\r\n$card-cap-color: null;\r\n$card-height: null;\r\n$card-color: null;\r\n$card-bg: $white;\r\n$card-img-overlay-padding: $spacer;\r\n$card-group-margin: calc($grid-gutter-width / 2);\r\n// scss-docs-end card-variables\r\n\r\n// Accordion\r\n\r\n// scss-docs-start accordion-variables\r\n$accordion-padding-y: 1rem;\r\n$accordion-padding-x: 1.25rem;\r\n$accordion-color: $body-color;\r\n$accordion-bg: $body-bg;\r\n$accordion-border-width: $border-width;\r\n$accordion-border-color: rgba($black, 0.125);\r\n$accordion-border-radius: $border-radius;\r\n$accordion-inner-border-radius: subtract($accordion-border-radius, $accordion-border-width);\r\n\r\n$accordion-body-padding-y: $accordion-padding-y;\r\n$accordion-body-padding-x: $accordion-padding-x;\r\n\r\n$accordion-button-padding-y: $accordion-padding-y;\r\n$accordion-button-padding-x: $accordion-padding-x;\r\n$accordion-button-color: $accordion-color;\r\n$accordion-button-bg: $accordion-bg;\r\n$accordion-transition: $btn-transition, border-radius 0.15s ease;\r\n$accordion-button-active-bg: tint-color($component-active-bg, 90%);\r\n$accordion-button-active-color: shade-color($primary, 10%);\r\n\r\n$accordion-button-focus-border-color: $input-focus-border-color;\r\n$accordion-button-focus-box-shadow: $btn-focus-box-shadow;\r\n\r\n$accordion-icon-width: 1.25rem;\r\n$accordion-icon-color: $accordion-color;\r\n$accordion-icon-active-color: $accordion-button-active-color;\r\n$accordion-icon-transition: transform 0.2s ease-in-out;\r\n$accordion-icon-transform: rotate(-180deg);\r\n\r\n$accordion-button-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fillRule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fillRule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n// scss-docs-end accordion-variables\r\n\r\n// Tooltips\r\n\r\n// scss-docs-start tooltip-variables\r\n$tooltip-font-size: $font-size-base;\r\n$tooltip-max-width: 200px;\r\n$tooltip-color: $white;\r\n$tooltip-bg: darken($secondary, 20%);\r\n$tooltip-border-radius: $border-radius-sm;\r\n$tooltip-opacity: 0.9;\r\n$tooltip-padding-y: 0.3rem;\r\n$tooltip-padding-x: 0.75rem;\r\n$tooltip-margin: 0;\r\n\r\n$tooltip-arrow-width: 0.75rem;\r\n$tooltip-arrow-height: 0.5rem;\r\n$tooltip-arrow-color: $tooltip-bg;\r\n// scss-docs-end tooltip-variables\r\n\r\n// Form tooltips must come after regular tooltips\r\n// scss-docs-start tooltip-feedback-variables\r\n$form-feedback-tooltip-padding-y: $tooltip-padding-y;\r\n$form-feedback-tooltip-padding-x: $tooltip-padding-x;\r\n$form-feedback-tooltip-font-size: $tooltip-font-size;\r\n$form-feedback-tooltip-line-height: null;\r\n$form-feedback-tooltip-opacity: $tooltip-opacity;\r\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\r\n// scss-docs-start tooltip-feedback-variables\r\n\r\n// Popovers\r\n\r\n// scss-docs-start popover-variables\r\n$popover-font-size: $font-size-base;\r\n$popover-bg: $white;\r\n$popover-max-width: 276px;\r\n$popover-border-width: $border-width;\r\n$popover-border-color: $gray-200;\r\n$popover-border-radius: $border-radius-sm;\r\n$popover-inner-border-radius: subtract($popover-border-radius, $popover-border-width);\r\n$popover-box-shadow: $box-shadow-lg;\r\n\r\n$popover-header-bg: $gray-100;\r\n$popover-header-color: $headings-color;\r\n$popover-header-padding-y: 0.5rem;\r\n$popover-header-padding-x: $spacer;\r\n\r\n$popover-body-color: $body-color;\r\n$popover-body-padding-y: $spacer;\r\n$popover-body-padding-x: $spacer;\r\n\r\n$popover-arrow-width: 1rem;\r\n$popover-arrow-height: 0.5rem;\r\n$popover-arrow-color: $popover-bg;\r\n\r\n$popover-arrow-outer-color: fade-in($popover-border-color, 0.05);\r\n// scss-docs-end popover-variables\r\n\r\n// Toasts\r\n\r\n// scss-docs-start toast-variables\r\n$toast-max-width: 350px;\r\n$toast-padding-x: 0.75rem;\r\n$toast-padding-y: 0.5rem;\r\n$toast-font-size: 0.875rem;\r\n$toast-color: null;\r\n$toast-background-color: rgba($white, 0.85);\r\n$toast-border-width: 1px;\r\n$toast-border-color: rgba(0, 0, 0, 0.1);\r\n$toast-border-radius: $border-radius;\r\n$toast-box-shadow: $box-shadow;\r\n$toast-spacing: $container-padding-x;\r\n\r\n$toast-header-color: $gray-600;\r\n$toast-header-background-color: rgba($white, 0.85);\r\n$toast-header-border-color: rgba(0, 0, 0, 0.05);\r\n// scss-docs-end toast-variables\r\n\r\n// Badges\r\n\r\n// scss-docs-start badge-variables\r\n$badge-font-size: 82%;\r\n$badge-font-weight: $font-weight-semibold;\r\n$badge-color: $white;\r\n$badge-padding-y: 0.3em;\r\n$badge-padding-x: 0.5em;\r\n$badge-border-radius: $border-radius-sm;\r\n// scss-docs-end badge-variables\r\n\r\n// Modals\r\n\r\n// scss-docs-start modal-variables\r\n$modal-inner-padding: 1rem;\r\n\r\n$modal-footer-margin-between: 0.5rem;\r\n\r\n$modal-dialog-margin: 0.5rem;\r\n$modal-dialog-margin-y-sm-up: 1.75rem;\r\n\r\n$modal-title-line-height: $line-height-base;\r\n\r\n$modal-content-color: null;\r\n$modal-content-bg: $white;\r\n$modal-content-border-color: rgba($black, 0.2);\r\n$modal-content-border-width: $border-width;\r\n$modal-content-border-radius: $border-radius-sm;\r\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\r\n$modal-content-box-shadow-xs: $box-shadow-sm;\r\n$modal-content-box-shadow-sm-up: $box-shadow;\r\n\r\n$modal-backdrop-bg: $black;\r\n$modal-backdrop-opacity: 0.5;\r\n$modal-header-border-color: $border-color;\r\n$modal-footer-border-color: $modal-header-border-color;\r\n$modal-header-border-width: $modal-content-border-width;\r\n$modal-footer-border-width: $modal-header-border-width;\r\n$modal-header-padding-y: $modal-inner-padding;\r\n$modal-header-padding-x: $modal-inner-padding;\r\n$modal-header-padding: 0.6rem $modal-header-padding-x; // Keep this for backwards compatibility\r\n\r\n$modal-sm: 300px;\r\n$modal-md: 500px;\r\n$modal-lg: 800px;\r\n$modal-xl: 1140px;\r\n\r\n$modal-fade-transform: translate(0, -50px);\r\n$modal-show-transform: none;\r\n$modal-transition: transform 0.3s ease-out;\r\n$modal-scale-transform: scale(1.02);\r\n// scss-docs-end modal-variables\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n// scss-docs-start alert-variables\r\n$alert-padding-y: $spacer * 0.75;\r\n$alert-padding-x: $spacer * 1.25;\r\n$alert-margin-bottom: 1rem;\r\n$alert-border-radius: $border-radius-sm;\r\n$alert-link-font-weight: $font-weight-bold;\r\n$alert-border-width: $border-width;\r\n$alert-bg-scale: -80%;\r\n$alert-border-scale: -70%;\r\n$alert-color-scale: 40%;\r\n$alert-dismissible-padding-r: $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\r\n// scss-docs-end alert-variables\r\n\r\n// Progress bars\r\n\r\n// scss-docs-start progress-variables\r\n$progress-height: 0.75rem;\r\n$progress-font-size: $font-size-base * 0.75;\r\n$progress-bg: $gray-200;\r\n$progress-border-radius: $border-radius-sm;\r\n$progress-box-shadow: $box-shadow-inset;\r\n$progress-bar-color: $white;\r\n$progress-bar-bg: $primary;\r\n$progress-bar-animation-timing: 1s linear infinite;\r\n$progress-bar-transition: width 0.6s ease;\r\n// scss-docs-end progress-variables\r\n\r\n// List group\r\n\r\n// scss-docs-start list-group-variables\r\n$list-group-color: $gray-900;\r\n$list-group-bg: $white;\r\n$list-group-border-color: rgba($black, 0.125);\r\n$list-group-border-width: $border-width;\r\n$list-group-border-radius: $border-radius-sm;\r\n\r\n$list-group-item-padding-y: $spacer * 0.5;\r\n$list-group-item-padding-x: $spacer;\r\n$list-group-item-bg-scale: -80%;\r\n$list-group-item-color-scale: 40%;\r\n\r\n$list-group-hover-bg: $gray-100;\r\n$list-group-active-color: $component-active-color;\r\n$list-group-active-bg: $component-active-bg;\r\n$list-group-active-border-color: $list-group-active-bg;\r\n\r\n$list-group-disabled-color: $gray-600;\r\n$list-group-disabled-bg: $list-group-bg;\r\n\r\n$list-group-action-color: $gray-700;\r\n$list-group-action-hover-color: $list-group-action-color;\r\n\r\n$list-group-action-active-color: $body-color;\r\n$list-group-action-active-bg: $gray-200;\r\n// scss-docs-end list-group-variables\r\n\r\n// Image thumbnails\r\n\r\n// scss-docs-start thumbnail-variables\r\n$thumbnail-padding: 0.25rem;\r\n$thumbnail-bg: $body-bg;\r\n$thumbnail-border-width: $border-width;\r\n$thumbnail-border-color: $gray-300;\r\n$thumbnail-border-radius: $border-radius;\r\n$thumbnail-box-shadow: $box-shadow-sm;\r\n// scss-docs-end thumbnail-variables\r\n\r\n// Figures\r\n\r\n// scss-docs-start figure-variables\r\n$figure-caption-font-size: $small-font-size;\r\n$figure-caption-color: $gray-600;\r\n// scss-docs-end figure-variables\r\n\r\n// Breadcrumbs\r\n\r\n// scss-docs-start breadcrumb-variables\r\n$breadcrumb-font-size: null;\r\n$breadcrumb-padding-y: 0.75rem;\r\n$breadcrumb-padding-x: 1rem;\r\n$breadcrumb-item-padding-x: 0.1rem;\r\n$breadcrumb-margin-bottom: 1rem;\r\n$breadcrumb-bg: $gray-100;\r\n$breadcrumb-divider-color: $gray-600;\r\n$breadcrumb-active-color: $gray-600;\r\n$breadcrumb-divider: quote('/');\r\n$breadcrumb-divider-flipped: $breadcrumb-divider;\r\n$breadcrumb-border-radius: null;\r\n// scss-docs-end breadcrumb-variables\r\n\r\n// Carousel\r\n\r\n// scss-docs-start carousel-variables\r\n$carousel-control-color: $white;\r\n$carousel-control-width: 15%;\r\n$carousel-control-opacity: 0.5;\r\n$carousel-control-hover-opacity: 0.9;\r\n$carousel-control-transition: opacity 0.15s ease;\r\n\r\n$carousel-indicator-width: 30px;\r\n$carousel-indicator-height: 3px;\r\n$carousel-indicator-hit-area-height: 10px;\r\n$carousel-indicator-spacer: 3px;\r\n$carousel-indicator-opacity: 0.5;\r\n$carousel-indicator-active-bg: $white;\r\n$carousel-indicator-active-opacity: 1;\r\n$carousel-indicator-transition: opacity 0.6s ease;\r\n\r\n$carousel-caption-width: 70%;\r\n$carousel-caption-color: $white;\r\n$carousel-caption-padding-y: 1.25rem;\r\n$carousel-caption-spacer: 1.25rem;\r\n\r\n$carousel-control-icon-width: 2rem;\r\n\r\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\r\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\r\n\r\n$carousel-transition-duration: 0.6s;\r\n$carousel-transition: transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n$carousel-dark-indicator-active-bg: $black;\r\n$carousel-dark-caption-color: $black;\r\n$carousel-dark-control-icon-filter: invert(1) grayscale(100);\r\n// scss-docs-end carousel-variables\r\n\r\n// Spinners\r\n\r\n// scss-docs-start spinner-variables\r\n$spinner-width: 2rem;\r\n$spinner-height: $spinner-width;\r\n$spinner-vertical-align: -0.125em;\r\n$spinner-border-width: 0.25em;\r\n$spinner-animation-speed: 0.75s;\r\n\r\n$spinner-width-sm: 1rem;\r\n$spinner-height-sm: $spinner-width-sm;\r\n$spinner-border-width-sm: 0.2em;\r\n// scss-docs-end spinner-variables\r\n\r\n// Close\r\n\r\n// scss-docs-start close-variables\r\n$btn-close-width: 1em;\r\n$btn-close-height: $btn-close-width;\r\n$btn-close-padding-x: 0.25em;\r\n$btn-close-padding-y: $btn-close-padding-x;\r\n$btn-close-color: $black;\r\n$btn-close-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\r\n$btn-close-focus-shadow: $input-btn-focus-box-shadow;\r\n$btn-close-opacity: 0.5;\r\n$btn-close-hover-opacity: 0.75;\r\n$btn-close-focus-opacity: 1;\r\n$btn-close-disabled-opacity: 0.25;\r\n$btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\r\n// scss-docs-end close-variables\r\n\r\n// Offcanvas\r\n\r\n// scss-docs-start offcanvas-variables\r\n$offcanvas-padding-y: $modal-inner-padding;\r\n$offcanvas-padding-x: $modal-inner-padding;\r\n$offcanvas-horizontal-width: 400px;\r\n$offcanvas-vertical-height: 30vh;\r\n$offcanvas-transition-duration: 0.3s;\r\n$offcanvas-border-color: $modal-content-border-color;\r\n$offcanvas-border-width: $modal-content-border-width;\r\n$offcanvas-title-line-height: $modal-title-line-height;\r\n$offcanvas-bg-color: $modal-content-bg;\r\n$offcanvas-color: $modal-content-color;\r\n$offcanvas-box-shadow: $modal-content-box-shadow-xs;\r\n$offcanvas-backdrop-bg: $modal-backdrop-bg;\r\n$offcanvas-backdrop-opacity: $modal-backdrop-opacity;\r\n// scss-docs-end offcanvas-variables\r\n\r\n// Code\r\n\r\n$code-font-size: $small-font-size;\r\n$code-color: $red;\r\n\r\n$kbd-padding-y: $spacer;\r\n$kbd-padding-x: $spacer;\r\n$kbd-font-size: $code-font-size;\r\n$kbd-color: $white;\r\n$kbd-bg: $gray-900;\r\n\r\n$pre-color: null;\r\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n",":root {\n    // neutral\n    --white: #ffffff;\n    --black: #000000;\n\n    // primary\n    --primary: #0b7f8e;\n\n    // grey\n    --grey1: #f9fafb;\n    --grey2: #f3f4f6;\n    --grey3: #e5e7eb;\n    --grey4: #d1d5db;\n    --grey5: #9ca3af;\n    --grey6: #6b7280;\n    --grey7: #4b5563;\n    --grey8: #334155;\n    --grey9: #1f2937;\n    --grey10: #111827;\n\n    // teal\n    --teal1: #eef6f7;\n    --teal2: #aed4d9;\n    --teal3: #85bfc6;\n    --teal4: #5caab4;\n    --teal5: #3494a1;\n    --teal6: #0b7f8e;\n    --teal7: #096a76;\n    --teal8: #07555f;\n    --teal9: #053f47;\n    --teal10: #042a2f;\n\n    // green\n    --green1: #f0fdf4;\n    --green2: #dcfce7;\n    --green3: #bbf7d0;\n    --green4: #86efac;\n    --green5: #4ade80;\n    --green6: #22c55e;\n    --green7: #16a34a;\n    --green8: #15803d;\n    --green9: #14532d;\n    --green10: #052e16;\n\n    // blue\n    --blue1: #eff6ff;\n    --blue2: #dbeafe;\n    --blue3: #bfdbfe;\n    --blue4: #93c5fd;\n    --blue5: #60a5fa;\n    --blue6: #3b82f6;\n    --blue7: #2563eb;\n    --blue8: #1d4ed8;\n    --blue9: #1e3a8a;\n    --blue10: #172554;\n\n    // red\n    --red1: #fef2f2;\n    --red2: #fee2e2;\n    --red3: #fecaca;\n    --red4: #fca5a5;\n    --red5: #f87171;\n    --red6: #ef4444;\n    --red7: #dc2626;\n    --red8: #b91c1c;\n    --red9: #991b1b;\n    --red10: #450a0a;\n\n    // yellow\n    --yellow1: #fefce8;\n    --yellow2: #fef9c3;\n    --yellow3: #fef08a;\n    --yellow4: #fde047;\n    --yellow5: #facc15;\n    --yellow6: #eab308;\n    --yellow7: #ca8a04;\n    --yellow8: #a16207;\n    --yellow9: #854d0e;\n    --yellow10: #422006;\n\n    // orange\n    --orange1: #fff7ed;\n    --orange2: #ffedd5;\n    --orange3: #fed7aa;\n    --orange4: #fdba74;\n    --orange5: #fb923c;\n    --orange6: #f97316;\n    --orange7: #ea580c;\n    --orange8: #c2410c;\n    --orange9: #7c2d12;\n    --orange10: #431407;\n\n    // purple\n    --purple1: #faf5ff;\n    --purple2: #f3e8ff;\n    --purple3: #e9d5ff;\n    --purple4: #d8b4fe;\n    --purple5: #c084fc;\n    --purple6: #a855f7;\n    --purple7: #9333ea;\n    --purple8: #7e22ce;\n    --purple9: #581c87;\n    --purple10: #3b0764;\n\n    // pink\n    --pink1: #fdf2f8;\n    --pink2: #fce7f3;\n    --pink3: #fbcfe8;\n    --pink4: #f9a8d4;\n    --pink5: #f472b6;\n    --pink6: #ec4899;\n    --pink7: #db2777;\n    --pink8: #be185d;\n    --pink9: #831843;\n    --pink10: #500724;\n}\n\n// neutral\n.white {\n    color: var(--white) !important;\n}\n.black {\n    color: var(--black) !important;\n}\n\n// primary\n.primary {\n    color: var(--primary) !important;\n}\n\n// grey\n.grey1 {\n    color: var(--grey1) !important;\n}\n.grey2 {\n    color: var(--grey2) !important;\n}\n.grey3 {\n    color: var(--grey3) !important;\n}\n.grey4 {\n    color: var(--grey4) !important;\n}\n.grey5 {\n    color: var(--grey5) !important;\n}\n.grey6 {\n    color: var(--grey6) !important;\n}\n.grey7 {\n    color: var(--grey7) !important;\n}\n.grey8 {\n    color: var(--grey8) !important;\n}\n.grey9 {\n    color: var(--grey9) !important;\n}\n.grey10 {\n    color: var(--grey10) !important;\n}\n\n// teal\n.teal1 {\n    color: var(--teal1) !important;\n}\n.teal2 {\n    color: var(--teal2) !important;\n}\n.teal3 {\n    color: var(--teal3) !important;\n}\n.teal4 {\n    color: var(--teal4) !important;\n}\n.teal5 {\n    color: var(--teal5) !important;\n}\n.teal6 {\n    color: var(--teal6) !important;\n}\n.teal7 {\n    color: var(--teal7) !important;\n}\n.teal8 {\n    color: var(--teal8) !important;\n}\n.teal9 {\n    color: var(--teal9) !important;\n}\n.teal10 {\n    color: var(--teal10) !important;\n}\n\n// green\n.green1 {\n    color: var(--green1) !important;\n}\n.green2 {\n    color: var(--green2) !important;\n}\n.green3 {\n    color: var(--green3) !important;\n}\n.green4 {\n    color: var(--green4) !important;\n}\n.green5 {\n    color: var(--green5) !important;\n}\n.green6 {\n    color: var(--green6) !important;\n}\n.green7 {\n    color: var(--green7) !important;\n}\n.green8 {\n    color: var(--green8) !important;\n}\n.green9 {\n    color: var(--green9) !important;\n}\n.green10 {\n    color: var(--green10) !important;\n}\n\n// blue\n.blue1 {\n    color: var(--blue1) !important;\n}\n.blue2 {\n    color: var(--blue2) !important;\n}\n.blue3 {\n    color: var(--blue3) !important;\n}\n.blue4 {\n    color: var(--blue4) !important;\n}\n.blue5 {\n    color: var(--blue5) !important;\n}\n.blue6 {\n    color: var(--blue6) !important;\n}\n.blue7 {\n    color: var(--blue7) !important;\n}\n.blue8 {\n    color: var(--blue8) !important;\n}\n.blue9 {\n    color: var(--blue9) !important;\n}\n.blue10 {\n    color: var(--blue10) !important;\n}\n\n// red\n.red1 {\n    color: var(--red1) !important;\n}\n.red2 {\n    color: var(--red2) !important;\n}\n.red3 {\n    color: var(--red3) !important;\n}\n.red4 {\n    color: var(--red4) !important;\n}\n.red5 {\n    color: var(--red5) !important;\n}\n.red6 {\n    color: var(--red6) !important;\n}\n.red7 {\n    color: var(--red7) !important;\n}\n.red8 {\n    color: var(--red8) !important;\n}\n.red9 {\n    color: var(--red9) !important;\n}\n.red10 {\n    color: var(--red10) !important;\n}\n\n// yellow\n.yellow1 {\n    color: var(--yellow1) !important;\n}\n.yellow2 {\n    color: var(--yellow2) !important;\n}\n.yellow3 {\n    color: var(--yellow3) !important;\n}\n.yellow4 {\n    color: var(--yellow4) !important;\n}\n.yellow5 {\n    color: var(--yellow5) !important;\n}\n.yellow6 {\n    color: var(--yellow6) !important;\n}\n.yellow7 {\n    color: var(--yellow7) !important;\n}\n.yellow8 {\n    color: var(--yellow8) !important;\n}\n.yellow9 {\n    color: var(--yellow9) !important;\n}\n.yellow10 {\n    color: var(--yellow10) !important;\n}\n\n// orange\n.orange1 {\n    color: var(--orange1) !important;\n}\n.orange2 {\n    color: var(--orange2) !important;\n}\n.orange3 {\n    color: var(--orange3) !important;\n}\n.orange4 {\n    color: var(--orange4) !important;\n}\n.orange5 {\n    color: var(--orange5) !important;\n}\n.orange6 {\n    color: var(--orange6) !important;\n}\n.orange7 {\n    color: var(--orange7) !important;\n}\n.orange8 {\n    color: var(--orange8) !important;\n}\n.orange9 {\n    color: var(--orange9) !important;\n}\n.orange10 {\n    color: var(--orange10) !important;\n}\n\n// purple\n.purple1 {\n    color: var(--purple1) !important;\n}\n.purple2 {\n    color: var(--purple2) !important;\n}\n.purple3 {\n    color: var(--purple3) !important;\n}\n.purple4 {\n    color: var(--purple4) !important;\n}\n.purple5 {\n    color: var(--purple5) !important;\n}\n.purple6 {\n    color: var(--purple6) !important;\n}\n.purple7 {\n    color: var(--purple7) !important;\n}\n.purple8 {\n    color: var(--purple8) !important;\n}\n.purple9 {\n    color: var(--purple9) !important;\n}\n.purple10 {\n    color: var(--purple10) !important;\n}\n\n// pink\n.pink1 {\n    color: var(--pink1) !important;\n}\n.pink2 {\n    color: var(--pink2) !important;\n}\n.pink3 {\n    color: var(--pink3) !important;\n}\n.pink4 {\n    color: var(--pink4) !important;\n}\n.pink5 {\n    color: var(--pink5) !important;\n}\n.pink6 {\n    color: var(--pink6) !important;\n}\n.pink7 {\n    color: var(--pink7) !important;\n}\n.pink8 {\n    color: var(--pink8) !important;\n}\n.pink9 {\n    color: var(--pink9) !important;\n}\n.pink10 {\n    color: var(--pink10) !important;\n}\n",".content {\n    padding-top: 7rem !important;\n    padding-bottom: 1.5rem !important;\n}\n\n.btn:hover .svg-hover-white {\n    filter: brightness(0) invert(1);\n}\n\n.typehead-primary .rbt-input-main {\n    border-color: $primary;\n}\n\n@media (max-width: 992px) {\n    .container-responsive {\n        padding-top: 90px !important;\n    }\n\n    .overflow-x-responsive {\n        overflow-y: hidden;\n        overflow-x: auto;\n    }\n}\n\n.gray-hover:hover {\n    background-color: rgb(248, 248, 248);\n}\n\n.table-layout-fixed {\n    table-layout: fixed;\n}\n\n.select-none {\n    user-select: none;\n}\n\n.plasma-menu {\n    .plasma-menu {\n        display: flex;\n        flex-direction: row;\n        gap: 0.5rem;\n    }\n\n    button {\n        padding: 0.3rem 1.2rem;\n        text-align: left;\n        opacity: 0.75;\n    }\n\n    button.active {\n        background: #012c32;\n        color: white;\n        font-weight: 500;\n        position: relative;\n        opacity: 1;\n    }\n\n    button.active::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 10px;\n        background-color: #0b7f8e;\n    }\n\n    button.active:hover {\n        opacity: 90%;\n    }\n\n    button:hover {\n        opacity: 1;\n    }\n}\n\n@media (min-width: 992px) {\n    .plasma-menu {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n    }\n}\n\n.accordion-button:not(.collapsed) {\n    background-color: white;\n    color: var(--bs-accordion-btn-color);\n}\n\n.accordion-button:not(.collapsed)::after {\n    background-image: var(--bs-accordion-btn-icon);\n}\n\n.input-group-text.input-group-text-plain {\n    background: white;\n    color: $gray-500;\n    user-select: none;\n}\n\n.input-group:has(.input-group-text-plain)\n    > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    border-left: none;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.input-group:has(.input-group-text-plain)\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:has(.input-group-text-plain) > .dropdown-toggle:nth-last-child(n + 3),\n.input-group:has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-control,\n.input-group:has(.input-group-text-plain) > .form-floating:not(:last-child) > .form-select {\n    border-right: none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain)\n    > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    border-color: $danger;\n}\n\n.input-group.has-validation:has(.is-warning):has(.input-group-text-plain)\n    > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    border-color: $warning;\n}\n\n.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain)\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain) > .dropdown-toggle:nth-last-child(n + 3),\n.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain)\n    > .form-floating:not(:last-child)\n    > .form-control,\n.input-group.has-validation:has(.is-invalid):has(.input-group-text-plain)\n    > .form-floating:not(:last-child)\n    > .form-select {\n    border-color: $danger;\n}\n\n.input-group.has-validation:has(.is-warning):has(.input-group-text-plain)\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation:has(.is-warning):has(.input-group-text-plain) > .dropdown-toggle:nth-last-child(n + 3),\n.input-group.has-validation:has(.is-warning):has(.input-group-text-plain)\n    > .form-floating:not(:last-child)\n    > .form-control,\n.input-group.has-validation:has(.is-warning):has(.input-group-text-plain)\n    > .form-floating:not(:last-child)\n    > .form-select {\n    border-color: $warning;\n}\n\n.form-control.is-warning {\n    background-image: url('../../images/icons/warning-circle.svg') !important;\n    background-repeat: no-repeat;\n    background-position: right calc(0.375em + 0.28125rem) center;\n}\n\n.form-control:focus ~ .input-group-text-plain {\n    border-color: rgba(0, 0, 0, 0.25);\n}\n\n.input-group-text-plain:has(+ .form-control:focus) {\n    border-color: rgba(0, 0, 0, 0.25);\n}\n\n.input-group:has(.input-group-text-plain) > .form-control:disabled {\n    background-color: $gray-200;\n}\n\n.input-group:has(.input-group-text-plain):has(.form-control:disabled) > .input-group-text-plain {\n    background-color: $gray-200;\n}\n\n.input-group:has(.input-group-text-plain) > .form-control:disabled {\n    background-color: $gray-200;\n}\n\n.input-group:has(.input-group-text-plain):has(.form-control:disabled) > .input-group-text-plain {\n    background-color: $gray-200;\n}\n\n.form-check-input:disabled {\n    background-color: $gray-400;\n}\n\n.indicator {\n    position: relative;\n\n    &::after {\n        content: '';\n        position: absolute;\n        top: -5px;\n        right: -5px;\n        width: 10px;\n        height: 10px;\n        border-radius: 5rem;\n        background-color: $danger;\n    }\n}\n\n.w-fit-content {\n    width: fit-content !important;\n}\n\n// ===== custom scrollbar =====\n.no-scrollbar {\n    scrollbar-width: thin;\n\n    &::-webkit-scrollbar {\n        width: 6px;\n        height: 274px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        border-radius: 10px;\n        background-color: var(--grey2);\n    }\n}\n\n// ===== react select =====\n.select {\n    &.select-ap {\n        .react-select__menu {\n            width: 300px;\n            right: 0;\n        }\n    }\n    &.select-unit {\n        .react-select__menu {\n            width: 200px;\n            right: 0;\n        }\n    }\n    &.disabled {\n        // select\n        .react-select__control {\n            background: var(--grey1);\n            .react-select__value-container {\n                .react-select__single-value {\n                    color: var(--grey6);\n                }\n            }\n            .react-select__indicators {\n                .react-select__indicator {\n                    display: none;\n                }\n            }\n        }\n    }\n    &.none {\n        width: fit-content;\n        // select\n        .react-select__control {\n            border: none !important;\n            min-height: fit-content;\n            .react-select__value-container {\n                padding: 0;\n                .react-select__single-value {\n                    font-weight: 500;\n                    font-size: var(--16);\n                }\n            }\n            .react-select__indicators {\n                .react-select__indicator {\n                    padding: 0;\n                }\n            }\n        }\n\n        // react menu\n        .react-select__menu {\n            width: 200px;\n        }\n    }\n    &.multi-unit {\n        .react-select__control {\n            min-height: 30px;\n        }\n        .react-select__menu {\n            width: 100%;\n        }\n    }\n    &.is-invalid {\n        .react-select__control {\n            border: 1px solid var(--red7) !important;\n        }\n    }\n\n    // select\n    .react-select__control {\n        gap: var(--8);\n        cursor: pointer;\n        min-height: var(--32);\n        border-radius: var(--8);\n        background: var(--white);\n        border: 1px solid var(--grey3);\n        &:hover {\n            border: 1px solid var(--grey3);\n        }\n        &.react-select__control--is-focused {\n            box-shadow: none;\n            border: 1px solid var(--primary);\n        }\n        .react-select__value-container {\n            padding: 0 0 0 var(--12);\n            .react-select__placeholder {\n                margin: 0;\n                font-weight: 400;\n                color: var(--grey9);\n                font-size: var(--14);\n                line-height: var(--18);\n                letter-spacing: -0.02em;\n            }\n            .react-select__single-value {\n                margin: 0;\n                font-weight: 400;\n                color: var(--grey9);\n                font-size: var(--14);\n                line-height: var(--18);\n                letter-spacing: -0.02em;\n            }\n            .react-select__input-container {\n                margin: 0;\n                padding: 0;\n            }\n        }\n        .react-select__indicators {\n            .react-select__indicator-separator {\n                display: none;\n            }\n            .react-select__indicator {\n                padding: 0 var(--12) 0 0;\n                svg {\n                    fill: var(--grey9);\n                }\n            }\n        }\n    }\n\n    // react menu\n    .react-select__menu {\n        z-index: 9999;\n        margin: 1px 0 0 0;\n        margin-top: var(--4);\n        border-radius: var(--8);\n        background: var(--white);\n        border: 1px solid var(--grey2);\n        box-shadow: 0px 4px 6px -2px #1a1a1a33;\n        .react-select__menu-list {\n            padding: 0;\n            padding: 4px;\n            overflow-y: auto;\n            max-height: 188px;\n            scrollbar-width: thin;\n            scrollbar-width: thin;\n            &::-webkit-scrollbar {\n                width: 6px;\n                height: 274px;\n            }\n            &::-webkit-scrollbar-thumb {\n                border-radius: 10px;\n                background-color: var(--grey2);\n            }\n            .react-select__option {\n                padding: 8px;\n                cursor: pointer;\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 18px;\n                color: var(--grey9);\n                letter-spacing: -0.02em;\n                text-wrap-style: balance;\n                transition: all ease-in-out 0.2s;\n                &:hover {\n                    font-weight: 500;\n                    color: var(--blue6);\n                    background: var(--blue1) !important;\n                }\n                &.react-select__option--is-selected {\n                    font-weight: 500;\n                    position: relative;\n                    color: var(--blue6);\n                    background: var(--blue1);\n                    &::before {\n                        content: '';\n                        width: var(--16);\n                        height: 16px;\n                        position: absolute;\n                        top: 10px;\n                        right: 8px;\n                        background: url('../../images/icons/check-blue.svg') no-repeat center center;\n                    }\n                }\n                &.css-d7l1ni-option {\n                    background: transparent;\n                }\n            }\n        }\n    }\n}\n.react-select--is-disabled {\n    .react-select__control {\n        min-height: 32px;\n        border-radius: 6px;\n        background: var(--grey1);\n        border: 1px solid var(--grey3);\n        .react-select__value-container {\n            .react-select__placeholder {\n                margin: 0;\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 16px;\n                color: var(--grey6);\n                letter-spacing: -0.02em;\n            }\n        }\n        .react-select__indicators {\n            .react-select__indicator {\n                svg {\n                    fill: var(--grey6) !important;\n                }\n            }\n        }\n    }\n}\n\n// ===== custom scrollbar =====\n.custom-scrollbar {\n    scrollbar-width: thin;\n\n    &::-webkit-scrollbar {\n        width: 6px;\n        height: 274px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        border-radius: 10px;\n        background-color: var(--grey2);\n    }\n}\n\n// ===== custom search =====\n.custom-search {\n    width: 240px;\n    height: 32px;\n    line-height: 16px;\n    border-radius: 6px;\n    color: var(--grey9);\n    letter-spacing: -0.02em;\n    padding: 8px 12px 8px 36px;\n    background-color: var(--white);\n    border: 1px solid var(--grey3);\n    background: url('../../images/icons/search.svg') no-repeat;\n    background-position: 12px center;\n    &:focus {\n        border: 1px solid var(--primary);\n    }\n    &::placeholder {\n        font-weight: 400;\n        line-height: 16px;\n        color: var(--grey5);\n        letter-spacing: -0.02em;\n    }\n}\n\n// ===== custom search no icon =====\n.custom-search-n-icon {\n    width: 300px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    padding: 12px 10px;\n    border-radius: 4px;\n    color: var(--grey9);\n    letter-spacing: -0.02em;\n    border: 1px solid var(--grey3);\n    &::placeholder {\n        color: var(--grey5);\n    }\n    &:focus {\n        border: 1px solid var(--primary);\n    }\n}\n\n// ===== custom field =====\n.custom-field {\n    height: 38px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    color: var(--grey10);\n    letter-spacing: -0.02em;\n    background: var(--white);\n    border: 1px solid var(--grey3);\n    &:focus {\n        border: 1px solid var(--primary);\n    }\n    &::placeholder {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n        color: var(--grey5);\n        letter-spacing: -0.02em;\n    }\n    &.is-invalid {\n        background-image: none;\n    }\n    &.error-border {\n        border: 1px solid var(--red7);\n    }\n}\n\n// ===== form label =====\n.form-label {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    margin-bottom: 6px;\n    color: var(--grey7);\n    letter-spacing: -0.02em;\n}\n\n// ===== custom input =====\n.custom-input {\n    width: 100%;\n    display: flex;\n    // flex-wrap: wrap;\n    position: relative;\n    align-items: stretch;\n    > .custom-number-format {\n        position: relative;\n        flex: 1 1 auto;\n        width: 70px;\n        min-width: 0;\n    }\n}\n\n// ===== custom number format =====\n.custom-number-format {\n    height: 32px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    padding: 8px 12px;\n    color: var(--grey9);\n    letter-spacing: -0.02em;\n    border-radius: 6px 0 0 6px;\n    border: 1px solid var(--grey3);\n    border-right: none;\n    &:focus {\n        border: 1px solid var(--primary) !important;\n        border-right: none !important;\n        + .custom-input-text {\n            border: 1px solid var(--primary) !important;\n        }\n    }\n    &.is-invalid {\n        border: 1px solid var(--red7) !important;\n        border-right: none !important;\n        + .custom-input-text {\n            border: 1px solid var(--red7) !important;\n        }\n    }\n    &.price {\n        order: 1;\n        border-radius: 0 6px 6px 0;\n        border: 1px solid var(--grey3);\n        border-left: none;\n        &:focus {\n            border: 1px solid var(--primary) !important;\n            border-left: none !important;\n            + .custom-input-text {\n                border: 1px solid var(--primary) !important;\n            }\n        }\n        &.is-invalid {\n            border: 1px solid var(--red7) !important;\n            border-left: none !important;\n            + .custom-input-text {\n                border: 1px solid var(--red7) !important;\n            }\n        }\n    }\n    &.full-border {\n        border-radius: 6px;\n        border: 1px solid var(--grey3);\n        &:focus {\n            border: 1px solid var(--primary) !important;\n            + .custom-input-text {\n                border: 1px solid var(--primary) !important;\n            }\n        }\n        &.is-invalid {\n            border: 1px solid var(--red7) !important;\n            + .custom-input-text {\n                border: 1px solid var(--red7) !important;\n            }\n        }\n    }\n}\n\n// ===== custom input text =====\n.custom-input-text {\n    height: 32px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    padding: 8px 12px;\n    color: var(--grey9);\n    letter-spacing: -0.02em;\n    background: var(--grey1);\n    border-radius: 0 6px 6px 0;\n    border: 1px solid var(--grey3);\n    &.price {\n        border-radius: 6px 0 0 6px;\n    }\n}\n\n// ===== react date picker =====\n.react-datepicker-wrapper {\n    width: 100%;\n    .react-datepicker__input-container {\n        .input-group {\n            width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            position: relative;\n            align-items: stretch;\n            .form-control {\n                position: relative;\n                flex: 1 1 auto;\n                width: 1%;\n                height: 32px;\n                font-size: 12px;\n                font-weight: 400;\n                padding: 8px 12px;\n                line-height: 16px;\n                color: var(--grey9);\n                background-image: none;\n                letter-spacing: -0.02em;\n                border-radius: 6px 0 0 6px;\n                border: 1px solid var(--grey3);\n                border-right: none !important;\n                transition: none !important;\n                &:focus {\n                    border: 1px solid var(--primary) !important;\n                    border-right: none !important;\n                    + .input-group-text-plain {\n                        border: 1px solid var(--primary) !important;\n                        border-left: none !important;\n                    }\n                }\n                &.is-invalid {\n                    border: 1px solid var(--red7) !important;\n                    border-right: none !important;\n                    + .input-group-text-plain {\n                        border: 1px solid var(--red7) !important;\n                    }\n                }\n                &:disabled {\n                    background: var(--grey1);\n                    + .input-group-text-plain {\n                        background: var(--grey1);\n                    }\n                }\n            }\n            .input-group-text-plain {\n                height: 32px;\n                padding: 8px 12px;\n                margin: 0 !important;\n                color: var(--primary);\n                border-radius: 0 6px 6px 0;\n                border: 1px solid var(--grey3);\n                border-left: none !important;\n                svg {\n                    width: 16px;\n                    height: 16px;\n                }\n            }\n        }\n    }\n}\n\n// ===== swal2 popup detail planning =====\n.delete-planning {\n    .swal2-popup {\n        padding: 0;\n        width: 550px;\n        border-radius: 8px;\n        // ===== icon =====\n        .swal2-icon {\n            border: none;\n            margin: 16px 24px 0 24px;\n            background: var(--red1);\n            .swal2-icon-content {\n                width: 100%;\n                height: 100%;\n                .icon-wrapper-red {\n                    width: 100%;\n                    height: 100%;\n                    .info-red6 {\n                        display: block;\n                        width: 100%;\n                        height: 100%;\n                        background: url('../../../assets/images/icons/planning/warning-red.svg') no-repeat center center;\n                    }\n                }\n            }\n        }\n        // ===== title =====\n        .swal2-title {\n            text-align: start;\n            margin: 20px 24px 12px 24px;\n        }\n        // ===== text =====\n        .swal2-html-container {\n            margin: 0 24px;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 20px;\n            text-align: start;\n            color: var(--grey6);\n            letter-spacing: -0.32px;\n        }\n        // ===== button =====\n        .swal2-actions {\n            border-radius: 0 0 8px 8px;\n        }\n    }\n}\n\n// ===== custom tabs =====\n.custom-tabs {\n    border: none !important;\n    .rts___tabs___container {\n        border: none !important;\n        .rts___tabs {\n            .rts___btn {\n                margin: 0;\n                transition: all 0.3s ease-in-out;\n                &:hover {\n                    color: var(--white) !important;\n                    background: var(--primary) !important;\n                    border: 1px solid var(--primary) !important;\n                }\n            }\n            .rts___tab___selected {\n                color: var(--white) !important;\n                background: var(--primary) !important;\n                border: 1px solid var(--primary) !important;\n            }\n        }\n    }\n}\n\n// ===== tab with bg =====\n.tab-w-bg {\n    .rts___tabs___container {\n        .rts___tabs {\n            display: flex;\n            width: fit-content;\n            border-radius: 6px;\n            align-items: center;\n            padding: 2px !important;\n            background: var(--grey1);\n            border: 1px solid var(--grey2);\n            .rts___btn {\n                margin: 0 !important;\n                border: none !important;\n                padding: 4px 20px !important;\n                transition: all 0.1s ease-in-out !important;\n                &:hover,\n                &.rts___tab___selected {\n                    border-radius: 4px !important;\n                    color: var(--primary) !important;\n                    background: var(--white) !important;\n                    box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.05) !important;\n                    img {\n                        filter: brightness(0) saturate(100%) invert(20%) sepia(94%) saturate(715%) hue-rotate(145deg)\n                            brightness(96%) contrast(95%);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.ws-nowrap {\n    white-space: nowrap;\n}\n\n.flex-none {\n    flex: none !important;\n}\n",".heading {\n    font-weight: 700 !important;\n    letter-spacing: -0.02em !important;\n    &.heading1 {\n        font-size: 40px !important;\n        line-height: 48px !important;\n    }\n    &.heading2 {\n        font-size: 36px !important;\n        line-height: 44px !important;\n    }\n    &.heading3 {\n        font-size: 32px !important;\n        line-height: 38px !important;\n    }\n}\n\n.title {\n    font-weight: 600 !important;\n    letter-spacing: -0.02em !important;\n    &.title1 {\n        font-size: 24px !important;\n        line-height: 28px !important;\n    }\n    &.title2 {\n        font-size: 20px !important;\n        line-height: 24px !important;\n    }\n}\n\n.subtitle {\n    font-weight: 500 !important;\n    letter-spacing: -0.02em !important;\n    &.subtitle1 {\n        font-size: 20px !important;\n        line-height: 24px !important;\n    }\n    &.subtitle2 {\n        font-size: 18px !important;\n        line-height: 24px !important;\n    }\n    &.subtitle3 {\n        font-size: 16px !important;\n        line-height: 20px !important;\n    }\n    &.subtitle4 {\n        font-size: 14px !important;\n        line-height: 18px !important;\n    }\n}\n\n.body {\n    font-weight: 400 !important;\n    letter-spacing: -0.02em !important;\n    &.bodyL {\n        font-size: 18px !important;\n        line-height: 24px !important;\n    }\n    &.bodyM {\n        font-size: 16px !important;\n        line-height: 20px !important;\n    }\n    &.bodyS {\n        font-size: 14px !important;\n        line-height: 18px !important;\n    }\n    &.bodyXs {\n        font-size: 12px !important;\n        line-height: 16px !important;\n    }\n}\n\n.label {\n    font-weight: 400 !important;\n    letter-spacing: -0.02em !important;\n    &.label1 {\n        font-size: 12px !important;\n        line-height: 16px !important;\n    }\n    &.label2 {\n        font-size: 12px !important;\n        font-weight: 500 !important;\n        line-height: 16px !important;\n    }\n}\n\n.caption {\n    font-size: 10px !important;\n    font-weight: 400 !important;\n    line-height: 14px !important;\n    letter-spacing: -0.02em !important;\n}\n",":root {\n    --4: 4px;\n    --6: 6px;\n    --8: 8px;\n    --10: 10px;\n    --12: 12px;\n    --14: 14px;\n    --16: 16px;\n    --18: 18px;\n    --20: 20px;\n    --24: 24px;\n    --28: 28px;\n    --32: 32px;\n    --38: 38px;\n    --40: 40px;\n    --42: 42px;\n    --46: 46px;\n    --48: 48px;\n    --50: 50px;\n    --56: 56px;\n    --64: 64px;\n    --72: 72px;\n} // === margin ===\n.m-4px {\n    margin: var(--4) !important;\n}\n.m-6px {\n    margin: var(--6) !important;\n}\n.m-8px {\n    margin: var(--8) !important;\n}\n.m-10px {\n    margin: var(--10) !important;\n}\n.m-12px {\n    margin: var(--12) !important;\n}\n.m-14px {\n    margin: var(--14) !important;\n}\n.m-16px {\n    margin: var(--16) !important;\n}\n.m-18px {\n    margin: var(--18) !important;\n}\n.m-20px {\n    margin: var(--20) !important;\n}\n.m-24px {\n    margin: var(--24) !important;\n}\n.m-28px {\n    margin: var(--28) !important;\n}\n.m-32px {\n    margin: var(--32) !important;\n}\n.m-38px {\n    margin: var(--38) !important;\n}\n.m-40px {\n    margin: var(--40) !important;\n}\n.m-42px {\n    margin: var(--42) !important;\n}\n.m-46px {\n    margin: var(--46) !important;\n}\n.m-48px {\n    margin: var(--48) !important;\n}\n.m-50px {\n    margin: var(--50) !important;\n}\n.m-56px {\n    margin: var(--56) !important;\n}\n.m-64px {\n    margin: var(--64) !important;\n}\n.m-72px {\n    margin: var(--72) !important;\n}\n\n// === margin top ===\n.mt-4px {\n    margin-top: var(--4) !important;\n}\n.mt-6px {\n    margin-top: var(--6) !important;\n}\n.mt-8px {\n    margin-top: var(--8) !important;\n}\n.mt-10px {\n    margin-top: var(--10) !important;\n}\n.mt-12px {\n    margin-top: var(--12) !important;\n}\n.m-14px {\n    margin-top: var(--14) !important;\n}\n.mt-16px {\n    margin-top: var(--16) !important;\n}\n.mt-18px {\n    margin-top: var(--18) !important;\n}\n.mt-20px {\n    margin-top: var(--20) !important;\n}\n.mt-24px {\n    margin-top: var(--24) !important;\n}\n.mt-28px {\n    margin-top: var(--28) !important;\n}\n.mt-32px {\n    margin-top: var(--32) !important;\n}\n.mt-38px {\n    margin-top: var(--38) !important;\n}\n.mt-40px {\n    margin-top: var(--40) !important;\n}\n.m-42px {\n    margin-top: var(--42) !important;\n}\n.mt-46px {\n    margin-top: var(--46) !important;\n}\n.mt-48px {\n    margin-top: var(--48) !important;\n}\n.mt-50px {\n    margin-top: var(--50) !important;\n}\n.mt-56px {\n    margin-top: var(--56) !important;\n}\n.mt-64px {\n    margin-top: var(--64) !important;\n}\n.mt-72px {\n    margin-top: var(--72) !important;\n}\n\n// === margin bottom ===\n.mb-4px {\n    margin-bottom: var(--4) !important;\n}\n.mb-6px {\n    margin-bottom: var(--6) !important;\n}\n.mb-8px {\n    margin-bottom: var(--8) !important;\n}\n.mb-10px {\n    margin-bottom: var(--10) !important;\n}\n.mb-12px {\n    margin-bottom: var(--12) !important;\n}\n.mb-14px {\n    margin-bottom: var(--14) !important;\n}\n.mb-16px {\n    margin-bottom: var(--16) !important;\n}\n.mb-18px {\n    margin-bottom: var(--18) !important;\n}\n.mb-20px {\n    margin-bottom: var(--20) !important;\n}\n.mb-24px {\n    margin-bottom: var(--24) !important;\n}\n.mb-28px {\n    margin-bottom: var(--28) !important;\n}\n.mb-32px {\n    margin-bottom: var(--32) !important;\n}\n.mb-38px {\n    margin-bottom: var(--38) !important;\n}\n.mb-40px {\n    margin-bottom: var(--40) !important;\n}\n.mb-42px {\n    margin-bottom: var(--42) !important;\n}\n.mb-46px {\n    margin-bottom: var(--46) !important;\n}\n.mb-48px {\n    margin-bottom: var(--48) !important;\n}\n.mb-50px {\n    margin-bottom: var(--50) !important;\n}\n.mb-56px {\n    margin-bottom: var(--56) !important;\n}\n.mb-64px {\n    margin-bottom: var(--64) !important;\n}\n.mb-72px {\n    margin-bottom: var(--72) !important;\n}\n\n// === margin left ===\n.ml-4px {\n    margin-left: var(--4) !important;\n}\n.ml-6px {\n    margin-left: var(--6) !important;\n}\n.ml-8px {\n    margin-left: var(--8) !important;\n}\n.ml-10px {\n    margin-left: var(--10) !important;\n}\n.ml-12px {\n    margin-left: var(--12) !important;\n}\n.ml-14px {\n    margin-left: var(--14) !important;\n}\n.ml-16px {\n    margin-left: var(--16) !important;\n}\n.ml-18px {\n    margin-left: var(--18) !important;\n}\n.ml-20px {\n    margin-left: var(--20) !important;\n}\n.ml-24px {\n    margin-left: var(--24) !important;\n}\n.ml-28px {\n    margin-left: var(--28) !important;\n}\n.ml-32px {\n    margin-left: var(--32) !important;\n}\n.ml-38px {\n    margin-left: var(--38) !important;\n}\n.ml-40px {\n    margin-left: var(--40) !important;\n}\n.ml-42px {\n    margin-left: var(--42) !important;\n}\n.ml-46px {\n    margin-left: var(--46) !important;\n}\n.ml-48px {\n    margin-left: var(--48) !important;\n}\n.ml-50px {\n    margin-left: var(--50) !important;\n}\n.ml-56px {\n    margin-left: var(--56) !important;\n}\n.ml-64px {\n    margin-left: var(--64) !important;\n}\n.ml-72px {\n    margin-left: var(--72) !important;\n}\n\n// === margin right ===\n.mr-4px {\n    margin-right: var(--4) !important;\n}\n.mr-6px {\n    margin-right: var(--6) !important;\n}\n.mr-8px {\n    margin-right: var(--8) !important;\n}\n.mr-10px {\n    margin-right: var(--10) !important;\n}\n.mr-12px {\n    margin-right: var(--12) !important;\n}\n.mr-14px {\n    margin-right: var(--14) !important;\n}\n.mr-16px {\n    margin-right: var(--16) !important;\n}\n.mr-18px {\n    margin-right: var(--18) !important;\n}\n.mr-20px {\n    margin-right: var(--20) !important;\n}\n.mr-24px {\n    margin-right: var(--24) !important;\n}\n.mr-28px {\n    margin-right: var(--28) !important;\n}\n.mr-32px {\n    margin-right: var(--32) !important;\n}\n.mr-38px {\n    margin-right: var(--38) !important;\n}\n.mr-40px {\n    margin-right: var(--40) !important;\n}\n.mr-42px {\n    margin-right: var(--42) !important;\n}\n.mr-46px {\n    margin-right: var(--46) !important;\n}\n.mr-48px {\n    margin-right: var(--48) !important;\n}\n.mr-50px {\n    margin-right: var(--50) !important;\n}\n.mr-56px {\n    margin-right: var(--56) !important;\n}\n.mr-64px {\n    margin-right: var(--64) !important;\n}\n.mr-72px {\n    margin-right: var(--72) !important;\n}\n\n// === margin x ===\n.mx-4px {\n    margin-left: var(--4) !important;\n    margin-right: var(--4) !important;\n}\n.mx-6px {\n    margin-left: var(--6) !important;\n    margin-right: var(--6) !important;\n}\n.mx-8px {\n    margin-left: var(--8) !important;\n    margin-right: var(--8) !important;\n}\n.mx-10px {\n    margin-left: var(--10) !important;\n    margin-right: var(--10) !important;\n}\n.mx-12px {\n    margin-left: var(--12) !important;\n    margin-right: var(--12) !important;\n}\n.mx-14px {\n    margin-left: var(--14) !important;\n    margin-right: var(--14) !important;\n}\n.mx-16px {\n    margin-left: var(--16) !important;\n    margin-right: var(--16) !important;\n}\n.mx-18px {\n    margin-left: var(--18) !important;\n    margin-right: var(--18) !important;\n}\n.mx-20px {\n    margin-left: var(--20) !important;\n    margin-right: var(--20) !important;\n}\n.mx-24px {\n    margin-left: var(--24) !important;\n    margin-right: var(--24) !important;\n}\n.mx-28px {\n    margin-left: var(--28) !important;\n    margin-right: var(--28) !important;\n}\n.mx-32px {\n    margin-left: var(--32) !important;\n    margin-right: var(--32) !important;\n}\n.mx-38px {\n    margin-left: var(--38) !important;\n    margin-right: var(--38) !important;\n}\n.mx-40px {\n    margin-left: var(--40) !important;\n    margin-right: var(--40) !important;\n}\n.mx-42px {\n    margin-left: var(--42) !important;\n    margin-right: var(--42) !important;\n}\n.mx-46px {\n    margin-left: var(--46) !important;\n    margin-right: var(--46) !important;\n}\n.mx-48px {\n    margin-left: var(--48) !important;\n    margin-right: var(--48) !important;\n}\n.mx-50px {\n    margin-left: var(--50) !important;\n    margin-right: var(--50) !important;\n}\n.mx-56px {\n    margin-left: var(--56) !important;\n    margin-right: var(--56) !important;\n}\n.mx-64px {\n    margin-left: var(--64) !important;\n    margin-right: var(--64) !important;\n}\n.mx-72px {\n    margin-left: var(--72) !important;\n    margin-right: var(--72) !important;\n}\n\n// === margin y ===\n.my-4px {\n    margin-top: var(--4) !important;\n    margin-bottom: var(--4) !important;\n}\n.my-6px {\n    margin-top: var(--6) !important;\n    margin-bottom: var(--6) !important;\n}\n.my-8px {\n    margin-top: var(--8) !important;\n    margin-bottom: var(--8) !important;\n}\n.my-10px {\n    margin-top: var(--10) !important;\n    margin-bottom: var(--10) !important;\n}\n.my-12px {\n    margin-top: var(--12) !important;\n    margin-bottom: var(--12) !important;\n}\n.my-14px {\n    margin-top: var(--14) !important;\n    margin-bottom: var(--14) !important;\n}\n.my-16px {\n    margin-top: var(--16) !important;\n    margin-bottom: var(--16) !important;\n}\n.my-18px {\n    margin-top: var(--18) !important;\n    margin-bottom: var(--18) !important;\n}\n.my-20px {\n    margin-top: var(--20) !important;\n    margin-bottom: var(--20) !important;\n}\n.my-24px {\n    margin-top: var(--24) !important;\n    margin-bottom: var(--24) !important;\n}\n.my-28px {\n    margin-top: var(--28) !important;\n    margin-bottom: var(--28) !important;\n}\n.my-32px {\n    margin-top: var(--32) !important;\n    margin-bottom: var(--32) !important;\n}\n.my-38px {\n    margin-top: var(--38) !important;\n    margin-bottom: var(--38) !important;\n}\n.my-40px {\n    margin-top: var(--40) !important;\n    margin-bottom: var(--40) !important;\n}\n.my-42px {\n    margin-top: var(--42) !important;\n    margin-bottom: var(--42) !important;\n}\n.my-46px {\n    margin-top: var(--46) !important;\n    margin-bottom: var(--46) !important;\n}\n.my-48px {\n    margin-top: var(--48) !important;\n    margin-bottom: var(--48) !important;\n}\n.my-50px {\n    margin-top: var(--50) !important;\n    margin-bottom: var(--50) !important;\n}\n.my-56px {\n    margin-top: var(--56) !important;\n    margin-bottom: var(--56) !important;\n}\n.my-64px {\n    margin-top: var(--64) !important;\n    margin-bottom: var(--64) !important;\n}\n.my-72px {\n    margin-top: var(--72) !important;\n    margin-bottom: var(--72) !important;\n}\n\n// === padding ===\n.p-4px {\n    padding: var(--4) !important;\n}\n.p-6px {\n    padding: var(--6) !important;\n}\n.p-8px {\n    padding: var(--8) !important;\n}\n.p-10px {\n    padding: var(--10) !important;\n}\n.p-12px {\n    padding: var(--12) !important;\n}\n.p-14px {\n    padding: var(--14) !important;\n}\n.p-16px {\n    padding: var(--16) !important;\n}\n.p-18px {\n    padding: var(--18) !important;\n}\n.p-20px {\n    padding: var(--20) !important;\n}\n.p-24px {\n    padding: var(--24) !important;\n}\n.p-28px {\n    padding: var(--28) !important;\n}\n.p-32px {\n    padding: var(--32) !important;\n}\n.p-38px {\n    padding: var(--38) !important;\n}\n.p-40px {\n    padding: var(--40) !important;\n}\n.p-42px {\n    padding: var(--42) !important;\n}\n.p-46px {\n    padding: var(--46) !important;\n}\n.p-48px {\n    padding: var(--48) !important;\n}\n.p-50px {\n    padding: var(--50) !important;\n}\n.p-56px {\n    padding: var(--56) !important;\n}\n.p-64px {\n    padding: var(--64) !important;\n}\n.p-72px {\n    padding: var(--72) !important;\n}\n\n// === padding top ===\n.pt-4px {\n    padding-top: var(--4) !important;\n}\n.pt-6px {\n    padding-top: var(--6) !important;\n}\n.pt-8px {\n    padding-top: var(--8) !important;\n}\n.pt-10px {\n    padding-top: var(--10) !important;\n}\n.pt-12px {\n    padding-top: var(--12) !important;\n}\n.pt-14px {\n    padding-top: var(--14) !important;\n}\n.pt-16px {\n    padding-top: var(--16) !important;\n}\n.pt-18px {\n    padding-top: var(--18) !important;\n}\n.pt-20px {\n    padding-top: var(--20) !important;\n}\n.pt-24px {\n    padding-top: var(--24) !important;\n}\n.pt-28px {\n    padding-top: var(--28) !important;\n}\n.pt-32px {\n    padding-top: var(--32) !important;\n}\n.pt-38px {\n    padding-top: var(--38) !important;\n}\n.pt-40px {\n    padding-top: var(--40) !important;\n}\n.pt-42px {\n    padding-top: var(--42) !important;\n}\n.pt-46px {\n    padding-top: var(--46) !important;\n}\n.pt-48px {\n    padding-top: var(--48) !important;\n}\n.pt-50px {\n    padding-top: var(--50) !important;\n}\n.p-56px {\n    padding-top: var(--56) !important;\n}\n.pt-64px {\n    padding-top: var(--64) !important;\n}\n.pt-72px {\n    padding-top: var(--72) !important;\n}\n\n// === padding bottom ===\n.pb-4px {\n    padding-bottom: var(--4) !important;\n}\n.pb-6px {\n    padding-bottom: var(--6) !important;\n}\n.pb-8px {\n    padding-bottom: var(--8) !important;\n}\n.pb-10px {\n    padding-bottom: var(--10) !important;\n}\n.pb-12px {\n    padding-bottom: var(--12) !important;\n}\n.pb-14px {\n    padding-bottom: var(--14) !important;\n}\n.pb-16px {\n    padding-bottom: var(--16) !important;\n}\n.pb-18px {\n    padding-bottom: var(--18) !important;\n}\n.pb-20px {\n    padding-bottom: var(--20) !important;\n}\n.pb-24px {\n    padding-bottom: var(--24) !important;\n}\n.pb-28px {\n    padding-bottom: var(--28) !important;\n}\n.pb-32px {\n    padding-bottom: var(--32) !important;\n}\n.pb-38px {\n    padding-bottom: var(--38) !important;\n}\n.pb-40px {\n    padding-bottom: var(--40) !important;\n}\n.pb-42px {\n    padding-bottom: var(--42) !important;\n}\n.pb-46px {\n    padding-bottom: var(--46) !important;\n}\n.pb-48px {\n    padding-bottom: var(--48) !important;\n}\n.pb-50px {\n    padding-bottom: var(--50) !important;\n}\n.pb-56px {\n    padding-bottom: var(--56) !important;\n}\n.pb-64px {\n    padding-bottom: var(--64) !important;\n}\n.pb-72px {\n    padding-bottom: var(--72) !important;\n}\n\n// === padding left ===\n.pl-4px {\n    padding-left: var(--4) !important;\n}\n.pl-6px {\n    padding-left: var(--6) !important;\n}\n.pl-8px {\n    padding-left: var(--8) !important;\n}\n.pl-10px {\n    padding-left: var(--10) !important;\n}\n.pl-12px {\n    padding-left: var(--12) !important;\n}\n.pl-14px {\n    padding-left: var(--14) !important;\n}\n.pl-16px {\n    padding-left: var(--16) !important;\n}\n.pl-18px {\n    padding-left: var(--18) !important;\n}\n.pl-20px {\n    padding-left: var(--20) !important;\n}\n.pl-24px {\n    padding-left: var(--24) !important;\n}\n.pl-28px {\n    padding-left: var(--28) !important;\n}\n.pl-32px {\n    padding-left: var(--32) !important;\n}\n.pl-38px {\n    padding-left: var(--38) !important;\n}\n.pl-40px {\n    padding-left: var(--40) !important;\n}\n.pl-42px {\n    padding-left: var(--42) !important;\n}\n.pl-46px {\n    padding-left: var(--46) !important;\n}\n.pl-48px {\n    padding-left: var(--48) !important;\n}\n.pl-50px {\n    padding-left: var(--50) !important;\n}\n.pl-56px {\n    padding-left: var(--56) !important;\n}\n.pl-64px {\n    padding-left: var(--64) !important;\n}\n.pl-72px {\n    padding-left: var(--72) !important;\n}\n\n// === padding right ===\n.pr-4px {\n    padding-right: var(--4) !important;\n}\n.pr-6px {\n    padding-right: var(--6) !important;\n}\n.pr-8px {\n    padding-right: var(--8) !important;\n}\n.pr-10px {\n    padding-right: var(--10) !important;\n}\n.pr-12px {\n    padding-right: var(--12) !important;\n}\n.pr-14px {\n    padding-right: var(--14) !important;\n}\n.pr-16px {\n    padding-right: var(--16) !important;\n}\n.pr-18px {\n    padding-right: var(--18) !important;\n}\n.pr-20px {\n    padding-right: var(--20) !important;\n}\n.pr-24px {\n    padding-right: var(--24) !important;\n}\n.pr-28px {\n    padding-right: var(--28) !important;\n}\n.pr-32px {\n    padding-right: var(--32) !important;\n}\n.pr-38px {\n    padding-right: var(--38) !important;\n}\n.pr-40px {\n    padding-right: var(--40) !important;\n}\n.pr-42px {\n    padding-right: var(--42) !important;\n}\n.pr-46px {\n    padding-right: var(--46) !important;\n}\n.pr-48px {\n    padding-right: var(--48) !important;\n}\n.pr-50px {\n    padding-right: var(--50) !important;\n}\n.pr-56px {\n    padding-right: var(--56) !important;\n}\n.pr-64px {\n    padding-right: var(--64) !important;\n}\n.pr-72px {\n    padding-right: var(--72) !important;\n}\n\n// === padding x ===\n.px-4px {\n    padding-left: var(--4) !important;\n    padding-right: var(--4) !important;\n}\n.px-6px {\n    padding-left: var(--6) !important;\n    padding-right: var(--6) !important;\n}\n.px-8px {\n    padding-left: var(--8) !important;\n    padding-right: var(--8) !important;\n}\n.px-10px {\n    padding-left: var(--10) !important;\n    padding-right: var(--10) !important;\n}\n.px-12px {\n    padding-left: var(--12) !important;\n    padding-right: var(--12) !important;\n}\n.px-14px {\n    padding-left: var(--14) !important;\n    padding-right: var(--14) !important;\n}\n.px-16px {\n    padding-left: var(--16) !important;\n    padding-right: var(--16) !important;\n}\n.px-18px {\n    padding-left: var(--18) !important;\n    padding-right: var(--18) !important;\n}\n.px-20px {\n    padding-left: var(--20) !important;\n    padding-right: var(--20) !important;\n}\n.px-24px {\n    padding-left: var(--24) !important;\n    padding-right: var(--24) !important;\n}\n.px-28px {\n    padding-left: var(--28) !important;\n    padding-right: var(--28) !important;\n}\n.px-32px {\n    padding-left: var(--32) !important;\n    padding-right: var(--32) !important;\n}\n.px-38px {\n    padding-left: var(--38) !important;\n    padding-right: var(--38) !important;\n}\n.px-40px {\n    padding-left: var(--40) !important;\n    padding-right: var(--40) !important;\n}\n.px-42px {\n    padding-left: var(--42) !important;\n    padding-right: var(--42) !important;\n}\n.px-46px {\n    padding-left: var(--46) !important;\n    padding-right: var(--46) !important;\n}\n.px-48px {\n    padding-left: var(--48) !important;\n    padding-right: var(--48) !important;\n}\n.px-50px {\n    padding-left: var(--50) !important;\n    padding-right: var(--50) !important;\n}\n.px-56px {\n    padding-left: var(--56) !important;\n    padding-right: var(--56) !important;\n}\n.px-64px {\n    padding-left: var(--64) !important;\n    padding-right: var(--64) !important;\n}\n.px-72px {\n    padding-left: var(--72) !important;\n    padding-right: var(--72) !important;\n}\n\n// === padding y ===\n.py-4px {\n    padding-top: var(--4) !important;\n    padding-bottom: var(--4) !important;\n}\n.py-6px {\n    padding-top: var(--6) !important;\n    padding-bottom: var(--6) !important;\n}\n.py-8px {\n    padding-top: var(--8) !important;\n    padding-bottom: var(--8) !important;\n}\n.py-10px {\n    padding-top: var(--10) !important;\n    padding-bottom: var(--10) !important;\n}\n.py-12px {\n    padding-top: var(--12) !important;\n    padding-bottom: var(--12) !important;\n}\n.py-14px {\n    padding-top: var(--14) !important;\n    padding-bottom: var(--14) !important;\n}\n.py-16px {\n    padding-top: var(--16) !important;\n    padding-bottom: var(--16) !important;\n}\n.py-18px {\n    padding-top: var(--18) !important;\n    padding-bottom: var(--18) !important;\n}\n.py-20px {\n    padding-top: var(--20) !important;\n    padding-bottom: var(--20) !important;\n}\n.py-24px {\n    padding-top: var(--24) !important;\n    padding-bottom: var(--24) !important;\n}\n.py-28px {\n    padding-top: var(--28) !important;\n    padding-bottom: var(--28) !important;\n}\n.py-32px {\n    padding-top: var(--32) !important;\n    padding-bottom: var(--32) !important;\n}\n.py-38px {\n    padding-top: var(--38) !important;\n    padding-bottom: var(--38) !important;\n}\n.py-40px {\n    padding-top: var(--40) !important;\n    padding-bottom: var(--40) !important;\n}\n.py-42px {\n    padding-top: var(--42) !important;\n    padding-bottom: var(--42) !important;\n}\n.py-46px {\n    padding-top: var(--46) !important;\n    padding-bottom: var(--46) !important;\n}\n.py-48px {\n    padding-top: var(--48) !important;\n    padding-bottom: var(--48) !important;\n}\n.py-50px {\n    padding-top: var(--50) !important;\n    padding-bottom: var(--50) !important;\n}\n.py-56px {\n    padding-top: var(--56) !important;\n    padding-bottom: var(--56) !important;\n}\n.py-64px {\n    padding-top: var(--64) !important;\n    padding-bottom: var(--64) !important;\n}\n.py-72px {\n    padding-top: var(--72) !important;\n    padding-bottom: var(--72) !important;\n}\n\n// === gap ===\n.gap-4px {\n    gap: var(--4) !important;\n}\n.gap-6px {\n    gap: var(--6) !important;\n}\n.gap-8px {\n    gap: var(--8) !important;\n}\n.gap-10px {\n    gap: var(--10) !important;\n}\n.gap-12px {\n    gap: var(--12) !important;\n}\n.gap-14px {\n    gap: var(--14) !important;\n}\n.gap-16px {\n    gap: var(--16) !important;\n}\n.gap-18px {\n    gap: var(--18) !important;\n}\n.gap-20px {\n    gap: var(--20) !important;\n}\n.gap-24px {\n    gap: var(--24) !important;\n}\n.gap-28px {\n    gap: var(--28) !important;\n}\n.gap-32px {\n    gap: var(--32) !important;\n}\n.gap-38px {\n    gap: var(--38) !important;\n}\n.gap-40px {\n    gap: var(--40) !important;\n}\n.gap-42px {\n    gap: var(--42) !important;\n}\n.gap-46px {\n    gap: var(--46) !important;\n}\n.gap-48px {\n    gap: var(--48) !important;\n}\n.gap-50px {\n    gap: var(--50) !important;\n}\n.gap-56px {\n    gap: var(--56) !important;\n}\n.gap-64px {\n    gap: var(--64) !important;\n}\n.gap-72px {\n    gap: var(--72) !important;\n}\n\n// === border radius ===\n.br-4px {\n    border-radius: var(--4) !important;\n}\n.br-6px {\n    border-radius: var(--6) !important;\n}\n.br-8px {\n    border-radius: var(--8) !important;\n}\n.br-10px {\n    border-radius: var(--10) !important;\n}\n.br-12px {\n    border-radius: var(--12) !important;\n}\n.br-14px {\n    border-radius: var(--14) !important;\n}\n.br-16px {\n    border-radius: var(--16) !important;\n}\n.br-18px {\n    border-radius: var(--18) !important;\n}\n.br-20px {\n    border-radius: var(--20) !important;\n}\n.br-24px {\n    border-radius: var(--24) !important;\n}\n.br-28px {\n    border-radius: var(--28) !important;\n}\n.br-32px {\n    border-radius: var(--32) !important;\n}\n.br-38px {\n    border-radius: var(--38) !important;\n}\n.br-40px {\n    border-radius: var(--40) !important;\n}\n.br-42px {\n    border-radius: var(--42) !important;\n}\n.br-46px {\n    border-radius: var(--46) !important;\n}\n.br-48px {\n    border-radius: var(--48) !important;\n}\n.br-50px {\n    border-radius: var(--50) !important;\n}\n.br-56px {\n    border-radius: var(--56) !important;\n}\n.br-64px {\n    border-radius: var(--64) !important;\n}\n.br-72px {\n    border-radius: var(--72) !important;\n}\n.br-circle {\n    border-radius: 50% !important;\n}\n\n// === border ===\n.border1-grey3 {\n    border: 1px solid var(--grey3) !important;\n}\n\n// === border bottom ===\n.border-bottom1-grey2 {\n    border-bottom: 1px solid var(--grey2) !important;\n}\n.border-bottom1-grey3 {\n    border-bottom: 1px solid var(--grey3) !important;\n}\n\n.border-bottom2-teal6 {\n    border-bottom: 2px solid var(--teal6) !important;\n}\n\n.border1-blue7 {\n    border: 1px solid var(--blue7) !important;\n}\n","// \n// accordions.scss\n//\n\n.custom-accordionwitharrow {\n    .card {\n        +.card {\n            margin-top: 0.5rem;\n        }\n        .card-header{\n            background-color: transparent;\n            position: relative;\n        }\n    }\n\n    .accordion-arrow {\n        position: absolute;\n        right: 1.25rem;\n    }\n\n    a {\n        &.collapsed {\n            .accordion-arrow {\n                transform: rotate(-90deg);\n            }\n        }\n    }\n}\n\n// Custom Accordion\n\n.custom-accordion {\n    .card {\n        overflow: visible;\n        border-color: transparent !important;\n        border-left: 2px dashed $gray-300 !important;\n        box-shadow: none;\n        padding-left: 40px;\n\n        .card-header {\n            border-radius: 7px !important;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 6px;\n                top: 22px;\n                width: 42px;\n                height: 2px;\n                background: $gray-300;\n            }\n        }\n\n        .icon {\n            position: absolute;\n            left: -18px;\n            top: -2px;\n        }\n    }\n}","//\n// alerts\n// Bootstrap - extended default\n//\n\n.alert-dismissible {\n    padding-right: $alert-dismissible-padding-r;\n  \n    // Adjust close link position\n    // .btn-close {\n    //   position: absolute;\n    //   top: 0;\n    //   right: 0;\n    //   z-index: $stretched-link-z-index + 1;\n    //   padding: $alert-padding-y $alert-padding-x;\n    // }\n  }\n\n  // @each $color, $value in $theme-colors {\n  //   .alert-#{$color} {\n  //     @include alert-variant(theme-color-level($value, $alert-bg-scale), theme-color-level($value, $alert-border-scale), color-yiq(theme-color-level($value, $alert-bg-scale)));\n  //     .close,\n  //     .alert-link {\n  //       color: color-yiq(theme-color-level($value, $alert-bg-scale));\n  //     }\n  //   }\n  // }\n\n  @each $color, $value in $theme-colors {\n    .alert-#{$color} {\n      color: $dark;\n      border-color: $value;\n      background-color: tint-color($value, 80%);\n    }\n  }\n  \n  \n  // scss-docs-start alert-modifiers\n  // Generate contextual modifier classes for colorizing the alert.\n  \n  // @each $state, $value in $theme-colors {\n  //   $alert-background: shift-color($value, $alert-bg-scale);\n  //   $alert-border: shift-color($value, $alert-border-scale);\n  //   $alert-color: shift-color($value, $alert-color-scale);\n  //   @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n  //     $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  //   }\n  //   .alert-#{$state} {\n  //     @include alert-variant($alert-background, $alert-border, $alert-color);\n  //   }\n  // }\n  // scss-docs-end alert-modifiers\n   ","// \n// badge.scss\n//\n.badge-soft {\n    color: $gray-800;\n}\n\n// badge soft\n\n@mixin badge-soft-variant($bg) {\n    background-color: rgba($bg, 0.12);\n    color: $bg !important;\n}\n\n@each $color, $value in $theme-colors {\n    .badge-soft-#{$color} {\n      @include badge-soft-variant($value);\n    }\n}\n\n\n// Basic Badge\n.badge {\n    &.badge-light {\n        color: $gray-800;\n    }\n    &.badge-pill {\n        border-radius: 50px !important;\n    }\n    &.badge-md {\n        padding: 4px 16px;\n        font-size: 16px;\n    }\n    &.badge-lg {\n        padding: 7px 20px;\n        font-size: 17px;\n    }\n}","//\n// backgrounds.scss\n//\n\n// soft\n@each $color, $value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.12) !important;\n    }\n}\n\n// gray\n@each $color, $value in $grays {\n    .bg-gray-#{$color} {\n        background-color: $value !important;\n    }\n}\n\n// shapes\n.shape {\n    position: absolute;\n    pointer-events: none;\n    overflow: hidden;\n\n    &.left {\n        top: 0;\n        bottom: 0;\n        left: -1px;\n    }\n\n    &.right {\n        top: 0;\n        right: -1px;\n        bottom: 0;\n    }\n\n    &.bottom {\n        bottom: -2px;\n        left: 0;\n        right: 0;\n\n        > svg {\n            width: 100%;\n        }\n    }\n\n    &.top {\n        top: -2px;\n        left: 0;\n        right: 0;\n\n        > svg {\n            width: 100%;\n        }\n    }\n\n    > svg {\n        width: auto;\n        height: 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .shape {\n        &.bottom {\n            bottom: -5px;\n        }\n    }\n}\n\n// divider\n.divider {\n    position: absolute;\n    pointer-events: none;\n    overflow: hidden;\n\n    &.top {\n        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 120' preserveAspectRatio='none'%3E%3Cg class='n2-ss-divider-end'%3E%3Cpath fill='RGBA(255,255,255,1)' opacity='0.25' d='M1920,0,0,120,0,0z'%3E%3C/path%3E%3Cpath fill='RGBA(255,255,255,1)' opacity='0.5' d='M1920,0,0,80,0,0z'%3E%3C/path%3E%3Cpath fill='RGBA(255,255,255,1)' d='M1920,-2,1920,0,0,40,0,-2z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n        top: 0px;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 120px;\n        transform: scaleX(-1);\n    }\n\n    &.bottom {\n        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 120' preserveAspectRatio='none'%3E%3Cg class='n2-ss-divider-end'%3E%3Cpath fill='RGBA(255,255,255,1)' opacity='0.25' d='M1920,0,0,120,0,0z'%3E%3C/path%3E%3Cpath fill='RGBA(255,255,255,1)' opacity='0.5' d='M1920,0,0,80,0,0z'%3E%3C/path%3E%3Cpath fill='RGBA(255,255,255,1)' d='M1920,-2,1920,0,0,40,0,-2z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n        bottom: 0px;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 120px;\n        transform: scaleX(1) scaleY(-1);\n    }\n}\n\n// animation - TODO\n.animate {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    -webkit-transition: 0.3s ease-in-out;\n    transition: 0.3s ease-in-out;\n}\n\n.animate:hover {\n    -webkit-transform: scale(1.1);\n    transform: scale(1.1);\n}\n\n// gradients\n.bg-gradient {\n    background: linear-gradient(180deg, rgba($primary, 0.05) 0%, rgba($primary, 0.02) 100%);\n}\n\n.bg-gradient2 {\n    background: #f7f8fb;\n}\n\n.bg-gradient3 {\n    background: linear-gradient(#f4f5f7 0, #fafafb 100%);\n}\n\n.bg-gradient4 {\n    background: linear-gradient(rgba($orange, 0.075) 0%, rgba($warning, 0.1) 100%) no-repeat left center;\n}\n\n.bg-gradient5 {\n    background: linear-gradient(rgba($orange, 0.05) 0%, rgba($orange, 0.07) 100%) no-repeat left center;\n}\n\n.bg-gradient6 {\n    background: linear-gradient(rgba($primary, 0.12) 0%, rgba($primary, 0.02) 100%) no-repeat top center;\n}\n","//\n// breadcrumb.scss\n//\n\n// breadcrumb without background\n.breadcrumb-no-bg {\n    background-color: transparent;\n}\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    + .breadcrumb-item {\n        align-items: center !important;\n\n        &::before {\n            // background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='1rem' height='1rem' stroke='currentColor' strokeWidth='2' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n            vertical-align: middle;\n            width: 1rem;\n            height: 1rem;\n        }\n    }\n}\n","//\r\n// buttons.scss\r\n//\r\n\r\n.buttons-excel {\r\n    color: #fff !important;\r\n    background-color: #3cd278 !important;\r\n    border-color: #3cd278 !important;\r\n    color: white !important;\r\n    border-radius: 5px;\r\n}\r\n\r\n.btn {\r\n    .icon {\r\n        svg {\r\n            width: 1rem;\r\n            height: 1rem;\r\n            margin-left: 0.1rem;\r\n            margin-top: -2px;\r\n        }\r\n    }\r\n}\r\n\r\n.btn-rounded {\r\n    border-radius: 2.125rem;\r\n}\r\n\r\n.btn-rounded-circle {\r\n    border-radius: 50%;\r\n}\r\n\r\n// icon button\r\n.btn-icon {\r\n    padding: 0;\r\n    width: 2.625rem;\r\n    height: 2.625rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    &.btn-sm {\r\n        height: 1.75rem;\r\n        width: 1.75rem;\r\n    }\r\n\r\n    &.btn-lg {\r\n        height: 2.875rem;\r\n        width: 2.875rem;\r\n    }\r\n}\r\n\r\n//\r\n// Link buttons\r\n//\r\n// Make a button look and behave like a link\r\n.btn-link {\r\n    font-weight: $font-weight-normal;\r\n    color: $link-color;\r\n    background-color: transparent;\r\n\r\n    &:hover {\r\n        color: $link-hover-color;\r\n        text-decoration: $link-hover-decoration;\r\n        background-color: transparent;\r\n        border-color: transparent;\r\n    }\r\n\r\n    &:focus,\r\n    &.focus {\r\n        text-decoration: $link-hover-decoration;\r\n        border-color: transparent;\r\n        box-shadow: none;\r\n    }\r\n\r\n    &:disabled,\r\n    &.disabled {\r\n        color: $btn-link-disabled-color;\r\n        pointer-events: none;\r\n    }\r\n}\r\n\r\n// Override styles\r\n\r\n@each $color, $value in $theme-colors {\r\n    .btn-#{$color} {\r\n        &:hover,\r\n        &:focus {\r\n            border-color: $value;\r\n            box-shadow: 0px 8px 20px -6px rgba($value, 0.6);\r\n            background: $value;\r\n        }\r\n    }\r\n\r\n    .btn-outline-#{$color} {\r\n        @include button-outline-variant($value);\r\n\r\n        &:hover,\r\n        &:focus {\r\n            box-shadow: 0px 8px 20px -6px rgba($value, 0.6);\r\n        }\r\n    }\r\n\r\n    .btn-soft-#{$color} {\r\n        background-color: rgba($value, 0.1);\r\n        color: $value;\r\n        border-color: transparent;\r\n\r\n        &:hover,\r\n        &:focus {\r\n            background-color: fade-in(rgba($value, 0.1), 0.05);\r\n            border-color: rgba($value, 0.1);\r\n            color: $value;\r\n            box-shadow: 0 1px 1px rgba($value, 0.1), 0 2px 4px 1px rgba($value, 0.1);\r\n        }\r\n    }\r\n}\r\n\r\n//\r\n// light button\r\n//\r\n.btn-white {\r\n    border-color: $gray-300;\r\n    transition: $btn-transition;\r\n    border-radius: $btn-border-radius;\r\n\r\n    &:hover,\r\n    &:focus {\r\n        color: $dark !important;\r\n        background-color: $white !important;\r\n        box-shadow: 0 1px 3px rgba(60, 72, 88, 0.15), 0 2px 4px 2px rgba(60, 72, 88, 0.18);\r\n    }\r\n}\r\n\r\n//\r\n// back to top\r\n//\r\n.btn-back-to-top {\r\n    position: fixed;\r\n    bottom: 1rem;\r\n    right: 1rem;\r\n    display: none;\r\n    z-index: 10;\r\n\r\n    &.show {\r\n        display: flex;\r\n    }\r\n}\r\n\r\n//\r\n// play button\r\n//\r\n.btn-play {\r\n    width: 3.5rem;\r\n    height: 3.5rem;\r\n    background: radial-gradient(rgba($success, 1) 98%, white 100%);\r\n    border-radius: 50%;\r\n    position: relative;\r\n    box-shadow: $box-shadow-lg;\r\n\r\n    @each $color, $value in $theme-colors {\r\n        &.#{$color} {\r\n            background: radial-gradient(rgba($value, 1) 98%, white 100%);\r\n        }\r\n    }\r\n\r\n    /* triangle */\r\n    &::after {\r\n        content: '';\r\n        position: absolute;\r\n        left: 50%;\r\n        top: 50%;\r\n        transform: translateX(-40%) translateY(-50%);\r\n        transform-origin: center center;\r\n        width: 0;\r\n        height: 0;\r\n        border-top: 0.5rem solid transparent;\r\n        border-bottom: 0.5rem solid transparent;\r\n        border-left: 0.75rem solid #fff;\r\n        z-index: 100;\r\n        transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    /* pulse wave */\r\n    &::before {\r\n        content: '';\r\n        position: absolute;\r\n        width: 130%;\r\n        height: 130%;\r\n        opacity: 1;\r\n        border-radius: 50%;\r\n        border: 3px solid rgba(255, 255, 255, 0.75);\r\n        top: -15%;\r\n        left: -15%;\r\n        background: rgba(198, 16, 0, 0);\r\n        animation-delay: 0s;\r\n        animation: pulsate1 2s;\r\n        animation-direction: forwards;\r\n        animation-iteration-count: infinite;\r\n        animation-timing-function: steps;\r\n    }\r\n\r\n    @keyframes pulsate1 {\r\n        0% {\r\n            -webkit-transform: scale(0.6);\r\n            transform: scale(0.6);\r\n            opacity: 1;\r\n            box-shadow: inset 0px 0px 25px 3px rgba(255, 255, 255, 0.75), 0px 0px 25px 10px rgba(255, 255, 255, 0.75);\r\n        }\r\n\r\n        100% {\r\n            -webkit-transform: scale(1, 1);\r\n            transform: scale(1);\r\n            opacity: 0;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n}\r\n\r\n.btn-outline-secondary {\r\n    background: #fff;\r\n    color: #202224;\r\n    border: 1px solid #d0d5da;\r\n    &.focus {\r\n        background: transparent;\r\n    }\r\n}\r\n\r\n.btn-hover-img {\r\n    &:hover {\r\n        img {\r\n            filter: brightness(0) invert(1);\r\n        }\r\n    }\r\n}\r\n\r\n.btn-disabled {\r\n    background: #eceef0 !important;\r\n    border: 1px solid #d0d5da !important;\r\n    color: #d0d5da !important;\r\n    cursor: unset !important;\r\n    img {\r\n        filter: grayscale(100%) brightness(10) sepia(1) saturate(1000%) hue-rotate(180deg) brightness(0.9);\r\n    }\r\n}\r\n\r\n// ===== btn download =====\r\n.btn-download {\r\n    cursor: pointer;\r\n    padding: 6px 8px;\r\n    border-radius: 6px;\r\n    border: 1px solid var(--grey3);\r\n    transition: all 0.1s ease-in-out !important;\r\n    img {\r\n        filter: brightness(0) saturate(100%) invert(15%) sepia(8%) saturate(377%) hue-rotate(180deg) brightness(91%)\r\n            contrast(90%);\r\n    }\r\n    &:hover {\r\n        color: var(--teal6) !important;\r\n        img {\r\n            filter: brightness(0) saturate(100%) invert(20%) sepia(94%) saturate(715%) hue-rotate(145deg)\r\n                brightness(96%) contrast(95%);\r\n        }\r\n    }\r\n}\r\n","// \n// card.scss\n//\n\n.card {\n    margin-bottom: $grid-gutter-width;\n    position: relative;\n    box-shadow: $box-shadow-sm;\n\n    &.hoverable {\n        transition: $transition-base;\n\n        &:hover {\n            box-shadow: 0rem 0rem 1.5rem 0px rgba(0, 0, 0, 0.12);\n            transform: translateY(-3px) !important;\n        }\n    }\n\n    .card-img-overlay {\n        .overlay-light-top {\n            padding: $card-img-overlay-padding $card-img-overlay-padding $card-img-overlay-padding * 1.5 $card-img-overlay-padding;\n            background: linear-gradient(180deg, $white 0%, rgba($white, 0.95) 50%, rgba($white, 0.90) 75%, transparent 100%);\n        }\n\n        .overlay-light-bottom {\n            position: absolute;\n            bottom: 0;\n            padding: $card-img-overlay-padding * 1.5 $card-img-overlay-padding $card-img-overlay-padding $card-img-overlay-padding;\n            background: linear-gradient(0deg, rgba($white, 0.95) 0%, rgba($white, 0.90) 50%, rgba($white, 0.85) 85%, transparent 100%);\n        }\n    }\n}\n\n.card-footer {\n    border-color: lighten($gray-200, 1%);\n}\n\n.card-drop {\n    display: inline-block;\n    font-size: 20px;\n    line-height: 30px;\n    color: inherit;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    text-align: center;\n    margin-top: -6px;\n\n    &:hover {\n        background-color: $gray-200;\n        color: $dark;\n    }\n}\n\n\n// Card title / Card Header\n.card-title,\n.card-header {\n    margin-top: 0;\n}\n\n.card-nav {\n    margin: -0.5rem 0;\n}\n\n// Custom card box\n.card-box {\n    background-color: $card-bg;\n    padding: $card-spacer-x;\n    margin-bottom: $grid-gutter-width;\n    @include border-radius($card-border-radius);\n}\n\n\n// custom positioning in card overlay\n.card-img-top-overlay {\n    position: relative;\n\n    .overlay {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba($gray-600, 0.4);\n    }\n\n    .overlay-light {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba($gray-200, 0.5);\n    }\n\n    .overlay-dark {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba($gray-900, 0.5);\n    }\n\n    .card-overlay-top {\n        position: absolute;\n        top: .75rem;\n        right: 1.25rem;\n        left: 1.25rem;\n    }\n\n    .card-overlay-bottom {\n        position: absolute;\n        right: 1.25rem;\n        bottom: .75rem;\n        left: 1.25rem;\n    }\n\n    .card-badge {\n        position: absolute;\n        font-size: 0.8125rem;\n        line-height: 1.5rem;\n        font-weight: $font-weight-bold;\n        box-shadow: $box-shadow-lg;\n        padding-left: 0.75rem;\n        padding-right: 0.75rem;\n        border-radius: $border-radius-sm;\n        z-index: 1000;\n\n        &.top-left {\n            top: 1rem;\n            left: 1rem;\n        }\n\n        &.bottom-left {\n            bottom: 1rem;\n            left: 1rem;\n        }\n\n        &.top-right {\n            top: 1rem;\n            right: 1rem;\n        }\n\n        &.bottom-right {\n            bottom: 1rem;\n            right: 1rem;\n        }\n    }\n}\n\n.card-portfolio-item {\n    .card-zoom {\n        overflow: hidden!important;\n        border-radius: inherit;\n\n        img {\n            transition: $transition-base;\n            transform-origin: center center;\n            border-radius: inherit;\n        }\n    }\n    \n\n    &:hover {\n        .card-zoom {\n            img {\n                transform: scale(1.1);\n            }\n        }\n    }   \n}\n\n.card-listing-item {\n    overflow: hidden !important;\n    border: $border-width solid $border-color !important;\n\n    &.overlay {\n        .overlay-details {\n            position: absolute;\n            opacity: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            backdrop-filter: blur(5px);\n            background: rgba($black, 0.25);\n            transform: translateY(10%);\n            transition: $transition-base;\n        }\n\n        &:hover {\n            .overlay-details {\n                opacity: 1;\n                transform: translateY(0px);\n            }\n        }\n    }\n}\n\n.sticky-el {\n    position: sticky;\n    top: 50px;\n}","// \n// dropdown.scss\n//\n\n.dropdown {\n\n    .dropdown-menu {\n        font-size: $font-size-base;\n        z-index: $zindex-fixed;\n        box-shadow: $box-shadow-lg;\n        padding: $dropdown-padding-y $dropdown-padding-x;\n        top: 100%;\n\n        &.dropdown-menu-sm {\n            width: $dropdown-min-width-sm;\n        }\n\n        &.dropdown-menu-lg {\n            width: $dropdown-min-width-lg;\n        }\n\n        &.dropdown-menu-xl {\n            width: $dropdown-min-width-xl;\n        }\n        .dropdown-item {\n            border-radius: $dropdown-border-radius;\n        }\n    }\n\n    &.btn-group {\n        .btn {\n\n            &:hover,\n            &:active,\n            &:focus {\n                transform: translate3d(0, 0px, 0) !important;\n            }\n        }\n    }\n}","// icon font sizes\n$icon-size-base: 3rem;\n\n$icon-font-sizes: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$icon-font-sizes: map-merge((\"xxs\": 1.25rem,\n        \"xs\": 1.5rem,\n        \"sm\": 2.25rem,\n        \"md\": 3rem,\n        \"lg\": 4rem,\n        \"xl\": 5rem,\n        \"xxl\": 6rem),\n    $icon-font-sizes);\n\n// Dropdown menu container and contents.\n$dropdown-min-width-sm: 5rem;\n$dropdown-min-width-lg: 20rem;\n$dropdown-min-width-xl: 30rem;\n\n// navbar dropdowns\n$navbar-dropdown-min-width: calc(#{$dropdown-min-width} + 3rem);\n$navbar-dropdown-min-width-lg: 30rem;\n$navbar-dropdown-min-width-xl: 48rem;\n$navbar-dropdown-spacer: 0.75rem;\n$navbar-dropdown-toggle-margin-bottom: 1.25rem;\n\n// custom\n$gray-50: lighten($gray-100, 2%);\n\n// Hero height\n\n$hero-height : 700px;","//\r\n// forms.scss\r\n//\r\n\r\n// Form-control light\r\n.form-control-light {\r\n    background-color: $gray-100;\r\n    border-color: $gray-100;\r\n}\r\n\r\n// Form elements (Color and Range)\r\ninput.form-control[type='color'],\r\ninput.form-control[type='range'] {\r\n    min-height: 39px;\r\n}\r\n\r\n// Custom select\r\n.custom-select.is-invalid,\r\n.form-control.is-invalid,\r\n.custom-select:invalid,\r\n.form-control:invalid,\r\n.custom-select.is-valid,\r\n.form-control.is-valid,\r\n.custom-select:valid,\r\n.form-control:valid {\r\n    &:focus {\r\n        box-shadow: none !important;\r\n    }\r\n}\r\n\r\n// Comment box\r\n.comment-area-box {\r\n    .form-control {\r\n        border-color: $gray-300;\r\n        border-radius: $input-border-radius $input-border-radius 0 0;\r\n    }\r\n    .comment-area-btn {\r\n        background-color: $gray-100;\r\n        padding: 10px;\r\n        border: 1px solid $gray-300;\r\n        border-top: none;\r\n        border-radius: 0 0 $input-border-radius $input-border-radius;\r\n    }\r\n}\r\n\r\n// Input\r\ninput {\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n}\r\n\r\n// Custom - form-group-hint\r\n.form-control-with-hint {\r\n    position: relative;\r\n    .form-control {\r\n        padding-right: 50px !important;\r\n    }\r\n    .form-control-feedback {\r\n        position: absolute;\r\n        top: $input-border-width + 1;\r\n        bottom: $input-border-width + 1;\r\n        right: $input-padding-x * 0.75;\r\n        display: flex;\r\n        align-items: center;\r\n        background: transparent;\r\n        font-size: 0.75rem;\r\n        font-weight: $font-weight-semibold;\r\n        color: lighten($input-color, 15%);\r\n    }\r\n}\r\n\r\n// .form-label {\r\n//     font-weight: $font-weight-medium !important;\r\n// }\r\n\r\n.form-check {\r\n    .form-check-input:checked ~ .form-label {\r\n        &::after {\r\n            background-image: none;\r\n            font-family: 'unicons';\r\n            content: '\\e8d9';\r\n            font-size: 1.25rem;\r\n            top: -0.185rem;\r\n            left: -1.7rem;\r\n            color: #ffffff;\r\n        }\r\n    }\r\n}\r\n\r\n.color55 {\r\n    color: #555555;\r\n}\r\n\r\n.rbt-aux {\r\n    position: absolute !important;\r\n    top: 10px !important;\r\n    right: 10px !important;\r\n}\r\n\r\n.t-sticky {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    top: 0;\r\n}\r\n\r\n.rbt-menu {\r\n    box-shadow: 0px 1px 7px rgb(0 0 0 / 15%) !important;\r\n    z-index: 800 !important;\r\n}\r\n\r\n.label-length-data {\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    width: max-content;\r\n    border-radius: 5px;\r\n    background: #e8edff;\r\n    color: #0b7f8e;\r\n}\r\n\r\n.color-y {\r\n    color: #f78216;\r\n}\r\n\r\n.react-datepicker-popper {\r\n    z-index: 9 !important;\r\n}\r\n\r\n.text-color-blue {\r\n    color: #0b7f8e;\r\n    cursor: pointer;\r\n    &:hover {\r\n        opacity: 0.8;\r\n    }\r\n}\r\n.rbt-token {\r\n    color: #0b7f8e !important;\r\n}\r\n\r\n.color555 {\r\n    color: #555555;\r\n}\r\n\r\n.text-align-right {\r\n    text-align: right !important;\r\n}\r\n\r\n.fs-10 {\r\n    font-size: 10px !important;\r\n}\r\n.border-blue {\r\n    border-color: #0b7f8e;\r\n}\r\n\r\n.label-perusahaan {\r\n    width: fit-content;\r\n    border: 1px solid #c1c1c1;\r\n    border-radius: 5px;\r\n    background: #c1c1c1;\r\n    color: white;\r\n    font-weight: bold;\r\n\r\n    padding: 0px 5px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.link {\r\n    cursor: pointer;\r\n    color: blue;\r\n    &:hover {\r\n        opacity: 0.8;\r\n    }\r\n}\r\n\r\n.blink {\r\n    animation: blinkMe 2s linear infinite;\r\n}\r\n\r\n.text-load-sensor {\r\n    position: relative;\r\n    top: 95px;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.x-icon {\r\n    position: absolute;\r\n    right: 5px;\r\n    top: 20px;\r\n}\r\n@keyframes blinkMe {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n    100% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type='number'] {\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n.highlightOption {\r\n    background: none !important;\r\n    color: none !important;\r\n}\r\n\r\n.input-search-iot {\r\n    max-width: 300px;\r\n    float: right;\r\n    position: relative;\r\n    top: 25px;\r\n}\r\n\r\n.t-main-color {\r\n    color: #0b7f8e;\r\n}\r\n\r\n.box-tab {\r\n    border: 1px solid #0b7f8e;\r\n    height: 40px;\r\n    border-radius: 100px;\r\n}\r\n\r\n.box-tab-active {\r\n    border: 1px solid #0b7f8e;\r\n    height: 40px;\r\n    border-radius: 100px;\r\n    background: #0b7f8e;\r\n    color: white;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.box-tab-non-active {\r\n    color: #0b7f8e;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.box-tab2 {\r\n    border: 1px solid #0b7f8e;\r\n    height: 30px;\r\n    border-radius: 100px;\r\n    max-width: 210px;\r\n}\r\n\r\n.box-tab-active2 {\r\n    border: 1px solid #0b7f8e;\r\n    height: 30px;\r\n    border-radius: 100px;\r\n    background: #0b7f8e;\r\n    color: white;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.box-tab-non-active2 {\r\n    color: #0b7f8e;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n// RHPP\r\n.box-tab3 {\r\n    border: 1px solid #0b7f8e;\r\n    height: 40px;\r\n    border-radius: 100px;\r\n    max-width: 400px;\r\n}\r\n\r\n.box-tab3-active {\r\n    border: 1px solid #0b7f8e;\r\n    height: 40px;\r\n    border-radius: 100px;\r\n    background: #0b7f8e;\r\n    color: white;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.box-tab3-non-active {\r\n    color: #0b7f8e;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.txt-circle1 {\r\n    position: absolute;\r\n    bottom: 16px;\r\n    right: 74px;\r\n}\r\n\r\n.txt-circle2 {\r\n    position: absolute;\r\n    bottom: 33px;\r\n    right: 115px;\r\n}\r\n\r\n.txt-circle3 {\r\n    position: absolute;\r\n    bottom: 73px;\r\n    right: 127px;\r\n}\r\n\r\n.txt-circle4 {\r\n    position: absolute;\r\n    top: 33px;\r\n    right: 111px;\r\n}\r\n\r\n.txt-circle5 {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 73px;\r\n}\r\n\r\n.txt-circle6 {\r\n    position: absolute;\r\n    top: 33px;\r\n    right: 32px;\r\n}\r\n\r\n.txt-circle7 {\r\n    position: absolute;\r\n    top: 73px;\r\n    right: 16px;\r\n}\r\n\r\n.txt-celcius {\r\n    position: absolute;\r\n    top: 50px;\r\n}\r\n\r\n.fs-8 {\r\n    font-size: 8px !important;\r\n}\r\n\r\n.color33333 {\r\n    color: #333333;\r\n}\r\n\r\n.color77777 {\r\n    color: #777777;\r\n}\r\n\r\n.bgcolorf4f4f4 {\r\n    background-color: #f4f4f4;\r\n}\r\n\r\n.card {\r\n    border-radius: 10px;\r\n}\r\n\r\n.blink_me {\r\n    animation: blinker 1s linear infinite;\r\n}\r\n\r\n@keyframes blinker {\r\n    50% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.pos_blink {\r\n    position: absolute;\r\n    right: 85px;\r\n    bottom: 29px;\r\n}\r\n\r\n.recharts-text {\r\n    font-size: 12px;\r\n}\r\n\r\n.text-format {\r\n    position: relative;\r\n    bottom: 75px;\r\n    /* right: -8px; */\r\n}\r\n\r\n.custom-form {\r\n    .rbt-input-multi {\r\n        border: 1px solid #e3e5e8;\r\n        border-radius: 8px;\r\n    }\r\n}\r\n","//\n// modal.scss\n//\n\n.modal {\n    .modal-content {\n        .modal-body {\n            padding: 0 $modal-inner-padding $modal-inner-padding $modal-inner-padding;\n        }\n    }\n}\n\n// Title text within header\n.modal-title {\n    margin-top: 0;\n}\n\n// Full modal\n.modal-full {\n    width: 92%;\n    max-width: none;\n}\n\n// Custom animation modal\n.modal-demo {\n    background-color: $white;\n    width: 600px !important;\n    border-radius: 4px;\n    display: none;\n    position: relative;\n    .close {\n        position: absolute;\n        top: 15px;\n        right: 25px;\n        color: $light;\n    }\n}\n\n@media (max-width: 768px) {\n    .modal-demo {\n        width: 96% !important;\n    }\n}\n\n.custom-modal-title {\n    padding: 15px 25px 15px 25px;\n    line-height: 22px;\n    font-size: 18px;\n    background-color: $dark;\n    color: $white;\n    text-align: left;\n    margin: 0;\n}\n\n.custom-modal-text {\n    padding: 20px;\n}\n\n.custombox-modal-wrapper {\n    text-align: left;\n}\n\n.custombox-modal-flash,\n.custombox-modal-rotatedown {\n    .close {\n        top: 20px;\n        z-index: 9999;\n    }\n}\n\n.modal-pakan {\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n    }\n    .modal-footer {\n        border: none;\n        display: block;\n        padding: 24px 16px;\n        box-shadow: 0px -2px 25px 0px rgba(0, 0, 0, 0.2);\n        .btn-disabled {\n            border: none !important;\n            background: #aed4d9 !important;\n            color: #fff !important;\n        }\n    }\n}\n\n.modal-rincian-produk {\n    &.kirim-pakan {\n        .modal-content {\n            .modal-header {\n                .modal-title {\n                    display: flex;\n                    align-items: center;\n                    .form-select {\n                        padding: 0;\n                        border: none;\n                        color: #202224;\n                        font-size: 20px;\n                        font-weight: 600;\n                        appearance: auto;\n                        background-image: none;\n                        cursor: pointer;\n                        &:focus {\n                            box-shadow: none;\n                        }\n                        option {\n                            font-size: 12px;\n                        }\n\n                        &.ews {\n                            width: 100%;\n                            max-width: 12%;\n                            font-size: 12px;\n                            font-weight: 400;\n                            border: 1px solid #e3e5e8;\n                            padding: 8px 12px;\n                            background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n                            appearance: none;\n                            background-position: right 10px center;\n                        }\n                    }\n                }\n            }\n            .modal-body {\n                .form-control {\n                    height: 32px;\n                    font-weight: 400;\n                    border-radius: 6px;\n                    color: var(--grey9);\n                    letter-spacing: -0.02em;\n                    padding: 8px 12px 8px 35px;\n                    border: 1px solid var(--grey3);\n                    background: url('../../images/icons/search.svg') no-repeat;\n                    background-position: 12px center;\n                    &::placeholder {\n                        color: var(--grey5);\n                    }\n                    &:focus {\n                        border: 1px solid var(--primary);\n                    }\n                }\n            }\n        }\n    }\n\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n        .modal-header {\n            padding: 24px 24px 0 24px;\n        }\n        .modal-body {\n            padding: 0 24px 24px 24px;\n        }\n    }\n}\n\n.modal-peran {\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n        overflow: hidden;\n    }\n}\n\n// custom modal\n.custom-modal {\n    &.telat-panen {\n        opacity: 0.9;\n        .modal-dialog {\n            .modal-content {\n                box-shadow: 0px 24px 48px -12px rgba(10, 13, 18, 0.18);\n            }\n        }\n    }\n    &.pengajuan-detail {\n        .modal-dialog {\n            max-width: 50%;\n            .modal-content {\n                border: 1px solid var(--grey3);\n                .modal-body {\n                    .list-pengajuan {\n                        margin-bottom: 12px;\n                        &:last-child {\n                            margin-bottom: 0;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.modal-detail-flok {\n        .modal-dialog {\n            &.modal-xl {\n                max-width: 85%;\n            }\n        }\n    }\n    &.announcement {\n        .modal-dialog {\n            max-width: 35%;\n            .modal-content {\n                .modal-header {\n                    .btn-close {\n                        margin: 0;\n                        opacity: 1;\n                        border-radius: 50%;\n                        background-color: var(--grey2);\n                        background-image: url('../../images/close.svg');\n                        background-position: center;\n                        background-repeat: no-repeat;\n                        background-size: 1em auto;\n                    }\n                }\n            }\n        }\n    }\n    .modal-dialog {\n        &.modal-xl {\n            max-width: 90%;\n        }\n    }\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n        background: var(--white);\n        .modal-header {\n            padding: 24px 24px 0 24px;\n\n            // react select\n            .select {\n                // select\n                .react-select__control {\n                    cursor: pointer;\n                    min-height: 32px;\n                    border-radius: 6px;\n                    &.react-select__control--menu-is-open {\n                        border: 1px solid var(--primary);\n                    }\n                    .react-select__value-container {\n                        padding: 0 0 0 12px;\n                        .react-select__single-value {\n                            margin: 0;\n                            font-size: 12px;\n                            font-weight: 400;\n                            line-height: 16px;\n                            color: var(--grey9);\n                            letter-spacing: -0.02em;\n                        }\n                    }\n                    .react-select__indicators {\n                        .react-select__indicator {\n                            padding: 0 12px 0 0;\n                        }\n                    }\n                }\n                // select menu\n                .react-select__menu {\n                    width: 200px;\n                }\n                &.none {\n                    width: fit-content;\n                    // select\n                    .react-select__control {\n                        border: none;\n                        min-height: fit-content;\n                        .react-select__value-container {\n                            padding: 0;\n                            .react-select__single-value {\n                                font-size: 20px;\n                                font-weight: 600;\n                                line-height: 24px;\n                            }\n                        }\n                        .react-select__indicators {\n                            .react-select__indicator {\n                                padding: 0;\n                            }\n                        }\n                    }\n                }\n                &.w-12 {\n                    width: 120px;\n                }\n            }\n\n            .btn-close {\n                opacity: 1;\n            }\n        }\n        .modal-body {\n            padding: 28px 24px 24px 24px;\n\n            // tabs segmentasi & klasifikasi\n            .tabs {\n                .rts___tabs___container {\n                    border-radius: 6px;\n                    background: var(--gray1);\n                    border: 1px solid var(--grey2);\n                    .rts___tabs {\n                        width: 100%;\n                        justify-content: space-between;\n                        .rts___btn {\n                            width: 100%;\n                            border: none;\n                            color: var(--grey9);\n                            transition: all 0.3s ease-in-out;\n                            &.rts___tab___selected {\n                                border: none !important;\n                                color: var(--grey9) !important;\n                                background: var(--white) !important;\n                                box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.05) !important;\n                            }\n                        }\n                    }\n                }\n            }\n            .rts___tabs___container {\n                padding: 0;\n                border-bottom: 1px solid var(--grey2);\n                // date ranges\n                .rts___tabs {\n                    .date-ranges {\n                        box-shadow: none;\n                        border-radius: 0;\n                        padding: 8px 12px;\n                        background: none !important;\n                        color: var(--grey6) !important;\n                        transition: all 0.3s ease-in-out;\n                        border-bottom: 1px solid transparent !important;\n                        &:hover {\n                            color: var(--primary) !important;\n                            border-bottom: 1px solid var(--primary) !important;\n                        }\n                        &.rts___tab___selected {\n                            border-radius: 0;\n                            color: var(--primary) !important;\n                            border-bottom: 1px solid var(--primary) !important;\n                        }\n                    }\n                }\n                // key ranges\n                &:nth-child(2) {\n                    border: none !important;\n                    .rts___tabs {\n                        .rts___btn {\n                            transition: all 0.3s ease-in-out;\n                            &:hover {\n                                color: var(--white) !important;\n                                background: var(--primary) !important;\n                                border: 1px solid var(--primary) !important;\n                            }\n                        }\n                        .rts___tab___selected {\n                            color: var(--white) !important;\n                            background: var(--primary) !important;\n                            border: 1px solid var(--primary) !important;\n                        }\n                    }\n                }\n            }\n\n            // accordion jadwal kirim pakan\n            .accordion-wrapper {\n                height: 600px;\n                overflow-y: auto;\n                scrollbar-width: none;\n                -ms-overflow-style: none;\n                &::-webkit-scrollbar {\n                    display: none;\n                }\n                .accordion {\n                    border: 1px solid #d0d5da;\n                    border-radius: 8px;\n                    background: #f4f5f6;\n                    padding: 8px 12px;\n                }\n            }\n\n            // date\n            .date-wrapper {\n                width: 110px;\n                position: relative;\n                justify-self: flex-end;\n                .date {\n                    height: 32px;\n                    cursor: pointer;\n                    font-weight: 400;\n                    background: none;\n                    padding: 8px 32px;\n                    text-align: center;\n                    color: var(--grey9);\n                    letter-spacing: -0.02em;\n                    border: 1px solid var(--grey2);\n                    background-position: right 12px center;\n                    &::placeholder {\n                        color: var(--grey5);\n                    }\n                    &:focus {\n                        border: 1px solid var(--primary);\n                    }\n                }\n                .calendar-icon {\n                    position: absolute;\n                    top: 16px;\n                    left: 12px;\n                    transform: translateY(-50%);\n                    pointer-events: none;\n                }\n                .chevron-icon {\n                    position: absolute;\n                    top: 16px;\n                    right: 12px;\n                    transform: translateY(-50%);\n                    pointer-events: none;\n                }\n                .react-datepicker__tab-loop {\n                    .react-datepicker-popper {\n                        .react-datepicker {\n                            border-radius: 8px;\n                            background: var(--white);\n                            border: 1px solid var(--grey2);\n                            box-shadow: 0px 4px 6px -2px #1a1a1a33;\n                            .react-datepicker__triangle {\n                                &::after,\n                                &::before {\n                                    border-bottom-color: var(--grey2) !important;\n                                }\n                            }\n                            .react-datepicker__year--container {\n                                .react-datepicker__header {\n                                    font-weight: 500;\n                                    color: var(--grey9);\n                                    letter-spacing: -0.02em;\n                                    background: var(--grey1);\n                                    border-bottom: 1px solid var(--grey2);\n                                }\n                            }\n                            .react-datepicker__year {\n                                .react-datepicker__year-wrapper {\n                                    justify-content: center;\n                                    .react-datepicker__year-text {\n                                        font-weight: 500;\n                                        color: var(--grey9);\n                                        letter-spacing: -0.02em;\n                                        &.react-datepicker__year-text--disabled {\n                                            color: #cccccc !important;\n                                        }\n                                        &.react-datepicker__year-text--selected {\n                                            color: var(--white) !important;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// modal pilih flok\n.modal-pilih-flok {\n    // modal content\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n        .modal-header {\n            border-bottom: none;\n        }\n        .btn-close {\n            opacity: 1;\n        }\n\n        // modal body\n        .modal-body {\n            .nav {\n                border-bottom: 2px solid var(--grey3) !important;\n                .nav-item {\n                    a {\n                        transition: all 0.1s ease-in-out;\n                        &:hover {\n                            color: var(--primary) !important;\n                            border-bottom: 2px solid var(--primary) !important;\n                        }\n                        &.active {\n                            border-bottom: 2px solid var(--primary) !important;\n                        }\n                    }\n                }\n            }\n\n            .pagination {\n                margin: 0;\n                padding: 28px 0 24px;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                button {\n                    &:disabled {\n                        color: var(--grey3) !important;\n                        background: var(--grey1);\n                        svg {\n                            color: var(--grey3) !important;\n                        }\n                    }\n                }\n                .page-item {\n                    width: 40px;\n                    height: 32px;\n                    &.active {\n                        .page-link {\n                            color: var(--primary);\n                            background-color: var(--teal1);\n                        }\n                    }\n                    .page-link {\n                        width: 100%;\n                        height: 100%;\n                        border: none;\n                        display: flex;\n                        font-size: 14px;\n                        font-weight: 500;\n                        padding: 4px 5px;\n                        line-height: 18px;\n                        border-radius: 4px;\n                        align-items: center;\n                        color: var(--grey6);\n                        letter-spacing: -0.02em;\n                        justify-content: center;\n                        transition: all 0.3s ease-in-out;\n                        &:hover {\n                            color: var(--primary);\n                            background-color: var(--teal1);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// modal pilih doc\n.modal-pilih-doc {\n    // modal content\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n        .btn-close {\n            opacity: 1;\n        }\n    }\n}\n\n// modal pilih pakan\n.modal-pilih-pakan {\n    // modal content\n    .modal-content {\n        border: none;\n        border-radius: 8px;\n        .btn-close {\n            opacity: 1;\n        }\n\n        // modal footer\n        .modal-footer {\n            box-shadow: 0px -2px 25px 0px #00000012;\n        }\n    }\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 100%;\n            }\n        }\n        .modal-content {\n            .modal-header {\n                .modal-title {\n                    flex-direction: column;\n                    align-items: flex-start !important;\n                    .div {\n                        display: none;\n                    }\n                }\n            }\n            .modal-body {\n                .custom-search {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n/* Medium mobile */\n@media (min-width: 375px) and (max-width: 424px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 100%;\n            }\n        }\n        .modal-content {\n            .modal-header {\n                // react select\n                .select {\n                    .react-select__menu {\n                        width: 160px;\n                    }\n                }\n            }\n            .modal-body {\n                .custom-search {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 100%;\n            }\n        }\n        .modal-content {\n            .modal-body {\n                .custom-search {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 85%;\n            }\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 70%;\n            }\n        }\n    }\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 50%;\n            }\n        }\n    }\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 40%;\n            }\n        }\n    }\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n    // custom modal\n    .custom-modal {\n        &.announcement {\n            .modal-dialog {\n                max-width: 30%;\n            }\n        }\n    }\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","//\n// navbar.scss\n//\n// Bootstrap override - navbar\n.navbar {\n    padding: 0;\n    .navbar-nav {\n        .nav-link {\n            font-weight: $font-weight-medium;\n            font-size: 0.9375rem;\n            [class^='icon-'] {\n                color: $link-color;\n                > svg [fill]:not([fill='none']) {\n                    fill: $link-color;\n                }\n            }\n            &.active {\n                color: $link-hover-color !important;\n                [class^='icon-'] {\n                    color: $link-hover-color;\n                    > svg [fill]:not([fill='none']) {\n                        fill: $link-hover-color;\n                    }\n                }\n            }\n            &:hover {\n                [class^='icon-'] {\n                    color: $link-hover-color;\n                    > svg [fill]:not([fill='none']) {\n                        fill: $link-hover-color;\n                    }\n                }\n            }\n        }\n        &.navbar-dropdown {\n            .nav-item {\n                .active {\n                    background: var(--teal1);\n                    color: var(--teal6);\n                    transition: all 0.2s ease-in-out;\n                    img {\n                        filter: invert(28%) sepia(35%) saturate(1400%) hue-rotate(151deg) brightness(90%) contrast(110%);\n                    }\n                }\n                .menu-dropdown {\n                    opacity: 0;\n                    visibility: hidden;\n                    transition: opacity 0.2s ease, transform 0.2s ease;\n                    transform: translate3d(-50%, 30px, 0);\n                }\n                .dropdown-toggle {\n                    &::after {\n                        display: none;\n                    }\n                }\n                &.show {\n                    .menu-dropdown {\n                        opacity: 1;\n                        visibility: visible;\n                        transform: translate3d(-50%, 1px, 0);\n                    }\n                }\n                &:hover {\n                    background: var(--teal1);\n                    color: var(--teal6);\n                    img {\n                        filter: invert(28%) sepia(35%) saturate(1400%) hue-rotate(151deg) brightness(90%) contrast(110%);\n                    }\n                    .menu-dropdown {\n                        opacity: 0;\n                        visibility: hidden;\n                        transform: translate3d(-50%, 30px, 0);\n                    }\n                    &.show {\n                        .menu-dropdown {\n                            opacity: 1;\n                            visibility: visible;\n                            transform: translate3d(-50%, 1px, 0);\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.topnav-menu {\n        height: 70px;\n        .navbar-nav {\n            & > .nav-item {\n                > .nav-link {\n                    padding: 0 $nav-link-padding-x;\n                    display: block;\n                    // line-height: 70px;\n                    max-height: 70px;\n                }\n            }\n        }\n    }\n    &.navbar-sticky {\n        transition: $transition-base;\n        box-shadow: $box-shadow;\n        background: $white;\n        z-index: 100000;\n        position: fixed;\n        width: 100%;\n        top: 0;\n    }\n    .profile-dropdown {\n        .menu-dropdown {\n            opacity: 0;\n            left: -57px;\n            visibility: hidden;\n            transition: opacity 0.2s ease, transform 0.2s ease;\n            transform: translate3d(-50%, 30px, 0);\n        }\n        .dropdown-toggle {\n            &::after {\n                display: none;\n            }\n        }\n        &.show {\n            .menu-dropdown {\n                opacity: 1;\n                visibility: visible;\n                transform: translate3d(-50%, 1px, 0);\n            }\n        }\n        &:hover {\n            .menu-dropdown {\n                opacity: 0 !important;\n                visibility: hidden !important;\n                transform: translate3d(-50%, 30px, 0) !important;\n            }\n            &.show {\n                .menu-dropdown {\n                    opacity: 1 !important;\n                    visibility: visible !important;\n                    transform: translate3d(-50%, 1px, 0) !important;\n                }\n            }\n        }\n    }\n}\n.navbar-light {\n    .logo {\n        .logo-dark {\n            display: inline-block;\n        }\n        .logo-light {\n            display: none;\n        }\n    }\n}\n\n.navbar-dark {\n    .logo {\n        .logo-dark {\n            display: none;\n        }\n        .logo-light {\n            display: inline-block;\n        }\n    }\n}\n\n.navbar {\n    .navbar-toggler {\n        &:focus {\n            box-shadow: none;\n        }\n    }\n}\n\n.navbar-nav .dropdown-menu {\n    min-width: 0;\n    margin: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    box-shadow: none;\n    @include media-breakpoint-up(lg) {\n        left: 50%;\n        min-width: $navbar-dropdown-min-width;\n        padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n        box-shadow: $box-shadow-lg;\n        visibility: hidden;\n        opacity: 0;\n        transform: translate3d(-50%, 30px, 0);\n        transition: $transition-base;\n        transition-property: opacity, visibility, transform, -webkit-transform;\n        transform-origin: top center;\n        &.dropdown-menu-lg {\n            min-width: $navbar-dropdown-min-width-lg;\n        }\n        &.dropdown-menu-xl {\n            min-width: $navbar-dropdown-min-width-xl;\n        }\n        .nav {\n            .nav-item {\n                &.dropdown {\n                    .dropdown-menu {\n                        position: absolute;\n                        top: 0;\n                        left: 150%;\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n    .nav {\n        display: block;\n        .nav-item {\n            .nav-link {\n                padding: 0.25rem 0.75rem;\n                font-weight: normal;\n                margin: 0 0.5rem;\n                position: relative;\n            }\n            &.dropdown {\n                &:hover {\n                    > .dropdown-menu.show {\n                        display: block;\n                    }\n                }\n                .arrow {\n                    &::after {\n                        right: 22px;\n                        transform: rotate(-135deg) translateY(-50%);\n                        position: absolute;\n                    }\n                }\n            }\n        }\n    }\n    .arrow {\n        display: inline-block;\n        &:after {\n            border-color: initial;\n            border-style: solid;\n            border-width: 0 0 1px 1px;\n            content: '';\n            height: 0.4rem;\n            display: inline-block;\n            right: 5px;\n            top: 50%;\n            margin-left: 10px;\n            transform: rotate(-45deg) translateY(-50%);\n            transform-origin: top;\n            transition: all 0.3s ease-out;\n            width: 0.4rem;\n        }\n    }\n}\n\n// Toggle dropdown on hover\n@include media-breakpoint-up(lg) {\n    .navbar-nav .dropdown .dropdown-menu {\n        z-index: $zindex-fixed;\n        display: block;\n    }\n    .navbar-nav {\n        .dropdown {\n            &:hover {\n                .dropdown-menu {\n                    opacity: 1;\n                    transform: translate3d(-50%, 1px, 0);\n                    visibility: visible;\n                    .dropdown {\n                        &:hover {\n                            .dropdown-menu {\n                                opacity: 1;\n                                transform: translate3d(-50%, 1px, 0);\n                                visibility: visible;\n                                display: block;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.navbar-dark {\n    .navbar-brand {\n        h4 {\n            color: $navbar-dark-brand-color;\n        }\n    }\n    .dropdown-menu {\n        .nav-link {\n            color: $body-color !important;\n        }\n    }\n}\n\n.nav-title {\n    padding: 0.25rem 0.75rem;\n    margin: 0 0.5rem;\n}\n\n@include media-breakpoint-down(lg) {\n    .navbar.topnav-menu {\n        background-color: $white;\n        padding: 8px 0;\n        height: auto;\n        position: fixed;\n        left: 0;\n        right: 0;\n        z-index: 1001;\n        .dropdown {\n            .dropdown-menu {\n                &.dropdown-menu-lg {\n                    width: 100%;\n                }\n            }\n        }\n        &.navbar-dark {\n            .logo {\n                .logo-dark {\n                    display: inline-block;\n                }\n                .logo-light {\n                    display: none;\n                }\n            }\n            .navbar-toggler {\n                color: $navbar-light-color;\n                border-color: $navbar-light-toggler-border-color;\n            }\n\n            .navbar-toggler-icon {\n                background-image: escape-svg($navbar-light-toggler-icon-bg);\n            }\n        }\n        .navbar-nav {\n            > .nav-item {\n                > .nav-link {\n                    line-height: inherit;\n                    padding: 0.5rem 1em;\n                    color: $nav-link-color;\n                    .feather {\n                        float: right;\n                    }\n                }\n                .btn.btn-white.text-white {\n                    color: $dark !important;\n                }\n            }\n            > .dropdown {\n                .dropdown-menu {\n                    .nav {\n                        .dropdown {\n                            .dropdown-menu {\n                                .nav {\n                                    .nav-item {\n                                        > .nav-link {\n                                            margin: 0 0.5rem 0 1.2rem;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .dropdown-menu {\n                .arrow {\n                    &:after {\n                        transform: rotate(-45deg) translateY(-50%) !important;\n                    }\n                }\n            }\n        }\n    }\n    .navbar-collapse {\n        max-height: 480px;\n        overflow-y: auto;\n    }\n}\n","//\n// nav.scss\n//\n\n// Bootstrap override - turn nav tab with broder\n\n.nav-tabs {\n    border-bottom: 2px solid rgba($gray-600, 0.2);\n\n    .nav-item {\n        margin-bottom: -2px;\n    }\n\n    li {\n        a {\n            border-color: transparent !important;\n            padding: 0.625rem 1.5rem;\n        }\n        a.active {\n            border-bottom: 2px solid $primary !important;\n        }\n    }\n}\n\n// pills\n.nav-tabs,\n.nav-pills {\n    > li {\n        > a {\n            color: $gray-700;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.nav-pills {\n    background: $body-bg;\n    border-radius: $nav-pills-border-radius;\n    padding: 6px;\n\n    .nav-link {\n        background-color: transparent;\n        color: $body-color;\n    }\n\n    .nav-link.active,\n    .show > .nav-link {\n        color: $body-color;\n        background-color: $card-bg;\n        box-shadow: $box-shadow-sm;\n    }\n}\n\n//Navtab custom\n.navtab-bg {\n    background-color: $gray-100 !important;\n\n    // li {\n    //     >a {\n    //         margin: 0 5px;\n    //     }\n    // }\n}\n\n.tab-content {\n    padding: 20px 0 0 0;\n}\n\n.nav {\n    .nav-link {\n        color: $body-color;\n\n        &:hover,\n        &:focus,\n        &:active {\n            color: $primary;\n        }\n\n        &.active {\n            color: $primary;\n        }\n    }\n}\n","// \n// pagination.scss\n//\n\n\n.page-item {\n  &:first-child {\n    .page-link {\n      border-top-left-radius: $border-radius-sm;\n      border-bottom-left-radius: $border-radius-sm;\n    }\n  }\n  &:last-child {\n    .page-link {\n      border-top-right-radius: $border-radius-sm;\n      border-bottom-right-radius: $border-radius-sm;\n    }\n  }\n}\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n  .page-link {\n    border-radius: 100% !important;\n    margin: 0 3px;\n  }\n}","// \n// popover.scss\n//\n\n.popover {\n    box-shadow: $box-shadow-lg;\n\n    .popover-header {\n        margin-top: 0;\n        font-size: $font-size-sm;\n    }\n}\n","//\r\n// progress.scss\r\n//\r\n\r\n// Custom height\r\n\r\n// Progress height small\r\n.progress-sm {\r\n    height: 5px;\r\n}\r\n\r\n// Progress height medium\r\n.progress-md {\r\n    height: 8px;\r\n}\r\n\r\n// Progress height large\r\n.progress-lg {\r\n    height: 12px;\r\n}\r\n\r\n// Progress height extra large\r\n.progress-xl {\r\n    height: 15px;\r\n}\r\n\r\n// Progress height dubble extra large\r\n.progress-xxl {\r\n    height: 25px;\r\n}\r\n\r\n/* Progressbar Vertical */\r\n.progress-vertical {\r\n    min-height: 250px;\r\n    height: 250px;\r\n    width: 10px;\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-bottom: 0;\r\n    margin-right: 20px;\r\n\r\n    .progress-bar {\r\n        width: 100%;\r\n    }\r\n\r\n    &.progress-xl {\r\n        width: 15px;\r\n    }\r\n\r\n    &.progress-lg {\r\n        width: 12px;\r\n    }\r\n\r\n    &.progress-md {\r\n        width: 8px;\r\n    }\r\n\r\n    &.progress-sm {\r\n        width: 5px;\r\n    }\r\n}\r\n\r\n.progress-vertical-bottom {\r\n    min-height: 250px;\r\n    height: 250px;\r\n    position: relative;\r\n    width: 10px;\r\n    display: inline-block;\r\n    margin-bottom: 0;\r\n    margin-right: 20px;\r\n\r\n    .progress-bar {\r\n        width: 100%;\r\n        bottom: 0;\r\n        position: absolute;\r\n    }\r\n\r\n    &.progress-xl {\r\n        width: 15px;\r\n    }\r\n\r\n    &.progress-lg {\r\n        width: 12px;\r\n    }\r\n\r\n    &.progress-md {\r\n        width: 8px;\r\n    }\r\n\r\n    &.progress-sm {\r\n        width: 5px;\r\n    }\r\n}\r\n\r\n// Progress with percentage\r\n\r\n.progress-w-percent {\r\n    min-height: 20px;\r\n    margin-bottom: 20px;\r\n\r\n    .progress {\r\n        width: 80%;\r\n        float: left;\r\n        margin-top: 8px;\r\n    }\r\n\r\n    .progress-value {\r\n        width: 20%;\r\n        float: right;\r\n        text-align: right;\r\n        line-height: 20px;\r\n    }\r\n}\r\n\r\n.div-loading {\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n}\r\n\r\n.loading-container {\r\n    position: relative;\r\n    width: 110px;\r\n    height: 110px;\r\n    margin: auto;\r\n}\r\n.loading-container .item {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    border: 5px solid #0b7f8e;\r\n    border-radius: 50%;\r\n    border-top-color: transparent;\r\n    border-bottom-color: transparent;\r\n    animation: spin 2s ease infinite;\r\n}\r\n.loading-container .item:nth-child(1) {\r\n    width: 50px;\r\n    height: 50px;\r\n}\r\n.loading-container .item:nth-child(2) {\r\n    width: 70px;\r\n    height: 70px;\r\n    animation-delay: 0.1s;\r\n}\r\n.loading-container .item:nth-child(3) {\r\n    width: 90px;\r\n    height: 90px;\r\n    animation-delay: 0.2s;\r\n}\r\n.loading-container .item:nth-child(4) {\r\n    width: 110px;\r\n    height: 110px;\r\n    animation-delay: 0.3s;\r\n}\r\n@keyframes spin {\r\n    50% {\r\n        transform: translate(-50%, -50%) rotate(180deg);\r\n    }\r\n    100% {\r\n        transform: translate(-50%, -50%) rotate(0deg);\r\n    }\r\n}\r\n\r\n@keyframes growProgressBar {\r\n    0%,\r\n    33% {\r\n        --pgPercentage: 0;\r\n    }\r\n    100% {\r\n        --pgPercentage: var(--value);\r\n    }\r\n}\r\n\r\n@property --pgPercentage {\r\n    syntax: '<number>';\r\n    inherits: false;\r\n    initial-value: 0;\r\n}\r\n\r\ndiv[role='progressbar'] {\r\n    --size: 12rem;\r\n    --fg: #369;\r\n    --bg: #def;\r\n    --pgPercentage: var(--value);\r\n    animation: growProgressBar 3s 1 forwards;\r\n    width: var(--size);\r\n    height: var(--size);\r\n    border-radius: 50%;\r\n    display: grid;\r\n    place-items: center;\r\n    background: radial-gradient(closest-side, white 80%, transparent 0 99.9%, white 0),\r\n        conic-gradient(var(--fg) calc(var(--pgPercentage) * 1%), var(--bg) 0);\r\n    font-family: Helvetica, Arial, sans-serif;\r\n    font-size: calc(var(--size) / 5);\r\n    color: var(--fg);\r\n}\r\n\r\ndiv[role='progressbar']::before {\r\n    counter-reset: percentage var(--value);\r\n    content: counter(percentage) '%';\r\n}\r\n","//\n// reboot.scss\n//\n\n\nbody {\n  letter-spacing: 0.02rem;\n  font-family: $font-family-base;\n}\n\n// a\n\na {\n  text-decoration: none !important;\n  display: inline-block;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.row>* {\n  position: relative;\n}\n\n// Forms\nlabel {\n  font-weight: $font-weight-semibold;\n  font-size: $font-size-sm;\n}\n\n// Buttons\nbutton:focus {\n  outline: none;\n}\n\n// blockquote\n\n.blockquote {\n  padding: 10px 20px;\n  margin-bottom: 20px;\n  border-left: 4px solid $gray-200;\n\n  &.blockquote-reverse {\n    border-left: 0;\n    border-right: 4px solid $gray-200;\n    text-align: right;\n  }\n}\n\n// zindex\n.zindex-1 {\n  z-index: 1;\n}\n\n.zindex-5 {\n  z-index: 5;\n}\n\n.zindex-10 {\n  z-index: 10;\n}\n\n.zindex-20 {\n  z-index: 20;\n}\n","//\r\n// tables.scss\r\n//\r\n\r\n.dataTables_paginate {\r\n    display: none;\r\n}\r\n\r\n.paginate_button {\r\n    display: none;\r\n}\r\n.dataTables_info {\r\n    display: none;\r\n}\r\n.dataTables_length {\r\n    display: none;\r\n}\r\n\r\n//Table centered (Custom)\r\n.table-centered {\r\n    td,\r\n    th {\r\n        vertical-align: middle !important;\r\n    }\r\n}\r\n\r\n// Custom table components (Custom)\r\n.table {\r\n    th {\r\n        font-weight: 600;\r\n    }\r\n    .table-user {\r\n        img {\r\n            height: 30px;\r\n            width: 30px;\r\n        }\r\n    }\r\n    border-collapse: collapse;\r\n}\r\n\r\n.action-icon {\r\n    color: $gray-600;\r\n    font-size: 1.2rem;\r\n    display: inline-block;\r\n    padding: 0 3px;\r\n\r\n    &:hover {\r\n        color: $gray-700;\r\n    }\r\n}\r\n\r\n// Tables fluid\r\n.table-nowrap {\r\n    th,\r\n    td {\r\n        white-space: nowrap;\r\n    }\r\n}\r\n\r\n// custom-table\r\n.custom-table {\r\n    .select-col {\r\n        width: 100px;\r\n    }\r\n}\r\n\r\n.t-sticky-1 {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    left: 0;\r\n    z-index: 1;\r\n}\r\n\r\n.t-sticky-2 {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    left: 44.6px;\r\n    z-index: 1;\r\n    min-width: 65px;\r\n}\r\n\r\n.t-sticky-3 {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    left: 100px;\r\n    z-index: 1;\r\n}\r\n\r\n.t-sticky-4 {\r\n    position: sticky;\r\n    left: 40.6px;\r\n    z-index: 1;\r\n    min-width: 64px;\r\n}\r\n\r\n.v-align {\r\n    vertical-align: middle;\r\n}\r\n\r\n.tableFixHead {\r\n    overflow-y: auto;\r\n    height: 200px;\r\n}\r\n\r\n.tableFixHead table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.tableFixHead th {\r\n    position: sticky;\r\n    top: 0;\r\n    background: #eee;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .navbar-nav .dropdown-menu {\r\n        left: 50%;\r\n        min-width: calc(10rem + 3rem);\r\n        padding: 0.75rem 0;\r\n        box-shadow: 0 0.8rem 1.2rem rgb(52 58 64 / 8%);\r\n        visibility: hidden;\r\n        opacity: 0;\r\n        transform: translate3d(-50%, 30px, 0);\r\n        transition: all 0.3s ease-in-out;\r\n        transition-property: opacity, visibility, transform;\r\n        transform-origin: top center;\r\n    }\r\n}\r\n\r\n.table > :not(caption) > * > * {\r\n    padding: 0.75rem 0.75rem;\r\n    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\r\n    border-bottom-width: 0px;\r\n}\r\n\r\n.sticky-h-1 {\r\n    position: sticky;\r\n    top: -1px;\r\n    z-index: 2;\r\n}\r\n\r\n.sticky-h-2 {\r\n    position: sticky;\r\n    top: 41px;\r\n    z-index: 2;\r\n}\r\n\r\n.sticky-h-3 {\r\n    position: sticky;\r\n    top: 59px;\r\n    z-index: 2;\r\n}\r\n.sticky-h-4 {\r\n    position: sticky;\r\n    top: 84px;\r\n    z-index: 2;\r\n}\r\n\r\n.th-b-color {\r\n    border: 1px solid #696969;\r\n}\r\n\r\n.td-bottom-none {\r\n    border-bottom: none !important;\r\n}\r\n\r\ntd {\r\n    border-right: 1px solid #696969;\r\n    border-bottom: none;\r\n}\r\nth {\r\n    border: 1px solid #696969;\r\n}\r\n\r\n.div-th {\r\n    width: initial;\r\n    border-bottom: 0.5px solid #696969;\r\n    position: relative;\r\n    top: 21px;\r\n}\r\n\r\n.div-th-3 {\r\n    width: initial;\r\n    border-bottom: 0.5px solid #696969;\r\n    position: relative;\r\n    top: 29px;\r\n}\r\n\r\n.div-th-2 {\r\n    width: initial;\r\n    border-bottom: 0.5px solid #696969;\r\n    position: relative;\r\n    top: 20px;\r\n}\r\n\r\n.p0 {\r\n    padding: 0 !important;\r\n}\r\n.bg-table-1 {\r\n    background-color: #e9ebef;\r\n}\r\n\r\n.table-grey {\r\n    --bs-table-bg: #dfe6eb;\r\n    --bs-table-striped-bg: #dfe6eb;\r\n    --bs-table-striped-color: #dfe6eb;\r\n    --bs-table-active-bg: #dfe6eb;\r\n    --bs-table-active-color: #dfe6eb;\r\n    --bs-table-hover-bg: #dfe6eb;\r\n    --bs-table-hover-color: #dfe6eb;\r\n    color: black;\r\n    border-color: #484e53;\r\n\r\n    thead tr th {\r\n        vertical-align: middle;\r\n        font-size: 12px;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.table-grey-2 {\r\n    width: 100%;\r\n    border: 1px solid #858687;\r\n\r\n    thead,\r\n    tfoot {\r\n        tr th {\r\n            background: #ccd9e2;\r\n            text-align: center;\r\n        }\r\n    }\r\n\r\n    tr th,\r\n    tr td {\r\n        font-size: 11.5px;\r\n        vertical-align: middle;\r\n        padding: 0.4rem 0.5rem;\r\n    }\r\n\r\n    thead tr {\r\n        box-shadow: 0px 1px 0px 0px #858687;\r\n    }\r\n\r\n    tbody tr:nth-child(even) {\r\n        background-color: #dfe6eb;\r\n    }\r\n\r\n    tbody tr:nth-child(odd) {\r\n        background-color: #f4f5f7;\r\n    }\r\n}\r\n\r\n.table-head {\r\n    td,\r\n    th {\r\n        background: #ccd9e2 !important;\r\n        text-align: center;\r\n        font-weight: bold !important;\r\n        border: 1px solid #858687;\r\n    }\r\n}\r\n\r\n.bottom-line {\r\n    box-shadow: 0px 1px 0px 0px #858687;\r\n}\r\n\r\n.sticky-border-y-gray {\r\n    -webkit-box-shadow: 0px -1px 0px 0px #dee2e6, 0px 1px 0px 0px #dee2e6;\r\n    box-shadow: 0px -1px 0px 0px #dee2e6, 0px 1px 0px 0px #dee2e6;\r\n}\r\n\r\n.table-border-outline {\r\n    outline: 1px solid #484e53 !important;\r\n    border: none;\r\n    outline-offset: -1px;\r\n}\r\n\r\n.table-border-outline-right {\r\n    box-shadow: -5px 0px 0px 0px black, 5px 0px 0px 0px black;\r\n    border: none;\r\n    outline-offset: -1px;\r\n}\r\n\r\n.b1234 {\r\n    border-width: 1px;\r\n    border-left: 1px solid rgb(204, 204, 204);\r\n    border-top: 1px solid rgb(204, 204, 204);\r\n    border-right: 1px solid rgb(204, 204, 204);\r\n    border-bottom: 1px solid rgb(204, 204, 204);\r\n}\r\n\r\n.formheader {\r\n    background: #efefef;\r\n    border: 1px solid #03476f;\r\n    padding: 5px;\r\n}\r\n\r\n//radar\r\n\r\n.body-radar {\r\n    background-color: #e5e5e5;\r\n    height: 100vh;\r\n}\r\n\r\n.box-radar {\r\n    max-width: 900px;\r\n    width: 100%;\r\n    background-color: #e5e5e5;\r\n    border-radius: 10px;\r\n}\r\n\r\n.box-user {\r\n    max-width: 284px;\r\n    background: #ffffff;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n}\r\n\r\n.usr-icon {\r\n    width: 29px;\r\n    height: 29px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.icon-radar {\r\n    position: absolute;\r\n    right: 0;\r\n}\r\n\r\n.txt-radar1 {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 22px;\r\n\r\n    color: #1d1d1d;\r\n}\r\n\r\n.txt-radar2 {\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 20px;\r\n    line-height: 28px;\r\n    /* identical to box height */\r\n\r\n    color: #1d1d1d;\r\n}\r\n\r\n.btn-radar-close {\r\n    width: 153px;\r\n    padding: 10px;\r\n    border: 1px solid #f0f0f0f0;\r\n    border-radius: 6px;\r\n}\r\n\r\n.width-radar-modal {\r\n    width: 401px !important;\r\n}\r\n\r\n.box-desc-radar {\r\n    width: 321px;\r\n    background: #e6fcff;\r\n    border: 1px solid #8ed5de;\r\n    border-radius: 6px;\r\n    padding: 10px;\r\n    position: relative;\r\n}\r\n\r\n.txt-edit-radar {\r\n    color: #0f98d8;\r\n    font-weight: bold;\r\n    font-size: 10px;\r\n    z-index: 68;\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-radar-save {\r\n    width: 153px;\r\n    padding: 10px;\r\n    border: 1px solid #0b7f8e;\r\n    border-radius: 6px;\r\n    background: #0b7f8e;\r\n    color: white;\r\n}\r\n\r\n.btn-batas-hari {\r\n    width: 80px;\r\n    padding: 10px;\r\n    border: 1px solid #0b7f8e;\r\n    border-radius: 6px;\r\n    background: #0b7f8e;\r\n    color: white;\r\n}\r\n\r\n.box-table-radar {\r\n    width: 100%;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n}\r\n\r\n.fl-table {\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    // border: 1px solid #f8f8f8 !important;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    white-space: nowrap;\r\n    background-color: white;\r\n\r\n    &.user-role {\r\n        thead {\r\n            tr {\r\n                th {\r\n                    border-top: none;\r\n                    border-bottom: 1px solid #e3e5e8;\r\n                    color: #51555a;\r\n                    font-weight: 500;\r\n                }\r\n            }\r\n        }\r\n        tbody {\r\n            tr {\r\n                .disabled {\r\n                    background: #f4f5f6;\r\n                }\r\n                .edit-peran {\r\n                    padding: 16px 22px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fl-table td,\r\n.fl-table th {\r\n    padding: 8px;\r\n    border: none;\r\n    border-bottom: 1px solid #d8d8d8;\r\n    border-top: 1px solid #d8d8d8;\r\n}\r\n\r\n.bg-transparent {\r\n    background: transparent !important;\r\n}\r\n\r\n.bg-white {\r\n    background: white !important;\r\n}\r\n\r\n.fl-table td {\r\n    // border-bottom: 1px solid #d8d8d8;\r\n    font-size: 12px;\r\n    padding: 12px 0;\r\n}\r\n\r\n.fl-table thead th {\r\n    color: black;\r\n    background: rgba(11, 127, 142, 0.1);\r\n}\r\n\r\n.tr-radar {\r\n    &:hover {\r\n        background: rgb(235, 235, 235);\r\n    }\r\n}\r\n\r\n.color-green {\r\n    color: #0b7f8e;\r\n}\r\n.color-green-light {\r\n    color: #2eb85c;\r\n}\r\n.color-red-light {\r\n    color: #e91a26;\r\n}\r\n.t-green {\r\n    color: #86efac;\r\n}\r\n.t-yellow {\r\n    color: #fde047;\r\n}\r\n.t-red {\r\n    color: #f87171;\r\n}\r\n\r\n.color-black-sensor {\r\n    color: #000000;\r\n}\r\n\r\n.color-green-light-sensor {\r\n    color: #26ff31;\r\n}\r\n\r\n.color-blue-sensor {\r\n    color: #0b7f8e;\r\n}\r\n\r\n.color-yellow {\r\n    color: #f78216;\r\n}\r\n\r\n.color-red {\r\n    color: red;\r\n}\r\n\r\n.box-jml-ayam {\r\n    background: white;\r\n    padding: 15px;\r\n    border-radius: 4px;\r\n    height: 46px;\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 15px;\r\n}\r\n\r\n.dataTables_scrollBody {\r\n    max-height: 90vh !important;\r\n}\r\n\r\n/* Define the classes to be used in the table datatables stripe */\r\n.stripe-1 {\r\n    background-color: #f4f5f7 !important;\r\n}\r\n\r\n.stripe-2 {\r\n    background-color: #dfe6eb !important;\r\n}\r\n\r\n.tdLeft {\r\n    border: none !important;\r\n}\r\n\r\n.tdRight {\r\n    border: none !important;\r\n}\r\n\r\n.tblChart td {\r\n    border: none !important;\r\n}\r\n\r\n/* Responsive */\r\n\r\n@media (max-width: 767px) {\r\n    .fl-table {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n    .table-wrapper:before {\r\n        content: 'Scroll horizontally >';\r\n        display: block;\r\n        text-align: right;\r\n        font-size: 11px;\r\n        color: white;\r\n        padding: 0 0 10px;\r\n    }\r\n    .fl-table thead,\r\n    .fl-table tbody,\r\n    .fl-table thead th {\r\n        display: block;\r\n    }\r\n    .fl-table thead th:last-child {\r\n        border-bottom: none;\r\n    }\r\n    .fl-table thead {\r\n        float: left;\r\n    }\r\n    .fl-table tbody {\r\n        width: auto;\r\n        position: relative;\r\n        overflow-x: auto;\r\n    }\r\n    .fl-table td,\r\n    .fl-table th {\r\n        padding: 20px 0.625em 0.625em 0.625em;\r\n        height: 60px;\r\n        vertical-align: middle;\r\n        box-sizing: border-box;\r\n        overflow-x: hidden;\r\n        overflow-y: auto;\r\n        width: 120px;\r\n        font-size: 13px;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .fl-table thead th {\r\n        text-align: left;\r\n        border-bottom: 1px solid #f7f7f9;\r\n    }\r\n    .fl-table tbody tr {\r\n        display: table-cell;\r\n    }\r\n    .fl-table tbody tr:nth-child(odd) {\r\n        background: none;\r\n    }\r\n    .fl-table tr:nth-child(even) {\r\n        background: transparent;\r\n    }\r\n    .fl-table tr td:nth-child(odd) {\r\n        background: #f8f8f8;\r\n        border-bottom: 1px solid #bdb8b8;\r\n    }\r\n    .fl-table tr td:nth-child(even) {\r\n        border-bottom: 1px solid #bdb8b8;\r\n    }\r\n    .fl-table tbody td {\r\n        display: block;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.details {\r\n    display: none;\r\n}\r\n\r\n.details.collapsed {\r\n    display: table-row;\r\n}\r\n\r\n.container-box {\r\n    width: 100%;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n}\r\n\r\n.custom-table-stripped {\r\n    font-size: 12px;\r\n\r\n    tr td,\r\n    tr th {\r\n        border: none;\r\n        padding: 10px;\r\n    }\r\n\r\n    thead tr {\r\n        background-color: white;\r\n    }\r\n\r\n    tbody tr:nth-child(odd) {\r\n        background-color: var(--bs-table-striped-bg);\r\n    }\r\n    tbody tr:nth-child(even) {\r\n        background-color: white;\r\n    }\r\n}\r\n\r\n.custom-table-stripped-2 {\r\n    font-size: 12px;\r\n\r\n    tr td,\r\n    tr th {\r\n        border: none;\r\n        padding: 10px;\r\n    }\r\n\r\n    thead tr {\r\n        background-color: white;\r\n    }\r\n\r\n    tbody tr:nth-child(odd) {\r\n        background-color: white;\r\n    }\r\n    tbody tr:nth-child(even) {\r\n        background-color: var(--bs-table-striped-bg);\r\n    }\r\n}\r\n\r\n.custom-table {\r\n    font-size: 12px;\r\n\r\n    tr td,\r\n    tr th {\r\n        border: none;\r\n        padding: 12px;\r\n    }\r\n\r\n    thead tr {\r\n        background-color: white;\r\n    }\r\n\r\n    tr {\r\n        border-bottom: 1px solid #ebebeb;\r\n    }\r\n}\r\n\r\n.custom-table-plain {\r\n    font-size: 12px;\r\n    letter-spacing: -0.02em;\r\n\r\n    tr td,\r\n    tr th {\r\n        border: none;\r\n        padding: 12px;\r\n    }\r\n\r\n    tr td {\r\n        color: var(--grey9);\r\n    }\r\n\r\n    thead tr {\r\n        background-color: transparent;\r\n    }\r\n\r\n    tr {\r\n        border-bottom: none;\r\n    }\r\n}\r\n\r\n.custom-table-plain.compact {\r\n    tr td,\r\n    tr th {\r\n        padding: 6px 8px;\r\n    }\r\n}\r\n\r\n.custom-table.zonasi-harga-table {\r\n    border-spacing: 0px 0.5rem;\r\n    border-collapse: separate;\r\n\r\n    tr td {\r\n        background: #f3f4f7;\r\n    }\r\n\r\n    td,\r\n    th {\r\n        vertical-align: middle;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.section-table-zonasi-harga {\r\n    width: calc(fit-content * 2);\r\n}\r\n\r\n.table-zonasi-harga {\r\n    tr:first-of-type th:first-of-type {\r\n        border-top-left-radius: 8px;\r\n    }\r\n    tr:first-of-type th:last-of-type {\r\n        border-top-right-radius: 8px;\r\n    }\r\n    tr:last-of-type td:first-of-type {\r\n        border-bottom-left-radius: 8px;\r\n    }\r\n    tr:last-of-type td:last-of-type {\r\n        border-bottom-right-radius: 8px;\r\n    }\r\n\r\n    tr {\r\n        border: none;\r\n    }\r\n\r\n    tr th {\r\n        min-width: 70px;\r\n    }\r\n\r\n    tr td,\r\n    tr th {\r\n        padding: 6px 8px;\r\n        border: 2px white solid;\r\n        // background-color: #ffe5e8;\r\n        text-align: center;\r\n        vertical-align: middle;\r\n        // border-radius: 5px !important;\r\n        text-wrap: nowrap;\r\n    }\r\n\r\n    &.table-tanggal {\r\n        tr th {\r\n            background-color: #dfe6eb;\r\n        }\r\n\r\n        tr td {\r\n            background-color: #f4f5f7;\r\n        }\r\n    }\r\n}\r\n\r\n.table-evaluasi-harga {\r\n    border-collapse: separate;\r\n\r\n    tr th {\r\n        background-color: #dfe6eb;\r\n        height: 45px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    tr td,\r\n    tr th {\r\n        vertical-align: middle;\r\n        text-align: center;\r\n    }\r\n\r\n    tr td {\r\n        text-wrap: nowrap;\r\n        border: 1px solid #f4f5f7;\r\n    }\r\n\r\n    &.table-tanggal {\r\n        &.show-by-zona {\r\n            tr th {\r\n                height: 92px;\r\n            }\r\n        }\r\n\r\n        &.show-by-unit {\r\n            tr th {\r\n                height: 134px;\r\n            }\r\n        }\r\n\r\n        tr td {\r\n            background-color: #f4f5f7;\r\n        }\r\n    }\r\n}\r\n\r\n.table-laporan {\r\n    font-size: 13px;\r\n    table {\r\n        width: 100%;\r\n    }\r\n\r\n    tr td,\r\n    tr th {\r\n        border: solid 1px #d3d4d6;\r\n        padding: 12px;\r\n    }\r\n\r\n    tr {\r\n        th {\r\n            background-color: #f3f4f7;\r\n            text-align: center;\r\n        }\r\n    }\r\n\r\n    &.table-laporan-primary {\r\n        tr th {\r\n            background-color: #d0e6e8;\r\n        }\r\n    }\r\n\r\n    &.striped tbody tr:nth-child(even) {\r\n        background-color: #fbfbfc;\r\n    }\r\n    &.striped tbody tr:nth-child(odd) {\r\n        background-color: white;\r\n    }\r\n\r\n    .row-odd {\r\n        background-color: #fbfbfc;\r\n    }\r\n\r\n    .row-even {\r\n        background-color: white;\r\n    }\r\n\r\n    thead {\r\n        position: sticky;\r\n        top: 0;\r\n\r\n        th {\r\n            border: none;\r\n            outline: 0.5px solid #d3d4d6;\r\n            outline-offset: -0.5px;\r\n        }\r\n    }\r\n\r\n    tfoot {\r\n        position: relative !important;\r\n    }\r\n}\r\n\r\n.table-panduan-panen {\r\n    margin-bottom: 8px;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: 1px solid #d0d5da;\r\n        height: 32px;\r\n        color: #555555;\r\n        font-weight: 500;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    tr td {\r\n        height: 48px;\r\n    }\r\n}\r\n\r\n.table-list-ppic {\r\n    font-size: 12px;\r\n\r\n    &.kirim-pakan {\r\n        thead {\r\n            tr {\r\n                background: #f4f5f6 !important;\r\n                border-bottom: 1px solid #e3e5e8;\r\n            }\r\n        }\r\n        tbody {\r\n            tr {\r\n                background: #fff !important;\r\n                &:last-child {\r\n                    td {\r\n                        border-bottom: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.stok-pakan {\r\n        thead {\r\n            tr {\r\n                th {\r\n                    &:first-child {\r\n                        border-top-left-radius: 8px;\r\n                        border-bottom-left-radius: 8px;\r\n                    }\r\n                    &:last-child {\r\n                        border-top-right-radius: 8px;\r\n                        border-bottom-right-radius: 8px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    tr td,\r\n    tr th {\r\n        border: none;\r\n        padding: 10px;\r\n    }\r\n\r\n    tr th {\r\n        font-weight: 500;\r\n        color: var(--grey6);\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    tr td {\r\n        font-weight: 400;\r\n        color: var(--grey9);\r\n        letter-spacing: -0.02em;\r\n        border-bottom: 1px solid var(--grey3);\r\n    }\r\n\r\n    thead tr {\r\n        background-color: var(--grey1);\r\n    }\r\n\r\n    &.custom-table-ppic {\r\n        tr {\r\n            &:last-child {\r\n                td {\r\n                    border-bottom: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.table-realisasi-terakhir {\r\n    thead {\r\n        tr {\r\n            th {\r\n                background: #b9ecca;\r\n            }\r\n        }\r\n    }\r\n    tbody {\r\n        tr {\r\n            td {\r\n                background: #ebfaf0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table dashboard =====\r\n.table-dashboard {\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n        padding: 10px;\r\n    }\r\n\r\n    tr th {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        color: var(--grey6);\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    tr td {\r\n        font-size: 12px;\r\n        font-weight: 400;\r\n        line-height: 16px;\r\n        color: var(--grey9);\r\n        vertical-align: middle;\r\n        letter-spacing: -0.02em;\r\n        border-bottom: 1px solid var(--grey3);\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            background: var(--grey1);\r\n            th {\r\n                border-top: 1px solid var(--grey3);\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-top-left-radius: 8px;\r\n                    border-bottom-left-radius: 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-top-right-radius: 8px;\r\n                    border-bottom-right-radius: 8px;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                // ===== pakan kurang & pakan over =====\r\n                .sehat {\r\n                    font-weight: 500;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    color: var(--green6);\r\n                    background: var(--green1);\r\n                }\r\n                .sakit {\r\n                    font-weight: 500;\r\n                    padding: 2px 8px;\r\n                    color: var(--red6);\r\n                    border-radius: 8px;\r\n                    background: var(--red1);\r\n                }\r\n                .normal {\r\n                    background: transparent;\r\n                }\r\n\r\n                // ===== telat panen =====\r\n                .sudah {\r\n                    font-weight: 500;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    color: var(--green6);\r\n                    letter-spacing: -0.02em;\r\n                    background: var(--green1);\r\n                }\r\n                .belum {\r\n                    font-weight: 500;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    color: var(--grey7);\r\n                    letter-spacing: -0.02em;\r\n                    background: var(--grey1);\r\n                }\r\n\r\n                // ===== flok siap chickin =====\r\n                .link-to-plasma {\r\n                    &:hover {\r\n                        color: var(--teal7) !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tfoot =====\r\n    tfoot {\r\n        tr {\r\n            background: var(--blue2);\r\n            th {\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                color: var(--grey9);\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table stok per unit =====\r\n.table-stok-per-unit {\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n        padding: 10px;\r\n    }\r\n\r\n    tr th {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        color: var(--grey6);\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    tr td {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        padding: 16px 12px;\r\n        color: var(--grey9);\r\n        vertical-align: middle;\r\n        letter-spacing: -0.02em;\r\n        border-bottom: 1px solid var(--grey3);\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            background: var(--grey1);\r\n        }\r\n        .first-th {\r\n            th {\r\n                border-top: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-top-left-radius: 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-top-right-radius: 8px;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n        .second-th {\r\n            th {\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-bottom-left-radius: 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-bottom-right-radius: 8px;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                .over {\r\n                    display: block;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    width: fit-content;\r\n                    background: var(--red1);\r\n                    color: var(--red6) !important;\r\n                }\r\n                .normal {\r\n                    display: block;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    width: fit-content;\r\n                    background: var(--green1);\r\n                    color: var(--green6) !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tfoot =====\r\n    tfoot {\r\n        tr {\r\n            background: var(--grey2);\r\n            th {\r\n                color: var(--grey9);\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table stok per unit =====\r\n.table-informasi-batas-atas {\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n        padding: 8px 12px;\r\n    }\r\n\r\n    tr th {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        color: var(--grey6);\r\n        letter-spacing: -0.02em;\r\n        background: var(--grey2);\r\n        border-bottom: 1px solid var(--grey3);\r\n    }\r\n\r\n    tr td {\r\n        font-size: 12px;\r\n        line-height: 16px;\r\n        color: var(--grey9);\r\n        letter-spacing: -0.02em;\r\n        background: var(--white);\r\n    }\r\n}\r\n\r\n// ===== table pilih flok =====\r\n.table-pilih-flok {\r\n    width: 100%;\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            background: var(--grey2);\r\n            th {\r\n                border: none;\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey6);\r\n                letter-spacing: -0.02em;\r\n                background: var(--grey2);\r\n                border-top: 1px solid var(--grey3);\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-radius: 8px 0 0 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-radius: 0 8px 8px 0;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                border: none;\r\n                font-size: 12px;\r\n                font-weight: 400;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey9);\r\n                vertical-align: middle;\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table pilih doc =====\r\n.table-pilih-doc {\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            background: var(--grey2);\r\n            th {\r\n                font-weight: 500;\r\n                font-size: 12px;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey6);\r\n                letter-spacing: -0.02em;\r\n                border-top: 1px solid var(--grey3);\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-radius: 8px 0 0 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-radius: 0 8px 8px 0;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                font-weight: 400;\r\n                font-size: 12px;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey9);\r\n                vertical-align: middle;\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table pilih pakan =====\r\n.table-pilih-pakan {\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            background: var(--grey2);\r\n            th {\r\n                font-weight: 500;\r\n                font-size: 12px;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey6);\r\n                letter-spacing: -0.02em;\r\n                border-top: 1px solid var(--grey3);\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-radius: 8px 0 0 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-radius: 0 8px 8px 0;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                font-weight: 400;\r\n                font-size: 12px;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey9);\r\n                vertical-align: middle;\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n\r\n                // ===== check input =====\r\n                .form-check-input {\r\n                    margin: 0;\r\n                    width: 12px;\r\n                    height: 12px;\r\n                    box-shadow: none;\r\n                    transform: scale(1.5);\r\n                    vertical-align: middle;\r\n                    border: 1.5px solid var(--grey5);\r\n                    &:checked {\r\n                        border: none;\r\n                        box-shadow: none;\r\n                        background: url('../../images//icons//planning/checkbox.svg') center;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== custom table planning =====\r\n.custom-table-planning {\r\n    width: 100%;\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            th {\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey6);\r\n                letter-spacing: -0.02em;\r\n                background: var(--grey2);\r\n                border-top: 1px solid var(--grey3);\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-radius: 8px 0 0 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-radius: 0 8px 8px 0;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey9);\r\n                vertical-align: middle;\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n                .link-to-plasma {\r\n                    &:hover {\r\n                        color: var(--teal7) !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tfoot =====\r\n    tfoot {\r\n        tr {\r\n            th {\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                padding: 16px 12px;\r\n                color: var(--grey9);\r\n                letter-spacing: -0.02em;\r\n                background: var(--grey1);\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table harga ayam besar =====\r\n.table-harga-ayam-besar {\r\n    width: 100%;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        tr {\r\n            background: var(--grey2);\r\n            th {\r\n                width: 50%;\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey6);\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n\r\n    // ===== tbody =====\r\n    tbody {\r\n        tr {\r\n            td {\r\n                font-size: 12px;\r\n                font-weight: 400;\r\n                line-height: 16px;\r\n                padding: 8px 12px;\r\n                color: var(--grey9);\r\n                vertical-align: middle;\r\n                letter-spacing: -0.02em;\r\n                border-bottom: 1px solid var(--grey3);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.realisasi {\r\n        // ===== tbody =====\r\n        tbody {\r\n            tr {\r\n                td {\r\n                    background: var(--green1);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ===== table assessment =====\r\n.table-assessment {\r\n    font-size: 12px;\r\n    letter-spacing: -0.02em;\r\n\r\n    tr td,\r\n    tr th {\r\n        border: none;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    tr th {\r\n        height: 52px;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        padding: 8px 12px;\r\n        color: var(--grey9);\r\n    }\r\n\r\n    tr td {\r\n        font-weight: 400;\r\n        padding: 18px 12px;\r\n        color: var(--grey8);\r\n        background: var(--white);\r\n        border-top: 1px solid var(--grey3);\r\n    }\r\n\r\n    // ===== thead =====\r\n    thead {\r\n        // ===== search =====\r\n        .custom-search {\r\n            background: url('../../images/icons/search.svg') white no-repeat 12px center;\r\n        }\r\n\r\n        // ===== select =====\r\n        .select {\r\n            .react-select__control {\r\n                min-height: 32px;\r\n                .react-select__value-container {\r\n                    padding: 0 0 0 12px;\r\n                    .react-select__input-container {\r\n                        margin: 0;\r\n                        padding: 0;\r\n                    }\r\n                }\r\n                .react-select__indicators {\r\n                    .react-select__indicator-separator {\r\n                        display: none;\r\n                    }\r\n                    .react-select__indicator {\r\n                        padding: 0 12px 0 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        // ===== dropdown search =====\r\n        .list-group {\r\n            z-index: 1000;\r\n            cursor: pointer;\r\n            overflow-y: auto;\r\n            max-height: 188px;\r\n            border-radius: 8px;\r\n            background: var(--white);\r\n            border: 1px solid var(--grey2);\r\n            box-shadow: 0px 4px 6px -2px #1a1a1a33;\r\n            .list-group-item {\r\n                border: none;\r\n                font-size: 14px;\r\n                font-weight: 400;\r\n                line-height: 18px;\r\n                padding: 8px 16px;\r\n                letter-spacing: -0.02em;\r\n                transition: all ease-in-out 0.2s;\r\n                &:hover {\r\n                    font-weight: 500;\r\n                    color: var(--blue6);\r\n                    background: var(--blue1);\r\n                }\r\n            }\r\n        }\r\n\r\n        // ===== header table =====\r\n        .header-wrapper {\r\n            padding: 0;\r\n            display: flex;\r\n            border-radius: 8px;\r\n            align-items: center;\r\n            background: var(--grey2);\r\n            border: 1px solid var(--grey3);\r\n            justify-content: space-between;\r\n            th {\r\n                width: 329px;\r\n                height: auto;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// === table panen ===\r\n.table-panen {\r\n    border-spacing: 0 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        white-space: nowrap;\r\n        border: 1px solid var(--grey3);\r\n    }\r\n\r\n    tr th {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        padding: 8px 12px;\r\n        color: var(--grey6);\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    tr td {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        padding: 18px 12px;\r\n        color: var(--grey9);\r\n        vertical-align: middle;\r\n        letter-spacing: -0.02em;\r\n        border-bottom: 1px solid var(--grey3);\r\n    }\r\n\r\n    // === thead ===\r\n    thead {\r\n        tr {\r\n            background: var(--grey2);\r\n            .col-sticky {\r\n                position: sticky;\r\n                left: 0;\r\n                z-index: 9;\r\n                background: var(--grey2);\r\n            }\r\n        }\r\n        .first-th {\r\n            th {\r\n                &:first-child {\r\n                    border-bottom: none;\r\n                    border-top-left-radius: 8px;\r\n                }\r\n                &:last-child {\r\n                    border-top-right-radius: 8px;\r\n                }\r\n                &:nth-child(2) {\r\n                    &::before {\r\n                        content: none;\r\n                    }\r\n                }\r\n            }\r\n            .group-col {\r\n                position: relative;\r\n                &::before {\r\n                    content: '';\r\n                    position: absolute;\r\n                    left: 0;\r\n                    top: -1px;\r\n                    width: 8px;\r\n                    height: 34px;\r\n                    background: var(--white);\r\n                }\r\n            }\r\n        }\r\n        .second-th {\r\n            th {\r\n                &:first-child {\r\n                    border-top: none;\r\n                    border-bottom-left-radius: 8px;\r\n                }\r\n                &:last-child {\r\n                    border-bottom-right-radius: 8px;\r\n                }\r\n                &:nth-child(2) {\r\n                    &::before {\r\n                        content: none;\r\n                    }\r\n                }\r\n            }\r\n            .group-end {\r\n                position: relative;\r\n                &::before {\r\n                    content: '';\r\n                    position: absolute;\r\n                    left: 0;\r\n                    top: -2px;\r\n                    width: 8px;\r\n                    height: 34px;\r\n                    background: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // === tbody ===\r\n    tbody {\r\n        tr {\r\n            td {\r\n                border-top: none;\r\n                &:first-child {\r\n                    border-left: none;\r\n                }\r\n                &:last-child {\r\n                    border-right: none;\r\n                }\r\n                &:nth-child(2) {\r\n                    &::before {\r\n                        content: none;\r\n                    }\r\n                }\r\n            }\r\n            .col-sticky {\r\n                position: sticky;\r\n                left: 0;\r\n                z-index: 9;\r\n                background: var(--white);\r\n            }\r\n            // .dashed {\r\n            //     border-bottom: 1px dashed var(--grey3);\r\n            // }\r\n            .group-end {\r\n                position: relative;\r\n                &::before {\r\n                    content: '';\r\n                    position: absolute;\r\n                    left: 0;\r\n                    top: -2px;\r\n                    width: 8px;\r\n                    height: 56px;\r\n                    background: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // === tfoot ===\r\n    tfoot {\r\n        tr {\r\n            background: var(--grey2);\r\n            th {\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                line-height: 16px;\r\n                padding: 16px 12px;\r\n                color: var(--grey9);\r\n                letter-spacing: -0.02em;\r\n                border-top: none;\r\n                &:first-child {\r\n                    border-left: none;\r\n                }\r\n                &:last-child {\r\n                    border-right: none;\r\n                }\r\n                &:nth-child(2) {\r\n                    &::before {\r\n                        content: none;\r\n                    }\r\n                }\r\n            }\r\n            .col-sticky {\r\n                position: sticky;\r\n                left: 0;\r\n                z-index: 9;\r\n                background: var(--grey2);\r\n            }\r\n            .group-end {\r\n                position: relative;\r\n                &::before {\r\n                    content: '';\r\n                    position: absolute;\r\n                    left: 0;\r\n                    top: -1px;\r\n                    width: 8px;\r\n                    height: 50px;\r\n                    background: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// === table pengaturan panen ===\r\n.table-pengaturan-panen {\r\n    border-spacing: 0;\r\n    border-collapse: separate;\r\n\r\n    tr th,\r\n    tr td {\r\n        border: none;\r\n    }\r\n\r\n    tr th {\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        line-height: 16px;\r\n        padding: 8px 12px;\r\n        color: var(--grey6);\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    tr td {\r\n        font-size: 12px;\r\n        font-weight: 400;\r\n        line-height: 16px;\r\n        padding: 18px 12px;\r\n        color: var(--grey9);\r\n        vertical-align: middle;\r\n        letter-spacing: -0.02em;\r\n        border-bottom: 1px solid var(--grey3);\r\n    }\r\n\r\n    // === thead ===\r\n    thead {\r\n        tr {\r\n            background: var(--grey1);\r\n            th {\r\n                border-top: 1px solid var(--grey3);\r\n                border-bottom: 1px solid var(--grey3);\r\n                &:first-child {\r\n                    border-top-left-radius: 8px;\r\n                    border-bottom-left-radius: 8px;\r\n                    border-left: 1px solid var(--grey3);\r\n                }\r\n                &:last-child {\r\n                    border-top-right-radius: 8px;\r\n                    border-bottom-right-radius: 8px;\r\n                    border-right: 1px solid var(--grey3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // === tbody ===\r\n    tbody {\r\n        tr {\r\n            td {\r\n                .penjarangan {\r\n                    font-weight: 500;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    width: fit-content;\r\n                    color: var(--orange6);\r\n                    background: var(--orange2);\r\n                    text-transform: capitalize;\r\n                }\r\n                .panen {\r\n                    font-weight: 500;\r\n                    padding: 2px 8px;\r\n                    border-radius: 8px;\r\n                    width: fit-content;\r\n                    color: var(--green6);\r\n                    background: var(--green2);\r\n                    text-transform: capitalize;\r\n                }\r\n            }\r\n            .react-datepicker-wrapper {\r\n                width: fit-content;\r\n                .react-datepicker__input-container {\r\n                    width: fit-content;\r\n                    input {\r\n                        cursor: pointer;\r\n                        width: var(--56);\r\n                        background: transparent;\r\n                    }\r\n                }\r\n            }\r\n            .select {\r\n                &.none {\r\n                    width: 100%;\r\n                    .react-select__control {\r\n                        background: transparent;\r\n                        .react-select__value-container {\r\n                            .react-select__single-value {\r\n                                font-size: 12px;\r\n                                font-weight: 400;\r\n                                line-height: 16px;\r\n                                color: var(--grey9);\r\n                            }\r\n                        }\r\n                        .react-select__indicators {\r\n                            .react-select__indicator {\r\n                                svg {\r\n                                    width: 16px;\r\n                                    height: 16px;\r\n                                    path {\r\n                                        color: var(--grey9);\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.row-border-y-0 tr:not(:last-child) td {\r\n    border-bottom: none !important;\r\n}\r\n\r\n.row-border-y-0 tr td {\r\n    border-top: none !important;\r\n}\r\n\r\n.table-master-batas-hari {\r\n    td:first-child,\r\n    th:first-child {\r\n        position: sticky;\r\n        left: 0;\r\n        z-index: 6;\r\n    }\r\n\r\n    td:first-child {\r\n        background-color: white;\r\n    }\r\n}\r\n","//\n// type.scss\n//\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 10px 0;\n    font-family: $font-family-sans-serif;\n    color: $gray-800;\n    font-weight: 600;\n}\n\np {\n    line-height: 1.6;\n}\n\n// Font sizes (Custom)\n.fs-11 {\n    font-size: 11px !important;\n}\n\n.fs-12 {\n    font-size: 12px !important;\n}\n\n.fs-13 {\n    font-size: 13px !important;\n}\n\n.fs-14 {\n    font-size: 14px !important;\n}\n\n.fs-15 {\n    font-size: 15px !important;\n}\n\n.fs-16 {\n    font-size: 16px !important;\n}\n\n.fs-17 {\n    font-size: 17px !important;\n}\n\n.fs-18 {\n    font-size: 18px !important;\n}\n\n.fs-19 {\n    font-size: 19px !important;\n}\n\n.fs-20 {\n    font-size: 20px !important;\n}\n\n.fs-22 {\n    font-size: 22px !important;\n}\n\n.fs-24 {\n    font-size: 24px !important;\n}\n\n// text utilies\n.text-unline-dashed {\n    border-bottom: $gray-400 1px dashed !important;\n    padding-bottom: 1px;\n}\n\n.line-height-normal {\n    line-height: 1;\n}\n\n// Font Family\n// .font-family-secondary {\n//     font-family: $font-family-secondary;\n// }\n\n.fw-regular {\n    font-weight: $font-weight-regular !important;\n}\n.fw-medium {\n    font-weight: $font-weight-medium;\n}\n\n.fw-semibold {\n    font-weight: $font-weight-semibold;\n}\n\n.highlight {\n    position: relative;\n    z-index: 1;\n    width: fit-content;\n\n    &::before {\n        content: '';\n        display: block;\n        position: absolute;\n        background: $gray-100;\n        width: 100%;\n        height: 1.2rem;\n        z-index: -1;\n        right: -0.5rem;\n        bottom: 0.35rem;\n    }\n\n    @each $color, $value in $theme-colors {\n        &.highlight-#{$color} {\n            &::before {\n                background: lighten($value, 25%) !important;\n            }\n        }\n    }\n}\n","//\n// helper.scss\n//\n\n// Minimum width\n\n.width-xs {\n    min-width: 80px;\n}\n\n.width-sm {\n    min-width: 95px;\n}\n\n.width-md {\n    min-width: 110px;\n}\n\n.width-lg {\n    min-width: 140px;\n}\n\n.width-xl {\n    min-width: 160px;\n}\n\n// Text specify lines (Only chrome browser support)\n\n.sp-line-1,\n.sp-line-2,\n.sp-line-3,\n.sp-line-4 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n}\n\n.sp-line-1 {\n    -webkit-line-clamp: 1;\n}\n\n.sp-line-2 {\n    -webkit-line-clamp: 2;\n}\n\n.sp-line-3 {\n    -webkit-line-clamp: 3;\n}\n\n.sp-line-4 {\n    -webkit-line-clamp: 4;\n}\n\n// pull in\n.pull-in {\n    margin-left: -$card-spacer-x;\n    margin-right: -$card-spacer-x;\n}\n\n// border-radius\n.rounded-sm {\n    border-radius: $border-radius-sm;\n}\n.rounded-lg {\n    border-radius: $border-radius-lg;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.cursor-normal {\n    cursor: default;\n}\n","// \n// list.scss\n//\n\n.list-with-separator {\n    li {\n        &::after {\n            content: \"-\";\n            color: $gray-400;\n            font-weight: 900;\n            margin: 0 10px;\n        }\n    }\n\n    li:last-child {\n        &::after {\n            content: '';\n        }\n    }\n}","// \n// widgets.scss\n//\n\n\n// Simple tile box\n.widget-flat {\n    position: relative;\n    overflow: hidden;\n\n    i.widget-icon {\n        font-size: 36px;\n    }\n}\n\n/* Chat widget */\n\n.conversation-list {\n    list-style: none;\n    height: 332px;\n    padding: 0 7px;\n\n    li {\n        margin-bottom: 24px;\n    }\n\n    .chat-avatar {\n        float: left;\n        text-align: center;\n        width: 34px;\n\n        img {\n            border-radius: 100%;\n            width: 100%;\n        }\n\n        i {\n            font-size: 12px;\n            font-style: normal;\n        }\n    }\n\n    .ctext-wrap {\n        background: lighten($primary, 32%);\n        color: $primary;\n        border-radius: $border-radius;\n        display: inline-block;\n        padding: 4px 12px;\n        position: relative;\n\n        i {\n            display: block;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: $font-weight-semibold;\n            position: relative;\n        }\n\n        p {\n            margin: 0;\n            padding-top: 3px;\n        }\n\n        &:after {\n            right: 99%;\n            top: 0;\n            border: solid transparent;\n            content: \" \";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-top-color: lighten($primary, 32%);\n            border-width: 6px;\n            margin-left: -1px;\n            border-right-color: lighten($primary, 32%);\n        }\n    }\n\n    .conversation-text {\n        float: left;\n        font-size: 12px;\n        margin-left: 12px;\n        width: 70%;\n    }\n\n    .odd {\n        .chat-avatar {\n            float: right !important;\n        }\n\n        .conversation-text {\n            float: right !important;\n            margin-right: 12px;\n            text-align: right;\n            width: 70% !important;\n        }\n\n        .ctext-wrap {\n            background-color: $gray-300;\n            color: $gray-700;\n            &:after {\n                border-color: transparent;\n                border-left-color: $gray-300;\n                border-top-color: $gray-300;\n                left: 99% !important;\n            }\n        }\n    }\n}\n\n/* profile / users */\n.profile-widget {\n    position: relative;\n\n    .card-action {\n        position: absolute;\n        right: 7px;\n        top: 12px;\n        z-index: 100;\n    }\n\n    .card-img-top {\n        max-height: 220px;\n    }\n\n    .profile-info {\n        margin-top: -2.7rem;\n    }\n}\n\n.calendar-widget {\n    .flatpickr-calendar {\n        box-shadow: none;\n        border: $border-width solid $border-color !important;\n    }\n}","//\n// Custom-checkbox.scss\n//\n\n.checkbox {\n    label {\n        display: inline-block;\n        padding-left: 8px;\n        position: relative;\n        font-weight: normal;\n        margin-bottom: 0;\n        &::before {\n            background-color: $gray-300;\n            border-radius: 3px;\n            border: 2px solid $gray-300;\n            content: '';\n            display: inline-block;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            position: absolute;\n            transition: 0.3s ease-in-out;\n            width: 18px;\n            outline: none !important;\n            top: 2px;\n        }\n        &::after {\n            color: $gray-700;\n            display: inline-block;\n            font-size: 11px;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            padding-left: 3px;\n            padding-top: 2px;\n            position: absolute;\n            top: 0;\n            width: 18px;\n        }\n    }\n    input[type='checkbox'] {\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n        outline: none !important;\n        &:disabled + label {\n            opacity: 0.65;\n        }\n    }\n    input[type='checkbox']:focus + label {\n        &::before {\n            outline-offset: -2px;\n            outline: none;\n        }\n    }\n    input[type='checkbox']:checked + label {\n        &::after {\n            content: '';\n            position: absolute;\n            top: 6px;\n            left: 7px;\n            display: table;\n            width: 4px;\n            height: 8px;\n            border: 2px solid $gray-700;\n            border-top-width: 0;\n            border-left-width: 0;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            transform: rotate(45deg);\n        }\n    }\n    input[type='checkbox']:disabled + label {\n        &::before {\n            background-color: $light;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.checkbox.checkbox-circle {\n    label {\n        &::before {\n            border-radius: 50%;\n        }\n    }\n}\n\n.checkbox.checkbox-inline {\n    margin-top: 0;\n}\n\n.checkbox.checkbox-single {\n    input {\n        height: 18px;\n        width: 18px;\n        position: absolute;\n    }\n    label {\n        height: 18px;\n        width: 18px;\n        &:before {\n            margin-left: 0;\n        }\n        &:after {\n            margin-left: 0;\n        }\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .checkbox-#{$color} {\n        input[type='checkbox']:checked + label {\n            &::before {\n                background-color: $value;\n                border-color: $value;\n            }\n            &::after {\n                border-color: $white;\n            }\n        }\n    }\n}\n\ninput[type='checkbox'],\ninput[type='checkbox'] + label {\n    cursor: pointer;\n}\n","// \n// custom-radio.scss\n//\n\n.radio {\n    label {\n        display: inline-block;\n        padding-left: 8px;\n        position: relative;\n        font-weight: normal;\n        margin-bottom: 0;\n        &::before {\n            -o-transition: border 0.5s ease-in-out;\n            -webkit-transition: border 0.5s ease-in-out;\n            background-color: $white;\n            border-radius: 50%;\n            border: 2px solid $gray-600;\n            content: \"\";\n            display: inline-block;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            position: absolute;\n            transition: border 0.5s ease-in-out;\n            width: 18px;\n            outline: none !important;\n        }\n        &::after {\n            -moz-transition: -moz-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            -ms-transform: scale(0, 0);\n            -o-transform: scale(0, 0);\n            -o-transition: -o-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            -webkit-transform: scale(0, 0);\n            -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            background-color: $gray-700;\n            border-radius: 50%;\n            content: \" \";\n            display: inline-block;\n            height: 10px;\n            left: 6px;\n            margin-left: -20px;\n            position: absolute;\n            top: 4px;\n            transform: scale(0, 0);\n            transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            width: 10px;\n        }\n    }\n    input[type=\"radio\"] {\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n        outline: none !important;\n        &:disabled+label {\n            opacity: 0.65;\n        }\n    }\n    input[type=\"radio\"]:focus+label {\n        &::before {\n            outline-offset: -2px;\n            outline: 5px auto -webkit-focus-ring-color;\n            outline: thin dotted;\n        }\n    }\n    input[type=\"radio\"]:checked+label {\n        &::after {\n            -ms-transform: scale(1, 1);\n            -o-transform: scale(1, 1);\n            -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n        }\n    }\n    input[type=\"radio\"]:disabled+label {\n        &::before {\n            cursor: not-allowed;\n        }\n    }\n}\n\n.radio.radio-inline {\n    margin-top: 0;\n}\n\n.radio.radio-single {\n    label {\n        height: 17px;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .radio-#{$color} {\n        input[type=\"radio\"]+label {\n            &::after {\n                background-color: $value;\n            }\n        }\n        input[type=\"radio\"]:checked+label {\n            &::before {\n                border-color: $value;\n            }\n            &::after {\n                background-color: $value;\n            }\n        }\n    }\n}","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .left-side-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-custom,\n    .footer {\n        display: none;\n    }\n    .card-body,\n    .content-page,\n    .right-bar,\n    .content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n}","//\n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: $body-bg;\n    z-index: 9999;\n}\n\n#status {\n    height: 80px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -40px 0 0 -40px;\n}\n\n.spinner {\n    > div {\n        display: inline-block;\n        width: 16px;\n        height: 16px;\n        background: $white;\n        border: 2px solid $primary;\n        border-radius: 50%;\n        animation: circle-loader 1s infinite ease-in-out both;\n        margin: 0px 7px;\n    }\n    .circle1 {\n        animation-delay: -0.24s;\n    }\n    .circle2 {\n        animation-delay: -0.16s;\n    }\n    .circle3 {\n        animation-delay: -0.08s;\n    }\n}\n\n@keyframes circle-loader {\n    0%,\n    80%,\n    100% {\n        transform: scale(0.4);\n    }\n    40% {\n        transform: scale(1);\n    }\n}\n","#tooltip-top {\n    .tooltip-arrow {\n        display: none;\n    }\n\n    .tooltip-inner {\n        max-width: 100%;\n        padding: 8px 12px;\n        border-radius: 8px;\n        background: var(--grey10);\n        div {\n            font-size: 12px;\n            font-weight: 500;\n            text-align: start;\n            color: var(--white);\n            letter-spacing: -0.02em;\n        }\n    }\n}\n",".offcanvas {\n    overflow-y: auto;\n    border-radius: var(--8) 0 0 var(--8);\n\n    // === tab ===\n    .tab-w-bg {\n        .rts___tabs___container {\n            .rts___tabs {\n                width: 100%;\n                .rts___tab {\n                    width: 100%;\n                    white-space: nowrap;\n                }\n            }\n        }\n    }\n\n    // === slider ===\n    .dual-slider-wrapper {\n        position: relative;\n        .track {\n            width: 100%;\n            height: 1px;\n            overflow: hidden;\n            position: relative;\n            background: var(--pink6);\n            .track-fill-left {\n                position: absolute;\n                top: 0;\n                left: 0;\n                z-index: 2;\n                height: 100%;\n                background: var(--grey3);\n            }\n            .track-fill-right {\n                position: absolute;\n                top: 0;\n                right: 0;\n                z-index: 2;\n                height: 100%;\n                background: var(--grey3);\n            }\n        }\n        .slider {\n            -webkit-appearance: none;\n            appearance: none;\n            position: absolute;\n            top: 50%;\n            width: 100%;\n            height: 1px;\n            background: transparent;\n            transform: translateY(-50%);\n            pointer-events: none;\n            z-index: 3;\n            &.slider-left {\n                left: 0;\n                z-index: 4;\n            }\n            &.slider-right {\n                right: 0;\n                z-index: 5;\n            }\n            &::-webkit-slider-thumb {\n                pointer-events: auto;\n                -webkit-appearance: none;\n                cursor: pointer;\n                width: var(--20);\n                height: var(--20);\n                border-radius: 50%;\n                background: var(--white);\n                border: 1px solid var(--grey3);\n            }\n            &::-moz-range-thumb {\n                pointer-events: auto;\n                cursor: pointer;\n                width: var(--20);\n                height: var(--20);\n                border-radius: 50%;\n                background: var(--white);\n                border: 1px solid var(--grey3);\n            }\n        }\n    }\n\n    .segmentasi {\n        width: 100px;\n    }\n\n    .rerata-pengambilan {\n        width: 140px;\n    }\n\n    .omset {\n        width: 200px;\n    }\n\n\t.custom-spinner{\n\t\twidth: var(--20);\n    \theight: var(--20);\n    \tborder: 3px solid #e3e5e8;\n    \tborder-top: 3px solid var(--primary);\n\t}\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    .offcanvas {\n        .offcanvas-body {\n            .tab-w-bg {\n                .rts___tabs___container {\n                    .rts___tabs {\n                        flex-direction: column;\n                    }\n                }\n            }\n            .custom-input {\n            }\n        }\n    }\n}\n\n/* Medium mobile */\n@media (min-width: 375px) and (max-width: 424px) {\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    .offcanvas {\n        width: 100% !important;\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","// === customs input ===\n.customs-input {\n    outline: none;\n    font-weight: 400;\n    color: var(--grey9);\n    font-size: var(--12);\n    line-height: var(--16);\n    border-radius: var(--6);\n    padding: var(--8) var(--12);\n    border: 1px solid var(--grey3);\n    &::placeholder {\n        color: var(--grey5);\n    }\n    &:focus {\n        border: 1px solid var(--teal6);\n    }\n    &.textarea {\n        height: 80px;\n        resize: none;\n    }\n}\n\n// === checkbox ===\n.label-checkbox {\n    margin-bottom: var(--12);\n    &:last-child {\n        margin-bottom: 0;\n    }\n    .custom-checkbox {\n        cursor: pointer;\n        appearance: none;\n        -webkit-appearance: none;\n        width: var(--12);\n        height: var(--12);\n        position: relative;\n        border-radius: 3px;\n        border: 1px solid var(--grey3);\n        &:checked {\n            background: var(--blue7);\n            border-color: var(--blue7);\n            &::after {\n                content: '';\n                position: absolute;\n                top: 0px;\n                left: 3px;\n                width: var(--4);\n                height: var(--8);\n                border: solid var(--white);\n                border-width: 0 2px 2px 0;\n                transform: rotate(45deg);\n            }\n        }\n    }\n}\n\n// === time ===\n.time-wrapper {\n    position: relative;\n    width: 100%;\n    .time {\n        width: 100%;\n        cursor: pointer;\n        -moz-appearance: textfield;\n        -webkit-appearance: none;\n        appearance: none;\n        &::-webkit-calendar-picker-indicator {\n            opacity: 0;\n            display: none;\n        }\n        &::-webkit-clear-button {\n            display: none;\n        }\n        &::-webkit-inner-spin-button {\n            display: none;\n        }\n    }\n    .time-icon {\n        position: absolute;\n        top: 50%;\n        right: var(--12);\n        width: var(--16);\n        height: var(--16);\n        transform: translateY(-50%);\n        background: url('../../images/icons/clock-grey9.svg') no-repeat center;\n        background-size: contain;\n    }\n}\n\n// === slider ===\n.customs-slider {\n    --percent: 0%;\n    -webkit-appearance: none;\n    appearance: none;\n    width: 100%;\n    height: 1px;\n    border-radius: var(--10);\n    background: linear-gradient(to right, var(--pink6) var(--percent), var(--grey3) var(--percent));\n    &::-webkit-slider-runnable-track {\n        height: 1px;\n        background: transparent;\n    }\n    &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        cursor: pointer;\n        width: var(--20);\n        height: var(--20);\n        border-radius: 50%;\n        background: var(--white);\n        border: 1px solid var(--grey3);\n        margin-top: calc((1px - var(--20)) / 2);\n    }\n    &::-moz-range-track {\n        height: 1px;\n        background: var(--grey3);\n    }\n    &::-moz-range-progress {\n        height: 1px;\n        background: var(--pink6);\n    }\n    &::-moz-range-thumb {\n        cursor: pointer;\n        width: var(--20);\n        height: var(--20);\n        border-radius: 50%;\n        background: var(--white);\n        border: 1px solid var(--grey3);\n    }\n}\n\n// === prefix suffix ===\n.affix-wrapper {\n    display: flex;\n    align-items: center;\n    border-radius: var(--6);\n    border: 1px solid var(--grey3);\n    &.error {\n        border: 1px solid var(--red7) !important;\n    }\n    &:focus-within {\n        border: 1px solid var(--teal6);\n        .affix {\n            &.prefix {\n                border-right: 1px solid var(--teal6);\n            }\n            &.suffix {\n                border-left: 1px solid var(--teal6);\n            }\n        }\n    }\n    .affix {\n        font-weight: 400;\n        white-space: nowrap;\n        color: var(--grey6);\n        font-size: var(--12);\n        line-height: var(--16);\n        background: var(--grey2);\n        &.prefix {\n            border-right: 1px solid var(--grey3);\n            border-radius: var(--6) 0 0 var(--6);\n            padding: var(--8) var(--8) var(--8) var(--12);\n        }\n        &.suffix {\n            border-left: 1px solid var(--grey3);\n            border-radius: 0 var(--6) var(--6) 0;\n            padding: var(--8) var(--12) var(--8) var(--8);\n        }\n    }\n    .customs-input {\n        flex: 1;\n        border: none;\n    }\n    .select {\n        width: 100%;\n        .react-select__control {\n            border: none;\n        }\n    }\n}\n","/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    #select {\n        .select-ap {\n            .react-select__menu {\n                left: -20px;\n            }\n        }\n        .select-unit {\n            .react-select__menu {\n                left: 0;\n            }\n        }\n    }\n}\n\n/* Medium mobile */\n@media (min-width: 375px) and (max-width: 424px) {\n    #select {\n        .select-ap {\n            .react-select__menu {\n                left: 0;\n            }\n        }\n        .select-unit {\n            .react-select__menu {\n                left: 0;\n            }\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    #select {\n        .select-ap {\n            .react-select__menu {\n                left: 0;\n            }\n        }\n        .select-unit {\n            .react-select__menu {\n                left: 0;\n            }\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    #select {\n        .select-ap {\n            .react-select__menu {\n                left: 0;\n            }\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","//\n// _rateit.scss\n//\n\n.rateit {\n    display: -moz-inline-box;\n    display: inline-block;\n    position: relative;\n    user-select: none;\n    -webkit-touch-callout: none;\n\n    .rateit-range * {\n        display: block;\n    }\n\n    .rateit-hover,\n    .rateit-selected {\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 0;\n    }\n\n    .rateit-hover-rtl,\n    .rateit-selected-rtl {\n        left: auto;\n        right: 0;\n    }\n\n    .rateit-hover {\n        color: $warning;\n    }\n\n    .rateit-hover-rtl {\n        background-position: right -32px;\n    }\n\n    .rateit-selected {\n        color: $danger;\n    }\n\n    .rateit-selected-rtl {\n        background-position: right -16px;\n    }\n\n    .rateit-preset {\n        color: $warning;\n    }\n\n    button.rateit-reset {\n        width: 16px;\n        height: 16px;\n        float: left;\n        outline: none;\n        border: none;\n        padding: 0;\n    }\n\n    .rateit-reset span {\n        display: none;\n    }\n\n\n    .rateit-range {\n        position: relative;\n        display: -moz-inline-box;\n        display: inline-block;\n        height: 16px;\n        outline: none;\n    }\n\n    &.rateit-font {\n        .rateit-reset {\n            width: .6em;\n            height: .6em;\n            margin-right: 5px;\n            margin-top: 5px;\n            background: $gray-300;\n            border-radius: 50%;\n            position: relative;\n\n            span {\n                display: block;\n                height: calc(50% - 0.045em);\n                top: 2px;\n                position: absolute;\n                border-bottom: 2px solid $gray-700;\n                width: 50%;\n                margin-left: 25%;\n                margin-right: 25%;\n            }\n        }\n        .rateit-reset:hover,\n        button.rateit-reset:focus {\n            background: $danger;\n            \n            span {\n                border-color: $white;\n            }\n        }\n    }\n}\n\n.rateit-font {\n    font-size: 24px;\n    line-height: 1em;\n\n    .rateit-range {\n        background: none;\n        height: auto;\n\n        > div {\n            background: none;\n            overflow: hidden;\n            cursor: default;\n            white-space: nowrap;\n        }\n    }\n    \n    .rateit-empty {\n        color: $gray-400;\n    }\n}",".mfp-image-holder .mfp-close,\n.mfp-iframe-holder .mfp-close {\n    width: 18px;\n    height: 18px;\n    background: center center url(/assets/images/shapes/x.svg) no-repeat;\n    top: 12px;\n}\n\n.mfp-arrow {\n    &:before {\n        width: 60px;\n        height: 60px;\n        opacity: .9;\n        background: center center url(\"/assets/images/shapes/chevron-left.svg\") no-repeat;\n    }\n\n    &:before,\n    &:after {\n        border: none;\n    }\n}\n\n.mfp-arrow-left {\n    left: 1rem;\n}\n\n.mfp-arrow-right {\n    right: 1rem;\n\n    &:before {\n        background: center center url(\"/assets/images/shapes/chevron-right.svg\") no-repeat;\n    }\n}\n\n.mfp-with-zoom .mfp-container,\n.mfp-with-zoom.mfp-bg {\n    opacity: 0;\n    backface-visibility: hidden;\n    transition: all 0.3s ease-out;\n}\n\n.mfp-with-zoom.mfp-ready .mfp-container {\n    opacity: 1;\n}\n\n.mfp-with-zoom.mfp-ready.mfp-bg {\n    opacity: 0.8;\n}\n\n.mfp-with-zoom.mfp-removing .mfp-container,\n.mfp-with-zoom.mfp-removing.mfp-bg {\n    opacity: 0;\n}","//\n// Daterange\n//\n\n.daterangepicker {\n    font-family: $font-family-base;\n    border: $dropdown-border-width solid $dropdown-border-color;\n    box-shadow: $box-shadow;\n    background-color: $dropdown-bg;\n\n    .calendar-table {\n        border: 1px solid $dropdown-bg;\n        background-color: $dropdown-bg;\n\n        td,th {\n            color: $gray-600;\n        }\n\n        .next,\n        .prev {\n            span {\n                border-color: $gray-500;\n            }\n        }\n    }   \n\n    td {\n        &.in-range {\n            background-color: lighten($gray-300,5%);\n            color: $gray-700;\n        }\n        &.off,\n        &.off.end-date, \n        &.off.in-range,\n        &.off.start-date {\n            background-color: $dropdown-bg;\n            color: $dropdown-link-color;\n            opacity: 0.5;\n        }\n    \n        &.active,&.active:hover{\n            background-color: $primary;\n            color: $white;\n        }\n    }\n\n    td.available:hover, \n    th.available:hover {\n        background-color: $primary;\n        color: $white;\n    } \n\n    &:after {\n        border-bottom: 6px solid $dropdown-bg;\n    }\n    &:before {\n        border-bottom: 7px solid $dropdown-border-color;\n    }\n\n    .ranges {\n        li {\n            &.active {\n                background-color: $primary;\n            }\n            &:hover {\n                background-color: $dropdown-link-hover-bg;\n            }\n        }\n    }\n\n    .drp-buttons {\n        border-top: 1px solid $dropdown-border-color;\n    }\n\n    select {\n        &.ampmselect, \n        &.hourselect, \n        &.minuteselect, \n        &.secondselect {\n            background: lighten($dropdown-bg,5%);;\n            border: 1px solid lighten($dropdown-bg,5%);\n            color: $white;\n        }\n    }\n\n    &.show-ranges {\n        .drp-calendar.left {\n            border-left: 1px solid $dropdown-border-color;\n        }\n    }\n}","// overriding popup\n.leaflet-container {\n    font-family: $font-family-base;\n    @include font-size($font-size-base);\n    font-weight: $font-weight-base;\n    line-height: $line-height-base;\n    color: $body-color;\n\n    a.leaflet-popup-close-button {\n        color: #fff;\n        font-size: 1.5rem;\n        margin: 7px;\n    }\n}\n\n.custom-map-marker-popup {\n    .leaflet-popup-content-wrapper {\n        padding: 0px !important;\n\n        .leaflet-popup-content {\n            margin: 0px !important;\n\n            p {\n                margin: inherit;\n            }\n        }\n    }\n}\n\n// custom marker\n.custom-map-marker {\n    font-size: 0.75rem;\n    font-weight: $font-weight-semibold;\n    background-color: $white;\n    color: $body-color;\n    border-color: $white;\n    box-shadow: 0 1rem 3rem rgba($black, 0.275);\n\n    &:before {\n        box-shadow: 0 1rem 3rem rgba($black, 0.275);\n    }\n\n    &.active {\n        background-color: $primary;\n        border-color: $primary;\n        color: $white;\n\n        &:before {\n            border-top-color: $primary;\n        }\n    }\n}\n\n.custom-marker-icon {\n    text-align: center; /* Horizontally center the text (icon) */\n    line-height: 28px; /* Vertically center the text (icon) */\n}\n\n// .leaflet-control-container {\n//     .leaflet-control-zoom.leaflet-bar a {\n//         background-color: $primary;\n//         color: white;\n\n//         &:hover {\n//             background-color: darken($primary, 2%);\n//         }\n//     }\n\n//     .leaflet-control-zoom {\n//         .leaflet-control-zoom-in {\n//             border: none;\n//             border-radius: 2px 2px;\n//             margin-bottom: 4px;\n//         }\n\n//         .leaflet-control-zoom-out {\n//             border-radius: 2px 2px;\n//         }\n//     }\n\n//     .leaflet-top.leaflet-right {\n//         display: flex;\n//         flex-direction: column;\n//         gap: 16px;\n//     }\n\n//     .leaflet-bar .fullscreen-icon {\n//         filter: invert(1);\n//         mix-blend-mode: multiply;\n//     }\n\n// }\n",".jarallax {\n    position: relative;\n    z-index: 0;\n}\n\n.jarallax>.jarallax-img {\n    position: absolute;\n    object-fit: cover;\n    /* support for plugin https://github.com/bfred-it/object-fit-images */\n    font-family: 'object-fit: cover;';\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n}","@import 'swiper-vars.scss';\n\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA')\n    format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n:root {\n  --swiper-theme-color: #{$themeColor};\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-pointer-events {\n  touch-action: pan-y;\n  &.swiper-vertical {\n    touch-action: pan-x;\n  }\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight {\n  &,\n  .swiper-slide {\n    height: auto;\n  }\n\n  .swiper-wrapper {\n    align-items: flex-start;\n    transition-property: transform, height;\n  }\n}\n\n/* 3D Effects */\n.swiper-3d {\n  &,\n  &.swiper-css-mode .swiper-wrapper {\n    perspective: 1200px;\n  }\n  .swiper-wrapper,\n  .swiper-slide,\n  .swiper-slide-shadow,\n  .swiper-slide-shadow-left,\n  .swiper-slide-shadow-right,\n  .swiper-slide-shadow-top,\n  .swiper-slide-shadow-bottom,\n  .swiper-cube-shadow {\n    transform-style: preserve-3d;\n  }\n  .swiper-slide-shadow,\n  .swiper-slide-shadow-left,\n  .swiper-slide-shadow-right,\n  .swiper-slide-shadow-top,\n  .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10;\n  }\n  .swiper-slide-shadow {\n    background: rgba(0, 0, 0, 0.15);\n  }\n  .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n}\n\n/* CSS Mode */\n.swiper-css-mode {\n  > .swiper-wrapper {\n    overflow: auto;\n    scrollbar-width: none; /* For Firefox */\n    -ms-overflow-style: none; /* For Internet Explorer and Edge */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: start start;\n  }\n}\n.swiper-horizontal.swiper-css-mode {\n  > .swiper-wrapper {\n    scroll-snap-type: x mandatory;\n  }\n}\n.swiper-vertical.swiper-css-mode {\n  > .swiper-wrapper {\n    scroll-snap-type: y mandatory;\n  }\n}\n.swiper-centered {\n  > .swiper-wrapper::before {\n    content: '';\n    flex-shrink: 0;\n    order: 9999;\n  }\n  &.swiper-horizontal {\n    > .swiper-wrapper > .swiper-slide:first-child {\n      margin-inline-start: var(--swiper-centered-offset-before);\n    }\n    > .swiper-wrapper::before {\n      height: 100%;\n      width: var(--swiper-centered-offset-after);\n    }\n  }\n  &.swiper-vertical {\n    > .swiper-wrapper > .swiper-slide:first-child {\n      margin-block-start: var(--swiper-centered-offset-before);\n    }\n    > .swiper-wrapper::before {\n      width: 100%;\n      height: var(--swiper-centered-offset-after);\n    }\n  }\n\n  > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: center center;\n  }\n}\n\n\n\n","@import '../../swiper-vars.scss';\n\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n  &.swiper-button-disabled {\n    opacity: 0.35;\n    cursor: auto;\n    pointer-events: none;\n  }\n  &:after {\n    font-family: swiper-icons;\n    font-size: var(--swiper-navigation-size);\n    text-transform: none !important;\n    letter-spacing: 0;\n    text-transform: none;\n    font-variant: initial;\n    line-height: 1;\n  }\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n  &:after {\n    content: 'prev';\n  }\n  left: 10px;\n  right: auto;\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  &:after {\n    content: 'next';\n  }\n  right: 10px;\n  left: auto;\n}\n\n.swiper-button-lock {\n  display: none;\n}\n","@import '../../swiper-vars.scss';\n\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  --swiper-pagination-bullet-size: 8px;\n  --swiper-pagination-bullet-width: 8px;\n  --swiper-pagination-bullet-height: 8px;\n  --swiper-pagination-bullet-inactive-color: #000;\n  --swiper-pagination-bullet-inactive-opacity: 0.2;\n  --swiper-pagination-bullet-opacity: 1;\n  --swiper-pagination-bullet-horizontal-gap: 4px;\n  --swiper-pagination-bullet-vertical-gap: 6px;\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n  &.swiper-pagination-hidden {\n    opacity: 0;\n  }\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n  .swiper-pagination-bullet {\n    transform: scale(0.33);\n    position: relative;\n  }\n  .swiper-pagination-bullet-active {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-main {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullet-active-next {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33);\n  }\n}\n.swiper-pagination-bullet {\n  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));\n  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n  display: inline-block;\n  border-radius: 50%;\n  background: var(--swiper-pagination-bullet-inactive-color, #000);\n  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n  @at-root button#{&} {\n    border: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    appearance: none;\n  }\n  .swiper-pagination-clickable & {\n    cursor: pointer;\n  }\n\n  &:only-child {\n    display: none !important;\n  }\n}\n.swiper-pagination-bullet-active {\n  opacity: var(--swiper-pagination-bullet-opacity, 1);\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n\n.swiper-vertical > .swiper-pagination-bullets,\n.swiper-pagination-vertical.swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n  .swiper-pagination-bullet {\n    margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;\n    display: block;\n  }\n  &.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px;\n    .swiper-pagination-bullet {\n      display: inline-block;\n      transition: 200ms transform, 200ms top;\n    }\n  }\n}\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-horizontal.swiper-pagination-bullets {\n  .swiper-pagination-bullet {\n    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);\n  }\n  &.swiper-pagination-bullets-dynamic {\n    left: 50%;\n    transform: translateX(-50%);\n    white-space: nowrap;\n    .swiper-pagination-bullet {\n      transition: 200ms transform, 200ms left;\n    }\n  }\n}\n.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n  .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(0);\n    transform-origin: left top;\n  }\n  .swiper-rtl & .swiper-pagination-progressbar-fill {\n    transform-origin: right top;\n  }\n  .swiper-horizontal > &,\n  &.swiper-pagination-horizontal,\n  .swiper-vertical > &.swiper-pagination-progressbar-opposite,\n  &.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0;\n  }\n  .swiper-vertical > &,\n  &.swiper-pagination-vertical,\n  .swiper-horizontal > &.swiper-pagination-progressbar-opposite,\n  &.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {\n    width: 4px;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n}\n.swiper-pagination-lock {\n  display: none;\n}\n","@keyframes closeWindow {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.ril__outer {\n    background-color: rgba(0, 0, 0, 0.85);\n    outline: none;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000;\n    width: 100%;\n    height: 100%;\n    -ms-content-zooming: none;\n    -ms-user-select: none;\n    -ms-touch-select: none;\n    touch-action: none;\n}\n\n.ril__outerClosing {\n    opacity: 0;\n}\n\n.ril__inner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.ril__image,\n.ril__imagePrev,\n.ril__imageNext {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    max-width: none;\n    -ms-content-zooming: none;\n    -ms-user-select: none;\n    -ms-touch-select: none;\n    touch-action: none;\n}\n\n.ril__imageDiscourager {\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n.ril__navButtons {\n    border: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 20px;\n    height: 34px;\n    padding: 40px 30px;\n    margin: auto;\n    cursor: pointer;\n    opacity: 0.7;\n}\n.ril__navButtons:hover {\n    opacity: 1;\n}\n.ril__navButtons:active {\n    opacity: 0.7;\n}\n\n.ril__navButtonPrev {\n    left: 0;\n    background: rgba(0, 0, 0, 0.2)\n        url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==\")\n        no-repeat center;\n}\n\n.ril__navButtonNext {\n    right: 0;\n    background: rgba(0, 0, 0, 0.2)\n        url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+\")\n        no-repeat center;\n}\n\n.ril__downloadBlocker {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");\n    background-size: cover;\n}\n\n.ril__caption,\n.ril__toolbar {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: absolute;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.ril__caption {\n    bottom: 0;\n    max-height: 150px;\n    overflow: auto;\n}\n\n.ril__captionContent {\n    padding: 10px 20px;\n    color: #fff;\n}\n\n.ril__toolbar {\n    top: 0;\n    height: 50px;\n}\n\n.ril__toolbarSide {\n    height: 50px;\n    margin: 0;\n}\n\n.ril__toolbarLeftSide {\n    padding-left: 20px;\n    padding-right: 0;\n    flex: 0 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.ril__toolbarRightSide {\n    padding-left: 0;\n    padding-right: 20px;\n    flex: 0 0 auto;\n}\n\n.ril__toolbarItem {\n    display: inline-block;\n    line-height: 50px;\n    padding: 0;\n    color: #fff;\n    font-size: 120%;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.ril__toolbarItemChild {\n    vertical-align: middle;\n}\n\n.ril__builtinButton {\n    width: 40px;\n    height: 35px;\n    cursor: pointer;\n    border: none;\n    opacity: 0.7;\n}\n.ril__builtinButton:hover {\n    opacity: 1;\n}\n.ril__builtinButton:active {\n    outline: none;\n}\n\n.ril__builtinButtonDisabled {\n    cursor: default;\n    opacity: 0.5;\n}\n.ril__builtinButtonDisabled:hover {\n    opacity: 0.5;\n}\n\n.ril__closeButton {\n    background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=\")\n        no-repeat center;\n}\n\n.ril__zoomInButton {\n    background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+\")\n        no-repeat center;\n}\n\n.ril__zoomOutButton {\n    background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=\")\n        no-repeat center;\n}\n\n.ril__outerAnimating {\n    animation-name: closeWindow;\n}\n\n@keyframes pointFade {\n    0%,\n    19.999%,\n    100% {\n        opacity: 0;\n    }\n    20% {\n        opacity: 1;\n    }\n}\n\n.ril__loadingCircle {\n    width: 60px;\n    height: 60px;\n    position: relative;\n}\n\n.ril__loadingCirclePoint {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n.ril__loadingCirclePoint::before {\n    content: \"\";\n    display: block;\n    margin: 0 auto;\n    width: 11%;\n    height: 30%;\n    background-color: #fff;\n    border-radius: 30%;\n    animation: pointFade 800ms infinite ease-in-out both;\n}\n.ril__loadingCirclePoint:nth-of-type(1) {\n    transform: rotate(0deg);\n}\n.ril__loadingCirclePoint:nth-of-type(7) {\n    transform: rotate(180deg);\n}\n.ril__loadingCirclePoint:nth-of-type(1)::before,\n.ril__loadingCirclePoint:nth-of-type(7)::before {\n    animation-delay: -800ms;\n}\n.ril__loadingCirclePoint:nth-of-type(2) {\n    transform: rotate(30deg);\n}\n.ril__loadingCirclePoint:nth-of-type(8) {\n    transform: rotate(210deg);\n}\n.ril__loadingCirclePoint:nth-of-type(2)::before,\n.ril__loadingCirclePoint:nth-of-type(8)::before {\n    animation-delay: -666ms;\n}\n.ril__loadingCirclePoint:nth-of-type(3) {\n    transform: rotate(60deg);\n}\n.ril__loadingCirclePoint:nth-of-type(9) {\n    transform: rotate(240deg);\n}\n.ril__loadingCirclePoint:nth-of-type(3)::before,\n.ril__loadingCirclePoint:nth-of-type(9)::before {\n    animation-delay: -533ms;\n}\n.ril__loadingCirclePoint:nth-of-type(4) {\n    transform: rotate(90deg);\n}\n.ril__loadingCirclePoint:nth-of-type(10) {\n    transform: rotate(270deg);\n}\n.ril__loadingCirclePoint:nth-of-type(4)::before,\n.ril__loadingCirclePoint:nth-of-type(10)::before {\n    animation-delay: -400ms;\n}\n.ril__loadingCirclePoint:nth-of-type(5) {\n    transform: rotate(120deg);\n}\n.ril__loadingCirclePoint:nth-of-type(11) {\n    transform: rotate(300deg);\n}\n.ril__loadingCirclePoint:nth-of-type(5)::before,\n.ril__loadingCirclePoint:nth-of-type(11)::before {\n    animation-delay: -266ms;\n}\n.ril__loadingCirclePoint:nth-of-type(6) {\n    transform: rotate(150deg);\n}\n.ril__loadingCirclePoint:nth-of-type(12) {\n    transform: rotate(330deg);\n}\n.ril__loadingCirclePoint:nth-of-type(6)::before,\n.ril__loadingCirclePoint:nth-of-type(12)::before {\n    animation-delay: -133ms;\n}\n.ril__loadingCirclePoint:nth-of-type(7) {\n    transform: rotate(180deg);\n}\n.ril__loadingCirclePoint:nth-of-type(13) {\n    transform: rotate(360deg);\n}\n.ril__loadingCirclePoint:nth-of-type(7)::before,\n.ril__loadingCirclePoint:nth-of-type(13)::before {\n    animation-delay: 0ms;\n}\n\n.ril__loadingContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n.ril__imagePrev .ril__loadingContainer,\n.ril__imageNext .ril__loadingContainer {\n    display: none;\n}\n\n.ril__errorContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n}\n.ril__imagePrev .ril__errorContainer,\n.ril__imageNext .ril__errorContainer {\n    display: none;\n}\n\n.ril__loadingContainer__icon {\n    color: #fff;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n}\n","[data-aos][data-aos][data-aos-duration=\"50\"],\nbody[data-aos-duration=\"50\"] [data-aos] {\n    transition-duration: 50ms;\n}\n\n[data-aos][data-aos][data-aos-delay=\"50\"],\nbody[data-aos-delay=\"50\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"50\"].aos-animate,\nbody[data-aos-delay=\"50\"] [data-aos].aos-animate {\n    transition-delay: 50ms;\n}\n\n[data-aos][data-aos][data-aos-duration=\"100\"],\nbody[data-aos-duration=\"100\"] [data-aos] {\n    transition-duration: 0.1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"100\"],\nbody[data-aos-delay=\"100\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"100\"].aos-animate,\nbody[data-aos-delay=\"100\"] [data-aos].aos-animate {\n    transition-delay: 0.1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"150\"],\nbody[data-aos-duration=\"150\"] [data-aos] {\n    transition-duration: 0.15s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"150\"],\nbody[data-aos-delay=\"150\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"150\"].aos-animate,\nbody[data-aos-delay=\"150\"] [data-aos].aos-animate {\n    transition-delay: 0.15s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"200\"],\nbody[data-aos-duration=\"200\"] [data-aos] {\n    transition-duration: 0.2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"200\"],\nbody[data-aos-delay=\"200\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"200\"].aos-animate,\nbody[data-aos-delay=\"200\"] [data-aos].aos-animate {\n    transition-delay: 0.2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"250\"],\nbody[data-aos-duration=\"250\"] [data-aos] {\n    transition-duration: 0.25s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"250\"],\nbody[data-aos-delay=\"250\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"250\"].aos-animate,\nbody[data-aos-delay=\"250\"] [data-aos].aos-animate {\n    transition-delay: 0.25s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"300\"],\nbody[data-aos-duration=\"300\"] [data-aos] {\n    transition-duration: 0.3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"300\"],\nbody[data-aos-delay=\"300\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"300\"].aos-animate,\nbody[data-aos-delay=\"300\"] [data-aos].aos-animate {\n    transition-delay: 0.3s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"350\"],\nbody[data-aos-duration=\"350\"] [data-aos] {\n    transition-duration: 0.35s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"350\"],\nbody[data-aos-delay=\"350\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"350\"].aos-animate,\nbody[data-aos-delay=\"350\"] [data-aos].aos-animate {\n    transition-delay: 0.35s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"400\"],\nbody[data-aos-duration=\"400\"] [data-aos] {\n    transition-duration: 0.4s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"400\"],\nbody[data-aos-delay=\"400\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"400\"].aos-animate,\nbody[data-aos-delay=\"400\"] [data-aos].aos-animate {\n    transition-delay: 0.4s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"450\"],\nbody[data-aos-duration=\"450\"] [data-aos] {\n    transition-duration: 0.45s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"450\"],\nbody[data-aos-delay=\"450\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"450\"].aos-animate,\nbody[data-aos-delay=\"450\"] [data-aos].aos-animate {\n    transition-delay: 0.45s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"500\"],\nbody[data-aos-duration=\"500\"] [data-aos] {\n    transition-duration: 0.5s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"500\"],\nbody[data-aos-delay=\"500\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"500\"].aos-animate,\nbody[data-aos-delay=\"500\"] [data-aos].aos-animate {\n    transition-delay: 0.5s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"550\"],\nbody[data-aos-duration=\"550\"] [data-aos] {\n    transition-duration: 0.55s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"550\"],\nbody[data-aos-delay=\"550\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"550\"].aos-animate,\nbody[data-aos-delay=\"550\"] [data-aos].aos-animate {\n    transition-delay: 0.55s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"600\"],\nbody[data-aos-duration=\"600\"] [data-aos] {\n    transition-duration: 0.6s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"600\"],\nbody[data-aos-delay=\"600\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"600\"].aos-animate,\nbody[data-aos-delay=\"600\"] [data-aos].aos-animate {\n    transition-delay: 0.6s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"650\"],\nbody[data-aos-duration=\"650\"] [data-aos] {\n    transition-duration: 0.65s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"650\"],\nbody[data-aos-delay=\"650\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"650\"].aos-animate,\nbody[data-aos-delay=\"650\"] [data-aos].aos-animate {\n    transition-delay: 0.65s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"700\"],\nbody[data-aos-duration=\"700\"] [data-aos] {\n    transition-duration: 0.7s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"700\"],\nbody[data-aos-delay=\"700\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"700\"].aos-animate,\nbody[data-aos-delay=\"700\"] [data-aos].aos-animate {\n    transition-delay: 0.7s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"750\"],\nbody[data-aos-duration=\"750\"] [data-aos] {\n    transition-duration: 0.75s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"750\"],\nbody[data-aos-delay=\"750\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"750\"].aos-animate,\nbody[data-aos-delay=\"750\"] [data-aos].aos-animate {\n    transition-delay: 0.75s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"800\"],\nbody[data-aos-duration=\"800\"] [data-aos] {\n    transition-duration: 0.8s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"800\"],\nbody[data-aos-delay=\"800\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"800\"].aos-animate,\nbody[data-aos-delay=\"800\"] [data-aos].aos-animate {\n    transition-delay: 0.8s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"850\"],\nbody[data-aos-duration=\"850\"] [data-aos] {\n    transition-duration: 0.85s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"850\"],\nbody[data-aos-delay=\"850\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"850\"].aos-animate,\nbody[data-aos-delay=\"850\"] [data-aos].aos-animate {\n    transition-delay: 0.85s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"900\"],\nbody[data-aos-duration=\"900\"] [data-aos] {\n    transition-duration: 0.9s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"900\"],\nbody[data-aos-delay=\"900\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"900\"].aos-animate,\nbody[data-aos-delay=\"900\"] [data-aos].aos-animate {\n    transition-delay: 0.9s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"950\"],\nbody[data-aos-duration=\"950\"] [data-aos] {\n    transition-duration: 0.95s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"950\"],\nbody[data-aos-delay=\"950\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"950\"].aos-animate,\nbody[data-aos-delay=\"950\"] [data-aos].aos-animate {\n    transition-delay: 0.95s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1000\"],\nbody[data-aos-duration=\"1000\"] [data-aos] {\n    transition-duration: 1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1000\"],\nbody[data-aos-delay=\"1000\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1000\"].aos-animate,\nbody[data-aos-delay=\"1000\"] [data-aos].aos-animate {\n    transition-delay: 1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1050\"],\nbody[data-aos-duration=\"1050\"] [data-aos] {\n    transition-duration: 1.05s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1050\"],\nbody[data-aos-delay=\"1050\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1050\"].aos-animate,\nbody[data-aos-delay=\"1050\"] [data-aos].aos-animate {\n    transition-delay: 1.05s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1100\"],\nbody[data-aos-duration=\"1100\"] [data-aos] {\n    transition-duration: 1.1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1100\"],\nbody[data-aos-delay=\"1100\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1100\"].aos-animate,\nbody[data-aos-delay=\"1100\"] [data-aos].aos-animate {\n    transition-delay: 1.1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1150\"],\nbody[data-aos-duration=\"1150\"] [data-aos] {\n    transition-duration: 1.15s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1150\"],\nbody[data-aos-delay=\"1150\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1150\"].aos-animate,\nbody[data-aos-delay=\"1150\"] [data-aos].aos-animate {\n    transition-delay: 1.15s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1200\"],\nbody[data-aos-duration=\"1200\"] [data-aos] {\n    transition-duration: 1.2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1200\"],\nbody[data-aos-delay=\"1200\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1200\"].aos-animate,\nbody[data-aos-delay=\"1200\"] [data-aos].aos-animate {\n    transition-delay: 1.2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1250\"],\nbody[data-aos-duration=\"1250\"] [data-aos] {\n    transition-duration: 1.25s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1250\"],\nbody[data-aos-delay=\"1250\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1250\"].aos-animate,\nbody[data-aos-delay=\"1250\"] [data-aos].aos-animate {\n    transition-delay: 1.25s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1300\"],\nbody[data-aos-duration=\"1300\"] [data-aos] {\n    transition-duration: 1.3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1300\"],\nbody[data-aos-delay=\"1300\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1300\"].aos-animate,\nbody[data-aos-delay=\"1300\"] [data-aos].aos-animate {\n    transition-delay: 1.3s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1350\"],\nbody[data-aos-duration=\"1350\"] [data-aos] {\n    transition-duration: 1.35s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1350\"],\nbody[data-aos-delay=\"1350\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1350\"].aos-animate,\nbody[data-aos-delay=\"1350\"] [data-aos].aos-animate {\n    transition-delay: 1.35s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1400\"],\nbody[data-aos-duration=\"1400\"] [data-aos] {\n    transition-duration: 1.4s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1400\"],\nbody[data-aos-delay=\"1400\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1400\"].aos-animate,\nbody[data-aos-delay=\"1400\"] [data-aos].aos-animate {\n    transition-delay: 1.4s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1450\"],\nbody[data-aos-duration=\"1450\"] [data-aos] {\n    transition-duration: 1.45s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1450\"],\nbody[data-aos-delay=\"1450\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1450\"].aos-animate,\nbody[data-aos-delay=\"1450\"] [data-aos].aos-animate {\n    transition-delay: 1.45s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1500\"],\nbody[data-aos-duration=\"1500\"] [data-aos] {\n    transition-duration: 1.5s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1500\"],\nbody[data-aos-delay=\"1500\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1500\"].aos-animate,\nbody[data-aos-delay=\"1500\"] [data-aos].aos-animate {\n    transition-delay: 1.5s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1550\"],\nbody[data-aos-duration=\"1550\"] [data-aos] {\n    transition-duration: 1.55s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1550\"],\nbody[data-aos-delay=\"1550\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1550\"].aos-animate,\nbody[data-aos-delay=\"1550\"] [data-aos].aos-animate {\n    transition-delay: 1.55s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1600\"],\nbody[data-aos-duration=\"1600\"] [data-aos] {\n    transition-duration: 1.6s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1600\"],\nbody[data-aos-delay=\"1600\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1600\"].aos-animate,\nbody[data-aos-delay=\"1600\"] [data-aos].aos-animate {\n    transition-delay: 1.6s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1650\"],\nbody[data-aos-duration=\"1650\"] [data-aos] {\n    transition-duration: 1.65s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1650\"],\nbody[data-aos-delay=\"1650\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1650\"].aos-animate,\nbody[data-aos-delay=\"1650\"] [data-aos].aos-animate {\n    transition-delay: 1.65s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1700\"],\nbody[data-aos-duration=\"1700\"] [data-aos] {\n    transition-duration: 1.7s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1700\"],\nbody[data-aos-delay=\"1700\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1700\"].aos-animate,\nbody[data-aos-delay=\"1700\"] [data-aos].aos-animate {\n    transition-delay: 1.7s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1750\"],\nbody[data-aos-duration=\"1750\"] [data-aos] {\n    transition-duration: 1.75s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1750\"],\nbody[data-aos-delay=\"1750\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1750\"].aos-animate,\nbody[data-aos-delay=\"1750\"] [data-aos].aos-animate {\n    transition-delay: 1.75s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1800\"],\nbody[data-aos-duration=\"1800\"] [data-aos] {\n    transition-duration: 1.8s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1800\"],\nbody[data-aos-delay=\"1800\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1800\"].aos-animate,\nbody[data-aos-delay=\"1800\"] [data-aos].aos-animate {\n    transition-delay: 1.8s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1850\"],\nbody[data-aos-duration=\"1850\"] [data-aos] {\n    transition-duration: 1.85s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1850\"],\nbody[data-aos-delay=\"1850\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1850\"].aos-animate,\nbody[data-aos-delay=\"1850\"] [data-aos].aos-animate {\n    transition-delay: 1.85s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1900\"],\nbody[data-aos-duration=\"1900\"] [data-aos] {\n    transition-duration: 1.9s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1900\"],\nbody[data-aos-delay=\"1900\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1900\"].aos-animate,\nbody[data-aos-delay=\"1900\"] [data-aos].aos-animate {\n    transition-delay: 1.9s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1950\"],\nbody[data-aos-duration=\"1950\"] [data-aos] {\n    transition-duration: 1.95s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1950\"],\nbody[data-aos-delay=\"1950\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1950\"].aos-animate,\nbody[data-aos-delay=\"1950\"] [data-aos].aos-animate {\n    transition-delay: 1.95s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2000\"],\nbody[data-aos-duration=\"2000\"] [data-aos] {\n    transition-duration: 2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2000\"],\nbody[data-aos-delay=\"2000\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2000\"].aos-animate,\nbody[data-aos-delay=\"2000\"] [data-aos].aos-animate {\n    transition-delay: 2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2050\"],\nbody[data-aos-duration=\"2050\"] [data-aos] {\n    transition-duration: 2.05s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2050\"],\nbody[data-aos-delay=\"2050\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2050\"].aos-animate,\nbody[data-aos-delay=\"2050\"] [data-aos].aos-animate {\n    transition-delay: 2.05s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2100\"],\nbody[data-aos-duration=\"2100\"] [data-aos] {\n    transition-duration: 2.1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2100\"],\nbody[data-aos-delay=\"2100\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2100\"].aos-animate,\nbody[data-aos-delay=\"2100\"] [data-aos].aos-animate {\n    transition-delay: 2.1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2150\"],\nbody[data-aos-duration=\"2150\"] [data-aos] {\n    transition-duration: 2.15s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2150\"],\nbody[data-aos-delay=\"2150\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2150\"].aos-animate,\nbody[data-aos-delay=\"2150\"] [data-aos].aos-animate {\n    transition-delay: 2.15s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2200\"],\nbody[data-aos-duration=\"2200\"] [data-aos] {\n    transition-duration: 2.2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2200\"],\nbody[data-aos-delay=\"2200\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2200\"].aos-animate,\nbody[data-aos-delay=\"2200\"] [data-aos].aos-animate {\n    transition-delay: 2.2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2250\"],\nbody[data-aos-duration=\"2250\"] [data-aos] {\n    transition-duration: 2.25s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2250\"],\nbody[data-aos-delay=\"2250\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2250\"].aos-animate,\nbody[data-aos-delay=\"2250\"] [data-aos].aos-animate {\n    transition-delay: 2.25s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2300\"],\nbody[data-aos-duration=\"2300\"] [data-aos] {\n    transition-duration: 2.3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2300\"],\nbody[data-aos-delay=\"2300\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2300\"].aos-animate,\nbody[data-aos-delay=\"2300\"] [data-aos].aos-animate {\n    transition-delay: 2.3s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2350\"],\nbody[data-aos-duration=\"2350\"] [data-aos] {\n    transition-duration: 2.35s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2350\"],\nbody[data-aos-delay=\"2350\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2350\"].aos-animate,\nbody[data-aos-delay=\"2350\"] [data-aos].aos-animate {\n    transition-delay: 2.35s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2400\"],\nbody[data-aos-duration=\"2400\"] [data-aos] {\n    transition-duration: 2.4s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2400\"],\nbody[data-aos-delay=\"2400\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2400\"].aos-animate,\nbody[data-aos-delay=\"2400\"] [data-aos].aos-animate {\n    transition-delay: 2.4s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2450\"],\nbody[data-aos-duration=\"2450\"] [data-aos] {\n    transition-duration: 2.45s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2450\"],\nbody[data-aos-delay=\"2450\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2450\"].aos-animate,\nbody[data-aos-delay=\"2450\"] [data-aos].aos-animate {\n    transition-delay: 2.45s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2500\"],\nbody[data-aos-duration=\"2500\"] [data-aos] {\n    transition-duration: 2.5s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2500\"],\nbody[data-aos-delay=\"2500\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2500\"].aos-animate,\nbody[data-aos-delay=\"2500\"] [data-aos].aos-animate {\n    transition-delay: 2.5s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2550\"],\nbody[data-aos-duration=\"2550\"] [data-aos] {\n    transition-duration: 2.55s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2550\"],\nbody[data-aos-delay=\"2550\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2550\"].aos-animate,\nbody[data-aos-delay=\"2550\"] [data-aos].aos-animate {\n    transition-delay: 2.55s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2600\"],\nbody[data-aos-duration=\"2600\"] [data-aos] {\n    transition-duration: 2.6s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2600\"],\nbody[data-aos-delay=\"2600\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2600\"].aos-animate,\nbody[data-aos-delay=\"2600\"] [data-aos].aos-animate {\n    transition-delay: 2.6s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2650\"],\nbody[data-aos-duration=\"2650\"] [data-aos] {\n    transition-duration: 2.65s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2650\"],\nbody[data-aos-delay=\"2650\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2650\"].aos-animate,\nbody[data-aos-delay=\"2650\"] [data-aos].aos-animate {\n    transition-delay: 2.65s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2700\"],\nbody[data-aos-duration=\"2700\"] [data-aos] {\n    transition-duration: 2.7s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2700\"],\nbody[data-aos-delay=\"2700\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2700\"].aos-animate,\nbody[data-aos-delay=\"2700\"] [data-aos].aos-animate {\n    transition-delay: 2.7s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2750\"],\nbody[data-aos-duration=\"2750\"] [data-aos] {\n    transition-duration: 2.75s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2750\"],\nbody[data-aos-delay=\"2750\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2750\"].aos-animate,\nbody[data-aos-delay=\"2750\"] [data-aos].aos-animate {\n    transition-delay: 2.75s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2800\"],\nbody[data-aos-duration=\"2800\"] [data-aos] {\n    transition-duration: 2.8s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2800\"],\nbody[data-aos-delay=\"2800\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2800\"].aos-animate,\nbody[data-aos-delay=\"2800\"] [data-aos].aos-animate {\n    transition-delay: 2.8s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2850\"],\nbody[data-aos-duration=\"2850\"] [data-aos] {\n    transition-duration: 2.85s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2850\"],\nbody[data-aos-delay=\"2850\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2850\"].aos-animate,\nbody[data-aos-delay=\"2850\"] [data-aos].aos-animate {\n    transition-delay: 2.85s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2900\"],\nbody[data-aos-duration=\"2900\"] [data-aos] {\n    transition-duration: 2.9s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2900\"],\nbody[data-aos-delay=\"2900\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2900\"].aos-animate,\nbody[data-aos-delay=\"2900\"] [data-aos].aos-animate {\n    transition-delay: 2.9s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2950\"],\nbody[data-aos-duration=\"2950\"] [data-aos] {\n    transition-duration: 2.95s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2950\"],\nbody[data-aos-delay=\"2950\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2950\"].aos-animate,\nbody[data-aos-delay=\"2950\"] [data-aos].aos-animate {\n    transition-delay: 2.95s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"3000\"],\nbody[data-aos-duration=\"3000\"] [data-aos] {\n    transition-duration: 3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"3000\"],\nbody[data-aos-delay=\"3000\"] [data-aos] {\n    transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"3000\"].aos-animate,\nbody[data-aos-delay=\"3000\"] [data-aos].aos-animate {\n    transition-delay: 3s;\n}\n\n[data-aos][data-aos][data-aos-easing=\"linear\"],\nbody[data-aos-easing=\"linear\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.25, 0.25, 0.75, 0.75);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease\"],\nbody[data-aos-easing=\"ease\"] [data-aos] {\n    transition-timing-function: ease;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in\"],\nbody[data-aos-easing=\"ease-in\"] [data-aos] {\n    transition-timing-function: ease-in;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out\"],\nbody[data-aos-easing=\"ease-out\"] [data-aos] {\n    transition-timing-function: ease-out;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out\"],\nbody[data-aos-easing=\"ease-in-out\"] [data-aos] {\n    transition-timing-function: ease-in-out;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-back\"],\nbody[data-aos-easing=\"ease-in-back\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-back\"],\nbody[data-aos-easing=\"ease-out-back\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-back\"],\nbody[data-aos-easing=\"ease-in-out-back\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-sine\"],\nbody[data-aos-easing=\"ease-in-sine\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-sine\"],\nbody[data-aos-easing=\"ease-out-sine\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-sine\"],\nbody[data-aos-easing=\"ease-in-out-sine\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-quad\"],\nbody[data-aos-easing=\"ease-in-quad\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-quad\"],\nbody[data-aos-easing=\"ease-out-quad\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-quad\"],\nbody[data-aos-easing=\"ease-in-out-quad\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-cubic\"],\nbody[data-aos-easing=\"ease-in-cubic\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-cubic\"],\nbody[data-aos-easing=\"ease-out-cubic\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-cubic\"],\nbody[data-aos-easing=\"ease-in-out-cubic\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-quart\"],\nbody[data-aos-easing=\"ease-in-quart\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-quart\"],\nbody[data-aos-easing=\"ease-out-quart\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-quart\"],\nbody[data-aos-easing=\"ease-in-out-quart\"] [data-aos] {\n    transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n[data-aos^=\"fade\"][data-aos^=\"fade\"] {\n    opacity: 0;\n    transition-property: opacity, transform;\n\n    &.aos-animate {\n        opacity: 1;\n        transform: translateZ(0);\n    }\n}\n\n[data-aos=\"fade-up\"] {\n    transform: translate3d(0, 100px, 0);\n}\n\n[data-aos=\"fade-down\"] {\n    transform: translate3d(0, -100px, 0);\n}\n\n[data-aos=\"fade-right\"] {\n    transform: translate3d(-100px, 0, 0);\n}\n\n[data-aos=\"fade-left\"] {\n    transform: translate3d(100px, 0, 0);\n}\n\n[data-aos=\"fade-up-right\"] {\n    transform: translate3d(-100px, 100px, 0);\n}\n\n[data-aos=\"fade-up-left\"] {\n    transform: translate3d(100px, 100px, 0);\n}\n\n[data-aos=\"fade-down-right\"] {\n    transform: translate3d(-100px, -100px, 0);\n}\n\n[data-aos=\"fade-down-left\"] {\n    transform: translate3d(100px, -100px, 0);\n}\n\n[data-aos^=\"zoom\"][data-aos^=\"zoom\"] {\n    opacity: 0;\n    transition-property: opacity, transform;\n\n    &.aos-animate {\n        opacity: 1;\n        transform: translateZ(0) scale(1);\n    }\n}\n\n[data-aos=\"zoom-in\"] {\n    transform: scale(0.6);\n}\n\n[data-aos=\"zoom-in-up\"] {\n    transform: translate3d(0, 100px, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-in-down\"] {\n    transform: translate3d(0, -100px, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-in-right\"] {\n    transform: translate3d(-100px, 0, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-in-left\"] {\n    transform: translate3d(100px, 0, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-out\"] {\n    transform: scale(1.2);\n}\n\n[data-aos=\"zoom-out-up\"] {\n    transform: translate3d(0, 100px, 0) scale(1.2);\n}\n\n[data-aos=\"zoom-out-down\"] {\n    transform: translate3d(0, -100px, 0) scale(1.2);\n}\n\n[data-aos=\"zoom-out-right\"] {\n    transform: translate3d(-100px, 0, 0) scale(1.2);\n}\n\n[data-aos=\"zoom-out-left\"] {\n    transform: translate3d(100px, 0, 0) scale(1.2);\n}\n\n[data-aos^=\"slide\"][data-aos^=\"slide\"] {\n    transition-property: transform;\n\n    &.aos-animate {\n        transform: translateZ(0);\n    }\n}\n\n[data-aos=\"slide-up\"] {\n    transform: translate3d(0, 100%, 0);\n}\n\n[data-aos=\"slide-down\"] {\n    transform: translate3d(0, -100%, 0);\n}\n\n[data-aos=\"slide-right\"] {\n    transform: translate3d(-100%, 0, 0);\n}\n\n[data-aos=\"slide-left\"] {\n    transform: translate3d(100%, 0, 0);\n}\n\n[data-aos^=\"flip\"][data-aos^=\"flip\"] {\n    backface-visibility: hidden;\n    transition-property: transform;\n}\n\n[data-aos=\"flip-left\"] {\n    transform: perspective(2500px) rotateY(-100deg);\n\n    &.aos-animate {\n        transform: perspective(2500px) rotateY(0);\n    }\n}\n\n[data-aos=\"flip-right\"] {\n    transform: perspective(2500px) rotateY(100deg);\n\n    &.aos-animate {\n        transform: perspective(2500px) rotateY(0);\n    }\n}\n\n[data-aos=\"flip-up\"] {\n    transform: perspective(2500px) rotateX(-100deg);\n\n    &.aos-animate {\n        transform: perspective(2500px) rotateX(0);\n    }\n}\n\n[data-aos=\"flip-down\"] {\n    transform: perspective(2500px) rotateX(100deg);\n\n    &.aos-animate {\n        transform: perspective(2500px) rotateX(0);\n    }\n}\n","//\n// sidenav.scss\n// Theme components\n//\n\n.sidenav {\n  @include media-breakpoint-up(lg) {\n    position: fixed;\n    top: 7rem;\n    height: calc(100vh - 7rem);\n    overflow: auto;\n  }\n}\n\n.sidenav-left {\n  @include media-breakpoint-up(lg) {\n    left: 0;\n  }\n}\n\n.sidenav-right {\n  @include media-breakpoint-up(lg) {\n    right: 0;\n  }\n}","// Footer\n.footer {\n    .cta-content {\n        position: relative;\n        top: -90px;\n    }\n    .footer-content {\n        position: relative;\n        z-index: 1;\n    }\n    .footer-social-icon {\n        .footer-icon-bg {\n            background: rgba($white, 0.08);\n            display: inline-block;\n            height: 40px;\n            width: 40px;\n            line-height: 40px;\n            text-align: center;\n            border-radius: 50%;\n            transition: all 0.5s;\n            .footer-icon {\n                height: 18px;\n                width: 18px;\n                strokewidth: 1.5px;\n                color: $white;\n            }\n            &:hover {\n                background: rgba($white, 0.3);\n                box-shadow: 0 0 0 5px rgba($white, 0.1);\n            }\n        }\n    }\n    .footer-submenu {\n        li {\n            margin: 14px 0;\n            .footer-item {\n                color: lighten($gray-600, 12%);\n                font-size: 14px;\n                transition: all 0.3s ease 0s;\n                &:hover {\n                    color: $primary;\n                    padding-left: 6px;\n                }\n            }\n        }\n    }\n    .footer-bg-bottom {\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        opacity: 0.03;\n    }\n}\n","// icon size\n.icon {\n    position: relative;\n    width: $icon-size-base;\n    height: $icon-size-base;\n\n\n    &.icon-with-bg {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    >svg {\n        width: $icon-size-base;\n        height: $icon-size-base;\n    }\n}\n\n@each $size,\n$value in $icon-font-sizes {\n    .icon-#{$size} {\n\n        &.feather {\n            width: $value * 0.8;\n            height: $value * 0.8;\n        }\n\n        >svg {\n            width: $value;\n            height: $value;\n        }\n    }\n}\n\n// fill icon\n.icon[class*=\"text-\"]>svg [fill]:not([fill=\"none\"]) {\n    fill: currentColor !important;\n}\n\n\n\n// Icons - colors\n.icon-dual {\n    color: $gray-600;\n    fill: rgba($gray-600, 0.12);\n}\n\n@each $color,\n$value in $theme-colors {\n    .icon-dual-#{$color} {\n        color: $value;\n        fill: rgba($value, 0.16);\n\n        >svg {\n            color: $value;\n            fill: rgba($value, 0.16);\n        }\n    }\n\n    .icon-fill-#{$color} {\n        fill: #{$value};\n\n        >svg {\n            fill: #{$value};\n        }\n    }\n}\n\n// arrows icons\n.icon-left-arrow,\n.icon-right-arrow {\n\n    @each $size,\n    $value in $icon-font-sizes {\n        &.icon-#{$size} {\n            width: $value;\n            height: $value;\n        }\n    }\n\n    display: inline-block;\n    vertical-align: middle;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icon-left-arrow {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='1em' height='1em' viewBox='0 0 16 16' class='bi bi-arrow-left' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' d='M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z'/%3E%3Cpath fillRule='evenodd' d='M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z'/%3E%3C/svg%3E\");\n}\n\n.icon-right-arrow {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='1em' height='1em' viewBox='0 0 16 16' class='bi bi-arrow-right' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' d='M10.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L12.793 8l-2.647-2.646a.5.5 0 0 1 0-.708z'/%3E%3Cpath fillRule='evenodd' d='M2 8a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8z'/%3E%3C/svg%3E\");\n}","//\n// avatar.scss (avatar thumbnail sizes)\n//\n.avatar-xs {\n  height: 2rem;\n  width: 2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  background-color: $primary;\n  color: $white;\n  display: flex;\n  font-weight: $font-weight-semibold;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n.avatar-group {\n  padding-left: 12px;\n  .avatar-group-item {\n    margin: 0 0 10px -12px;\n    display: inline-block;\n  }\n}\n\n\n.avatar-border {\n  box-shadow: $box-shadow !important;\n  border: 2px solid $white !important;\n}",".ribbon {\n    position: absolute;\n    padding-left: 0.5rem;\n    padding-right: 1.4rem;\n    clip-path: polygon(100% 0, 90% 50%, 100% 100%, 0 100%, 0 50%, 0 0);\n    top: 1rem;\n    left: 0px;\n    color: $white;\n    font-size: 0.8125rem;\n    line-height: 1.5rem;\n    font-weight: $font-weight-bold;\n    box-shadow: $box-shadow-lg;\n    border-bottom-right-radius: $border-radius-sm;\n    border-top-right-radius: $border-radius-sm;\n}\n\n@each $color,\n$value in $theme-colors {\n    .ribbon-#{$color} {\n        background: #{$value};\n\n        &:before {\n            border-color: darken($value, 5%);\n        }\n    }\n}\n\n.ribbon2 {\n    padding: 2px 60px;\n    transform: rotate(45deg);\n    position: absolute;\n    top: 16px;\n    right: -56px;\n}\n\n@each $color,\n$value in $theme-colors {\n    .ribbon2-#{$color} {\n        background: #{$value};\n\n        &:before {\n            border-color: darken($value, 5%);\n        }\n    }\n}",".header-1 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgba($primary, 0.07) 0%, rgba($primary, 0.05) 100%) no-repeat left center;\n        background-size: calc(1240px + (100vw - 1240px)/ 2) 100%;\n        transform: skewY(-6deg);\n        transform-origin: top left;\n    }\n\n    @media (max-width: 768px) {\n        &::before {\n            background-size: 100% 100%;\n        }\n    }\n}\n\n.header-2 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgb(255, 255, 255) 0%, rgba($warning, 0.05) 100%) no-repeat left center;\n        background-size: calc(1240px + (100vw - 1240px)/ 2) 100%;\n        transform: skewY(3deg);\n        transform-origin: top left;\n    }\n\n    &.primary {\n        padding-bottom: 5rem;\n        &::before {\n            top: -6rem;\n            background: linear-gradient($gray-100 0%, $gray-50 100%) no-repeat left center;\n            background-size: calc(1240px + (100vw - 1240px)/ 2) 100%;\n        }\n    }\n\n    @media (max-width: 768px) {\n        &::before {\n            background-size: 100% 100%;\n        }\n    }\n}\n\n\n.header-3 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgba($primary, 0.07) 0%, rgba($primary, 0.05) 100%) no-repeat right center;\n        // background-size: calc(1240px + (100vw - 1240px)/ 2) 100%;\n    }\n\n    @media (max-width: 768px) {\n        &::before {\n            background-size: 100% 100%;\n        }\n    }\n}\n\n.header-4 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        width: calc(100% - 60px);\n        height: 100%;\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgba($warning, 0.05) 0%, rgba($warning, 0.07) 100%) no-repeat left center;\n    }\n}\n\n.header-5 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgba($orange, 0.05) 0%, rgba($orange, 0.07) 100%) no-repeat left center;\n    }\n\n    @media (max-width: 768px) {\n        &::before {\n            background-size: 100% 100%;\n        }\n    }\n}\n\n.header-6 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgba($orange, 0.075) 0%, rgba($warning, 0.1) 100%) no-repeat left center;\n    }\n}\n\n.header-7 {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        display: block;\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: -1;\n        bottom: 0;\n        background: linear-gradient(rgba($gray-100, 0.25) 0%, rgba($gray-100, 0.4) 100%) no-repeat right center;\n    }\n\n    .overlay {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        background: rgba($gray-900, 0.25);\n    }\n}","\n// title\n\n.hero-title {\n    font-size: 3rem;\n    line-height: 1.3;\n    font-weight: $font-weight-semibold;\n\n    @media (max-width: 768px) {\n        font-size: 2.6rem;\n        line-height: 1.1;\n    }\n    @media (max-width: 576px) {\n        font-size: 2rem !important;\n    }\n}\n\n// Hero 1\n.hero-1 {\n    position: relative;\n\n    .slider {\n        position: absolute;\n        width: 320px;\n        height: 240px;\n        z-index: 10;\n        bottom: 1rem;\n        left: -15rem;\n\n        .swiper-initialized {\n            z-index: 100 !important;\n            height: 100%;\n            width: 100%;\n\n            .swiper-slide {\n                .swiper-slide-content {\n                    max-width: 280px;\n                    text-align: left;\n                    padding-top: 2rem;\n                    position: relative;\n                }\n            }\n        }\n    }\n\n    .hero-container {\n        position: relative;\n\n        .hero-img {\n            position: relative;\n\n            img {\n                position: relative;\n                z-index: 2;\n            }\n\n            &::before {\n                content: \"\";\n                background: url('/assets/images/pattern/dot3.svg');\n                width: 6rem;\n                height: 6rem;\n                position: absolute;\n                bottom: 4rem;\n                left: 0rem;\n                z-index: 0;\n            }\n    \n            &::after {\n                content: \"\";\n                background: url('/assets/images/pattern/dot3.svg');\n                width: 8rem;\n                height: 8rem;\n                position: absolute;\n                top: 0rem;\n                right: 0rem;\n                z-index: 0;\n            }\n        }\n\n        .quote {\n            position: relative;\n\n            &::before {\n                font-size: 6rem;\n                line-height: 0rem;\n                color: rgba($danger, 0.2);\n                z-index: 0;\n                content: \"\\201D\";\n                position: absolute;\n                font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n                position: absolute;\n                bottom: 0;\n                right: 0;\n            }\n        }\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 22%;\n        z-index: -2;\n        background: linear-gradient($gray-100 0%, $gray-50 100%);\n    }\n\n    @media (max-width: 768px) {\n        .slider {\n            display: none;\n        }\n\n        .hero-container {\n\n            &::before,\n            &::after {\n                display: none;\n            }\n\n            .action-buttons {\n                justify-content: center !important;\n            }\n        }\n    }\n}\n\n\n// hero-2\n.hero-2 {\n    height: $hero-height;\n\n    @media (max-width: 1024px) {\n        height: $hero-height;\n    }\n\n    @media (min-width:769px) and (max-width: 1024px) {\n        height: 48vh;\n    }\n\n    .slider {\n        position: relative;\n\n        .form-container {\n            position: absolute;\n            top: 0rem;\n            width: 100%;\n            height: auto;\n            z-index: 2;\n            left: 0;\n            right: 0;\n        }\n\n        .navigations {\n            .swiper-custom-prev,\n            .swiper-custom-next {\n                padding: .15rem .3rem;\n                line-height: 1.25;\n                border-radius: 0.15rem;\n            }\n        }\n\n        .slider-item {\n            position: relative;\n            height: 520px;\n            background-size: cover;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .hero-2 {\n        .slider {\n            position: relative;\n    \n            .form-container {\n                position: absolute;\n                top: -1rem;\n                width: 100%;\n                height: auto;\n                z-index: 2;\n                left: 0;\n                right: 0;\n            }\n    \n            .navigations {\n                .swiper-custom-prev,\n                .swiper-custom-next {\n                    padding: .15rem .3rem;\n                    line-height: 1.25;\n                    border-radius: 0.15rem;\n                }\n            }\n    \n            .slider-item {\n                position: relative;\n                height: 240px;\n                background-size: cover;\n            }\n        }\n    }\n}\n\n@media (max-width: 1024px) {\n    .hero-2 {\n        height: auto;\n        padding: 50px 0 0;\n    }\n}\n\n// moving objects\n.hero-with-shapes {\n    @keyframes rotating {\n        0%{\n            transform: rotate(0deg);\n            top: 10%;\n            left: 5%;\n        }\n        100%{\n            transform: rotate(360deg);\n            top: 60%;\n            left: 15%;\n        }\n    }\n\n    @keyframes rotating2 {\n        0%{\n            transform: rotate(0deg);\n            bottom: 10%;\n            right: 10%;\n        }\n        100%{\n            transform: rotate(360deg);\n            bottom: 80%;\n            right: 30%;\n        }\n    }\n\n    @keyframes rotating3 {\n        0%{\n            transform: rotate(0deg);\n            bottom: 0%;\n            right: 65%;\n        }\n        100%{\n            transform: rotate(360deg);\n            bottom: 50%;\n            right: 35%;\n        }\n    }\n\n    .shape1 {\n        position: absolute;\n        top: 5%;\n        left: 5%;\n        width: 7rem;\n        height: 7rem;\n        background: url('/assets/images/shapes/rounded-square2.svg');\n        animation: rotating alternate ease-in-out infinite 6s;\n    }\n\n    .shape2 {\n        position: absolute;\n        bottom: 20%;\n        right: 10%;\n        width: 7rem;\n        height: 7rem;\n        background: url('/assets/images/shapes/rounded-square2.svg');\n        animation: rotating2 alternate ease-in-out infinite 6s;\n    }\n\n    .shape3 {\n        position: absolute;\n        bottom: 0%;\n        right: 65%;\n        width: 7rem;\n        height: 7rem;\n        background: url('/assets/images/shapes/rounded-square2.svg');\n        animation: rotating3 alternate ease-in-out infinite 6s;\n    }\n}\n\n// hero-3\n.hero-3 {\n    \n    .shape1 {\n        position: absolute;\n        bottom: 5%;\n        left: 5%;\n        width: 7rem;\n        height: 7rem;\n        background: url('/assets/images/shapes/rounded-square.svg');\n    }\n\n    .shape2 {\n        position: absolute;\n        top: 40%;\n        right: 10%;\n        width: 7rem;\n        height: 7rem;\n        background: url('/assets/images/shapes/rounded-square2.svg');\n    }\n\n    .shape3 {\n        position: absolute;\n        top: 5%;\n        right: 50%;\n        width: 7rem;\n        height: 7rem;\n        background: url('/assets/images/shapes/rounded-square2.svg');\n    }\n\n    .img-container {\n        position: relative;\n\n        img {\n            position: relative;\n            z-index: 1;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .hero-3 {\n        .img-container {\n            margin-top: 1rem;\n\n            &::before {\n                left: 0;\n                top: 0;\n                height: 100%;\n            }\n        }\n    }\n}\n\n\n\n// hero -5\n.hero-5 {\n    height: 65vh;\n\n    .links-social {\n        position: absolute;\n        top: 10%;\n        right: 0px;\n        writing-mode: vertical-rl;\n        text-orientation: mixed;\n    }\n}\n\n@media (max-width: 576px) {\n    .hero-5 {\n        .shape.bottom {\n            bottom: -5px;\n        }\n    }\n}\n\n@media (max-width: 1024px) {\n    .hero-5 {\n        height: auto;\n    }\n}\n\n\n// hero-6\n.hero-6 {\n    position: relative;\n    \n    &::before {\n        content: \"\";\n        position: absolute;\n        top: -12rem;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: -2;\n        background: linear-gradient(rgba($orange, 0.02) 0,rgba($orange, 0.03) 100%);\n        transform: skewY(3deg);\n        transform-origin: top left;\n    }\n\n    .shapes {\n        position: relative;\n        height: 100%;\n\n        .shape1 {\n            position: absolute;\n            bottom: 1%;\n            left: 2%;\n            width: 2rem;\n            height: 2rem;\n            border-radius: 100%;\n            border: 5px solid rgba($danger, 0.3);\n            background: transparent;\n        }\n\n        .shape2 {\n            position: absolute;\n            top: 50%;\n            right: 20%;\n            width: 2rem;\n            height: 2rem;\n            border-radius: 100%;\n            border: 5px solid rgba($warning, 0.3);\n            background: transparent;\n        }\n    }\n\n    .video-container {\n        .video-item {\n            padding: 1rem 0 1rem 1rem;\n            position: relative;\n            width: 100%;\n\n            img {\n                position: relative;\n                z-index: 2;\n                border-top-right-radius: 1.5rem;\n                border-bottom-left-radius: 1.5rem;\n            }\n\n            .video-overlay {\n                background: rgba($white, 0.1);\n                position: absolute;\n                top: 0;\n                bottom: 0;\n                right: 0;\n                left: 0;\n                z-index: 3;\n            }\n\n            &::before {\n                position: absolute;\n                width: calc(100% + -3rem);\n                height: calc(100% + -2rem);\n                top: 2rem;\n                content: \"\";\n                border: 2px dashed $orange;\n                z-index: 1;\n                left: 0rem;\n                border-bottom-left-radius: 2.15rem;\n                border-top-right-radius: 2.15rem;\n            }\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .hero-6 {\n        .hero-sub-title {\n            font-size: 14px !important;\n            text-align: left;\n        }\n\n        .video-container {\n            width: 100%;\n\n            .video-item {\n                width: 100%;\n                padding: 1rem 0 1rem 0rem;\n                &::before {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n\n\n// hero-7\n.hero-7 {\n    .hero-right {\n        .img-container {\n            position: relative;\n            padding: 0.6rem;\n            z-index: 1;\n            background: $white;\n            box-shadow: $box-shadow-lg;\n            border-radius: $border-radius-lg;\n            min-width: 150%;\n\n            img {\n                max-width: 100%;\n                position: relative;\n                z-index: 1;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot2.svg');\n            width: 8rem;\n            height: 8rem;\n            position: absolute;\n            bottom: -2.25rem;\n            left: -2.25rem;\n            z-index: 0;\n        }\n    }\n}\n\n@media (max-width: 1024px) {\n    .hero-7 {\n        .hero-right {\n            .img-container {\n                min-width: 100%;\n            }\n        }\n    }\n}\n\n// hero-9\n.hero-9 {\n    position: relative;\n\n    .hero-top {\n        position: relative;\n        // background: linear-gradient(rgba($orange, 0.05) 0%, rgba($orange, 0.07) 100%) no-repeat left center;\n        text-align: center;\n        overflow: hidden;\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot.svg');\n            position: absolute;\n            width: 4rem;\n            height: 4rem;\n            right: -1rem;\n            bottom: -1rem;\n            transform: rotate(45deg);\n        }\n    }\n\n    .hero-cta {\n        text-align: center;\n        padding: 0;\n        position: absolute;\n        display: block;\n        transform: translate3d(0,-50%,0);\n        left: 1rem;\n        right: 1rem;\n        margin: auto;\n        z-index: 5;\n\n        .btn-cta {\n            width: 18%;\n            text-transform: uppercase;\n            font-weight: $font-weight-semibold;\n            // font-family: $font-family-secondary;\n        }\n    }\n\n    .hero-bottom {\n        position: relative;\n\n        .hero-image {\n            height: 560px;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .hero-9 {\n        .hero-cta {    \n            .btn-cta {\n                width: 75%;\n            }\n        }\n\n        .hero-bottom {    \n            .hero-image {\n                height: 260px;\n            }\n        }\n    }\n}\n\n// hero-10\n.hero-10 {    \n    .img-container {\n        position: relative;\n        min-width: 140%;\n        margin-left: -40%;\n\n        img {\n            z-index: 1;\n            position: relative;\n        }\n    }\n\n    @media (max-width: 768px) {\n        .img-container {\n            min-width: 100%;\n            margin-left: 0;\n        }\n    }\n}\n\n\n// hero-11\n.hero-11 {\n    position: relative;\n\n    &::before {\n        background: linear-gradient($gray-200 0%, $gray-100 100%) no-repeat left center;\n        position: absolute;\n        top: 0;\n        bottom: 40%;\n        left: 0;\n        right: 0;\n        content: '';\n    }\n\n\n    .hero-content {\n        position: relative;\n    }\n\n    .slider-container {\n        position: relative;\n\n        .slider-container-body {\n            position: relative;\n            padding: 0.75rem;\n            z-index: 1;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 6rem;\n            height: 6rem;\n            position: absolute;\n            top: -2.5rem;\n            right: 4rem;\n            z-index: 0;\n        }\n    }\n\n    .swiper-slide-content {\n        position: relative;\n\n        .video-overlay {\n            background: rgba($white, 0.1);\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            right: 0;\n            left: 0;\n            z-index: 10;\n        }\n    }\n}\n\n// hero-12\n.hero-12 {\n    height: 640px;\n\n    .hero-image {\n        position: relative;\n\n        img {\n            position: relative;\n            z-index: 1;\n        }\n\n        &::before,\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot3.svg');\n            width: 8rem;\n            height: 8rem;\n            position: absolute;\n            z-index: 0;\n        }\n\n        &::before {\n            bottom: 2rem;\n            @media (max-width: 768px) {\n                top: 6rem;\n            }\n        }\n\n        &::after {\n            top: -2rem;\n            right: 8rem;\n        }\n    }\n\n    @media (max-width: 768px) {\n        .hero-image {\n            &::after {\n                display: none;\n            }\n        }\n    }\n}\n\n// hero-13\n.hero-13 {\n    .hero-right {\n        .slider-container {\n            position: relative;\n    \n            .slider-container-body {\n                position: relative;\n                padding: 0.5rem;\n                z-index: 1;\n            }\n    \n            &::after {\n                content: \"\";\n                background: url('/assets/images/pattern/dot3.svg');\n                width: 8rem;\n                height: 8rem;\n                position: absolute;\n                top: -3rem;\n                right: 3rem;\n                z-index: 0;\n            }\n        }\n    \n        .swiper-slide-content {\n            position: relative;\n    \n            .video-overlay {\n                background: rgba($white, 0.05);\n                position: absolute;\n                top: 0;\n                bottom: 0;\n                right: 0;\n                left: 0;\n                z-index: 10;\n            }\n        }\n\n        .img-container {\n            position: relative;\n            padding: 0.3rem;\n            z-index: 1;\n            background: $white;\n            box-shadow: $box-shadow-lg;\n            border-radius: $border-radius-lg;\n            min-width: 160%;\n        }\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot2.svg');\n            width: 6rem;\n            height: 6rem;\n            position: absolute;\n            bottom: -2rem;\n            left: -2rem;\n            z-index: 0;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 6rem;\n            height: 6rem;\n            position: absolute;\n            top: -2.5rem;\n            right: -6rem;\n            z-index: 0;\n            transform: rotate(45deg);\n            z-index: 0;\n        }\n    }\n}\n\n@media (max-width: 1024px) {\n    .hero-13 {\n        .hero-right {\n            .img-container {\n                min-width: 100%;\n            }\n            &::after {\n                right: 2rem;\n            }\n        }\n    }\n}\n","// feature 1\n.features-1 {\n    .img-content {\n        position: relative;\n\n        &::before {\n            content: \"\";\n            background: linear-gradient(rgba($orange, 0.1) 0, rgba($orange, 0.15) 100%);\n            width: 65%;\n            height: 60%;\n            position: absolute;\n            bottom: 3rem;\n            right: 5rem;\n            z-index: -1;\n            border-radius: 3rem;\n            transform: rotate(20deg);\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot4.svg');\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            top: -3rem;\n            right: 3rem;\n            z-index: -1;\n        }\n\n        .img-up {\n            max-width: 80%;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .features-1 {\n        .img-content {\n            .img-up {\n                max-width: 90%;\n            }\n        }\n    }\n}\n\n.features-2 {\n    .shapes {\n        position: relative;\n\n        .shape1 {\n            position: absolute;\n            top: 30%;\n            right: 3%;\n            background: lighten($primary, 10%);\n            height: 0.6rem;\n            width: 0.6rem;\n            border-radius: 100%;\n        }\n\n        .shape2 {\n            position: absolute;\n            bottom: 20%;\n            left: 3%;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 6px 10.4px 6px 0;\n            border-color: transparent lighten($success, 10%) transparent transparent;\n        }\n\n        .shape3 {\n            position: absolute;\n            bottom: 5%;\n            left: 5%;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 6px 10.4px 6px 0;\n            border-color: transparent lighten($danger, 10%) transparent transparent;\n        }\n\n        .shape4 {\n            position: absolute;\n            top: 35%;\n            right: 30%;\n            background: lighten($warning, 10%);\n            height: 0.6rem;\n            width: 0.6rem;\n            border-radius: 100%;\n        }\n\n        .shape5 {\n            position: absolute;\n            bottom: 5%;\n            right: 5%;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 6px 0 6px 10.4px;\n            border-color: transparent transparent transparent lighten($warning, 10%);\n        }\n\n        .shape6 {\n            position: absolute;\n            bottom: 40%;\n            left: 5%;\n            width: 10px;\n            height: 10px;\n            background: rgba(0, 0, 0, 0);\n            border-radius: 100%;\n            border: calc(12px/8) solid lighten($primary, 20%);\n            box-sizing: content-box\n        }\n    }\n}\n\n\n// features 3\n.features-3 {\n    .img-content {\n        position: relative;\n\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            top: -2rem;\n            left: -2rem;\n            z-index: -1;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot2.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            bottom: -2rem;\n            right: -2rem;\n            z-index: -1;\n        }\n    }\n\n    .img-content2 {\n        position: relative;\n\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            top: -2rem;\n            right: -2rem;\n            z-index: -1;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot2.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            bottom: -2rem;\n            left: -2rem;\n            z-index: -1;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .features-3 {\n        .img-content,\n        .img-content2 {\n            .img-up {\n                margin: 0 auto;\n                max-width: 90%;\n            }\n        }\n        .img-content {\n            &::after {\n                right: 0rem;\n            }\n            &::before {\n                left: 0rem;\n            }\n        }\n        .img-content2 {\n            &::after {\n                left: 0rem;\n            }\n            &::before {\n                right: 0rem;\n            }\n        }\n    }\n}\n\n\n// features 4\n.features-4 {\n    .img-content {\n        img {\n            border: 10px solid $white;\n        }\n\n        &:after {\n            content: \"\";\n            background: linear-gradient(rgba($success, 0.1) 0, rgba($success, 0.15) 100%);\n            position: absolute;\n            border-radius: 70% 30% 76% 24% / 68% 30% 73% 22%;\n            top: -20px;\n            bottom: -20px;\n            height: 120%;\n            width: 70%;\n            left: 0;\n            right: 0;\n            margin: auto;\n            z-index: -1;\n        }\n    }\n\n    .feature-content {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: -100px;\n    }\n}\n\n@media (max-width: 768px) {\n    .features-4 {\n        .feature-content {\n            position: relative;\n            top: 0;\n            transform: none;\n            left: 0;\n        }\n    }\n}\n\n// features -  5\n.features-5 {\n    .feature-item {\n        &:hover {\n            transition: box-shadow 0.25s ease-in-out 0.15s;\n            box-shadow: $box-shadow-lg !important;\n        }\n    }\n}\n\n// features -  6\n.features-6 {\n    .feature-item {\n        transition: $transition-base;\n        position: relative;\n\n        .overlay {\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            right: 0;\n            left: 0;\n            background: rgba($white, 0.5);\n            opacity: 0;\n        }\n\n        .btn-view {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            margin-right: -50%;\n            transform: translate(-50%, -50%);\n        }\n\n        &:hover {\n            box-shadow: $box-shadow !important;\n\n            .overlay {\n                opacity: 1;\n            }\n        }\n    }\n}\n\n// features - 7\n.features-7 {\n    .feature-item {\n        .number {\n            position: absolute;\n            top: 0;\n            z-index: -1;\n            opacity: 0.3;\n        }\n    }\n}\n\n// features-8\n.features-8 {\n    .feature-content {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        max-width: 400px;\n        z-index: 1;\n\n        .feature-text {\n            position: relative;\n            z-index: 1;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot2.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            bottom: -2rem;\n            left: -2rem;\n            z-index: -1;\n        }\n    }\n\n    .feature-img {\n        .overlay {\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            background: rgba($white, 0.25);\n            z-index: 0;\n        }\n\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            top: -2rem;\n            right: -2rem;\n            z-index: -1;\n        }\n\n        img {\n            position: relative;\n            z-index: -1;\n            width: 85%;\n        }\n    }\n\n    @media (max-width: 576px) {\n        .feature-content {\n            position: relative;\n            top: 0;\n            transform: none;\n            max-width: 100%;\n            &::after {\n                left: -0.5rem;\n            }\n        }\n        .feature-img {\n            img {\n                width: 100%;\n            }\n            &::before {\n                right: -0.5rem;\n            }\n        }\n    }\n}\n\n// features - 9\n.features-9 {\n    .feature-item {\n        transition: all 0.25s ease-in-out 0.15s;\n\n        .icon {\n            border-bottom-left-radius: 0.75rem !important;\n            border-top-right-radius: 0.75rem !important;\n            transition: all 0.25s ease-in-out 0.15s;\n        }\n\n        &:hover {\n            box-shadow: $box-shadow-lg !important;\n\n            .icon {\n                border-top-left-radius: 0.75rem !important;\n                border-bottom-right-radius: 0.75rem !important;\n                border-bottom-left-radius: 0 !important;\n                border-top-right-radius: 0 !important;\n            }\n        }\n    }\n}","// feature 1\n.testimonials-1 {\n\n    .slider {\n        position: relative;\n\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot3.svg');\n            width: 6rem;\n            height: 6rem;\n            position: absolute;\n            bottom: -2.5rem;\n            left: -2.5rem;\n            z-index: 0;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot3.svg');\n            width: 6rem;\n            height: 6rem;\n            position: absolute;\n            top: -2.5rem;\n            right: -2.5rem;\n            z-index: 0;\n            transform: rotate(90deg);\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .testimonials-1 {\n        .slider {\n            &::after {\n                display: none;\n            }\n        }\n    }\n}\n\n\n// testimonials-2\n.testimonials-2,\n.testimonials-3 {\n    .slider {\n        position: relative;\n\n\n        .swiper-slide {\n            .img-author {\n                max-height: 300px;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            bottom: -2.25rem;\n            left: -2.25rem;\n            z-index: 0;\n        }\n\n        &::after {\n            content: \"\";\n            background: url('/assets/images/pattern/dot5.svg');\n            width: 5rem;\n            height: 5rem;\n            position: absolute;\n            top: -2.25rem;\n            right: -2.25rem;\n            z-index: 0;\n        }\n\n        .testimonial-body {\n            padding: 2rem;\n        }\n\n        .quotation-mark {\n            font-weight: 700;\n            font-size: 6rem;\n            font-family: \"Times New Roman\", Georgia, Serif;\n            line-height: 0.7;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n\n    .testimonials-2,\n    .testimonials-3 {\n        .slider {\n            &::after {\n                display: none;\n            }\n        }\n    }\n}\n\n\n.testimonials-3 {\n    .slider {\n        &::before,\n        &::after {\n            background: none;\n        }\n    }\n}\n\n\n\n// testimonials-4\n.testimonials-4 {\n    .client-img {\n        background-size: cover;\n        background-repeat: no-repeat;\n    }\n    .quotation-mark {\n        font-weight: 700;\n        font-size: 8rem;\n        font-family: \"Times New Roman\", Georgia, Serif;\n        line-height: 0.7;\n    }\n    .navigations {\n        position: absolute;\n        right: 10px;\n        bottom: 25px;\n        z-index: 1;\n    }\n}",".code-block {\n    position: relative;\n    border: $border-width solid $border-color !important;\n    padding: $kbd-padding-y $kbd-padding-x;\n    background: $white;\n    border-radius: $border-radius-sm;\n    margin-bottom: 1rem;\n\n    h6 {\n        margin-top: 0px;\n    }\n\n    .prettyprint {\n        background: $gray-100;\n        border: none;\n        padding: $kbd-padding-y $kbd-padding-x;\n        margin-bottom: 0px;\n    }\n\n    .btn-copy-clipboard {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n    }\n}\n\n.doc-carousel {\n    .carousel-item {\n        height: 400px;\n    }\n\n    .carousel-item img {\n        height: 400px;\n        position: absolute;\n        object-fit:cover;\n        top: 0;\n        left: 0;\n    }\n}",".filter-menu {\n    .filter-menu-item {\n        display: inline-block;\n        font-family: $btn-font-family;\n        font-weight: $btn-font-weight;\n        color: $body-color;\n        text-align: center;\n        text-decoration: if($link-decoration==none, null, none);\n        white-space: $btn-white-space;\n        vertical-align: middle;\n        user-select: none;\n        background-color: transparent;\n        border: $btn-border-width solid transparent;\n        padding: $input-btn-padding-y-sm $input-btn-padding-x-sm;\n        line-height: $line-height-base;\n        border-radius: $border-radius-sm;\n        font-size: $input-btn-font-size-sm;\n        margin: 4px 2px;\n        // @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $input-btn-font-size-sm, $line-height-sm, $btn-border-radius-sm);\n\n        border-color: $gray-300;\n        transition: $btn-transition;\n\n        &.active {\n            color: $white !important;\n            background-color: $primary !important;\n            border-color: $primary !important;\n        }\n\n        &:focus,\n        &.focus {\n            outline: 0;\n            box-shadow: $btn-focus-box-shadow;\n        }\n\n        // Disabled comes first so active can properly restyle\n        &.disabled,\n        &:disabled {\n            opacity: $btn-disabled-opacity;\n            @include box-shadow(none);\n        }\n\n        &:not(:disabled):not(.disabled) {\n            // cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n            &:active,\n            &.active {\n                @include box-shadow($btn-active-box-shadow);\n\n                &:focus {\n                    @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n                }\n            }\n        }\n\n        &:hover,\n        &:focus {\n            background-color: $white;\n            box-shadow: 0 1px 3px rgba(60, 72, 88, 0.15), 0 2px 4px 2px rgba(60, 72, 88, 0.18);\n        }\n    }\n}\n\n.masonry-grid {\n    position: relative;\n    padding: 0;\n    margin: 0;\n    opacity: 0;\n    transition: height 0.3s ease-out, opacity 0.3s ease-out 0.3s;\n    [data-masonry-el] {\n        opacity: 0;\n        position: absolute;\n        top: 0;\n        left: 0;\n        transition: transform 0.3s ease-in-out;\n    }    \n}\n","//\n// gallery.scss\n//\n\n.filter-menu {\n    margin-bottom: 20px;\n\n    a {\n        transition: all 0.3s ease-out;\n        color: $dark;\n        border-radius: 3px;\n        padding: 5px 10px;\n        display: inline-block;\n        margin-bottom: 5px;\n        font-weight: $font-weight-medium;\n        font-family: $font-family-base;\n\n        &:hover {\n            background-color: rgba($primary, 0.15);\n            color: $primary;\n        }\n\n        &.active {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n}\n\n// Gallary Thumb\n.gal-box {\n    background-color: $card-bg;\n    border-radius: 3px;\n    box-shadow: $box-shadow;\n    margin-bottom: $grid-gutter-width;\n\n    .image-popup {\n        padding: 10px;\n        display: block;\n\n        img {\n            cursor: zoom-in;\n        }\n    }\n\n    .gall-info {\n        padding: 15px;\n        border-top: 1px solid $gray-200;\n        position: relative;\n\n        h4 {\n            display: block;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n\n        .gal-like-btn {\n            position: absolute;\n            right: 15px;\n            font-size: 22px;\n            top: 24px;\n        }\n    }\n}\n\n// light box\n.ReactModal__Body--open {\n    .ReactModalPortal {\n        > div {\n            z-index: 1031 !important;\n        }\n    }\n    .ril-toolbar {\n        align-items: center;\n        .ril-toolbar__item__child {\n            p {\n                margin-bottom: 0;\n                line-height: 2.6;\n            }\n        }\n    }\n}\n","#ppic {\n    // ===== periode chickin =====\n    .react-datepicker-wrapper {\n        display: none;\n    }\n    .dates {\n        display: flex;\n        align-items: stretch;\n        scrollbar-width: none;\n        &::-webkit-scrollbar {\n            display: none;\n        }\n        .range-date {\n            width: 100%;\n            padding: 8px 12px;\n            text-align: center;\n            border: 1px solid var(--grey3);\n            &:first-child {\n                border-radius: 8px 0 0 8px;\n            }\n            &:last-child {\n                border-radius: 0 8px 8px 0;\n            }\n        }\n    }\n\n    // ===== status flok =====\n    .card-flok {\n        gap: 20px;\n        .card {\n            width: 100%;\n            border: 1px solid var(--grey3);\n            .card-body {\n                padding: 16px 20px;\n            }\n        }\n    }\n\n    // ===== list planning =====\n    .link-to-plasma {\n        &:hover {\n            color: var(--teal7) !important;\n        }\n    }\n\n    // ===== pagination =====\n    .pagination {\n        margin: 0;\n        padding: 28px 0 24px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        button {\n            &:disabled {\n                color: var(--grey3) !important;\n                background: var(--grey1);\n                svg {\n                    color: var(--grey3) !important;\n                }\n            }\n        }\n        .page-item {\n            width: 40px;\n            height: 32px;\n            &.active {\n                .page-link {\n                    color: var(--primary);\n                    background-color: var(--teal1);\n                }\n            }\n            .page-link {\n                width: 100%;\n                height: 100%;\n                border: none;\n                display: flex;\n                font-size: 14px;\n                font-weight: 500;\n                padding: 4px 5px;\n                line-height: 18px;\n                border-radius: 4px;\n                align-items: center;\n                color: var(--grey6);\n                letter-spacing: -0.02em;\n                justify-content: center;\n                transition: all 0.3s ease-in-out;\n                &:hover {\n                    color: var(--primary);\n                    background-color: var(--teal1);\n                }\n            }\n        }\n    }\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    #ppic {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        // ===== periode chickin =====\n        .dates {\n            flex-direction: column;\n            .range-date {\n                &:first-child {\n                    border-radius: 0;\n                }\n                &:last-child {\n                    border-radius: 0;\n                }\n            }\n        }\n\n        // ===== status flok & estimasi card =====\n        .card-flok,\n        .estimasi-card {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n@media (min-width: 375px) and (max-width: 424px) {\n    #ppic {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        // ===== periode chickin =====\n        .dates {\n            flex-direction: column;\n            .range-date {\n                &:first-child {\n                    border-radius: 0;\n                }\n                &:last-child {\n                    border-radius: 0;\n                }\n            }\n        }\n\n        // ===== status flok & estimasi card =====\n        .card-flok,\n        .estimasi-card {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    #ppic {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        // ===== periode chickin =====\n        .dates {\n            flex-direction: column;\n            .range-date {\n                &:first-child {\n                    border-radius: 0;\n                }\n                &:last-child {\n                    border-radius: 0;\n                }\n            }\n        }\n\n        // ===== status flok & estimasi card =====\n        .card-flok,\n        .estimasi-card {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    #ppic {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        // ===== periode chickin =====\n        .dates {\n            flex-direction: column;\n            .range-date {\n                &:first-child {\n                    border-radius: 0;\n                }\n                &:last-child {\n                    border-radius: 0;\n                }\n            }\n        }\n\n        // ===== status flok & estimasi card =====\n        .card-flok,\n        .estimasi-card {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n    #ppic {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        // ===== periode chickin =====\n        .dates {\n            flex-direction: column;\n            .range-date {\n                &:first-child {\n                    border-radius: 0;\n                }\n                &:last-child {\n                    border-radius: 0;\n                }\n            }\n        }\n\n        // ===== status flok & estimasi card =====\n        .card-flok,\n        .estimasi-card {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n    #ppic {\n        // ===== status flok & estimasi card =====\n        .card-flok,\n        .estimasi-card {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n    #ppic {\n        // ===== container =====\n        .container {\n            margin: 0;\n            max-width: 100%;\n        }\n\n        // ===== status flok =====\n        .card-flok {\n            .subtitle4 {\n                font-size: 12px !important;\n            }\n        }\n\n        // ===== estimasi card =====\n        .estimasi-card {\n            .subtitle2 {\n                font-size: 16px !important;\n            }\n        }\n    }\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","#dashboard {\n    overflow: clip;\n\n    // ===== container =====\n    .container-responsive {\n        padding-top: 0 !important;\n    }\n\n    // ===== sticky =====\n    .sticky {\n        position: sticky;\n        top: 0;\n        z-index: 999;\n        background: var(--white);\n        box-shadow: 0px 4px 100px 25px #00000005;\n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 98px;\n            background: var(--white);\n            transition: all 0.1s ease-out;\n        }\n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            right: -100%;\n            width: 100%;\n            height: 98px;\n            background: var(--white);\n            transition: all 0.1s ease-out;\n        }\n    }\n\n    // ===== manuver =====\n    .manuver {\n        .rts___tabs___container {\n            padding: 0;\n            // border-bottom: 1px solid var(--grey2);\n            .rts___tabs {\n                padding: 0;\n                .rts___btn {\n                    margin: 0;\n                    border: none;\n                    box-shadow: none;\n                    border-radius: 0;\n                    background: none;\n                    padding: 8px 12px;\n                    transition: all 0.3s ease-in-out;\n                    border-bottom: 1px solid transparent;\n                    &:hover {\n                        color: var(--primary) !important;\n                        border-bottom: 1px solid var(--primary);\n                    }\n                    &.rts___tab___selected {\n                        border-radius: 0;\n                        color: var(--primary) !important;\n                        border-bottom: 1px solid var(--primary);\n                    }\n                }\n            }\n        }\n    }\n    // ===== checkbox manuver =====\n    .recharts-responsive-container {\n        .recharts-wrapper {\n            .recharts-legend-wrapper {\n                .custom-legend {\n                    .custom-checkbox {\n                        appearance: none;\n                        -webkit-appearance: none;\n                        width: 12px;\n                        height: 12px;\n                        position: relative;\n                        border-radius: 2px;\n                        cursor: pointer;\n                        &:checked {\n                            &::after {\n                                content: '';\n                                position: absolute;\n                                top: 0;\n                                left: 3px;\n                                width: 4px;\n                                height: 8px;\n                                border: solid var(--white);\n                                border-width: 0 2px 2px 0;\n                                transform: rotate(45deg);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    // ===== stok harian per unit =====\n    .accordion {\n        padding-bottom: 16px;\n        .accordion-item {\n            border: none;\n            .chevron {\n                display: flex;\n                cursor: pointer;\n                padding: 4px 8px;\n                border-radius: 6px;\n                align-items: center;\n                justify-content: center;\n                border: 1px solid var(--grey3);\n            }\n            .accordion-collapse {\n                .accordion-body {\n                    padding: 16px;\n                    border-radius: 12px;\n                    background: var(--blue1);\n                    border: 1px solid var(--blue6);\n                    display: flex;\n                    align-items: flex-start;\n                    gap: 24px;\n                    .information {\n                        max-width: 23%;\n                    }\n                    .border-dashed {\n                        width: 1px;\n                        height: 124px;\n                        border: 1px dashed var(--blue4);\n                    }\n                }\n            }\n        }\n    }\n\n    // ===== parameter =====\n    .custom-tab {\n        transition: all 0.3s ease-in-out;\n        border-bottom: 2px solid transparent;\n        &.active,\n        &:hover {\n            border-bottom: 2px solid var(--primary);\n        }\n    }\n\n    // ===== tab multi unit =====\n    .tab-multi-unit {\n        .rts___tabs___container {\n            overflow: unset;\n            margin-bottom: 10px;\n            border-bottom: 1px solid var(--grey3);\n            .rts___tabs {\n                .rts___tab {\n                    box-shadow: none;\n                    padding: 8px 12px;\n                    margin: 0 !important;\n                    background: transparent;\n                    border-radius: 0 !important;\n                    border: 2px solid transparent;\n                    transition: all 0.2s ease-in-out;\n                    &:hover,\n                    &.rts___tab___selected {\n                        color: var(--primary) !important;\n                        border-bottom: 2px solid var(--primary);\n                    }\n                }\n            }\n        }\n        .scroll-icon {\n            width: 44px;\n            height: 44px;\n            display: flex;\n            cursor: pointer;\n            align-items: center;\n            justify-content: center;\n            background: var(--white);\n            transition: all 0.3s ease-in-out;\n            box-shadow: -2px 0px 4px 0px rgba(156, 163, 175, 0.15);\n            &.left {\n                position: absolute;\n                top: -8px;\n                left: -24px;\n            }\n            &.right {\n                position: absolute;\n                top: -8px;\n                right: -24px;\n            }\n        }\n        .scroll-wrapper {\n            scrollbar-width: none;\n            &::-webkit-scrollbar {\n                display: none;\n            }\n        }\n    }\n}\n\n// ===== custom spinner =====\n.custom-spinner {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: 5px solid #e3e5e8;\n    border-top: 5px solid var(--primary);\n    animation: spiner 1s linear infinite;\n}\n@keyframes spiner {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n// ===== toggle switch =====\n.toggle-switch {\n    position: relative;\n    display: inline-block;\n    width: 20px;\n    height: 14px;\n    flex: none;\n    input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n        &:checked + .slider {\n            background-color: var(--blue6);\n            &::before {\n                transform: translateX(6px);\n            }\n        }\n    }\n    .slider {\n        position: absolute;\n        cursor: pointer;\n        background-color: var(--grey3);\n        border-radius: 34px;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        transition: 0.4s;\n        &::before {\n            position: absolute;\n            content: '';\n            height: 6px;\n            width: 6px;\n            left: 4px;\n            bottom: 4px;\n            background-color: var(--white);\n            transition: 0.4s;\n            border-radius: 50%;\n        }\n    }\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    #dashboard {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        flex-direction: column;\n                        .information {\n                            max-width: 100%;\n                        }\n                        .border-dashed {\n                            width: 100%;\n                            height: 1px;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== custom width =====\n        .w-25 {\n            width: 100% !important;\n        }\n\n        // ===== rencana chickin =====\n        .rencana-chickin {\n            .block {\n                flex-direction: column;\n            }\n        }\n\n        // ===== tab multi unit =====\n        .tab-multi-unit {\n            .rts___tabs___container {\n                padding: 0;\n            }\n        }\n    }\n}\n\n/* Medium mobile */\n@media (min-width: 375px) and (max-width: 424px) {\n    #dashboard {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        flex-direction: column;\n                        .information {\n                            max-width: 100%;\n                        }\n                        .border-dashed {\n                            width: 100%;\n                            height: 1px;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== custom width =====\n        .w-25 {\n            width: 100% !important;\n        }\n\n        // ===== rencana chickin =====\n        .rencana-chickin {\n            .block {\n                flex-direction: column;\n            }\n        }\n\n        // ===== tab multi unit =====\n        .tab-multi-unit {\n            .rts___tabs___container {\n                padding: 0;\n            }\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    #dashboard {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        flex-direction: column;\n                        .information {\n                            max-width: 100%;\n                        }\n                        .border-dashed {\n                            width: 100%;\n                            height: 1px;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== custom width =====\n        .w-25 {\n            width: 100% !important;\n        }\n\n        // ===== rencana chickin =====\n        .rencana-chickin {\n            .block {\n                flex-direction: column;\n            }\n        }\n\n        // ===== tab multi unit =====\n        .tab-multi-unit {\n            .rts___tabs___container {\n                padding: 0;\n            }\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    #dashboard {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        flex-direction: column;\n                        .information {\n                            max-width: 100%;\n                        }\n                        .border-dashed {\n                            width: 100%;\n                            height: 1px;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== custom width =====\n        .w-25 {\n            width: 100% !important;\n        }\n\n        // ===== rencana chickin =====\n        .rencana-chickin {\n            .block {\n                flex-direction: column;\n            }\n        }\n\n        // ===== tab multi unit =====\n        .tab-multi-unit {\n            .rts___tabs___container {\n                padding: 0;\n            }\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n    #dashboard {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        flex-direction: column;\n                        .information {\n                            max-width: 100%;\n                        }\n                        .border-dashed {\n                            width: 100%;\n                            height: 1px;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== rencana chickin =====\n        .rencana-chickin {\n            .block {\n                flex-direction: column;\n            }\n        }\n\n        // ===== tab multi unit =====\n        .tab-multi-unit {\n            .rts___tabs___container {\n                padding: 0;\n            }\n        }\n    }\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n    #dashboard {\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        .information {\n                            max-width: 34%;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== custom width =====\n        .w-25 {\n            width: 100% !important;\n        }\n\n        // ===== rencana chickin =====\n        .rencana-chickin {\n            .block {\n                flex-direction: column;\n            }\n        }\n    }\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n    #dashboard {\n        // ===== container =====\n        .container {\n            margin: 0;\n            max-width: 100%;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== stok harian per unit =====\n        .accordion {\n            .accordion-item {\n                .accordion-collapse {\n                    .accordion-body {\n                        .information {\n                            max-width: 26%;\n                        }\n                    }\n                }\n            }\n        }\n\n        // ===== custom width =====\n        .w-25 {\n            width: 100% !important;\n        }\n    }\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","#assessment {\n    overflow: clip;\n\n    // ===== container =====\n    .container-responsive {\n        padding-top: 0 !important;\n    }\n\n    // ===== sticky =====\n    .sticky {\n        position: sticky;\n        top: 0;\n        z-index: 999;\n        background: var(--white);\n        box-shadow: 0px 4px 100px 25px #00000005;\n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 156px;\n            background: var(--white);\n            transition: all 0.1s ease-out;\n        }\n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            right: -100%;\n            width: 100%;\n            height: 156px;\n            background: var(--white);\n            transition: all 0.1s ease-out;\n        }\n    }\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    #assessment {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            display: none !important;\n        }\n\n        // ===== table wrapper =====\n        .table-wrapper {\n            margin-top: 0 !important;\n        }\n\n        // ===== table assessment =====\n        .table-assessment {\n            .d-none {\n                display: flex !important;\n                gap: 8px;\n            }\n        }\n    }\n}\n\n@media (min-width: 375px) and (max-width: 424px) {\n    #assessment {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            display: none !important;\n        }\n\n        // ===== table wrapper =====\n        .table-wrapper {\n            margin-top: 0 !important;\n        }\n\n        // ===== table assessment =====\n        .table-assessment {\n            .d-none {\n                display: flex !important;\n                gap: 8px;\n            }\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    #assessment {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            display: none !important;\n        }\n\n        // ===== table wrapper =====\n        .table-wrapper {\n            margin-top: 0 !important;\n        }\n\n        // ===== table assessment =====\n        .table-assessment {\n            .d-none {\n                display: flex !important;\n                gap: 8px;\n            }\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    #assessment {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            display: none !important;\n        }\n\n        // ===== table wrapper =====\n        .table-wrapper {\n            margin-top: 0 !important;\n        }\n\n        // ===== table assessment =====\n        .table-assessment {\n            .d-none {\n                display: flex !important;\n                gap: 8px;\n            }\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n    #assessment {\n        // ===== container =====\n        .container-responsive {\n            padding-top: 90px !important;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            position: static;\n            background: transparent;\n            &::after,\n            &::before {\n                display: none;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            display: none !important;\n        }\n\n        // ===== table wrapper =====\n        .table-wrapper {\n            margin-top: 0 !important;\n        }\n\n        // ===== table assessment =====\n        .table-assessment {\n            .d-none {\n                display: flex !important;\n                gap: 8px;\n            }\n        }\n    }\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n    #assessment {\n        // ===== sticky =====\n        .sticky {\n            &::after,\n            &::before {\n                height: 86px;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            display: none !important;\n        }\n\n        // ===== table wrapper =====\n        .table-wrapper {\n            margin-top: 0 !important;\n        }\n\n        // ===== table assessment =====\n        .table-assessment {\n            .d-none {\n                display: flex !important;\n                gap: 8px;\n            }\n        }\n    }\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n    #assessment {\n        // ===== container =====\n        .container {\n            margin: 0;\n            max-width: 100%;\n        }\n\n        // ===== sticky =====\n        .sticky {\n            &::after,\n            &::before {\n                height: 136px;\n            }\n        }\n\n        // ===== header sticky =====\n        .header-scroll {\n            .table-assessment {\n                thead {\n                    .header-wrapper {\n                        th {\n                            width: 289px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","// custom spinner\n.auth-spinner {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 3px solid var(--white);\n    border-top: 3px solid var(--teal2);\n    animation: spiner 1s linear infinite;\n}\n@keyframes spiner {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n","// ===== swal2 popup =====\n.tambah-planning {\n    &.cancel {\n        .swal2-icon {\n            background: var(--yellow1) !important;\n            .swal2-icon-content {\n                width: 100%;\n                height: 100%;\n                .icon-wrapper-yellow {\n                    width: 100%;\n                    height: 100%;\n                    .info-yellow6 {\n                        display: block;\n                        width: 100%;\n                        height: 100%;\n                        background: url('../../../images/icons/planning/warning-yellow.svg') no-repeat center center;\n                    }\n                }\n            }\n        }\n    }\n    .swal2-popup {\n        padding: 0;\n        width: 550px;\n        border-radius: 8px;\n        // ===== icon =====\n        .swal2-icon {\n            border: none;\n            margin: 16px 24px 0 24px;\n            background: var(--blue1);\n            .swal2-icon-content {\n                width: 100%;\n                height: 100%;\n                .icon-wrapper-blue {\n                    width: 100%;\n                    height: 100%;\n                    .info-blue6 {\n                        display: block;\n                        width: 100%;\n                        height: 100%;\n                        background: url('../../../images/icons/planning/info.svg') no-repeat center center;\n                    }\n                }\n            }\n        }\n\n        // ===== title =====\n        .swal2-title {\n            text-align: start;\n            margin: 20px 24px 12px 24px;\n        }\n        // ===== text =====\n        .swal2-html-container {\n            margin: 0 24px;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 20px;\n            text-align: start;\n            color: var(--grey6);\n            letter-spacing: -0.32px;\n        }\n        .swal2-actions {\n            border-radius: 0 0 8px 8px;\n        }\n    }\n}\n","#bakul {\n    /* ===== list bakul ===== */\n\n    .custom-search {\n        width: 260px;\n        height: var(--32);\n        padding: var(--8) var(--12) var(--8) var(--38);\n    }\n\n    .filter {\n        height: var(--32);\n    }\n\n    .table {\n        tbody {\n            tr {\n                td {\n                    font-weight: 400;\n                }\n            }\n        }\n    }\n\n    .individu {\n        width: fit-content;\n        padding: 2px var(--8);\n        border-radius: var(--8);\n        font-weight: 400 !important;\n        color: var(--blue6) !important;\n        background: var(--blue1) !important;\n    }\n    .badan-usaha {\n        width: fit-content;\n        padding: 2px var(--8);\n        border-radius: var(--8);\n        font-weight: 400 !important;\n        color: var(--purple7) !important;\n        background: var(--purple2) !important;\n    }\n\n    .pagination {\n        align-items: center;\n        justify-content: space-between;\n        border-radius: var(--8);\n        margin: 16px 0 0 auto;\n        .arrow {\n            border-radius: var(--6);\n            &:hover {\n                background: var(--grey2);\n            }\n            &:disabled {\n                background: transparent;\n            }\n        }\n\n        .page-item {\n            width: var(--40);\n            height: var(--32);\n            .page-link {\n                height: 100%;\n                border: none;\n                display: flex;\n                font-weight: 500;\n                border-radius: 0;\n                line-height: 18px;\n                align-items: center;\n                color: var(--grey6);\n                font-size: var(--14);\n                padding: var(--4) 5px;\n                letter-spacing: -0.02em;\n                justify-content: center;\n                border-radius: var(--4);\n                transition: all 0.3s ease-in-out;\n                &:hover {\n                    color: var(--teal6);\n                    background: var(--teal1);\n                }\n            }\n            &.active {\n                .page-link {\n                    color: var(--teal6);\n                    background: var(--teal1);\n                }\n            }\n        }\n    }\n\n    /* ===== detail bakul ===== */\n\n    .rts___tabs___container {\n        .rts___tabs {\n            .rts___btn {\n                transition: all 0.2s ease-in-out;\n                &:hover {\n                    background: var(--white);\n                    color: var(--teal6) !important;\n                }\n            }\n        }\n    }\n\n    .leaflet-container {\n        .leaflet-map-pane {\n            .leaflet-tooltip-pane {\n                .leaflet-tooltip {\n                    padding: 0;\n                    border: none;\n                    border-radius: 0;\n                    box-shadow: none;\n                    margin: var(--8) 0 0;\n                    background: transparent;\n                }\n            }\n        }\n        .leaflet-control-container {\n            .leaflet-top {\n                .leaflet-control-zoom {\n                    display: none;\n                }\n            }\n            .leaflet-bottom {\n                &.leaflet-right {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    .select-periode {\n        .react-select__control {\n            border-radius: var(--6);\n        }\n    }\n    .tab {\n        .rts___tabs___container {\n            .rts___tabs {\n                border-bottom: 1px solid var(--grey2);\n                .rts___tab {\n                    border: none;\n                    padding: var(--8) var(--12);\n                    border-bottom: 2px solid transparent;\n                    &:hover {\n                        border: none !important;\n                        color: var(--teal6) !important;\n                        background: transparent !important;\n                        border-bottom: 2px solid var(--teal6) !important;\n                    }\n                }\n            }\n        }\n    }\n\n    .bermasalah {\n        margin-left: auto;\n        width: fit-content;\n        padding: 2px var(--8);\n        border-radius: var(--8);\n        color: var(--red6) !important;\n        background: var(--red1) !important;\n    }\n    .lancar {\n        margin-left: auto;\n        width: fit-content;\n        padding: 2px var(--8);\n        border-radius: var(--8);\n        color: var(--green6) !important;\n        background: var(--green1) !important;\n    }\n\n    .custom-toast {\n        font-weight: 500;\n        color: var(--white);\n        font-size: var(--16);\n        line-height: var(--20);\n        border-radius: var(--8);\n        letter-spacing: -0.02em;\n        background: var(--green7);\n        position: fixed;\n        top: var(--16);\n        left: 0;\n        right: 0;\n        z-index: 9999;\n        margin: 0 auto;\n        width: fit-content;\n        padding: var(--10) var(--12);\n        animation: slideIn 0.3s ease, fadeOut 0.5s ease 1.5s forwards;\n    }\n    @keyframes slideIn {\n        from {\n            opacity: 0;\n            transform: translateY(-10px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n    @keyframes fadeOut {\n        to {\n            opacity: 0;\n            transform: translateY(-10px);\n        }\n    }\n\n    .recharts-responsive-container {\n        .recharts-wrapper {\n            .recharts-legend-wrapper {\n                .custom-legend {\n                    .custom-checkbox {\n                        appearance: none;\n                        -webkit-appearance: none;\n                        width: var(--12);\n                        height: var(--12);\n                        position: relative;\n                        border-radius: 2px;\n                        cursor: pointer;\n                        &:checked {\n                            &::after {\n                                content: '';\n                                position: absolute;\n                                top: 0;\n                                left: 3px;\n                                width: var(--4);\n                                height: var(--8);\n                                border: solid var(--white);\n                                border-width: 0 2px 2px 0;\n                                transform: rotate(45deg);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .date-picker-wrapper {\n        width: 100%;\n        .react-datepicker-wrapper {\n            .react-datepicker__input-container {\n                .customs-input {\n                    background: url('../../../images/icons/calendar-grey9.svg');\n                    background-repeat: no-repeat;\n                    background-position: left;\n                    background-position-x: var(--12);\n                    padding-left: 34px;\n                }\n            }\n        }\n    }\n    .react-datepicker__tab-loop {\n        .react-datepicker-popper {\n            .react-datepicker {\n                .react-datepicker__triangle,\n                .react-datepicker__navigation {\n                    display: none;\n                }\n                .react-datepicker__month-container {\n                    .react-datepicker__header {\n                        .react-datepicker__current-month {\n                            display: none;\n                        }\n                        .react-datepicker__header__dropdown {\n                            .react-datepicker__month-select,\n                            .react-datepicker__year-select {\n                                background: transparent;\n                            }\n                            .react-datepicker__month-read-view,\n                            .react-datepicker__year-read-view {\n                                visibility: unset !important;\n                            }\n                            .react-datepicker__month-read-view--down-arrow,\n                            .react-datepicker__year-read-view--down-arrow {\n                                top: var(--6);\n                                right: -12px;\n                                width: var(--6);\n                                height: var(--6);\n                                border-width: 2px 2px 0 0;\n                                border-color: var(--grey9);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .select {\n        .react-select__control {\n            border-radius: var(--6);\n            .react-select__value-container {\n                .react-select__single-value {\n                    color: var(--grey9);\n                    font-size: var(--12);\n                    line-height: var(--16);\n                }\n                .react-select__placeholder {\n                    font-weight: 400;\n                    color: var(--grey5);\n                    font-size: var(--12);\n                    line-height: var(--16);\n                }\n            }\n        }\n    }\n\n    .label-checkbox {\n        margin-bottom: 0 !important;\n        .custom-checkbox {\n            width: var(--14);\n            height: var(--14);\n            &:checked {\n                &::after {\n                    top: 1px;\n                    left: var(--4);\n                }\n            }\n        }\n    }\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    #bakul {\n        .container-responsive {\n            padding: 90px var(--16) var(--16) var(--16) !important;\n        }\n\n        .rts___tabs___container {\n            .rts___tabs {\n                flex-direction: column;\n            }\n        }\n\n        .overview {\n            flex-direction: column;\n        }\n\n        .produk {\n            flex-direction: column;\n            .d-grid {\n                grid-template-columns: repeat(1, 1fr) !important;\n            }\n        }\n    }\n}\n\n/* Medium mobile */\n@media (min-width: 375px) and (max-width: 424px) {\n    #bakul {\n        .container-responsive {\n            padding: 90px var(--16) var(--16) var(--16) !important;\n        }\n\n        .rts___tabs___container {\n            .rts___tabs {\n                flex-direction: column;\n            }\n        }\n\n        .overview {\n            flex-direction: column;\n        }\n\n        .produk {\n            flex-direction: column;\n            .d-grid {\n                grid-template-columns: repeat(1, 1fr) !important;\n            }\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    #bakul {\n        .container-responsive {\n            padding: 90px var(--16) var(--16) var(--16) !important;\n        }\n\n        .rts___tabs___container {\n            .rts___tabs {\n                flex-direction: column;\n            }\n        }\n\n        .overview {\n            flex-direction: column;\n        }\n\n        .produk {\n            flex-direction: column;\n            .d-grid {\n                grid-template-columns: repeat(1, 1fr) !important;\n            }\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    #bakul {\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        .rts___tabs___container {\n            .rts___tabs {\n                flex-direction: column;\n            }\n        }\n\n        .overview {\n            flex-direction: column;\n        }\n\n        .produk {\n            .d-grid {\n                grid-template-columns: repeat(1, 1fr) !important;\n            }\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n    #bakul {\n        .container-responsive {\n            padding-top: 116px !important;\n        }\n\n        .rts___tabs___container {\n            .rts___tabs {\n                flex-direction: column;\n            }\n        }\n\n        .overview {\n            flex-direction: column;\n        }\n\n        .produk {\n            .d-grid {\n                grid-template-columns: repeat(1, 1fr) !important;\n            }\n        }\n    }\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n}\n\n@media (min-width: 375px) and (max-width: 424px) {\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n    #create-ppic {\n        .container-responsive {\n            .container {\n                margin: 0;\n                max-width: 100%;\n            }\n        }\n    }\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n","#panen {\n    .checkbox {\n        appearance: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n\n        width: 12px;\n        height: 12px;\n        display: flex;\n        outline: none;\n        cursor: pointer;\n        position: relative;\n        border-radius: 2px;\n        background-color: var(--white);\n        border: 1px solid var(--grey7);\n        &:checked {\n            background: var(--teal6);\n            border: 1px solid var(--teal7);\n            &::after {\n                content: '';\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                width: 10px;\n                height: 8px;\n                transform: translate(-50%, -50%);\n                background-image: url('../../../images/icons/check-white.svg');\n                background-size: contain;\n                background-repeat: no-repeat;\n            }\n        }\n    }\n    .rts___tabs___container {\n        padding: 0;\n        display: flex;\n        align-items: center;\n        .rts___tabs {\n            padding: 0;\n            .rts___btn {\n                margin: 0;\n                border: none;\n                box-shadow: none;\n                border-radius: 0;\n                background: none;\n                padding: 8px 12px;\n                transition: all 0.3s ease-in-out;\n                border-bottom: 1px solid transparent;\n                &:hover {\n                    color: var(--primary) !important;\n                    border-bottom: 1px solid var(--primary);\n                }\n                &.rts___tab___selected {\n                    border-radius: 0;\n                    color: var(--primary) !important;\n                    border-bottom: 1px solid var(--primary);\n                }\n            }\n        }\n    }\n    .pagination {\n        margin: 0;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        button {\n            &:disabled {\n                color: var(--grey3) !important;\n                background: var(--grey1);\n                svg {\n                    color: var(--grey3) !important;\n                }\n            }\n        }\n        .page-item {\n            width: 40px;\n            height: 32px;\n            &.active {\n                .page-link {\n                    color: var(--primary);\n                    background-color: var(--teal1);\n                }\n            }\n            .page-link {\n                width: 100%;\n                height: 100%;\n                border: none;\n                display: flex;\n                font-size: 14px;\n                font-weight: 500;\n                padding: 4px 5px;\n                line-height: 18px;\n                border-radius: 4px;\n                align-items: center;\n                color: var(--grey6);\n                letter-spacing: -0.02em;\n                justify-content: center;\n                transition: all 0.3s ease-in-out;\n                &:hover {\n                    color: var(--primary);\n                    background-color: var(--teal1);\n                }\n            }\n        }\n    }\n}\n\n/* Small mobile */\n@media (min-width: 320px) and (max-width: 374px) {\n    #panen {\n        .container-responsive {\n            padding-top: 86px !important;\n        }\n        .select {\n            &.select-ap {\n                .react-select__menu {\n                    left: 0;\n                    width: 276px;\n                }\n            }\n        }\n        .setting-panen {\n            .select,\n            .custom-search {\n                width: 100%;\n            }\n        }\n    }\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Medium mobile */\n@media (min-width: 375px) and (max-width: 424px) {\n    #panen {\n        .container-responsive {\n            padding-top: 86px !important;\n        }\n        .setting-panen {\n            .filter {\n                width: 100%;\n            }\n            .select,\n            .custom-search {\n                width: 100%;\n            }\n        }\n    }\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Large mobile */\n@media (min-width: 425px) and (max-width: 599px) {\n    #panen {\n        .container-responsive {\n            padding-top: 86px !important;\n        }\n        .setting-panen {\n            .filter {\n                width: 100%;\n            }\n            .select,\n            .custom-search {\n                width: 100%;\n            }\n        }\n    }\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Small tablet */\n@media (min-width: 600px) and (max-width: 767px) {\n    #panen {\n        .container-responsive {\n            padding-top: 86px !important;\n        }\n    }\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Medium tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n    #panen {\n        .container-responsive {\n            padding-top: 86px !important;\n        }\n    }\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Large tablet */\n@media (min-width: 1024px) and (max-width: 1279px) {\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Small laptop */\n@media (min-width: 1280px) and (max-width: 1439px) {\n    .table-pengaturan-panen {\n        .cta {\n            padding: 0;\n            .btn-wrapper {\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n/* Medium laptop */\n@media (min-width: 1440px) and (max-width: 1599px) {\n}\n\n/* Large laptop */\n@media (min-width: 1600px) and (max-width: 1919px) {\n}\n\n/* Small desktop */\n@media (min-width: 1920px) and (max-width: 2559px) {\n}\n\n/* Large desktop */\n@media (min-width: 2560px) and (max-width: 3439px) {\n}\n\n/* Ultra-Wide screens */\n@media (min-width: 3440px) and (max-width: 3839px) {\n}\n\n/* 4K screens */\n@media (min-width: 3840px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
